import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Cursor for paging through collections */
  ConnectionCursor: { input: any; output: any };
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any };
};

export type ActiveInactiveUsers = {
  __typename?: "ActiveInactiveUsers";
  activityLevel: UserActivityLevel;
  count: Scalars["Int"]["output"];
  /** Any date in the range of the data. */
  date: Scalars["DateTime"]["output"];
};

export type ActiveOrderConnection = {
  __typename?: "ActiveOrderConnection";
  edges: Array<TaxiOrder>;
  pageInfo: PageInformation;
  totalCount: Scalars["Int"]["output"];
};

export type ActiveOrderDriver = {
  __typename?: "ActiveOrderDriver";
  fullName?: Maybe<Scalars["String"]["output"]>;
  location?: Maybe<Point>;
  mobileNumber?: Maybe<Scalars["String"]["output"]>;
  profileImageUrl?: Maybe<Scalars["ID"]["output"]>;
  /** Driver Rating. Between 0 to 100 */
  rating?: Maybe<Scalars["Int"]["output"]>;
  vehicleColor?: Maybe<Scalars["String"]["output"]>;
  vehicleName?: Maybe<Scalars["String"]["output"]>;
  vehiclePlate?: Maybe<Scalars["String"]["output"]>;
};

export type ActiveTaxiOrderFleet = {
  __typename?: "ActiveTaxiOrderFleet";
  id: Scalars["ID"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  rating?: Maybe<Scalars["Int"]["output"]>;
};

export type ActiveTaxiOrderRider = {
  __typename?: "ActiveTaxiOrderRider";
  fullName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  mobileNumber?: Maybe<Scalars["String"]["output"]>;
  rating?: Maybe<Scalars["Int"]["output"]>;
};

export type AddFleetsToZonePriceInput = {
  /** The id of the record. */
  id: Scalars["ID"]["input"];
  /** The ids of the relations. */
  relationIds: Array<Scalars["ID"]["input"]>;
};

export type AddOptionsToServiceInput = {
  /** The id of the record. */
  id: Scalars["ID"]["input"];
  /** The ids of the relations. */
  relationIds: Array<Scalars["ID"]["input"]>;
};

export type AddRegionsToServiceInput = {
  /** The id of the record. */
  id: Scalars["ID"]["input"];
  /** The ids of the relations. */
  relationIds: Array<Scalars["ID"]["input"]>;
};

export type AddServicesToZonePriceInput = {
  /** The id of the record. */
  id: Scalars["ID"]["input"];
  /** The ids of the relations. */
  relationIds: Array<Scalars["ID"]["input"]>;
};

export type Address = {
  __typename?: "Address";
  details?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  location: Point;
  riderId: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
  type: RiderAddressType;
};

export type AddressConnection = {
  __typename?: "AddressConnection";
  /** Array of nodes. */
  nodes: Array<Address>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type AddressFilter = {
  and?: InputMaybe<Array<AddressFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<AddressFilter>>;
  riderId?: InputMaybe<IdFilterComparison>;
};

export type AddressSort = {
  direction: SortDirection;
  field: AddressSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum AddressSortFields {
  Id = "id",
  RiderId = "riderId",
}

export enum AdminBrowserPushBrowser {
  Chrome = "Chrome",
  Edge = "Edge",
  Firefox = "Firefox",
  Other = "Other",
  Safari = "Safari",
}

export type AdminBrowserPushCategoryPreferencesDto = {
  __typename?: "AdminBrowserPushCategoryPreferencesDTO";
  complaintEnabled: Scalars["Boolean"]["output"];
  driverOperationalEnabled: Scalars["Boolean"]["output"];
  emergencyEnabled: Scalars["Boolean"]["output"];
  requestEnabled: Scalars["Boolean"]["output"];
  scheduleEnabled: Scalars["Boolean"]["output"];
  systemEnabled: Scalars["Boolean"]["output"];
  telematicsEnabled: Scalars["Boolean"]["output"];
};

export type AdminBrowserPushCategoryPreferencesInput = {
  complaintEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  driverOperationalEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  emergencyEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  requestEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  scheduleEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  systemEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  telematicsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum AdminBrowserPushPermissionState {
  Default = "Default",
  Denied = "Denied",
  Granted = "Granted",
  Revoked = "Revoked",
  Unsupported = "Unsupported",
}

export enum AdminBrowserPushPlatform {
  Android = "Android",
  Ios = "Ios",
  Linux = "Linux",
  Macos = "Macos",
  Unknown = "Unknown",
  Windows = "Windows",
}

export enum AdminBrowserPushProvider {
  FcmWeb = "FcmWeb",
}

export type AdminBrowserPushRegistration = {
  __typename?: "AdminBrowserPushRegistration";
  browser: AdminBrowserPushBrowser;
  browserInstanceId: Scalars["String"]["output"];
  browserVersion?: Maybe<Scalars["String"]["output"]>;
  categoryPreferences: AdminBrowserPushCategoryPreferencesDto;
  createdAt: Scalars["DateTime"]["output"];
  criticalOnly: Scalars["Boolean"]["output"];
  desktopEnabled: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  lastFailureAt?: Maybe<Scalars["DateTime"]["output"]>;
  lastFailureCode?: Maybe<Scalars["String"]["output"]>;
  lastProviderAcceptedAt?: Maybe<Scalars["DateTime"]["output"]>;
  lastSeenAt: Scalars["DateTime"]["output"];
  locale: Scalars["String"]["output"];
  operatingSystemLabel?: Maybe<Scalars["String"]["output"]>;
  permissionState: AdminBrowserPushPermissionState;
  platform: AdminBrowserPushPlatform;
  provider: AdminBrowserPushProvider;
  revokedAt?: Maybe<Scalars["DateTime"]["output"]>;
  serviceWorkerVersion?: Maybe<Scalars["String"]["output"]>;
  soundEnabled: Scalars["Boolean"]["output"];
  tokenRefreshedAt: Scalars["DateTime"]["output"];
};

export type AdminDesktopAlertRuntimeConfiguration = {
  __typename?: "AdminDesktopAlertRuntimeConfiguration";
  blockers: Array<Scalars["String"]["output"]>;
  effective: AdminDesktopAlertRuntimePolicyValues;
  environmentMasterAllowed: Scalars["Boolean"]["output"];
  policyId: Scalars["ID"]["output"];
  readiness: AdminDesktopAlertRuntimeReadiness;
  requested: AdminDesktopAlertRuntimePolicyValues;
  source: IntegrationRuntimePolicySource;
  version: Scalars["Int"]["output"];
};

export type AdminDesktopAlertRuntimePolicyValues = {
  __typename?: "AdminDesktopAlertRuntimePolicyValues";
  deliveryEnabled: Scalars["Boolean"]["output"];
  registrationAllowed: Scalars["Boolean"]["output"];
  testPushEnabled: Scalars["Boolean"]["output"];
};

export type AdminDesktopAlertRuntimePolicyValuesInput = {
  deliveryEnabled: Scalars["Boolean"]["input"];
  registrationAllowed: Scalars["Boolean"]["input"];
  testPushEnabled: Scalars["Boolean"]["input"];
};

export type AdminDesktopAlertRuntimeReadiness = {
  __typename?: "AdminDesktopAlertRuntimeReadiness";
  activeBrowserRegistrationCount: Scalars["Int"]["output"];
  firebaseAdminConfigured: Scalars["Boolean"]["output"];
  firebaseWebConfigured: Scalars["Boolean"]["output"];
  outboxWorkerConfigured: Scalars["Boolean"]["output"];
  serviceWorkerReady: Scalars["Boolean"]["output"];
  vapidConfigured: Scalars["Boolean"]["output"];
};

export type AdminDesktopTestPushResultDto = {
  __typename?: "AdminDesktopTestPushResultDTO";
  eventId: Scalars["String"]["output"];
  queued: Scalars["Boolean"]["output"];
};

export enum AdminNotificationAcknowledgementPolicy {
  Explicit = "Explicit",
  None = "None",
  Open = "Open",
}

export enum AdminNotificationCategory {
  Complaint = "Complaint",
  DriverOperational = "DriverOperational",
  Emergency = "Emergency",
  Request = "Request",
  Schedule = "Schedule",
  System = "System",
  Telematics = "Telematics",
}

export type AdminNotificationEventV1 = {
  __typename?: "AdminNotificationEventV1";
  acknowledgementPolicy: AdminNotificationAcknowledgementPolicy;
  category: AdminNotificationCategory;
  createdAt: Scalars["String"]["output"];
  dedupeKey: Scalars["String"]["output"];
  eventId: Scalars["String"]["output"];
  expiresAt: Scalars["String"]["output"];
  route: Scalars["String"]["output"];
  safeBody: Scalars["String"]["output"];
  safeTitle: Scalars["String"]["output"];
  schemaVersion: Scalars["Int"]["output"];
  severity: AdminNotificationSeverity;
  soundPolicy: AdminNotificationSoundPolicy;
  tag: Scalars["String"]["output"];
  type: AdminNotificationType;
};

export enum AdminNotificationSeverity {
  Critical = "Critical",
  High = "High",
  Normal = "Normal",
}

export enum AdminNotificationSoundPolicy {
  None = "None",
  Once = "Once",
  UntilAcknowledged = "UntilAcknowledged",
}

/** The type of admin notification. */
export enum AdminNotificationType {
  DriverManualRideCreated = "DriverManualRideCreated",
  ReviewPendingApproval = "ReviewPendingApproval",
  RideRequestUnassigned = "RideRequestUnassigned",
  ScheduledRideAdminWarning = "ScheduledRideAdminWarning",
  ScheduledRideAssigned = "ScheduledRideAssigned",
  ScheduledRideConfirmed = "ScheduledRideConfirmed",
  ScheduledRideCreated = "ScheduledRideCreated",
  ScheduledRideDriverDeclined = "ScheduledRideDriverDeclined",
  ScheduledRideEmergencyDispatch = "ScheduledRideEmergencyDispatch",
  ScheduledRideUrgentWarning = "ScheduledRideUrgentWarning",
  SosSubmitted = "SosSubmitted",
  SupportRequestAssigned = "SupportRequestAssigned",
  SupportRequestSubmitted = "SupportRequestSubmitted",
  TelematicsIntegrityAlert = "TelematicsIntegrityAlert",
  Test = "Test",
  UserPendingVerification = "UserPendingVerification",
}

export type AdminNotificationUnion =
  | DriverPendingVerificationNotification
  | SosNotification
  | ScheduleEventNotification
  | TaxiSupportRequestNotification;

export type AdminResetOperatorPasswordInput = {
  newPassword: Scalars["String"]["input"];
  targetOperatorId: Scalars["ID"]["input"];
};

export type Announcement = {
  __typename?: "Announcement";
  appType?: Maybe<AppType>;
  description: Scalars["String"]["output"];
  expireAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars["ID"]["output"]>;
  notificationSentAt?: Maybe<Scalars["DateTime"]["output"]>;
  startAt: Scalars["DateTime"]["output"];
  title: Scalars["String"]["output"];
  url?: Maybe<Scalars["String"]["output"]>;
  userType: Array<AnnouncementUserType>;
};

export type AnnouncementConnection = {
  __typename?: "AnnouncementConnection";
  /** Array of nodes. */
  nodes: Array<Announcement>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type AnnouncementDeleteResponse = {
  __typename?: "AnnouncementDeleteResponse";
  appType?: Maybe<AppType>;
  description?: Maybe<Scalars["String"]["output"]>;
  expireAt?: Maybe<Scalars["DateTime"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  mediaId?: Maybe<Scalars["ID"]["output"]>;
  notificationSentAt?: Maybe<Scalars["DateTime"]["output"]>;
  startAt?: Maybe<Scalars["DateTime"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
  userType?: Maybe<Array<AnnouncementUserType>>;
};

export type AnnouncementFilter = {
  and?: InputMaybe<Array<AnnouncementFilter>>;
  appType?: InputMaybe<AppTypeFilterComparison>;
  description?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<AnnouncementFilter>>;
  title?: InputMaybe<StringFieldComparison>;
};

export type AnnouncementSort = {
  direction: SortDirection;
  field: AnnouncementSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum AnnouncementSortFields {
  AppType = "appType",
  Description = "description",
  Id = "id",
  Title = "title",
}

export enum AnnouncementUserType {
  Driver = "Driver",
  Operator = "Operator",
  Rider = "Rider",
}

export enum AppColorScheme {
  AutumnOrange = "AutumnOrange",
  Cobalt = "Cobalt",
  CoralRed = "CoralRed",
  EarthyGreen = "EarthyGreen",
  ElectricIndigo = "ElectricIndigo",
  HyperPink = "HyperPink",
  Noir = "Noir",
  SunburstYellow = "SunburstYellow",
}

export type AppConfigInfo = {
  __typename?: "AppConfigInfo";
  color?: Maybe<AppColorScheme>;
  logo?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type AppConfigInfoInput = {
  color?: InputMaybe<AppColorScheme>;
  logo?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export enum AppType {
  Taxi = "Taxi",
}

export type AppTypeFilterComparison = {
  eq?: InputMaybe<AppType>;
  gt?: InputMaybe<AppType>;
  gte?: InputMaybe<AppType>;
  iLike?: InputMaybe<AppType>;
  in?: InputMaybe<Array<AppType>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<AppType>;
  lt?: InputMaybe<AppType>;
  lte?: InputMaybe<AppType>;
  neq?: InputMaybe<AppType>;
  notILike?: InputMaybe<AppType>;
  notIn?: InputMaybe<Array<AppType>>;
  notLike?: InputMaybe<AppType>;
};

export type ApplyTelematicsRuntimePresetInput = {
  expectedDesktopVersion?: InputMaybe<Scalars["Int"]["input"]>;
  expectedVersion: Scalars["Int"]["input"];
  preset: TelematicsRuntimePreset;
  providerSettingId: Scalars["ID"]["input"];
  reason: Scalars["String"]["input"];
};

export type ArchivedDriver = {
  __typename?: "ArchivedDriver";
  archivedAt: Scalars["DateTime"]["output"];
  firstName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  lastArchiveReason?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  mobileNumber: Scalars["String"]["output"];
};

export type AssignTaxiSupportRequestInput = {
  staffIds: Array<Scalars["ID"]["input"]>;
  supportRequestId: Scalars["ID"]["input"];
};

export type AssignVehicleToDriverInput = {
  driverId: Scalars["ID"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  reason?: InputMaybe<Scalars["String"]["input"]>;
  vehicleId: Scalars["ID"]["input"];
};

export type BooleanFieldComparison = {
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BoundedLocations = {
  __typename?: "BoundedLocations";
  clusters: Array<ClusteredLocation>;
  h3IndexesInView: Array<Scalars["String"]["output"]>;
  h3Resolution: Scalars["Int"]["output"];
  singles: Array<DriverLocationUpdate>;
  totalCount: Scalars["Int"]["output"];
};

export type BoundsInput = {
  northEast: PointInput;
  southWest: PointInput;
  zoom?: InputMaybe<Scalars["Int"]["input"]>;
};

export type BroadcastConfig = {
  __typename?: "BroadcastConfig";
  /** Driver response time after the final offered broadcast wave, in seconds. New automation only; capped by the original request deadline. */
  finalResponseWindowSeconds?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum number of waves to send */
  maxWaves: Scalars["Int"]["output"];
  /** Incremental radius in meters for each wave */
  radiusIncrementMeters?: Maybe<Scalars["Int"]["output"]>;
  /** Interval in seconds between notification waves */
  waveIntervalSeconds: Scalars["Int"]["output"];
  /** Number of drivers to notify in each wave */
  waveSize: Scalars["Int"]["output"];
};

export type BroadcastConfigInput = {
  /** Driver response time after the final offered broadcast wave, in seconds. New automation only; capped by the original request deadline. */
  finalResponseWindowSeconds?: InputMaybe<Scalars["Int"]["input"]>;
  /** Maximum number of waves to send */
  maxWaves: Scalars["Int"]["input"];
  /** Incremental radius in meters for each wave */
  radiusIncrementMeters?: InputMaybe<Scalars["Int"]["input"]>;
  /** Interval in seconds between notification waves */
  waveIntervalSeconds: Scalars["Int"]["input"];
  /** Number of drivers to notify in each wave */
  waveSize: Scalars["Int"]["input"];
};

export type CalculateFare = {
  __typename?: "CalculateFare";
  currency: Scalars["String"]["output"];
  distance: Scalars["Int"]["output"];
  duration: Scalars["Int"]["output"];
  error?: Maybe<CalculateFareError>;
  routeSource: RouteSource;
  services: Array<ServiceCategoryWithCost>;
};

export enum CalculateFareError {
  NoServiceInRegion = "NoServiceInRegion",
  RegionUnsupported = "RegionUnsupported",
}

export type CalculateFareInput = {
  orderType: TaxiOrderType;
  points: Array<PointInput>;
  riderId?: InputMaybe<Scalars["ID"]["input"]>;
  tariffProfileId?: InputMaybe<Scalars["ID"]["input"]>;
  waitTime?: Scalars["Int"]["input"];
};

export type Campaign = {
  __typename?: "Campaign";
  appType: Array<AppType>;
  codes: CampaignCodesConnection;
  codesAggregate: Array<CampaignCodesAggregateResponse>;
  currency: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  discountFlat: Scalars["Float"]["output"];
  discountPercent: Scalars["Float"]["output"];
  expireAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  isEnabled: Scalars["Boolean"]["output"];
  isFirstTravelOnly: Scalars["Boolean"]["output"];
  manyTimesUserCanUse: Scalars["Int"]["output"];
  manyUsersCanUse: Scalars["Int"]["output"];
  maximumCost: Scalars["Float"]["output"];
  minimumCost: Scalars["Float"]["output"];
  name: Scalars["String"]["output"];
  startAt: Scalars["DateTime"]["output"];
};

export type CampaignCodesArgs = {
  filter?: CampaignCodeFilter;
  paging?: OffsetPaging;
  sorting?: Array<CampaignCodeSort>;
};

export type CampaignCodesAggregateArgs = {
  filter?: InputMaybe<CampaignCodeAggregateFilter>;
};

export type CampaignCode = {
  __typename?: "CampaignCode";
  campaignId?: Maybe<Scalars["ID"]["output"]>;
  code: Scalars["String"]["output"];
  customer?: Maybe<Rider>;
  customerId?: Maybe<Scalars["ID"]["output"]>;
  id: Scalars["ID"]["output"];
  usedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type CampaignCodeAggregateFilter = {
  and?: InputMaybe<Array<CampaignCodeAggregateFilter>>;
  campaignId?: InputMaybe<IdFilterComparison>;
  customerId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<CampaignCodeAggregateFilter>>;
};

export type CampaignCodeConnection = {
  __typename?: "CampaignCodeConnection";
  /** Array of nodes. */
  nodes: Array<CampaignCode>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type CampaignCodeFilter = {
  and?: InputMaybe<Array<CampaignCodeFilter>>;
  campaignId?: InputMaybe<IdFilterComparison>;
  customerId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<CampaignCodeFilter>>;
};

export type CampaignCodeSort = {
  direction: SortDirection;
  field: CampaignCodeSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum CampaignCodeSortFields {
  CampaignId = "campaignId",
  CustomerId = "customerId",
  Id = "id",
}

export type CampaignCodesAggregateGroupBy = {
  __typename?: "CampaignCodesAggregateGroupBy";
  campaignId?: Maybe<Scalars["ID"]["output"]>;
  customerId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type CampaignCodesAggregateResponse = {
  __typename?: "CampaignCodesAggregateResponse";
  avg?: Maybe<CampaignCodesAvgAggregate>;
  count?: Maybe<CampaignCodesCountAggregate>;
  groupBy?: Maybe<CampaignCodesAggregateGroupBy>;
  max?: Maybe<CampaignCodesMaxAggregate>;
  min?: Maybe<CampaignCodesMinAggregate>;
  sum?: Maybe<CampaignCodesSumAggregate>;
};

export type CampaignCodesAvgAggregate = {
  __typename?: "CampaignCodesAvgAggregate";
  campaignId?: Maybe<Scalars["Float"]["output"]>;
  customerId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type CampaignCodesConnection = {
  __typename?: "CampaignCodesConnection";
  /** Array of nodes. */
  nodes: Array<CampaignCode>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type CampaignCodesCountAggregate = {
  __typename?: "CampaignCodesCountAggregate";
  campaignId?: Maybe<Scalars["Int"]["output"]>;
  customerId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
};

export type CampaignCodesMaxAggregate = {
  __typename?: "CampaignCodesMaxAggregate";
  campaignId?: Maybe<Scalars["ID"]["output"]>;
  customerId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type CampaignCodesMinAggregate = {
  __typename?: "CampaignCodesMinAggregate";
  campaignId?: Maybe<Scalars["ID"]["output"]>;
  customerId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type CampaignCodesSumAggregate = {
  __typename?: "CampaignCodesSumAggregate";
  campaignId?: Maybe<Scalars["Float"]["output"]>;
  customerId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type CampaignConnection = {
  __typename?: "CampaignConnection";
  /** Array of nodes. */
  nodes: Array<Campaign>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export enum CampaignCriteriaOrdersType {
  OrderCountLessThan = "OrderCountLessThan",
  OrderCountMoreThan = "OrderCountMoreThan",
  PurchaseAmountLessThan = "PurchaseAmountLessThan",
  PurchaseAmountMoreThan = "PurchaseAmountMoreThan",
}

export type CampaignDeleteResponse = {
  __typename?: "CampaignDeleteResponse";
  appType?: Maybe<Array<AppType>>;
  currency?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  discountFlat?: Maybe<Scalars["Float"]["output"]>;
  discountPercent?: Maybe<Scalars["Float"]["output"]>;
  expireAt?: Maybe<Scalars["DateTime"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  isEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  isFirstTravelOnly?: Maybe<Scalars["Boolean"]["output"]>;
  manyTimesUserCanUse?: Maybe<Scalars["Int"]["output"]>;
  manyUsersCanUse?: Maybe<Scalars["Int"]["output"]>;
  maximumCost?: Maybe<Scalars["Float"]["output"]>;
  minimumCost?: Maybe<Scalars["Float"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  startAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type CampaignFilter = {
  and?: InputMaybe<Array<CampaignFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<CampaignFilter>>;
};

export type CampaignSort = {
  direction: SortDirection;
  field: CampaignSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum CampaignSortFields {
  Id = "id",
  Name = "name",
}

export type CampaignTargetSegmentCriteria = {
  appType: AppType;
  lastDays: Scalars["Int"]["input"];
  type: CampaignCriteriaOrdersType;
  value: Scalars["Float"]["input"];
};

export type CarColor = {
  __typename?: "CarColor";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type CarColorConnection = {
  __typename?: "CarColorConnection";
  /** Array of nodes. */
  nodes: Array<CarColor>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type CarColorDeleteResponse = {
  __typename?: "CarColorDeleteResponse";
  id?: Maybe<Scalars["ID"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type CarColorFilter = {
  and?: InputMaybe<Array<CarColorFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<CarColorFilter>>;
};

export type CarColorInput = {
  name: Scalars["String"]["input"];
};

export type CarColorSort = {
  direction: SortDirection;
  field: CarColorSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum CarColorSortFields {
  Id = "id",
  Name = "name",
}

export type CarModel = {
  __typename?: "CarModel";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type CarModelConnection = {
  __typename?: "CarModelConnection";
  /** Array of nodes. */
  nodes: Array<CarModel>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type CarModelDeleteResponse = {
  __typename?: "CarModelDeleteResponse";
  id?: Maybe<Scalars["ID"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type CarModelFilter = {
  and?: InputMaybe<Array<CarModelFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<CarModelFilter>>;
};

export type CarModelInput = {
  name: Scalars["String"]["input"];
};

export type CarModelSort = {
  direction: SortDirection;
  field: CarModelSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum CarModelSortFields {
  Id = "id",
  Name = "name",
}

export type CashPaymentMethod = PaymentMethodBase & {
  __typename?: "CashPaymentMethod";
  id?: Maybe<Scalars["ID"]["output"]>;
  mode: PaymentMode;
};

export type ChangeTaxiSupportRequestStatusInput = {
  status: ComplaintStatus;
  supportRequestId: Scalars["ID"]["input"];
};

export type ChartFilterInput = {
  endDate: Scalars["DateTime"]["input"];
  interval: ChartInterval;
  startDate: Scalars["DateTime"]["input"];
};

export enum ChartInterval {
  Daily = "Daily",
  Monthly = "Monthly",
  Quarterly = "Quarterly",
  Yearly = "Yearly",
}

export enum ChartTimeframe {
  Daily = "Daily",
  Monthly = "Monthly",
  Weekly = "Weekly",
  Yearly = "Yearly",
}

export type ChatMessage = {
  __typename?: "ChatMessage";
  createdAt: Scalars["DateTime"]["output"];
  isFromMe: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  seenAt?: Maybe<Scalars["DateTime"]["output"]>;
  senderFullName?: Maybe<Scalars["String"]["output"]>;
};

export type ClosingPaginationInput = {
  after?: InputMaybe<Scalars["Int"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ClusteredLocation = {
  __typename?: "ClusteredLocation";
  count: Scalars["Int"]["output"];
  h3Index: Scalars["String"]["output"];
  location: Point;
};

export type CommissionPartnerConnectionDto = {
  __typename?: "CommissionPartnerConnectionDTO";
  nodes: Array<CommissionPartnerDto>;
  totalCount: Scalars["Int"]["output"];
};

export type CommissionPartnerDto = {
  __typename?: "CommissionPartnerDTO";
  active: Scalars["Boolean"]["output"];
  commissionRatePercent?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  notes?: Maybe<Scalars["String"]["output"]>;
  type: CommissionPartnerType;
  updatedAt: Scalars["DateTime"]["output"];
  usedHistorically: Scalars["Boolean"]["output"];
};

export type CommissionPartnerFilterInput = {
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<CommissionPartnerType>;
};

export type CommissionPartnerInput = {
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  commissionRatePercent?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
  type: CommissionPartnerType;
};

export enum CommissionPartnerType {
  Business = "Business",
  Hotel = "Hotel",
  Other = "Other",
  Restaurant = "Restaurant",
  TourOperator = "TourOperator",
  TravelAgency = "TravelAgency",
}

export type CommissionReportConnectionDto = {
  __typename?: "CommissionReportConnectionDTO";
  nodes: Array<CommissionReportRowDto>;
  summary: CommissionReportSummaryDto;
  totalCount: Scalars["Int"]["output"];
};

export type CommissionReportFilterInput = {
  createdByOperatorId?: InputMaybe<Scalars["ID"]["input"]>;
  driverId?: InputMaybe<Scalars["ID"]["input"]>;
  partnerId?: InputMaybe<Scalars["ID"]["input"]>;
  partnerType?: InputMaybe<CommissionPartnerType>;
  periodFromLocal?: InputMaybe<Scalars["String"]["input"]>;
  periodToLocal?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<DriverClosingRecordStatus>;
};

export type CommissionReportRowDto = {
  __typename?: "CommissionReportRowDTO";
  amount: Scalars["String"]["output"];
  calculationMode: DriverClosingCommissionCalculationMode;
  closingRecordId: Scalars["ID"]["output"];
  commissionRatePercent?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  createdByName: Scalars["String"]["output"];
  driverId: Scalars["ID"]["output"];
  driverName: Scalars["String"]["output"];
  finalizedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  orderId?: Maybe<Scalars["ID"]["output"]>;
  orderReference?: Maybe<Scalars["String"]["output"]>;
  partnerId: Scalars["ID"]["output"];
  partnerName: Scalars["String"]["output"];
  partnerType: CommissionPartnerType;
  periodEnd: Scalars["DateTime"]["output"];
  periodStart: Scalars["DateTime"]["output"];
  recordNumber: Scalars["String"]["output"];
  status: DriverClosingRecordStatus;
  tripReportTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  tripRevenue?: Maybe<Scalars["String"]["output"]>;
};

export type CommissionReportSummaryDto = {
  __typename?: "CommissionReportSummaryDTO";
  commissionedTripCount: Scalars["Int"]["output"];
  entryCount: Scalars["Int"]["output"];
  partnerCount: Scalars["Int"]["output"];
  recordCount: Scalars["Int"]["output"];
  totalCommission: Scalars["String"]["output"];
};

export enum ComplaintActivityType {
  AssignToOperator = "AssignToOperator",
  Comment = "Comment",
  Create = "Create",
  Resolved = "Resolved",
  StatusChange = "StatusChange",
  UnassignFromOperators = "UnassignFromOperators",
  Update = "Update",
}

export enum ComplaintStatus {
  Resolved = "Resolved",
  Submitted = "Submitted",
  UnderInvestigation = "UnderInvestigation",
}

export type ComplaintStatusFilterComparison = {
  eq?: InputMaybe<ComplaintStatus>;
  gt?: InputMaybe<ComplaintStatus>;
  gte?: InputMaybe<ComplaintStatus>;
  iLike?: InputMaybe<ComplaintStatus>;
  in?: InputMaybe<Array<ComplaintStatus>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<ComplaintStatus>;
  lt?: InputMaybe<ComplaintStatus>;
  lte?: InputMaybe<ComplaintStatus>;
  neq?: InputMaybe<ComplaintStatus>;
  notILike?: InputMaybe<ComplaintStatus>;
  notIn?: InputMaybe<Array<ComplaintStatus>>;
  notLike?: InputMaybe<ComplaintStatus>;
};

export type ConfigInformation = {
  __typename?: "ConfigInformation";
  config?: Maybe<CurrentConfiguration>;
  isValid: Scalars["Boolean"]["output"];
};

export type CostResult = FixedCost | RangeCost;

export type CountryDistribution = {
  __typename?: "CountryDistribution";
  count: Scalars["Int"]["output"];
  country: Scalars["String"]["output"];
};

export type Coupon = {
  __typename?: "Coupon";
  allowedServices: Array<Service>;
  code: Scalars["String"]["output"];
  creditGift: Scalars["Float"]["output"];
  description: Scalars["String"]["output"];
  discountFlat: Scalars["Int"]["output"];
  discountPercent: Scalars["Int"]["output"];
  expireAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  isEnabled: Scalars["Boolean"]["output"];
  isFirstTravelOnly: Scalars["Boolean"]["output"];
  manyTimesUserCanUse: Scalars["Int"]["output"];
  manyUsersCanUse: Scalars["Int"]["output"];
  maximumCost: Scalars["Float"]["output"];
  minimumCost: Scalars["Float"]["output"];
  startAt: Scalars["DateTime"]["output"];
  title: Scalars["String"]["output"];
};

export type CouponAllowedServicesArgs = {
  filter?: ServiceFilter;
  sorting?: Array<ServiceSort>;
};

export type CouponConnection = {
  __typename?: "CouponConnection";
  /** Array of nodes. */
  nodes: Array<Coupon>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type CouponDeleteResponse = {
  __typename?: "CouponDeleteResponse";
  code?: Maybe<Scalars["String"]["output"]>;
  creditGift?: Maybe<Scalars["Float"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  discountFlat?: Maybe<Scalars["Int"]["output"]>;
  discountPercent?: Maybe<Scalars["Int"]["output"]>;
  expireAt?: Maybe<Scalars["DateTime"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  isEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  isFirstTravelOnly?: Maybe<Scalars["Boolean"]["output"]>;
  manyTimesUserCanUse?: Maybe<Scalars["Int"]["output"]>;
  manyUsersCanUse?: Maybe<Scalars["Int"]["output"]>;
  maximumCost?: Maybe<Scalars["Float"]["output"]>;
  minimumCost?: Maybe<Scalars["Float"]["output"]>;
  startAt?: Maybe<Scalars["DateTime"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type CouponFilter = {
  and?: InputMaybe<Array<CouponFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<CouponFilter>>;
};

export type CouponInput = {
  code: Scalars["String"]["input"];
  creditGift: Scalars["Float"]["input"];
  description: Scalars["String"]["input"];
  discountFlat: Scalars["Int"]["input"];
  discountPercent: Scalars["Int"]["input"];
  expireAt: Scalars["DateTime"]["input"];
  isEnabled: Scalars["Boolean"]["input"];
  isFirstTravelOnly: Scalars["Boolean"]["input"];
  manyTimesUserCanUse: Scalars["Int"]["input"];
  manyUsersCanUse: Scalars["Int"]["input"];
  maximumCost: Scalars["Float"]["input"];
  minimumCost: Scalars["Float"]["input"];
  startAt: Scalars["DateTime"]["input"];
  title: Scalars["String"]["input"];
};

export type CouponSort = {
  direction: SortDirection;
  field: CouponSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum CouponSortFields {
  Id = "id",
}

export type CreateAndReserveDriverAfterCurrentTripInput = {
  addresses: Array<Scalars["String"]["input"]>;
  dispatcherNote?: InputMaybe<Scalars["String"]["input"]>;
  driverId: Scalars["ID"]["input"];
  fareMode?: InputMaybe<FareMode>;
  optionIds?: Array<Scalars["ID"]["input"]>;
  paymentMode?: InputMaybe<PaymentMode>;
  points: Array<PointInput>;
  /** Reporting-only ride source label. Reservation lifecycle remains unchanged. */
  reportingSource?: InputMaybe<OrderSource>;
  riderId?: InputMaybe<Scalars["ID"]["input"]>;
  scheduledAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  serviceId: Scalars["ID"]["input"];
  tariffProfileId?: InputMaybe<Scalars["ID"]["input"]>;
  tariffProfileReason?: InputMaybe<Scalars["String"]["input"]>;
  twoWay?: Scalars["Boolean"]["input"];
  waitingTimeMinutes?: Scalars["Int"]["input"];
};

export type CreateAndReserveDriverAfterCurrentTripResultDto = {
  __typename?: "CreateAndReserveDriverAfterCurrentTripResultDTO";
  canCancelRequest: Scalars["Boolean"]["output"];
  canCreateNormalRequest: Scalars["Boolean"]["output"];
  canOpenRequest: Scalars["Boolean"]["output"];
  canTryAnotherDriver: Scalars["Boolean"]["output"];
  canTryAutomaticNextAvailable: Scalars["Boolean"]["output"];
  code: Scalars["String"]["output"];
  driverId?: Maybe<Scalars["ID"]["output"]>;
  estimatedFinishEta?: Maybe<Scalars["DateTime"]["output"]>;
  estimatedPickupEta?: Maybe<Scalars["DateTime"]["output"]>;
  holdExpiresAt?: Maybe<Scalars["DateTime"]["output"]>;
  message: Scalars["String"]["output"];
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars["ID"]["output"]>;
  reservedDriverId?: Maybe<Scalars["ID"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type CreateAnnouncementInput = {
  appType?: InputMaybe<AppType>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  expireAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  mediaId?: InputMaybe<Scalars["ID"]["input"]>;
  pushNotification?: InputMaybe<Scalars["Boolean"]["input"]>;
  pushNotificationBody?: InputMaybe<Scalars["String"]["input"]>;
  pushNotificationTitle?: InputMaybe<Scalars["String"]["input"]>;
  smsNotification?: InputMaybe<Scalars["Boolean"]["input"]>;
  smsNotificationBody?: InputMaybe<Scalars["String"]["input"]>;
  startAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  title: Scalars["String"]["input"];
  url?: InputMaybe<Scalars["String"]["input"]>;
  userType?: InputMaybe<Array<AnnouncementUserType>>;
};

export type CreateCampaignInput = {
  codesCount: Scalars["Int"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  discountFlat?: InputMaybe<Scalars["Float"]["input"]>;
  discountPercent: Scalars["Float"]["input"];
  emailSubject?: InputMaybe<Scalars["String"]["input"]>;
  emailText?: InputMaybe<Scalars["String"]["input"]>;
  expireAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  isFirstTravelOnly: Scalars["Boolean"]["input"];
  manyTimesUserCanUse: Scalars["Int"]["input"];
  manyUsersCanUse: Scalars["Int"]["input"];
  maximumCost?: InputMaybe<Scalars["Float"]["input"]>;
  minimumCost?: InputMaybe<Scalars["Float"]["input"]>;
  name: Scalars["String"]["input"];
  pushText?: InputMaybe<Scalars["String"]["input"]>;
  pushTitle?: InputMaybe<Scalars["String"]["input"]>;
  sendAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  sendEmail: Scalars["Boolean"]["input"];
  sendPush: Scalars["Boolean"]["input"];
  sendSMS: Scalars["Boolean"]["input"];
  smsText?: InputMaybe<Scalars["String"]["input"]>;
  startAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  targetUsers: Array<CampaignTargetSegmentCriteria>;
};

export type CreateCustomerNoteInput = {
  customerId: Scalars["ID"]["input"];
  note: Scalars["String"]["input"];
};

export type CreateDispatcherGuestCustomerInput = {
  countryOfResidence?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  mobileNumber: Scalars["String"]["input"];
  nationality?: InputMaybe<Scalars["String"]["input"]>;
  tariffProfileId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CreateDispatcherRegisteredCustomerInput = {
  countryOfResidence?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName: Scalars["String"]["input"];
  gender?: InputMaybe<Gender>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  mobileNumber: Scalars["String"]["input"];
  nationality?: InputMaybe<Scalars["String"]["input"]>;
  tariffProfileId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CreateDriverNoteInput = {
  driverId: Scalars["ID"]["input"];
  note: Scalars["String"]["input"];
};

export type CreateFleetInput = {
  accountNumber: Scalars["String"]["input"];
  address?: InputMaybe<Scalars["String"]["input"]>;
  commissionShareFlat: Scalars["Float"]["input"];
  commissionSharePercent: Scalars["Float"]["input"];
  exclusivityAreas?: InputMaybe<Array<Array<PointInput>>>;
  feeMultiplier?: InputMaybe<Scalars["Float"]["input"]>;
  isBlocked?: InputMaybe<Scalars["Boolean"]["input"]>;
  mobileNumber: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  phoneNumber: Scalars["String"]["input"];
  profilePictureId?: InputMaybe<Scalars["ID"]["input"]>;
  userName: Scalars["String"]["input"];
};

export type CreateFleetStaffInput = {
  address?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName: Scalars["String"]["input"];
  fleetId: Scalars["ID"]["input"];
  lastName: Scalars["String"]["input"];
  mobileNumber?: InputMaybe<Scalars["String"]["input"]>;
  password: Scalars["String"]["input"];
  permissionFinancial: FleetStaffPermissionFinancial;
  permissionOrder: FleetStaffPermissionOrder;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  profileImageId?: InputMaybe<Scalars["ID"]["input"]>;
  userName: Scalars["String"]["input"];
};

export type CreateGiftBatchInput = {
  amount: Scalars["Float"]["input"];
  availableFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  currency: Scalars["String"]["input"];
  expireAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  name: Scalars["String"]["input"];
  quantity: Scalars["Int"]["input"];
};

export type CreateManyDriverDocumentRetentionPoliciesInput = {
  /** Array of records to create */
  driverDocumentRetentionPolicies: Array<DriverDocumentRetentionPolicyInput>;
};

export type CreateManyDriverDocumentsInput = {
  /** Array of records to create */
  driverDocuments: Array<DriverDocumentInput>;
};

export type CreateManyDriverShiftRulesInput = {
  /** Array of records to create */
  driverShiftRules: Array<DriverShiftRuleInput>;
};

export type CreateManyEmailProvidersInput = {
  /** Array of records to create */
  emailProviders: Array<EmailProviderInput>;
};

export type CreateManyEmailTemplatesInput = {
  /** Array of records to create */
  emailTemplates: Array<EmailTemplateInput>;
};

export type CreateManySmsInput = {
  /** Array of records to create */
  sMS: Array<CreateSms>;
};

export type CreateManySmsProvidersInput = {
  /** Array of records to create */
  sMSProviders: Array<SmsProviderInput>;
};

export type CreateOneCarColorInput = {
  /** The record to create */
  carColor: CarColorInput;
};

export type CreateOneCarModelInput = {
  /** The record to create */
  carModel: CarModelInput;
};

export type CreateOneCouponInput = {
  /** The record to create */
  coupon: CouponInput;
};

export type CreateOneCustomerNoteInput = {
  /** The record to create */
  customerNote: CreateCustomerNoteInput;
};

export type CreateOneDriverDocumentInput = {
  /** The record to create */
  driverDocument: DriverDocumentInput;
};

export type CreateOneDriverDocumentRetentionPolicyInput = {
  /** The record to create */
  driverDocumentRetentionPolicy: DriverDocumentRetentionPolicyInput;
};

export type CreateOneDriverInput = {
  /** The record to create */
  driver: UpdateDriverInput;
};

export type CreateOneDriverNoteInput = {
  /** The record to create */
  driverNote: CreateDriverNoteInput;
};

export type CreateOneDriverShiftRuleInput = {
  /** The record to create */
  driverShiftRule: DriverShiftRuleInput;
};

export type CreateOneDriverToDriverDocumentInput = {
  /** The record to create */
  driverToDriverDocument: DriverToDriverDocumentInput;
};

export type CreateOneDriverTransactionInput = {
  /** The record to create */
  driverTransaction: DriverTransactionInput;
};

export type CreateOneEmailProviderInput = {
  /** The record to create */
  emailProvider: EmailProviderInput;
};

export type CreateOneEmailTemplateInput = {
  /** The record to create */
  emailTemplate: EmailTemplateInput;
};

export type CreateOneFeedbackParameterInput = {
  /** The record to create */
  feedbackParameter: FeedbackParameterInput;
};

export type CreateOneFleetInput = {
  /** The record to create */
  fleet: CreateFleetInput;
};

export type CreateOneFleetStaffInput = {
  /** The record to create */
  fleetStaff: CreateFleetStaffInput;
};

export type CreateOneOperatorInput = {
  /** The record to create */
  operator: CreateOperatorInput;
};

export type CreateOneOperatorRoleInput = {
  /** The record to create */
  operatorRole: OperatorRoleInput;
};

export type CreateOneOrderCancelReasonInput = {
  /** The record to create */
  orderCancelReason: OrderCancelReasonInput;
};

export type CreateOnePaymentGatewayInput = {
  /** The record to create */
  paymentGateway: CreatePaymentGatewayInput;
};

export type CreateOnePayoutMethodInput = {
  /** The record to create */
  payoutMethod: CreatePayoutMethodInput;
};

export type CreateOneProviderTransactionInput = {
  /** The record to create */
  providerTransaction: ProviderTransactionInput;
};

export type CreateOneRegionCategoryInput = {
  /** The record to create */
  regionCategory: RegionCategoryInput;
};

export type CreateOneRegionInput = {
  /** The record to create */
  region: CreateRegionInput;
};

export type CreateOneRewardInput = {
  /** The record to create */
  reward: CreateReward;
};

export type CreateOneRiderAddressInput = {
  /** The record to create */
  riderAddress: CreateRiderAddress;
};

export type CreateOneRiderInput = {
  /** The record to create */
  rider: RiderInput;
};

export type CreateOneRiderTransactionInput = {
  /** The record to create */
  riderTransaction: RiderTransactionInput;
};

export type CreateOneSmsInput = {
  /** The record to create */
  sMS: CreateSms;
};

export type CreateOneSmsProviderInput = {
  /** The record to create */
  sMSProvider: SmsProviderInput;
};

export type CreateOneSosActivityInput = {
  /** The record to create */
  sOSActivity: CreateSosAcitivtyInput;
};

export type CreateOneSosReasonInput = {
  /** The record to create */
  sOSReason: CreateSosReasonInput;
};

export type CreateOneServiceCategoryInput = {
  /** The record to create */
  serviceCategory: ServiceCategoryInput;
};

export type CreateOneServiceInput = {
  /** The record to create */
  service: ServiceInput;
};

export type CreateOneServiceOptionInput = {
  /** The record to create */
  serviceOption: ServiceOptionInput;
};

export type CreateOneServiceTariffProfileInput = {
  /** The record to create */
  serviceTariffProfile: ServiceTariffProfileInput;
};

export type CreateOneTariffProfileInput = {
  /** The record to create */
  tariffProfile: TariffProfileInput;
};

export type CreateOneTaxiSupportRequestActivityInput = {
  /** The record to create */
  taxiSupportRequestActivity: CreateTaxiSupportRequestActivity;
};

export type CreateOneZoneMultiplierInput = {
  /** The record to create */
  zoneMultiplier: ZoneMultiplierInput;
};

export type CreateOneZonePriceCategoryInput = {
  /** The record to create */
  zonePriceCategory: ZonePriceCategoryInput;
};

export type CreateOneZonePriceInput = {
  /** The record to create */
  zonePrice: ZonePriceInput;
};

export type CreateOperatorInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  mobileNumber: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  roleId: Scalars["ID"]["input"];
  userName: Scalars["String"]["input"];
};

export type CreateOrderInput = {
  addresses: Array<Scalars["String"]["input"]>;
  /** Internal dispatcher flow flag: create the order without dispatching so it can be manually reserved for a busy driver. */
  deferDispatchForManualReservation?: Scalars["Boolean"]["input"];
  dispatcherNote?: InputMaybe<Scalars["String"]["input"]>;
  driverId?: InputMaybe<Scalars["ID"]["input"]>;
  fareMode?: InputMaybe<FareMode>;
  optionIds?: Array<Scalars["ID"]["input"]>;
  paymentMode?: InputMaybe<PaymentMode>;
  points: Array<PointInput>;
  /** Reporting-only ride source label. Dispatcher lifecycle remains unchanged. */
  reportingSource?: InputMaybe<OrderSource>;
  riderId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Absolute scheduled pickup time for future rides. */
  scheduledAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  serviceId: Scalars["ID"]["input"];
  tariffProfileId?: InputMaybe<Scalars["ID"]["input"]>;
  tariffProfileReason?: InputMaybe<Scalars["String"]["input"]>;
  twoWay?: Scalars["Boolean"]["input"];
  waitingTimeMinutes?: Scalars["Int"]["input"];
};

export type CreatePaymentGatewayInput = {
  enabled: Scalars["Boolean"]["input"];
  mediaId?: InputMaybe<Scalars["ID"]["input"]>;
  merchantId?: InputMaybe<Scalars["ID"]["input"]>;
  privateKey: Scalars["String"]["input"];
  publicKey?: InputMaybe<Scalars["String"]["input"]>;
  saltKey?: InputMaybe<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
  type: PaymentGatewayType;
};

export type CreatePayoutMethodInput = {
  currency: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  mediaId?: InputMaybe<Scalars["ID"]["input"]>;
  merchantId?: InputMaybe<Scalars["ID"]["input"]>;
  name: Scalars["String"]["input"];
  privateKey?: InputMaybe<Scalars["String"]["input"]>;
  publicKey?: InputMaybe<Scalars["String"]["input"]>;
  saltKey?: InputMaybe<Scalars["String"]["input"]>;
  type: PayoutMethodType;
};

export type CreatePayoutSessionInput = {
  appType?: AppType;
  currency: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  minimumAmount: Scalars["Float"]["input"];
  payoutMethodIds: Array<Scalars["ID"]["input"]>;
};

export type CreateRegionInput = {
  categoryId?: InputMaybe<Scalars["ID"]["input"]>;
  currency: Scalars["String"]["input"];
  enabled: Scalars["Boolean"]["input"];
  location: Array<Array<PointInput>>;
  name: Scalars["String"]["input"];
};

export type CreateReward = {
  appType: RewardAppType;
  beneficiary: RewardBeneficiary;
  conditionTripCountsLessThan?: InputMaybe<Scalars["Float"]["input"]>;
  conditionUserNumberFirstDigits?: InputMaybe<
    Array<Scalars["String"]["input"]>
  >;
  creditCurrency?: InputMaybe<Scalars["String"]["input"]>;
  creditGift: Scalars["Float"]["input"];
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  event: RewardEvent;
  id: Scalars["ID"]["input"];
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  title: Scalars["String"]["input"];
  tripFeePercentGift?: InputMaybe<Scalars["Float"]["input"]>;
};

export type CreateRiderAddress = {
  details?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  location: PointInput;
  riderId: Scalars["ID"]["input"];
  title: Scalars["String"]["input"];
  type: RiderAddressType;
};

export type CreateSms = {
  countryIsoCode: Scalars["String"]["input"];
  from: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
  message: Scalars["String"]["input"];
  providerId: Scalars["ID"]["input"];
  status: SmsStatus;
  to: Scalars["String"]["input"];
  type: SmsType;
};

export type CreateSosAcitivtyInput = {
  action: SosActivityAction;
  note?: InputMaybe<Scalars["String"]["input"]>;
  sosId: Scalars["ID"]["input"];
};

export type CreateSosReasonInput = {
  name: Scalars["String"]["input"];
};

export type CreateTaxiOrderNoteInput = {
  note: Scalars["String"]["input"];
  orderId: Scalars["ID"]["input"];
};

export type CreateTaxiSupportRequestActivity = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
  complaintId: Scalars["ID"]["input"];
  createdAt: Scalars["DateTime"]["input"];
  id: Scalars["ID"]["input"];
  statusFrom?: InputMaybe<ComplaintStatus>;
  statusTo?: InputMaybe<ComplaintStatus>;
  type: ComplaintActivityType;
};

export type CreateTaxiSupportRequestCommentInput = {
  comment: Scalars["String"]["input"];
  supportRequestId: Scalars["ID"]["input"];
};

export type CreateTelematicsProfileVersionInput = {
  fields: Array<TelematicsFieldMappingInput>;
  name: Scalars["String"]["input"];
  previousProfileId?: InputMaybe<Scalars["ID"]["input"]>;
  providerSettingId: Scalars["ID"]["input"];
};

export type CreateVehicleInput = {
  colorId?: InputMaybe<Scalars["ID"]["input"]>;
  modelId?: InputMaybe<Scalars["ID"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  plate: Scalars["String"]["input"];
  productionYear?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<VehicleStatus>;
};

export type CreateVehicleTelematicsMappingInput = {
  acceptDegradedCapability?: Scalars["Boolean"]["input"];
  confirmed: Scalars["Boolean"]["input"];
  profileId: Scalars["ID"]["input"];
  providerDeviceId?: InputMaybe<Scalars["String"]["input"]>;
  providerSettingId: Scalars["ID"]["input"];
  providerUserId: Scalars["String"]["input"];
  vehicleId: Scalars["ID"]["input"];
};

export type CurrentConfiguration = {
  __typename?: "CurrentConfiguration";
  adminPanelAPIKey?: Maybe<Scalars["String"]["output"]>;
  adminPanelMapId?: Maybe<Scalars["String"]["output"]>;
  backendMapsAPIKey?: Maybe<Scalars["String"]["output"]>;
  companyColor?: Maybe<AppColorScheme>;
  companyLogo?: Maybe<Scalars["String"]["output"]>;
  companyName?: Maybe<Scalars["String"]["output"]>;
  firebaseProjectPrivateKey?: Maybe<Scalars["String"]["output"]>;
  mysqlDatabase?: Maybe<Scalars["String"]["output"]>;
  mysqlHost?: Maybe<Scalars["String"]["output"]>;
  mysqlPassword?: Maybe<Scalars["String"]["output"]>;
  mysqlPort?: Maybe<Scalars["Int"]["output"]>;
  mysqlUser?: Maybe<Scalars["String"]["output"]>;
  redisDb?: Maybe<Scalars["Int"]["output"]>;
  redisHost?: Maybe<Scalars["String"]["output"]>;
  redisPassword?: Maybe<Scalars["String"]["output"]>;
  redisPort?: Maybe<Scalars["Int"]["output"]>;
  taxi?: Maybe<AppConfigInfo>;
  versionNumber?: Maybe<Scalars["String"]["output"]>;
};

export type CursorPaging = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars["ConnectionCursor"]["input"]>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars["ConnectionCursor"]["input"]>;
  /** Paginate first */
  first?: InputMaybe<Scalars["Int"]["input"]>;
  /** Paginate last */
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CustomerLoginPerApp = {
  __typename?: "CustomerLoginPerApp";
  app: AppType;
  count: Scalars["Int"]["output"];
};

export type CustomerNote = {
  __typename?: "CustomerNote";
  createdAt: Scalars["DateTime"]["output"];
  createdBy: Operator;
  createdById: Scalars["ID"]["output"];
  customer: Rider;
  customerId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  note: Scalars["String"]["output"];
};

export type CustomerNoteFilter = {
  and?: InputMaybe<Array<CustomerNoteFilter>>;
  customerId: IdFilterComparison;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<CustomerNoteFilter>>;
};

export type CustomerNoteSort = {
  direction: SortDirection;
  field: CustomerNoteSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum CustomerNoteSortFields {
  CustomerId = "customerId",
  Id = "id",
}

export type CustomerSession = {
  __typename?: "CustomerSession";
  customerId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  sessionInfo: SessionInfo;
};

export type CustomerSessionDeleteResponse = {
  __typename?: "CustomerSessionDeleteResponse";
  customerId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  sessionInfo?: Maybe<SessionInfo>;
};

export type CustomerSessionFilter = {
  and?: InputMaybe<Array<CustomerSessionFilter>>;
  customerId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<CustomerSessionFilter>>;
};

export type CustomerSessionSort = {
  direction: SortDirection;
  field: CustomerSessionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum CustomerSessionSortFields {
  CustomerId = "customerId",
  Id = "id",
}

export type DashboardRevenueByServiceItemDto = {
  __typename?: "DashboardRevenueByServiceItemDTO";
  currency: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  sum: Scalars["Float"]["output"];
};

export type DashboardServicePerformanceDto = {
  __typename?: "DashboardServicePerformanceDTO";
  avgTripDurationSeconds?: Maybe<Scalars["Float"]["output"]>;
  avgWaitMinutes?: Maybe<Scalars["Float"]["output"]>;
  peakHour?: Maybe<Scalars["String"]["output"]>;
  peakRideCount: Scalars["Int"]["output"];
};

export type DateFieldComparison = {
  between?: InputMaybe<DateFieldComparisonBetween>;
  eq?: InputMaybe<Scalars["DateTime"]["input"]>;
  gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  in?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  neq?: InputMaybe<Scalars["DateTime"]["input"]>;
  notBetween?: InputMaybe<DateFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
};

export type DateFieldComparisonBetween = {
  lower: Scalars["DateTime"]["input"];
  upper: Scalars["DateTime"]["input"];
};

export type DateRangeMultiplier = {
  __typename?: "DateRangeMultiplier";
  endDate: Scalars["Float"]["output"];
  multiply: Scalars["Float"]["output"];
  startDate: Scalars["Float"]["output"];
};

export type DateRangeMultiplierInput = {
  endDate: Scalars["Float"]["input"];
  multiply: Scalars["Float"]["input"];
  startDate: Scalars["Float"]["input"];
};

export type DeleteManyDriverDocumentRetentionPoliciesInput = {
  /** Filter to find records to delete */
  filter: DriverDocumentRetentionPolicyDeleteFilter;
};

export type DeleteManyDriverDocumentsInput = {
  /** Filter to find records to delete */
  filter: DriverDocumentDeleteFilter;
};

export type DeleteManyDriverShiftRulesInput = {
  /** Filter to find records to delete */
  filter: DriverShiftRuleDeleteFilter;
};

export type DeleteManyEmailProvidersInput = {
  /** Filter to find records to delete */
  filter: EmailProviderDeleteFilter;
};

export type DeleteManyEmailTemplatesInput = {
  /** Filter to find records to delete */
  filter: EmailTemplateDeleteFilter;
};

export type DeleteManyEmailsInput = {
  /** Filter to find records to delete */
  filter: EmailDeleteFilter;
};

export type DeleteManyResponse = {
  __typename?: "DeleteManyResponse";
  /** The number of records deleted. */
  deletedCount: Scalars["Int"]["output"];
};

export type DeleteManySmsInput = {
  /** Filter to find records to delete */
  filter: SmsDeleteFilter;
};

export type DeleteManySmsProvidersInput = {
  /** Filter to find records to delete */
  filter: SmsProviderDeleteFilter;
};

export type DeleteOneAnnouncementInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneCampaignInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneCarColorInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneCarModelInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneCouponInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneCustomerSessionInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneDriverDocumentInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneDriverDocumentRetentionPolicyInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneDriverSessionInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneDriverShiftRuleInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneDriverToDriverDocumentInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneEmailInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneEmailProviderInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneEmailTemplateInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneFeedbackParameterInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneFleetInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneFleetStaffInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneOperatorInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneOperatorRoleInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneOrderCancelReasonInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOnePaymentGatewayInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOnePayoutMethodInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneRegionCategoryInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneRegionInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneRewardInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneSmsInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneSmsProviderInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneSosReasonInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneSavedPaymentMethodInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneServiceCategoryInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneServiceInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneServiceOptionInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneServiceTariffProfileInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneTariffProfileInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneZoneMultiplierInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneZonePriceCategoryInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeleteOneZonePriceInput = {
  /** The id of the record to delete. */
  id: Scalars["ID"]["input"];
};

export type DeliveryContact = {
  __typename?: "DeliveryContact";
  addressLine1: Scalars["String"]["output"];
  addressLine2?: Maybe<Scalars["String"]["output"]>;
  apartmentNumber?: Maybe<Scalars["String"]["output"]>;
  buildingNumber?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  companyName?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  instructions?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  phoneNumber: PhoneNumber;
  postalCode?: Maybe<Scalars["String"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
  zone?: Maybe<Scalars["String"]["output"]>;
};

export type DeliveryContactInput = {
  addressLine1: Scalars["String"]["input"];
  addressLine2?: InputMaybe<Scalars["String"]["input"]>;
  apartmentNumber?: InputMaybe<Scalars["String"]["input"]>;
  buildingNumber?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  companyName?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  instructions?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  phoneNumber: PhoneNumberInput;
  postalCode?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  zone?: InputMaybe<Scalars["String"]["input"]>;
};

export enum DeliveryPackageSize {
  Large = "Large",
  Medium = "Medium",
  Small = "Small",
}

export type DeliveryPackageSizeFilterComparison = {
  eq?: InputMaybe<DeliveryPackageSize>;
  gt?: InputMaybe<DeliveryPackageSize>;
  gte?: InputMaybe<DeliveryPackageSize>;
  iLike?: InputMaybe<DeliveryPackageSize>;
  in?: InputMaybe<Array<DeliveryPackageSize>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<DeliveryPackageSize>;
  lt?: InputMaybe<DeliveryPackageSize>;
  lte?: InputMaybe<DeliveryPackageSize>;
  neq?: InputMaybe<DeliveryPackageSize>;
  notILike?: InputMaybe<DeliveryPackageSize>;
  notIn?: InputMaybe<Array<DeliveryPackageSize>>;
  notLike?: InputMaybe<DeliveryPackageSize>;
};

export type DeliveryWaypoint = WaypointBase & {
  __typename?: "DeliveryWaypoint";
  address: Scalars["String"]["output"];
  deliveryContact?: Maybe<DeliveryContact>;
  location: Point;
  role: WaypointRole;
  service: WaypointService;
};

export enum DevicePlatform {
  Android = "Android",
  Ios = "Ios",
  Linux = "Linux",
  MacOs = "MacOS",
  Web = "Web",
  Windows = "Windows",
}

export enum DeviceType {
  Desktop = "DESKTOP",
  Mobile = "MOBILE",
}

export type DisableAllIntegrationRuntimeInput = {
  expectedDesktopVersion: Scalars["Int"]["input"];
  expectedTelematicsVersion: Scalars["Int"]["input"];
  providerSettingId: Scalars["ID"]["input"];
  reason: Scalars["String"]["input"];
};

export type DispatchAutomationOptions = {
  __typename?: "DispatchAutomationOptions";
  candidateSearchLimit: Scalars["Int"]["output"];
  enabled: Scalars["Boolean"]["output"];
  initialRadiusMeters: Scalars["Int"]["output"];
};

export type DispatchAutomationOptionsInput = {
  candidateSearchLimit: Scalars["Int"]["input"];
  enabled: Scalars["Boolean"]["input"];
  initialRadiusMeters: Scalars["Int"]["input"];
};

export type DispatchConfig = {
  __typename?: "DispatchConfig";
  /** Broadcast-specific configuration */
  broadcastConfig?: Maybe<BroadcastConfig>;
  /** Fallback configuration for dispatch */
  fallback?: Maybe<FallbackConfig>;
  /** Maximum search radius in meters */
  maxSearchRadiusMeters: Scalars["Int"]["output"];
  /** Next Available Driver waiting-request configuration */
  nextAvailable?: Maybe<NextAvailableConfig>;
  /** Enable admin notifications on dispatch failure */
  notifyAdminOnFailure?: Maybe<Scalars["Boolean"]["output"]>;
  /** Pre-dispatch buffer in minutes (dispatches scheduled orders this many minutes before the scheduled pickup time) */
  preDispatchBufferMinutes?: Maybe<Scalars["Int"]["output"]>;
  /** Radius expansion configuration for dispatch */
  radiusExpansion?: Maybe<RadiusExpansionConfig>;
  /** Request timeout in seconds for dispatch */
  requestTimeoutSeconds: Scalars["Int"]["output"];
  /** Scheduling behavior configuration */
  schedule?: Maybe<ScheduleConfig>;
  /** Driver scoring configuration for dispatch */
  scoring?: Maybe<DriverScoringConfig>;
  /** Sequential-specific configuration */
  sequentialConfig?: Maybe<SequentialConfig>;
  /** The dispatch strategy to use */
  strategy: DispatchStrategy;
};

export type DispatchConfigInput = {
  /** Broadcast-specific configuration */
  broadcastConfig?: InputMaybe<BroadcastConfigInput>;
  /** Fallback configuration for dispatch */
  fallback?: InputMaybe<FallbackConfigInput>;
  /** Maximum search radius in meters */
  maxSearchRadiusMeters: Scalars["Int"]["input"];
  /** Next Available Driver waiting-request configuration */
  nextAvailable?: InputMaybe<NextAvailableConfigInput>;
  /** Enable admin notifications on dispatch failure */
  notifyAdminOnFailure?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Pre-dispatch buffer in minutes (dispatches scheduled orders this many minutes before the scheduled pickup time) */
  preDispatchBufferMinutes?: InputMaybe<Scalars["Int"]["input"]>;
  /** Radius expansion configuration for dispatch */
  radiusExpansion?: InputMaybe<RadiusExpansionConfigInput>;
  /** Request timeout in seconds for dispatch */
  requestTimeoutSeconds: Scalars["Int"]["input"];
  /** Scheduling behavior configuration */
  schedule?: InputMaybe<ScheduleConfigInput>;
  /** Driver scoring configuration for dispatch */
  scoring?: InputMaybe<DriverScoringConfigInput>;
  /** Sequential-specific configuration */
  sequentialConfig?: InputMaybe<SequentialConfigInput>;
  /** The dispatch strategy to use */
  strategy: DispatchStrategy;
};

export type DispatchNextAvailableRuntimeField = {
  __typename?: "DispatchNextAvailableRuntimeField";
  field: Scalars["String"]["output"];
  invalidOverride: Scalars["Boolean"]["output"];
  overridden: Scalars["Boolean"]["output"];
  value: Scalars["Float"]["output"];
};

export type DispatchPolicy = {
  __typename?: "DispatchPolicy";
  automation: DispatchAutomationOptions;
  configuration: DispatchConfig;
  fingerprint: Scalars["String"]["output"];
  nextAvailableRuntime: Array<DispatchNextAvailableRuntimeField>;
  updatedAt?: Maybe<Scalars["String"]["output"]>;
  updatedBy?: Maybe<Scalars["Int"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type DispatchPolicyRevision = {
  __typename?: "DispatchPolicyRevision";
  actorOperatorId: Scalars["Int"]["output"];
  changedAt: Scalars["DateTime"]["output"];
  newValues: DispatchPolicyValues;
  previousValues: DispatchPolicyValues;
  reason: Scalars["String"]["output"];
  version: Scalars["Int"]["output"];
};

export type DispatchPolicyValues = {
  __typename?: "DispatchPolicyValues";
  automation: DispatchAutomationOptions;
  configuration: DispatchConfig;
};

export enum DispatchStrategy {
  Broadcast = "Broadcast",
  Sequential = "Sequential",
}

export type DistanceMultiplier = {
  __typename?: "DistanceMultiplier";
  distanceFrom: Scalars["Float"]["output"];
  distanceTo: Scalars["Float"]["output"];
  multiply: Scalars["Float"]["output"];
};

export type DistanceMultiplierInput = {
  distanceFrom: Scalars["Float"]["input"];
  distanceTo: Scalars["Float"]["input"];
  multiply: Scalars["Float"]["input"];
};

export type DistressSignal = {
  __typename?: "DistressSignal";
  activities: Array<SosActivity>;
  activitiesAggregate: Array<DistressSignalActivitiesAggregateResponse>;
  comment?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  location?: Maybe<Point>;
  order: Order;
  reason?: Maybe<SosReason>;
  requestId: Scalars["ID"]["output"];
  status: SosStatus;
  submittedByRider: Scalars["Boolean"]["output"];
};

export type DistressSignalActivitiesArgs = {
  filter?: SosActivityFilter;
  sorting?: Array<SosActivitySort>;
};

export type DistressSignalActivitiesAggregateArgs = {
  filter?: InputMaybe<SosActivityAggregateFilter>;
};

export type DistressSignalActivitiesAggregateGroupBy = {
  __typename?: "DistressSignalActivitiesAggregateGroupBy";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type DistressSignalActivitiesAggregateResponse = {
  __typename?: "DistressSignalActivitiesAggregateResponse";
  avg?: Maybe<DistressSignalActivitiesAvgAggregate>;
  count?: Maybe<DistressSignalActivitiesCountAggregate>;
  groupBy?: Maybe<DistressSignalActivitiesAggregateGroupBy>;
  max?: Maybe<DistressSignalActivitiesMaxAggregate>;
  min?: Maybe<DistressSignalActivitiesMinAggregate>;
  sum?: Maybe<DistressSignalActivitiesSumAggregate>;
};

export type DistressSignalActivitiesAvgAggregate = {
  __typename?: "DistressSignalActivitiesAvgAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type DistressSignalActivitiesCountAggregate = {
  __typename?: "DistressSignalActivitiesCountAggregate";
  id?: Maybe<Scalars["Int"]["output"]>;
};

export type DistressSignalActivitiesMaxAggregate = {
  __typename?: "DistressSignalActivitiesMaxAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type DistressSignalActivitiesMinAggregate = {
  __typename?: "DistressSignalActivitiesMinAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type DistressSignalActivitiesSumAggregate = {
  __typename?: "DistressSignalActivitiesSumAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type DistressSignalAggregateFilter = {
  and?: InputMaybe<Array<DistressSignalAggregateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DistressSignalAggregateFilter>>;
  status?: InputMaybe<SosStatusFilterComparison>;
};

export type DistressSignalAggregateGroupBy = {
  __typename?: "DistressSignalAggregateGroupBy";
  id?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<SosStatus>;
};

export type DistressSignalAggregateResponse = {
  __typename?: "DistressSignalAggregateResponse";
  avg?: Maybe<DistressSignalAvgAggregate>;
  count?: Maybe<DistressSignalCountAggregate>;
  groupBy?: Maybe<DistressSignalAggregateGroupBy>;
  max?: Maybe<DistressSignalMaxAggregate>;
  min?: Maybe<DistressSignalMinAggregate>;
  sum?: Maybe<DistressSignalSumAggregate>;
};

export type DistressSignalAvgAggregate = {
  __typename?: "DistressSignalAvgAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type DistressSignalConnection = {
  __typename?: "DistressSignalConnection";
  /** Array of nodes. */
  nodes: Array<DistressSignal>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type DistressSignalCountAggregate = {
  __typename?: "DistressSignalCountAggregate";
  id?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
};

export type DistressSignalFilter = {
  and?: InputMaybe<Array<DistressSignalFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DistressSignalFilter>>;
  status?: InputMaybe<SosStatusFilterComparison>;
};

export type DistressSignalMaxAggregate = {
  __typename?: "DistressSignalMaxAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<SosStatus>;
};

export type DistressSignalMinAggregate = {
  __typename?: "DistressSignalMinAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<SosStatus>;
};

export type DistressSignalSort = {
  direction: SortDirection;
  field: DistressSignalSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum DistressSignalSortFields {
  Id = "id",
  Status = "status",
}

export type DistressSignalSumAggregate = {
  __typename?: "DistressSignalSumAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type Driver = {
  __typename?: "Driver";
  accountNumber?: Maybe<Scalars["String"]["output"]>;
  address?: Maybe<Scalars["String"]["output"]>;
  bankName?: Maybe<Scalars["String"]["output"]>;
  bankRoutingNumber?: Maybe<Scalars["String"]["output"]>;
  bankSwift?: Maybe<Scalars["String"]["output"]>;
  canDeliver: Scalars["Boolean"]["output"];
  carColorId?: Maybe<Scalars["ID"]["output"]>;
  carId?: Maybe<Scalars["ID"]["output"]>;
  carPlate?: Maybe<Scalars["String"]["output"]>;
  carProductionYear?: Maybe<Scalars["Int"]["output"]>;
  certificateNumber?: Maybe<Scalars["String"]["output"]>;
  countryIso?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use driverToDriverDocuments instead. This will be removed in the next major version. */
  documents: Array<Media>;
  documentsAggregate: Array<DriverDocumentsAggregateResponse>;
  driverToDriverDocuments: Array<DriverToDriverDocument>;
  driverToDriverDocumentsAggregate: Array<DriverDriverToDriverDocumentsAggregateResponse>;
  email?: Maybe<Scalars["String"]["output"]>;
  enabledServices: Array<DriverServicesServiceDto>;
  enabledServicesAggregate: Array<DriverEnabledServicesAggregateResponse>;
  feedbacks: DriverFeedbacksConnection;
  feedbacksAggregate: Array<DriverFeedbacksAggregateResponse>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  gender?: Maybe<Gender>;
  id: Scalars["ID"]["output"];
  lastName?: Maybe<Scalars["String"]["output"]>;
  lastSeenTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  maxDeliveryPackageSize: DeliveryPackageSize;
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars["ID"]["output"]>;
  mobileNumber: Scalars["String"]["output"];
  orders: DriverOrdersConnection;
  ordersAggregate: Array<DriverOrdersAggregateResponse>;
  payoutAccounts: DriverPayoutAccountsConnection;
  payoutAccountsAggregate: Array<DriverPayoutAccountsAggregateResponse>;
  rating?: Maybe<Scalars["Int"]["output"]>;
  registrationTimestamp: Scalars["DateTime"]["output"];
  reviewCount: Scalars["Int"]["output"];
  sessions: Array<DriverSession>;
  sessionsAggregate: Array<DriverSessionsAggregateResponse>;
  softRejectionNote?: Maybe<Scalars["String"]["output"]>;
  status: DriverStatus;
  transactions: DriverTransactionsConnection;
  transactionsAggregate: Array<DriverTransactionsAggregateResponse>;
  wallet: Array<DriverWallet>;
  walletAggregate: Array<DriverWalletAggregateResponse>;
};

export type DriverDocumentsArgs = {
  filter?: MediaFilter;
  sorting?: Array<MediaSort>;
};

export type DriverDocumentsAggregateArgs = {
  filter?: InputMaybe<MediaAggregateFilter>;
};

export type DriverDriverToDriverDocumentsArgs = {
  filter?: DriverToDriverDocumentFilter;
  sorting?: Array<DriverToDriverDocumentSort>;
};

export type DriverDriverToDriverDocumentsAggregateArgs = {
  filter?: InputMaybe<DriverToDriverDocumentAggregateFilter>;
};

export type DriverEnabledServicesArgs = {
  filter?: DriverServicesServiceDtoFilter;
  sorting?: Array<DriverServicesServiceDtoSort>;
};

export type DriverEnabledServicesAggregateArgs = {
  filter?: InputMaybe<DriverServicesServiceDtoAggregateFilter>;
};

export type DriverFeedbacksArgs = {
  filter?: FeedbackFilter;
  paging?: OffsetPaging;
  sorting?: Array<FeedbackSort>;
};

export type DriverFeedbacksAggregateArgs = {
  filter?: InputMaybe<FeedbackAggregateFilter>;
};

export type DriverOrdersArgs = {
  filter?: OrderFilter;
  paging?: OffsetPaging;
  sorting?: Array<OrderSort>;
};

export type DriverOrdersAggregateArgs = {
  filter?: InputMaybe<OrderAggregateFilter>;
};

export type DriverPayoutAccountsArgs = {
  filter?: PayoutAccountFilter;
  paging?: OffsetPaging;
  sorting?: Array<PayoutAccountSort>;
};

export type DriverPayoutAccountsAggregateArgs = {
  filter?: InputMaybe<PayoutAccountAggregateFilter>;
};

export type DriverSessionsArgs = {
  filter?: DriverSessionFilter;
  sorting?: Array<DriverSessionSort>;
};

export type DriverSessionsAggregateArgs = {
  filter?: InputMaybe<DriverSessionAggregateFilter>;
};

export type DriverTransactionsArgs = {
  filter?: DriverTransactionFilter;
  paging?: OffsetPaging;
  sorting?: Array<DriverTransactionSort>;
};

export type DriverTransactionsAggregateArgs = {
  filter?: InputMaybe<DriverTransactionAggregateFilter>;
};

export type DriverWalletArgs = {
  filter?: DriverWalletFilter;
  sorting?: Array<DriverWalletSort>;
};

export type DriverWalletAggregateArgs = {
  filter?: InputMaybe<DriverWalletAggregateFilter>;
};

export type DriverAggregateFilter = {
  and?: InputMaybe<Array<DriverAggregateFilter>>;
  carColorId?: InputMaybe<IdFilterComparison>;
  carId?: InputMaybe<IdFilterComparison>;
  carPlate?: InputMaybe<StringFieldComparison>;
  firstName?: InputMaybe<StringFieldComparison>;
  fleetId?: InputMaybe<IdFilterComparison>;
  gender?: InputMaybe<GenderFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  lastName?: InputMaybe<StringFieldComparison>;
  maxDeliveryPackageSize?: InputMaybe<DeliveryPackageSizeFilterComparison>;
  mobileNumber?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<DriverAggregateFilter>>;
  rating?: InputMaybe<IntFieldComparison>;
  reviewCount?: InputMaybe<IntFieldComparison>;
  status?: InputMaybe<DriverStatusFilterComparison>;
};

export type DriverAggregateGroupBy = {
  __typename?: "DriverAggregateGroupBy";
  carColorId?: Maybe<Scalars["ID"]["output"]>;
  carId?: Maybe<Scalars["ID"]["output"]>;
  carPlate?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  gender?: Maybe<Gender>;
  id?: Maybe<Scalars["ID"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  maxDeliveryPackageSize?: Maybe<DeliveryPackageSize>;
  mobileNumber?: Maybe<Scalars["String"]["output"]>;
  rating?: Maybe<Scalars["Int"]["output"]>;
  reviewCount?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<DriverStatus>;
};

export type DriverAggregateResponse = {
  __typename?: "DriverAggregateResponse";
  avg?: Maybe<DriverAvgAggregate>;
  count?: Maybe<DriverCountAggregate>;
  groupBy?: Maybe<DriverAggregateGroupBy>;
  max?: Maybe<DriverMaxAggregate>;
  min?: Maybe<DriverMinAggregate>;
  sum?: Maybe<DriverSumAggregate>;
};

export enum DriverArchiveAction {
  Archive = "Archive",
  Restore = "Restore",
}

export type DriverArchiveAudit = {
  __typename?: "DriverArchiveAudit";
  action: DriverArchiveAction;
  createdAt: Scalars["DateTime"]["output"];
  driverId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  initiatedByDriver: Scalars["Boolean"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  previousStatus?: Maybe<Scalars["String"]["output"]>;
  reason: Scalars["String"]["output"];
  resultingStatus: Scalars["String"]["output"];
};

export type DriverAvailabilitySnapshot = {
  __typename?: "DriverAvailabilitySnapshot";
  activeOrderId?: Maybe<Scalars["ID"]["output"]>;
  assignable: Scalars["Boolean"]["output"];
  code: DriverAvailabilityStatus;
  desiredOnline: Scalars["Boolean"]["output"];
  driverId: Scalars["ID"]["output"];
  estimatedFinishTime?: Maybe<Scalars["DateTime"]["output"]>;
  evaluatedAt: Scalars["DateTime"]["output"];
  heartbeatAgeSeconds?: Maybe<Scalars["Int"]["output"]>;
  isOnline: Scalars["Boolean"]["output"];
  locationAgeSeconds?: Maybe<Scalars["Int"]["output"]>;
  nextTransitionAt?: Maybe<Scalars["DateTime"]["output"]>;
  reason?: Maybe<Scalars["String"]["output"]>;
  serverTime: Scalars["DateTime"]["output"];
  serviceCompatible: Scalars["Boolean"]["output"];
  source: DriverAvailabilityTransitionSource;
  version: Scalars["Int"]["output"];
};

export enum DriverAvailabilityStatus {
  ActiveRide = "ActiveRide",
  Available = "Available",
  ConnectionLost = "ConnectionLost",
  ConnectionSuspected = "ConnectionSuspected",
  CreatingStreetRide = "CreatingStreetRide",
  DriverBlocked = "DriverBlocked",
  DriverNotApproved = "DriverNotApproved",
  HeldForNextAvailable = "HeldForNextAvailable",
  OfferPending = "OfferPending",
  Offline = "Offline",
  ScheduleConflict = "ScheduleConflict",
  ServiceIncompatible = "ServiceIncompatible",
  StaleLocation = "StaleLocation",
  UnknownUnavailable = "UnknownUnavailable",
}

export enum DriverAvailabilityTransitionSource {
  ActiveOrderChanged = "ActiveOrderChanged",
  DesiredOnlineChanged = "DesiredOnlineChanged",
  DriverProfileChanged = "DriverProfileChanged",
  HeartbeatAccepted = "HeartbeatAccepted",
  OfferChanged = "OfferChanged",
  OperationalStateRebuilt = "OperationalStateRebuilt",
  PositionAccepted = "PositionAccepted",
  Reconciliation = "Reconciliation",
  ReservationChanged = "ReservationChanged",
  StartupRecovery = "StartupRecovery",
  StreetCustomerChanged = "StreetCustomerChanged",
  TimeThreshold = "TimeThreshold",
}

export type DriverAvgAggregate = {
  __typename?: "DriverAvgAggregate";
  carColorId?: Maybe<Scalars["Float"]["output"]>;
  carId?: Maybe<Scalars["Float"]["output"]>;
  fleetId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  rating?: Maybe<Scalars["Float"]["output"]>;
  reviewCount?: Maybe<Scalars["Float"]["output"]>;
};

export enum DriverClosingCommissionCalculationMode {
  LegacyManual = "LegacyManual",
  TripPercentage = "TripPercentage",
}

export type DriverClosingCommissionDto = {
  __typename?: "DriverClosingCommissionDTO";
  amount: Scalars["String"]["output"];
  calculationMode: DriverClosingCommissionCalculationMode;
  commissionRatePercent?: Maybe<Scalars["String"]["output"]>;
  currentPartnerRatePercent?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  orderId?: Maybe<Scalars["ID"]["output"]>;
  orderReference?: Maybe<Scalars["String"]["output"]>;
  partnerId: Scalars["ID"]["output"];
  partnerName: Scalars["String"]["output"];
  partnerRateChanged: Scalars["Boolean"]["output"];
  partnerType: CommissionPartnerType;
  tripReportTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  tripRevenue?: Maybe<Scalars["String"]["output"]>;
};

export type DriverClosingCommissionInput = {
  note?: InputMaybe<Scalars["String"]["input"]>;
  orderId: Scalars["ID"]["input"];
  partnerId: Scalars["ID"]["input"];
};

export type DriverClosingCorrectionDto = {
  __typename?: "DriverClosingCorrectionDTO";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  previousFinalizedAt?: Maybe<Scalars["DateTime"]["output"]>;
  previousFinalizedByName?: Maybe<Scalars["String"]["output"]>;
  reason: Scalars["String"]["output"];
  reopenedByName: Scalars["String"]["output"];
  reopenedByOperatorId?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverClosingDraftInput = {
  chargingAmount?: InputMaybe<Scalars["String"]["input"]>;
  commissions?: InputMaybe<Array<DriverClosingCommissionInput>>;
  driverId: Scalars["ID"]["input"];
  manualPosAmount?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  otherDeductibleAmount?: InputMaybe<Scalars["String"]["input"]>;
  otherDeductibleNote?: InputMaybe<Scalars["String"]["input"]>;
  parkingAmount?: InputMaybe<Scalars["String"]["input"]>;
  /** Europe/Tirane local time: YYYY-MM-DDTHH:mm */
  periodEndLocal: Scalars["String"]["input"];
  /** Europe/Tirane local time: YYYY-MM-DDTHH:mm */
  periodStartLocal: Scalars["String"]["input"];
  tollsAmount?: InputMaybe<Scalars["String"]["input"]>;
};

export type DriverClosingDriverDto = {
  __typename?: "DriverClosingDriverDTO";
  displayName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  mobileNumber: Scalars["String"]["output"];
};

export type DriverClosingPreviewDto = {
  __typename?: "DriverClosingPreviewDTO";
  currency: Scalars["String"]["output"];
  driverId: Scalars["ID"]["output"];
  driverName: Scalars["String"]["output"];
  generatedRevenue: Scalars["String"]["output"];
  includedTrips: Array<DriverClosingPreviewTripDto>;
  includedTripsPageInfo: DriverClosingPreviewPageInfoDto;
  periodEnd: Scalars["DateTime"]["output"];
  periodStart: Scalars["DateTime"]["output"];
  tripCount: Scalars["Int"]["output"];
};

export type DriverClosingPreviewPageInfoDto = {
  __typename?: "DriverClosingPreviewPageInfoDTO";
  after: Scalars["Int"]["output"];
  first: Scalars["Int"]["output"];
  hasNextPage: Scalars["Boolean"]["output"];
};

export type DriverClosingPreviewTripDto = {
  __typename?: "DriverClosingPreviewTripDTO";
  destinationAddress?: Maybe<Scalars["String"]["output"]>;
  orderId: Scalars["ID"]["output"];
  orderReference: Scalars["String"]["output"];
  paymentMethod?: Maybe<Scalars["String"]["output"]>;
  pickupAddress?: Maybe<Scalars["String"]["output"]>;
  reportTimestamp: Scalars["DateTime"]["output"];
  revenueAmount: Scalars["String"]["output"];
  source?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
};

export type DriverClosingRecordConnectionDto = {
  __typename?: "DriverClosingRecordConnectionDTO";
  nodes: Array<DriverClosingRecordDto>;
  totalCount: Scalars["Int"]["output"];
};

export type DriverClosingRecordDto = {
  __typename?: "DriverClosingRecordDTO";
  amountToHandOver: Scalars["String"]["output"];
  businessTimezone: Scalars["String"]["output"];
  chargingAmount: Scalars["String"]["output"];
  commissions: Array<DriverClosingCommissionDto>;
  corrections: Array<DriverClosingCorrectionDto>;
  createdAt: Scalars["DateTime"]["output"];
  createdByName: Scalars["String"]["output"];
  createdByOperatorId?: Maybe<Scalars["ID"]["output"]>;
  createdByRole?: Maybe<Scalars["String"]["output"]>;
  createdBySystemType?: Maybe<OperatorRoleSystemType>;
  driverId: Scalars["ID"]["output"];
  driverMobile?: Maybe<Scalars["String"]["output"]>;
  driverName: Scalars["String"]["output"];
  finalizedAt?: Maybe<Scalars["DateTime"]["output"]>;
  finalizedByName?: Maybe<Scalars["String"]["output"]>;
  finalizedByOperatorId?: Maybe<Scalars["ID"]["output"]>;
  generatedRevenue: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  manualPosAmount: Scalars["String"]["output"];
  notes?: Maybe<Scalars["String"]["output"]>;
  otherDeductibleAmount: Scalars["String"]["output"];
  otherDeductibleNote?: Maybe<Scalars["String"]["output"]>;
  parkingAmount: Scalars["String"]["output"];
  periodEnd: Scalars["DateTime"]["output"];
  periodStart: Scalars["DateTime"]["output"];
  recordNumber: Scalars["String"]["output"];
  status: DriverClosingRecordStatus;
  tollsAmount: Scalars["String"]["output"];
  totalCommission: Scalars["String"]["output"];
  totalDeductions: Scalars["String"]["output"];
  tripCount: Scalars["Int"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type DriverClosingRecordFilterInput = {
  createdByOperatorId?: InputMaybe<Scalars["ID"]["input"]>;
  driverId?: InputMaybe<Scalars["ID"]["input"]>;
  driverSearch?: InputMaybe<Scalars["String"]["input"]>;
  periodFromLocal?: InputMaybe<Scalars["String"]["input"]>;
  periodToLocal?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<DriverClosingRecordStatus>;
};

export enum DriverClosingRecordStatus {
  Draft = "Draft",
  Finalized = "Finalized",
}

export type DriverConnection = {
  __typename?: "DriverConnection";
  /** Array of nodes. */
  nodes: Array<Driver>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type DriverCountAggregate = {
  __typename?: "DriverCountAggregate";
  carColorId?: Maybe<Scalars["Int"]["output"]>;
  carId?: Maybe<Scalars["Int"]["output"]>;
  carPlate?: Maybe<Scalars["Int"]["output"]>;
  firstName?: Maybe<Scalars["Int"]["output"]>;
  fleetId?: Maybe<Scalars["Int"]["output"]>;
  gender?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  lastName?: Maybe<Scalars["Int"]["output"]>;
  maxDeliveryPackageSize?: Maybe<Scalars["Int"]["output"]>;
  mobileNumber?: Maybe<Scalars["Int"]["output"]>;
  rating?: Maybe<Scalars["Int"]["output"]>;
  reviewCount?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
};

export enum DriverDeductTransactionType {
  Commission = "Commission",
  Correction = "Correction",
  Withdraw = "Withdraw",
}

export type DriverDocument = {
  __typename?: "DriverDocument";
  hasExpiryDate: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  isEnabled: Scalars["Boolean"]["output"];
  isRequired: Scalars["Boolean"]["output"];
  notificationDaysBeforeExpiry: Scalars["Int"]["output"];
  numberOfImages: Scalars["Int"]["output"];
  retentionPolicies: Array<DriverDocumentRetentionPolicy>;
  title: Scalars["String"]["output"];
};

export type DriverDocumentRetentionPoliciesArgs = {
  filter?: DriverDocumentRetentionPolicyFilter;
  sorting?: Array<DriverDocumentRetentionPolicySort>;
};

export type DriverDocumentDeleteFilter = {
  and?: InputMaybe<Array<DriverDocumentDeleteFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DriverDocumentDeleteFilter>>;
};

export type DriverDocumentDeleteResponse = {
  __typename?: "DriverDocumentDeleteResponse";
  hasExpiryDate?: Maybe<Scalars["Boolean"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  isEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  isRequired?: Maybe<Scalars["Boolean"]["output"]>;
  notificationDaysBeforeExpiry?: Maybe<Scalars["Int"]["output"]>;
  numberOfImages?: Maybe<Scalars["Int"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type DriverDocumentFilter = {
  and?: InputMaybe<Array<DriverDocumentFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DriverDocumentFilter>>;
};

export type DriverDocumentInput = {
  hasExpiryDate: Scalars["Boolean"]["input"];
  isEnabled: Scalars["Boolean"]["input"];
  isRequired: Scalars["Boolean"]["input"];
  notificationDaysBeforeExpiry: Scalars["Int"]["input"];
  numberOfImages: Scalars["Int"]["input"];
  title: Scalars["String"]["input"];
};

export type DriverDocumentRetentionPolicy = {
  __typename?: "DriverDocumentRetentionPolicy";
  deleteAfterDays: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type DriverDocumentRetentionPolicyConnection = {
  __typename?: "DriverDocumentRetentionPolicyConnection";
  /** Array of edges. */
  edges: Array<DriverDocumentRetentionPolicyEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type DriverDocumentRetentionPolicyDeleteFilter = {
  and?: InputMaybe<Array<DriverDocumentRetentionPolicyDeleteFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DriverDocumentRetentionPolicyDeleteFilter>>;
};

export type DriverDocumentRetentionPolicyDeleteResponse = {
  __typename?: "DriverDocumentRetentionPolicyDeleteResponse";
  deleteAfterDays?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type DriverDocumentRetentionPolicyEdge = {
  __typename?: "DriverDocumentRetentionPolicyEdge";
  /** Cursor for this node. */
  cursor: Scalars["ConnectionCursor"]["output"];
  /** The node containing the DriverDocumentRetentionPolicy */
  node: DriverDocumentRetentionPolicy;
};

export type DriverDocumentRetentionPolicyFilter = {
  and?: InputMaybe<Array<DriverDocumentRetentionPolicyFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DriverDocumentRetentionPolicyFilter>>;
};

export type DriverDocumentRetentionPolicyInput = {
  deleteAfterDays: Scalars["Int"]["input"];
  driverDocumentId: Scalars["ID"]["input"];
  title: Scalars["String"]["input"];
};

export type DriverDocumentRetentionPolicySort = {
  direction: SortDirection;
  field: DriverDocumentRetentionPolicySortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum DriverDocumentRetentionPolicySortFields {
  Id = "id",
}

export type DriverDocumentRetentionPolicyUpdateFilter = {
  and?: InputMaybe<Array<DriverDocumentRetentionPolicyUpdateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DriverDocumentRetentionPolicyUpdateFilter>>;
};

export type DriverDocumentSort = {
  direction: SortDirection;
  field: DriverDocumentSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum DriverDocumentSortFields {
  Id = "id",
}

export type DriverDocumentUpdateFilter = {
  and?: InputMaybe<Array<DriverDocumentUpdateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DriverDocumentUpdateFilter>>;
};

export type DriverDocumentsAggregateGroupBy = {
  __typename?: "DriverDocumentsAggregateGroupBy";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverDocumentsAggregateResponse = {
  __typename?: "DriverDocumentsAggregateResponse";
  avg?: Maybe<DriverDocumentsAvgAggregate>;
  count?: Maybe<DriverDocumentsCountAggregate>;
  groupBy?: Maybe<DriverDocumentsAggregateGroupBy>;
  max?: Maybe<DriverDocumentsMaxAggregate>;
  min?: Maybe<DriverDocumentsMinAggregate>;
  sum?: Maybe<DriverDocumentsSumAggregate>;
};

export type DriverDocumentsAvgAggregate = {
  __typename?: "DriverDocumentsAvgAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverDocumentsCountAggregate = {
  __typename?: "DriverDocumentsCountAggregate";
  id?: Maybe<Scalars["Int"]["output"]>;
};

export type DriverDocumentsMaxAggregate = {
  __typename?: "DriverDocumentsMaxAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverDocumentsMinAggregate = {
  __typename?: "DriverDocumentsMinAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverDocumentsSumAggregate = {
  __typename?: "DriverDocumentsSumAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverDriverToDriverDocumentsAggregateGroupBy = {
  __typename?: "DriverDriverToDriverDocumentsAggregateGroupBy";
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverDriverToDriverDocumentsAggregateResponse = {
  __typename?: "DriverDriverToDriverDocumentsAggregateResponse";
  avg?: Maybe<DriverDriverToDriverDocumentsAvgAggregate>;
  count?: Maybe<DriverDriverToDriverDocumentsCountAggregate>;
  groupBy?: Maybe<DriverDriverToDriverDocumentsAggregateGroupBy>;
  max?: Maybe<DriverDriverToDriverDocumentsMaxAggregate>;
  min?: Maybe<DriverDriverToDriverDocumentsMinAggregate>;
  sum?: Maybe<DriverDriverToDriverDocumentsSumAggregate>;
};

export type DriverDriverToDriverDocumentsAvgAggregate = {
  __typename?: "DriverDriverToDriverDocumentsAvgAggregate";
  driverId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverDriverToDriverDocumentsCountAggregate = {
  __typename?: "DriverDriverToDriverDocumentsCountAggregate";
  driverId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
};

export type DriverDriverToDriverDocumentsMaxAggregate = {
  __typename?: "DriverDriverToDriverDocumentsMaxAggregate";
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverDriverToDriverDocumentsMinAggregate = {
  __typename?: "DriverDriverToDriverDocumentsMinAggregate";
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverDriverToDriverDocumentsSumAggregate = {
  __typename?: "DriverDriverToDriverDocumentsSumAggregate";
  driverId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverEnabledServicesAggregateGroupBy = {
  __typename?: "DriverEnabledServicesAggregateGroupBy";
  driverId?: Maybe<Scalars["ID"]["output"]>;
  serviceId?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverEnabledServicesAggregateResponse = {
  __typename?: "DriverEnabledServicesAggregateResponse";
  avg?: Maybe<DriverEnabledServicesAvgAggregate>;
  count?: Maybe<DriverEnabledServicesCountAggregate>;
  groupBy?: Maybe<DriverEnabledServicesAggregateGroupBy>;
  max?: Maybe<DriverEnabledServicesMaxAggregate>;
  min?: Maybe<DriverEnabledServicesMinAggregate>;
  sum?: Maybe<DriverEnabledServicesSumAggregate>;
};

export type DriverEnabledServicesAvgAggregate = {
  __typename?: "DriverEnabledServicesAvgAggregate";
  driverId?: Maybe<Scalars["Float"]["output"]>;
  serviceId?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverEnabledServicesCountAggregate = {
  __typename?: "DriverEnabledServicesCountAggregate";
  driverId?: Maybe<Scalars["Int"]["output"]>;
  serviceId?: Maybe<Scalars["Int"]["output"]>;
};

export type DriverEnabledServicesMaxAggregate = {
  __typename?: "DriverEnabledServicesMaxAggregate";
  driverId?: Maybe<Scalars["ID"]["output"]>;
  serviceId?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverEnabledServicesMinAggregate = {
  __typename?: "DriverEnabledServicesMinAggregate";
  driverId?: Maybe<Scalars["ID"]["output"]>;
  serviceId?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverEnabledServicesSumAggregate = {
  __typename?: "DriverEnabledServicesSumAggregate";
  driverId?: Maybe<Scalars["Float"]["output"]>;
  serviceId?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverFeedbacksAggregateGroupBy = {
  __typename?: "DriverFeedbacksAggregateGroupBy";
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverFeedbacksAggregateResponse = {
  __typename?: "DriverFeedbacksAggregateResponse";
  avg?: Maybe<DriverFeedbacksAvgAggregate>;
  count?: Maybe<DriverFeedbacksCountAggregate>;
  groupBy?: Maybe<DriverFeedbacksAggregateGroupBy>;
  max?: Maybe<DriverFeedbacksMaxAggregate>;
  min?: Maybe<DriverFeedbacksMinAggregate>;
  sum?: Maybe<DriverFeedbacksSumAggregate>;
};

export type DriverFeedbacksAvgAggregate = {
  __typename?: "DriverFeedbacksAvgAggregate";
  driverId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  requestId?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverFeedbacksConnection = {
  __typename?: "DriverFeedbacksConnection";
  /** Array of nodes. */
  nodes: Array<Feedback>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type DriverFeedbacksCountAggregate = {
  __typename?: "DriverFeedbacksCountAggregate";
  driverId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  requestId?: Maybe<Scalars["Int"]["output"]>;
};

export type DriverFeedbacksMaxAggregate = {
  __typename?: "DriverFeedbacksMaxAggregate";
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverFeedbacksMinAggregate = {
  __typename?: "DriverFeedbacksMinAggregate";
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverFeedbacksSumAggregate = {
  __typename?: "DriverFeedbacksSumAggregate";
  driverId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  requestId?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverFilter = {
  and?: InputMaybe<Array<DriverFilter>>;
  carColorId?: InputMaybe<IdFilterComparison>;
  carId?: InputMaybe<IdFilterComparison>;
  carPlate?: InputMaybe<StringFieldComparison>;
  firstName?: InputMaybe<StringFieldComparison>;
  fleetId?: InputMaybe<IdFilterComparison>;
  gender?: InputMaybe<GenderFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  lastName?: InputMaybe<StringFieldComparison>;
  maxDeliveryPackageSize?: InputMaybe<DeliveryPackageSizeFilterComparison>;
  mobileNumber?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<DriverFilter>>;
  rating?: InputMaybe<IntFieldComparison>;
  reviewCount?: InputMaybe<IntFieldComparison>;
  status?: InputMaybe<DriverStatusFilterComparison>;
};

export type DriverLocationUpdate = {
  __typename?: "DriverLocationUpdate";
  accuracyMeters?: Maybe<Scalars["Float"]["output"]>;
  capturedAt?: Maybe<Scalars["DateTime"]["output"]>;
  driverId: Scalars["ID"]["output"];
  isLegacy?: Maybe<Scalars["Boolean"]["output"]>;
  lastUpdatedAt: Scalars["DateTime"]["output"];
  orderIds: Array<Scalars["ID"]["output"]>;
  point: Point;
  protocolVersion?: Maybe<Scalars["Int"]["output"]>;
  receivedAt?: Maybe<Scalars["DateTime"]["output"]>;
  sequence?: Maybe<Scalars["Int"]["output"]>;
  sessionId?: Maybe<Scalars["String"]["output"]>;
  source?: Maybe<Scalars["String"]["output"]>;
  speedMetersPerSecond?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverManualRideCreatedEvent = {
  __typename?: "DriverManualRideCreatedEvent";
  carPlate?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  driverId: Scalars["ID"]["output"];
  driverName: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
  orderId: Scalars["ID"]["output"];
};

export type DriverMaxAggregate = {
  __typename?: "DriverMaxAggregate";
  carColorId?: Maybe<Scalars["ID"]["output"]>;
  carId?: Maybe<Scalars["ID"]["output"]>;
  carPlate?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  gender?: Maybe<Gender>;
  id?: Maybe<Scalars["ID"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  maxDeliveryPackageSize?: Maybe<DeliveryPackageSize>;
  mobileNumber?: Maybe<Scalars["String"]["output"]>;
  rating?: Maybe<Scalars["Int"]["output"]>;
  reviewCount?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<DriverStatus>;
};

export type DriverMinAggregate = {
  __typename?: "DriverMinAggregate";
  carColorId?: Maybe<Scalars["ID"]["output"]>;
  carId?: Maybe<Scalars["ID"]["output"]>;
  carPlate?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  gender?: Maybe<Gender>;
  id?: Maybe<Scalars["ID"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  maxDeliveryPackageSize?: Maybe<DeliveryPackageSize>;
  mobileNumber?: Maybe<Scalars["String"]["output"]>;
  rating?: Maybe<Scalars["Int"]["output"]>;
  reviewCount?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<DriverStatus>;
};

export type DriverNote = {
  __typename?: "DriverNote";
  createdAt: Scalars["DateTime"]["output"];
  driverId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  note: Scalars["String"]["output"];
  staff: Operator;
};

export type DriverNoteConnection = {
  __typename?: "DriverNoteConnection";
  /** Array of nodes. */
  nodes: Array<DriverNote>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type DriverNoteFilter = {
  and?: InputMaybe<Array<DriverNoteFilter>>;
  driverId: IdFilterComparison;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DriverNoteFilter>>;
};

export type DriverNoteSort = {
  direction: SortDirection;
  field: DriverNoteSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum DriverNoteSortFields {
  DriverId = "driverId",
  Id = "id",
}

export type DriverOrderFilterOption = {
  __typename?: "DriverOrderFilterOption";
  carPlate?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  lastName?: Maybe<Scalars["String"]["output"]>;
  mobileNumber: Scalars["String"]["output"];
};

export type DriverOrdersAggregateGroupBy = {
  __typename?: "DriverOrdersAggregateGroupBy";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  createdOn?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  distanceBest?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  durationBest?: Maybe<Scalars["Int"]["output"]>;
  fareMode?: Maybe<FareMode>;
  finishTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  orderSource?: Maybe<OrderSource>;
  paymentMode?: Maybe<PaymentMode>;
  regionId?: Maybe<Scalars["ID"]["output"]>;
  reportingSource?: Maybe<OrderSource>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  routeSource?: Maybe<RouteSource>;
  serviceId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<OrderStatus>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
  type?: Maybe<TaxiOrderType>;
};

export type DriverOrdersAggregateResponse = {
  __typename?: "DriverOrdersAggregateResponse";
  avg?: Maybe<DriverOrdersAvgAggregate>;
  count?: Maybe<DriverOrdersCountAggregate>;
  groupBy?: Maybe<DriverOrdersAggregateGroupBy>;
  max?: Maybe<DriverOrdersMaxAggregate>;
  min?: Maybe<DriverOrdersMinAggregate>;
  sum?: Maybe<DriverOrdersSumAggregate>;
};

export type DriverOrdersAvgAggregate = {
  __typename?: "DriverOrdersAvgAggregate";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  distanceBest?: Maybe<Scalars["Float"]["output"]>;
  driverId?: Maybe<Scalars["Float"]["output"]>;
  durationBest?: Maybe<Scalars["Float"]["output"]>;
  fleetId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  regionId?: Maybe<Scalars["Float"]["output"]>;
  riderId?: Maybe<Scalars["Float"]["output"]>;
  serviceId?: Maybe<Scalars["Float"]["output"]>;
  tariffProfileId?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverOrdersConnection = {
  __typename?: "DriverOrdersConnection";
  /** Array of nodes. */
  nodes: Array<Order>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type DriverOrdersCountAggregate = {
  __typename?: "DriverOrdersCountAggregate";
  costAfterCoupon?: Maybe<Scalars["Int"]["output"]>;
  costBest?: Maybe<Scalars["Int"]["output"]>;
  createdOn?: Maybe<Scalars["Int"]["output"]>;
  currency?: Maybe<Scalars["Int"]["output"]>;
  distanceBest?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["Int"]["output"]>;
  durationBest?: Maybe<Scalars["Int"]["output"]>;
  fareMode?: Maybe<Scalars["Int"]["output"]>;
  finishTimestamp?: Maybe<Scalars["Int"]["output"]>;
  fleetId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  operatorId?: Maybe<Scalars["Int"]["output"]>;
  orderSource?: Maybe<Scalars["Int"]["output"]>;
  paymentMode?: Maybe<Scalars["Int"]["output"]>;
  regionId?: Maybe<Scalars["Int"]["output"]>;
  reportingSource?: Maybe<Scalars["Int"]["output"]>;
  riderId?: Maybe<Scalars["Int"]["output"]>;
  routeSource?: Maybe<Scalars["Int"]["output"]>;
  serviceId?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
  tariffProfileId?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Scalars["Int"]["output"]>;
};

export type DriverOrdersMaxAggregate = {
  __typename?: "DriverOrdersMaxAggregate";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  createdOn?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  distanceBest?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  durationBest?: Maybe<Scalars["Int"]["output"]>;
  fareMode?: Maybe<FareMode>;
  finishTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  orderSource?: Maybe<OrderSource>;
  paymentMode?: Maybe<PaymentMode>;
  regionId?: Maybe<Scalars["ID"]["output"]>;
  reportingSource?: Maybe<OrderSource>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  routeSource?: Maybe<RouteSource>;
  serviceId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<OrderStatus>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
  type?: Maybe<TaxiOrderType>;
};

export type DriverOrdersMinAggregate = {
  __typename?: "DriverOrdersMinAggregate";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  createdOn?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  distanceBest?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  durationBest?: Maybe<Scalars["Int"]["output"]>;
  fareMode?: Maybe<FareMode>;
  finishTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  orderSource?: Maybe<OrderSource>;
  paymentMode?: Maybe<PaymentMode>;
  regionId?: Maybe<Scalars["ID"]["output"]>;
  reportingSource?: Maybe<OrderSource>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  routeSource?: Maybe<RouteSource>;
  serviceId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<OrderStatus>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
  type?: Maybe<TaxiOrderType>;
};

export type DriverOrdersSumAggregate = {
  __typename?: "DriverOrdersSumAggregate";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  distanceBest?: Maybe<Scalars["Float"]["output"]>;
  driverId?: Maybe<Scalars["Float"]["output"]>;
  durationBest?: Maybe<Scalars["Float"]["output"]>;
  fleetId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  regionId?: Maybe<Scalars["Float"]["output"]>;
  riderId?: Maybe<Scalars["Float"]["output"]>;
  serviceId?: Maybe<Scalars["Float"]["output"]>;
  tariffProfileId?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverPayoutAccountsAggregateGroupBy = {
  __typename?: "DriverPayoutAccountsAggregateGroupBy";
  id?: Maybe<Scalars["ID"]["output"]>;
  isDefault?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DriverPayoutAccountsAggregateResponse = {
  __typename?: "DriverPayoutAccountsAggregateResponse";
  avg?: Maybe<DriverPayoutAccountsAvgAggregate>;
  count?: Maybe<DriverPayoutAccountsCountAggregate>;
  groupBy?: Maybe<DriverPayoutAccountsAggregateGroupBy>;
  max?: Maybe<DriverPayoutAccountsMaxAggregate>;
  min?: Maybe<DriverPayoutAccountsMinAggregate>;
  sum?: Maybe<DriverPayoutAccountsSumAggregate>;
};

export type DriverPayoutAccountsAvgAggregate = {
  __typename?: "DriverPayoutAccountsAvgAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverPayoutAccountsConnection = {
  __typename?: "DriverPayoutAccountsConnection";
  /** Array of nodes. */
  nodes: Array<PayoutAccount>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type DriverPayoutAccountsCountAggregate = {
  __typename?: "DriverPayoutAccountsCountAggregate";
  id?: Maybe<Scalars["Int"]["output"]>;
  isDefault?: Maybe<Scalars["Int"]["output"]>;
};

export type DriverPayoutAccountsMaxAggregate = {
  __typename?: "DriverPayoutAccountsMaxAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverPayoutAccountsMinAggregate = {
  __typename?: "DriverPayoutAccountsMinAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverPayoutAccountsSumAggregate = {
  __typename?: "DriverPayoutAccountsSumAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverPendingVerificationNotification = {
  __typename?: "DriverPendingVerificationNotification";
  appType: AppType;
  createdAt: Scalars["DateTime"]["output"];
  driverPendingVerification: Driver;
  id: Scalars["ID"]["output"];
  readAt?: Maybe<Scalars["DateTime"]["output"]>;
  type: AdminNotificationType;
};

export enum DriverRechargeTransactionType {
  BankTransfer = "BankTransfer",
  Gift = "Gift",
  InAppPayment = "InAppPayment",
  OrderFee = "OrderFee",
}

export type DriverScoringConfig = {
  __typename?: "DriverScoringConfig";
  /** Weight for offer acceptance ratio in driver scoring, not trip cancellations */
  cancelRateWeight: Scalars["Float"]["output"];
  /** Weight for distance in driver scoring */
  distanceWeight: Scalars["Float"]["output"];
  /** Weight for driver rating in driver scoring */
  driverRatingWeight: Scalars["Float"]["output"];
  /** Weight for idle time in driver scoring */
  idleTimeWeight: Scalars["Float"]["output"];
  /** Minimum combined weighted score for dispatch eligibility, not a Driver rating */
  threshold?: Maybe<Scalars["Float"]["output"]>;
  /** The number of top drivers to consider for dispatch */
  topN?: Maybe<Scalars["Int"]["output"]>;
};

export type DriverScoringConfigInput = {
  /** Weight for offer acceptance ratio in driver scoring, not trip cancellations */
  cancelRateWeight: Scalars["Float"]["input"];
  /** Weight for distance in driver scoring */
  distanceWeight: Scalars["Float"]["input"];
  /** Weight for driver rating in driver scoring */
  driverRatingWeight: Scalars["Float"]["input"];
  /** Weight for idle time in driver scoring */
  idleTimeWeight: Scalars["Float"]["input"];
  /** Minimum combined weighted score for dispatch eligibility, not a Driver rating */
  threshold?: InputMaybe<Scalars["Float"]["input"]>;
  /** The number of top drivers to consider for dispatch */
  topN?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DriverServicesServiceDto = {
  __typename?: "DriverServicesServiceDTO";
  driverEnabled: Scalars["Boolean"]["output"];
  driverId: Scalars["ID"]["output"];
  service: Service;
  serviceId: Scalars["ID"]["output"];
};

export type DriverServicesServiceDtoAggregateFilter = {
  and?: InputMaybe<Array<DriverServicesServiceDtoAggregateFilter>>;
  driverId?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DriverServicesServiceDtoAggregateFilter>>;
  serviceId?: InputMaybe<IdFilterComparison>;
};

export type DriverServicesServiceDtoFilter = {
  and?: InputMaybe<Array<DriverServicesServiceDtoFilter>>;
  driverId?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DriverServicesServiceDtoFilter>>;
  serviceId?: InputMaybe<IdFilterComparison>;
};

export type DriverServicesServiceDtoSort = {
  direction: SortDirection;
  field: DriverServicesServiceDtoSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum DriverServicesServiceDtoSortFields {
  DriverId = "driverId",
  ServiceId = "serviceId",
}

export type DriverSession = {
  __typename?: "DriverSession";
  driverId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  sessionInfo: SessionInfo;
};

export type DriverSessionAggregateFilter = {
  and?: InputMaybe<Array<DriverSessionAggregateFilter>>;
  driverId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DriverSessionAggregateFilter>>;
};

export type DriverSessionDeleteResponse = {
  __typename?: "DriverSessionDeleteResponse";
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  sessionInfo?: Maybe<SessionInfo>;
};

export type DriverSessionFilter = {
  and?: InputMaybe<Array<DriverSessionFilter>>;
  driverId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DriverSessionFilter>>;
};

export type DriverSessionSort = {
  direction: SortDirection;
  field: DriverSessionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum DriverSessionSortFields {
  DriverId = "driverId",
  Id = "id",
}

export type DriverSessionsAggregateGroupBy = {
  __typename?: "DriverSessionsAggregateGroupBy";
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverSessionsAggregateResponse = {
  __typename?: "DriverSessionsAggregateResponse";
  avg?: Maybe<DriverSessionsAvgAggregate>;
  count?: Maybe<DriverSessionsCountAggregate>;
  groupBy?: Maybe<DriverSessionsAggregateGroupBy>;
  max?: Maybe<DriverSessionsMaxAggregate>;
  min?: Maybe<DriverSessionsMinAggregate>;
  sum?: Maybe<DriverSessionsSumAggregate>;
};

export type DriverSessionsAvgAggregate = {
  __typename?: "DriverSessionsAvgAggregate";
  driverId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverSessionsCountAggregate = {
  __typename?: "DriverSessionsCountAggregate";
  driverId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
};

export type DriverSessionsMaxAggregate = {
  __typename?: "DriverSessionsMaxAggregate";
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverSessionsMinAggregate = {
  __typename?: "DriverSessionsMinAggregate";
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverSessionsSumAggregate = {
  __typename?: "DriverSessionsSumAggregate";
  driverId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverShiftRule = {
  __typename?: "DriverShiftRule";
  id: Scalars["ID"]["output"];
  mandatoryBreakMinutes: Scalars["Int"]["output"];
  maxHoursPerFrequency: Scalars["Int"]["output"];
  timeFrequency: TimeFrequency;
};

export type DriverShiftRuleDeleteFilter = {
  and?: InputMaybe<Array<DriverShiftRuleDeleteFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DriverShiftRuleDeleteFilter>>;
};

export type DriverShiftRuleDeleteResponse = {
  __typename?: "DriverShiftRuleDeleteResponse";
  id?: Maybe<Scalars["ID"]["output"]>;
  mandatoryBreakMinutes?: Maybe<Scalars["Int"]["output"]>;
  maxHoursPerFrequency?: Maybe<Scalars["Int"]["output"]>;
  timeFrequency?: Maybe<TimeFrequency>;
};

export type DriverShiftRuleFilter = {
  and?: InputMaybe<Array<DriverShiftRuleFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DriverShiftRuleFilter>>;
};

export type DriverShiftRuleInput = {
  mandatoryBreakMinutes: Scalars["Int"]["input"];
  maxHoursPerFrequency: Scalars["Int"]["input"];
  timeFrequency: TimeFrequency;
};

export type DriverShiftRuleSort = {
  direction: SortDirection;
  field: DriverShiftRuleSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum DriverShiftRuleSortFields {
  Id = "id",
}

export type DriverShiftRuleUpdateFilter = {
  and?: InputMaybe<Array<DriverShiftRuleUpdateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DriverShiftRuleUpdateFilter>>;
};

export type DriverSort = {
  direction: SortDirection;
  field: DriverSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum DriverSortFields {
  CarColorId = "carColorId",
  CarId = "carId",
  CarPlate = "carPlate",
  FirstName = "firstName",
  FleetId = "fleetId",
  Gender = "gender",
  Id = "id",
  LastName = "lastName",
  MaxDeliveryPackageSize = "maxDeliveryPackageSize",
  MobileNumber = "mobileNumber",
  Rating = "rating",
  ReviewCount = "reviewCount",
  Status = "status",
}

export enum DriverStatus {
  Blocked = "Blocked",
  HardReject = "HardReject",
  InService = "InService",
  Offline = "Offline",
  Online = "Online",
  PendingApproval = "PendingApproval",
  SoftReject = "SoftReject",
  WaitingDocuments = "WaitingDocuments",
}

export type DriverStatusFilterComparison = {
  eq?: InputMaybe<DriverStatus>;
  gt?: InputMaybe<DriverStatus>;
  gte?: InputMaybe<DriverStatus>;
  iLike?: InputMaybe<DriverStatus>;
  in?: InputMaybe<Array<DriverStatus>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<DriverStatus>;
  lt?: InputMaybe<DriverStatus>;
  lte?: InputMaybe<DriverStatus>;
  neq?: InputMaybe<DriverStatus>;
  notILike?: InputMaybe<DriverStatus>;
  notIn?: InputMaybe<Array<DriverStatus>>;
  notLike?: InputMaybe<DriverStatus>;
};

export type DriverStatusUpdate = {
  __typename?: "DriverStatusUpdate";
  driverId: Scalars["ID"]["output"];
  status: DriverStatus;
  updatedAt: Scalars["DateTime"]["output"];
};

export type DriverSumAggregate = {
  __typename?: "DriverSumAggregate";
  carColorId?: Maybe<Scalars["Float"]["output"]>;
  carId?: Maybe<Scalars["Float"]["output"]>;
  fleetId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  rating?: Maybe<Scalars["Float"]["output"]>;
  reviewCount?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverTimesheet = {
  __typename?: "DriverTimesheet";
  date: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  timeRanges: Array<DriverTimesheetTimeRange>;
};

export type DriverTimesheetFilterInput = {
  driverId: Scalars["ID"]["input"];
  endDate: Scalars["DateTime"]["input"];
  startDate: Scalars["DateTime"]["input"];
};

export type DriverTimesheetTimeRange = {
  __typename?: "DriverTimesheetTimeRange";
  endTime?: Maybe<Scalars["DateTime"]["output"]>;
  startTime: Scalars["DateTime"]["output"];
};

export type DriverToDriverDocument = {
  __typename?: "DriverToDriverDocument";
  driver: Driver;
  driverDocument: DriverDocument;
  driverDocumentId: Scalars["ID"]["output"];
  driverId: Scalars["ID"]["output"];
  expiresAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  media: Media;
  mediaId: Scalars["ID"]["output"];
  retentionPolicy?: Maybe<DriverDocumentRetentionPolicy>;
  retentionPolicyId: Scalars["ID"]["output"];
};

export type DriverToDriverDocumentAggregateFilter = {
  and?: InputMaybe<Array<DriverToDriverDocumentAggregateFilter>>;
  driverId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DriverToDriverDocumentAggregateFilter>>;
};

export type DriverToDriverDocumentConnection = {
  __typename?: "DriverToDriverDocumentConnection";
  /** Array of edges. */
  edges: Array<DriverToDriverDocumentEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type DriverToDriverDocumentDeleteResponse = {
  __typename?: "DriverToDriverDocumentDeleteResponse";
  driverDocumentId?: Maybe<Scalars["ID"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  expiresAt?: Maybe<Scalars["DateTime"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  mediaId?: Maybe<Scalars["ID"]["output"]>;
  retentionPolicyId?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverToDriverDocumentEdge = {
  __typename?: "DriverToDriverDocumentEdge";
  /** Cursor for this node. */
  cursor: Scalars["ConnectionCursor"]["output"];
  /** The node containing the DriverToDriverDocument */
  node: DriverToDriverDocument;
};

export type DriverToDriverDocumentFilter = {
  and?: InputMaybe<Array<DriverToDriverDocumentFilter>>;
  driverId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DriverToDriverDocumentFilter>>;
};

export type DriverToDriverDocumentInput = {
  driverDocumentId: Scalars["ID"]["input"];
  driverId: Scalars["ID"]["input"];
  expiresAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  mediaId: Scalars["ID"]["input"];
  retentionPolicyId: Scalars["ID"]["input"];
};

export type DriverToDriverDocumentSort = {
  direction: SortDirection;
  field: DriverToDriverDocumentSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum DriverToDriverDocumentSortFields {
  DriverId = "driverId",
  Id = "id",
}

export type DriverTransaction = {
  __typename?: "DriverTransaction";
  action: TransactionAction;
  amount: Scalars["Float"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  currency: Scalars["String"]["output"];
  deductType?: Maybe<DriverDeductTransactionType>;
  description?: Maybe<Scalars["String"]["output"]>;
  driver?: Maybe<Driver>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id: Scalars["ID"]["output"];
  operator?: Maybe<Operator>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  paymentGateway?: Maybe<PaymentGateway>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  payoutAccount?: Maybe<PayoutAccount>;
  payoutAccountId?: Maybe<Scalars["ID"]["output"]>;
  payoutMethod?: Maybe<PayoutMethod>;
  payoutMethodId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<DriverRechargeTransactionType>;
  refrenceNumber?: Maybe<Scalars["String"]["output"]>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  savedPaymentMethod?: Maybe<SavedPaymentMethod>;
  status: TransactionStatus;
};

export type DriverTransactionAggregateFilter = {
  action?: InputMaybe<TransactionActionFilterComparison>;
  amount?: InputMaybe<NumberFieldComparison>;
  and?: InputMaybe<Array<DriverTransactionAggregateFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  driverId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DriverTransactionAggregateFilter>>;
  paymentGatewayId?: InputMaybe<IdFilterComparison>;
  payoutAccountId?: InputMaybe<IdFilterComparison>;
  payoutMethod?: InputMaybe<DriverTransactionAggregateFilterPayoutMethodAggregateFilter>;
  payoutMethodId?: InputMaybe<IdFilterComparison>;
  payoutSessionId?: InputMaybe<IdFilterComparison>;
  payoutSessionMethodId?: InputMaybe<IdFilterComparison>;
  status?: InputMaybe<TransactionStatusFilterComparison>;
};

export type DriverTransactionAggregateFilterPayoutMethodAggregateFilter = {
  and?: InputMaybe<
    Array<DriverTransactionAggregateFilterPayoutMethodAggregateFilter>
  >;
  currency?: InputMaybe<StringFieldComparison>;
  enabled?: InputMaybe<BooleanFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<
    Array<DriverTransactionAggregateFilterPayoutMethodAggregateFilter>
  >;
  type?: InputMaybe<PayoutMethodTypeFilterComparison>;
};

export type DriverTransactionAggregateGroupBy = {
  __typename?: "DriverTransactionAggregateGroupBy";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  payoutAccountId?: Maybe<Scalars["ID"]["output"]>;
  payoutMethodId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type DriverTransactionAggregateGroupByCreatedAtArgs = {
  by?: GroupBy;
};

export type DriverTransactionAggregateResponse = {
  __typename?: "DriverTransactionAggregateResponse";
  avg?: Maybe<DriverTransactionAvgAggregate>;
  count?: Maybe<DriverTransactionCountAggregate>;
  groupBy?: Maybe<DriverTransactionAggregateGroupBy>;
  max?: Maybe<DriverTransactionMaxAggregate>;
  min?: Maybe<DriverTransactionMinAggregate>;
  sum?: Maybe<DriverTransactionSumAggregate>;
};

export type DriverTransactionAvgAggregate = {
  __typename?: "DriverTransactionAvgAggregate";
  amount?: Maybe<Scalars["Float"]["output"]>;
  driverId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Float"]["output"]>;
  payoutAccountId?: Maybe<Scalars["Float"]["output"]>;
  payoutMethodId?: Maybe<Scalars["Float"]["output"]>;
  payoutSessionId?: Maybe<Scalars["Float"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverTransactionConnection = {
  __typename?: "DriverTransactionConnection";
  /** Array of nodes. */
  nodes: Array<DriverTransaction>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type DriverTransactionCountAggregate = {
  __typename?: "DriverTransactionCountAggregate";
  action?: Maybe<Scalars["Int"]["output"]>;
  amount?: Maybe<Scalars["Int"]["output"]>;
  createdAt?: Maybe<Scalars["Int"]["output"]>;
  currency?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Int"]["output"]>;
  payoutAccountId?: Maybe<Scalars["Int"]["output"]>;
  payoutMethodId?: Maybe<Scalars["Int"]["output"]>;
  payoutSessionId?: Maybe<Scalars["Int"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
};

export type DriverTransactionFilter = {
  action?: InputMaybe<TransactionActionFilterComparison>;
  amount?: InputMaybe<NumberFieldComparison>;
  and?: InputMaybe<Array<DriverTransactionFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  driverId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DriverTransactionFilter>>;
  paymentGatewayId?: InputMaybe<IdFilterComparison>;
  payoutAccountId?: InputMaybe<IdFilterComparison>;
  payoutMethod?: InputMaybe<DriverTransactionFilterPayoutMethodFilter>;
  payoutMethodId?: InputMaybe<IdFilterComparison>;
  payoutSessionId?: InputMaybe<IdFilterComparison>;
  payoutSessionMethodId?: InputMaybe<IdFilterComparison>;
  status?: InputMaybe<TransactionStatusFilterComparison>;
};

export type DriverTransactionFilterPayoutMethodFilter = {
  and?: InputMaybe<Array<DriverTransactionFilterPayoutMethodFilter>>;
  currency?: InputMaybe<StringFieldComparison>;
  enabled?: InputMaybe<BooleanFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<DriverTransactionFilterPayoutMethodFilter>>;
  type?: InputMaybe<PayoutMethodTypeFilterComparison>;
};

export type DriverTransactionInput = {
  action: TransactionAction;
  amount: Scalars["Float"]["input"];
  currency: Scalars["String"]["input"];
  deductType?: InputMaybe<DriverDeductTransactionType>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  driverId: Scalars["ID"]["input"];
  rechargeType?: InputMaybe<DriverRechargeTransactionType>;
  refrenceNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type DriverTransactionMaxAggregate = {
  __typename?: "DriverTransactionMaxAggregate";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  payoutAccountId?: Maybe<Scalars["ID"]["output"]>;
  payoutMethodId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type DriverTransactionMinAggregate = {
  __typename?: "DriverTransactionMinAggregate";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  payoutAccountId?: Maybe<Scalars["ID"]["output"]>;
  payoutMethodId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type DriverTransactionSort = {
  direction: SortDirection;
  field: DriverTransactionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum DriverTransactionSortFields {
  Action = "action",
  Amount = "amount",
  CreatedAt = "createdAt",
  Currency = "currency",
  DriverId = "driverId",
  Id = "id",
  PaymentGatewayId = "paymentGatewayId",
  PayoutAccountId = "payoutAccountId",
  PayoutMethodId = "payoutMethodId",
  PayoutSessionId = "payoutSessionId",
  PayoutSessionMethodId = "payoutSessionMethodId",
  Status = "status",
}

export type DriverTransactionSumAggregate = {
  __typename?: "DriverTransactionSumAggregate";
  amount?: Maybe<Scalars["Float"]["output"]>;
  driverId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Float"]["output"]>;
  payoutAccountId?: Maybe<Scalars["Float"]["output"]>;
  payoutMethodId?: Maybe<Scalars["Float"]["output"]>;
  payoutSessionId?: Maybe<Scalars["Float"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverTransactionsAggregateGroupBy = {
  __typename?: "DriverTransactionsAggregateGroupBy";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  payoutAccountId?: Maybe<Scalars["ID"]["output"]>;
  payoutMethodId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type DriverTransactionsAggregateResponse = {
  __typename?: "DriverTransactionsAggregateResponse";
  avg?: Maybe<DriverTransactionsAvgAggregate>;
  count?: Maybe<DriverTransactionsCountAggregate>;
  groupBy?: Maybe<DriverTransactionsAggregateGroupBy>;
  max?: Maybe<DriverTransactionsMaxAggregate>;
  min?: Maybe<DriverTransactionsMinAggregate>;
  sum?: Maybe<DriverTransactionsSumAggregate>;
};

export type DriverTransactionsAvgAggregate = {
  __typename?: "DriverTransactionsAvgAggregate";
  amount?: Maybe<Scalars["Float"]["output"]>;
  driverId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Float"]["output"]>;
  payoutAccountId?: Maybe<Scalars["Float"]["output"]>;
  payoutMethodId?: Maybe<Scalars["Float"]["output"]>;
  payoutSessionId?: Maybe<Scalars["Float"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverTransactionsConnection = {
  __typename?: "DriverTransactionsConnection";
  /** Array of nodes. */
  nodes: Array<DriverTransaction>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type DriverTransactionsCountAggregate = {
  __typename?: "DriverTransactionsCountAggregate";
  action?: Maybe<Scalars["Int"]["output"]>;
  amount?: Maybe<Scalars["Int"]["output"]>;
  createdAt?: Maybe<Scalars["Int"]["output"]>;
  currency?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Int"]["output"]>;
  payoutAccountId?: Maybe<Scalars["Int"]["output"]>;
  payoutMethodId?: Maybe<Scalars["Int"]["output"]>;
  payoutSessionId?: Maybe<Scalars["Int"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
};

export type DriverTransactionsMaxAggregate = {
  __typename?: "DriverTransactionsMaxAggregate";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  payoutAccountId?: Maybe<Scalars["ID"]["output"]>;
  payoutMethodId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type DriverTransactionsMinAggregate = {
  __typename?: "DriverTransactionsMinAggregate";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  payoutAccountId?: Maybe<Scalars["ID"]["output"]>;
  payoutMethodId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type DriverTransactionsSumAggregate = {
  __typename?: "DriverTransactionsSumAggregate";
  amount?: Maybe<Scalars["Float"]["output"]>;
  driverId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Float"]["output"]>;
  payoutAccountId?: Maybe<Scalars["Float"]["output"]>;
  payoutMethodId?: Maybe<Scalars["Float"]["output"]>;
  payoutSessionId?: Maybe<Scalars["Float"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverTripReportConnection = {
  __typename?: "DriverTripReportConnection";
  nodes: Array<DriverTripReportRow>;
  totalCount: Scalars["Int"]["output"];
};

export type DriverTripReportFilterInput = {
  dateFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  dateTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  driverId?: InputMaybe<Scalars["ID"]["input"]>;
  driverName?: InputMaybe<Scalars["String"]["input"]>;
  fareMode?: InputMaybe<FareMode>;
  orderSource?: InputMaybe<OrderSource>;
  paymentMode?: InputMaybe<PaymentMode>;
  plate?: InputMaybe<Scalars["String"]["input"]>;
  serviceId?: InputMaybe<Scalars["ID"]["input"]>;
  status?: InputMaybe<OrderStatus>;
};

export type DriverTripReportRow = {
  __typename?: "DriverTripReportRow";
  arrivalTime?: Maybe<Scalars["DateTime"]["output"]>;
  currency: Scalars["String"]["output"];
  departureTime: Scalars["DateTime"]["output"];
  destinationAddress: Scalars["String"]["output"];
  driverId?: Maybe<Scalars["ID"]["output"]>;
  driverName: Scalars["String"]["output"];
  fareMode: FareMode;
  finalPrice: Scalars["Float"]["output"];
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  operatorName?: Maybe<Scalars["String"]["output"]>;
  orderId: Scalars["ID"]["output"];
  orderSource: OrderSource;
  paymentMode?: Maybe<PaymentMode>;
  pickupAddress: Scalars["String"]["output"];
  plateNumber: Scalars["String"]["output"];
  reportingSource?: Maybe<OrderSource>;
  status: OrderStatus;
};

export type DriverTripRevenueCurrencyTotal = {
  __typename?: "DriverTripRevenueCurrencyTotal";
  amount: Scalars["Float"]["output"];
  currency: Scalars["String"]["output"];
};

export type DriverTripRevenueSummary = {
  __typename?: "DriverTripRevenueSummary";
  currencyTotals: Array<DriverTripRevenueCurrencyTotal>;
  finishedTripCount: Scalars["Int"]["output"];
  lastCompletedTripAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type DriverVehicleAssignment = {
  __typename?: "DriverVehicleAssignment";
  assignedByOperatorId?: Maybe<Scalars["ID"]["output"]>;
  assignedByOperatorName?: Maybe<Scalars["String"]["output"]>;
  driverId: Scalars["ID"]["output"];
  endedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  reason?: Maybe<Scalars["String"]["output"]>;
  startedAt: Scalars["DateTime"]["output"];
  vehicleColor?: Maybe<Scalars["String"]["output"]>;
  vehicleId: Scalars["ID"]["output"];
  vehicleModel?: Maybe<Scalars["String"]["output"]>;
  vehiclePlate: Scalars["String"]["output"];
  vehicleProductionYear?: Maybe<Scalars["Int"]["output"]>;
  vehicleStatus?: Maybe<VehicleStatus>;
};

export type DriverVehicleAssignmentIntegritySummary = {
  __typename?: "DriverVehicleAssignmentIntegritySummary";
  clean: Scalars["Boolean"]["output"];
  invalidIntervals: Scalars["Int"]["output"];
  missingDrivers: Scalars["Int"]["output"];
  missingVehicles: Scalars["Int"]["output"];
  multipleOpenDrivers: Scalars["Int"]["output"];
  multipleOpenVehicles: Scalars["Int"]["output"];
  overlappingDriverIntervals: Scalars["Int"]["output"];
  overlappingVehicleIntervals: Scalars["Int"]["output"];
};

export type DriverWallet = {
  __typename?: "DriverWallet";
  balance: Scalars["Float"]["output"];
  currency: Scalars["String"]["output"];
  driver?: Maybe<Driver>;
  driverId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
};

export type DriverWalletAggregateFilter = {
  and?: InputMaybe<Array<DriverWalletAggregateFilter>>;
  balance?: InputMaybe<FloatFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  driverId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DriverWalletAggregateFilter>>;
};

export type DriverWalletAggregateGroupBy = {
  __typename?: "DriverWalletAggregateGroupBy";
  balance?: Maybe<Scalars["Float"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverWalletAggregateResponse = {
  __typename?: "DriverWalletAggregateResponse";
  avg?: Maybe<DriverWalletAvgAggregate>;
  count?: Maybe<DriverWalletCountAggregate>;
  groupBy?: Maybe<DriverWalletAggregateGroupBy>;
  max?: Maybe<DriverWalletMaxAggregate>;
  min?: Maybe<DriverWalletMinAggregate>;
  sum?: Maybe<DriverWalletSumAggregate>;
};

export type DriverWalletAvgAggregate = {
  __typename?: "DriverWalletAvgAggregate";
  balance?: Maybe<Scalars["Float"]["output"]>;
  driverId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type DriverWalletConnection = {
  __typename?: "DriverWalletConnection";
  /** Array of nodes. */
  nodes: Array<DriverWallet>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type DriverWalletCountAggregate = {
  __typename?: "DriverWalletCountAggregate";
  balance?: Maybe<Scalars["Int"]["output"]>;
  currency?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
};

export type DriverWalletFilter = {
  and?: InputMaybe<Array<DriverWalletFilter>>;
  balance?: InputMaybe<FloatFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  driverId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DriverWalletFilter>>;
};

export type DriverWalletMaxAggregate = {
  __typename?: "DriverWalletMaxAggregate";
  balance?: Maybe<Scalars["Float"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverWalletMinAggregate = {
  __typename?: "DriverWalletMinAggregate";
  balance?: Maybe<Scalars["Float"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type DriverWalletSort = {
  direction: SortDirection;
  field: DriverWalletSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum DriverWalletSortFields {
  Balance = "balance",
  Currency = "currency",
  DriverId = "driverId",
  Id = "id",
}

export type DriverWalletSumAggregate = {
  __typename?: "DriverWalletSumAggregate";
  balance?: Maybe<Scalars["Float"]["output"]>;
  driverId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type EligibleDriverClosingCommissionTripDto = {
  __typename?: "EligibleDriverClosingCommissionTripDTO";
  calculatedCommissionAmount?: Maybe<Scalars["String"]["output"]>;
  commissionRatePercent?: Maybe<Scalars["String"]["output"]>;
  currency: Scalars["String"]["output"];
  orderId: Scalars["ID"]["output"];
  orderReference: Scalars["String"]["output"];
  reportTimestamp: Scalars["DateTime"]["output"];
  revenueAmount: Scalars["String"]["output"];
  serviceName?: Maybe<Scalars["String"]["output"]>;
  vehiclePlate?: Maybe<Scalars["String"]["output"]>;
};

export type EligibleDriverClosingCommissionTripsInput = {
  closingRecordId?: InputMaybe<Scalars["ID"]["input"]>;
  driverId: Scalars["ID"]["input"];
  excludeCommissionEntryId?: InputMaybe<Scalars["ID"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  partnerId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Europe/Tirane local time: YYYY-MM-DDTHH:mm */
  periodEndLocal: Scalars["String"]["input"];
  /** Europe/Tirane local time: YYYY-MM-DDTHH:mm */
  periodStartLocal: Scalars["String"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
};

/** Email Log */
export type Email = {
  __typename?: "Email";
  bodyHtml: Scalars["String"]["output"];
  cc?: Maybe<Scalars["String"]["output"]>;
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  eventType: EmailEventType;
  from: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  providerId: Scalars["ID"]["output"];
  providerMessageId?: Maybe<Scalars["String"]["output"]>;
  sentAt: Scalars["DateTime"]["output"];
  status: EmailStatus;
  subject: Scalars["String"]["output"];
  templateId?: Maybe<Scalars["ID"]["output"]>;
  to: Scalars["String"]["output"];
};

export type EmailAggregateFilter = {
  and?: InputMaybe<Array<EmailAggregateFilter>>;
  eventType?: InputMaybe<EmailEventTypeFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<EmailAggregateFilter>>;
  providerId?: InputMaybe<IdFilterComparison>;
  status?: InputMaybe<EmailStatusFilterComparison>;
  templateId?: InputMaybe<IdFilterComparison>;
  to?: InputMaybe<StringFieldComparison>;
};

export type EmailConnection = {
  __typename?: "EmailConnection";
  /** Array of nodes. */
  nodes: Array<Email>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

/** The source of email content - inline body or provider template */
export enum EmailContentSource {
  Inline = "Inline",
  ProviderTemplate = "ProviderTemplate",
}

export type EmailContentSourceFilterComparison = {
  eq?: InputMaybe<EmailContentSource>;
  gt?: InputMaybe<EmailContentSource>;
  gte?: InputMaybe<EmailContentSource>;
  iLike?: InputMaybe<EmailContentSource>;
  in?: InputMaybe<Array<EmailContentSource>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<EmailContentSource>;
  lt?: InputMaybe<EmailContentSource>;
  lte?: InputMaybe<EmailContentSource>;
  neq?: InputMaybe<EmailContentSource>;
  notILike?: InputMaybe<EmailContentSource>;
  notIn?: InputMaybe<Array<EmailContentSource>>;
  notLike?: InputMaybe<EmailContentSource>;
};

export type EmailDeleteFilter = {
  and?: InputMaybe<Array<EmailDeleteFilter>>;
  eventType?: InputMaybe<EmailEventTypeFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<EmailDeleteFilter>>;
  providerId?: InputMaybe<IdFilterComparison>;
  status?: InputMaybe<EmailStatusFilterComparison>;
  templateId?: InputMaybe<IdFilterComparison>;
  to?: InputMaybe<StringFieldComparison>;
};

export type EmailDeleteResponse = {
  __typename?: "EmailDeleteResponse";
  bodyHtml?: Maybe<Scalars["String"]["output"]>;
  cc?: Maybe<Scalars["String"]["output"]>;
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  eventType?: Maybe<EmailEventType>;
  from?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  providerId?: Maybe<Scalars["ID"]["output"]>;
  providerMessageId?: Maybe<Scalars["String"]["output"]>;
  sentAt?: Maybe<Scalars["DateTime"]["output"]>;
  status?: Maybe<EmailStatus>;
  subject?: Maybe<Scalars["String"]["output"]>;
  templateId?: Maybe<Scalars["ID"]["output"]>;
  to?: Maybe<Scalars["String"]["output"]>;
};

/** The type of event that triggers an email */
export enum EmailEventType {
  AuthPasswordReset = "AUTH_PASSWORD_RESET",
  AuthVerification = "AUTH_VERIFICATION",
  AuthWelcome = "AUTH_WELCOME",
  DriverApproved = "DRIVER_APPROVED",
  DriverDocumentsPending = "DRIVER_DOCUMENTS_PENDING",
  DriverRegistrationSubmitted = "DRIVER_REGISTRATION_SUBMITTED",
  DriverRejected = "DRIVER_REJECTED",
  DriverSuspended = "DRIVER_SUSPENDED",
  ExpiringKyc_1DayReminder = "EXPIRING_KYC_1_DAY_REMINDER",
  ExpiringKyc_2DayReminder = "EXPIRING_KYC_2_DAY_REMINDER",
  ExpiringKyc_3DayReminder = "EXPIRING_KYC_3_DAY_REMINDER",
  ExpiringKyc_7DayReminder = "EXPIRING_KYC_7_DAY_REMINDER",
  ExpiringKyc_14DayReminder = "EXPIRING_KYC_14_DAY_REMINDER",
  ExpiringKyc_30DayReminder = "EXPIRING_KYC_30_DAY_REMINDER",
  OrderCancelled = "ORDER_CANCELLED",
  OrderCompleted = "ORDER_COMPLETED",
  OrderConfirmed = "ORDER_CONFIRMED",
  OrderRefunded = "ORDER_REFUNDED",
}

export type EmailEventTypeFilterComparison = {
  eq?: InputMaybe<EmailEventType>;
  gt?: InputMaybe<EmailEventType>;
  gte?: InputMaybe<EmailEventType>;
  iLike?: InputMaybe<EmailEventType>;
  in?: InputMaybe<Array<EmailEventType>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<EmailEventType>;
  lt?: InputMaybe<EmailEventType>;
  lte?: InputMaybe<EmailEventType>;
  neq?: InputMaybe<EmailEventType>;
  notILike?: InputMaybe<EmailEventType>;
  notIn?: InputMaybe<Array<EmailEventType>>;
  notLike?: InputMaybe<EmailEventType>;
};

export type EmailFilter = {
  and?: InputMaybe<Array<EmailFilter>>;
  eventType?: InputMaybe<EmailEventTypeFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<EmailFilter>>;
  providerId?: InputMaybe<IdFilterComparison>;
  status?: InputMaybe<EmailStatusFilterComparison>;
  templateId?: InputMaybe<IdFilterComparison>;
  to?: InputMaybe<StringFieldComparison>;
};

/** Email Provider */
export type EmailProvider = {
  __typename?: "EmailProvider";
  apiKey?: Maybe<Scalars["String"]["output"]>;
  emails: EmailProviderEmailsConnection;
  emailsAggregate: Array<EmailProviderEmailsAggregateResponse>;
  fromEmail?: Maybe<Scalars["String"]["output"]>;
  fromName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  replyToEmail?: Maybe<Scalars["String"]["output"]>;
  type: EmailProviderType;
};

/** Email Provider */
export type EmailProviderEmailsArgs = {
  filter?: EmailFilter;
  paging?: OffsetPaging;
  sorting?: Array<EmailSort>;
};

/** Email Provider */
export type EmailProviderEmailsAggregateArgs = {
  filter?: InputMaybe<EmailAggregateFilter>;
};

export type EmailProviderConnection = {
  __typename?: "EmailProviderConnection";
  /** Array of nodes. */
  nodes: Array<EmailProvider>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type EmailProviderDeleteFilter = {
  and?: InputMaybe<Array<EmailProviderDeleteFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<EmailProviderDeleteFilter>>;
  type?: InputMaybe<EmailProviderTypeFilterComparison>;
};

export type EmailProviderDeleteResponse = {
  __typename?: "EmailProviderDeleteResponse";
  apiKey?: Maybe<Scalars["String"]["output"]>;
  fromEmail?: Maybe<Scalars["String"]["output"]>;
  fromName?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  isDefault?: Maybe<Scalars["Boolean"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  replyToEmail?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<EmailProviderType>;
};

export type EmailProviderEmailsAggregateGroupBy = {
  __typename?: "EmailProviderEmailsAggregateGroupBy";
  eventType?: Maybe<EmailEventType>;
  id?: Maybe<Scalars["ID"]["output"]>;
  providerId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<EmailStatus>;
  templateId?: Maybe<Scalars["ID"]["output"]>;
  to?: Maybe<Scalars["String"]["output"]>;
};

export type EmailProviderEmailsAggregateResponse = {
  __typename?: "EmailProviderEmailsAggregateResponse";
  avg?: Maybe<EmailProviderEmailsAvgAggregate>;
  count?: Maybe<EmailProviderEmailsCountAggregate>;
  groupBy?: Maybe<EmailProviderEmailsAggregateGroupBy>;
  max?: Maybe<EmailProviderEmailsMaxAggregate>;
  min?: Maybe<EmailProviderEmailsMinAggregate>;
  sum?: Maybe<EmailProviderEmailsSumAggregate>;
};

export type EmailProviderEmailsAvgAggregate = {
  __typename?: "EmailProviderEmailsAvgAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
  providerId?: Maybe<Scalars["Float"]["output"]>;
  templateId?: Maybe<Scalars["Float"]["output"]>;
};

export type EmailProviderEmailsConnection = {
  __typename?: "EmailProviderEmailsConnection";
  /** Array of nodes. */
  nodes: Array<Email>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type EmailProviderEmailsCountAggregate = {
  __typename?: "EmailProviderEmailsCountAggregate";
  eventType?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  providerId?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
  templateId?: Maybe<Scalars["Int"]["output"]>;
  to?: Maybe<Scalars["Int"]["output"]>;
};

export type EmailProviderEmailsMaxAggregate = {
  __typename?: "EmailProviderEmailsMaxAggregate";
  eventType?: Maybe<EmailEventType>;
  id?: Maybe<Scalars["ID"]["output"]>;
  providerId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<EmailStatus>;
  templateId?: Maybe<Scalars["ID"]["output"]>;
  to?: Maybe<Scalars["String"]["output"]>;
};

export type EmailProviderEmailsMinAggregate = {
  __typename?: "EmailProviderEmailsMinAggregate";
  eventType?: Maybe<EmailEventType>;
  id?: Maybe<Scalars["ID"]["output"]>;
  providerId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<EmailStatus>;
  templateId?: Maybe<Scalars["ID"]["output"]>;
  to?: Maybe<Scalars["String"]["output"]>;
};

export type EmailProviderEmailsSumAggregate = {
  __typename?: "EmailProviderEmailsSumAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
  providerId?: Maybe<Scalars["Float"]["output"]>;
  templateId?: Maybe<Scalars["Float"]["output"]>;
};

export type EmailProviderFilter = {
  and?: InputMaybe<Array<EmailProviderFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<EmailProviderFilter>>;
  type?: InputMaybe<EmailProviderTypeFilterComparison>;
};

export type EmailProviderInput = {
  apiKey?: InputMaybe<Scalars["String"]["input"]>;
  fromEmail?: InputMaybe<Scalars["String"]["input"]>;
  fromName?: InputMaybe<Scalars["String"]["input"]>;
  isDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  replyToEmail?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<EmailProviderType>;
};

export type EmailProviderSort = {
  direction: SortDirection;
  field: EmailProviderSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum EmailProviderSortFields {
  Id = "id",
  Name = "name",
  Type = "type",
}

/** The type of the email provider */
export enum EmailProviderType {
  MailerSend = "MailerSend",
  SendGrid = "SendGrid",
}

export type EmailProviderTypeFilterComparison = {
  eq?: InputMaybe<EmailProviderType>;
  gt?: InputMaybe<EmailProviderType>;
  gte?: InputMaybe<EmailProviderType>;
  iLike?: InputMaybe<EmailProviderType>;
  in?: InputMaybe<Array<EmailProviderType>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<EmailProviderType>;
  lt?: InputMaybe<EmailProviderType>;
  lte?: InputMaybe<EmailProviderType>;
  neq?: InputMaybe<EmailProviderType>;
  notILike?: InputMaybe<EmailProviderType>;
  notIn?: InputMaybe<Array<EmailProviderType>>;
  notLike?: InputMaybe<EmailProviderType>;
};

export type EmailProviderUpdateFilter = {
  and?: InputMaybe<Array<EmailProviderUpdateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<EmailProviderUpdateFilter>>;
  type?: InputMaybe<EmailProviderTypeFilterComparison>;
};

export type EmailSort = {
  direction: SortDirection;
  field: EmailSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum EmailSortFields {
  EventType = "eventType",
  Id = "id",
  ProviderId = "providerId",
  Status = "status",
  TemplateId = "templateId",
  To = "to",
}

/** The status of the email */
export enum EmailStatus {
  Bounced = "BOUNCED",
  Clicked = "CLICKED",
  Delivered = "DELIVERED",
  Failed = "FAILED",
  Opened = "OPENED",
  Pending = "PENDING",
  Sent = "SENT",
}

export type EmailStatusFilterComparison = {
  eq?: InputMaybe<EmailStatus>;
  gt?: InputMaybe<EmailStatus>;
  gte?: InputMaybe<EmailStatus>;
  iLike?: InputMaybe<EmailStatus>;
  in?: InputMaybe<Array<EmailStatus>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<EmailStatus>;
  lt?: InputMaybe<EmailStatus>;
  lte?: InputMaybe<EmailStatus>;
  neq?: InputMaybe<EmailStatus>;
  notILike?: InputMaybe<EmailStatus>;
  notIn?: InputMaybe<Array<EmailStatus>>;
  notLike?: InputMaybe<EmailStatus>;
};

/** Email Template */
export type EmailTemplate = {
  __typename?: "EmailTemplate";
  bodyHtml?: Maybe<Scalars["String"]["output"]>;
  bodyPlainText?: Maybe<Scalars["String"]["output"]>;
  /** Comma-separated list of CC email addresses */
  cc?: Maybe<Scalars["String"]["output"]>;
  /** Source of email content - Inline or ProviderTemplate */
  contentSource: EmailContentSource;
  createdAt: Scalars["DateTime"]["output"];
  eventType: EmailEventType;
  id: Scalars["ID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  locale?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  /** External template ID from email provider (SendGrid/MailerSend) */
  providerTemplateId?: Maybe<Scalars["String"]["output"]>;
  subject: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type EmailTemplateConnection = {
  __typename?: "EmailTemplateConnection";
  /** Array of nodes. */
  nodes: Array<EmailTemplate>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type EmailTemplateDeleteFilter = {
  and?: InputMaybe<Array<EmailTemplateDeleteFilter>>;
  contentSource?: InputMaybe<EmailContentSourceFilterComparison>;
  eventType?: InputMaybe<EmailEventTypeFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isActive?: InputMaybe<BooleanFieldComparison>;
  locale?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<EmailTemplateDeleteFilter>>;
};

export type EmailTemplateDeleteResponse = {
  __typename?: "EmailTemplateDeleteResponse";
  bodyHtml?: Maybe<Scalars["String"]["output"]>;
  bodyPlainText?: Maybe<Scalars["String"]["output"]>;
  /** Comma-separated list of CC email addresses */
  cc?: Maybe<Scalars["String"]["output"]>;
  /** Source of email content - Inline or ProviderTemplate */
  contentSource?: Maybe<EmailContentSource>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  eventType?: Maybe<EmailEventType>;
  id?: Maybe<Scalars["ID"]["output"]>;
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  locale?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  /** External template ID from email provider (SendGrid/MailerSend) */
  providerTemplateId?: Maybe<Scalars["String"]["output"]>;
  subject?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type EmailTemplateFilter = {
  and?: InputMaybe<Array<EmailTemplateFilter>>;
  contentSource?: InputMaybe<EmailContentSourceFilterComparison>;
  eventType?: InputMaybe<EmailEventTypeFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isActive?: InputMaybe<BooleanFieldComparison>;
  locale?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<EmailTemplateFilter>>;
};

export type EmailTemplateInput = {
  bodyHtml?: InputMaybe<Scalars["String"]["input"]>;
  bodyPlainText?: InputMaybe<Scalars["String"]["input"]>;
  /** Comma-separated list of CC email addresses */
  cc?: InputMaybe<Scalars["String"]["input"]>;
  /** Source of email content - Inline or ProviderTemplate */
  contentSource?: InputMaybe<EmailContentSource>;
  eventType?: InputMaybe<EmailEventType>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** External template ID from email provider (SendGrid/MailerSend) */
  providerTemplateId?: InputMaybe<Scalars["String"]["input"]>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
};

export type EmailTemplateSort = {
  direction: SortDirection;
  field: EmailTemplateSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum EmailTemplateSortFields {
  ContentSource = "contentSource",
  EventType = "eventType",
  Id = "id",
  IsActive = "isActive",
  Locale = "locale",
  Name = "name",
}

export type EmailTemplateUpdateFilter = {
  and?: InputMaybe<Array<EmailTemplateUpdateFilter>>;
  contentSource?: InputMaybe<EmailContentSourceFilterComparison>;
  eventType?: InputMaybe<EmailEventTypeFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isActive?: InputMaybe<BooleanFieldComparison>;
  locale?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<EmailTemplateUpdateFilter>>;
};

export enum EnabledNotification {
  NewOrder = "NewOrder",
  Sos = "SOS",
  SupportRequest = "SupportRequest",
  UserPendingVerification = "UserPendingVerification",
}

export type EndVehicleTelematicsMappingInput = {
  confirmed: Scalars["Boolean"]["input"];
  mappingId: Scalars["ID"]["input"];
  reason: Scalars["String"]["input"];
};

export type ExportArgs = {
  filters?: InputMaybe<Array<ExportFilterArg>>;
  relations?: InputMaybe<Array<Scalars["String"]["input"]>>;
  sort?: InputMaybe<ExportSortArg>;
  table: ExportTable;
  type: ExportType;
};

export type ExportFieldInput = {
  /** The field to export. Use dot notation for nested fields. */
  field: Scalars["String"]["input"];
  /** Optional label for the field in the export. */
  label?: InputMaybe<Scalars["String"]["input"]>;
};

export type ExportFilterArg = {
  field: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

/** The format for exporting data */
export enum ExportFormat {
  Csv = "CSV",
  Pdf = "PDF",
}

export type ExportResult = {
  __typename?: "ExportResult";
  url: Scalars["String"]["output"];
};

export type ExportSessionToCsvInput = {
  payoutMethodId: Scalars["ID"]["input"];
  payoutSessionId: Scalars["ID"]["input"];
};

export type ExportSortArg = {
  direction: SortDirection;
  property: Scalars["String"]["input"];
};

export enum ExportTable {
  DriverWallet = "DriverWallet",
  FleetWallet = "FleetWallet",
  ProviderWallet = "ProviderWallet",
  RiderWallet = "RiderWallet",
}

export enum ExportType {
  Csv = "CSV",
}

export type FallbackConfig = {
  __typename?: "FallbackConfig";
  /** Enable fallback dispatch strategy */
  fallbackEnabled: Scalars["Boolean"]["output"];
  /** Scoring configuration for fallback dispatch */
  fallbackScoring?: Maybe<DriverScoringConfig>;
  /** Fallback dispatch strategy to use */
  fallbackStrategy: DispatchStrategy;
};

export type FallbackConfigInput = {
  /** Enable fallback dispatch strategy */
  fallbackEnabled: Scalars["Boolean"]["input"];
  /** Scoring configuration for fallback dispatch */
  fallbackScoring?: InputMaybe<DriverScoringConfigInput>;
  /** Fallback dispatch strategy to use */
  fallbackStrategy: DispatchStrategy;
};

/** How the final ride fare is settled. */
export enum FareMode {
  FixedPrice = "FixedPrice",
  Taximeter = "Taximeter",
}

export type FareModeFilterComparison = {
  eq?: InputMaybe<FareMode>;
  gt?: InputMaybe<FareMode>;
  gte?: InputMaybe<FareMode>;
  iLike?: InputMaybe<FareMode>;
  in?: InputMaybe<Array<FareMode>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<FareMode>;
  lt?: InputMaybe<FareMode>;
  lte?: InputMaybe<FareMode>;
  neq?: InputMaybe<FareMode>;
  notILike?: InputMaybe<FareMode>;
  notIn?: InputMaybe<Array<FareMode>>;
  notLike?: InputMaybe<FareMode>;
};

export type Feedback = {
  __typename?: "Feedback";
  description?: Maybe<Scalars["String"]["output"]>;
  driver: Driver;
  driverId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  parameters: Array<FeedbackParameter>;
  parametersAggregate: Array<FeedbackParametersAggregateResponse>;
  request: Order;
  requestId: Scalars["ID"]["output"];
  reviewTimestamp: Scalars["DateTime"]["output"];
  score: Scalars["Int"]["output"];
};

export type FeedbackParametersArgs = {
  filter?: FeedbackParameterFilter;
  sorting?: Array<FeedbackParameterSort>;
};

export type FeedbackParametersAggregateArgs = {
  filter?: InputMaybe<FeedbackParameterAggregateFilter>;
};

export type FeedbackAggregateFilter = {
  and?: InputMaybe<Array<FeedbackAggregateFilter>>;
  driverId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<FeedbackAggregateFilter>>;
  parameters?: InputMaybe<FeedbackAggregateFilterFeedbackParameterAggregateFilter>;
  request?: InputMaybe<FeedbackAggregateFilterOrderAggregateFilter>;
  requestId?: InputMaybe<IdFilterComparison>;
};

export type FeedbackAggregateFilterFeedbackParameterAggregateFilter = {
  and?: InputMaybe<
    Array<FeedbackAggregateFilterFeedbackParameterAggregateFilter>
  >;
  id?: InputMaybe<IdFilterComparison>;
  isGood?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<
    Array<FeedbackAggregateFilterFeedbackParameterAggregateFilter>
  >;
  title?: InputMaybe<StringFieldComparison>;
};

export type FeedbackAggregateFilterOrderAggregateFilter = {
  and?: InputMaybe<Array<FeedbackAggregateFilterOrderAggregateFilter>>;
  costAfterCoupon?: InputMaybe<FloatFieldComparison>;
  costBest?: InputMaybe<FloatFieldComparison>;
  createdOn?: InputMaybe<DateFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  distanceBest?: InputMaybe<IntFieldComparison>;
  driverId?: InputMaybe<IdFilterComparison>;
  durationBest?: InputMaybe<IntFieldComparison>;
  fareMode?: InputMaybe<FareModeFilterComparison>;
  finishTimestamp?: InputMaybe<DateFieldComparison>;
  fleetId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  operatorId?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<FeedbackAggregateFilterOrderAggregateFilter>>;
  orderSource?: InputMaybe<OrderSourceFilterComparison>;
  paymentMode?: InputMaybe<PaymentModeFilterComparison>;
  regionId?: InputMaybe<IdFilterComparison>;
  reportingSource?: InputMaybe<OrderSourceFilterComparison>;
  riderId?: InputMaybe<IdFilterComparison>;
  routeSource?: InputMaybe<RouteSourceFilterComparison>;
  serviceId?: InputMaybe<IdFilterComparison>;
  status?: InputMaybe<OrderStatusFilterComparison>;
  tariffProfileId?: InputMaybe<IdFilterComparison>;
  type?: InputMaybe<TaxiOrderTypeFilterComparison>;
};

export type FeedbackConnection = {
  __typename?: "FeedbackConnection";
  /** Array of nodes. */
  nodes: Array<Feedback>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type FeedbackFilter = {
  and?: InputMaybe<Array<FeedbackFilter>>;
  driverId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<FeedbackFilter>>;
  parameters?: InputMaybe<FeedbackFilterFeedbackParameterFilter>;
  request?: InputMaybe<FeedbackFilterOrderFilter>;
  requestId?: InputMaybe<IdFilterComparison>;
};

export type FeedbackFilterFeedbackParameterFilter = {
  and?: InputMaybe<Array<FeedbackFilterFeedbackParameterFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  isGood?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<FeedbackFilterFeedbackParameterFilter>>;
  title?: InputMaybe<StringFieldComparison>;
};

export type FeedbackFilterOrderFilter = {
  and?: InputMaybe<Array<FeedbackFilterOrderFilter>>;
  costAfterCoupon?: InputMaybe<FloatFieldComparison>;
  costBest?: InputMaybe<FloatFieldComparison>;
  createdOn?: InputMaybe<DateFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  distanceBest?: InputMaybe<IntFieldComparison>;
  driverId?: InputMaybe<IdFilterComparison>;
  durationBest?: InputMaybe<IntFieldComparison>;
  fareMode?: InputMaybe<FareModeFilterComparison>;
  finishTimestamp?: InputMaybe<DateFieldComparison>;
  fleetId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  operatorId?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<FeedbackFilterOrderFilter>>;
  orderSource?: InputMaybe<OrderSourceFilterComparison>;
  paymentMode?: InputMaybe<PaymentModeFilterComparison>;
  regionId?: InputMaybe<IdFilterComparison>;
  reportingSource?: InputMaybe<OrderSourceFilterComparison>;
  riderId?: InputMaybe<IdFilterComparison>;
  routeSource?: InputMaybe<RouteSourceFilterComparison>;
  serviceId?: InputMaybe<IdFilterComparison>;
  status?: InputMaybe<OrderStatusFilterComparison>;
  tariffProfileId?: InputMaybe<IdFilterComparison>;
  type?: InputMaybe<TaxiOrderTypeFilterComparison>;
};

export type FeedbackParameter = {
  __typename?: "FeedbackParameter";
  feedbacks: FeedbackParameterFeedbacksConnection;
  feedbacksAggregate: Array<FeedbackParameterFeedbacksAggregateResponse>;
  id: Scalars["ID"]["output"];
  isGood: Scalars["Boolean"]["output"];
  title: Scalars["String"]["output"];
};

export type FeedbackParameterFeedbacksArgs = {
  filter?: FeedbackParameterFilter;
  paging?: OffsetPaging;
  sorting?: Array<FeedbackParameterSort>;
};

export type FeedbackParameterFeedbacksAggregateArgs = {
  filter?: InputMaybe<FeedbackParameterAggregateFilter>;
};

export type FeedbackParameterAggregate = {
  __typename?: "FeedbackParameterAggregate";
  count: Scalars["ID"]["output"];
  isGood: Scalars["Boolean"]["output"];
  title: Scalars["String"]["output"];
};

export type FeedbackParameterAggregateFilter = {
  and?: InputMaybe<Array<FeedbackParameterAggregateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  isGood?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<FeedbackParameterAggregateFilter>>;
  title?: InputMaybe<StringFieldComparison>;
};

export type FeedbackParameterDeleteResponse = {
  __typename?: "FeedbackParameterDeleteResponse";
  id?: Maybe<Scalars["ID"]["output"]>;
  isGood?: Maybe<Scalars["Boolean"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type FeedbackParameterFeedbacksAggregateGroupBy = {
  __typename?: "FeedbackParameterFeedbacksAggregateGroupBy";
  id?: Maybe<Scalars["ID"]["output"]>;
  isGood?: Maybe<Scalars["Boolean"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type FeedbackParameterFeedbacksAggregateResponse = {
  __typename?: "FeedbackParameterFeedbacksAggregateResponse";
  avg?: Maybe<FeedbackParameterFeedbacksAvgAggregate>;
  count?: Maybe<FeedbackParameterFeedbacksCountAggregate>;
  groupBy?: Maybe<FeedbackParameterFeedbacksAggregateGroupBy>;
  max?: Maybe<FeedbackParameterFeedbacksMaxAggregate>;
  min?: Maybe<FeedbackParameterFeedbacksMinAggregate>;
  sum?: Maybe<FeedbackParameterFeedbacksSumAggregate>;
};

export type FeedbackParameterFeedbacksAvgAggregate = {
  __typename?: "FeedbackParameterFeedbacksAvgAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type FeedbackParameterFeedbacksConnection = {
  __typename?: "FeedbackParameterFeedbacksConnection";
  /** Array of nodes. */
  nodes: Array<FeedbackParameter>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type FeedbackParameterFeedbacksCountAggregate = {
  __typename?: "FeedbackParameterFeedbacksCountAggregate";
  id?: Maybe<Scalars["Int"]["output"]>;
  isGood?: Maybe<Scalars["Int"]["output"]>;
  title?: Maybe<Scalars["Int"]["output"]>;
};

export type FeedbackParameterFeedbacksMaxAggregate = {
  __typename?: "FeedbackParameterFeedbacksMaxAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type FeedbackParameterFeedbacksMinAggregate = {
  __typename?: "FeedbackParameterFeedbacksMinAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type FeedbackParameterFeedbacksSumAggregate = {
  __typename?: "FeedbackParameterFeedbacksSumAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type FeedbackParameterFilter = {
  and?: InputMaybe<Array<FeedbackParameterFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  isGood?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<FeedbackParameterFilter>>;
  title?: InputMaybe<StringFieldComparison>;
};

export type FeedbackParameterInput = {
  isGood: Scalars["Boolean"]["input"];
  title: Scalars["String"]["input"];
};

export type FeedbackParameterSort = {
  direction: SortDirection;
  field: FeedbackParameterSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum FeedbackParameterSortFields {
  Id = "id",
  IsGood = "isGood",
  Title = "title",
}

export type FeedbackParametersAggregateGroupBy = {
  __typename?: "FeedbackParametersAggregateGroupBy";
  id?: Maybe<Scalars["ID"]["output"]>;
  isGood?: Maybe<Scalars["Boolean"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type FeedbackParametersAggregateResponse = {
  __typename?: "FeedbackParametersAggregateResponse";
  avg?: Maybe<FeedbackParametersAvgAggregate>;
  count?: Maybe<FeedbackParametersCountAggregate>;
  groupBy?: Maybe<FeedbackParametersAggregateGroupBy>;
  max?: Maybe<FeedbackParametersMaxAggregate>;
  min?: Maybe<FeedbackParametersMinAggregate>;
  sum?: Maybe<FeedbackParametersSumAggregate>;
};

export type FeedbackParametersAvgAggregate = {
  __typename?: "FeedbackParametersAvgAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type FeedbackParametersCountAggregate = {
  __typename?: "FeedbackParametersCountAggregate";
  id?: Maybe<Scalars["Int"]["output"]>;
  isGood?: Maybe<Scalars["Int"]["output"]>;
  title?: Maybe<Scalars["Int"]["output"]>;
};

export type FeedbackParametersMaxAggregate = {
  __typename?: "FeedbackParametersMaxAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type FeedbackParametersMinAggregate = {
  __typename?: "FeedbackParametersMinAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type FeedbackParametersSumAggregate = {
  __typename?: "FeedbackParametersSumAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type FeedbackSort = {
  direction: SortDirection;
  field: FeedbackSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum FeedbackSortFields {
  DriverId = "driverId",
  Id = "id",
  RequestId = "requestId",
}

export type FinancialTimeline = {
  __typename?: "FinancialTimeline";
  amount: Scalars["Float"]["output"];
  /** Any date within the range of revenue interval. */
  anyDate: Scalars["DateTime"]["output"];
  dateString: Scalars["String"]["output"];
};

export type FixedCost = {
  __typename?: "FixedCost";
  cost: Scalars["Float"]["output"];
  mode: PricingMode;
  zonePriceBreakdown?: Maybe<ZonePriceFareBreakdown>;
};

export enum FixedFareRoutingMode {
  TrafficAwareOptimal = "TrafficAwareOptimal",
  TrafficUnaware = "TrafficUnaware",
}

export type FixedFareRoutingSettings = {
  __typename?: "FixedFareRoutingSettings";
  configurationWarning?: Maybe<Scalars["String"]["output"]>;
  ignoreLiveTraffic: Scalars["Boolean"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  mode: FixedFareRoutingMode;
  recommendedMode: FixedFareRoutingMode;
  success: Scalars["Boolean"]["output"];
  updatedAt?: Maybe<Scalars["String"]["output"]>;
  updatedByName?: Maybe<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type Fleet = {
  __typename?: "Fleet";
  accountNumber: Scalars["String"]["output"];
  address?: Maybe<Scalars["String"]["output"]>;
  commissionShareFlat: Scalars["Float"]["output"];
  commissionSharePercent: Scalars["Float"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  drivers: FleetDriversConnection;
  driversAggregate: Array<FleetDriversAggregateResponse>;
  exclusivityAreas?: Maybe<Array<Array<Point>>>;
  feeMultiplier?: Maybe<Scalars["Float"]["output"]>;
  id: Scalars["ID"]["output"];
  isBlocked: Scalars["Boolean"]["output"];
  mobileNumber: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  password?: Maybe<Scalars["String"]["output"]>;
  phoneNumber: Scalars["String"]["output"];
  profilePicture?: Maybe<Media>;
  transactions: FleetTransactionsConnection;
  userName?: Maybe<Scalars["String"]["output"]>;
  wallet: Array<FleetWallet>;
  zonePrices: FleetZonePricesConnection;
};

export type FleetDriversArgs = {
  filter?: DriverFilter;
  paging?: OffsetPaging;
  sorting?: Array<DriverSort>;
};

export type FleetDriversAggregateArgs = {
  filter?: InputMaybe<DriverAggregateFilter>;
};

export type FleetTransactionsArgs = {
  filter?: FleetTransactionFilter;
  paging?: OffsetPaging;
  sorting?: Array<FleetTransactionSort>;
};

export type FleetWalletArgs = {
  filter?: FleetWalletFilter;
  sorting?: Array<FleetWalletSort>;
};

export type FleetZonePricesArgs = {
  filter?: ZonePriceFilter;
  paging?: OffsetPaging;
  sorting?: Array<ZonePriceSort>;
};

export type FleetConnection = {
  __typename?: "FleetConnection";
  /** Array of nodes. */
  nodes: Array<Fleet>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type FleetDeleteResponse = {
  __typename?: "FleetDeleteResponse";
  accountNumber?: Maybe<Scalars["String"]["output"]>;
  address?: Maybe<Scalars["String"]["output"]>;
  commissionShareFlat?: Maybe<Scalars["Float"]["output"]>;
  commissionSharePercent?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  exclusivityAreas?: Maybe<Array<Array<Point>>>;
  feeMultiplier?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  isBlocked?: Maybe<Scalars["Boolean"]["output"]>;
  mobileNumber?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  password?: Maybe<Scalars["String"]["output"]>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  userName?: Maybe<Scalars["String"]["output"]>;
};

export type FleetDriversAggregateGroupBy = {
  __typename?: "FleetDriversAggregateGroupBy";
  carColorId?: Maybe<Scalars["ID"]["output"]>;
  carId?: Maybe<Scalars["ID"]["output"]>;
  carPlate?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  gender?: Maybe<Gender>;
  id?: Maybe<Scalars["ID"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  maxDeliveryPackageSize?: Maybe<DeliveryPackageSize>;
  mobileNumber?: Maybe<Scalars["String"]["output"]>;
  rating?: Maybe<Scalars["Int"]["output"]>;
  reviewCount?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<DriverStatus>;
};

export type FleetDriversAggregateResponse = {
  __typename?: "FleetDriversAggregateResponse";
  avg?: Maybe<FleetDriversAvgAggregate>;
  count?: Maybe<FleetDriversCountAggregate>;
  groupBy?: Maybe<FleetDriversAggregateGroupBy>;
  max?: Maybe<FleetDriversMaxAggregate>;
  min?: Maybe<FleetDriversMinAggregate>;
  sum?: Maybe<FleetDriversSumAggregate>;
};

export type FleetDriversAvgAggregate = {
  __typename?: "FleetDriversAvgAggregate";
  carColorId?: Maybe<Scalars["Float"]["output"]>;
  carId?: Maybe<Scalars["Float"]["output"]>;
  fleetId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  rating?: Maybe<Scalars["Float"]["output"]>;
  reviewCount?: Maybe<Scalars["Float"]["output"]>;
};

export type FleetDriversConnection = {
  __typename?: "FleetDriversConnection";
  /** Array of nodes. */
  nodes: Array<Driver>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type FleetDriversCountAggregate = {
  __typename?: "FleetDriversCountAggregate";
  carColorId?: Maybe<Scalars["Int"]["output"]>;
  carId?: Maybe<Scalars["Int"]["output"]>;
  carPlate?: Maybe<Scalars["Int"]["output"]>;
  firstName?: Maybe<Scalars["Int"]["output"]>;
  fleetId?: Maybe<Scalars["Int"]["output"]>;
  gender?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  lastName?: Maybe<Scalars["Int"]["output"]>;
  maxDeliveryPackageSize?: Maybe<Scalars["Int"]["output"]>;
  mobileNumber?: Maybe<Scalars["Int"]["output"]>;
  rating?: Maybe<Scalars["Int"]["output"]>;
  reviewCount?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
};

export type FleetDriversMaxAggregate = {
  __typename?: "FleetDriversMaxAggregate";
  carColorId?: Maybe<Scalars["ID"]["output"]>;
  carId?: Maybe<Scalars["ID"]["output"]>;
  carPlate?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  gender?: Maybe<Gender>;
  id?: Maybe<Scalars["ID"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  maxDeliveryPackageSize?: Maybe<DeliveryPackageSize>;
  mobileNumber?: Maybe<Scalars["String"]["output"]>;
  rating?: Maybe<Scalars["Int"]["output"]>;
  reviewCount?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<DriverStatus>;
};

export type FleetDriversMinAggregate = {
  __typename?: "FleetDriversMinAggregate";
  carColorId?: Maybe<Scalars["ID"]["output"]>;
  carId?: Maybe<Scalars["ID"]["output"]>;
  carPlate?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  gender?: Maybe<Gender>;
  id?: Maybe<Scalars["ID"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  maxDeliveryPackageSize?: Maybe<DeliveryPackageSize>;
  mobileNumber?: Maybe<Scalars["String"]["output"]>;
  rating?: Maybe<Scalars["Int"]["output"]>;
  reviewCount?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<DriverStatus>;
};

export type FleetDriversSumAggregate = {
  __typename?: "FleetDriversSumAggregate";
  carColorId?: Maybe<Scalars["Float"]["output"]>;
  carId?: Maybe<Scalars["Float"]["output"]>;
  fleetId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  rating?: Maybe<Scalars["Float"]["output"]>;
  reviewCount?: Maybe<Scalars["Float"]["output"]>;
};

export type FleetFilter = {
  and?: InputMaybe<Array<FleetFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FleetFilter>>;
};

export type FleetSort = {
  direction: SortDirection;
  field: FleetSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum FleetSortFields {
  Id = "id",
  Name = "name",
}

export type FleetStaff = {
  __typename?: "FleetStaff";
  address?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  firstName: Scalars["String"]["output"];
  fleetId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  isBlocked: Scalars["Boolean"]["output"];
  lastActivityAt?: Maybe<Scalars["DateTime"]["output"]>;
  lastName: Scalars["String"]["output"];
  mobileNumber: Scalars["String"]["output"];
  password: Scalars["String"]["output"];
  permissionFinancial: FleetStaffPermissionOrder;
  permissionOrder: FleetStaffPermissionOrder;
  phoneNumber: Scalars["String"]["output"];
  profileImage?: Maybe<Media>;
  registeredAt: Scalars["DateTime"]["output"];
  userName: Scalars["String"]["output"];
};

export type FleetStaffConnection = {
  __typename?: "FleetStaffConnection";
  /** Array of nodes. */
  nodes: Array<FleetStaff>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type FleetStaffDeleteResponse = {
  __typename?: "FleetStaffDeleteResponse";
  address?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  isBlocked?: Maybe<Scalars["Boolean"]["output"]>;
  lastActivityAt?: Maybe<Scalars["DateTime"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  mobileNumber?: Maybe<Scalars["String"]["output"]>;
  password?: Maybe<Scalars["String"]["output"]>;
  permissionFinancial?: Maybe<FleetStaffPermissionOrder>;
  permissionOrder?: Maybe<FleetStaffPermissionOrder>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  registeredAt?: Maybe<Scalars["DateTime"]["output"]>;
  userName?: Maybe<Scalars["String"]["output"]>;
};

export type FleetStaffFilter = {
  and?: InputMaybe<Array<FleetStaffFilter>>;
  firstName?: InputMaybe<StringFieldComparison>;
  fleetId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isBlocked?: InputMaybe<BooleanFieldComparison>;
  lastName?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FleetStaffFilter>>;
  userName?: InputMaybe<StringFieldComparison>;
};

export enum FleetStaffPermissionFinancial {
  CanEdit = "CAN_EDIT",
  CanView = "CAN_VIEW",
}

export enum FleetStaffPermissionOrder {
  CanEdit = "CAN_EDIT",
  CanView = "CAN_VIEW",
}

export type FleetStaffSession = {
  __typename?: "FleetStaffSession";
  fleetStaffId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  sessionInfo: SessionInfo;
};

export type FleetStaffSessionFilter = {
  and?: InputMaybe<Array<FleetStaffSessionFilter>>;
  fleetStaffId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<FleetStaffSessionFilter>>;
};

export type FleetStaffSessionSort = {
  direction: SortDirection;
  field: FleetStaffSessionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum FleetStaffSessionSortFields {
  FleetStaffId = "fleetStaffId",
  Id = "id",
}

export type FleetStaffSort = {
  direction: SortDirection;
  field: FleetStaffSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum FleetStaffSortFields {
  FirstName = "firstName",
  FleetId = "fleetId",
  Id = "id",
  IsBlocked = "isBlocked",
  LastName = "lastName",
  UserName = "userName",
}

export type FleetTransaction = {
  __typename?: "FleetTransaction";
  action: TransactionAction;
  amount: Scalars["Float"]["output"];
  currency: Scalars["String"]["output"];
  deductType?: Maybe<ProviderDeductTransactionType>;
  description?: Maybe<Scalars["String"]["output"]>;
  fleetId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  operator?: Maybe<Operator>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<ProviderRechargeTransactionType>;
  refrenceNumber?: Maybe<Scalars["String"]["output"]>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  status: TransactionStatus;
  transactionTimestamp: Scalars["DateTime"]["output"];
};

export type FleetTransactionAggregateFilter = {
  action?: InputMaybe<TransactionActionFilterComparison>;
  and?: InputMaybe<Array<FleetTransactionAggregateFilter>>;
  deductType?: InputMaybe<ProviderDeductTransactionTypeFilterComparison>;
  fleetId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  operatorId?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<FleetTransactionAggregateFilter>>;
  rechargeType?: InputMaybe<ProviderRechargeTransactionTypeFilterComparison>;
  requestId?: InputMaybe<IdFilterComparison>;
  status?: InputMaybe<TransactionStatusFilterComparison>;
};

export type FleetTransactionAggregateGroupBy = {
  __typename?: "FleetTransactionAggregateGroupBy";
  action?: Maybe<TransactionAction>;
  deductType?: Maybe<ProviderDeductTransactionType>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<ProviderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type FleetTransactionAggregateResponse = {
  __typename?: "FleetTransactionAggregateResponse";
  avg?: Maybe<FleetTransactionAvgAggregate>;
  count?: Maybe<FleetTransactionCountAggregate>;
  groupBy?: Maybe<FleetTransactionAggregateGroupBy>;
  max?: Maybe<FleetTransactionMaxAggregate>;
  min?: Maybe<FleetTransactionMinAggregate>;
  sum?: Maybe<FleetTransactionSumAggregate>;
};

export type FleetTransactionAvgAggregate = {
  __typename?: "FleetTransactionAvgAggregate";
  fleetId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  requestId?: Maybe<Scalars["Float"]["output"]>;
};

export type FleetTransactionConnection = {
  __typename?: "FleetTransactionConnection";
  /** Array of nodes. */
  nodes: Array<FleetTransaction>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type FleetTransactionCountAggregate = {
  __typename?: "FleetTransactionCountAggregate";
  action?: Maybe<Scalars["Int"]["output"]>;
  deductType?: Maybe<Scalars["Int"]["output"]>;
  fleetId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  operatorId?: Maybe<Scalars["Int"]["output"]>;
  rechargeType?: Maybe<Scalars["Int"]["output"]>;
  requestId?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
};

export type FleetTransactionFilter = {
  action?: InputMaybe<TransactionActionFilterComparison>;
  and?: InputMaybe<Array<FleetTransactionFilter>>;
  deductType?: InputMaybe<ProviderDeductTransactionTypeFilterComparison>;
  fleetId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  operatorId?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<FleetTransactionFilter>>;
  rechargeType?: InputMaybe<ProviderRechargeTransactionTypeFilterComparison>;
  requestId?: InputMaybe<IdFilterComparison>;
  status?: InputMaybe<TransactionStatusFilterComparison>;
};

export type FleetTransactionInput = {
  action: TransactionAction;
  amount: Scalars["Float"]["input"];
  currency: Scalars["String"]["input"];
  deductType?: InputMaybe<ProviderDeductTransactionType>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  fleetId: Scalars["ID"]["input"];
  rechargeType?: InputMaybe<ProviderRechargeTransactionType>;
  refrenceNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type FleetTransactionMaxAggregate = {
  __typename?: "FleetTransactionMaxAggregate";
  action?: Maybe<TransactionAction>;
  deductType?: Maybe<ProviderDeductTransactionType>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<ProviderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type FleetTransactionMinAggregate = {
  __typename?: "FleetTransactionMinAggregate";
  action?: Maybe<TransactionAction>;
  deductType?: Maybe<ProviderDeductTransactionType>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<ProviderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type FleetTransactionSort = {
  direction: SortDirection;
  field: FleetTransactionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum FleetTransactionSortFields {
  Action = "action",
  DeductType = "deductType",
  FleetId = "fleetId",
  Id = "id",
  OperatorId = "operatorId",
  RechargeType = "rechargeType",
  RequestId = "requestId",
  Status = "status",
}

export type FleetTransactionSumAggregate = {
  __typename?: "FleetTransactionSumAggregate";
  fleetId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  requestId?: Maybe<Scalars["Float"]["output"]>;
};

export type FleetTransactionsConnection = {
  __typename?: "FleetTransactionsConnection";
  /** Array of nodes. */
  nodes: Array<FleetTransaction>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type FleetWallet = {
  __typename?: "FleetWallet";
  balance: Scalars["Float"]["output"];
  currency: Scalars["String"]["output"];
  fleet: Fleet;
  fleetId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
};

export type FleetWalletAggregateFilter = {
  and?: InputMaybe<Array<FleetWalletAggregateFilter>>;
  balance?: InputMaybe<FloatFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  fleetId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<FleetWalletAggregateFilter>>;
};

export type FleetWalletAggregateGroupBy = {
  __typename?: "FleetWalletAggregateGroupBy";
  balance?: Maybe<Scalars["Float"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type FleetWalletAggregateResponse = {
  __typename?: "FleetWalletAggregateResponse";
  avg?: Maybe<FleetWalletAvgAggregate>;
  count?: Maybe<FleetWalletCountAggregate>;
  groupBy?: Maybe<FleetWalletAggregateGroupBy>;
  max?: Maybe<FleetWalletMaxAggregate>;
  min?: Maybe<FleetWalletMinAggregate>;
  sum?: Maybe<FleetWalletSumAggregate>;
};

export type FleetWalletAvgAggregate = {
  __typename?: "FleetWalletAvgAggregate";
  balance?: Maybe<Scalars["Float"]["output"]>;
  fleetId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type FleetWalletConnection = {
  __typename?: "FleetWalletConnection";
  /** Array of nodes. */
  nodes: Array<FleetWallet>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type FleetWalletCountAggregate = {
  __typename?: "FleetWalletCountAggregate";
  balance?: Maybe<Scalars["Int"]["output"]>;
  currency?: Maybe<Scalars["Int"]["output"]>;
  fleetId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
};

export type FleetWalletFilter = {
  and?: InputMaybe<Array<FleetWalletFilter>>;
  balance?: InputMaybe<FloatFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  fleetId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<FleetWalletFilter>>;
};

export type FleetWalletMaxAggregate = {
  __typename?: "FleetWalletMaxAggregate";
  balance?: Maybe<Scalars["Float"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type FleetWalletMinAggregate = {
  __typename?: "FleetWalletMinAggregate";
  balance?: Maybe<Scalars["Float"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type FleetWalletSort = {
  direction: SortDirection;
  field: FleetWalletSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum FleetWalletSortFields {
  Balance = "balance",
  Currency = "currency",
  FleetId = "fleetId",
  Id = "id",
}

export type FleetWalletSumAggregate = {
  __typename?: "FleetWalletSumAggregate";
  balance?: Maybe<Scalars["Float"]["output"]>;
  fleetId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type FleetZonePricesConnection = {
  __typename?: "FleetZonePricesConnection";
  /** Array of nodes. */
  nodes: Array<ZonePrice>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type FloatFieldComparison = {
  between?: InputMaybe<FloatFieldComparisonBetween>;
  eq?: InputMaybe<Scalars["Float"]["input"]>;
  gt?: InputMaybe<Scalars["Float"]["input"]>;
  gte?: InputMaybe<Scalars["Float"]["input"]>;
  in?: InputMaybe<Array<Scalars["Float"]["input"]>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  lt?: InputMaybe<Scalars["Float"]["input"]>;
  lte?: InputMaybe<Scalars["Float"]["input"]>;
  neq?: InputMaybe<Scalars["Float"]["input"]>;
  notBetween?: InputMaybe<FloatFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars["Float"]["input"]>>;
};

export type FloatFieldComparisonBetween = {
  lower: Scalars["Float"]["input"];
  upper: Scalars["Float"]["input"];
};

/** Method of connecting to a payout or saved payment method. */
export enum GatewayLinkMethod {
  Manual = "manual",
  None = "none",
  Redirect = "redirect",
}

export enum Gender {
  Female = "Female",
  Male = "Male",
  Other = "Other",
  Unknown = "Unknown",
}

export type GenderDistribution = {
  __typename?: "GenderDistribution";
  count: Scalars["Int"]["output"];
  gender: Gender;
};

export type GenderFilterComparison = {
  eq?: InputMaybe<Gender>;
  gt?: InputMaybe<Gender>;
  gte?: InputMaybe<Gender>;
  iLike?: InputMaybe<Gender>;
  in?: InputMaybe<Array<Gender>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<Gender>;
  lt?: InputMaybe<Gender>;
  lte?: InputMaybe<Gender>;
  neq?: InputMaybe<Gender>;
  notILike?: InputMaybe<Gender>;
  notIn?: InputMaybe<Array<Gender>>;
  notLike?: InputMaybe<Gender>;
};

export enum GeoProvider {
  Google = "GOOGLE",
  Mapbox = "MAPBOX",
  Nominatim = "NOMINATIM",
}

export type GiftBatch = {
  __typename?: "GiftBatch";
  amount: Scalars["Float"]["output"];
  availableFrom?: Maybe<Scalars["DateTime"]["output"]>;
  currency: Scalars["String"]["output"];
  expireAt?: Maybe<Scalars["DateTime"]["output"]>;
  giftCodes: GiftBatchGiftCodesConnection;
  giftCodesAggregate: Array<GiftBatchGiftCodesAggregateResponse>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type GiftBatchGiftCodesArgs = {
  filter?: GiftCodeFilter;
  paging?: OffsetPaging;
  sorting?: Array<GiftCodeSort>;
};

export type GiftBatchGiftCodesAggregateArgs = {
  filter?: InputMaybe<GiftCodeAggregateFilter>;
};

export type GiftBatchConnection = {
  __typename?: "GiftBatchConnection";
  /** Array of nodes. */
  nodes: Array<GiftBatch>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type GiftBatchFilter = {
  and?: InputMaybe<Array<GiftBatchFilter>>;
  currency?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<GiftBatchFilter>>;
};

export type GiftBatchGiftCodesAggregateGroupBy = {
  __typename?: "GiftBatchGiftCodesAggregateGroupBy";
  giftId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  usedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type GiftBatchGiftCodesAggregateResponse = {
  __typename?: "GiftBatchGiftCodesAggregateResponse";
  avg?: Maybe<GiftBatchGiftCodesAvgAggregate>;
  count?: Maybe<GiftBatchGiftCodesCountAggregate>;
  groupBy?: Maybe<GiftBatchGiftCodesAggregateGroupBy>;
  max?: Maybe<GiftBatchGiftCodesMaxAggregate>;
  min?: Maybe<GiftBatchGiftCodesMinAggregate>;
  sum?: Maybe<GiftBatchGiftCodesSumAggregate>;
};

export type GiftBatchGiftCodesAvgAggregate = {
  __typename?: "GiftBatchGiftCodesAvgAggregate";
  giftId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type GiftBatchGiftCodesConnection = {
  __typename?: "GiftBatchGiftCodesConnection";
  /** Array of nodes. */
  nodes: Array<GiftCode>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type GiftBatchGiftCodesCountAggregate = {
  __typename?: "GiftBatchGiftCodesCountAggregate";
  giftId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  usedAt?: Maybe<Scalars["Int"]["output"]>;
};

export type GiftBatchGiftCodesMaxAggregate = {
  __typename?: "GiftBatchGiftCodesMaxAggregate";
  giftId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  usedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type GiftBatchGiftCodesMinAggregate = {
  __typename?: "GiftBatchGiftCodesMinAggregate";
  giftId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  usedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type GiftBatchGiftCodesSumAggregate = {
  __typename?: "GiftBatchGiftCodesSumAggregate";
  giftId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type GiftBatchSort = {
  direction: SortDirection;
  field: GiftBatchSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum GiftBatchSortFields {
  Currency = "currency",
  Id = "id",
  Name = "name",
}

export type GiftCode = {
  __typename?: "GiftCode";
  code: Scalars["String"]["output"];
  driverTransaction?: Maybe<DriverTransaction>;
  giftId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  riderTransaction?: Maybe<RiderTransaction>;
  usedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type GiftCodeAggregateFilter = {
  and?: InputMaybe<Array<GiftCodeAggregateFilter>>;
  giftId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<GiftCodeAggregateFilter>>;
  usedAt?: InputMaybe<DateFieldComparison>;
};

export type GiftCodeConnection = {
  __typename?: "GiftCodeConnection";
  /** Array of nodes. */
  nodes: Array<GiftCode>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type GiftCodeFilter = {
  and?: InputMaybe<Array<GiftCodeFilter>>;
  giftId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<GiftCodeFilter>>;
  usedAt?: InputMaybe<DateFieldComparison>;
};

export type GiftCodeSort = {
  direction: SortDirection;
  field: GiftCodeSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum GiftCodeSortFields {
  GiftId = "giftId",
  Id = "id",
  UsedAt = "usedAt",
}

/** Group by */
export enum GroupBy {
  Day = "DAY",
  Month = "MONTH",
  Week = "WEEK",
  Year = "YEAR",
}

export type IdFilterComparison = {
  eq?: InputMaybe<Scalars["ID"]["input"]>;
  gt?: InputMaybe<Scalars["ID"]["input"]>;
  gte?: InputMaybe<Scalars["ID"]["input"]>;
  iLike?: InputMaybe<Scalars["ID"]["input"]>;
  in?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<Scalars["ID"]["input"]>;
  lt?: InputMaybe<Scalars["ID"]["input"]>;
  lte?: InputMaybe<Scalars["ID"]["input"]>;
  neq?: InputMaybe<Scalars["ID"]["input"]>;
  notILike?: InputMaybe<Scalars["ID"]["input"]>;
  notIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  notLike?: InputMaybe<Scalars["ID"]["input"]>;
};

export type IncomeResultItem = {
  __typename?: "IncomeResultItem";
  currency: Scalars["String"]["output"];
  sum: Scalars["Float"]["output"];
  time: Scalars["String"]["output"];
};

export type IntFieldComparison = {
  between?: InputMaybe<IntFieldComparisonBetween>;
  eq?: InputMaybe<Scalars["Int"]["input"]>;
  gt?: InputMaybe<Scalars["Int"]["input"]>;
  gte?: InputMaybe<Scalars["Int"]["input"]>;
  in?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  lt?: InputMaybe<Scalars["Int"]["input"]>;
  lte?: InputMaybe<Scalars["Int"]["input"]>;
  neq?: InputMaybe<Scalars["Int"]["input"]>;
  notBetween?: InputMaybe<IntFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type IntFieldComparisonBetween = {
  lower: Scalars["Int"]["input"];
  upper: Scalars["Int"]["input"];
};

export type IntegrationRuntimeConfiguration = {
  __typename?: "IntegrationRuntimeConfiguration";
  desktopAlerts: AdminDesktopAlertRuntimeConfiguration;
  telematics: TelematicsRuntimeConfiguration;
};

export type IntegrationRuntimePolicyRevision = {
  __typename?: "IntegrationRuntimePolicyRevision";
  actorOperatorId?: Maybe<Scalars["ID"]["output"]>;
  changedAt: Scalars["DateTime"]["output"];
  changedFields: Array<Scalars["String"]["output"]>;
  expiresAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  newValuesJson: Scalars["String"]["output"];
  newVersion: Scalars["Int"]["output"];
  policyType: IntegrationRuntimePolicyType;
  previousValuesJson: Scalars["String"]["output"];
  priorVersion: Scalars["Int"]["output"];
  reason: Scalars["String"]["output"];
  scopeId: Scalars["String"]["output"];
};

export enum IntegrationRuntimePolicySource {
  Database = "Database",
  Env = "Env",
  Invalid = "Invalid",
}

export enum IntegrationRuntimePolicyType {
  AdminDesktopAlerts = "AdminDesktopAlerts",
  Telematics = "Telematics",
}

export type KpiAppBreakdown = {
  __typename?: "KPIAppBreakdown";
  /** Application key or enum value (e.g., "taxi") */
  app: AppType;
  /** Percentage share of the KPI that belongs to this app */
  percentage: Scalars["Float"]["output"];
  /** Value for this app in the current time period */
  value: Scalars["Float"]["output"];
};

/** KPI period for the platform overview */
export enum KpiPeriod {
  AllTime = "AllTime",
  Last7Days = "Last7Days",
  Last30Days = "Last30Days",
  Last90Days = "Last90Days",
  Last365Days = "Last365Days",
}

export type LeaderboardItem = {
  __typename?: "LeaderboardItem";
  avatarUrl?: Maybe<Scalars["String"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  totalAmount?: Maybe<Scalars["Float"]["output"]>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type ManualPayoutInput = {
  /** Fill this with the user's app type. Taxi for a driver. */
  appType?: AppType;
  description?: InputMaybe<Scalars["String"]["input"]>;
  transactionNumber: Scalars["String"]["input"];
  userTransactionId: Scalars["ID"]["input"];
};

export type Media = {
  __typename?: "Media";
  address: Scalars["String"]["output"];
  base64?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
};

export type MediaAggregateFilter = {
  and?: InputMaybe<Array<MediaAggregateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<MediaAggregateFilter>>;
};

export type MediaEdge = {
  __typename?: "MediaEdge";
  /** Cursor for this node. */
  cursor: Scalars["ConnectionCursor"]["output"];
  /** The node containing the Media */
  node: Media;
};

export type MediaFilter = {
  and?: InputMaybe<Array<MediaFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<MediaFilter>>;
};

export type MediaSort = {
  direction: SortDirection;
  field: MediaSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum MediaSortFields {
  Id = "id",
}

export enum MessageStatus {
  Delivered = "Delivered",
  Seen = "Seen",
  Sent = "Sent",
}

export type Mutation = {
  __typename?: "Mutation";
  acknowledgeAdminNotificationEvent: Scalars["Boolean"]["output"];
  acknowledgeTelematicsAlert: TelematicsAlertDto;
  addCommentToTaxiSupportRequest: TaxiSupportRequestActivity;
  addFleetsToZonePrice: ZonePrice;
  addOptionsToService: Service;
  addRegionsToService: Service;
  addServicesToZonePrice: ZonePrice;
  adjustOrderFinalPrice: OrderFinalPriceAdjustment;
  adminResetOperatorPassword: Scalars["Boolean"]["output"];
  applyTelematicsRuntimePreset: IntegrationRuntimeConfiguration;
  archiveDriver: Driver;
  assignDriverToOrder: Order;
  assignScheduledRide: Scalars["Boolean"]["output"];
  assignTaxiSupportRequestToStaff: TaxiSupportRequestActivity;
  assignVehicleToDriver: DriverVehicleAssignment;
  beginRiderWhatsAppSignup: RiderWhatsAppSignupSession;
  cancelOrder: Order;
  cancelRiderWhatsAppSignup: Scalars["Boolean"]["output"];
  cancelScheduledRideByAdmin: Scalars["Boolean"]["output"];
  changeTaxiSupportRequestStatus: TaxiSupportRequestActivity;
  /** Close a cash Rider booking setup review only after the order ended. Preserves receipts and does not retry, cancel or settle a trip. */
  closeRiderBookingReview: Scalars["Boolean"]["output"];
  completeRiderWhatsAppSignup: Scalars["Boolean"]["output"];
  confirmTelematicsAlert: TelematicsAlertDto;
  createAndReserveDriverAfterCurrentTrip: CreateAndReserveDriverAfterCurrentTripResultDto;
  createAnnouncement: Announcement;
  createCampaign: Campaign;
  createCommissionPartner: CommissionPartnerDto;
  createDispatcherGuestCustomer: Rider;
  createDispatcherRegisteredCustomer: Rider;
  createDriverClosingDraft: DriverClosingRecordDto;
  createDriverTransaction: DriverWallet;
  createFleetTransaction: FleetWallet;
  createGiftCardBatch: GiftBatch;
  createManyDriverDocumentRetentionPolicies: Array<DriverDocumentRetentionPolicy>;
  createManyDriverDocuments: Array<DriverDocument>;
  createManyDriverShiftRules: Array<DriverShiftRule>;
  createManyEmailProviders: Array<EmailProvider>;
  createManyEmailTemplates: Array<EmailTemplate>;
  createManySMS: Array<Sms>;
  createManySMSProviders: Array<SmsProvider>;
  createOneCarColor: CarColor;
  createOneCarModel: CarModel;
  createOneCoupon: Coupon;
  createOneCustomerNote: CustomerNote;
  createOneDriver: Driver;
  createOneDriverDocument: DriverDocument;
  createOneDriverDocumentRetentionPolicy: DriverDocumentRetentionPolicy;
  createOneDriverNote: DriverNote;
  createOneDriverShiftRule: DriverShiftRule;
  createOneDriverToDriverDocument: DriverToDriverDocument;
  createOneDriverTransaction: DriverTransaction;
  createOneEmailProvider: EmailProvider;
  createOneEmailTemplate: EmailTemplate;
  createOneFeedbackParameter: FeedbackParameter;
  createOneFleet: Fleet;
  createOneFleetStaff: FleetStaff;
  createOneOperator: Operator;
  createOneOperatorRole: OperatorRole;
  createOneOrderCancelReason: OrderCancelReason;
  createOnePaymentGateway: PaymentGateway;
  createOnePayoutMethod: PayoutMethod;
  createOneProviderTransaction: ProviderTransaction;
  createOneRegion: Region;
  createOneRegionCategory: RegionCategory;
  createOneReward: Reward;
  createOneRider: Rider;
  createOneRiderAddress: RiderAddress;
  createOneRiderTransaction: RiderTransaction;
  createOneSMS: Sms;
  createOneSMSProvider: SmsProvider;
  createOneSOSActivity: SosActivity;
  createOneSOSReason: SosReason;
  createOneService: Service;
  createOneServiceCategory: ServiceCategory;
  createOneServiceOption: ServiceOption;
  createOneServiceTariffProfile: ServiceTariffProfile;
  createOneTariffProfile: TariffProfile;
  createOneTaxiSupportRequestActivity: TaxiSupportRequestActivity;
  createOneZoneMultiplier: ZoneMultiplier;
  createOneZonePrice: ZonePrice;
  createOneZonePriceCategory: ZonePriceCategory;
  createOrder: Order;
  createRiderTransaction: RiderWallet;
  createTaxiOrderNote: TaxiOrderNote;
  createTaxiPayoutSession: TaxiPayoutSession;
  createTelematicsProfileVersion: TelematicsProfile;
  createVehicle: Vehicle;
  createVehicleTelematicsMapping: VehicleTelematicsMapping;
  deleteCommissionPartner: Scalars["Boolean"]["output"];
  deleteDriverClosingDraft: Scalars["Boolean"]["output"];
  deleteDriverClosingRecord: Scalars["Boolean"]["output"];
  deleteManyDriverDocumentRetentionPolicies: DeleteManyResponse;
  deleteManyDriverDocuments: DeleteManyResponse;
  deleteManyDriverShiftRules: DeleteManyResponse;
  deleteManyEmailProviders: DeleteManyResponse;
  deleteManyEmailTemplates: DeleteManyResponse;
  deleteManyEmails: DeleteManyResponse;
  deleteManySMS: DeleteManyResponse;
  deleteManySMSProviders: DeleteManyResponse;
  deleteOneAnnouncement: AnnouncementDeleteResponse;
  deleteOneCampaign: CampaignDeleteResponse;
  deleteOneCarColor: CarColorDeleteResponse;
  deleteOneCarModel: CarModelDeleteResponse;
  deleteOneCoupon: CouponDeleteResponse;
  deleteOneCustomerSession: CustomerSessionDeleteResponse;
  deleteOneDriver: Driver;
  deleteOneDriverDocument: DriverDocumentDeleteResponse;
  deleteOneDriverDocumentRetentionPolicy: DriverDocumentRetentionPolicyDeleteResponse;
  deleteOneDriverSession: DriverSessionDeleteResponse;
  deleteOneDriverShiftRule: DriverShiftRuleDeleteResponse;
  deleteOneDriverToDriverDocument: DriverToDriverDocumentDeleteResponse;
  deleteOneEmail: EmailDeleteResponse;
  deleteOneEmailProvider: EmailProviderDeleteResponse;
  deleteOneEmailTemplate: EmailTemplateDeleteResponse;
  deleteOneFeedbackParameter: FeedbackParameterDeleteResponse;
  deleteOneFleet: FleetDeleteResponse;
  deleteOneFleetStaff: FleetStaffDeleteResponse;
  deleteOneOperator: OperatorDeleteResponse;
  deleteOneOperatorRole: OperatorRoleDeleteResponse;
  deleteOneOrderCancelReason: OrderCancelReasonDeleteResponse;
  deleteOnePaymentGateway: PaymentGatewayDeleteResponse;
  deleteOnePayoutMethod: PayoutMethodDeleteResponse;
  deleteOneRegion: RegionDeleteResponse;
  deleteOneRegionCategory: RegionCategoryDeleteResponse;
  deleteOneReward: RewardDeleteResponse;
  deleteOneRider: Rider;
  deleteOneSMS: SmsDeleteResponse;
  deleteOneSMSProvider: SmsProviderDeleteResponse;
  deleteOneSOSReason: SosReasonDeleteResponse;
  deleteOneSavedPaymentMethod: SavedPaymentMethodDeleteResponse;
  deleteOneService: ServiceDeleteResponse;
  deleteOneServiceCategory: ServiceCategoryDeleteResponse;
  deleteOneServiceOption: ServiceOptionDeleteResponse;
  deleteOneServiceTariffProfile: ServiceTariffProfileDeleteResponse;
  deleteOneTariffProfile: TariffProfileDeleteResponse;
  deleteOneZoneMultiplier: ZoneMultiplierDeleteResponse;
  deleteOneZonePrice: ZonePriceDeleteResponse;
  deleteOneZonePriceCategory: ZonePriceCategoryDeleteResponse;
  disableAllIntegrationRuntime: IntegrationRuntimeConfiguration;
  disconnectRiderWhatsApp: RiderWhatsAppSettings;
  dismissAdminNotificationEvent: Scalars["Boolean"]["output"];
  dismissTelematicsAlert: TelematicsAlertDto;
  emergencyDispatchScheduledRide: Scalars["Boolean"]["output"];
  endVehicleTelematicsMapping: VehicleTelematicsMapping;
  exchangeRiderWhatsAppSignup: Array<Scalars["String"]["output"]>;
  exportDriverTripReportToExcel: ExportResult;
  exportGiftCardBatch: Scalars["String"]["output"];
  exportTaxiPayoutSessionToCsv: Scalars["String"]["output"];
  finalizeDriverClosingRecord: DriverClosingRecordDto;
  forceCancelTaxiOrder: Order;
  markAsRead: Scalars["Boolean"]["output"];
  markEmailProviderAsDefault: EmailProvider;
  markSMSProviderAsDefault: SmsProvider;
  markTelematicsAlertExplained: TelematicsAlertDto;
  openAdminNotificationEvent: Scalars["Boolean"]["output"];
  queueDispatcherOrderForNextAvailable: Order;
  rebuildTelematicsLatestCache: TelematicsOperationResult;
  reencryptLegacyTelematicsProviderSecret: TelematicsProviderSetting;
  reopenDriverClosingRecord: DriverClosingRecordDto;
  replaceVehicleTelematicsMapping: VehicleTelematicsMapping;
  rescheduleScheduledRideByAdmin: Scalars["Boolean"]["output"];
  reserveDriverAfterCurrentTrip: Order;
  resolveTelematicsAlert: TelematicsAlertDto;
  restoreArchivedDriver: Driver;
  revokeAdminBrowserPushRegistration: Scalars["Boolean"]["output"];
  riderWhatsAppSignupPhones: Array<RiderWhatsAppSignupPhone>;
  runTaxiAutoPayout: Scalars["Boolean"]["output"];
  runTelematicsEvidenceReconciliation: TelematicsOperationResult;
  runTelematicsRetentionCleanup: TelematicsRetentionResultDto;
  runTelematicsRetentionDryRun: TelematicsRetentionResultDto;
  /** @deprecated Use updateConfigurations instead */
  saveConfiguration: CurrentConfiguration;
  saveRiderDisplaySettings: RiderDisplaySettings;
  saveRiderWhatsAppSettings: RiderWhatsAppSettings;
  saveServiceDistanceBands: Array<ServiceDistanceBand>;
  saveZonePriceProfileFares: Array<ZonePriceProfileFare>;
  sendMyAdminDesktopTestPush: AdminDesktopTestPushResultDto;
  setActivatedServicesOnDriver: Scalars["Boolean"]["output"];
  setCommissionPartnerActive: CommissionPartnerDto;
  setFleetsOnZonePrice: ZonePrice;
  setOptionsOnService: Service;
  setRegionsOnService: Service;
  setRiderWhatsAppEnabled: RiderWhatsAppSettings;
  setServicesOnZonePrice: ZonePrice;
  setTelematicsProfileActive: TelematicsProfile;
  setTelematicsProviderSecret: TelematicsProviderSetting;
  startTelematicsAlertReview: TelematicsAlertDto;
  taxiManualPayout: DriverTransaction;
  terminateCustomerLoginSession: Scalars["Boolean"]["output"];
  terminateDriverLoginSession: Scalars["Boolean"]["output"];
  terminateFleetStaffSession: Scalars["Boolean"]["output"];
  terminateStaffSession: Scalars["Boolean"]["output"];
  testTelematicsProviderConnection: TelematicsOperationResult;
  updateAdminBrowserPushPreferences: AdminBrowserPushRegistration;
  updateAdminDesktopAlertRuntimePolicy: IntegrationRuntimeConfiguration;
  updateCommissionPartner: CommissionPartnerDto;
  updateConfigurations: UpdateConfigResult;
  updateDispatchConfig: DispatchConfig;
  updateDispatchPolicy: DispatchPolicy;
  updateDriverClosingDraft: DriverClosingRecordDto;
  updateDriverStatus: Driver;
  updateFcmToken: Scalars["Boolean"]["output"];
  /** @deprecated Use updateConfigurations instead */
  updateFirebase: UpdateConfigResult;
  updateFixedFareRoutingMode: FixedFareRoutingSettings;
  updateManyDriverDocumentRetentionPolicies: UpdateManyResponse;
  updateManyDriverDocuments: UpdateManyResponse;
  updateManyDriverShiftRules: UpdateManyResponse;
  updateManyEmailProviders: UpdateManyResponse;
  updateManyEmailTemplates: UpdateManyResponse;
  updateManyRiderAddresses: UpdateManyResponse;
  updateManySMS: UpdateManyResponse;
  updateManySMSProviders: UpdateManyResponse;
  /** @deprecated Use updateConfigurations instead */
  updateMapsAPIKey: UpdateConfigResult;
  updateOneAnnouncement: Announcement;
  updateOneCarColor: CarColor;
  updateOneCarModel: CarModel;
  updateOneCoupon: Coupon;
  updateOneDistressSignal: DistressSignal;
  updateOneDriver: Driver;
  updateOneDriverDocument: DriverDocument;
  updateOneDriverDocumentRetentionPolicy: DriverDocumentRetentionPolicy;
  updateOneDriverShiftRule: DriverShiftRule;
  updateOneDriverToDriverDocument: DriverToDriverDocument;
  updateOneEmailProvider: EmailProvider;
  updateOneEmailTemplate: EmailTemplate;
  updateOneFeedback: Feedback;
  updateOneFeedbackParameter: FeedbackParameter;
  updateOneFleet: Fleet;
  updateOneFleetStaff: FleetStaff;
  updateOneOperator: Operator;
  updateOneOperatorRole: OperatorRole;
  updateOneOrderCancelReason: OrderCancelReason;
  updateOnePaymentGateway: PaymentGateway;
  updateOnePayoutMethod: PayoutMethod;
  updateOneRegion: Region;
  updateOneRegionCategory: RegionCategory;
  updateOneReward: Reward;
  updateOneRider: Rider;
  updateOneRiderAddress: RiderAddress;
  updateOneSMS: Sms;
  updateOneSMSProvider: SmsProvider;
  updateOneSOSReason: SosReason;
  updateOneService: Service;
  updateOneServiceCategory: ServiceCategory;
  updateOneServiceOption: ServiceOption;
  updateOneServiceTariffProfile: ServiceTariffProfile;
  updateOneTariffProfile: TariffProfile;
  updateOneTaxiPayoutSession: TaxiPayoutSession;
  updateOneTaxiSupportRequest: TaxiSupportRequest;
  updateOneZoneMultiplier: ZoneMultiplier;
  updateOneZonePrice: ZonePrice;
  updateOneZonePriceCategory: ZonePriceCategory;
  updatePassword: Operator;
  updateProfile: Operator;
  updateTelematicsRuntimePolicy: TelematicsRuntimeConfiguration;
  updateVehicle: Vehicle;
  upsertAdminBrowserPushRegistration: AdminBrowserPushRegistration;
  upsertTelematicsProviderSetting: TelematicsProviderSetting;
  useCurrentDriverClosingCommissionRate: DriverClosingRecordDto;
  validateRiderWhatsAppSettings: RiderWhatsAppSettings;
};

export type MutationAcknowledgeAdminNotificationEventArgs = {
  eventId: Scalars["String"]["input"];
};

export type MutationAcknowledgeTelematicsAlertArgs = {
  input: TelematicsAlertReviewInput;
};

export type MutationAddCommentToTaxiSupportRequestArgs = {
  input: CreateTaxiSupportRequestCommentInput;
};

export type MutationAddFleetsToZonePriceArgs = {
  input: AddFleetsToZonePriceInput;
};

export type MutationAddOptionsToServiceArgs = {
  input: AddOptionsToServiceInput;
};

export type MutationAddRegionsToServiceArgs = {
  input: AddRegionsToServiceInput;
};

export type MutationAddServicesToZonePriceArgs = {
  input: AddServicesToZonePriceInput;
};

export type MutationAdjustOrderFinalPriceArgs = {
  newAmount: Scalars["Float"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  orderId: Scalars["ID"]["input"];
  reason: Scalars["String"]["input"];
};

export type MutationAdminResetOperatorPasswordArgs = {
  input: AdminResetOperatorPasswordInput;
};

export type MutationApplyTelematicsRuntimePresetArgs = {
  input: ApplyTelematicsRuntimePresetInput;
};

export type MutationArchiveDriverArgs = {
  id: Scalars["ID"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  reason: Scalars["String"]["input"];
};

export type MutationAssignDriverToOrderArgs = {
  driverId: Scalars["ID"]["input"];
  orderId: Scalars["ID"]["input"];
};

export type MutationAssignScheduledRideArgs = {
  driverId: Scalars["ID"]["input"];
  orderId: Scalars["ID"]["input"];
  reason?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationAssignTaxiSupportRequestToStaffArgs = {
  input: AssignTaxiSupportRequestInput;
};

export type MutationAssignVehicleToDriverArgs = {
  input: AssignVehicleToDriverInput;
};

export type MutationBeginRiderWhatsAppSignupArgs = {
  expectedVersion: Scalars["Int"]["input"];
};

export type MutationCancelOrderArgs = {
  orderId: Scalars["ID"]["input"];
};

export type MutationCancelRiderWhatsAppSignupArgs = {
  nonce: Scalars["String"]["input"];
};

export type MutationCancelScheduledRideByAdminArgs = {
  orderId: Scalars["ID"]["input"];
  reason?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationChangeTaxiSupportRequestStatusArgs = {
  input: ChangeTaxiSupportRequestStatusInput;
};

export type MutationCloseRiderBookingReviewArgs = {
  expectedStatus: Scalars["String"]["input"];
  orderId: Scalars["ID"]["input"];
  reason: Scalars["String"]["input"];
};

export type MutationCompleteRiderWhatsAppSignupArgs = {
  language: Scalars["String"]["input"];
  nonce: Scalars["String"]["input"];
  phoneNumberId: Scalars["String"]["input"];
  template: Scalars["String"]["input"];
};

export type MutationConfirmTelematicsAlertArgs = {
  input: TelematicsAlertReviewInput;
};

export type MutationCreateAndReserveDriverAfterCurrentTripArgs = {
  input: CreateAndReserveDriverAfterCurrentTripInput;
};

export type MutationCreateAnnouncementArgs = {
  input: CreateAnnouncementInput;
};

export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};

export type MutationCreateCommissionPartnerArgs = {
  input: CommissionPartnerInput;
};

export type MutationCreateDispatcherGuestCustomerArgs = {
  input: CreateDispatcherGuestCustomerInput;
};

export type MutationCreateDispatcherRegisteredCustomerArgs = {
  input: CreateDispatcherRegisteredCustomerInput;
};

export type MutationCreateDriverClosingDraftArgs = {
  input: DriverClosingDraftInput;
};

export type MutationCreateDriverTransactionArgs = {
  input: DriverTransactionInput;
};

export type MutationCreateFleetTransactionArgs = {
  input: FleetTransactionInput;
};

export type MutationCreateGiftCardBatchArgs = {
  input: CreateGiftBatchInput;
};

export type MutationCreateManyDriverDocumentRetentionPoliciesArgs = {
  input: CreateManyDriverDocumentRetentionPoliciesInput;
};

export type MutationCreateManyDriverDocumentsArgs = {
  input: CreateManyDriverDocumentsInput;
};

export type MutationCreateManyDriverShiftRulesArgs = {
  input: CreateManyDriverShiftRulesInput;
};

export type MutationCreateManyEmailProvidersArgs = {
  input: CreateManyEmailProvidersInput;
};

export type MutationCreateManyEmailTemplatesArgs = {
  input: CreateManyEmailTemplatesInput;
};

export type MutationCreateManySmsArgs = {
  input: CreateManySmsInput;
};

export type MutationCreateManySmsProvidersArgs = {
  input: CreateManySmsProvidersInput;
};

export type MutationCreateOneCarColorArgs = {
  input: CreateOneCarColorInput;
};

export type MutationCreateOneCarModelArgs = {
  input: CreateOneCarModelInput;
};

export type MutationCreateOneCouponArgs = {
  input: CreateOneCouponInput;
};

export type MutationCreateOneCustomerNoteArgs = {
  input: CreateOneCustomerNoteInput;
};

export type MutationCreateOneDriverArgs = {
  input: CreateOneDriverInput;
};

export type MutationCreateOneDriverDocumentArgs = {
  input: CreateOneDriverDocumentInput;
};

export type MutationCreateOneDriverDocumentRetentionPolicyArgs = {
  input: CreateOneDriverDocumentRetentionPolicyInput;
};

export type MutationCreateOneDriverNoteArgs = {
  input: CreateOneDriverNoteInput;
};

export type MutationCreateOneDriverShiftRuleArgs = {
  input: CreateOneDriverShiftRuleInput;
};

export type MutationCreateOneDriverToDriverDocumentArgs = {
  input: CreateOneDriverToDriverDocumentInput;
};

export type MutationCreateOneDriverTransactionArgs = {
  input: CreateOneDriverTransactionInput;
};

export type MutationCreateOneEmailProviderArgs = {
  input: CreateOneEmailProviderInput;
};

export type MutationCreateOneEmailTemplateArgs = {
  input: CreateOneEmailTemplateInput;
};

export type MutationCreateOneFeedbackParameterArgs = {
  input: CreateOneFeedbackParameterInput;
};

export type MutationCreateOneFleetArgs = {
  input: CreateOneFleetInput;
};

export type MutationCreateOneFleetStaffArgs = {
  input: CreateOneFleetStaffInput;
};

export type MutationCreateOneOperatorArgs = {
  input: CreateOneOperatorInput;
};

export type MutationCreateOneOperatorRoleArgs = {
  input: CreateOneOperatorRoleInput;
};

export type MutationCreateOneOrderCancelReasonArgs = {
  input: CreateOneOrderCancelReasonInput;
};

export type MutationCreateOnePaymentGatewayArgs = {
  input: CreateOnePaymentGatewayInput;
};

export type MutationCreateOnePayoutMethodArgs = {
  input: CreateOnePayoutMethodInput;
};

export type MutationCreateOneProviderTransactionArgs = {
  input: CreateOneProviderTransactionInput;
};

export type MutationCreateOneRegionArgs = {
  input: CreateOneRegionInput;
};

export type MutationCreateOneRegionCategoryArgs = {
  input: CreateOneRegionCategoryInput;
};

export type MutationCreateOneRewardArgs = {
  input: CreateOneRewardInput;
};

export type MutationCreateOneRiderArgs = {
  input: CreateOneRiderInput;
};

export type MutationCreateOneRiderAddressArgs = {
  input: CreateOneRiderAddressInput;
};

export type MutationCreateOneRiderTransactionArgs = {
  input: CreateOneRiderTransactionInput;
};

export type MutationCreateOneSmsArgs = {
  input: CreateOneSmsInput;
};

export type MutationCreateOneSmsProviderArgs = {
  input: CreateOneSmsProviderInput;
};

export type MutationCreateOneSosActivityArgs = {
  input: CreateOneSosActivityInput;
};

export type MutationCreateOneSosReasonArgs = {
  input: CreateOneSosReasonInput;
};

export type MutationCreateOneServiceArgs = {
  input: CreateOneServiceInput;
};

export type MutationCreateOneServiceCategoryArgs = {
  input: CreateOneServiceCategoryInput;
};

export type MutationCreateOneServiceOptionArgs = {
  input: CreateOneServiceOptionInput;
};

export type MutationCreateOneServiceTariffProfileArgs = {
  input: CreateOneServiceTariffProfileInput;
};

export type MutationCreateOneTariffProfileArgs = {
  input: CreateOneTariffProfileInput;
};

export type MutationCreateOneTaxiSupportRequestActivityArgs = {
  input: CreateOneTaxiSupportRequestActivityInput;
};

export type MutationCreateOneZoneMultiplierArgs = {
  input: CreateOneZoneMultiplierInput;
};

export type MutationCreateOneZonePriceArgs = {
  input: CreateOneZonePriceInput;
};

export type MutationCreateOneZonePriceCategoryArgs = {
  input: CreateOneZonePriceCategoryInput;
};

export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};

export type MutationCreateRiderTransactionArgs = {
  input: RiderTransactionInput;
};

export type MutationCreateTaxiOrderNoteArgs = {
  input: CreateTaxiOrderNoteInput;
};

export type MutationCreateTaxiPayoutSessionArgs = {
  input: CreatePayoutSessionInput;
};

export type MutationCreateTelematicsProfileVersionArgs = {
  input: CreateTelematicsProfileVersionInput;
};

export type MutationCreateVehicleArgs = {
  input: CreateVehicleInput;
};

export type MutationCreateVehicleTelematicsMappingArgs = {
  input: CreateVehicleTelematicsMappingInput;
};

export type MutationDeleteCommissionPartnerArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteDriverClosingDraftArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteDriverClosingRecordArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteManyDriverDocumentRetentionPoliciesArgs = {
  input: DeleteManyDriverDocumentRetentionPoliciesInput;
};

export type MutationDeleteManyDriverDocumentsArgs = {
  input: DeleteManyDriverDocumentsInput;
};

export type MutationDeleteManyDriverShiftRulesArgs = {
  input: DeleteManyDriverShiftRulesInput;
};

export type MutationDeleteManyEmailProvidersArgs = {
  input: DeleteManyEmailProvidersInput;
};

export type MutationDeleteManyEmailTemplatesArgs = {
  input: DeleteManyEmailTemplatesInput;
};

export type MutationDeleteManyEmailsArgs = {
  input: DeleteManyEmailsInput;
};

export type MutationDeleteManySmsArgs = {
  input: DeleteManySmsInput;
};

export type MutationDeleteManySmsProvidersArgs = {
  input: DeleteManySmsProvidersInput;
};

export type MutationDeleteOneAnnouncementArgs = {
  input: DeleteOneAnnouncementInput;
};

export type MutationDeleteOneCampaignArgs = {
  input: DeleteOneCampaignInput;
};

export type MutationDeleteOneCarColorArgs = {
  input: DeleteOneCarColorInput;
};

export type MutationDeleteOneCarModelArgs = {
  input: DeleteOneCarModelInput;
};

export type MutationDeleteOneCouponArgs = {
  input: DeleteOneCouponInput;
};

export type MutationDeleteOneCustomerSessionArgs = {
  input: DeleteOneCustomerSessionInput;
};

export type MutationDeleteOneDriverArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteOneDriverDocumentArgs = {
  input: DeleteOneDriverDocumentInput;
};

export type MutationDeleteOneDriverDocumentRetentionPolicyArgs = {
  input: DeleteOneDriverDocumentRetentionPolicyInput;
};

export type MutationDeleteOneDriverSessionArgs = {
  input: DeleteOneDriverSessionInput;
};

export type MutationDeleteOneDriverShiftRuleArgs = {
  input: DeleteOneDriverShiftRuleInput;
};

export type MutationDeleteOneDriverToDriverDocumentArgs = {
  input: DeleteOneDriverToDriverDocumentInput;
};

export type MutationDeleteOneEmailArgs = {
  input: DeleteOneEmailInput;
};

export type MutationDeleteOneEmailProviderArgs = {
  input: DeleteOneEmailProviderInput;
};

export type MutationDeleteOneEmailTemplateArgs = {
  input: DeleteOneEmailTemplateInput;
};

export type MutationDeleteOneFeedbackParameterArgs = {
  input: DeleteOneFeedbackParameterInput;
};

export type MutationDeleteOneFleetArgs = {
  input: DeleteOneFleetInput;
};

export type MutationDeleteOneFleetStaffArgs = {
  input: DeleteOneFleetStaffInput;
};

export type MutationDeleteOneOperatorArgs = {
  input: DeleteOneOperatorInput;
};

export type MutationDeleteOneOperatorRoleArgs = {
  input: DeleteOneOperatorRoleInput;
};

export type MutationDeleteOneOrderCancelReasonArgs = {
  input: DeleteOneOrderCancelReasonInput;
};

export type MutationDeleteOnePaymentGatewayArgs = {
  input: DeleteOnePaymentGatewayInput;
};

export type MutationDeleteOnePayoutMethodArgs = {
  input: DeleteOnePayoutMethodInput;
};

export type MutationDeleteOneRegionArgs = {
  input: DeleteOneRegionInput;
};

export type MutationDeleteOneRegionCategoryArgs = {
  input: DeleteOneRegionCategoryInput;
};

export type MutationDeleteOneRewardArgs = {
  input: DeleteOneRewardInput;
};

export type MutationDeleteOneRiderArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteOneSmsArgs = {
  input: DeleteOneSmsInput;
};

export type MutationDeleteOneSmsProviderArgs = {
  input: DeleteOneSmsProviderInput;
};

export type MutationDeleteOneSosReasonArgs = {
  input: DeleteOneSosReasonInput;
};

export type MutationDeleteOneSavedPaymentMethodArgs = {
  input: DeleteOneSavedPaymentMethodInput;
};

export type MutationDeleteOneServiceArgs = {
  input: DeleteOneServiceInput;
};

export type MutationDeleteOneServiceCategoryArgs = {
  input: DeleteOneServiceCategoryInput;
};

export type MutationDeleteOneServiceOptionArgs = {
  input: DeleteOneServiceOptionInput;
};

export type MutationDeleteOneServiceTariffProfileArgs = {
  input: DeleteOneServiceTariffProfileInput;
};

export type MutationDeleteOneTariffProfileArgs = {
  input: DeleteOneTariffProfileInput;
};

export type MutationDeleteOneZoneMultiplierArgs = {
  input: DeleteOneZoneMultiplierInput;
};

export type MutationDeleteOneZonePriceArgs = {
  input: DeleteOneZonePriceInput;
};

export type MutationDeleteOneZonePriceCategoryArgs = {
  input: DeleteOneZonePriceCategoryInput;
};

export type MutationDisableAllIntegrationRuntimeArgs = {
  input: DisableAllIntegrationRuntimeInput;
};

export type MutationDisconnectRiderWhatsAppArgs = {
  expectedVersion: Scalars["Int"]["input"];
};

export type MutationDismissAdminNotificationEventArgs = {
  eventId: Scalars["String"]["input"];
};

export type MutationDismissTelematicsAlertArgs = {
  input: TelematicsAlertReviewInput;
};

export type MutationEmergencyDispatchScheduledRideArgs = {
  orderId: Scalars["ID"]["input"];
  reason?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationEndVehicleTelematicsMappingArgs = {
  input: EndVehicleTelematicsMappingInput;
};

export type MutationExchangeRiderWhatsAppSignupArgs = {
  code: Scalars["String"]["input"];
  nonce: Scalars["String"]["input"];
};

export type MutationExportDriverTripReportToExcelArgs = {
  filter?: InputMaybe<DriverTripReportFilterInput>;
};

export type MutationExportGiftCardBatchArgs = {
  batchId: Scalars["ID"]["input"];
};

export type MutationExportTaxiPayoutSessionToCsvArgs = {
  input: ExportSessionToCsvInput;
};

export type MutationFinalizeDriverClosingRecordArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationForceCancelTaxiOrderArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationMarkAsReadArgs = {
  notificationIds: Array<Scalars["ID"]["input"]>;
};

export type MutationMarkEmailProviderAsDefaultArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationMarkSmsProviderAsDefaultArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationMarkTelematicsAlertExplainedArgs = {
  input: TelematicsAlertReviewInput;
};

export type MutationOpenAdminNotificationEventArgs = {
  eventId: Scalars["String"]["input"];
};

export type MutationQueueDispatcherOrderForNextAvailableArgs = {
  orderId: Scalars["ID"]["input"];
};

export type MutationReencryptLegacyTelematicsProviderSecretArgs = {
  providerSettingId: Scalars["ID"]["input"];
};

export type MutationReopenDriverClosingRecordArgs = {
  id: Scalars["ID"]["input"];
  reason: Scalars["String"]["input"];
};

export type MutationReplaceVehicleTelematicsMappingArgs = {
  input: ReplaceVehicleTelematicsMappingInput;
};

export type MutationRescheduleScheduledRideByAdminArgs = {
  orderId: Scalars["ID"]["input"];
  reason?: InputMaybe<Scalars["String"]["input"]>;
  scheduledAt: Scalars["DateTime"]["input"];
};

export type MutationReserveDriverAfterCurrentTripArgs = {
  driverId: Scalars["ID"]["input"];
  orderId: Scalars["ID"]["input"];
};

export type MutationResolveTelematicsAlertArgs = {
  input: TelematicsAlertReviewInput;
};

export type MutationRestoreArchivedDriverArgs = {
  id: Scalars["ID"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  reason: Scalars["String"]["input"];
};

export type MutationRevokeAdminBrowserPushRegistrationArgs = {
  browserInstanceId: Scalars["String"]["input"];
};

export type MutationRiderWhatsAppSignupPhonesArgs = {
  businessAccountId: Scalars["String"]["input"];
  nonce: Scalars["String"]["input"];
};

export type MutationRunTaxiAutoPayoutArgs = {
  input: RunAutoPayoutInput;
};

export type MutationRunTelematicsEvidenceReconciliationArgs = {
  input: TelematicsReconciliationInput;
};

export type MutationRunTelematicsRetentionCleanupArgs = {
  batchSize?: Scalars["Int"]["input"];
};

export type MutationSaveConfigurationArgs = {
  input: UpdateConfigInput;
};

export type MutationSaveRiderDisplaySettingsArgs = {
  expectedVersion: Scalars["Int"]["input"];
  minimumKm: Scalars["Int"]["input"];
};

export type MutationSaveRiderWhatsAppSettingsArgs = {
  input: SaveRiderWhatsAppSettingsInput;
};

export type MutationSaveServiceDistanceBandsArgs = {
  input: SaveServiceDistanceBandsInput;
};

export type MutationSaveZonePriceProfileFaresArgs = {
  input: SaveZonePriceProfileFaresInput;
};

export type MutationSendMyAdminDesktopTestPushArgs = {
  browserInstanceId: Scalars["String"]["input"];
};

export type MutationSetActivatedServicesOnDriverArgs = {
  input: SetActiveServicesOnDriverInput;
};

export type MutationSetCommissionPartnerActiveArgs = {
  active: Scalars["Boolean"]["input"];
  id: Scalars["ID"]["input"];
};

export type MutationSetFleetsOnZonePriceArgs = {
  input: SetFleetsOnZonePriceInput;
};

export type MutationSetOptionsOnServiceArgs = {
  input: SetOptionsOnServiceInput;
};

export type MutationSetRegionsOnServiceArgs = {
  input: SetRegionsOnServiceInput;
};

export type MutationSetRiderWhatsAppEnabledArgs = {
  input: SetRiderWhatsAppEnabledInput;
};

export type MutationSetServicesOnZonePriceArgs = {
  input: SetServicesOnZonePriceInput;
};

export type MutationSetTelematicsProfileActiveArgs = {
  input: SetTelematicsProfileActiveInput;
};

export type MutationSetTelematicsProviderSecretArgs = {
  input: SetTelematicsProviderSecretInput;
};

export type MutationStartTelematicsAlertReviewArgs = {
  input: TelematicsAlertReviewInput;
};

export type MutationTaxiManualPayoutArgs = {
  input: ManualPayoutInput;
};

export type MutationTerminateCustomerLoginSessionArgs = {
  sessionId: Scalars["ID"]["input"];
};

export type MutationTerminateDriverLoginSessionArgs = {
  sessionId: Scalars["ID"]["input"];
};

export type MutationTerminateFleetStaffSessionArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationTerminateStaffSessionArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationTestTelematicsProviderConnectionArgs = {
  providerSettingId: Scalars["ID"]["input"];
};

export type MutationUpdateAdminBrowserPushPreferencesArgs = {
  input: UpdateAdminBrowserPushPreferencesInput;
};

export type MutationUpdateAdminDesktopAlertRuntimePolicyArgs = {
  input: UpdateAdminDesktopAlertRuntimePolicyInput;
  providerSettingId: Scalars["ID"]["input"];
};

export type MutationUpdateCommissionPartnerArgs = {
  id: Scalars["ID"]["input"];
  input: CommissionPartnerInput;
};

export type MutationUpdateConfigurationsArgs = {
  input: UpdateConfigInputV2;
};

export type MutationUpdateDispatchConfigArgs = {
  input: DispatchConfigInput;
};

export type MutationUpdateDispatchPolicyArgs = {
  input: UpdateDispatchPolicyInput;
};

export type MutationUpdateDriverClosingDraftArgs = {
  id: Scalars["ID"]["input"];
  input: DriverClosingDraftInput;
};

export type MutationUpdateDriverStatusArgs = {
  id: Scalars["ID"]["input"];
  status: DriverStatus;
};

export type MutationUpdateFcmTokenArgs = {
  fcmToken: Scalars["String"]["input"];
};

export type MutationUpdateFirebaseArgs = {
  keyFileName: Scalars["String"]["input"];
};

export type MutationUpdateFixedFareRoutingModeArgs = {
  input: UpdateFixedFareRoutingModeInput;
};

export type MutationUpdateManyDriverDocumentRetentionPoliciesArgs = {
  input: UpdateManyDriverDocumentRetentionPoliciesInput;
};

export type MutationUpdateManyDriverDocumentsArgs = {
  input: UpdateManyDriverDocumentsInput;
};

export type MutationUpdateManyDriverShiftRulesArgs = {
  input: UpdateManyDriverShiftRulesInput;
};

export type MutationUpdateManyEmailProvidersArgs = {
  input: UpdateManyEmailProvidersInput;
};

export type MutationUpdateManyEmailTemplatesArgs = {
  input: UpdateManyEmailTemplatesInput;
};

export type MutationUpdateManyRiderAddressesArgs = {
  input: UpdateManyRiderAddressesInput;
};

export type MutationUpdateManySmsArgs = {
  input: UpdateManySmsInput;
};

export type MutationUpdateManySmsProvidersArgs = {
  input: UpdateManySmsProvidersInput;
};

export type MutationUpdateMapsApiKeyArgs = {
  adminPanel: Scalars["String"]["input"];
  backend: Scalars["String"]["input"];
};

export type MutationUpdateOneAnnouncementArgs = {
  input: UpdateOneAnnouncementInput;
};

export type MutationUpdateOneCarColorArgs = {
  input: UpdateOneCarColorInput;
};

export type MutationUpdateOneCarModelArgs = {
  input: UpdateOneCarModelInput;
};

export type MutationUpdateOneCouponArgs = {
  input: UpdateOneCouponInput;
};

export type MutationUpdateOneDistressSignalArgs = {
  input: UpdateOneDistressSignalInput;
};

export type MutationUpdateOneDriverArgs = {
  input: UpdateOneDriverInput;
};

export type MutationUpdateOneDriverDocumentArgs = {
  input: UpdateOneDriverDocumentInput;
};

export type MutationUpdateOneDriverDocumentRetentionPolicyArgs = {
  input: UpdateOneDriverDocumentRetentionPolicyInput;
};

export type MutationUpdateOneDriverShiftRuleArgs = {
  input: UpdateOneDriverShiftRuleInput;
};

export type MutationUpdateOneDriverToDriverDocumentArgs = {
  input: UpdateOneDriverToDriverDocumentInput;
};

export type MutationUpdateOneEmailProviderArgs = {
  input: UpdateOneEmailProviderInput;
};

export type MutationUpdateOneEmailTemplateArgs = {
  input: UpdateOneEmailTemplateInput;
};

export type MutationUpdateOneFeedbackArgs = {
  input: UpdateOneFeedbackInput;
};

export type MutationUpdateOneFeedbackParameterArgs = {
  input: UpdateOneFeedbackParameterInput;
};

export type MutationUpdateOneFleetArgs = {
  input: UpdateOneFleetInput;
};

export type MutationUpdateOneFleetStaffArgs = {
  input: UpdateOneFleetStaffInput;
};

export type MutationUpdateOneOperatorArgs = {
  input: UpdateOneOperatorInput;
};

export type MutationUpdateOneOperatorRoleArgs = {
  input: UpdateOneOperatorRoleInput;
};

export type MutationUpdateOneOrderCancelReasonArgs = {
  input: UpdateOneOrderCancelReasonInput;
};

export type MutationUpdateOnePaymentGatewayArgs = {
  input: UpdateOnePaymentGatewayInput;
};

export type MutationUpdateOnePayoutMethodArgs = {
  input: UpdateOnePayoutMethodInput;
};

export type MutationUpdateOneRegionArgs = {
  input: UpdateOneRegionInput;
};

export type MutationUpdateOneRegionCategoryArgs = {
  input: UpdateOneRegionCategoryInput;
};

export type MutationUpdateOneRewardArgs = {
  input: UpdateOneRewardInput;
};

export type MutationUpdateOneRiderArgs = {
  input: UpdateOneRiderInput;
};

export type MutationUpdateOneRiderAddressArgs = {
  input: UpdateOneRiderAddressInput;
};

export type MutationUpdateOneSmsArgs = {
  input: UpdateOneSmsInput;
};

export type MutationUpdateOneSmsProviderArgs = {
  input: UpdateOneSmsProviderInput;
};

export type MutationUpdateOneSosReasonArgs = {
  input: UpdateOneSosReasonInput;
};

export type MutationUpdateOneServiceArgs = {
  input: UpdateOneServiceInput;
};

export type MutationUpdateOneServiceCategoryArgs = {
  input: UpdateOneServiceCategoryInput;
};

export type MutationUpdateOneServiceOptionArgs = {
  input: UpdateOneServiceOptionInput;
};

export type MutationUpdateOneServiceTariffProfileArgs = {
  input: UpdateOneServiceTariffProfileInput;
};

export type MutationUpdateOneTariffProfileArgs = {
  input: UpdateOneTariffProfileInput;
};

export type MutationUpdateOneTaxiPayoutSessionArgs = {
  input: UpdateOneTaxiPayoutSessionInput;
};

export type MutationUpdateOneTaxiSupportRequestArgs = {
  input: UpdateOneTaxiSupportRequestInput;
};

export type MutationUpdateOneZoneMultiplierArgs = {
  input: UpdateOneZoneMultiplierInput;
};

export type MutationUpdateOneZonePriceArgs = {
  input: UpdateOneZonePriceInput;
};

export type MutationUpdateOneZonePriceCategoryArgs = {
  input: UpdateOneZonePriceCategoryInput;
};

export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};

export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};

export type MutationUpdateTelematicsRuntimePolicyArgs = {
  input: UpdateTelematicsRuntimePolicyInput;
};

export type MutationUpdateVehicleArgs = {
  id: Scalars["ID"]["input"];
  input: UpdateVehicleInput;
};

export type MutationUpsertAdminBrowserPushRegistrationArgs = {
  input: UpsertAdminBrowserPushRegistrationInput;
};

export type MutationUpsertTelematicsProviderSettingArgs = {
  input: UpsertTelematicsProviderSettingInput;
};

export type MutationUseCurrentDriverClosingCommissionRateArgs = {
  entryId: Scalars["ID"]["input"];
};

export type MutationValidateRiderWhatsAppSettingsArgs = {
  expectedVersion: Scalars["Int"]["input"];
};

export type NameCount = {
  __typename?: "NameCount";
  count: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
};

export type NextAvailableConfig = {
  __typename?: "NextAvailableConfig";
  /** Maximum ranked busy candidates retained; route evaluation attempts are capped at three times this number */
  candidateLimit: Scalars["Int"]["output"];
  /** Enable next-available-driver waiting requests */
  enabled: Scalars["Boolean"]["output"];
  /** Soft hold grace after the estimated pickup, in minutes; not the maximum passenger wait */
  holdMinutes: Scalars["Int"]["output"];
  /** Enable operators to reserve one specific busy driver */
  manualBusyDriverReservationEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** Absolute maximum lifetime for a manual reservation */
  manualHardMaxSeconds?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum total pickup wait: remaining trip time, drive to pickup and operational buffer, in minutes (inclusive) */
  maxEtaMinutes: Scalars["Int"]["output"];
  /** Maximum driving distance from the current trip final dropoff to the new pickup in km (inclusive) */
  maxPickupDistanceKm: Scalars["Float"]["output"];
  /** Operation center phone number shown to riders */
  operationCenterPhoneNumber?: Maybe<Scalars["String"]["output"]>;
  /** Operational buffer included in pickup ETA estimates */
  operationalBufferSeconds?: Maybe<Scalars["Int"]["output"]>;
  /** Reservation attempt threshold: 2 permits an initial hold and one replacement; 0 or 1 permits no replacement */
  recomputeAttempts: Scalars["Int"]["output"];
  /** Interval for durable reservation reconciliation */
  reconcileIntervalSeconds?: Maybe<Scalars["Int"]["output"]>;
  /** Redis recovery buffer beyond the hard deadline */
  redisRecoveryBufferSeconds?: Maybe<Scalars["Int"]["output"]>;
  /** Retry lease used when ETA is temporarily unavailable */
  renewalRetrySeconds?: Maybe<Scalars["Int"]["output"]>;
  /** Grace added to a renewable reservation ETA */
  softGraceSeconds?: Maybe<Scalars["Int"]["output"]>;
};

export type NextAvailableConfigInput = {
  /** Maximum ranked busy candidates retained; route evaluation attempts are capped at three times this number */
  candidateLimit: Scalars["Int"]["input"];
  /** Enable next-available-driver waiting requests */
  enabled: Scalars["Boolean"]["input"];
  /** Soft hold grace after the estimated pickup, in minutes; not the maximum passenger wait */
  holdMinutes: Scalars["Int"]["input"];
  /** Enable operators to reserve one specific busy driver */
  manualBusyDriverReservationEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Absolute maximum lifetime for a manual reservation */
  manualHardMaxSeconds?: InputMaybe<Scalars["Int"]["input"]>;
  /** Maximum total pickup wait: remaining trip time, drive to pickup and operational buffer, in minutes (inclusive) */
  maxEtaMinutes: Scalars["Int"]["input"];
  /** Maximum driving distance from the current trip final dropoff to the new pickup in km (inclusive) */
  maxPickupDistanceKm: Scalars["Float"]["input"];
  /** Operation center phone number shown to riders */
  operationCenterPhoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Operational buffer included in pickup ETA estimates */
  operationalBufferSeconds?: InputMaybe<Scalars["Int"]["input"]>;
  /** Reservation attempt threshold: 2 permits an initial hold and one replacement; 0 or 1 permits no replacement */
  recomputeAttempts: Scalars["Int"]["input"];
  /** Interval for durable reservation reconciliation */
  reconcileIntervalSeconds?: InputMaybe<Scalars["Int"]["input"]>;
  /** Redis recovery buffer beyond the hard deadline */
  redisRecoveryBufferSeconds?: InputMaybe<Scalars["Int"]["input"]>;
  /** Retry lease used when ETA is temporarily unavailable */
  renewalRetrySeconds?: InputMaybe<Scalars["Int"]["input"]>;
  /** Grace added to a renewable reservation ETA */
  softGraceSeconds?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum NextAvailableMode {
  Auto = "AUTO",
  ManualSpecificDriver = "MANUAL_SPECIFIC_DRIVER",
}

export type NextAvailableReservation = {
  __typename?: "NextAvailableReservation";
  createdAt: Scalars["DateTime"]["output"];
  currentTripId: Scalars["ID"]["output"];
  driverId: Scalars["ID"]["output"];
  driverName: Scalars["String"]["output"];
  endReason?: Maybe<Scalars["String"]["output"]>;
  endedAt?: Maybe<Scalars["DateTime"]["output"]>;
  etaState: Scalars["String"]["output"];
  generation: Scalars["Int"]["output"];
  hardExpiresAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  initialSoftExpiresAt: Scalars["DateTime"]["output"];
  lastFailureCode?: Maybe<Scalars["String"]["output"]>;
  lastRenewedAt?: Maybe<Scalars["DateTime"]["output"]>;
  latestEstimatedPickupAt?: Maybe<Scalars["DateTime"]["output"]>;
  latestEtaSeconds?: Maybe<Scalars["Int"]["output"]>;
  latestPickupDistanceMeters?: Maybe<Scalars["Int"]["output"]>;
  leaseVersion: Scalars["Int"]["output"];
  mode: Scalars["String"]["output"];
  offerSentAt?: Maybe<Scalars["DateTime"]["output"]>;
  orderId: Scalars["ID"]["output"];
  renewalCount: Scalars["Int"]["output"];
  softExpiresAt: Scalars["DateTime"]["output"];
  status: Scalars["String"]["output"];
  warningCode?: Maybe<Scalars["String"]["output"]>;
  warningMessage?: Maybe<Scalars["String"]["output"]>;
};

export type NumberFieldComparison = {
  between?: InputMaybe<NumberFieldComparisonBetween>;
  eq?: InputMaybe<Scalars["Float"]["input"]>;
  gt?: InputMaybe<Scalars["Float"]["input"]>;
  gte?: InputMaybe<Scalars["Float"]["input"]>;
  in?: InputMaybe<Array<Scalars["Float"]["input"]>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  lt?: InputMaybe<Scalars["Float"]["input"]>;
  lte?: InputMaybe<Scalars["Float"]["input"]>;
  neq?: InputMaybe<Scalars["Float"]["input"]>;
  notBetween?: InputMaybe<NumberFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars["Float"]["input"]>>;
};

export type NumberFieldComparisonBetween = {
  lower: Scalars["Float"]["input"];
  upper: Scalars["Float"]["input"];
};

export type OffsetPageInfo = {
  __typename?: "OffsetPageInfo";
  /** true if paging forward and there are more records. */
  hasNextPage?: Maybe<Scalars["Boolean"]["output"]>;
  /** true if paging backwards and there are more records. */
  hasPreviousPage?: Maybe<Scalars["Boolean"]["output"]>;
};

export type OffsetPaging = {
  /** Limit the number of records returned */
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  /** Offset to start returning records from */
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OnlineDriver = {
  __typename?: "OnlineDriver";
  accuracyMeters?: Maybe<Scalars["Float"]["output"]>;
  capturedAt?: Maybe<Scalars["DateTime"]["output"]>;
  driverId: Scalars["ID"]["output"];
  isLegacy?: Maybe<Scalars["Boolean"]["output"]>;
  lastUpdatedAt: Scalars["DateTime"]["output"];
  location: Point;
  protocolVersion?: Maybe<Scalars["Int"]["output"]>;
  receivedAt?: Maybe<Scalars["DateTime"]["output"]>;
  sequence?: Maybe<Scalars["Int"]["output"]>;
  sessionId?: Maybe<Scalars["String"]["output"]>;
  source?: Maybe<Scalars["String"]["output"]>;
  speedMetersPerSecond?: Maybe<Scalars["Float"]["output"]>;
};

export type OnlineDriverWithData = {
  __typename?: "OnlineDriverWithData";
  accuracyMeters?: Maybe<Scalars["Float"]["output"]>;
  activeOrderId?: Maybe<Scalars["ID"]["output"]>;
  availabilityReason: Scalars["String"]["output"];
  availabilityStatus: DriverAvailabilityStatus;
  avatarUrl?: Maybe<Scalars["String"]["output"]>;
  canAssignNow: Scalars["Boolean"]["output"];
  capturedAt?: Maybe<Scalars["DateTime"]["output"]>;
  estimatedFinishTime?: Maybe<Scalars["DateTime"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  gender?: Maybe<Gender>;
  id: Scalars["ID"]["output"];
  isLegacy?: Maybe<Scalars["Boolean"]["output"]>;
  isOnline: Scalars["Boolean"]["output"];
  lastName?: Maybe<Scalars["String"]["output"]>;
  lastUpdatedAt: Scalars["DateTime"]["output"];
  location: Point;
  mobileNumber: Scalars["String"]["output"];
  protocolVersion?: Maybe<Scalars["Int"]["output"]>;
  rating?: Maybe<Scalars["Int"]["output"]>;
  receivedAt?: Maybe<Scalars["DateTime"]["output"]>;
  reviewCount: Scalars["Int"]["output"];
  sequence?: Maybe<Scalars["Int"]["output"]>;
  serviceCompatible: Scalars["Boolean"]["output"];
  serviceIds: Array<Scalars["ID"]["output"]>;
  sessionId?: Maybe<Scalars["String"]["output"]>;
  source?: Maybe<Scalars["String"]["output"]>;
  speedMetersPerSecond?: Maybe<Scalars["Float"]["output"]>;
  status: DriverStatus;
  vehiclePlate?: Maybe<Scalars["String"]["output"]>;
};

export type OnlinePaymentMethod = PaymentMethodBase & {
  __typename?: "OnlinePaymentMethod";
  id: Scalars["ID"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  linkMethod: GatewayLinkMethod;
  mode: PaymentMode;
  name: Scalars["String"]["output"];
};

export type OpeningHoursInput = {
  close: Scalars["String"]["input"];
  open: Scalars["String"]["input"];
};

export type Operator = {
  __typename?: "Operator";
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  enabledNotifications: Array<EnabledNotification>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isBlocked: Scalars["Boolean"]["output"];
  lastActivity?: Maybe<Scalars["DateTime"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  media?: Maybe<Media>;
  mobileNumber?: Maybe<Scalars["String"]["output"]>;
  role?: Maybe<OperatorRole>;
  roleId?: Maybe<Scalars["ID"]["output"]>;
  sessions: OperatorSessionsConnection;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  userName: Scalars["String"]["output"];
};

export type OperatorSessionsArgs = {
  filter?: OperatorSessionFilter;
  paging?: OffsetPaging;
  sorting?: Array<OperatorSessionSort>;
};

export type OperatorAggregateFilter = {
  and?: InputMaybe<Array<OperatorAggregateFilter>>;
  email?: InputMaybe<StringFieldComparison>;
  firstName?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isBlocked?: InputMaybe<BooleanFieldComparison>;
  lastName?: InputMaybe<StringFieldComparison>;
  mobileNumber?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<OperatorAggregateFilter>>;
  roleId?: InputMaybe<IdFilterComparison>;
  userName?: InputMaybe<StringFieldComparison>;
};

export type OperatorConnection = {
  __typename?: "OperatorConnection";
  /** Array of nodes. */
  nodes: Array<Operator>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type OperatorDashboardEvent = {
  __typename?: "OperatorDashboardEvent";
  accuracyMeters?: Maybe<Scalars["Float"]["output"]>;
  activeOrderId?: Maybe<Scalars["ID"]["output"]>;
  assignable?: Maybe<Scalars["Boolean"]["output"]>;
  availabilityCode?: Maybe<Scalars["String"]["output"]>;
  availabilityReason?: Maybe<Scalars["String"]["output"]>;
  availabilitySource?: Maybe<Scalars["String"]["output"]>;
  availabilityVersion?: Maybe<Scalars["Int"]["output"]>;
  capturedAt?: Maybe<Scalars["DateTime"]["output"]>;
  desiredOnline?: Maybe<Scalars["Boolean"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  dropOffEta?: Maybe<Scalars["DateTime"]["output"]>;
  entityId: Scalars["ID"]["output"];
  estimatedFinishTime?: Maybe<Scalars["DateTime"]["output"]>;
  evaluatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  heartbeatAgeSeconds?: Maybe<Scalars["Int"]["output"]>;
  isLegacy?: Maybe<Scalars["Boolean"]["output"]>;
  isOnline?: Maybe<Scalars["Boolean"]["output"]>;
  isScheduled?: Maybe<Scalars["Boolean"]["output"]>;
  locationAgeSeconds?: Maybe<Scalars["Int"]["output"]>;
  nextTransitionAt?: Maybe<Scalars["DateTime"]["output"]>;
  orderId?: Maybe<Scalars["ID"]["output"]>;
  pickupEta?: Maybe<Scalars["DateTime"]["output"]>;
  point?: Maybe<Point>;
  previousAvailabilityCode?: Maybe<Scalars["String"]["output"]>;
  protocolVersion?: Maybe<Scalars["Int"]["output"]>;
  receivedAt?: Maybe<Scalars["DateTime"]["output"]>;
  scheduleStatus?: Maybe<Scalars["String"]["output"]>;
  sequence?: Maybe<Scalars["Int"]["output"]>;
  serverTime?: Maybe<Scalars["DateTime"]["output"]>;
  serviceCompatible?: Maybe<Scalars["Boolean"]["output"]>;
  sessionId?: Maybe<Scalars["String"]["output"]>;
  source?: Maybe<Scalars["String"]["output"]>;
  speedMetersPerSecond?: Maybe<Scalars["Float"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  timestamp: Scalars["DateTime"]["output"];
  type: OperatorDashboardEventType;
};

export enum OperatorDashboardEventType {
  ComplaintCreated = "ComplaintCreated",
  DriverAvailabilityChanged = "DriverAvailabilityChanged",
  DriverLocationUpdated = "DriverLocationUpdated",
  DriverStatusUpdated = "DriverStatusUpdated",
  NotificationCreated = "NotificationCreated",
  OrderChanged = "OrderChanged",
  SosCreated = "SosCreated",
}

export type OperatorDeleteResponse = {
  __typename?: "OperatorDeleteResponse";
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  enabledNotifications?: Maybe<Array<EnabledNotification>>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  isBlocked?: Maybe<Scalars["Boolean"]["output"]>;
  lastActivity?: Maybe<Scalars["DateTime"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  mobileNumber?: Maybe<Scalars["String"]["output"]>;
  roleId?: Maybe<Scalars["ID"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  userName?: Maybe<Scalars["String"]["output"]>;
};

export type OperatorFilter = {
  and?: InputMaybe<Array<OperatorFilter>>;
  email?: InputMaybe<StringFieldComparison>;
  firstName?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isBlocked?: InputMaybe<BooleanFieldComparison>;
  lastName?: InputMaybe<StringFieldComparison>;
  mobileNumber?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<OperatorFilter>>;
  roleId?: InputMaybe<IdFilterComparison>;
  userName?: InputMaybe<StringFieldComparison>;
};

export enum OperatorPermission {
  AccountSettingsEdit = "AccountSettings_Edit",
  AccountSettingsView = "AccountSettings_View",
  AnnouncementsEdit = "Announcements_Edit",
  AnnouncementsView = "Announcements_View",
  CarsEdit = "Cars_Edit",
  CarsView = "Cars_View",
  CommissionPartnerManage = "CommissionPartner_Manage",
  CommissionReportExport = "CommissionReport_Export",
  CommissionReportView = "CommissionReport_View",
  ComplaintsEdit = "Complaints_Edit",
  ComplaintsView = "Complaints_View",
  CouponsEdit = "Coupons_Edit",
  CouponsView = "Coupons_View",
  CriticalEdit = "Critical_Edit",
  CriticalView = "Critical_View",
  DispatcherCreate = "Dispatcher_Create",
  DispatcherView = "Dispatcher_View",
  DriverClosingRecordCreate = "DriverClosingRecord_Create",
  DriverClosingRecordEditDraft = "DriverClosingRecord_EditDraft",
  DriverClosingRecordExport = "DriverClosingRecord_Export",
  DriverClosingRecordFinalize = "DriverClosingRecord_Finalize",
  DriverClosingRecordView = "DriverClosingRecord_View",
  DriverVehicleAssignmentEdit = "DriverVehicleAssignment_Edit",
  DriverWalletEdit = "DriverWallet_Edit",
  DriverWalletView = "DriverWallet_View",
  DriversEdit = "Drivers_Edit",
  DriversView = "Drivers_View",
  EmailProvidersEdit = "EmailProviders_Edit",
  EmailProvidersView = "EmailProviders_View",
  EmailTemplatesEdit = "EmailTemplates_Edit",
  EmailTemplatesView = "EmailTemplates_View",
  FleetWalletEdit = "FleetWallet_Edit",
  FleetWalletView = "FleetWallet_View",
  FleetsEdit = "Fleets_Edit",
  FleetsView = "Fleets_View",
  GatewaysEdit = "Gateways_Edit",
  GatewaysView = "Gateways_View",
  GiftBatchCreate = "GiftBatch_Create",
  GiftBatchView = "GiftBatch_View",
  GiftBatchViewCodes = "GiftBatch_ViewCodes",
  NotificationsEdit = "Notifications_Edit",
  NotificationsView = "Notifications_View",
  OperatorDashboardView = "OperatorDashboard_View",
  OrderFinalPriceAdjustmentEdit = "OrderFinalPriceAdjustment_Edit",
  PayoutsEdit = "Payouts_Edit",
  PayoutsView = "Payouts_View",
  ProviderWalletEdit = "ProviderWallet_Edit",
  ProviderWalletView = "ProviderWallet_View",
  RegionsEdit = "Regions_Edit",
  RegionsView = "Regions_View",
  ReportsExport = "Reports_Export",
  ReportsView = "Reports_View",
  RequestsEdit = "Requests_Edit",
  RequestsView = "Requests_View",
  ReviewParameterEdit = "ReviewParameter_Edit",
  RiderWalletEdit = "RiderWallet_Edit",
  RiderWalletView = "RiderWallet_View",
  RidersEdit = "Riders_Edit",
  RidersView = "Riders_View",
  SmsProvidersEdit = "SMSProviders_Edit",
  SmsProvidersView = "SMSProviders_View",
  SosEdit = "SOS_Edit",
  SosView = "SOS_View",
  SchedulesEdit = "Schedules_Edit",
  SchedulesView = "Schedules_View",
  ServicesEdit = "Services_Edit",
  ServicesView = "Services_View",
  TelematicsAlertsAcknowledge = "Telematics_Alerts_Acknowledge",
  TelematicsAlertsResolve = "Telematics_Alerts_Resolve",
  TelematicsAlertsReview = "Telematics_Alerts_Review",
  TelematicsAlertsView = "Telematics_Alerts_View",
  TelematicsCurrentTripEvidenceView = "Telematics_CurrentTripEvidence_View",
  TelematicsDeviceMappingsManage = "Telematics_DeviceMappings_Manage",
  TelematicsHistoryView = "Telematics_History_View",
  TelematicsLiveView = "Telematics_Live_View",
  TelematicsReportsExport = "Telematics_Reports_Export",
  TelematicsRulesManage = "Telematics_Rules_Manage",
  TelematicsSettingsManage = "Telematics_Settings_Manage",
  UsersEdit = "Users_Edit",
  UsersView = "Users_View",
}

export type OperatorRole = {
  __typename?: "OperatorRole";
  allowedApps: Array<AppType>;
  id: Scalars["ID"]["output"];
  permissions: Array<OperatorPermission>;
  systemType: OperatorRoleSystemType;
  taxiPermissions: Array<TaxiPermission>;
  title: Scalars["String"]["output"];
};

export type OperatorRoleDeleteResponse = {
  __typename?: "OperatorRoleDeleteResponse";
  allowedApps?: Maybe<Array<AppType>>;
  id?: Maybe<Scalars["ID"]["output"]>;
  permissions?: Maybe<Array<OperatorPermission>>;
  systemType?: Maybe<OperatorRoleSystemType>;
  taxiPermissions?: Maybe<Array<TaxiPermission>>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type OperatorRoleFilter = {
  and?: InputMaybe<Array<OperatorRoleFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<OperatorRoleFilter>>;
  title?: InputMaybe<StringFieldComparison>;
};

export type OperatorRoleInput = {
  allowedApps?: InputMaybe<Array<AppType>>;
  permissions?: InputMaybe<Array<OperatorPermission>>;
  systemType?: InputMaybe<OperatorRoleSystemType>;
  taxiPermissions?: InputMaybe<Array<TaxiPermission>>;
  title: Scalars["String"]["input"];
};

export type OperatorRoleSort = {
  direction: SortDirection;
  field: OperatorRoleSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum OperatorRoleSortFields {
  Id = "id",
  Title = "title",
}

export enum OperatorRoleSystemType {
  Admin = "ADMIN",
  Operator = "OPERATOR",
}

export type OperatorSession = {
  __typename?: "OperatorSession";
  id: Scalars["ID"]["output"];
  operatorId: Scalars["ID"]["output"];
  sessionInfo: SessionInfo;
};

export type OperatorSessionFilter = {
  and?: InputMaybe<Array<OperatorSessionFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  operatorId?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<OperatorSessionFilter>>;
};

export type OperatorSessionSort = {
  direction: SortDirection;
  field: OperatorSessionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum OperatorSessionSortFields {
  Id = "id",
  OperatorId = "operatorId",
}

export type OperatorSessionsConnection = {
  __typename?: "OperatorSessionsConnection";
  /** Array of nodes. */
  nodes: Array<OperatorSession>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type OperatorSort = {
  direction: SortDirection;
  field: OperatorSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum OperatorSortFields {
  Email = "email",
  FirstName = "firstName",
  Id = "id",
  IsBlocked = "isBlocked",
  LastName = "lastName",
  MobileNumber = "mobileNumber",
  RoleId = "roleId",
  UserName = "userName",
}

export type Order = {
  __typename?: "Order";
  activities: Array<RequestActivity>;
  activitiesAggregate: Array<OrderActivitiesAggregateResponse>;
  addresses: Array<Scalars["String"]["output"]>;
  complaints: Array<TaxiSupportRequest>;
  complaintsAggregate: Array<OrderComplaintsAggregateResponse>;
  conversation: Array<OrderMessage>;
  conversationAggregate: Array<OrderConversationAggregateResponse>;
  costAfterCoupon: Scalars["Float"]["output"];
  costBest: Scalars["Float"]["output"];
  coupon?: Maybe<Coupon>;
  couponCode?: Maybe<Scalars["String"]["output"]>;
  createdDirectlyByDriverId?: Maybe<Scalars["ID"]["output"]>;
  createdOn: Scalars["DateTime"]["output"];
  currency: Scalars["String"]["output"];
  destinationArrivedTo: Scalars["Int"]["output"];
  directions?: Maybe<Array<Point>>;
  distanceBest: Scalars["Int"]["output"];
  driver?: Maybe<Driver>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  driverTransactions: Array<DriverTransaction>;
  driverTransactionsAggregate: Array<OrderDriverTransactionsAggregateResponse>;
  driverVehicleAssignmentId?: Maybe<Scalars["ID"]["output"]>;
  dropOffEta?: Maybe<Scalars["DateTime"]["output"]>;
  durationBest: Scalars["Int"]["output"];
  estimatedFixedPrice?: Maybe<Scalars["Float"]["output"]>;
  expectedTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  fareMode: FareMode;
  finalCollectedAmount?: Maybe<Scalars["Float"]["output"]>;
  finalPriceAdjustments: Array<OrderFinalPriceAdjustment>;
  finalPriceAdjustmentsAggregate: Array<OrderFinalPriceAdjustmentsAggregateResponse>;
  finishTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  fleet?: Maybe<Fleet>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  fleetTransactions: Array<FleetTransaction>;
  fleetTransactionsAggregate: Array<OrderFleetTransactionsAggregateResponse>;
  id: Scalars["ID"]["output"];
  isAnonymousPassenger: Scalars["Boolean"]["output"];
  isScheduled: Scalars["Boolean"]["output"];
  meterAmount?: Maybe<Scalars["Float"]["output"]>;
  meterCurrency?: Maybe<Scalars["String"]["output"]>;
  meterEnteredAt?: Maybe<Scalars["DateTime"]["output"]>;
  meterExtrasAmount?: Maybe<Scalars["Float"]["output"]>;
  meterNote?: Maybe<Scalars["String"]["output"]>;
  meterPhotoUrl?: Maybe<Scalars["String"]["output"]>;
  nextAvailableAttemptCount: Scalars["Int"]["output"];
  nextAvailableCandidateStillFeasible?: Maybe<Scalars["Boolean"]["output"]>;
  nextAvailableDriver?: Maybe<Driver>;
  nextAvailableDriverId?: Maybe<Scalars["ID"]["output"]>;
  nextAvailableEstimatedPickupAt?: Maybe<Scalars["DateTime"]["output"]>;
  nextAvailableEtaSeconds?: Maybe<Scalars["Int"]["output"]>;
  nextAvailableFailureReason?: Maybe<Scalars["String"]["output"]>;
  nextAvailableHoldExpiresAt?: Maybe<Scalars["DateTime"]["output"]>;
  nextAvailableMode?: Maybe<NextAvailableMode>;
  nextAvailableOperationCenterPhoneNumber?: Maybe<Scalars["String"]["output"]>;
  nextAvailablePickupDistanceMeters?: Maybe<Scalars["Int"]["output"]>;
  nextAvailableReservation?: Maybe<NextAvailableReservation>;
  operator?: Maybe<Operator>;
  operatorDisplayName?: Maybe<Scalars["String"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  options: Array<ServiceOption>;
  optionsAggregate: Array<OrderOptionsAggregateResponse>;
  orderSource: OrderSource;
  paymentGateway?: Maybe<PaymentGateway>;
  paymentMode?: Maybe<PaymentMode>;
  pickupEta?: Maybe<Scalars["DateTime"]["output"]>;
  points: Array<Point>;
  providerTransactions: Array<ProviderTransaction>;
  providerTransactionsAggregate: Array<OrderProviderTransactionsAggregateResponse>;
  regionId?: Maybe<Scalars["ID"]["output"]>;
  reportingSource?: Maybe<OrderSource>;
  rideOptionsCost: Scalars["Float"]["output"];
  rider?: Maybe<Rider>;
  /** Read-only Rider booking setup evidence. Null for orders without a keyed Rider receipt; UNAVAILABLE when the evidence cannot be read. */
  riderBookingSetupStatus?: Maybe<Scalars["String"]["output"]>;
  riderId: Scalars["ID"]["output"];
  riderTransactions: Array<RiderTransaction>;
  riderTransactionsAggregate: Array<OrderRiderTransactionsAggregateResponse>;
  routeSource: RouteSource;
  savedPaymentMethod?: Maybe<SavedPaymentMethod>;
  scheduleNotes?: Maybe<Scalars["String"]["output"]>;
  scheduleRevision: Scalars["Int"]["output"];
  scheduleStatus?: Maybe<ScheduleStatus>;
  scheduledAssignmentMode?: Maybe<ScheduledAssignmentMode>;
  scheduledAt?: Maybe<Scalars["DateTime"]["output"]>;
  scheduledDriver?: Maybe<Driver>;
  scheduledDriverConfirmedAt?: Maybe<Scalars["DateTime"]["output"]>;
  scheduledDriverId?: Maybe<Scalars["ID"]["output"]>;
  service?: Maybe<Service>;
  serviceCost: Scalars["Float"]["output"];
  serviceId?: Maybe<Scalars["ID"]["output"]>;
  serviceName?: Maybe<Scalars["String"]["output"]>;
  settlementSource?: Maybe<SettlementSource>;
  startTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  status: OrderStatus;
  streetPassengerName?: Maybe<Scalars["String"]["output"]>;
  streetPassengerNationality?: Maybe<Scalars["String"]["output"]>;
  streetPassengerPhone?: Maybe<Scalars["String"]["output"]>;
  tariffProfile?: Maybe<TariffProfile>;
  tariffProfileCode?: Maybe<Scalars["String"]["output"]>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
  tariffProfileTitle?: Maybe<Scalars["String"]["output"]>;
  taxCost: Scalars["Float"]["output"];
  type: TaxiOrderType;
  vehicleColor?: Maybe<Scalars["String"]["output"]>;
  vehicleId?: Maybe<Scalars["ID"]["output"]>;
  vehicleModel?: Maybe<Scalars["String"]["output"]>;
  vehiclePlate?: Maybe<Scalars["String"]["output"]>;
  vehicleProductionYear?: Maybe<Scalars["Int"]["output"]>;
  vehicleSnapshotSource?: Maybe<VehicleSnapshotSource>;
  waitCost: Scalars["Float"]["output"];
  waitMinutes: Scalars["Float"]["output"];
};

export type OrderActivitiesArgs = {
  filter?: RequestActivityFilter;
  sorting?: Array<RequestActivitySort>;
};

export type OrderActivitiesAggregateArgs = {
  filter?: InputMaybe<RequestActivityAggregateFilter>;
};

export type OrderComplaintsArgs = {
  filter?: TaxiSupportRequestFilter;
  sorting?: Array<TaxiSupportRequestSort>;
};

export type OrderComplaintsAggregateArgs = {
  filter?: InputMaybe<TaxiSupportRequestAggregateFilter>;
};

export type OrderConversationArgs = {
  filter?: OrderMessageFilter;
  sorting?: Array<OrderMessageSort>;
};

export type OrderConversationAggregateArgs = {
  filter?: InputMaybe<OrderMessageAggregateFilter>;
};

export type OrderDriverTransactionsArgs = {
  filter?: DriverTransactionFilter;
  sorting?: Array<DriverTransactionSort>;
};

export type OrderDriverTransactionsAggregateArgs = {
  filter?: InputMaybe<DriverTransactionAggregateFilter>;
};

export type OrderFinalPriceAdjustmentsArgs = {
  filter?: OrderFinalPriceAdjustmentFilter;
  sorting?: Array<OrderFinalPriceAdjustmentSort>;
};

export type OrderFinalPriceAdjustmentsAggregateArgs = {
  filter?: InputMaybe<OrderFinalPriceAdjustmentAggregateFilter>;
};

export type OrderFleetTransactionsArgs = {
  filter?: FleetTransactionFilter;
  sorting?: Array<FleetTransactionSort>;
};

export type OrderFleetTransactionsAggregateArgs = {
  filter?: InputMaybe<FleetTransactionAggregateFilter>;
};

export type OrderOptionsArgs = {
  filter?: ServiceOptionFilter;
  sorting?: Array<ServiceOptionSort>;
};

export type OrderOptionsAggregateArgs = {
  filter?: InputMaybe<ServiceOptionAggregateFilter>;
};

export type OrderProviderTransactionsArgs = {
  filter?: ProviderTransactionFilter;
  sorting?: Array<ProviderTransactionSort>;
};

export type OrderProviderTransactionsAggregateArgs = {
  filter?: InputMaybe<ProviderTransactionAggregateFilter>;
};

export type OrderRiderTransactionsArgs = {
  filter?: RiderTransactionFilter;
  sorting?: Array<RiderTransactionSort>;
};

export type OrderRiderTransactionsAggregateArgs = {
  filter?: InputMaybe<RiderTransactionAggregateFilter>;
};

export type OrderActivitiesAggregateGroupBy = {
  __typename?: "OrderActivitiesAggregateGroupBy";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type OrderActivitiesAggregateResponse = {
  __typename?: "OrderActivitiesAggregateResponse";
  avg?: Maybe<OrderActivitiesAvgAggregate>;
  count?: Maybe<OrderActivitiesCountAggregate>;
  groupBy?: Maybe<OrderActivitiesAggregateGroupBy>;
  max?: Maybe<OrderActivitiesMaxAggregate>;
  min?: Maybe<OrderActivitiesMinAggregate>;
  sum?: Maybe<OrderActivitiesSumAggregate>;
};

export type OrderActivitiesAvgAggregate = {
  __typename?: "OrderActivitiesAvgAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderActivitiesCountAggregate = {
  __typename?: "OrderActivitiesCountAggregate";
  id?: Maybe<Scalars["Int"]["output"]>;
};

export type OrderActivitiesMaxAggregate = {
  __typename?: "OrderActivitiesMaxAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type OrderActivitiesMinAggregate = {
  __typename?: "OrderActivitiesMinAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type OrderActivitiesSumAggregate = {
  __typename?: "OrderActivitiesSumAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderAggregateFilter = {
  and?: InputMaybe<Array<OrderAggregateFilter>>;
  costAfterCoupon?: InputMaybe<FloatFieldComparison>;
  costBest?: InputMaybe<FloatFieldComparison>;
  createdOn?: InputMaybe<DateFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  distanceBest?: InputMaybe<IntFieldComparison>;
  driverId?: InputMaybe<IdFilterComparison>;
  durationBest?: InputMaybe<IntFieldComparison>;
  fareMode?: InputMaybe<FareModeFilterComparison>;
  finishTimestamp?: InputMaybe<DateFieldComparison>;
  fleetId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  operatorId?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<OrderAggregateFilter>>;
  orderSource?: InputMaybe<OrderSourceFilterComparison>;
  paymentMode?: InputMaybe<PaymentModeFilterComparison>;
  regionId?: InputMaybe<IdFilterComparison>;
  reportingSource?: InputMaybe<OrderSourceFilterComparison>;
  riderId?: InputMaybe<IdFilterComparison>;
  routeSource?: InputMaybe<RouteSourceFilterComparison>;
  serviceId?: InputMaybe<IdFilterComparison>;
  status?: InputMaybe<OrderStatusFilterComparison>;
  tariffProfileId?: InputMaybe<IdFilterComparison>;
  type?: InputMaybe<TaxiOrderTypeFilterComparison>;
};

export type OrderAggregateGroupBy = {
  __typename?: "OrderAggregateGroupBy";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  createdOn?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  distanceBest?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  durationBest?: Maybe<Scalars["Int"]["output"]>;
  fareMode?: Maybe<FareMode>;
  finishTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  orderSource?: Maybe<OrderSource>;
  paymentMode?: Maybe<PaymentMode>;
  regionId?: Maybe<Scalars["ID"]["output"]>;
  reportingSource?: Maybe<OrderSource>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  routeSource?: Maybe<RouteSource>;
  serviceId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<OrderStatus>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
  type?: Maybe<TaxiOrderType>;
};

export type OrderAggregateGroupByCreatedOnArgs = {
  by?: GroupBy;
};

export type OrderAggregateGroupByFinishTimestampArgs = {
  by?: GroupBy;
};

export type OrderAggregateResponse = {
  __typename?: "OrderAggregateResponse";
  avg?: Maybe<OrderAvgAggregate>;
  count?: Maybe<OrderCountAggregate>;
  groupBy?: Maybe<OrderAggregateGroupBy>;
  max?: Maybe<OrderMaxAggregate>;
  min?: Maybe<OrderMinAggregate>;
  sum?: Maybe<OrderSumAggregate>;
};

export type OrderAvgAggregate = {
  __typename?: "OrderAvgAggregate";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  distanceBest?: Maybe<Scalars["Float"]["output"]>;
  driverId?: Maybe<Scalars["Float"]["output"]>;
  durationBest?: Maybe<Scalars["Float"]["output"]>;
  fleetId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  regionId?: Maybe<Scalars["Float"]["output"]>;
  riderId?: Maybe<Scalars["Float"]["output"]>;
  serviceId?: Maybe<Scalars["Float"]["output"]>;
  tariffProfileId?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderCancelReason = {
  __typename?: "OrderCancelReason";
  id: Scalars["ID"]["output"];
  isEnabled: Scalars["Boolean"]["output"];
  orders: OrderCancelReasonOrdersConnection;
  ordersAggregate: Array<OrderCancelReasonOrdersAggregateResponse>;
  title: Scalars["String"]["output"];
  userType: AnnouncementUserType;
};

export type OrderCancelReasonOrdersArgs = {
  filter?: OrderFilter;
  paging?: OffsetPaging;
  sorting?: Array<OrderSort>;
};

export type OrderCancelReasonOrdersAggregateArgs = {
  filter?: InputMaybe<OrderAggregateFilter>;
};

export type OrderCancelReasonConnection = {
  __typename?: "OrderCancelReasonConnection";
  /** Array of nodes. */
  nodes: Array<OrderCancelReason>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type OrderCancelReasonDeleteResponse = {
  __typename?: "OrderCancelReasonDeleteResponse";
  id?: Maybe<Scalars["ID"]["output"]>;
  isEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  userType?: Maybe<AnnouncementUserType>;
};

export type OrderCancelReasonFilter = {
  and?: InputMaybe<Array<OrderCancelReasonFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<OrderCancelReasonFilter>>;
};

export type OrderCancelReasonInput = {
  isEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  userType?: InputMaybe<AnnouncementUserType>;
};

export type OrderCancelReasonOrdersAggregateGroupBy = {
  __typename?: "OrderCancelReasonOrdersAggregateGroupBy";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  createdOn?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  distanceBest?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  durationBest?: Maybe<Scalars["Int"]["output"]>;
  fareMode?: Maybe<FareMode>;
  finishTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  orderSource?: Maybe<OrderSource>;
  paymentMode?: Maybe<PaymentMode>;
  regionId?: Maybe<Scalars["ID"]["output"]>;
  reportingSource?: Maybe<OrderSource>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  routeSource?: Maybe<RouteSource>;
  serviceId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<OrderStatus>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
  type?: Maybe<TaxiOrderType>;
};

export type OrderCancelReasonOrdersAggregateResponse = {
  __typename?: "OrderCancelReasonOrdersAggregateResponse";
  avg?: Maybe<OrderCancelReasonOrdersAvgAggregate>;
  count?: Maybe<OrderCancelReasonOrdersCountAggregate>;
  groupBy?: Maybe<OrderCancelReasonOrdersAggregateGroupBy>;
  max?: Maybe<OrderCancelReasonOrdersMaxAggregate>;
  min?: Maybe<OrderCancelReasonOrdersMinAggregate>;
  sum?: Maybe<OrderCancelReasonOrdersSumAggregate>;
};

export type OrderCancelReasonOrdersAvgAggregate = {
  __typename?: "OrderCancelReasonOrdersAvgAggregate";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  distanceBest?: Maybe<Scalars["Float"]["output"]>;
  driverId?: Maybe<Scalars["Float"]["output"]>;
  durationBest?: Maybe<Scalars["Float"]["output"]>;
  fleetId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  regionId?: Maybe<Scalars["Float"]["output"]>;
  riderId?: Maybe<Scalars["Float"]["output"]>;
  serviceId?: Maybe<Scalars["Float"]["output"]>;
  tariffProfileId?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderCancelReasonOrdersConnection = {
  __typename?: "OrderCancelReasonOrdersConnection";
  /** Array of nodes. */
  nodes: Array<Order>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type OrderCancelReasonOrdersCountAggregate = {
  __typename?: "OrderCancelReasonOrdersCountAggregate";
  costAfterCoupon?: Maybe<Scalars["Int"]["output"]>;
  costBest?: Maybe<Scalars["Int"]["output"]>;
  createdOn?: Maybe<Scalars["Int"]["output"]>;
  currency?: Maybe<Scalars["Int"]["output"]>;
  distanceBest?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["Int"]["output"]>;
  durationBest?: Maybe<Scalars["Int"]["output"]>;
  fareMode?: Maybe<Scalars["Int"]["output"]>;
  finishTimestamp?: Maybe<Scalars["Int"]["output"]>;
  fleetId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  operatorId?: Maybe<Scalars["Int"]["output"]>;
  orderSource?: Maybe<Scalars["Int"]["output"]>;
  paymentMode?: Maybe<Scalars["Int"]["output"]>;
  regionId?: Maybe<Scalars["Int"]["output"]>;
  reportingSource?: Maybe<Scalars["Int"]["output"]>;
  riderId?: Maybe<Scalars["Int"]["output"]>;
  routeSource?: Maybe<Scalars["Int"]["output"]>;
  serviceId?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
  tariffProfileId?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Scalars["Int"]["output"]>;
};

export type OrderCancelReasonOrdersMaxAggregate = {
  __typename?: "OrderCancelReasonOrdersMaxAggregate";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  createdOn?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  distanceBest?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  durationBest?: Maybe<Scalars["Int"]["output"]>;
  fareMode?: Maybe<FareMode>;
  finishTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  orderSource?: Maybe<OrderSource>;
  paymentMode?: Maybe<PaymentMode>;
  regionId?: Maybe<Scalars["ID"]["output"]>;
  reportingSource?: Maybe<OrderSource>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  routeSource?: Maybe<RouteSource>;
  serviceId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<OrderStatus>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
  type?: Maybe<TaxiOrderType>;
};

export type OrderCancelReasonOrdersMinAggregate = {
  __typename?: "OrderCancelReasonOrdersMinAggregate";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  createdOn?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  distanceBest?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  durationBest?: Maybe<Scalars["Int"]["output"]>;
  fareMode?: Maybe<FareMode>;
  finishTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  orderSource?: Maybe<OrderSource>;
  paymentMode?: Maybe<PaymentMode>;
  regionId?: Maybe<Scalars["ID"]["output"]>;
  reportingSource?: Maybe<OrderSource>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  routeSource?: Maybe<RouteSource>;
  serviceId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<OrderStatus>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
  type?: Maybe<TaxiOrderType>;
};

export type OrderCancelReasonOrdersSumAggregate = {
  __typename?: "OrderCancelReasonOrdersSumAggregate";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  distanceBest?: Maybe<Scalars["Float"]["output"]>;
  driverId?: Maybe<Scalars["Float"]["output"]>;
  durationBest?: Maybe<Scalars["Float"]["output"]>;
  fleetId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  regionId?: Maybe<Scalars["Float"]["output"]>;
  riderId?: Maybe<Scalars["Float"]["output"]>;
  serviceId?: Maybe<Scalars["Float"]["output"]>;
  tariffProfileId?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderCancelReasonSort = {
  direction: SortDirection;
  field: OrderCancelReasonSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum OrderCancelReasonSortFields {
  Id = "id",
}

export type OrderChangeDriver = {
  __typename?: "OrderChangeDriver";
  firstName?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  mobileNumber?: Maybe<Scalars["String"]["output"]>;
};

export type OrderChangeEvent = {
  __typename?: "OrderChangeEvent";
  driver?: Maybe<OrderChangeDriver>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  isScheduled: Scalars["Boolean"]["output"];
  orderId: Scalars["ID"]["output"];
  scheduleStatus?: Maybe<ScheduleStatus>;
  scheduledAt?: Maybe<Scalars["DateTime"]["output"]>;
  scheduledDriverId?: Maybe<Scalars["ID"]["output"]>;
  status: OrderStatus;
};

export type OrderComplaintsAggregateGroupBy = {
  __typename?: "OrderComplaintsAggregateGroupBy";
  id?: Maybe<Scalars["ID"]["output"]>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  requestedByDriver?: Maybe<Scalars["Boolean"]["output"]>;
  status?: Maybe<ComplaintStatus>;
};

export type OrderComplaintsAggregateResponse = {
  __typename?: "OrderComplaintsAggregateResponse";
  avg?: Maybe<OrderComplaintsAvgAggregate>;
  count?: Maybe<OrderComplaintsCountAggregate>;
  groupBy?: Maybe<OrderComplaintsAggregateGroupBy>;
  max?: Maybe<OrderComplaintsMaxAggregate>;
  min?: Maybe<OrderComplaintsMinAggregate>;
  sum?: Maybe<OrderComplaintsSumAggregate>;
};

export type OrderComplaintsAvgAggregate = {
  __typename?: "OrderComplaintsAvgAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
  requestId?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderComplaintsCountAggregate = {
  __typename?: "OrderComplaintsCountAggregate";
  id?: Maybe<Scalars["Int"]["output"]>;
  requestId?: Maybe<Scalars["Int"]["output"]>;
  requestedByDriver?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
};

export type OrderComplaintsMaxAggregate = {
  __typename?: "OrderComplaintsMaxAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<ComplaintStatus>;
};

export type OrderComplaintsMinAggregate = {
  __typename?: "OrderComplaintsMinAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<ComplaintStatus>;
};

export type OrderComplaintsSumAggregate = {
  __typename?: "OrderComplaintsSumAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
  requestId?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderConnection = {
  __typename?: "OrderConnection";
  /** Array of nodes. */
  nodes: Array<Order>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type OrderConversationAggregateGroupBy = {
  __typename?: "OrderConversationAggregateGroupBy";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type OrderConversationAggregateResponse = {
  __typename?: "OrderConversationAggregateResponse";
  avg?: Maybe<OrderConversationAvgAggregate>;
  count?: Maybe<OrderConversationCountAggregate>;
  groupBy?: Maybe<OrderConversationAggregateGroupBy>;
  max?: Maybe<OrderConversationMaxAggregate>;
  min?: Maybe<OrderConversationMinAggregate>;
  sum?: Maybe<OrderConversationSumAggregate>;
};

export type OrderConversationAvgAggregate = {
  __typename?: "OrderConversationAvgAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderConversationCountAggregate = {
  __typename?: "OrderConversationCountAggregate";
  id?: Maybe<Scalars["Int"]["output"]>;
};

export type OrderConversationMaxAggregate = {
  __typename?: "OrderConversationMaxAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type OrderConversationMinAggregate = {
  __typename?: "OrderConversationMinAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type OrderConversationSumAggregate = {
  __typename?: "OrderConversationSumAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderCountAggregate = {
  __typename?: "OrderCountAggregate";
  costAfterCoupon?: Maybe<Scalars["Int"]["output"]>;
  costBest?: Maybe<Scalars["Int"]["output"]>;
  createdOn?: Maybe<Scalars["Int"]["output"]>;
  currency?: Maybe<Scalars["Int"]["output"]>;
  distanceBest?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["Int"]["output"]>;
  durationBest?: Maybe<Scalars["Int"]["output"]>;
  fareMode?: Maybe<Scalars["Int"]["output"]>;
  finishTimestamp?: Maybe<Scalars["Int"]["output"]>;
  fleetId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  operatorId?: Maybe<Scalars["Int"]["output"]>;
  orderSource?: Maybe<Scalars["Int"]["output"]>;
  paymentMode?: Maybe<Scalars["Int"]["output"]>;
  regionId?: Maybe<Scalars["Int"]["output"]>;
  reportingSource?: Maybe<Scalars["Int"]["output"]>;
  riderId?: Maybe<Scalars["Int"]["output"]>;
  routeSource?: Maybe<Scalars["Int"]["output"]>;
  serviceId?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
  tariffProfileId?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Scalars["Int"]["output"]>;
};

export type OrderDriverTransactionsAggregateGroupBy = {
  __typename?: "OrderDriverTransactionsAggregateGroupBy";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  payoutAccountId?: Maybe<Scalars["ID"]["output"]>;
  payoutMethodId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type OrderDriverTransactionsAggregateResponse = {
  __typename?: "OrderDriverTransactionsAggregateResponse";
  avg?: Maybe<OrderDriverTransactionsAvgAggregate>;
  count?: Maybe<OrderDriverTransactionsCountAggregate>;
  groupBy?: Maybe<OrderDriverTransactionsAggregateGroupBy>;
  max?: Maybe<OrderDriverTransactionsMaxAggregate>;
  min?: Maybe<OrderDriverTransactionsMinAggregate>;
  sum?: Maybe<OrderDriverTransactionsSumAggregate>;
};

export type OrderDriverTransactionsAvgAggregate = {
  __typename?: "OrderDriverTransactionsAvgAggregate";
  amount?: Maybe<Scalars["Float"]["output"]>;
  driverId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Float"]["output"]>;
  payoutAccountId?: Maybe<Scalars["Float"]["output"]>;
  payoutMethodId?: Maybe<Scalars["Float"]["output"]>;
  payoutSessionId?: Maybe<Scalars["Float"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderDriverTransactionsCountAggregate = {
  __typename?: "OrderDriverTransactionsCountAggregate";
  action?: Maybe<Scalars["Int"]["output"]>;
  amount?: Maybe<Scalars["Int"]["output"]>;
  createdAt?: Maybe<Scalars["Int"]["output"]>;
  currency?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Int"]["output"]>;
  payoutAccountId?: Maybe<Scalars["Int"]["output"]>;
  payoutMethodId?: Maybe<Scalars["Int"]["output"]>;
  payoutSessionId?: Maybe<Scalars["Int"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
};

export type OrderDriverTransactionsMaxAggregate = {
  __typename?: "OrderDriverTransactionsMaxAggregate";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  payoutAccountId?: Maybe<Scalars["ID"]["output"]>;
  payoutMethodId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type OrderDriverTransactionsMinAggregate = {
  __typename?: "OrderDriverTransactionsMinAggregate";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  payoutAccountId?: Maybe<Scalars["ID"]["output"]>;
  payoutMethodId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type OrderDriverTransactionsSumAggregate = {
  __typename?: "OrderDriverTransactionsSumAggregate";
  amount?: Maybe<Scalars["Float"]["output"]>;
  driverId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Float"]["output"]>;
  payoutAccountId?: Maybe<Scalars["Float"]["output"]>;
  payoutMethodId?: Maybe<Scalars["Float"]["output"]>;
  payoutSessionId?: Maybe<Scalars["Float"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderFilter = {
  and?: InputMaybe<Array<OrderFilter>>;
  costAfterCoupon?: InputMaybe<FloatFieldComparison>;
  costBest?: InputMaybe<FloatFieldComparison>;
  createdOn?: InputMaybe<DateFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  distanceBest?: InputMaybe<IntFieldComparison>;
  driverId?: InputMaybe<IdFilterComparison>;
  durationBest?: InputMaybe<IntFieldComparison>;
  fareMode?: InputMaybe<FareModeFilterComparison>;
  finishTimestamp?: InputMaybe<DateFieldComparison>;
  fleetId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  operatorId?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<OrderFilter>>;
  orderSource?: InputMaybe<OrderSourceFilterComparison>;
  paymentMode?: InputMaybe<PaymentModeFilterComparison>;
  regionId?: InputMaybe<IdFilterComparison>;
  reportingSource?: InputMaybe<OrderSourceFilterComparison>;
  riderId?: InputMaybe<IdFilterComparison>;
  routeSource?: InputMaybe<RouteSourceFilterComparison>;
  serviceId?: InputMaybe<IdFilterComparison>;
  status?: InputMaybe<OrderStatusFilterComparison>;
  tariffProfileId?: InputMaybe<IdFilterComparison>;
  type?: InputMaybe<TaxiOrderTypeFilterComparison>;
};

export type OrderFinalPriceAdjustment = {
  __typename?: "OrderFinalPriceAdjustment";
  actor: OrderFinalPriceAdjustmentActor;
  adjustedByOperatorId?: Maybe<Scalars["ID"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  newFinalCollectedAmount: Scalars["Float"]["output"];
  newSettlementSource?: Maybe<SettlementSource>;
  note?: Maybe<Scalars["String"]["output"]>;
  oldFinalCollectedAmount?: Maybe<Scalars["Float"]["output"]>;
  oldSettlementSource?: Maybe<SettlementSource>;
  orderId: Scalars["ID"]["output"];
  reason: Scalars["String"]["output"];
};

export type OrderFinalPriceAdjustmentActor = {
  __typename?: "OrderFinalPriceAdjustmentActor";
  displayName: Scalars["String"]["output"];
  roleName?: Maybe<Scalars["String"]["output"]>;
  systemType?: Maybe<OperatorRoleSystemType>;
};

export type OrderFinalPriceAdjustmentAggregateFilter = {
  adjustedByOperatorId?: InputMaybe<IdFilterComparison>;
  and?: InputMaybe<Array<OrderFinalPriceAdjustmentAggregateFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<OrderFinalPriceAdjustmentAggregateFilter>>;
  orderId?: InputMaybe<IdFilterComparison>;
};

export type OrderFinalPriceAdjustmentFilter = {
  adjustedByOperatorId?: InputMaybe<IdFilterComparison>;
  and?: InputMaybe<Array<OrderFinalPriceAdjustmentFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<OrderFinalPriceAdjustmentFilter>>;
  orderId?: InputMaybe<IdFilterComparison>;
};

export type OrderFinalPriceAdjustmentSort = {
  direction: SortDirection;
  field: OrderFinalPriceAdjustmentSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum OrderFinalPriceAdjustmentSortFields {
  AdjustedByOperatorId = "adjustedByOperatorId",
  CreatedAt = "createdAt",
  Id = "id",
  OrderId = "orderId",
}

export type OrderFinalPriceAdjustmentsAggregateGroupBy = {
  __typename?: "OrderFinalPriceAdjustmentsAggregateGroupBy";
  adjustedByOperatorId?: Maybe<Scalars["ID"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  orderId?: Maybe<Scalars["ID"]["output"]>;
};

export type OrderFinalPriceAdjustmentsAggregateResponse = {
  __typename?: "OrderFinalPriceAdjustmentsAggregateResponse";
  avg?: Maybe<OrderFinalPriceAdjustmentsAvgAggregate>;
  count?: Maybe<OrderFinalPriceAdjustmentsCountAggregate>;
  groupBy?: Maybe<OrderFinalPriceAdjustmentsAggregateGroupBy>;
  max?: Maybe<OrderFinalPriceAdjustmentsMaxAggregate>;
  min?: Maybe<OrderFinalPriceAdjustmentsMinAggregate>;
  sum?: Maybe<OrderFinalPriceAdjustmentsSumAggregate>;
};

export type OrderFinalPriceAdjustmentsAvgAggregate = {
  __typename?: "OrderFinalPriceAdjustmentsAvgAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
  orderId?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderFinalPriceAdjustmentsCountAggregate = {
  __typename?: "OrderFinalPriceAdjustmentsCountAggregate";
  adjustedByOperatorId?: Maybe<Scalars["Int"]["output"]>;
  createdAt?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  orderId?: Maybe<Scalars["Int"]["output"]>;
};

export type OrderFinalPriceAdjustmentsMaxAggregate = {
  __typename?: "OrderFinalPriceAdjustmentsMaxAggregate";
  adjustedByOperatorId?: Maybe<Scalars["ID"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  orderId?: Maybe<Scalars["ID"]["output"]>;
};

export type OrderFinalPriceAdjustmentsMinAggregate = {
  __typename?: "OrderFinalPriceAdjustmentsMinAggregate";
  adjustedByOperatorId?: Maybe<Scalars["ID"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  orderId?: Maybe<Scalars["ID"]["output"]>;
};

export type OrderFinalPriceAdjustmentsSumAggregate = {
  __typename?: "OrderFinalPriceAdjustmentsSumAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
  orderId?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderFleetTransactionsAggregateGroupBy = {
  __typename?: "OrderFleetTransactionsAggregateGroupBy";
  action?: Maybe<TransactionAction>;
  deductType?: Maybe<ProviderDeductTransactionType>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<ProviderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type OrderFleetTransactionsAggregateResponse = {
  __typename?: "OrderFleetTransactionsAggregateResponse";
  avg?: Maybe<OrderFleetTransactionsAvgAggregate>;
  count?: Maybe<OrderFleetTransactionsCountAggregate>;
  groupBy?: Maybe<OrderFleetTransactionsAggregateGroupBy>;
  max?: Maybe<OrderFleetTransactionsMaxAggregate>;
  min?: Maybe<OrderFleetTransactionsMinAggregate>;
  sum?: Maybe<OrderFleetTransactionsSumAggregate>;
};

export type OrderFleetTransactionsAvgAggregate = {
  __typename?: "OrderFleetTransactionsAvgAggregate";
  fleetId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  requestId?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderFleetTransactionsCountAggregate = {
  __typename?: "OrderFleetTransactionsCountAggregate";
  action?: Maybe<Scalars["Int"]["output"]>;
  deductType?: Maybe<Scalars["Int"]["output"]>;
  fleetId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  operatorId?: Maybe<Scalars["Int"]["output"]>;
  rechargeType?: Maybe<Scalars["Int"]["output"]>;
  requestId?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
};

export type OrderFleetTransactionsMaxAggregate = {
  __typename?: "OrderFleetTransactionsMaxAggregate";
  action?: Maybe<TransactionAction>;
  deductType?: Maybe<ProviderDeductTransactionType>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<ProviderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type OrderFleetTransactionsMinAggregate = {
  __typename?: "OrderFleetTransactionsMinAggregate";
  action?: Maybe<TransactionAction>;
  deductType?: Maybe<ProviderDeductTransactionType>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<ProviderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type OrderFleetTransactionsSumAggregate = {
  __typename?: "OrderFleetTransactionsSumAggregate";
  fleetId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  requestId?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderMaxAggregate = {
  __typename?: "OrderMaxAggregate";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  createdOn?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  distanceBest?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  durationBest?: Maybe<Scalars["Int"]["output"]>;
  fareMode?: Maybe<FareMode>;
  finishTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  orderSource?: Maybe<OrderSource>;
  paymentMode?: Maybe<PaymentMode>;
  regionId?: Maybe<Scalars["ID"]["output"]>;
  reportingSource?: Maybe<OrderSource>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  routeSource?: Maybe<RouteSource>;
  serviceId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<OrderStatus>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
  type?: Maybe<TaxiOrderType>;
};

export type OrderMessage = {
  __typename?: "OrderMessage";
  content: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  sentAt: Scalars["DateTime"]["output"];
  sentByDriver: Scalars["Boolean"]["output"];
  status: MessageStatus;
};

export type OrderMessageAggregateFilter = {
  and?: InputMaybe<Array<OrderMessageAggregateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<OrderMessageAggregateFilter>>;
};

export type OrderMessageFilter = {
  and?: InputMaybe<Array<OrderMessageFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<OrderMessageFilter>>;
};

export type OrderMessageSort = {
  direction: SortDirection;
  field: OrderMessageSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum OrderMessageSortFields {
  Id = "id",
}

export type OrderMinAggregate = {
  __typename?: "OrderMinAggregate";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  createdOn?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  distanceBest?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  durationBest?: Maybe<Scalars["Int"]["output"]>;
  fareMode?: Maybe<FareMode>;
  finishTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  orderSource?: Maybe<OrderSource>;
  paymentMode?: Maybe<PaymentMode>;
  regionId?: Maybe<Scalars["ID"]["output"]>;
  reportingSource?: Maybe<OrderSource>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  routeSource?: Maybe<RouteSource>;
  serviceId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<OrderStatus>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
  type?: Maybe<TaxiOrderType>;
};

export type OrderOptionsAggregateGroupBy = {
  __typename?: "OrderOptionsAggregateGroupBy";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type OrderOptionsAggregateResponse = {
  __typename?: "OrderOptionsAggregateResponse";
  avg?: Maybe<OrderOptionsAvgAggregate>;
  count?: Maybe<OrderOptionsCountAggregate>;
  groupBy?: Maybe<OrderOptionsAggregateGroupBy>;
  max?: Maybe<OrderOptionsMaxAggregate>;
  min?: Maybe<OrderOptionsMinAggregate>;
  sum?: Maybe<OrderOptionsSumAggregate>;
};

export type OrderOptionsAvgAggregate = {
  __typename?: "OrderOptionsAvgAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderOptionsCountAggregate = {
  __typename?: "OrderOptionsCountAggregate";
  id?: Maybe<Scalars["Int"]["output"]>;
};

export type OrderOptionsMaxAggregate = {
  __typename?: "OrderOptionsMaxAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type OrderOptionsMinAggregate = {
  __typename?: "OrderOptionsMinAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type OrderOptionsSumAggregate = {
  __typename?: "OrderOptionsSumAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderProviderTransactionsAggregateGroupBy = {
  __typename?: "OrderProviderTransactionsAggregateGroupBy";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  deductType?: Maybe<ProviderDeductTransactionType>;
  expenseType?: Maybe<ProviderExpenseType>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<ProviderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
};

export type OrderProviderTransactionsAggregateResponse = {
  __typename?: "OrderProviderTransactionsAggregateResponse";
  avg?: Maybe<OrderProviderTransactionsAvgAggregate>;
  count?: Maybe<OrderProviderTransactionsCountAggregate>;
  groupBy?: Maybe<OrderProviderTransactionsAggregateGroupBy>;
  max?: Maybe<OrderProviderTransactionsMaxAggregate>;
  min?: Maybe<OrderProviderTransactionsMinAggregate>;
  sum?: Maybe<OrderProviderTransactionsSumAggregate>;
};

export type OrderProviderTransactionsAvgAggregate = {
  __typename?: "OrderProviderTransactionsAvgAggregate";
  amount?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  requestId?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderProviderTransactionsCountAggregate = {
  __typename?: "OrderProviderTransactionsCountAggregate";
  action?: Maybe<Scalars["Int"]["output"]>;
  amount?: Maybe<Scalars["Int"]["output"]>;
  currency?: Maybe<Scalars["Int"]["output"]>;
  deductType?: Maybe<Scalars["Int"]["output"]>;
  expenseType?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  operatorId?: Maybe<Scalars["Int"]["output"]>;
  rechargeType?: Maybe<Scalars["Int"]["output"]>;
  requestId?: Maybe<Scalars["Int"]["output"]>;
};

export type OrderProviderTransactionsMaxAggregate = {
  __typename?: "OrderProviderTransactionsMaxAggregate";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  deductType?: Maybe<ProviderDeductTransactionType>;
  expenseType?: Maybe<ProviderExpenseType>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<ProviderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
};

export type OrderProviderTransactionsMinAggregate = {
  __typename?: "OrderProviderTransactionsMinAggregate";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  deductType?: Maybe<ProviderDeductTransactionType>;
  expenseType?: Maybe<ProviderExpenseType>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<ProviderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
};

export type OrderProviderTransactionsSumAggregate = {
  __typename?: "OrderProviderTransactionsSumAggregate";
  amount?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  requestId?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderRiderTransactionsAggregateGroupBy = {
  __typename?: "OrderRiderTransactionsAggregateGroupBy";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  deductType?: Maybe<RiderDeductTransactionType>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<RiderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  savedPaymentMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type OrderRiderTransactionsAggregateResponse = {
  __typename?: "OrderRiderTransactionsAggregateResponse";
  avg?: Maybe<OrderRiderTransactionsAvgAggregate>;
  count?: Maybe<OrderRiderTransactionsCountAggregate>;
  groupBy?: Maybe<OrderRiderTransactionsAggregateGroupBy>;
  max?: Maybe<OrderRiderTransactionsMaxAggregate>;
  min?: Maybe<OrderRiderTransactionsMinAggregate>;
  sum?: Maybe<OrderRiderTransactionsSumAggregate>;
};

export type OrderRiderTransactionsAvgAggregate = {
  __typename?: "OrderRiderTransactionsAvgAggregate";
  amount?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Float"]["output"]>;
  requestId?: Maybe<Scalars["Float"]["output"]>;
  riderId?: Maybe<Scalars["Float"]["output"]>;
  savedPaymentMethodId?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderRiderTransactionsCountAggregate = {
  __typename?: "OrderRiderTransactionsCountAggregate";
  action?: Maybe<Scalars["Int"]["output"]>;
  amount?: Maybe<Scalars["Int"]["output"]>;
  createdAt?: Maybe<Scalars["Int"]["output"]>;
  currency?: Maybe<Scalars["Int"]["output"]>;
  deductType?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  operatorId?: Maybe<Scalars["Int"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Int"]["output"]>;
  rechargeType?: Maybe<Scalars["Int"]["output"]>;
  requestId?: Maybe<Scalars["Int"]["output"]>;
  riderId?: Maybe<Scalars["Int"]["output"]>;
  savedPaymentMethodId?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
};

export type OrderRiderTransactionsMaxAggregate = {
  __typename?: "OrderRiderTransactionsMaxAggregate";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  deductType?: Maybe<RiderDeductTransactionType>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<RiderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  savedPaymentMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type OrderRiderTransactionsMinAggregate = {
  __typename?: "OrderRiderTransactionsMinAggregate";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  deductType?: Maybe<RiderDeductTransactionType>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<RiderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  savedPaymentMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type OrderRiderTransactionsSumAggregate = {
  __typename?: "OrderRiderTransactionsSumAggregate";
  amount?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Float"]["output"]>;
  requestId?: Maybe<Scalars["Float"]["output"]>;
  riderId?: Maybe<Scalars["Float"]["output"]>;
  savedPaymentMethodId?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderSort = {
  direction: SortDirection;
  field: OrderSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum OrderSortFields {
  CostAfterCoupon = "costAfterCoupon",
  CostBest = "costBest",
  CreatedOn = "createdOn",
  Currency = "currency",
  DistanceBest = "distanceBest",
  DriverId = "driverId",
  DurationBest = "durationBest",
  FareMode = "fareMode",
  FinishTimestamp = "finishTimestamp",
  FleetId = "fleetId",
  Id = "id",
  OperatorId = "operatorId",
  OrderSource = "orderSource",
  PaymentMode = "paymentMode",
  RegionId = "regionId",
  ReportingSource = "reportingSource",
  RiderId = "riderId",
  RouteSource = "routeSource",
  ServiceId = "serviceId",
  Status = "status",
  TariffProfileId = "tariffProfileId",
  Type = "type",
}

/** Where the ride request originated from. */
export enum OrderSource {
  Dispatcher = "Dispatcher",
  DriverManual = "DriverManual",
  RiderApp = "RiderApp",
}

export type OrderSourceFilterComparison = {
  eq?: InputMaybe<OrderSource>;
  gt?: InputMaybe<OrderSource>;
  gte?: InputMaybe<OrderSource>;
  iLike?: InputMaybe<OrderSource>;
  in?: InputMaybe<Array<OrderSource>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<OrderSource>;
  lt?: InputMaybe<OrderSource>;
  lte?: InputMaybe<OrderSource>;
  neq?: InputMaybe<OrderSource>;
  notILike?: InputMaybe<OrderSource>;
  notIn?: InputMaybe<Array<OrderSource>>;
  notLike?: InputMaybe<OrderSource>;
};

export enum OrderStatus {
  Arrived = "Arrived",
  Booked = "Booked",
  DriverAccepted = "DriverAccepted",
  DriverCanceled = "DriverCanceled",
  Expired = "Expired",
  Finished = "Finished",
  Found = "Found",
  NextAvailableExpired = "NextAvailableExpired",
  NextAvailableOfferPending = "NextAvailableOfferPending",
  NoCloseFound = "NoCloseFound",
  NotFound = "NotFound",
  Requested = "Requested",
  RiderCanceled = "RiderCanceled",
  Started = "Started",
  WaitingForDriverFee = "WaitingForDriverFee",
  WaitingForNextAvailableDriver = "WaitingForNextAvailableDriver",
  WaitingForPostPay = "WaitingForPostPay",
  WaitingForPrePay = "WaitingForPrePay",
  WaitingForReview = "WaitingForReview",
}

export type OrderStatusFilterComparison = {
  eq?: InputMaybe<OrderStatus>;
  gt?: InputMaybe<OrderStatus>;
  gte?: InputMaybe<OrderStatus>;
  iLike?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<OrderStatus>;
  lt?: InputMaybe<OrderStatus>;
  lte?: InputMaybe<OrderStatus>;
  neq?: InputMaybe<OrderStatus>;
  notILike?: InputMaybe<OrderStatus>;
  notIn?: InputMaybe<Array<OrderStatus>>;
  notLike?: InputMaybe<OrderStatus>;
};

export type OrderSumAggregate = {
  __typename?: "OrderSumAggregate";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  distanceBest?: Maybe<Scalars["Float"]["output"]>;
  driverId?: Maybe<Scalars["Float"]["output"]>;
  durationBest?: Maybe<Scalars["Float"]["output"]>;
  fleetId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  regionId?: Maybe<Scalars["Float"]["output"]>;
  riderId?: Maybe<Scalars["Float"]["output"]>;
  serviceId?: Maybe<Scalars["Float"]["output"]>;
  tariffProfileId?: Maybe<Scalars["Float"]["output"]>;
};

export type OrderVolumeBucket = {
  __typename?: "OrderVolumeBucket";
  date: Scalars["String"]["output"];
  orderCount: Scalars["Int"]["output"];
};

export type OrderVolumeByApp = {
  __typename?: "OrderVolumeByApp";
  app: AppType;
  buckets: Array<OrderVolumeBucket>;
};

export type PageInfo = {
  __typename?: "PageInfo";
  /** The cursor of the last returned record. */
  endCursor?: Maybe<Scalars["ConnectionCursor"]["output"]>;
  /** true if paging forward and there are more records. */
  hasNextPage?: Maybe<Scalars["Boolean"]["output"]>;
  /** true if paging backwards and there are more records. */
  hasPreviousPage?: Maybe<Scalars["Boolean"]["output"]>;
  /** The cursor of the first returned record. */
  startCursor?: Maybe<Scalars["ConnectionCursor"]["output"]>;
};

export type PageInformation = {
  __typename?: "PageInformation";
  hasNextPage: Scalars["Boolean"]["output"];
  hasPreviousPage: Scalars["Boolean"]["output"];
};

export type PaginationInput = {
  after?: InputMaybe<Scalars["Int"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PassengerInformation = {
  __typename?: "PassengerInformation";
  firstName?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  profilePicture?: Maybe<Scalars["String"]["output"]>;
};

export type PaymentGateway = {
  __typename?: "PaymentGateway";
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars["ID"]["output"]>;
  merchantId?: Maybe<Scalars["String"]["output"]>;
  privateKey: Scalars["String"]["output"];
  publicKey?: Maybe<Scalars["String"]["output"]>;
  riderTransactions: PaymentGatewayRiderTransactionsConnection;
  riderTransactionsAggregate: Array<PaymentGatewayRiderTransactionsAggregateResponse>;
  saltKey?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  type: PaymentGatewayType;
};

export type PaymentGatewayRiderTransactionsArgs = {
  filter?: RiderTransactionFilter;
  paging?: OffsetPaging;
  sorting?: Array<RiderTransactionSort>;
};

export type PaymentGatewayRiderTransactionsAggregateArgs = {
  filter?: InputMaybe<RiderTransactionAggregateFilter>;
};

export type PaymentGatewayConnection = {
  __typename?: "PaymentGatewayConnection";
  /** Array of nodes. */
  nodes: Array<PaymentGateway>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type PaymentGatewayDeleteResponse = {
  __typename?: "PaymentGatewayDeleteResponse";
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  mediaId?: Maybe<Scalars["ID"]["output"]>;
  merchantId?: Maybe<Scalars["String"]["output"]>;
  privateKey?: Maybe<Scalars["String"]["output"]>;
  publicKey?: Maybe<Scalars["String"]["output"]>;
  saltKey?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<PaymentGatewayType>;
};

export type PaymentGatewayFilter = {
  and?: InputMaybe<Array<PaymentGatewayFilter>>;
  enabled?: InputMaybe<BooleanFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<PaymentGatewayFilter>>;
  title?: InputMaybe<StringFieldComparison>;
  type?: InputMaybe<PaymentGatewayTypeFilterComparison>;
};

export type PaymentGatewayRiderTransactionsAggregateGroupBy = {
  __typename?: "PaymentGatewayRiderTransactionsAggregateGroupBy";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  deductType?: Maybe<RiderDeductTransactionType>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<RiderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  savedPaymentMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type PaymentGatewayRiderTransactionsAggregateResponse = {
  __typename?: "PaymentGatewayRiderTransactionsAggregateResponse";
  avg?: Maybe<PaymentGatewayRiderTransactionsAvgAggregate>;
  count?: Maybe<PaymentGatewayRiderTransactionsCountAggregate>;
  groupBy?: Maybe<PaymentGatewayRiderTransactionsAggregateGroupBy>;
  max?: Maybe<PaymentGatewayRiderTransactionsMaxAggregate>;
  min?: Maybe<PaymentGatewayRiderTransactionsMinAggregate>;
  sum?: Maybe<PaymentGatewayRiderTransactionsSumAggregate>;
};

export type PaymentGatewayRiderTransactionsAvgAggregate = {
  __typename?: "PaymentGatewayRiderTransactionsAvgAggregate";
  amount?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Float"]["output"]>;
  requestId?: Maybe<Scalars["Float"]["output"]>;
  riderId?: Maybe<Scalars["Float"]["output"]>;
  savedPaymentMethodId?: Maybe<Scalars["Float"]["output"]>;
};

export type PaymentGatewayRiderTransactionsConnection = {
  __typename?: "PaymentGatewayRiderTransactionsConnection";
  /** Array of nodes. */
  nodes: Array<RiderTransaction>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type PaymentGatewayRiderTransactionsCountAggregate = {
  __typename?: "PaymentGatewayRiderTransactionsCountAggregate";
  action?: Maybe<Scalars["Int"]["output"]>;
  amount?: Maybe<Scalars["Int"]["output"]>;
  createdAt?: Maybe<Scalars["Int"]["output"]>;
  currency?: Maybe<Scalars["Int"]["output"]>;
  deductType?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  operatorId?: Maybe<Scalars["Int"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Int"]["output"]>;
  rechargeType?: Maybe<Scalars["Int"]["output"]>;
  requestId?: Maybe<Scalars["Int"]["output"]>;
  riderId?: Maybe<Scalars["Int"]["output"]>;
  savedPaymentMethodId?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
};

export type PaymentGatewayRiderTransactionsMaxAggregate = {
  __typename?: "PaymentGatewayRiderTransactionsMaxAggregate";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  deductType?: Maybe<RiderDeductTransactionType>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<RiderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  savedPaymentMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type PaymentGatewayRiderTransactionsMinAggregate = {
  __typename?: "PaymentGatewayRiderTransactionsMinAggregate";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  deductType?: Maybe<RiderDeductTransactionType>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<RiderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  savedPaymentMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type PaymentGatewayRiderTransactionsSumAggregate = {
  __typename?: "PaymentGatewayRiderTransactionsSumAggregate";
  amount?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Float"]["output"]>;
  requestId?: Maybe<Scalars["Float"]["output"]>;
  riderId?: Maybe<Scalars["Float"]["output"]>;
  savedPaymentMethodId?: Maybe<Scalars["Float"]["output"]>;
};

export type PaymentGatewaySort = {
  direction: SortDirection;
  field: PaymentGatewaySortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum PaymentGatewaySortFields {
  Enabled = "enabled",
  Id = "id",
  Title = "title",
  Type = "type",
}

export enum PaymentGatewayType {
  AmazonPaymentServices = "AmazonPaymentServices",
  BambooPay = "BambooPay",
  BinancePay = "BinancePay",
  BrainTree = "BrainTree",
  CustomLink = "CustomLink",
  Flutterwave = "Flutterwave",
  Instamojo = "Instamojo",
  Mips = "MIPS",
  MercadoPago = "MercadoPago",
  MyFatoorah = "MyFatoorah",
  MyTMoney = "MyTMoney",
  OpenPix = "OpenPix",
  PayGate = "PayGate",
  PayPal = "PayPal",
  PayTr = "PayTR",
  PayU = "PayU",
  Paystack = "Paystack",
  Paytm = "Paytm",
  Razorpay = "Razorpay",
  SberBank = "SberBank",
  Stripe = "Stripe",
  WayForPay = "WayForPay",
}

export type PaymentGatewayTypeFilterComparison = {
  eq?: InputMaybe<PaymentGatewayType>;
  gt?: InputMaybe<PaymentGatewayType>;
  gte?: InputMaybe<PaymentGatewayType>;
  iLike?: InputMaybe<PaymentGatewayType>;
  in?: InputMaybe<Array<PaymentGatewayType>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<PaymentGatewayType>;
  lt?: InputMaybe<PaymentGatewayType>;
  lte?: InputMaybe<PaymentGatewayType>;
  neq?: InputMaybe<PaymentGatewayType>;
  notILike?: InputMaybe<PaymentGatewayType>;
  notIn?: InputMaybe<Array<PaymentGatewayType>>;
  notLike?: InputMaybe<PaymentGatewayType>;
};

export type PaymentMethodBase = {
  id?: Maybe<Scalars["ID"]["output"]>;
  mode: PaymentMode;
};

/** The means of payment for an order. */
export enum PaymentMode {
  Cash = "Cash",
  PaymentGateway = "PaymentGateway",
  SavedPaymentMethod = "SavedPaymentMethod",
  Wallet = "Wallet",
}

export type PaymentModeFilterComparison = {
  eq?: InputMaybe<PaymentMode>;
  gt?: InputMaybe<PaymentMode>;
  gte?: InputMaybe<PaymentMode>;
  iLike?: InputMaybe<PaymentMode>;
  in?: InputMaybe<Array<PaymentMode>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<PaymentMode>;
  lt?: InputMaybe<PaymentMode>;
  lte?: InputMaybe<PaymentMode>;
  neq?: InputMaybe<PaymentMode>;
  notILike?: InputMaybe<PaymentMode>;
  notIn?: InputMaybe<Array<PaymentMode>>;
  notLike?: InputMaybe<PaymentMode>;
};

export type PayoutAccount = {
  __typename?: "PayoutAccount";
  accountHolderAddress?: Maybe<Scalars["String"]["output"]>;
  accountHolderCity?: Maybe<Scalars["String"]["output"]>;
  accountHolderCountry?: Maybe<Scalars["String"]["output"]>;
  accountHolderDateOfBirth?: Maybe<Scalars["DateTime"]["output"]>;
  accountHolderName?: Maybe<Scalars["String"]["output"]>;
  accountHolderPhone?: Maybe<Scalars["String"]["output"]>;
  accountHolderState?: Maybe<Scalars["String"]["output"]>;
  accountHolderZip?: Maybe<Scalars["String"]["output"]>;
  accountNumber?: Maybe<Scalars["String"]["output"]>;
  bankName?: Maybe<Scalars["String"]["output"]>;
  branchName?: Maybe<Scalars["String"]["output"]>;
  currency: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  isVerified: Scalars["Boolean"]["output"];
  last4: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  payoutMethod: PayoutMethod;
  payoutMethodId: Scalars["ID"]["output"];
  routingNumber?: Maybe<Scalars["String"]["output"]>;
  type: SavedPaymentMethodType;
};

export type PayoutAccountAggregateFilter = {
  and?: InputMaybe<Array<PayoutAccountAggregateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  isDefault?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<PayoutAccountAggregateFilter>>;
};

export type PayoutAccountEdge = {
  __typename?: "PayoutAccountEdge";
  /** Cursor for this node. */
  cursor: Scalars["ConnectionCursor"]["output"];
  /** The node containing the PayoutAccount */
  node: PayoutAccount;
};

export type PayoutAccountFilter = {
  and?: InputMaybe<Array<PayoutAccountFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  isDefault?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<PayoutAccountFilter>>;
};

export type PayoutAccountSort = {
  direction: SortDirection;
  field: PayoutAccountSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum PayoutAccountSortFields {
  Id = "id",
  IsDefault = "isDefault",
}

export type PayoutMethod = {
  __typename?: "PayoutMethod";
  balance?: Maybe<Scalars["Float"]["output"]>;
  currency: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  driverTransactions: DriverTransaction;
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  isInstantPayoutEnabled: Scalars["Boolean"]["output"];
  media?: Maybe<Media>;
  mediaId: Scalars["ID"]["output"];
  merchantId?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  privateKey?: Maybe<Scalars["String"]["output"]>;
  publicKey?: Maybe<Scalars["String"]["output"]>;
  saltKey?: Maybe<Scalars["String"]["output"]>;
  type: PayoutMethodType;
};

export type PayoutMethodConnection = {
  __typename?: "PayoutMethodConnection";
  /** Array of nodes. */
  nodes: Array<PayoutMethod>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type PayoutMethodDeleteResponse = {
  __typename?: "PayoutMethodDeleteResponse";
  balance?: Maybe<Scalars["Float"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  isInstantPayoutEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  mediaId?: Maybe<Scalars["ID"]["output"]>;
  merchantId?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  privateKey?: Maybe<Scalars["String"]["output"]>;
  publicKey?: Maybe<Scalars["String"]["output"]>;
  saltKey?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<PayoutMethodType>;
};

export type PayoutMethodFilter = {
  and?: InputMaybe<Array<PayoutMethodFilter>>;
  currency?: InputMaybe<StringFieldComparison>;
  driverTransactions?: InputMaybe<PayoutMethodFilterDriverTransactionFilter>;
  enabled?: InputMaybe<BooleanFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<PayoutMethodFilter>>;
  type?: InputMaybe<PayoutMethodTypeFilterComparison>;
};

export type PayoutMethodFilterDriverTransactionFilter = {
  action?: InputMaybe<TransactionActionFilterComparison>;
  amount?: InputMaybe<NumberFieldComparison>;
  and?: InputMaybe<Array<PayoutMethodFilterDriverTransactionFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  driverId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<PayoutMethodFilterDriverTransactionFilter>>;
  paymentGatewayId?: InputMaybe<IdFilterComparison>;
  payoutAccountId?: InputMaybe<IdFilterComparison>;
  payoutMethodId?: InputMaybe<IdFilterComparison>;
  payoutSessionId?: InputMaybe<IdFilterComparison>;
  payoutSessionMethodId?: InputMaybe<IdFilterComparison>;
  status?: InputMaybe<TransactionStatusFilterComparison>;
};

export type PayoutMethodSort = {
  direction: SortDirection;
  field: PayoutMethodSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum PayoutMethodSortFields {
  Currency = "currency",
  Enabled = "enabled",
  Id = "id",
  Name = "name",
  Type = "type",
}

export type PayoutMethodStats = {
  __typename?: "PayoutMethodStats";
  payoutMethod?: Maybe<PayoutMethod>;
  totalCount: Scalars["Int"]["output"];
};

/** The type of payout method */
export enum PayoutMethodType {
  BankTransfer = "BankTransfer",
  Stripe = "Stripe",
}

export type PayoutMethodTypeFilterComparison = {
  eq?: InputMaybe<PayoutMethodType>;
  gt?: InputMaybe<PayoutMethodType>;
  gte?: InputMaybe<PayoutMethodType>;
  iLike?: InputMaybe<PayoutMethodType>;
  in?: InputMaybe<Array<PayoutMethodType>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<PayoutMethodType>;
  lt?: InputMaybe<PayoutMethodType>;
  lte?: InputMaybe<PayoutMethodType>;
  neq?: InputMaybe<PayoutMethodType>;
  notILike?: InputMaybe<PayoutMethodType>;
  notIn?: InputMaybe<Array<PayoutMethodType>>;
  notLike?: InputMaybe<PayoutMethodType>;
};

export enum PayoutSessionStatus {
  Cancelled = "CANCELLED",
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
  Paid = "PAID",
  Pending = "PENDING",
}

export type PayoutSessionStatusFilterComparison = {
  eq?: InputMaybe<PayoutSessionStatus>;
  gt?: InputMaybe<PayoutSessionStatus>;
  gte?: InputMaybe<PayoutSessionStatus>;
  iLike?: InputMaybe<PayoutSessionStatus>;
  in?: InputMaybe<Array<PayoutSessionStatus>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<PayoutSessionStatus>;
  lt?: InputMaybe<PayoutSessionStatus>;
  lte?: InputMaybe<PayoutSessionStatus>;
  neq?: InputMaybe<PayoutSessionStatus>;
  notILike?: InputMaybe<PayoutSessionStatus>;
  notIn?: InputMaybe<Array<PayoutSessionStatus>>;
  notLike?: InputMaybe<PayoutSessionStatus>;
};

export type PayoutStatistics = {
  __typename?: "PayoutStatistics";
  currency: Scalars["String"]["output"];
  lastPayoutAmount: Scalars["Float"]["output"];
  pendingAmount: Scalars["Float"]["output"];
  usersDefaultPayoutMethodStats: Array<PayoutMethodStats>;
};

export type PhoneNumber = {
  __typename?: "PhoneNumber";
  countryCode: Scalars["String"]["output"];
  number: Scalars["String"]["output"];
};

export type PhoneNumberInput = {
  countryCode: Scalars["String"]["input"];
  number: Scalars["String"]["input"];
};

export type PlaceDto = {
  __typename?: "PlaceDTO";
  address: Scalars["String"]["output"];
  point: Point;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type PlacePredictionDto = {
  __typename?: "PlacePredictionDTO";
  distanceMeters?: Maybe<Scalars["Int"]["output"]>;
  fullText: Scalars["String"]["output"];
  placeId: Scalars["String"]["output"];
  primaryText: Scalars["String"]["output"];
  provider: Scalars["String"]["output"];
  secondaryText?: Maybe<Scalars["String"]["output"]>;
  types?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type PlatformDistribution = {
  __typename?: "PlatformDistribution";
  count: Scalars["Int"]["output"];
  platform: DevicePlatform;
};

export type PlatformKpi = {
  __typename?: "PlatformKPI";
  activeCustomers: PlatformKpiItem;
  totalOrders: PlatformKpiItem;
  totalRevenue: PlatformKpiItem;
};

export type PlatformKpiInput = {
  /** The currency for the KPI */
  currency: Scalars["String"]["input"];
  /** The period for the KPI */
  period: KpiPeriod;
};

export type PlatformKpiItem = {
  __typename?: "PlatformKPIItem";
  /** Breakdown of KPI value by sub-application. */
  breakdown: Array<KpiAppBreakdown>;
  /** Percentage change compared to the previous time period */
  change: Scalars["Float"]["output"];
  /** Display name of the KPI (e.g., "Total Orders") */
  name: Scalars["String"]["output"];
  /** Total value for the current time period */
  total: Scalars["Float"]["output"];
  /** Unit of measurement (e.g., "orders", "$") */
  unit?: Maybe<Scalars["String"]["output"]>;
};

export type Point = {
  __typename?: "Point";
  heading?: Maybe<Scalars["Int"]["output"]>;
  lat: Scalars["Float"]["output"];
  lng: Scalars["Float"]["output"];
};

export type PointInput = {
  heading?: InputMaybe<Scalars["Int"]["input"]>;
  lat: Scalars["Float"]["input"];
  lng: Scalars["Float"]["input"];
};

export enum PricingMode {
  Fixed = "FIXED",
  Range = "RANGE",
}

export type PricingV2Breakdown = {
  __typename?: "PricingV2Breakdown";
  baseFare: Scalars["Float"]["output"];
  baseFareSource: Scalars["String"]["output"];
  calendarMultiplier: Scalars["Float"]["output"];
  calendarMultiplierCap: Scalars["Float"]["output"];
  calendarRuleSource: Scalars["String"]["output"];
  couponAmount: Scalars["Float"]["output"];
  distanceBandBreakdown: Array<PricingV2DistanceBandCharge>;
  distanceBandSource: Scalars["String"]["output"];
  distanceCharge: Scalars["Float"]["output"];
  distanceMeters: Scalars["Int"]["output"];
  distanceRateSource: Scalars["String"]["output"];
  driveMinuteSource: Scalars["String"]["output"];
  driveTimeCharge: Scalars["Float"]["output"];
  durationSeconds: Scalars["Int"]["output"];
  fareAfterZoneMultiplier: Scalars["Float"]["output"];
  fareBeforeCoupon: Scalars["Float"]["output"];
  fareBeforeZoneMultiplier: Scalars["Float"]["output"];
  finalFare: Scalars["Float"]["output"];
  matchedCalendarRules: Array<PricingV2CalendarRuleMatch>;
  matchedZoneMultiplierId?: Maybe<Scalars["ID"]["output"]>;
  matchedZoneMultiplierName?: Maybe<Scalars["String"]["output"]>;
  maxCalendarMultiplierSource: Scalars["String"]["output"];
  minimumFare: Scalars["Float"]["output"];
  minimumFareApplied: Scalars["Boolean"]["output"];
  minimumFareSource: Scalars["String"]["output"];
  optionCharge: Scalars["Float"]["output"];
  roundedSubtotalAfterCalendar: Scalars["Float"]["output"];
  roundingApplied: Scalars["Boolean"]["output"];
  roundingFactor?: Maybe<Scalars["Float"]["output"]>;
  roundingSource: Scalars["String"]["output"];
  selectedZoneMultiplier: Scalars["Float"]["output"];
  subtotalAfterCalendar: Scalars["Float"]["output"];
  subtotalBeforeCalendar: Scalars["Float"]["output"];
  totalCalendarUplift: Scalars["Float"]["output"];
  waitCharge: Scalars["Float"]["output"];
  waitMinuteSource: Scalars["String"]["output"];
  waitMinutes: Scalars["Float"]["output"];
  zoneMultiplierApplied: Scalars["Boolean"]["output"];
  zoneMultiplierTriggerReason?: Maybe<Scalars["String"]["output"]>;
};

export type PricingV2CalendarRuleMatch = {
  __typename?: "PricingV2CalendarRuleMatch";
  label: Scalars["String"]["output"];
  multiply: Scalars["Float"]["output"];
  type: Scalars["String"]["output"];
  uplift: Scalars["Float"]["output"];
};

export type PricingV2DistanceBandCharge = {
  __typename?: "PricingV2DistanceBandCharge";
  appliedEndMeters: Scalars["Int"]["output"];
  appliedStartMeters: Scalars["Int"]["output"];
  charge: Scalars["Float"]["output"];
  endMeters?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  label?: Maybe<Scalars["String"]["output"]>;
  meters: Scalars["Int"]["output"];
  pricePer100m: Scalars["Float"]["output"];
  startMeters: Scalars["Int"]["output"];
};

export type PricingV2PreviewInput = {
  couponAmount?: InputMaybe<Scalars["Float"]["input"]>;
  distanceMeters: Scalars["Int"]["input"];
  dropoffPoint?: InputMaybe<PointInput>;
  durationMinutes: Scalars["Float"]["input"];
  optionIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  pickupPoint?: InputMaybe<PointInput>;
  pricingTimestamp: Scalars["DateTime"]["input"];
  serviceId: Scalars["ID"]["input"];
  tariffProfileId?: InputMaybe<Scalars["ID"]["input"]>;
  waitMinutes?: Scalars["Float"]["input"];
};

/** Brand of the provider wether bank name or card provider */
export enum ProviderBrand {
  Amex = "Amex",
  Diners = "Diners",
  Discover = "Discover",
  EftPosAu = "EftPosAu",
  Jcb = "JCB",
  Mastercard = "Mastercard",
  UnionPay = "UnionPay",
  Unknown = "Unknown",
  Visa = "Visa",
}

export enum ProviderDeductTransactionType {
  Expense = "Expense",
  Refund = "Refund",
  Withdraw = "Withdraw",
}

export type ProviderDeductTransactionTypeFilterComparison = {
  eq?: InputMaybe<ProviderDeductTransactionType>;
  gt?: InputMaybe<ProviderDeductTransactionType>;
  gte?: InputMaybe<ProviderDeductTransactionType>;
  iLike?: InputMaybe<ProviderDeductTransactionType>;
  in?: InputMaybe<Array<ProviderDeductTransactionType>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<ProviderDeductTransactionType>;
  lt?: InputMaybe<ProviderDeductTransactionType>;
  lte?: InputMaybe<ProviderDeductTransactionType>;
  neq?: InputMaybe<ProviderDeductTransactionType>;
  notILike?: InputMaybe<ProviderDeductTransactionType>;
  notIn?: InputMaybe<Array<ProviderDeductTransactionType>>;
  notLike?: InputMaybe<ProviderDeductTransactionType>;
};

export type ProviderExpenseBreakdownRecord = {
  __typename?: "ProviderExpenseBreakdownRecord";
  anyDate: Scalars["DateTime"]["output"];
  dateString: Scalars["String"]["output"];
  expenseType: ProviderExpenseType;
  value: Scalars["Float"]["output"];
};

export enum ProviderExpenseType {
  CloudServices = "CloudServices",
  Hosting = "Hosting",
  Marketing = "Marketing",
  PlatformMaintenance = "PlatformMaintenance",
  SoftwareLicense = "SoftwareLicense",
  TechnologyDevelopment = "TechnologyDevelopment",
}

export type ProviderExpenseTypeFilterComparison = {
  eq?: InputMaybe<ProviderExpenseType>;
  gt?: InputMaybe<ProviderExpenseType>;
  gte?: InputMaybe<ProviderExpenseType>;
  iLike?: InputMaybe<ProviderExpenseType>;
  in?: InputMaybe<Array<ProviderExpenseType>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<ProviderExpenseType>;
  lt?: InputMaybe<ProviderExpenseType>;
  lte?: InputMaybe<ProviderExpenseType>;
  neq?: InputMaybe<ProviderExpenseType>;
  notILike?: InputMaybe<ProviderExpenseType>;
  notIn?: InputMaybe<Array<ProviderExpenseType>>;
  notLike?: InputMaybe<ProviderExpenseType>;
};

export enum ProviderRechargeTransactionType {
  Commission = "Commission",
}

export type ProviderRechargeTransactionTypeFilterComparison = {
  eq?: InputMaybe<ProviderRechargeTransactionType>;
  gt?: InputMaybe<ProviderRechargeTransactionType>;
  gte?: InputMaybe<ProviderRechargeTransactionType>;
  iLike?: InputMaybe<ProviderRechargeTransactionType>;
  in?: InputMaybe<Array<ProviderRechargeTransactionType>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<ProviderRechargeTransactionType>;
  lt?: InputMaybe<ProviderRechargeTransactionType>;
  lte?: InputMaybe<ProviderRechargeTransactionType>;
  neq?: InputMaybe<ProviderRechargeTransactionType>;
  notILike?: InputMaybe<ProviderRechargeTransactionType>;
  notIn?: InputMaybe<Array<ProviderRechargeTransactionType>>;
  notLike?: InputMaybe<ProviderRechargeTransactionType>;
};

export type ProviderTransaction = {
  __typename?: "ProviderTransaction";
  action: TransactionAction;
  amount: Scalars["Float"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  currency: Scalars["String"]["output"];
  deductType?: Maybe<ProviderDeductTransactionType>;
  description?: Maybe<Scalars["String"]["output"]>;
  expenseType?: Maybe<ProviderExpenseType>;
  id: Scalars["ID"]["output"];
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<ProviderRechargeTransactionType>;
  refrenceNumber?: Maybe<Scalars["String"]["output"]>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
};

export type ProviderTransactionAggregateFilter = {
  action?: InputMaybe<TransactionActionFilterComparison>;
  amount?: InputMaybe<NumberFieldComparison>;
  and?: InputMaybe<Array<ProviderTransactionAggregateFilter>>;
  currency?: InputMaybe<StringFieldComparison>;
  deductType?: InputMaybe<ProviderDeductTransactionTypeFilterComparison>;
  expenseType?: InputMaybe<ProviderExpenseTypeFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  operatorId?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ProviderTransactionAggregateFilter>>;
  rechargeType?: InputMaybe<ProviderRechargeTransactionTypeFilterComparison>;
  requestId?: InputMaybe<IdFilterComparison>;
};

export type ProviderTransactionAggregateGroupBy = {
  __typename?: "ProviderTransactionAggregateGroupBy";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  deductType?: Maybe<ProviderDeductTransactionType>;
  expenseType?: Maybe<ProviderExpenseType>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<ProviderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
};

export type ProviderTransactionAggregateResponse = {
  __typename?: "ProviderTransactionAggregateResponse";
  avg?: Maybe<ProviderTransactionAvgAggregate>;
  count?: Maybe<ProviderTransactionCountAggregate>;
  groupBy?: Maybe<ProviderTransactionAggregateGroupBy>;
  max?: Maybe<ProviderTransactionMaxAggregate>;
  min?: Maybe<ProviderTransactionMinAggregate>;
  sum?: Maybe<ProviderTransactionSumAggregate>;
};

export type ProviderTransactionAvgAggregate = {
  __typename?: "ProviderTransactionAvgAggregate";
  amount?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  requestId?: Maybe<Scalars["Float"]["output"]>;
};

export type ProviderTransactionConnection = {
  __typename?: "ProviderTransactionConnection";
  /** Array of nodes. */
  nodes: Array<ProviderTransaction>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type ProviderTransactionCountAggregate = {
  __typename?: "ProviderTransactionCountAggregate";
  action?: Maybe<Scalars["Int"]["output"]>;
  amount?: Maybe<Scalars["Int"]["output"]>;
  currency?: Maybe<Scalars["Int"]["output"]>;
  deductType?: Maybe<Scalars["Int"]["output"]>;
  expenseType?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  operatorId?: Maybe<Scalars["Int"]["output"]>;
  rechargeType?: Maybe<Scalars["Int"]["output"]>;
  requestId?: Maybe<Scalars["Int"]["output"]>;
};

export type ProviderTransactionFilter = {
  action?: InputMaybe<TransactionActionFilterComparison>;
  amount?: InputMaybe<NumberFieldComparison>;
  and?: InputMaybe<Array<ProviderTransactionFilter>>;
  currency?: InputMaybe<StringFieldComparison>;
  deductType?: InputMaybe<ProviderDeductTransactionTypeFilterComparison>;
  expenseType?: InputMaybe<ProviderExpenseTypeFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  operatorId?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ProviderTransactionFilter>>;
  rechargeType?: InputMaybe<ProviderRechargeTransactionTypeFilterComparison>;
  requestId?: InputMaybe<IdFilterComparison>;
};

export type ProviderTransactionInput = {
  action: TransactionAction;
  amount: Scalars["Float"]["input"];
  currency: Scalars["String"]["input"];
  deductType?: InputMaybe<ProviderDeductTransactionType>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  expenseType?: InputMaybe<ProviderExpenseType>;
  operatorId?: InputMaybe<Scalars["ID"]["input"]>;
  rechargeType?: InputMaybe<ProviderRechargeTransactionType>;
  refrenceNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type ProviderTransactionMaxAggregate = {
  __typename?: "ProviderTransactionMaxAggregate";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  deductType?: Maybe<ProviderDeductTransactionType>;
  expenseType?: Maybe<ProviderExpenseType>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<ProviderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
};

export type ProviderTransactionMinAggregate = {
  __typename?: "ProviderTransactionMinAggregate";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  deductType?: Maybe<ProviderDeductTransactionType>;
  expenseType?: Maybe<ProviderExpenseType>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<ProviderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
};

export type ProviderTransactionSort = {
  direction: SortDirection;
  field: ProviderTransactionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ProviderTransactionSortFields {
  Action = "action",
  Amount = "amount",
  Currency = "currency",
  DeductType = "deductType",
  ExpenseType = "expenseType",
  Id = "id",
  OperatorId = "operatorId",
  RechargeType = "rechargeType",
  RequestId = "requestId",
}

export type ProviderTransactionSumAggregate = {
  __typename?: "ProviderTransactionSumAggregate";
  amount?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  requestId?: Maybe<Scalars["Float"]["output"]>;
};

export type ProviderWallet = {
  __typename?: "ProviderWallet";
  balance: Scalars["Float"]["output"];
  currency: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

export type ProviderWalletFilter = {
  and?: InputMaybe<Array<ProviderWalletFilter>>;
  balance?: InputMaybe<FloatFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ProviderWalletFilter>>;
};

export type ProviderWalletSort = {
  direction: SortDirection;
  field: ProviderWalletSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ProviderWalletSortFields {
  Balance = "balance",
  Currency = "currency",
  Id = "id",
}

export type Query = {
  __typename?: "Query";
  activeInactiveDrivers: Array<ActiveInactiveUsers>;
  activeInactiveUsers: Array<ActiveInactiveUsers>;
  address: Address;
  addresses: AddressConnection;
  announcement: Announcement;
  announcements: AnnouncementConnection;
  archivedDrivers: Array<ArchivedDriver>;
  calculateFare: CalculateFare;
  campaign: Campaign;
  campaignCode: CampaignCode;
  campaignCodes: CampaignCodeConnection;
  campaigns: CampaignConnection;
  cancelReasonPopularityByName: Array<NameCount>;
  cancelReasonPopularityByUserType: Array<UserTypeCountPair>;
  carColor: CarColor;
  carColors: CarColorConnection;
  carModel: CarModel;
  carModels: CarModelConnection;
  commissionPartners: CommissionPartnerConnectionDto;
  configInformation: ConfigInformation;
  countryDistribution: Array<CountryDistribution>;
  coupon: Coupon;
  coupons: CouponConnection;
  currentConfiguration: CurrentConfiguration;
  currentUserSessions: Array<OperatorSession>;
  customerNotes: Array<CustomerNote>;
  customerPlatformDistribution: Array<PlatformDistribution>;
  customerSessions: Array<CustomerSession>;
  customersPerApp: Array<CustomerLoginPerApp>;
  dashboardRevenueByService: Array<DashboardRevenueByServiceItemDto>;
  dashboardServicePerformance: DashboardServicePerformanceDto;
  defaultDispatchService?: Maybe<Service>;
  dispatchConfig: DispatchConfig;
  dispatchPolicy: DispatchPolicy;
  dispatchPolicyHistory: Array<DispatchPolicyRevision>;
  distressSignal: DistressSignal;
  distressSignalAggregate: Array<DistressSignalAggregateResponse>;
  distressSignals: DistressSignalConnection;
  driver: Driver;
  driverAggregate: Array<DriverAggregateResponse>;
  driverArchiveHistory: Array<DriverArchiveAudit>;
  driverAvailabilitySnapshots: Array<DriverAvailabilitySnapshot>;
  driverClosingDrivers: Array<DriverClosingDriverDto>;
  driverClosingRecord: DriverClosingRecordDto;
  driverClosingRecords: DriverClosingRecordConnectionDto;
  driverCommissionReport: CommissionReportConnectionDto;
  driverCurrentVehicleAssignment?: Maybe<DriverVehicleAssignment>;
  driverDocumentRetentionPolicies: DriverDocumentRetentionPolicyConnection;
  driverDocuments: Array<DriverDocument>;
  driverFeedbackParametersSummary: Array<FeedbackParameterAggregate>;
  driverForOrderFilter?: Maybe<DriverOrderFilterOption>;
  driverLocationsByViewport: BoundedLocations;
  driverNotes: DriverNoteConnection;
  driverRegistrations: Array<RegistrationResultItem>;
  driverSessions: Array<DriverSession>;
  driverShiftRules: Array<DriverShiftRule>;
  driverTimesheets: Array<DriverTimesheet>;
  driverToDriverDocuments: DriverToDriverDocumentConnection;
  driverTransaction: DriverTransaction;
  driverTransactionAggregate: Array<DriverTransactionAggregateResponse>;
  driverTransactions: DriverTransactionConnection;
  driverTripReport: DriverTripReportConnection;
  driverTripRevenueSummary: DriverTripRevenueSummary;
  driverVehicleAssignmentHistory: Array<DriverVehicleAssignment>;
  driverVehicleAssignmentIntegritySummary: DriverVehicleAssignmentIntegritySummary;
  driverWalletAggregate: Array<DriverWalletAggregateResponse>;
  driverWallets: DriverWalletConnection;
  drivers: DriverConnection;
  eligibleDriverClosingCommissionTrips: Array<EligibleDriverClosingCommissionTripDto>;
  email: Email;
  emailProvider: EmailProvider;
  emailProviders: EmailProviderConnection;
  emailTemplate: EmailTemplate;
  emailTemplates: EmailTemplateConnection;
  emails: EmailConnection;
  export: ExportResult;
  exportCampaignCodes: Scalars["String"]["output"];
  exportDriverClosingRecord: ExportResult;
  exportDriverClosingRecords: ExportResult;
  exportDriverCommissionReport: ExportResult;
  exportDriverTransactions: Scalars["String"]["output"];
  exportDrivers: Scalars["String"]["output"];
  exportFleetTransactions: Scalars["String"]["output"];
  exportFleets: Scalars["String"]["output"];
  exportOrders: Scalars["String"]["output"];
  exportProviderTransactions: Scalars["String"]["output"];
  exportRiderTransactions: Scalars["String"]["output"];
  exportRiders: Scalars["String"]["output"];
  feedback: Feedback;
  feedbackParameter: FeedbackParameter;
  feedbackParameters: Array<FeedbackParameter>;
  feedbacks: FeedbackConnection;
  fixedFareRoutingSettings: FixedFareRoutingSettings;
  fleet: Fleet;
  fleetIncome: Array<FinancialTimeline>;
  fleetStaff: FleetStaff;
  fleetStaffSession: FleetStaffSession;
  fleetStaffSessions: Array<FleetStaffSession>;
  fleetStaffs: FleetStaffConnection;
  fleetTransaction: FleetTransaction;
  fleetTransactionAggregate: Array<FleetTransactionAggregateResponse>;
  fleetTransactions: FleetTransactionConnection;
  fleetWallet: FleetWallet;
  fleetWalletAggregate: Array<FleetWalletAggregateResponse>;
  fleetWallets: FleetWalletConnection;
  fleets: FleetConnection;
  genderDistribution: Array<GenderDistribution>;
  getDriversLocation: Array<OnlineDriver>;
  getDriversLocationWithData: Array<OnlineDriverWithData>;
  getPlaces: Array<PlaceDto>;
  getUsedUnusedCountPair: UsedUnusedCountPairDto;
  giftBatch: GiftBatch;
  giftBatches: GiftBatchConnection;
  giftCodes: GiftCodeConnection;
  incomeChart: Array<IncomeResultItem>;
  integrationRuntimeConfiguration: IntegrationRuntimeConfiguration;
  integrationRuntimePolicyRevisions: Array<IntegrationRuntimePolicyRevision>;
  login: TokenObject;
  login2: TokenObject2;
  me: Operator;
  myAdminBrowserPushRegistrations: Array<AdminBrowserPushRegistration>;
  notifications: Array<AdminNotificationUnion>;
  operator: Operator;
  operatorRole: OperatorRole;
  operatorRoles: Array<OperatorRole>;
  operatorSessions: Array<OperatorSession>;
  operators: OperatorConnection;
  order: Order;
  orderAggregate: Array<OrderAggregateResponse>;
  orderCancelReason: OrderCancelReason;
  orderCancelReasons: OrderCancelReasonConnection;
  orderVolumeTimeSeries: Array<OrderVolumeByApp>;
  orders: OrderConnection;
  paymentGateway: PaymentGateway;
  paymentGateways: PaymentGatewayConnection;
  payoutAccount: PayoutAccount;
  payoutMethod: PayoutMethod;
  payoutMethods: PayoutMethodConnection;
  placePredictions: Array<PlacePredictionDto>;
  platformKPI: PlatformKpi;
  popularRegionsByTaxiOrders: Array<NameCount>;
  previewDriverClosingRevenue: DriverClosingPreviewDto;
  pricingV2Preview: PricingV2Breakdown;
  providerExpenseBreakdownHistory: Array<ProviderExpenseBreakdownRecord>;
  providerRevenueExpenseHistory: Array<RevenueExpensePair>;
  providerTransaction: ProviderTransaction;
  providerTransactionAggregate: Array<ProviderTransactionAggregateResponse>;
  providerTransactions: ProviderTransactionConnection;
  providerWallet: ProviderWallet;
  providerWalletBalanceHistory: Array<FinancialTimeline>;
  providerWallets: Array<ProviderWallet>;
  ratingPointPopularities: Array<NameCount>;
  refreshToken: TokenObject2;
  region: Region;
  regionAggregate: Array<RegionAggregateResponse>;
  regionCategories: Array<RegionCategory>;
  regionCategory: RegionCategory;
  regionCategoryAggregate: Array<RegionCategoryAggregateResponse>;
  regions: RegionConnection;
  requestChart: Array<RequestResultItem>;
  resolvePlacePrediction: PlaceDto;
  retentionRate: Array<RetentionRate>;
  revenuePerApp: Array<RevenuePerApp>;
  reverseGeocode: PlaceDto;
  reward: Reward;
  rewards: RewardConnection;
  rider: Rider;
  riderAddress: RiderAddress;
  riderAddresses: RiderAddressConnection;
  riderAggregate: Array<RiderAggregateResponse>;
  riderDeletionPreview: RiderDeletionReviewPreview;
  riderDeletionRequests: RiderDeletionReviewPage;
  riderDisplaySettings: RiderDisplaySettings;
  riderRegistrations: Array<RegistrationResultItem>;
  riderTransaction: RiderTransaction;
  riderTransactions: RiderTransactionConnection;
  riderWallet: RiderWallet;
  riderWalletAggregate: Array<RiderWalletAggregateResponse>;
  riderWallets: RiderWalletConnection;
  riderWhatsAppSettings: RiderWhatsAppSettings;
  riders: RiderConnection;
  savedPaymentMethods: SavedPaymentMethodConnection;
  scheduledRideAssignmentDrivers: Array<ScheduledRideAssignmentDriver>;
  scheduledRideBoard: ScheduledRideBoardConnection;
  searchDispatcherCustomers: Array<Rider>;
  searchDriversForOrderFilter: Array<DriverOrderFilterOption>;
  searchVehiclesForTelematicsFilter: Array<Vehicle>;
  service: Service;
  serviceCategories: Array<ServiceCategory>;
  serviceCategory: ServiceCategory;
  serviceDistanceBands: Array<ServiceDistanceBand>;
  serviceOption: ServiceOption;
  serviceOptions: Array<ServiceOption>;
  serviceTariffProfile: ServiceTariffProfile;
  serviceTariffProfiles: ServiceTariffProfileConnection;
  services: Array<Service>;
  sms: Sms;
  smsProvider: SmsProvider;
  smsProviders: SmsProviderConnection;
  smses: SmsConnection;
  sosReason: SosReason;
  sosReasons: SosReasonConnection;
  supportedCurrencies: Array<Scalars["String"]["output"]>;
  tariffProfile: TariffProfile;
  tariffProfiles: TariffProfileConnection;
  taxiOrderNotes: TaxiOrderNoteConnection;
  taxiOrderSuccessRate?: Maybe<Scalars["Float"]["output"]>;
  taxiOrders: ActiveOrderConnection;
  taxiPayoutSession: TaxiPayoutSession;
  taxiPayoutSessions: TaxiPayoutSessionConnection;
  taxiPayoutStatistics: PayoutStatistics;
  taxiSupportRequest: TaxiSupportRequest;
  taxiSupportRequestAggregate: Array<TaxiSupportRequestAggregateResponse>;
  taxiSupportRequests: TaxiSupportRequestConnection;
  telematicsDriverIntegrityReport: TelematicsDriverReportDto;
  telematicsFeatureState: TelematicsFeatureState;
  telematicsHistorySyncStatus: TelematicsRuntimeStatusDto;
  telematicsIntegrityAlert?: Maybe<TelematicsAlertDto>;
  telematicsIntegrityAlerts: Array<TelematicsAlertDto>;
  telematicsLatestCacheConsistency: TelematicsCacheConsistencyDto;
  telematicsLiveFleet: Array<TelematicsLiveVehicleDto>;
  telematicsLiveSyncEnabled: Scalars["Boolean"]["output"];
  telematicsLiveViewEnabled: Scalars["Boolean"]["output"];
  telematicsMappingConflicts: TelematicsMappingConflicts;
  telematicsProfiles: Array<TelematicsProfile>;
  telematicsProviderCurrentStatusPreview: TelematicsCurrentStatusPreview;
  telematicsProviderInventory: TelematicsProviderInventoryPage;
  telematicsProviderInventoryItem: TelematicsProviderInventoryDetail;
  telematicsProviderSetting: TelematicsProviderSetting;
  telematicsProviderSettings: Array<TelematicsProviderSetting>;
  telematicsProviderVariables: Array<TelematicsProviderVariable>;
  telematicsRequestEvidence: TelematicsRequestEvidenceDto;
  telematicsRetentionStatus: TelematicsRuntimeStatusDto;
  telematicsShadowDiagnostics: TelematicsShadowDiagnostics;
  telematicsVehicleHistory: TelematicsVehicleHistoryDto;
  telematicsVehicleLiveStatus?: Maybe<TelematicsLiveVehicleDto>;
  topEarningDrivers: Array<LeaderboardItem>;
  topSpendingCustomers: Array<LeaderboardItem>;
  topTripsCompletedDrivers: Array<LeaderboardItem>;
  totalExpenses: TotalDailyPair;
  totalRevenue: TotalDailyPair;
  totaloutstandingUserBalances: TotalDailyPair;
  vehicleTelematicsMappings: Array<VehicleTelematicsMapping>;
  vehicleTelematicsSetup: VehicleTelematicsSetup;
  vehicles: Array<Vehicle>;
  zoneMultiplier: ZoneMultiplier;
  zoneMultipliers: ZoneMultiplierConnection;
  zonePrice: ZonePrice;
  zonePriceCategories: Array<ZonePriceCategory>;
  zonePriceCategory: ZonePriceCategory;
  zonePriceProfileFares: Array<ZonePriceProfileFare>;
  zonePrices: ZonePriceConnection;
};

export type QueryActiveInactiveUsersArgs = {
  input: ChartFilterInput;
};

export type QueryAddressArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryAddressesArgs = {
  filter?: AddressFilter;
  paging?: OffsetPaging;
  sorting?: Array<AddressSort>;
};

export type QueryAnnouncementArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryAnnouncementsArgs = {
  filter?: AnnouncementFilter;
  paging?: OffsetPaging;
  sorting?: Array<AnnouncementSort>;
};

export type QueryCalculateFareArgs = {
  input: CalculateFareInput;
};

export type QueryCampaignArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryCampaignCodeArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryCampaignCodesArgs = {
  filter?: CampaignCodeFilter;
  paging?: OffsetPaging;
  sorting?: Array<CampaignCodeSort>;
};

export type QueryCampaignsArgs = {
  filter?: CampaignFilter;
  paging?: OffsetPaging;
  sorting?: Array<CampaignSort>;
};

export type QueryCarColorArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryCarColorsArgs = {
  filter?: CarColorFilter;
  paging?: OffsetPaging;
  sorting?: Array<CarColorSort>;
};

export type QueryCarModelArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryCarModelsArgs = {
  filter?: CarModelFilter;
  paging?: OffsetPaging;
  sorting?: Array<CarModelSort>;
};

export type QueryCommissionPartnersArgs = {
  filter?: InputMaybe<CommissionPartnerFilterInput>;
  paging?: InputMaybe<ClosingPaginationInput>;
};

export type QueryCouponArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryCouponsArgs = {
  filter?: CouponFilter;
  paging?: OffsetPaging;
  sorting?: Array<CouponSort>;
};

export type QueryCustomerNotesArgs = {
  filter: CustomerNoteFilter;
  sorting?: Array<CustomerNoteSort>;
};

export type QueryCustomerSessionsArgs = {
  filter?: CustomerSessionFilter;
  sorting?: Array<CustomerSessionSort>;
};

export type QueryDispatchPolicyHistoryArgs = {
  beforeVersion?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryDistressSignalArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryDistressSignalAggregateArgs = {
  filter?: InputMaybe<DistressSignalAggregateFilter>;
};

export type QueryDistressSignalsArgs = {
  filter?: DistressSignalFilter;
  paging?: OffsetPaging;
  sorting?: Array<DistressSignalSort>;
};

export type QueryDriverArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryDriverAggregateArgs = {
  filter?: InputMaybe<DriverAggregateFilter>;
};

export type QueryDriverArchiveHistoryArgs = {
  driverId: Scalars["ID"]["input"];
};

export type QueryDriverAvailabilitySnapshotsArgs = {
  driverIds: Array<Scalars["ID"]["input"]>;
};

export type QueryDriverClosingDriversArgs = {
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryDriverClosingRecordArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryDriverClosingRecordsArgs = {
  filter?: InputMaybe<DriverClosingRecordFilterInput>;
  paging?: InputMaybe<ClosingPaginationInput>;
};

export type QueryDriverCommissionReportArgs = {
  filter?: InputMaybe<CommissionReportFilterInput>;
  paging?: InputMaybe<ClosingPaginationInput>;
};

export type QueryDriverCurrentVehicleAssignmentArgs = {
  driverId: Scalars["ID"]["input"];
};

export type QueryDriverDocumentRetentionPoliciesArgs = {
  filter?: DriverDocumentRetentionPolicyFilter;
  paging?: CursorPaging;
  sorting?: Array<DriverDocumentRetentionPolicySort>;
};

export type QueryDriverDocumentsArgs = {
  filter?: DriverDocumentFilter;
  sorting?: Array<DriverDocumentSort>;
};

export type QueryDriverFeedbackParametersSummaryArgs = {
  driverId: Scalars["ID"]["input"];
};

export type QueryDriverForOrderFilterArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryDriverLocationsByViewportArgs = {
  bounds: BoundsInput;
};

export type QueryDriverNotesArgs = {
  filter: DriverNoteFilter;
  paging?: OffsetPaging;
  sorting?: Array<DriverNoteSort>;
};

export type QueryDriverRegistrationsArgs = {
  timeframe: ChartTimeframe;
};

export type QueryDriverSessionsArgs = {
  filter?: DriverSessionFilter;
  sorting?: Array<DriverSessionSort>;
};

export type QueryDriverShiftRulesArgs = {
  filter?: DriverShiftRuleFilter;
  sorting?: Array<DriverShiftRuleSort>;
};

export type QueryDriverTimesheetsArgs = {
  input: DriverTimesheetFilterInput;
};

export type QueryDriverToDriverDocumentsArgs = {
  filter?: DriverToDriverDocumentFilter;
  paging?: CursorPaging;
  sorting?: Array<DriverToDriverDocumentSort>;
};

export type QueryDriverTransactionArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryDriverTransactionAggregateArgs = {
  filter?: InputMaybe<DriverTransactionAggregateFilter>;
};

export type QueryDriverTransactionsArgs = {
  filter?: DriverTransactionFilter;
  paging?: OffsetPaging;
  sorting?: Array<DriverTransactionSort>;
};

export type QueryDriverTripReportArgs = {
  filter?: InputMaybe<DriverTripReportFilterInput>;
  paging?: InputMaybe<PaginationInput>;
};

export type QueryDriverTripRevenueSummaryArgs = {
  dateFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  dateTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  driverId: Scalars["ID"]["input"];
};

export type QueryDriverVehicleAssignmentHistoryArgs = {
  driverId: Scalars["ID"]["input"];
};

export type QueryDriverWalletAggregateArgs = {
  filter?: InputMaybe<DriverWalletAggregateFilter>;
};

export type QueryDriverWalletsArgs = {
  filter?: DriverWalletFilter;
  paging?: OffsetPaging;
  sorting?: Array<DriverWalletSort>;
};

export type QueryDriversArgs = {
  filter?: DriverFilter;
  paging?: OffsetPaging;
  sorting?: Array<DriverSort>;
};

export type QueryEligibleDriverClosingCommissionTripsArgs = {
  input: EligibleDriverClosingCommissionTripsInput;
};

export type QueryEmailArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryEmailProviderArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryEmailProvidersArgs = {
  filter?: EmailProviderFilter;
  paging?: OffsetPaging;
  sorting?: Array<EmailProviderSort>;
};

export type QueryEmailTemplateArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryEmailTemplatesArgs = {
  filter?: EmailTemplateFilter;
  paging?: OffsetPaging;
  sorting?: Array<EmailTemplateSort>;
};

export type QueryEmailsArgs = {
  filter?: EmailFilter;
  paging?: OffsetPaging;
  sorting?: Array<EmailSort>;
};

export type QueryExportArgs = {
  input: ExportArgs;
};

export type QueryExportCampaignCodesArgs = {
  batchId: Scalars["ID"]["input"];
};

export type QueryExportDriverClosingRecordArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryExportDriverClosingRecordsArgs = {
  filter?: InputMaybe<DriverClosingRecordFilterInput>;
};

export type QueryExportDriverCommissionReportArgs = {
  filter?: InputMaybe<CommissionReportFilterInput>;
};

export type QueryExportDriverTransactionsArgs = {
  fields: Array<ExportFieldInput>;
  filter?: DriverTransactionFilter;
  format: ExportFormat;
  sorting?: Array<DriverTransactionSort>;
};

export type QueryExportDriversArgs = {
  fields: Array<ExportFieldInput>;
  filter?: DriverFilter;
  format: ExportFormat;
  sorting?: Array<DriverSort>;
};

export type QueryExportFleetTransactionsArgs = {
  fields: Array<ExportFieldInput>;
  filter?: FleetTransactionFilter;
  format: ExportFormat;
  sorting?: Array<FleetTransactionSort>;
};

export type QueryExportFleetsArgs = {
  fields: Array<ExportFieldInput>;
  filter?: FleetFilter;
  format: ExportFormat;
  sorting?: Array<FleetSort>;
};

export type QueryExportOrdersArgs = {
  fields: Array<ExportFieldInput>;
  filter?: OrderFilter;
  format: ExportFormat;
  sorting?: Array<OrderSort>;
};

export type QueryExportProviderTransactionsArgs = {
  fields: Array<ExportFieldInput>;
  filter?: ProviderTransactionFilter;
  format: ExportFormat;
  sorting?: Array<ProviderTransactionSort>;
};

export type QueryExportRiderTransactionsArgs = {
  fields: Array<ExportFieldInput>;
  filter?: RiderTransactionFilter;
  format: ExportFormat;
  sorting?: Array<RiderTransactionSort>;
};

export type QueryExportRidersArgs = {
  fields: Array<ExportFieldInput>;
  filter?: RiderFilter;
  format: ExportFormat;
  sorting?: Array<RiderSort>;
};

export type QueryFeedbackArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryFeedbackParameterArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryFeedbackParametersArgs = {
  filter?: FeedbackParameterFilter;
  sorting?: Array<FeedbackParameterSort>;
};

export type QueryFeedbacksArgs = {
  filter?: FeedbackFilter;
  paging?: OffsetPaging;
  sorting?: Array<FeedbackSort>;
};

export type QueryFleetArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryFleetIncomeArgs = {
  fleetId: Scalars["ID"]["input"];
  input: ChartFilterInput;
};

export type QueryFleetStaffArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryFleetStaffSessionArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryFleetStaffSessionsArgs = {
  filter?: FleetStaffSessionFilter;
  sorting?: Array<FleetStaffSessionSort>;
};

export type QueryFleetStaffsArgs = {
  filter?: FleetStaffFilter;
  paging?: OffsetPaging;
  sorting?: Array<FleetStaffSort>;
};

export type QueryFleetTransactionArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryFleetTransactionAggregateArgs = {
  filter?: InputMaybe<FleetTransactionAggregateFilter>;
};

export type QueryFleetTransactionsArgs = {
  filter?: FleetTransactionFilter;
  paging?: OffsetPaging;
  sorting?: Array<FleetTransactionSort>;
};

export type QueryFleetWalletArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryFleetWalletAggregateArgs = {
  filter?: InputMaybe<FleetWalletAggregateFilter>;
};

export type QueryFleetWalletsArgs = {
  filter?: FleetWalletFilter;
  paging?: OffsetPaging;
  sorting?: Array<FleetWalletSort>;
};

export type QueryFleetsArgs = {
  filter?: FleetFilter;
  paging?: OffsetPaging;
  sorting?: Array<FleetSort>;
};

export type QueryGetDriversLocationArgs = {
  center: PointInput;
  count: Scalars["Int"]["input"];
};

export type QueryGetDriversLocationWithDataArgs = {
  center: PointInput;
  count: Scalars["Int"]["input"];
  serviceId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryGetPlacesArgs = {
  apiKey?: InputMaybe<Scalars["String"]["input"]>;
  countryCode?: InputMaybe<Scalars["String"]["input"]>;
  keyword: Scalars["String"]["input"];
  language?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<PointInput>;
  provider?: InputMaybe<GeoProvider>;
  radius?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetUsedUnusedCountPairArgs = {
  campaignId: Scalars["ID"]["input"];
};

export type QueryGiftBatchArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryGiftBatchesArgs = {
  filter?: GiftBatchFilter;
  paging?: OffsetPaging;
  sorting?: Array<GiftBatchSort>;
};

export type QueryGiftCodesArgs = {
  filter?: GiftCodeFilter;
  paging?: OffsetPaging;
  sorting?: Array<GiftCodeSort>;
};

export type QueryIncomeChartArgs = {
  timeframe: ChartTimeframe;
};

export type QueryIntegrationRuntimeConfigurationArgs = {
  providerSettingId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryIntegrationRuntimePolicyRevisionsArgs = {
  page?: Scalars["Int"]["input"];
  policyType: IntegrationRuntimePolicyType;
  providerSettingId: Scalars["ID"]["input"];
};

export type QueryLoginArgs = {
  password: Scalars["String"]["input"];
  userName: Scalars["String"]["input"];
};

export type QueryLogin2Args = {
  deviceType?: DeviceType;
  password: Scalars["String"]["input"];
  platform?: DevicePlatform;
  userName: Scalars["String"]["input"];
};

export type QueryNotificationsArgs = {
  type?: InputMaybe<AdminNotificationType>;
};

export type QueryOperatorArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryOperatorRoleArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryOperatorRolesArgs = {
  filter?: OperatorRoleFilter;
  sorting?: Array<OperatorRoleSort>;
};

export type QueryOperatorSessionsArgs = {
  filter?: OperatorSessionFilter;
  sorting?: Array<OperatorSessionSort>;
};

export type QueryOperatorsArgs = {
  filter?: OperatorFilter;
  paging?: OffsetPaging;
  sorting?: Array<OperatorSort>;
};

export type QueryOrderArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryOrderAggregateArgs = {
  filter?: InputMaybe<OrderAggregateFilter>;
};

export type QueryOrderCancelReasonArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryOrderCancelReasonsArgs = {
  filter?: OrderCancelReasonFilter;
  paging?: OffsetPaging;
  sorting?: Array<OrderCancelReasonSort>;
};

export type QueryOrderVolumeTimeSeriesArgs = {
  period: KpiPeriod;
};

export type QueryOrdersArgs = {
  filter?: OrderFilter;
  paging?: OffsetPaging;
  sorting?: Array<OrderSort>;
};

export type QueryPaymentGatewayArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryPaymentGatewaysArgs = {
  filter?: PaymentGatewayFilter;
  paging?: OffsetPaging;
  sorting?: Array<PaymentGatewaySort>;
};

export type QueryPayoutAccountArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryPayoutMethodArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryPayoutMethodsArgs = {
  filter?: PayoutMethodFilter;
  paging?: OffsetPaging;
  sorting?: Array<PayoutMethodSort>;
};

export type QueryPlacePredictionsArgs = {
  countryCode?: InputMaybe<Scalars["String"]["input"]>;
  flow?: InputMaybe<Scalars["String"]["input"]>;
  languageCode?: InputMaybe<Scalars["String"]["input"]>;
  locationBias?: InputMaybe<PointInput>;
  query: Scalars["String"]["input"];
  sessionToken: Scalars["String"]["input"];
};

export type QueryPlatformKpiArgs = {
  input: PlatformKpiInput;
};

export type QueryPreviewDriverClosingRevenueArgs = {
  driverId: Scalars["ID"]["input"];
  paging?: InputMaybe<ClosingPaginationInput>;
  periodEndLocal: Scalars["String"]["input"];
  periodStartLocal: Scalars["String"]["input"];
};

export type QueryPricingV2PreviewArgs = {
  input: PricingV2PreviewInput;
};

export type QueryProviderExpenseBreakdownHistoryArgs = {
  currency: Scalars["String"]["input"];
  input: ChartFilterInput;
};

export type QueryProviderRevenueExpenseHistoryArgs = {
  currency: Scalars["String"]["input"];
  input: ChartFilterInput;
};

export type QueryProviderTransactionArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryProviderTransactionAggregateArgs = {
  filter?: InputMaybe<ProviderTransactionAggregateFilter>;
};

export type QueryProviderTransactionsArgs = {
  filter?: ProviderTransactionFilter;
  paging?: OffsetPaging;
  sorting?: Array<ProviderTransactionSort>;
};

export type QueryProviderWalletArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryProviderWalletBalanceHistoryArgs = {
  currency: Scalars["String"]["input"];
  input: ChartFilterInput;
};

export type QueryProviderWalletsArgs = {
  filter?: ProviderWalletFilter;
  sorting?: Array<ProviderWalletSort>;
};

export type QueryRefreshTokenArgs = {
  refreshToken: Scalars["String"]["input"];
};

export type QueryRegionArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryRegionAggregateArgs = {
  filter?: InputMaybe<RegionAggregateFilter>;
};

export type QueryRegionCategoriesArgs = {
  filter?: RegionCategoryFilter;
  sorting?: Array<RegionCategorySort>;
};

export type QueryRegionCategoryArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryRegionCategoryAggregateArgs = {
  filter?: InputMaybe<RegionCategoryAggregateFilter>;
};

export type QueryRegionsArgs = {
  filter?: RegionFilter;
  paging?: OffsetPaging;
  sorting?: Array<RegionSort>;
};

export type QueryRequestChartArgs = {
  timeframe: ChartTimeframe;
};

export type QueryResolvePlacePredictionArgs = {
  countryCode?: InputMaybe<Scalars["String"]["input"]>;
  flow?: InputMaybe<Scalars["String"]["input"]>;
  fullText?: InputMaybe<Scalars["String"]["input"]>;
  languageCode?: InputMaybe<Scalars["String"]["input"]>;
  placeId: Scalars["String"]["input"];
  primaryText: Scalars["String"]["input"];
  secondaryText?: InputMaybe<Scalars["String"]["input"]>;
  sessionToken: Scalars["String"]["input"];
};

export type QueryRetentionRateArgs = {
  input: ChartFilterInput;
};

export type QueryRevenuePerAppArgs = {
  input: ChartFilterInput;
};

export type QueryReverseGeocodeArgs = {
  apiKey?: InputMaybe<Scalars["String"]["input"]>;
  flow?: InputMaybe<Scalars["String"]["input"]>;
  language?: InputMaybe<Scalars["String"]["input"]>;
  location: PointInput;
  provider?: InputMaybe<GeoProvider>;
};

export type QueryRewardArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryRewardsArgs = {
  filter?: RewardFilter;
  paging?: OffsetPaging;
  sorting?: Array<RewardSort>;
};

export type QueryRiderArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryRiderAddressArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryRiderAddressesArgs = {
  filter?: RiderAddressFilter;
  paging?: OffsetPaging;
  sorting?: Array<RiderAddressSort>;
};

export type QueryRiderAggregateArgs = {
  filter?: InputMaybe<RiderAggregateFilter>;
};

export type QueryRiderDeletionPreviewArgs = {
  reference: Scalars["ID"]["input"];
};

export type QueryRiderDeletionRequestsArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryRiderRegistrationsArgs = {
  timeframe: ChartTimeframe;
};

export type QueryRiderTransactionArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryRiderTransactionsArgs = {
  filter?: RiderTransactionFilter;
  paging?: OffsetPaging;
  sorting?: Array<RiderTransactionSort>;
};

export type QueryRiderWalletArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryRiderWalletAggregateArgs = {
  filter?: InputMaybe<RiderWalletAggregateFilter>;
};

export type QueryRiderWalletsArgs = {
  filter?: RiderWalletFilter;
  paging?: OffsetPaging;
  sorting?: Array<RiderWalletSort>;
};

export type QueryRidersArgs = {
  filter?: RiderFilter;
  paging?: OffsetPaging;
  sorting?: Array<RiderSort>;
};

export type QuerySavedPaymentMethodsArgs = {
  filter?: SavedPaymentMethodFilter;
  paging?: OffsetPaging;
  sorting?: Array<SavedPaymentMethodSort>;
};

export type QueryScheduledRideAssignmentDriversArgs = {
  orderId: Scalars["ID"]["input"];
};

export type QueryScheduledRideBoardArgs = {
  filter?: InputMaybe<ScheduledRideFilterInput>;
};

export type QuerySearchDispatcherCustomersArgs = {
  keyword: Scalars["String"]["input"];
};

export type QuerySearchDriversForOrderFilterArgs = {
  limit?: Scalars["Int"]["input"];
  query: Scalars["String"]["input"];
};

export type QuerySearchVehiclesForTelematicsFilterArgs = {
  limit?: Scalars["Int"]["input"];
  query: Scalars["String"]["input"];
};

export type QueryServiceArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryServiceCategoriesArgs = {
  filter?: ServiceCategoryFilter;
  sorting?: Array<ServiceCategorySort>;
};

export type QueryServiceCategoryArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryServiceDistanceBandsArgs = {
  serviceId: Scalars["ID"]["input"];
  tariffProfileId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryServiceOptionArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryServiceOptionsArgs = {
  filter?: ServiceOptionFilter;
  sorting?: Array<ServiceOptionSort>;
};

export type QueryServiceTariffProfileArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryServiceTariffProfilesArgs = {
  filter?: ServiceTariffProfileFilter;
  paging?: OffsetPaging;
  sorting?: Array<ServiceTariffProfileSort>;
};

export type QueryServicesArgs = {
  filter?: ServiceFilter;
  sorting?: Array<ServiceSort>;
};

export type QuerySmsArgs = {
  id: Scalars["ID"]["input"];
};

export type QuerySmsProviderArgs = {
  id: Scalars["ID"]["input"];
};

export type QuerySmsProvidersArgs = {
  filter?: SmsProviderFilter;
  paging?: OffsetPaging;
  sorting?: Array<SmsProviderSort>;
};

export type QuerySmsesArgs = {
  filter?: SmsFilter;
  paging?: OffsetPaging;
  sorting?: Array<SmsSort>;
};

export type QuerySosReasonArgs = {
  id: Scalars["ID"]["input"];
};

export type QuerySosReasonsArgs = {
  filter?: SosReasonFilter;
  paging?: OffsetPaging;
  sorting?: Array<SosReasonSort>;
};

export type QueryTariffProfileArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryTariffProfilesArgs = {
  filter?: TariffProfileFilter;
  paging?: OffsetPaging;
  sorting?: Array<TariffProfileSort>;
};

export type QueryTaxiOrderNotesArgs = {
  filter: TaxiOrderNoteFilter;
  paging?: OffsetPaging;
  sorting?: Array<TaxiOrderNoteSort>;
};

export type QueryTaxiOrderSuccessRateArgs = {
  endTime?: InputMaybe<Scalars["DateTime"]["input"]>;
  startTime?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type QueryTaxiOrdersArgs = {
  filter?: InputMaybe<TaxiOrderFilterInput>;
  paging?: InputMaybe<PaginationInput>;
  sorting?: InputMaybe<TaxiOrderSortInput>;
};

export type QueryTaxiPayoutSessionArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryTaxiPayoutSessionsArgs = {
  filter?: TaxiPayoutSessionFilter;
  paging?: OffsetPaging;
  sorting?: Array<TaxiPayoutSessionSort>;
};

export type QueryTaxiPayoutStatisticsArgs = {
  currency?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryTaxiSupportRequestArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryTaxiSupportRequestAggregateArgs = {
  filter?: InputMaybe<TaxiSupportRequestAggregateFilter>;
};

export type QueryTaxiSupportRequestsArgs = {
  filter?: TaxiSupportRequestFilter;
  paging?: OffsetPaging;
  sorting?: Array<TaxiSupportRequestSort>;
};

export type QueryTelematicsDriverIntegrityReportArgs = {
  alertType?: InputMaybe<Scalars["String"]["input"]>;
  dateFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  dateTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  driverId?: InputMaybe<Scalars["ID"]["input"]>;
  reviewStatus?: InputMaybe<Scalars["String"]["input"]>;
  severity?: InputMaybe<Scalars["String"]["input"]>;
  vehicleId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryTelematicsIntegrityAlertArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryTelematicsIntegrityAlertsArgs = {
  attribution?: InputMaybe<Scalars["String"]["input"]>;
  dateFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  dateTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  driverId?: InputMaybe<Scalars["ID"]["input"]>;
  orderId?: InputMaybe<Scalars["ID"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  severity?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  vehicleId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryTelematicsLiveFleetArgs = {
  capability?: InputMaybe<Scalars["String"]["input"]>;
  driverId?: InputMaybe<Scalars["ID"]["input"]>;
  freshness?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  signalState?: InputMaybe<Scalars["String"]["input"]>;
  vehicleId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryTelematicsProfilesArgs = {
  includeInactive?: Scalars["Boolean"]["input"];
  providerSettingId: Scalars["ID"]["input"];
};

export type QueryTelematicsProviderCurrentStatusPreviewArgs = {
  providerSettingId: Scalars["ID"]["input"];
  providerUserId: Scalars["String"]["input"];
};

export type QueryTelematicsProviderInventoryArgs = {
  fromIndex?: Scalars["Int"]["input"];
  pageSize?: Scalars["Int"]["input"];
  providerSettingId: Scalars["ID"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryTelematicsProviderInventoryItemArgs = {
  providerSettingId: Scalars["ID"]["input"];
  providerUserId: Scalars["String"]["input"];
};

export type QueryTelematicsProviderSettingArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryTelematicsProviderVariablesArgs = {
  providerSettingId: Scalars["ID"]["input"];
};

export type QueryTelematicsRequestEvidenceArgs = {
  orderId: Scalars["ID"]["input"];
};

export type QueryTelematicsShadowDiagnosticsArgs = {
  vehicleId: Scalars["ID"]["input"];
};

export type QueryTelematicsVehicleHistoryArgs = {
  dateFrom: Scalars["DateTime"]["input"];
  dateTo: Scalars["DateTime"]["input"];
  vehicleId: Scalars["ID"]["input"];
};

export type QueryTelematicsVehicleLiveStatusArgs = {
  vehicleId: Scalars["ID"]["input"];
};

export type QueryTopEarningDriversArgs = {
  currency: Scalars["String"]["input"];
};

export type QueryTotalExpensesArgs = {
  currency: Scalars["String"]["input"];
};

export type QueryTotalRevenueArgs = {
  currency: Scalars["String"]["input"];
};

export type QueryTotaloutstandingUserBalancesArgs = {
  currency: Scalars["String"]["input"];
};

export type QueryVehicleTelematicsMappingsArgs = {
  includeEnded?: Scalars["Boolean"]["input"];
  vehicleId: Scalars["ID"]["input"];
};

export type QueryVehicleTelematicsSetupArgs = {
  vehicleId: Scalars["ID"]["input"];
};

export type QueryZoneMultiplierArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryZoneMultipliersArgs = {
  filter?: ZoneMultiplierFilter;
  paging?: OffsetPaging;
  sorting?: Array<ZoneMultiplierSort>;
};

export type QueryZonePriceArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryZonePriceCategoriesArgs = {
  filter?: ZonePriceCategoryFilter;
  sorting?: Array<ZonePriceCategorySort>;
};

export type QueryZonePriceCategoryArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryZonePriceProfileFaresArgs = {
  zonePriceId: Scalars["ID"]["input"];
};

export type QueryZonePricesArgs = {
  filter?: ZonePriceFilter;
  paging?: OffsetPaging;
  sorting?: Array<ZonePriceSort>;
};

export type RadiusExpansionConfig = {
  __typename?: "RadiusExpansionConfig";
  /** Enable radius expansion for dispatch */
  enabled: Scalars["Boolean"]["output"];
  /** Interval in seconds between radius expansion steps */
  intervalSeconds: Scalars["Int"]["output"];
  /** Maximum number of steps for radius expansion */
  maxSteps: Scalars["Int"]["output"];
  /** Step size in meters for radius expansion */
  stepMeters: Scalars["Int"]["output"];
};

export type RadiusExpansionConfigInput = {
  /** Enable radius expansion for dispatch */
  enabled: Scalars["Boolean"]["input"];
  /** Interval in seconds between radius expansion steps */
  intervalSeconds: Scalars["Int"]["input"];
  /** Maximum number of steps for radius expansion */
  maxSteps: Scalars["Int"]["input"];
  /** Step size in meters for radius expansion */
  stepMeters: Scalars["Int"]["input"];
};

export type RangeCost = {
  __typename?: "RangeCost";
  cost: Scalars["Float"]["output"];
  max: Scalars["Float"]["output"];
  min: Scalars["Float"]["output"];
  mode: PricingMode;
  rangePolicy: RangePolicy;
};

export enum RangePolicy {
  Enforce = "ENFORCE",
  Open = "OPEN",
  Soft = "SOFT",
}

export type RatingAggregate = {
  __typename?: "RatingAggregate";
  rating?: Maybe<Scalars["Int"]["output"]>;
  reviewCount: Scalars["Int"]["output"];
};

export type RatingAggregateInput = {
  rating?: InputMaybe<Scalars["Int"]["input"]>;
  reviewCount: Scalars["Int"]["input"];
};

export type Region = {
  __typename?: "Region";
  category?: Maybe<RegionCategory>;
  categoryId?: Maybe<Scalars["ID"]["output"]>;
  currency: Scalars["String"]["output"];
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  location: Array<Array<Point>>;
  name: Scalars["String"]["output"];
  taxiOrders: RegionTaxiOrdersConnection;
  taxiOrdersAggregate: Array<RegionTaxiOrdersAggregateResponse>;
};

export type RegionTaxiOrdersArgs = {
  filter?: OrderFilter;
  paging?: OffsetPaging;
  sorting?: Array<OrderSort>;
};

export type RegionTaxiOrdersAggregateArgs = {
  filter?: InputMaybe<OrderAggregateFilter>;
};

export type RegionAggregateFilter = {
  and?: InputMaybe<Array<RegionAggregateFilter>>;
  categoryId?: InputMaybe<IdFilterComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<RegionAggregateFilter>>;
};

export type RegionAggregateGroupBy = {
  __typename?: "RegionAggregateGroupBy";
  categoryId?: Maybe<Scalars["ID"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type RegionAggregateResponse = {
  __typename?: "RegionAggregateResponse";
  avg?: Maybe<RegionAvgAggregate>;
  count?: Maybe<RegionCountAggregate>;
  groupBy?: Maybe<RegionAggregateGroupBy>;
  max?: Maybe<RegionMaxAggregate>;
  min?: Maybe<RegionMinAggregate>;
  sum?: Maybe<RegionSumAggregate>;
};

export type RegionAvgAggregate = {
  __typename?: "RegionAvgAggregate";
  categoryId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type RegionCategory = {
  __typename?: "RegionCategory";
  currency: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  regions: RegionCategoryRegionsConnection;
  regionsAggregate: Array<RegionCategoryRegionsAggregateResponse>;
};

export type RegionCategoryRegionsArgs = {
  filter?: RegionFilter;
  paging?: OffsetPaging;
  sorting?: Array<RegionSort>;
};

export type RegionCategoryRegionsAggregateArgs = {
  filter?: InputMaybe<RegionAggregateFilter>;
};

export type RegionCategoryAggregateFilter = {
  and?: InputMaybe<Array<RegionCategoryAggregateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<RegionCategoryAggregateFilter>>;
};

export type RegionCategoryAggregateGroupBy = {
  __typename?: "RegionCategoryAggregateGroupBy";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type RegionCategoryAggregateResponse = {
  __typename?: "RegionCategoryAggregateResponse";
  avg?: Maybe<RegionCategoryAvgAggregate>;
  count?: Maybe<RegionCategoryCountAggregate>;
  groupBy?: Maybe<RegionCategoryAggregateGroupBy>;
  max?: Maybe<RegionCategoryMaxAggregate>;
  min?: Maybe<RegionCategoryMinAggregate>;
  sum?: Maybe<RegionCategorySumAggregate>;
};

export type RegionCategoryAvgAggregate = {
  __typename?: "RegionCategoryAvgAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type RegionCategoryCountAggregate = {
  __typename?: "RegionCategoryCountAggregate";
  id?: Maybe<Scalars["Int"]["output"]>;
};

export type RegionCategoryDeleteResponse = {
  __typename?: "RegionCategoryDeleteResponse";
  currency?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type RegionCategoryFilter = {
  and?: InputMaybe<Array<RegionCategoryFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<RegionCategoryFilter>>;
};

export type RegionCategoryInput = {
  currency: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
};

export type RegionCategoryMaxAggregate = {
  __typename?: "RegionCategoryMaxAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type RegionCategoryMinAggregate = {
  __typename?: "RegionCategoryMinAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type RegionCategoryRegionsAggregateGroupBy = {
  __typename?: "RegionCategoryRegionsAggregateGroupBy";
  categoryId?: Maybe<Scalars["ID"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type RegionCategoryRegionsAggregateResponse = {
  __typename?: "RegionCategoryRegionsAggregateResponse";
  avg?: Maybe<RegionCategoryRegionsAvgAggregate>;
  count?: Maybe<RegionCategoryRegionsCountAggregate>;
  groupBy?: Maybe<RegionCategoryRegionsAggregateGroupBy>;
  max?: Maybe<RegionCategoryRegionsMaxAggregate>;
  min?: Maybe<RegionCategoryRegionsMinAggregate>;
  sum?: Maybe<RegionCategoryRegionsSumAggregate>;
};

export type RegionCategoryRegionsAvgAggregate = {
  __typename?: "RegionCategoryRegionsAvgAggregate";
  categoryId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type RegionCategoryRegionsConnection = {
  __typename?: "RegionCategoryRegionsConnection";
  /** Array of nodes. */
  nodes: Array<Region>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type RegionCategoryRegionsCountAggregate = {
  __typename?: "RegionCategoryRegionsCountAggregate";
  categoryId?: Maybe<Scalars["Int"]["output"]>;
  currency?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["Int"]["output"]>;
};

export type RegionCategoryRegionsMaxAggregate = {
  __typename?: "RegionCategoryRegionsMaxAggregate";
  categoryId?: Maybe<Scalars["ID"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type RegionCategoryRegionsMinAggregate = {
  __typename?: "RegionCategoryRegionsMinAggregate";
  categoryId?: Maybe<Scalars["ID"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type RegionCategoryRegionsSumAggregate = {
  __typename?: "RegionCategoryRegionsSumAggregate";
  categoryId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type RegionCategorySort = {
  direction: SortDirection;
  field: RegionCategorySortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum RegionCategorySortFields {
  Id = "id",
}

export type RegionCategorySumAggregate = {
  __typename?: "RegionCategorySumAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type RegionConnection = {
  __typename?: "RegionConnection";
  /** Array of nodes. */
  nodes: Array<Region>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type RegionCountAggregate = {
  __typename?: "RegionCountAggregate";
  categoryId?: Maybe<Scalars["Int"]["output"]>;
  currency?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["Int"]["output"]>;
};

export type RegionDeleteResponse = {
  __typename?: "RegionDeleteResponse";
  categoryId?: Maybe<Scalars["ID"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  location?: Maybe<Array<Array<Point>>>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type RegionFilter = {
  and?: InputMaybe<Array<RegionFilter>>;
  categoryId?: InputMaybe<IdFilterComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<RegionFilter>>;
};

export type RegionMaxAggregate = {
  __typename?: "RegionMaxAggregate";
  categoryId?: Maybe<Scalars["ID"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type RegionMinAggregate = {
  __typename?: "RegionMinAggregate";
  categoryId?: Maybe<Scalars["ID"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type RegionSort = {
  direction: SortDirection;
  field: RegionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum RegionSortFields {
  CategoryId = "categoryId",
  Currency = "currency",
  Id = "id",
  Name = "name",
}

export type RegionSumAggregate = {
  __typename?: "RegionSumAggregate";
  categoryId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type RegionTaxiOrdersAggregateGroupBy = {
  __typename?: "RegionTaxiOrdersAggregateGroupBy";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  createdOn?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  distanceBest?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  durationBest?: Maybe<Scalars["Int"]["output"]>;
  fareMode?: Maybe<FareMode>;
  finishTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  orderSource?: Maybe<OrderSource>;
  paymentMode?: Maybe<PaymentMode>;
  regionId?: Maybe<Scalars["ID"]["output"]>;
  reportingSource?: Maybe<OrderSource>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  routeSource?: Maybe<RouteSource>;
  serviceId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<OrderStatus>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
  type?: Maybe<TaxiOrderType>;
};

export type RegionTaxiOrdersAggregateResponse = {
  __typename?: "RegionTaxiOrdersAggregateResponse";
  avg?: Maybe<RegionTaxiOrdersAvgAggregate>;
  count?: Maybe<RegionTaxiOrdersCountAggregate>;
  groupBy?: Maybe<RegionTaxiOrdersAggregateGroupBy>;
  max?: Maybe<RegionTaxiOrdersMaxAggregate>;
  min?: Maybe<RegionTaxiOrdersMinAggregate>;
  sum?: Maybe<RegionTaxiOrdersSumAggregate>;
};

export type RegionTaxiOrdersAvgAggregate = {
  __typename?: "RegionTaxiOrdersAvgAggregate";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  distanceBest?: Maybe<Scalars["Float"]["output"]>;
  driverId?: Maybe<Scalars["Float"]["output"]>;
  durationBest?: Maybe<Scalars["Float"]["output"]>;
  fleetId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  regionId?: Maybe<Scalars["Float"]["output"]>;
  riderId?: Maybe<Scalars["Float"]["output"]>;
  serviceId?: Maybe<Scalars["Float"]["output"]>;
  tariffProfileId?: Maybe<Scalars["Float"]["output"]>;
};

export type RegionTaxiOrdersConnection = {
  __typename?: "RegionTaxiOrdersConnection";
  /** Array of nodes. */
  nodes: Array<Order>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type RegionTaxiOrdersCountAggregate = {
  __typename?: "RegionTaxiOrdersCountAggregate";
  costAfterCoupon?: Maybe<Scalars["Int"]["output"]>;
  costBest?: Maybe<Scalars["Int"]["output"]>;
  createdOn?: Maybe<Scalars["Int"]["output"]>;
  currency?: Maybe<Scalars["Int"]["output"]>;
  distanceBest?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["Int"]["output"]>;
  durationBest?: Maybe<Scalars["Int"]["output"]>;
  fareMode?: Maybe<Scalars["Int"]["output"]>;
  finishTimestamp?: Maybe<Scalars["Int"]["output"]>;
  fleetId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  operatorId?: Maybe<Scalars["Int"]["output"]>;
  orderSource?: Maybe<Scalars["Int"]["output"]>;
  paymentMode?: Maybe<Scalars["Int"]["output"]>;
  regionId?: Maybe<Scalars["Int"]["output"]>;
  reportingSource?: Maybe<Scalars["Int"]["output"]>;
  riderId?: Maybe<Scalars["Int"]["output"]>;
  routeSource?: Maybe<Scalars["Int"]["output"]>;
  serviceId?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
  tariffProfileId?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Scalars["Int"]["output"]>;
};

export type RegionTaxiOrdersMaxAggregate = {
  __typename?: "RegionTaxiOrdersMaxAggregate";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  createdOn?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  distanceBest?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  durationBest?: Maybe<Scalars["Int"]["output"]>;
  fareMode?: Maybe<FareMode>;
  finishTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  orderSource?: Maybe<OrderSource>;
  paymentMode?: Maybe<PaymentMode>;
  regionId?: Maybe<Scalars["ID"]["output"]>;
  reportingSource?: Maybe<OrderSource>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  routeSource?: Maybe<RouteSource>;
  serviceId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<OrderStatus>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
  type?: Maybe<TaxiOrderType>;
};

export type RegionTaxiOrdersMinAggregate = {
  __typename?: "RegionTaxiOrdersMinAggregate";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  createdOn?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  distanceBest?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  durationBest?: Maybe<Scalars["Int"]["output"]>;
  fareMode?: Maybe<FareMode>;
  finishTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  orderSource?: Maybe<OrderSource>;
  paymentMode?: Maybe<PaymentMode>;
  regionId?: Maybe<Scalars["ID"]["output"]>;
  reportingSource?: Maybe<OrderSource>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  routeSource?: Maybe<RouteSource>;
  serviceId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<OrderStatus>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
  type?: Maybe<TaxiOrderType>;
};

export type RegionTaxiOrdersSumAggregate = {
  __typename?: "RegionTaxiOrdersSumAggregate";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  distanceBest?: Maybe<Scalars["Float"]["output"]>;
  driverId?: Maybe<Scalars["Float"]["output"]>;
  durationBest?: Maybe<Scalars["Float"]["output"]>;
  fleetId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  regionId?: Maybe<Scalars["Float"]["output"]>;
  riderId?: Maybe<Scalars["Float"]["output"]>;
  serviceId?: Maybe<Scalars["Float"]["output"]>;
  tariffProfileId?: Maybe<Scalars["Float"]["output"]>;
};

export type RegistrationResultItem = {
  __typename?: "RegistrationResultItem";
  count: Scalars["Int"]["output"];
  time: Scalars["String"]["output"];
};

export type ReplaceVehicleTelematicsMappingInput = {
  acceptDegradedCapability?: Scalars["Boolean"]["input"];
  confirmed: Scalars["Boolean"]["input"];
  mappingId: Scalars["ID"]["input"];
  profileId: Scalars["ID"]["input"];
  providerDeviceId?: InputMaybe<Scalars["String"]["input"]>;
  providerUserId: Scalars["String"]["input"];
  reason: Scalars["String"]["input"];
};

export type RequestActivity = {
  __typename?: "RequestActivity";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  operator?: Maybe<Operator>;
  operatorDisplayName?: Maybe<Scalars["String"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  type: RequestActivityType;
};

export type RequestActivityAggregateFilter = {
  and?: InputMaybe<Array<RequestActivityAggregateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<RequestActivityAggregateFilter>>;
};

export type RequestActivityFilter = {
  and?: InputMaybe<Array<RequestActivityFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<RequestActivityFilter>>;
};

export type RequestActivitySort = {
  direction: SortDirection;
  field: RequestActivitySortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum RequestActivitySortFields {
  Id = "id",
}

export enum RequestActivityType {
  ArrivedToDestination = "ArrivedToDestination",
  ArrivedToPickupPoint = "ArrivedToPickupPoint",
  AssignedByOperator = "AssignedByOperator",
  BookedByOperator = "BookedByOperator",
  BookedByRider = "BookedByRider",
  CanceledByDriver = "CanceledByDriver",
  CanceledByOperator = "CanceledByOperator",
  CanceledByRider = "CanceledByRider",
  DriverAccepted = "DriverAccepted",
  Expired = "Expired",
  Paid = "Paid",
  RequestedByOperator = "RequestedByOperator",
  RequestedByRider = "RequestedByRider",
  Reviewed = "Reviewed",
  Started = "Started",
}

export type RequestResultItem = {
  __typename?: "RequestResultItem";
  count: Scalars["Int"]["output"];
  status: OrderStatus;
  time: Scalars["String"]["output"];
};

export type RetentionRate = {
  __typename?: "RetentionRate";
  /** Any date within the range of revenue interval. */
  date: Scalars["DateTime"]["output"];
  retentionRate: Scalars["Float"]["output"];
};

export type RevenueExpensePair = {
  __typename?: "RevenueExpensePair";
  anyDate: Scalars["DateTime"]["output"];
  dateString: Scalars["String"]["output"];
  expense: Scalars["Float"]["output"];
  revenue: Scalars["Float"]["output"];
};

export type RevenuePerApp = {
  __typename?: "RevenuePerApp";
  app: AppType;
  /** Any date within the range of revenue interval. */
  date: Scalars["DateTime"]["output"];
  revenue: Scalars["Float"]["output"];
};

export type Reward = {
  __typename?: "Reward";
  appType: RewardAppType;
  beneficiary: RewardBeneficiary;
  conditionTripCountsLessThan?: Maybe<Scalars["Float"]["output"]>;
  conditionUserNumberFirstDigits?: Maybe<Array<Scalars["String"]["output"]>>;
  creditCurrency?: Maybe<Scalars["String"]["output"]>;
  creditGift: Scalars["Float"]["output"];
  endDate?: Maybe<Scalars["DateTime"]["output"]>;
  event: RewardEvent;
  id: Scalars["ID"]["output"];
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
  title: Scalars["String"]["output"];
  tripFeePercentGift?: Maybe<Scalars["Float"]["output"]>;
};

export enum RewardAppType {
  Driver = "Driver",
  Rider = "Rider",
}

export enum RewardBeneficiary {
  Referrer = "Referrer",
  Self = "Self",
}

export type RewardConnection = {
  __typename?: "RewardConnection";
  /** Array of nodes. */
  nodes: Array<Reward>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type RewardDeleteResponse = {
  __typename?: "RewardDeleteResponse";
  appType?: Maybe<RewardAppType>;
  beneficiary?: Maybe<RewardBeneficiary>;
  conditionTripCountsLessThan?: Maybe<Scalars["Float"]["output"]>;
  conditionUserNumberFirstDigits?: Maybe<Array<Scalars["String"]["output"]>>;
  creditCurrency?: Maybe<Scalars["String"]["output"]>;
  creditGift?: Maybe<Scalars["Float"]["output"]>;
  endDate?: Maybe<Scalars["DateTime"]["output"]>;
  event?: Maybe<RewardEvent>;
  id?: Maybe<Scalars["ID"]["output"]>;
  startDate?: Maybe<Scalars["DateTime"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  tripFeePercentGift?: Maybe<Scalars["Float"]["output"]>;
};

export enum RewardEvent {
  Register = "Register",
  ServiceCompleted = "ServiceCompleted",
}

export type RewardFilter = {
  and?: InputMaybe<Array<RewardFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<RewardFilter>>;
};

export type RewardSort = {
  direction: SortDirection;
  field: RewardSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum RewardSortFields {
  Id = "id",
}

export type RideOffer = {
  __typename?: "RideOffer";
  /** The maximum cost estimate for the order. */
  costMax?: Maybe<Scalars["Float"]["output"]>;
  /** The minimum cost estimate for the order. */
  costMin?: Maybe<Scalars["Float"]["output"]>;
  currency: Scalars["String"]["output"];
  /** The directions for the order from driver to passenger. */
  directions: Array<Point>;
  dispatchedToUserAt?: Maybe<Scalars["DateTime"]["output"]>;
  dispatcherNote?: Maybe<Scalars["String"]["output"]>;
  /** The total distance in meters for the order. */
  distance: Scalars["Int"]["output"];
  /** The total duration in seconds for the order */
  duration: Scalars["Int"]["output"];
  expiresAt?: Maybe<Scalars["DateTime"]["output"]>;
  fareEstimate: Scalars["Float"]["output"];
  fareMode: FareMode;
  id: Scalars["ID"]["output"];
  options: Array<RideOption>;
  passenger?: Maybe<PassengerInformation>;
  pricingMode: PricingMode;
  rangePolicy?: Maybe<RangePolicy>;
  serviceImageAddress: Scalars["String"]["output"];
  serviceName: Scalars["String"]["output"];
  type: TaxiOrderType;
  waypoints: Array<WaypointBase>;
};

export type RideOption = {
  __typename?: "RideOption";
  icon: ServiceOptionIcon;
  name: Scalars["String"]["output"];
};

export type RideWaypoint = WaypointBase & {
  __typename?: "RideWaypoint";
  address: Scalars["String"]["output"];
  deliveryContact?: Maybe<DeliveryContact>;
  location: Point;
  role: WaypointRole;
  service: WaypointService;
};

export type Rider = {
  __typename?: "Rider";
  addresses: RiderAddressesConnection;
  addressesAggregate: Array<RiderAddressesAggregateResponse>;
  /** Country ISO code. For example "GB" for United Kingdom, "CA" for Canada, "AU" for Australia, etc. */
  countryIso?: Maybe<Scalars["String"]["output"]>;
  countryOfResidence?: Maybe<Scalars["String"]["output"]>;
  createdByDispatcherOperator?: Maybe<Operator>;
  createdByDispatcherOperatorId?: Maybe<Scalars["ID"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  gender?: Maybe<Gender>;
  id: Scalars["ID"]["output"];
  idNumber?: Maybe<Scalars["String"]["output"]>;
  isResident?: Maybe<Scalars["Boolean"]["output"]>;
  lastActivityAt?: Maybe<Scalars["DateTime"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  media?: Maybe<Media>;
  mobileNumber?: Maybe<Scalars["String"]["output"]>;
  nationality?: Maybe<Scalars["String"]["output"]>;
  orders: RiderOrdersConnection;
  ordersAggregate: Array<RiderOrdersAggregateResponse>;
  ratingAggregate?: Maybe<RatingAggregate>;
  registrationTimestamp: Scalars["DateTime"]["output"];
  status: RiderStatus;
  tariffProfile?: Maybe<TariffProfile>;
  tariffProfileCode?: Maybe<Scalars["String"]["output"]>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
  tariffProfileTitle?: Maybe<Scalars["String"]["output"]>;
  transactions: RiderTransactionsConnection;
  transactionsAggregate: Array<RiderTransactionsAggregateResponse>;
  wallet: Array<RiderWallet>;
  walletAggregate: Array<RiderWalletAggregateResponse>;
};

export type RiderAddressesArgs = {
  filter?: RiderAddressFilter;
  paging?: OffsetPaging;
  sorting?: Array<RiderAddressSort>;
};

export type RiderAddressesAggregateArgs = {
  filter?: InputMaybe<RiderAddressAggregateFilter>;
};

export type RiderOrdersArgs = {
  filter?: OrderFilter;
  paging?: OffsetPaging;
  sorting?: Array<OrderSort>;
};

export type RiderOrdersAggregateArgs = {
  filter?: InputMaybe<OrderAggregateFilter>;
};

export type RiderTransactionsArgs = {
  filter?: RiderTransactionFilter;
  paging?: OffsetPaging;
  sorting?: Array<RiderTransactionSort>;
};

export type RiderTransactionsAggregateArgs = {
  filter?: InputMaybe<RiderTransactionAggregateFilter>;
};

export type RiderWalletArgs = {
  filter?: RiderWalletFilter;
  sorting?: Array<RiderWalletSort>;
};

export type RiderWalletAggregateArgs = {
  filter?: InputMaybe<RiderWalletAggregateFilter>;
};

export type RiderAddress = {
  __typename?: "RiderAddress";
  details?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  location: Point;
  riderId: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
  type: RiderAddressType;
};

export type RiderAddressAggregateFilter = {
  and?: InputMaybe<Array<RiderAddressAggregateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<RiderAddressAggregateFilter>>;
  riderId?: InputMaybe<IdFilterComparison>;
};

export type RiderAddressConnection = {
  __typename?: "RiderAddressConnection";
  /** Array of nodes. */
  nodes: Array<RiderAddress>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type RiderAddressFilter = {
  and?: InputMaybe<Array<RiderAddressFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<RiderAddressFilter>>;
  riderId?: InputMaybe<IdFilterComparison>;
};

export type RiderAddressSort = {
  direction: SortDirection;
  field: RiderAddressSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum RiderAddressSortFields {
  Id = "id",
  RiderId = "riderId",
}

export enum RiderAddressType {
  Cafe = "Cafe",
  Gym = "Gym",
  Home = "Home",
  Other = "Other",
  Parent = "Parent",
  Park = "Park",
  Partner = "Partner",
  Work = "Work",
}

export type RiderAddressUpdateFilter = {
  and?: InputMaybe<Array<RiderAddressUpdateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<RiderAddressUpdateFilter>>;
  riderId?: InputMaybe<IdFilterComparison>;
};

export type RiderAddressesAggregateGroupBy = {
  __typename?: "RiderAddressesAggregateGroupBy";
  id?: Maybe<Scalars["ID"]["output"]>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
};

export type RiderAddressesAggregateResponse = {
  __typename?: "RiderAddressesAggregateResponse";
  avg?: Maybe<RiderAddressesAvgAggregate>;
  count?: Maybe<RiderAddressesCountAggregate>;
  groupBy?: Maybe<RiderAddressesAggregateGroupBy>;
  max?: Maybe<RiderAddressesMaxAggregate>;
  min?: Maybe<RiderAddressesMinAggregate>;
  sum?: Maybe<RiderAddressesSumAggregate>;
};

export type RiderAddressesAvgAggregate = {
  __typename?: "RiderAddressesAvgAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
  riderId?: Maybe<Scalars["Float"]["output"]>;
};

export type RiderAddressesConnection = {
  __typename?: "RiderAddressesConnection";
  /** Array of nodes. */
  nodes: Array<RiderAddress>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type RiderAddressesCountAggregate = {
  __typename?: "RiderAddressesCountAggregate";
  id?: Maybe<Scalars["Int"]["output"]>;
  riderId?: Maybe<Scalars["Int"]["output"]>;
};

export type RiderAddressesMaxAggregate = {
  __typename?: "RiderAddressesMaxAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
};

export type RiderAddressesMinAggregate = {
  __typename?: "RiderAddressesMinAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
};

export type RiderAddressesSumAggregate = {
  __typename?: "RiderAddressesSumAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
  riderId?: Maybe<Scalars["Float"]["output"]>;
};

export type RiderAggregateFilter = {
  and?: InputMaybe<Array<RiderAggregateFilter>>;
  createdByDispatcherOperatorId?: InputMaybe<IdFilterComparison>;
  firstName?: InputMaybe<StringFieldComparison>;
  gender?: InputMaybe<GenderFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  lastName?: InputMaybe<StringFieldComparison>;
  mobileNumber?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<RiderAggregateFilter>>;
  status?: InputMaybe<RiderStatusFilterComparison>;
  tariffProfileId?: InputMaybe<IdFilterComparison>;
};

export type RiderAggregateGroupBy = {
  __typename?: "RiderAggregateGroupBy";
  createdByDispatcherOperatorId?: Maybe<Scalars["ID"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  gender?: Maybe<Gender>;
  id?: Maybe<Scalars["ID"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  mobileNumber?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<RiderStatus>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
};

export type RiderAggregateResponse = {
  __typename?: "RiderAggregateResponse";
  avg?: Maybe<RiderAvgAggregate>;
  count?: Maybe<RiderCountAggregate>;
  groupBy?: Maybe<RiderAggregateGroupBy>;
  max?: Maybe<RiderMaxAggregate>;
  min?: Maybe<RiderMinAggregate>;
  sum?: Maybe<RiderSumAggregate>;
};

export type RiderAvgAggregate = {
  __typename?: "RiderAvgAggregate";
  createdByDispatcherOperatorId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  tariffProfileId?: Maybe<Scalars["Float"]["output"]>;
};

export type RiderConnection = {
  __typename?: "RiderConnection";
  /** Array of nodes. */
  nodes: Array<Rider>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type RiderCountAggregate = {
  __typename?: "RiderCountAggregate";
  createdByDispatcherOperatorId?: Maybe<Scalars["Int"]["output"]>;
  firstName?: Maybe<Scalars["Int"]["output"]>;
  gender?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  lastName?: Maybe<Scalars["Int"]["output"]>;
  mobileNumber?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
  tariffProfileId?: Maybe<Scalars["Int"]["output"]>;
};

export enum RiderDeductTransactionType {
  CancellationFee = "CancellationFee",
  Correction = "Correction",
  OrderFee = "OrderFee",
  ParkingFee = "ParkingFee",
  Withdraw = "Withdraw",
}

export type RiderDeductTransactionTypeFilterComparison = {
  eq?: InputMaybe<RiderDeductTransactionType>;
  gt?: InputMaybe<RiderDeductTransactionType>;
  gte?: InputMaybe<RiderDeductTransactionType>;
  iLike?: InputMaybe<RiderDeductTransactionType>;
  in?: InputMaybe<Array<RiderDeductTransactionType>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<RiderDeductTransactionType>;
  lt?: InputMaybe<RiderDeductTransactionType>;
  lte?: InputMaybe<RiderDeductTransactionType>;
  neq?: InputMaybe<RiderDeductTransactionType>;
  notILike?: InputMaybe<RiderDeductTransactionType>;
  notIn?: InputMaybe<Array<RiderDeductTransactionType>>;
  notLike?: InputMaybe<RiderDeductTransactionType>;
};

export type RiderDeletionReviewCategory = {
  __typename?: "RiderDeletionReviewCategory";
  coverage: Scalars["String"]["output"];
  key: Scalars["String"]["output"];
  records?: Maybe<Scalars["Float"]["output"]>;
  treatment: Scalars["String"]["output"];
};

export type RiderDeletionReviewCheck = {
  __typename?: "RiderDeletionReviewCheck";
  coverage: Scalars["String"]["output"];
  key: Scalars["String"]["output"];
  records?: Maybe<Scalars["Float"]["output"]>;
};

export type RiderDeletionReviewPage = {
  __typename?: "RiderDeletionReviewPage";
  nextCursor?: Maybe<Scalars["String"]["output"]>;
  nodes: Array<RiderDeletionReviewRequest>;
};

export type RiderDeletionReviewPreview = {
  __typename?: "RiderDeletionReviewPreview";
  blockers: Array<Scalars["String"]["output"]>;
  categories: Array<RiderDeletionReviewCategory>;
  checks: Array<RiderDeletionReviewCheck>;
  executionEnabled: Scalars["Boolean"]["output"];
  generatedAt: Scalars["String"]["output"];
  readyForErasure: Scalars["Boolean"]["output"];
  requestReference: Scalars["ID"]["output"];
  unmappedDirectForeignKeys: Scalars["Float"]["output"];
  unscanned: Array<Scalars["String"]["output"]>;
  version: Scalars["String"]["output"];
};

export type RiderDeletionReviewRequest = {
  __typename?: "RiderDeletionReviewRequest";
  id: Scalars["ID"]["output"];
  requestedAt: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
};

export type RiderDisplaySettings = {
  __typename?: "RiderDisplaySettings";
  taximeterMinimumKm: Scalars["Int"]["output"];
  version: Scalars["Int"]["output"];
};

export type RiderFilter = {
  and?: InputMaybe<Array<RiderFilter>>;
  createdByDispatcherOperatorId?: InputMaybe<IdFilterComparison>;
  firstName?: InputMaybe<StringFieldComparison>;
  gender?: InputMaybe<GenderFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  lastName?: InputMaybe<StringFieldComparison>;
  mobileNumber?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<RiderFilter>>;
  status?: InputMaybe<RiderStatusFilterComparison>;
  tariffProfileId?: InputMaybe<IdFilterComparison>;
};

export type RiderInput = {
  countryIso?: InputMaybe<Scalars["String"]["input"]>;
  countryOfResidence?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  gender?: InputMaybe<Gender>;
  idNumber?: InputMaybe<Scalars["String"]["input"]>;
  isResident?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  mobileNumber?: InputMaybe<Scalars["String"]["input"]>;
  nationality?: InputMaybe<Scalars["String"]["input"]>;
  password?: InputMaybe<Scalars["String"]["input"]>;
  registrationTimestamp?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<RiderStatus>;
  tariffProfileId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type RiderMaxAggregate = {
  __typename?: "RiderMaxAggregate";
  createdByDispatcherOperatorId?: Maybe<Scalars["ID"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  gender?: Maybe<Gender>;
  id?: Maybe<Scalars["ID"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  mobileNumber?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<RiderStatus>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
};

export type RiderMinAggregate = {
  __typename?: "RiderMinAggregate";
  createdByDispatcherOperatorId?: Maybe<Scalars["ID"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  gender?: Maybe<Gender>;
  id?: Maybe<Scalars["ID"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  mobileNumber?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<RiderStatus>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
};

export type RiderOrdersAggregateGroupBy = {
  __typename?: "RiderOrdersAggregateGroupBy";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  createdOn?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  distanceBest?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  durationBest?: Maybe<Scalars["Int"]["output"]>;
  fareMode?: Maybe<FareMode>;
  finishTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  orderSource?: Maybe<OrderSource>;
  paymentMode?: Maybe<PaymentMode>;
  regionId?: Maybe<Scalars["ID"]["output"]>;
  reportingSource?: Maybe<OrderSource>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  routeSource?: Maybe<RouteSource>;
  serviceId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<OrderStatus>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
  type?: Maybe<TaxiOrderType>;
};

export type RiderOrdersAggregateResponse = {
  __typename?: "RiderOrdersAggregateResponse";
  avg?: Maybe<RiderOrdersAvgAggregate>;
  count?: Maybe<RiderOrdersCountAggregate>;
  groupBy?: Maybe<RiderOrdersAggregateGroupBy>;
  max?: Maybe<RiderOrdersMaxAggregate>;
  min?: Maybe<RiderOrdersMinAggregate>;
  sum?: Maybe<RiderOrdersSumAggregate>;
};

export type RiderOrdersAvgAggregate = {
  __typename?: "RiderOrdersAvgAggregate";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  distanceBest?: Maybe<Scalars["Float"]["output"]>;
  driverId?: Maybe<Scalars["Float"]["output"]>;
  durationBest?: Maybe<Scalars["Float"]["output"]>;
  fleetId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  regionId?: Maybe<Scalars["Float"]["output"]>;
  riderId?: Maybe<Scalars["Float"]["output"]>;
  serviceId?: Maybe<Scalars["Float"]["output"]>;
  tariffProfileId?: Maybe<Scalars["Float"]["output"]>;
};

export type RiderOrdersConnection = {
  __typename?: "RiderOrdersConnection";
  /** Array of nodes. */
  nodes: Array<Order>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type RiderOrdersCountAggregate = {
  __typename?: "RiderOrdersCountAggregate";
  costAfterCoupon?: Maybe<Scalars["Int"]["output"]>;
  costBest?: Maybe<Scalars["Int"]["output"]>;
  createdOn?: Maybe<Scalars["Int"]["output"]>;
  currency?: Maybe<Scalars["Int"]["output"]>;
  distanceBest?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["Int"]["output"]>;
  durationBest?: Maybe<Scalars["Int"]["output"]>;
  fareMode?: Maybe<Scalars["Int"]["output"]>;
  finishTimestamp?: Maybe<Scalars["Int"]["output"]>;
  fleetId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  operatorId?: Maybe<Scalars["Int"]["output"]>;
  orderSource?: Maybe<Scalars["Int"]["output"]>;
  paymentMode?: Maybe<Scalars["Int"]["output"]>;
  regionId?: Maybe<Scalars["Int"]["output"]>;
  reportingSource?: Maybe<Scalars["Int"]["output"]>;
  riderId?: Maybe<Scalars["Int"]["output"]>;
  routeSource?: Maybe<Scalars["Int"]["output"]>;
  serviceId?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
  tariffProfileId?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Scalars["Int"]["output"]>;
};

export type RiderOrdersMaxAggregate = {
  __typename?: "RiderOrdersMaxAggregate";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  createdOn?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  distanceBest?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  durationBest?: Maybe<Scalars["Int"]["output"]>;
  fareMode?: Maybe<FareMode>;
  finishTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  orderSource?: Maybe<OrderSource>;
  paymentMode?: Maybe<PaymentMode>;
  regionId?: Maybe<Scalars["ID"]["output"]>;
  reportingSource?: Maybe<OrderSource>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  routeSource?: Maybe<RouteSource>;
  serviceId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<OrderStatus>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
  type?: Maybe<TaxiOrderType>;
};

export type RiderOrdersMinAggregate = {
  __typename?: "RiderOrdersMinAggregate";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  createdOn?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  distanceBest?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  durationBest?: Maybe<Scalars["Int"]["output"]>;
  fareMode?: Maybe<FareMode>;
  finishTimestamp?: Maybe<Scalars["DateTime"]["output"]>;
  fleetId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  orderSource?: Maybe<OrderSource>;
  paymentMode?: Maybe<PaymentMode>;
  regionId?: Maybe<Scalars["ID"]["output"]>;
  reportingSource?: Maybe<OrderSource>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  routeSource?: Maybe<RouteSource>;
  serviceId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<OrderStatus>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
  type?: Maybe<TaxiOrderType>;
};

export type RiderOrdersSumAggregate = {
  __typename?: "RiderOrdersSumAggregate";
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  costBest?: Maybe<Scalars["Float"]["output"]>;
  distanceBest?: Maybe<Scalars["Float"]["output"]>;
  driverId?: Maybe<Scalars["Float"]["output"]>;
  durationBest?: Maybe<Scalars["Float"]["output"]>;
  fleetId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  regionId?: Maybe<Scalars["Float"]["output"]>;
  riderId?: Maybe<Scalars["Float"]["output"]>;
  serviceId?: Maybe<Scalars["Float"]["output"]>;
  tariffProfileId?: Maybe<Scalars["Float"]["output"]>;
};

export enum RiderRechargeTransactionType {
  BankTransfer = "BankTransfer",
  Correction = "Correction",
  Gift = "Gift",
  InAppPayment = "InAppPayment",
}

export type RiderRechargeTransactionTypeFilterComparison = {
  eq?: InputMaybe<RiderRechargeTransactionType>;
  gt?: InputMaybe<RiderRechargeTransactionType>;
  gte?: InputMaybe<RiderRechargeTransactionType>;
  iLike?: InputMaybe<RiderRechargeTransactionType>;
  in?: InputMaybe<Array<RiderRechargeTransactionType>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<RiderRechargeTransactionType>;
  lt?: InputMaybe<RiderRechargeTransactionType>;
  lte?: InputMaybe<RiderRechargeTransactionType>;
  neq?: InputMaybe<RiderRechargeTransactionType>;
  notILike?: InputMaybe<RiderRechargeTransactionType>;
  notIn?: InputMaybe<Array<RiderRechargeTransactionType>>;
  notLike?: InputMaybe<RiderRechargeTransactionType>;
};

export type RiderSort = {
  direction: SortDirection;
  field: RiderSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum RiderSortFields {
  CreatedByDispatcherOperatorId = "createdByDispatcherOperatorId",
  FirstName = "firstName",
  Gender = "gender",
  Id = "id",
  LastName = "lastName",
  MobileNumber = "mobileNumber",
  Status = "status",
  TariffProfileId = "tariffProfileId",
}

export enum RiderStatus {
  Disabled = "Disabled",
  Enabled = "Enabled",
}

export type RiderStatusFilterComparison = {
  eq?: InputMaybe<RiderStatus>;
  gt?: InputMaybe<RiderStatus>;
  gte?: InputMaybe<RiderStatus>;
  iLike?: InputMaybe<RiderStatus>;
  in?: InputMaybe<Array<RiderStatus>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<RiderStatus>;
  lt?: InputMaybe<RiderStatus>;
  lte?: InputMaybe<RiderStatus>;
  neq?: InputMaybe<RiderStatus>;
  notILike?: InputMaybe<RiderStatus>;
  notIn?: InputMaybe<Array<RiderStatus>>;
  notLike?: InputMaybe<RiderStatus>;
};

export type RiderSumAggregate = {
  __typename?: "RiderSumAggregate";
  createdByDispatcherOperatorId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  tariffProfileId?: Maybe<Scalars["Float"]["output"]>;
};

export type RiderTransaction = {
  __typename?: "RiderTransaction";
  action: TransactionAction;
  amount: Scalars["Float"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  currency: Scalars["String"]["output"];
  deductType?: Maybe<RiderDeductTransactionType>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  operator?: Maybe<Operator>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  paymentGateway?: Maybe<PaymentGateway>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<RiderRechargeTransactionType>;
  refrenceNumber?: Maybe<Scalars["String"]["output"]>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  rider: Rider;
  riderId: Scalars["ID"]["output"];
  savedPaymentMethod?: Maybe<SavedPaymentMethod>;
  savedPaymentMethodId?: Maybe<Scalars["ID"]["output"]>;
  status: TransactionStatus;
};

export type RiderTransactionAggregateFilter = {
  action?: InputMaybe<TransactionActionFilterComparison>;
  amount?: InputMaybe<FloatFieldComparison>;
  and?: InputMaybe<Array<RiderTransactionAggregateFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  deductType?: InputMaybe<RiderDeductTransactionTypeFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  operatorId?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<RiderTransactionAggregateFilter>>;
  paymentGatewayId?: InputMaybe<IdFilterComparison>;
  rechargeType?: InputMaybe<RiderRechargeTransactionTypeFilterComparison>;
  requestId?: InputMaybe<IdFilterComparison>;
  riderId?: InputMaybe<IdFilterComparison>;
  savedPaymentMethodId?: InputMaybe<IdFilterComparison>;
  status?: InputMaybe<TransactionStatusFilterComparison>;
};

export type RiderTransactionConnection = {
  __typename?: "RiderTransactionConnection";
  /** Array of nodes. */
  nodes: Array<RiderTransaction>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type RiderTransactionFilter = {
  action?: InputMaybe<TransactionActionFilterComparison>;
  amount?: InputMaybe<FloatFieldComparison>;
  and?: InputMaybe<Array<RiderTransactionFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  deductType?: InputMaybe<RiderDeductTransactionTypeFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  operatorId?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<RiderTransactionFilter>>;
  paymentGatewayId?: InputMaybe<IdFilterComparison>;
  rechargeType?: InputMaybe<RiderRechargeTransactionTypeFilterComparison>;
  requestId?: InputMaybe<IdFilterComparison>;
  riderId?: InputMaybe<IdFilterComparison>;
  savedPaymentMethodId?: InputMaybe<IdFilterComparison>;
  status?: InputMaybe<TransactionStatusFilterComparison>;
};

export type RiderTransactionInput = {
  action: TransactionAction;
  amount: Scalars["Float"]["input"];
  currency: Scalars["String"]["input"];
  deductType?: InputMaybe<RiderDeductTransactionType>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  rechargeType?: InputMaybe<RiderRechargeTransactionType>;
  refrenceNumber?: InputMaybe<Scalars["String"]["input"]>;
  riderId: Scalars["ID"]["input"];
};

export type RiderTransactionSort = {
  direction: SortDirection;
  field: RiderTransactionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum RiderTransactionSortFields {
  Action = "action",
  Amount = "amount",
  CreatedAt = "createdAt",
  Currency = "currency",
  DeductType = "deductType",
  Id = "id",
  OperatorId = "operatorId",
  PaymentGatewayId = "paymentGatewayId",
  RechargeType = "rechargeType",
  RequestId = "requestId",
  RiderId = "riderId",
  SavedPaymentMethodId = "savedPaymentMethodId",
  Status = "status",
}

export type RiderTransactionsAggregateGroupBy = {
  __typename?: "RiderTransactionsAggregateGroupBy";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  deductType?: Maybe<RiderDeductTransactionType>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<RiderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  savedPaymentMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type RiderTransactionsAggregateResponse = {
  __typename?: "RiderTransactionsAggregateResponse";
  avg?: Maybe<RiderTransactionsAvgAggregate>;
  count?: Maybe<RiderTransactionsCountAggregate>;
  groupBy?: Maybe<RiderTransactionsAggregateGroupBy>;
  max?: Maybe<RiderTransactionsMaxAggregate>;
  min?: Maybe<RiderTransactionsMinAggregate>;
  sum?: Maybe<RiderTransactionsSumAggregate>;
};

export type RiderTransactionsAvgAggregate = {
  __typename?: "RiderTransactionsAvgAggregate";
  amount?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Float"]["output"]>;
  requestId?: Maybe<Scalars["Float"]["output"]>;
  riderId?: Maybe<Scalars["Float"]["output"]>;
  savedPaymentMethodId?: Maybe<Scalars["Float"]["output"]>;
};

export type RiderTransactionsConnection = {
  __typename?: "RiderTransactionsConnection";
  /** Array of nodes. */
  nodes: Array<RiderTransaction>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type RiderTransactionsCountAggregate = {
  __typename?: "RiderTransactionsCountAggregate";
  action?: Maybe<Scalars["Int"]["output"]>;
  amount?: Maybe<Scalars["Int"]["output"]>;
  createdAt?: Maybe<Scalars["Int"]["output"]>;
  currency?: Maybe<Scalars["Int"]["output"]>;
  deductType?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  operatorId?: Maybe<Scalars["Int"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Int"]["output"]>;
  rechargeType?: Maybe<Scalars["Int"]["output"]>;
  requestId?: Maybe<Scalars["Int"]["output"]>;
  riderId?: Maybe<Scalars["Int"]["output"]>;
  savedPaymentMethodId?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
};

export type RiderTransactionsMaxAggregate = {
  __typename?: "RiderTransactionsMaxAggregate";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  deductType?: Maybe<RiderDeductTransactionType>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<RiderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  savedPaymentMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type RiderTransactionsMinAggregate = {
  __typename?: "RiderTransactionsMinAggregate";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  deductType?: Maybe<RiderDeductTransactionType>;
  id?: Maybe<Scalars["ID"]["output"]>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  rechargeType?: Maybe<RiderRechargeTransactionType>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  savedPaymentMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type RiderTransactionsSumAggregate = {
  __typename?: "RiderTransactionsSumAggregate";
  amount?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  operatorId?: Maybe<Scalars["Float"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Float"]["output"]>;
  requestId?: Maybe<Scalars["Float"]["output"]>;
  riderId?: Maybe<Scalars["Float"]["output"]>;
  savedPaymentMethodId?: Maybe<Scalars["Float"]["output"]>;
};

export type RiderWallet = {
  __typename?: "RiderWallet";
  balance: Scalars["Float"]["output"];
  currency: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  rider?: Maybe<Rider>;
  riderId: Scalars["ID"]["output"];
};

export type RiderWalletAggregateFilter = {
  and?: InputMaybe<Array<RiderWalletAggregateFilter>>;
  balance?: InputMaybe<FloatFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<RiderWalletAggregateFilter>>;
  riderId?: InputMaybe<IdFilterComparison>;
};

export type RiderWalletAggregateGroupBy = {
  __typename?: "RiderWalletAggregateGroupBy";
  balance?: Maybe<Scalars["Float"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
};

export type RiderWalletAggregateResponse = {
  __typename?: "RiderWalletAggregateResponse";
  avg?: Maybe<RiderWalletAvgAggregate>;
  count?: Maybe<RiderWalletCountAggregate>;
  groupBy?: Maybe<RiderWalletAggregateGroupBy>;
  max?: Maybe<RiderWalletMaxAggregate>;
  min?: Maybe<RiderWalletMinAggregate>;
  sum?: Maybe<RiderWalletSumAggregate>;
};

export type RiderWalletAvgAggregate = {
  __typename?: "RiderWalletAvgAggregate";
  balance?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  riderId?: Maybe<Scalars["Float"]["output"]>;
};

export type RiderWalletConnection = {
  __typename?: "RiderWalletConnection";
  /** Array of nodes. */
  nodes: Array<RiderWallet>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type RiderWalletCountAggregate = {
  __typename?: "RiderWalletCountAggregate";
  balance?: Maybe<Scalars["Int"]["output"]>;
  currency?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  riderId?: Maybe<Scalars["Int"]["output"]>;
};

export type RiderWalletFilter = {
  and?: InputMaybe<Array<RiderWalletFilter>>;
  balance?: InputMaybe<FloatFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<RiderWalletFilter>>;
  riderId?: InputMaybe<IdFilterComparison>;
};

export type RiderWalletMaxAggregate = {
  __typename?: "RiderWalletMaxAggregate";
  balance?: Maybe<Scalars["Float"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
};

export type RiderWalletMinAggregate = {
  __typename?: "RiderWalletMinAggregate";
  balance?: Maybe<Scalars["Float"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
};

export type RiderWalletSort = {
  direction: SortDirection;
  field: RiderWalletSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum RiderWalletSortFields {
  Balance = "balance",
  Currency = "currency",
  Id = "id",
  RiderId = "riderId",
}

export type RiderWalletSumAggregate = {
  __typename?: "RiderWalletSumAggregate";
  balance?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  riderId?: Maybe<Scalars["Float"]["output"]>;
};

export type RiderWhatsAppBusinessConfiguration = {
  __typename?: "RiderWhatsAppBusinessConfiguration";
  apiVersion: Scalars["String"]["output"];
  businessAccountId: Scalars["String"]["output"];
  language: Scalars["String"]["output"];
  phoneNumberId: Scalars["String"]["output"];
  template: Scalars["String"]["output"];
};

export type RiderWhatsAppBusinessConfigurationInput = {
  apiVersion: Scalars["String"]["input"];
  businessAccountId: Scalars["String"]["input"];
  language: Scalars["String"]["input"];
  phoneNumberId: Scalars["String"]["input"];
  template: Scalars["String"]["input"];
};

export type RiderWhatsAppSettings = {
  __typename?: "RiderWhatsAppSettings";
  activationBlockers: Array<Scalars["String"]["output"]>;
  configuration?: Maybe<RiderWhatsAppBusinessConfiguration>;
  embeddedSignupAvailable: Scalars["Boolean"]["output"];
  embeddedSignupBlockers: Array<Scalars["String"]["output"]>;
  enabled: Scalars["Boolean"]["output"];
  encryptionReady: Scalars["Boolean"]["output"];
  tokenConfigured: Scalars["Boolean"]["output"];
  tokenExpiresAt?: Maybe<Scalars["String"]["output"]>;
  validatedAt?: Maybe<Scalars["String"]["output"]>;
  validationCode?: Maybe<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
};

export type RiderWhatsAppSignupPhone = {
  __typename?: "RiderWhatsAppSignupPhone";
  displayNumber: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  verifiedName: Scalars["String"]["output"];
};

export type RiderWhatsAppSignupSession = {
  __typename?: "RiderWhatsAppSignupSession";
  apiVersion: Scalars["String"]["output"];
  appId: Scalars["String"]["output"];
  configId: Scalars["String"]["output"];
  expiresAt: Scalars["String"]["output"];
  nonce: Scalars["String"]["output"];
  origin: Scalars["String"]["output"];
};

/** How the order distance and duration were calculated. */
export enum RouteSource {
  GoogleRoadRoute = "GoogleRoadRoute",
  HaversineFallback = "HaversineFallback",
  ManualMeter = "ManualMeter",
  Unknown = "Unknown",
}

export type RouteSourceFilterComparison = {
  eq?: InputMaybe<RouteSource>;
  gt?: InputMaybe<RouteSource>;
  gte?: InputMaybe<RouteSource>;
  iLike?: InputMaybe<RouteSource>;
  in?: InputMaybe<Array<RouteSource>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<RouteSource>;
  lt?: InputMaybe<RouteSource>;
  lte?: InputMaybe<RouteSource>;
  neq?: InputMaybe<RouteSource>;
  notILike?: InputMaybe<RouteSource>;
  notIn?: InputMaybe<Array<RouteSource>>;
  notLike?: InputMaybe<RouteSource>;
};

export type RunAutoPayoutInput = {
  payoutMethodId: Scalars["ID"]["input"];
  payoutSessionId: Scalars["ID"]["input"];
};

export type Sms = {
  __typename?: "SMS";
  countryIsoCode: Scalars["String"]["output"];
  from: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  message: Scalars["String"]["output"];
  providerId: Scalars["ID"]["output"];
  status: SmsStatus;
  to: Scalars["String"]["output"];
  type: SmsType;
};

export type SmsAggregateFilter = {
  and?: InputMaybe<Array<SmsAggregateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<SmsAggregateFilter>>;
};

export type SmsConnection = {
  __typename?: "SMSConnection";
  /** Array of nodes. */
  nodes: Array<Sms>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type SmsDeleteFilter = {
  and?: InputMaybe<Array<SmsDeleteFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<SmsDeleteFilter>>;
};

export type SmsDeleteResponse = {
  __typename?: "SMSDeleteResponse";
  countryIsoCode?: Maybe<Scalars["String"]["output"]>;
  from?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  providerId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<SmsStatus>;
  to?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<SmsType>;
};

export type SmsFilter = {
  and?: InputMaybe<Array<SmsFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<SmsFilter>>;
};

/** SMS Provider */
export type SmsProvider = {
  __typename?: "SMSProvider";
  accountId: Scalars["ID"]["output"];
  authToken?: Maybe<Scalars["String"]["output"]>;
  callMaskingEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  callMaskingNumber?: Maybe<Scalars["String"]["output"]>;
  fromNumber?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  messages: SmsProviderMessagesConnection;
  messagesAggregate: Array<SmsProviderMessagesAggregateResponse>;
  name: Scalars["String"]["output"];
  smsType?: Maybe<Scalars["String"]["output"]>;
  type: SmsProviderType;
  verificationTemplate?: Maybe<Scalars["String"]["output"]>;
};

/** SMS Provider */
export type SmsProviderMessagesArgs = {
  filter?: SmsFilter;
  paging?: OffsetPaging;
  sorting?: Array<SmsSort>;
};

/** SMS Provider */
export type SmsProviderMessagesAggregateArgs = {
  filter?: InputMaybe<SmsAggregateFilter>;
};

export type SmsProviderConnection = {
  __typename?: "SMSProviderConnection";
  /** Array of nodes. */
  nodes: Array<SmsProvider>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type SmsProviderDeleteFilter = {
  and?: InputMaybe<Array<SmsProviderDeleteFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SmsProviderDeleteFilter>>;
  type?: InputMaybe<SmsProviderTypeFilterComparison>;
};

export type SmsProviderDeleteResponse = {
  __typename?: "SMSProviderDeleteResponse";
  accountId?: Maybe<Scalars["ID"]["output"]>;
  authToken?: Maybe<Scalars["String"]["output"]>;
  callMaskingEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  callMaskingNumber?: Maybe<Scalars["String"]["output"]>;
  fromNumber?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  isDefault?: Maybe<Scalars["Boolean"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  smsType?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<SmsProviderType>;
  verificationTemplate?: Maybe<Scalars["String"]["output"]>;
};

export type SmsProviderFilter = {
  and?: InputMaybe<Array<SmsProviderFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SmsProviderFilter>>;
  type?: InputMaybe<SmsProviderTypeFilterComparison>;
};

export type SmsProviderInput = {
  accountId?: InputMaybe<Scalars["String"]["input"]>;
  authToken?: InputMaybe<Scalars["String"]["input"]>;
  callMaskingEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  callMaskingNumber?: InputMaybe<Scalars["String"]["input"]>;
  fromNumber?: InputMaybe<Scalars["String"]["input"]>;
  isDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  smsType?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<SmsProviderType>;
  verificationTemplate?: InputMaybe<Scalars["String"]["input"]>;
};

export type SmsProviderMessagesAggregateGroupBy = {
  __typename?: "SMSProviderMessagesAggregateGroupBy";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type SmsProviderMessagesAggregateResponse = {
  __typename?: "SMSProviderMessagesAggregateResponse";
  avg?: Maybe<SmsProviderMessagesAvgAggregate>;
  count?: Maybe<SmsProviderMessagesCountAggregate>;
  groupBy?: Maybe<SmsProviderMessagesAggregateGroupBy>;
  max?: Maybe<SmsProviderMessagesMaxAggregate>;
  min?: Maybe<SmsProviderMessagesMinAggregate>;
  sum?: Maybe<SmsProviderMessagesSumAggregate>;
};

export type SmsProviderMessagesAvgAggregate = {
  __typename?: "SMSProviderMessagesAvgAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type SmsProviderMessagesConnection = {
  __typename?: "SMSProviderMessagesConnection";
  /** Array of nodes. */
  nodes: Array<Sms>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type SmsProviderMessagesCountAggregate = {
  __typename?: "SMSProviderMessagesCountAggregate";
  id?: Maybe<Scalars["Int"]["output"]>;
};

export type SmsProviderMessagesMaxAggregate = {
  __typename?: "SMSProviderMessagesMaxAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type SmsProviderMessagesMinAggregate = {
  __typename?: "SMSProviderMessagesMinAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type SmsProviderMessagesSumAggregate = {
  __typename?: "SMSProviderMessagesSumAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type SmsProviderSort = {
  direction: SortDirection;
  field: SmsProviderSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum SmsProviderSortFields {
  Id = "id",
  Name = "name",
  Type = "type",
}

/** The type of the SMS provider */
export enum SmsProviderType {
  BroadNet = "BroadNet",
  ClickSmsNet = "ClickSMSNet",
  ClickSend = "ClickSend",
  Firebase = "Firebase",
  Infobip = "Infobip",
  MessageBird = "MessageBird",
  Pahappa = "Pahappa",
  Plivo = "Plivo",
  Twilio = "Twilio",
  VentisSms = "VentisSMS",
  Vonage = "Vonage",
}

export type SmsProviderTypeFilterComparison = {
  eq?: InputMaybe<SmsProviderType>;
  gt?: InputMaybe<SmsProviderType>;
  gte?: InputMaybe<SmsProviderType>;
  iLike?: InputMaybe<SmsProviderType>;
  in?: InputMaybe<Array<SmsProviderType>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<SmsProviderType>;
  lt?: InputMaybe<SmsProviderType>;
  lte?: InputMaybe<SmsProviderType>;
  neq?: InputMaybe<SmsProviderType>;
  notILike?: InputMaybe<SmsProviderType>;
  notIn?: InputMaybe<Array<SmsProviderType>>;
  notLike?: InputMaybe<SmsProviderType>;
};

export type SmsProviderUpdateFilter = {
  and?: InputMaybe<Array<SmsProviderUpdateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SmsProviderUpdateFilter>>;
  type?: InputMaybe<SmsProviderTypeFilterComparison>;
};

export type SmsSort = {
  direction: SortDirection;
  field: SmsSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum SmsSortFields {
  Id = "id",
}

export enum SmsStatus {
  Delivered = "DELIVERED",
  Expired = "EXPIRED",
  Failed = "FAILED",
  Pending = "PENDING",
  Rejected = "REJECTED",
  Sent = "SENT",
  Undelivered = "UNDELIVERED",
}

export enum SmsType {
  Notification = "NOTIFICATION",
  Otp = "OTP",
  Promotional = "PROMOTIONAL",
  Transactional = "TRANSACTIONAL",
}

export type SmsUpdateFilter = {
  and?: InputMaybe<Array<SmsUpdateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<SmsUpdateFilter>>;
};

export type SosActivity = {
  __typename?: "SOSActivity";
  action: SosActivityAction;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  operator: Operator;
  operatorDisplayName?: Maybe<Scalars["String"]["output"]>;
  operatorId: Scalars["ID"]["output"];
};

export enum SosActivityAction {
  ContactAuthorities = "ContactAuthorities",
  ContactDriver = "ContactDriver",
  MarkedAsFalseAlarm = "MarkedAsFalseAlarm",
  MarkedAsResolved = "MarkedAsResolved",
  Seen = "Seen",
  Submitted = "Submitted",
}

export type SosActivityAggregateFilter = {
  and?: InputMaybe<Array<SosActivityAggregateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<SosActivityAggregateFilter>>;
};

export type SosActivityFilter = {
  and?: InputMaybe<Array<SosActivityFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<SosActivityFilter>>;
};

export type SosActivitySort = {
  direction: SortDirection;
  field: SosActivitySortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum SosActivitySortFields {
  Id = "id",
}

export type SosNotification = {
  __typename?: "SOSNotification";
  appType: AppType;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  readAt?: Maybe<Scalars["DateTime"]["output"]>;
  sos: DistressSignal;
  type: AdminNotificationType;
};

export type SosReason = {
  __typename?: "SOSReason";
  id: Scalars["ID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  sos: SosReasonSosConnection;
  sosAggregate: Array<SosReasonSosAggregateResponse>;
};

export type SosReasonSosArgs = {
  filter?: DistressSignalFilter;
  paging?: OffsetPaging;
  sorting?: Array<DistressSignalSort>;
};

export type SosReasonSosAggregateArgs = {
  filter?: InputMaybe<DistressSignalAggregateFilter>;
};

export type SosReasonConnection = {
  __typename?: "SOSReasonConnection";
  /** Array of nodes. */
  nodes: Array<SosReason>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type SosReasonDeleteResponse = {
  __typename?: "SOSReasonDeleteResponse";
  id?: Maybe<Scalars["ID"]["output"]>;
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type SosReasonFilter = {
  and?: InputMaybe<Array<SosReasonFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  isActive?: InputMaybe<BooleanFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SosReasonFilter>>;
};

export type SosReasonSort = {
  direction: SortDirection;
  field: SosReasonSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum SosReasonSortFields {
  Id = "id",
  IsActive = "isActive",
  Name = "name",
}

export type SosReasonSosAggregateGroupBy = {
  __typename?: "SOSReasonSosAggregateGroupBy";
  id?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<SosStatus>;
};

export type SosReasonSosAggregateResponse = {
  __typename?: "SOSReasonSosAggregateResponse";
  avg?: Maybe<SosReasonSosAvgAggregate>;
  count?: Maybe<SosReasonSosCountAggregate>;
  groupBy?: Maybe<SosReasonSosAggregateGroupBy>;
  max?: Maybe<SosReasonSosMaxAggregate>;
  min?: Maybe<SosReasonSosMinAggregate>;
  sum?: Maybe<SosReasonSosSumAggregate>;
};

export type SosReasonSosAvgAggregate = {
  __typename?: "SOSReasonSosAvgAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type SosReasonSosConnection = {
  __typename?: "SOSReasonSosConnection";
  /** Array of nodes. */
  nodes: Array<DistressSignal>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type SosReasonSosCountAggregate = {
  __typename?: "SOSReasonSosCountAggregate";
  id?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
};

export type SosReasonSosMaxAggregate = {
  __typename?: "SOSReasonSosMaxAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<SosStatus>;
};

export type SosReasonSosMinAggregate = {
  __typename?: "SOSReasonSosMinAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<SosStatus>;
};

export type SosReasonSosSumAggregate = {
  __typename?: "SOSReasonSosSumAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
};

export enum SosStatus {
  FalseAlarm = "FalseAlarm",
  Resolved = "Resolved",
  Submitted = "Submitted",
  UnderReview = "UnderReview",
}

export type SosStatusFilterComparison = {
  eq?: InputMaybe<SosStatus>;
  gt?: InputMaybe<SosStatus>;
  gte?: InputMaybe<SosStatus>;
  iLike?: InputMaybe<SosStatus>;
  in?: InputMaybe<Array<SosStatus>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<SosStatus>;
  lt?: InputMaybe<SosStatus>;
  lte?: InputMaybe<SosStatus>;
  neq?: InputMaybe<SosStatus>;
  notILike?: InputMaybe<SosStatus>;
  notIn?: InputMaybe<Array<SosStatus>>;
  notLike?: InputMaybe<SosStatus>;
};

export type SaveRiderWhatsAppSettingsInput = {
  accessToken?: InputMaybe<Scalars["String"]["input"]>;
  configuration: RiderWhatsAppBusinessConfigurationInput;
  expectedVersion: Scalars["Int"]["input"];
};

export type SaveServiceDistanceBandsInput = {
  bands: Array<ServiceDistanceBandItemInput>;
  serviceId: Scalars["ID"]["input"];
  tariffProfileId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SaveZonePriceProfileFaresInput = {
  profileFares: Array<ZonePriceProfileFareInput>;
  zonePriceId: Scalars["ID"]["input"];
};

export type SavedAccount = PaymentMethodBase & {
  __typename?: "SavedAccount";
  id: Scalars["ID"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  mode: PaymentMode;
  name: Scalars["String"]["output"];
  providerBrand?: Maybe<ProviderBrand>;
};

export type SavedPaymentMethod = {
  __typename?: "SavedPaymentMethod";
  driverId?: Maybe<Scalars["ID"]["output"]>;
  expiryDate?: Maybe<Scalars["DateTime"]["output"]>;
  holderName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  lastFour?: Maybe<Scalars["String"]["output"]>;
  providerBrand?: Maybe<ProviderBrand>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  title: Scalars["String"]["output"];
  type: SavedPaymentMethodType;
};

export type SavedPaymentMethodConnection = {
  __typename?: "SavedPaymentMethodConnection";
  /** Array of nodes. */
  nodes: Array<SavedPaymentMethod>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type SavedPaymentMethodDeleteResponse = {
  __typename?: "SavedPaymentMethodDeleteResponse";
  driverId?: Maybe<Scalars["ID"]["output"]>;
  expiryDate?: Maybe<Scalars["DateTime"]["output"]>;
  holderName?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  isDefault?: Maybe<Scalars["Boolean"]["output"]>;
  lastFour?: Maybe<Scalars["String"]["output"]>;
  providerBrand?: Maybe<ProviderBrand>;
  riderId?: Maybe<Scalars["ID"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<SavedPaymentMethodType>;
};

export type SavedPaymentMethodFilter = {
  and?: InputMaybe<Array<SavedPaymentMethodFilter>>;
  driverId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isEnabled?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<SavedPaymentMethodFilter>>;
  riderId?: InputMaybe<IdFilterComparison>;
};

export type SavedPaymentMethodSort = {
  direction: SortDirection;
  field: SavedPaymentMethodSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum SavedPaymentMethodSortFields {
  DriverId = "driverId",
  Id = "id",
  IsEnabled = "isEnabled",
  RiderId = "riderId",
}

/** Saved payment method type */
export enum SavedPaymentMethodType {
  BankAccount = "BANK_ACCOUNT",
  Card = "CARD",
}

export type ScheduleConfig = {
  __typename?: "ScheduleConfig";
  /** Minutes before pickup when admin/dispatcher should receive an unassigned warning */
  adminWarningMinutes: Scalars["Int"]["output"];
  /** Hard block window in minutes before scheduled pickup when no new immediate rides should be offered */
  driverHardBlockMinutes: Scalars["Int"]["output"];
  /** Safety buffer in minutes a driver must keep before a scheduled pickup */
  driverSafetyBufferMinutes: Scalars["Int"]["output"];
  /** Enable emergency automatic dispatch fallback for scheduled rides nearing pickup time */
  emergencyAutoDispatchEnabled: Scalars["Boolean"]["output"];
  /** Minutes before pickup when emergency fallback behavior should kick in */
  emergencyFallbackMinutes: Scalars["Int"]["output"];
  /** Minimum lead time in minutes required for a ride to be treated as scheduled */
  minimumLeadMinutes: Scalars["Int"]["output"];
  /** Minutes before pickup when urgent admin/dispatcher warnings should fire */
  urgentWarningMinutes: Scalars["Int"]["output"];
};

export type ScheduleConfigInput = {
  /** Minutes before pickup when admin/dispatcher should receive an unassigned warning */
  adminWarningMinutes: Scalars["Int"]["input"];
  /** Hard block window in minutes before scheduled pickup when no new immediate rides should be offered */
  driverHardBlockMinutes: Scalars["Int"]["input"];
  /** Safety buffer in minutes a driver must keep before a scheduled pickup */
  driverSafetyBufferMinutes: Scalars["Int"]["input"];
  /** Enable emergency automatic dispatch fallback for scheduled rides nearing pickup time */
  emergencyAutoDispatchEnabled: Scalars["Boolean"]["input"];
  /** Minutes before pickup when emergency fallback behavior should kick in */
  emergencyFallbackMinutes: Scalars["Int"]["input"];
  /** Minimum lead time in minutes required for a ride to be treated as scheduled */
  minimumLeadMinutes: Scalars["Int"]["input"];
  /** Minutes before pickup when urgent admin/dispatcher warnings should fire */
  urgentWarningMinutes: Scalars["Int"]["input"];
};

export type ScheduleEventNotification = {
  __typename?: "ScheduleEventNotification";
  appType: AppType;
  canonicalCategory?: Maybe<AdminNotificationCategory>;
  canonicalEventId?: Maybe<Scalars["String"]["output"]>;
  canonicalRoute?: Maybe<Scalars["String"]["output"]>;
  canonicalSeverity?: Maybe<AdminNotificationSeverity>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  readAt?: Maybe<Scalars["DateTime"]["output"]>;
  taxiOrderId?: Maybe<Scalars["Float"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  type: AdminNotificationType;
};

export enum ScheduleStatus {
  Assigned = "Assigned",
  Canceled = "Canceled",
  Completed = "Completed",
  Confirmed = "Confirmed",
  Dispatching = "Dispatching",
  Expired = "Expired",
  PendingPayment = "PendingPayment",
  Unassigned = "Unassigned",
}

export enum ScheduledAssignmentMode {
  EmergencyAuto = "EmergencyAuto",
  Manual = "Manual",
}

export type ScheduledRideAssignmentDriver = {
  __typename?: "ScheduledRideAssignmentDriver";
  distanceMeters?: Maybe<Scalars["Int"]["output"]>;
  feasibilityReason?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isFeasible: Scalars["Boolean"]["output"];
  isOnline: Scalars["Boolean"]["output"];
  lastName?: Maybe<Scalars["String"]["output"]>;
  mobileNumber: Scalars["String"]["output"];
  rating?: Maybe<Scalars["Int"]["output"]>;
  serviceIds: Array<Scalars["ID"]["output"]>;
  status: DriverStatus;
  vehiclePlate?: Maybe<Scalars["String"]["output"]>;
};

export type ScheduledRideBoardConnection = {
  __typename?: "ScheduledRideBoardConnection";
  nodes: Array<ScheduledRideBoardRow>;
  totalCount: Scalars["Int"]["output"];
};

export type ScheduledRideBoardRow = {
  __typename?: "ScheduledRideBoardRow";
  assignedDriverId?: Maybe<Scalars["ID"]["output"]>;
  assignedDriverName?: Maybe<Scalars["String"]["output"]>;
  assignedDriverPhone?: Maybe<Scalars["String"]["output"]>;
  assignedDriverPlate?: Maybe<Scalars["String"]["output"]>;
  assignedDriverStatus?: Maybe<DriverStatus>;
  costAfterCoupon?: Maybe<Scalars["Float"]["output"]>;
  createdByOperatorId?: Maybe<Scalars["ID"]["output"]>;
  createdByOperatorName?: Maybe<Scalars["String"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  customerId?: Maybe<Scalars["ID"]["output"]>;
  customerName: Scalars["String"]["output"];
  customerPhone?: Maybe<Scalars["String"]["output"]>;
  destinationAddress: Scalars["String"]["output"];
  destinationPoint?: Maybe<Point>;
  fareMode: FareMode;
  isAtRisk: Scalars["Boolean"]["output"];
  isScheduled: Scalars["Boolean"]["output"];
  lastScheduleAction?: Maybe<Scalars["String"]["output"]>;
  lastScheduleActivityAt?: Maybe<Scalars["DateTime"]["output"]>;
  lastScheduleOperatorId?: Maybe<Scalars["ID"]["output"]>;
  lastScheduleOperatorName?: Maybe<Scalars["String"]["output"]>;
  minutesUntilPickup?: Maybe<Scalars["Int"]["output"]>;
  orderId: Scalars["ID"]["output"];
  orderSource: OrderSource;
  paymentMode?: Maybe<PaymentMode>;
  pickupAddress: Scalars["String"]["output"];
  pickupPoint: Point;
  scheduleRevision: Scalars["Int"]["output"];
  scheduleStatus?: Maybe<ScheduleStatus>;
  scheduledAssignmentMode?: Maybe<ScheduledAssignmentMode>;
  scheduledAt: Scalars["DateTime"]["output"];
  scheduledDriverConfirmedAt?: Maybe<Scalars["DateTime"]["output"]>;
  serviceId?: Maybe<Scalars["ID"]["output"]>;
  serviceName?: Maybe<Scalars["String"]["output"]>;
  status: OrderStatus;
};

export enum ScheduledRideBucket {
  All = "All",
  Assigned = "Assigned",
  AtRisk = "AtRisk",
  Confirmed = "Confirmed",
  History = "History",
  Unassigned = "Unassigned",
}

export type ScheduledRideFilterInput = {
  bucket?: InputMaybe<ScheduledRideBucket>;
  dateFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  dateTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  driverKeyword?: InputMaybe<Scalars["String"]["input"]>;
  fareMode?: InputMaybe<FareMode>;
  paymentMode?: InputMaybe<PaymentMode>;
  scheduleStatus?: InputMaybe<ScheduleStatus>;
  serviceId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SequentialConfig = {
  __typename?: "SequentialConfig";
  /** New automation: offer each Driver at most once. Explicit rejections are always excluded. */
  avoidPreviousCandidates: Scalars["Boolean"]["output"];
  /** New automation: additional unanswered-offer attempts when avoiding previous candidates is off */
  driverRetryLimit: Scalars["Int"]["output"];
  /** Maximum number of drivers to test */
  maxDriversToTest?: Maybe<Scalars["Int"]["output"]>;
  /** Response time in seconds for one sequential offer */
  perDriverTimeoutSeconds: Scalars["Int"]["output"];
};

export type SequentialConfigInput = {
  /** New automation: offer each Driver at most once. Explicit rejections are always excluded. */
  avoidPreviousCandidates: Scalars["Boolean"]["input"];
  /** New automation: additional unanswered-offer attempts when avoiding previous candidates is off */
  driverRetryLimit: Scalars["Int"]["input"];
  /** Maximum number of drivers to test */
  maxDriversToTest?: InputMaybe<Scalars["Int"]["input"]>;
  /** Response time in seconds for one sequential offer */
  perDriverTimeoutSeconds: Scalars["Int"]["input"];
};

export type Service = {
  __typename?: "Service";
  baseFare: Scalars["Float"]["output"];
  cancellationDriverShare: Scalars["Float"]["output"];
  cancellationTotalFee: Scalars["Float"]["output"];
  categoryId: Scalars["ID"]["output"];
  dateRangeMultipliers: Array<DateRangeMultiplier>;
  description?: Maybe<Scalars["String"]["output"]>;
  displayPriority: Scalars["Int"]["output"];
  distanceMultipliers: Array<DistanceMultiplier>;
  id: Scalars["ID"]["output"];
  isDefaultDispatchService: Scalars["Boolean"]["output"];
  maximumDestinationDistance: Scalars["Int"]["output"];
  media: Media;
  mediaId: Scalars["ID"]["output"];
  minimumFee: Scalars["Float"]["output"];
  name: Scalars["String"]["output"];
  options: Array<ServiceOption>;
  orderTypes: Array<TaxiOrderType>;
  paymentMethod: ServicePaymentMethod;
  perHundredMeters: Scalars["Float"]["output"];
  perMinuteDrive: Scalars["Float"]["output"];
  perMinuteWait: Scalars["Float"]["output"];
  personCapacity?: Maybe<Scalars["Int"]["output"]>;
  prepayPercent: Scalars["Float"]["output"];
  priceRangeMaxPercent: Scalars["Float"]["output"];
  priceRangeMinPercent: Scalars["Float"]["output"];
  pricingMode: PricingMode;
  providerShareFlat: Scalars["Float"]["output"];
  providerSharePercent: Scalars["Int"]["output"];
  rangePolicy: RangePolicy;
  regions: Array<Region>;
  roundingFactor?: Maybe<Scalars["Float"]["output"]>;
  searchRadius: Scalars["Int"]["output"];
  timeMultipliers: Array<TimeMultiplier>;
  twoWayAvailable: Scalars["Boolean"]["output"];
  weekdayMultipliers: Array<WeekdayMultiplier>;
};

export type ServiceOptionsArgs = {
  filter?: ServiceOptionFilter;
  sorting?: Array<ServiceOptionSort>;
};

export type ServiceRegionsArgs = {
  filter?: RegionFilter;
  sorting?: Array<RegionSort>;
};

export type ServiceCategory = {
  __typename?: "ServiceCategory";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  services: Array<Service>;
};

export type ServiceCategoryServicesArgs = {
  filter?: ServiceFilter;
  sorting?: Array<ServiceSort>;
};

export type ServiceCategoryDeleteResponse = {
  __typename?: "ServiceCategoryDeleteResponse";
  id?: Maybe<Scalars["ID"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type ServiceCategoryFilter = {
  and?: InputMaybe<Array<ServiceCategoryFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ServiceCategoryFilter>>;
};

export type ServiceCategoryInput = {
  enabled?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

export type ServiceCategorySort = {
  direction: SortDirection;
  field: ServiceCategorySortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ServiceCategorySortFields {
  Id = "id",
}

export type ServiceCategoryWithCost = {
  __typename?: "ServiceCategoryWithCost";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  services: Array<ServiceWithCost>;
};

export type ServiceDeleteResponse = {
  __typename?: "ServiceDeleteResponse";
  baseFare?: Maybe<Scalars["Float"]["output"]>;
  cancellationDriverShare?: Maybe<Scalars["Float"]["output"]>;
  cancellationTotalFee?: Maybe<Scalars["Float"]["output"]>;
  categoryId?: Maybe<Scalars["ID"]["output"]>;
  dateRangeMultipliers?: Maybe<Array<DateRangeMultiplier>>;
  description?: Maybe<Scalars["String"]["output"]>;
  displayPriority?: Maybe<Scalars["Int"]["output"]>;
  distanceMultipliers?: Maybe<Array<DistanceMultiplier>>;
  id?: Maybe<Scalars["ID"]["output"]>;
  isDefaultDispatchService?: Maybe<Scalars["Boolean"]["output"]>;
  maximumDestinationDistance?: Maybe<Scalars["Int"]["output"]>;
  mediaId?: Maybe<Scalars["ID"]["output"]>;
  minimumFee?: Maybe<Scalars["Float"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  orderTypes?: Maybe<Array<TaxiOrderType>>;
  paymentMethod?: Maybe<ServicePaymentMethod>;
  perHundredMeters?: Maybe<Scalars["Float"]["output"]>;
  perMinuteDrive?: Maybe<Scalars["Float"]["output"]>;
  perMinuteWait?: Maybe<Scalars["Float"]["output"]>;
  personCapacity?: Maybe<Scalars["Int"]["output"]>;
  prepayPercent?: Maybe<Scalars["Float"]["output"]>;
  priceRangeMaxPercent?: Maybe<Scalars["Float"]["output"]>;
  priceRangeMinPercent?: Maybe<Scalars["Float"]["output"]>;
  pricingMode?: Maybe<PricingMode>;
  providerShareFlat?: Maybe<Scalars["Float"]["output"]>;
  providerSharePercent?: Maybe<Scalars["Int"]["output"]>;
  rangePolicy?: Maybe<RangePolicy>;
  roundingFactor?: Maybe<Scalars["Float"]["output"]>;
  searchRadius?: Maybe<Scalars["Int"]["output"]>;
  timeMultipliers?: Maybe<Array<TimeMultiplier>>;
  twoWayAvailable?: Maybe<Scalars["Boolean"]["output"]>;
  weekdayMultipliers?: Maybe<Array<WeekdayMultiplier>>;
};

export type ServiceDistanceBand = {
  __typename?: "ServiceDistanceBand";
  createdAt: Scalars["DateTime"]["output"];
  enabled: Scalars["Boolean"]["output"];
  endMeters?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  pricePer100m: Scalars["Float"]["output"];
  serviceId: Scalars["ID"]["output"];
  sortOrder: Scalars["Int"]["output"];
  startMeters: Scalars["Int"]["output"];
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ServiceDistanceBandItemInput = {
  enabled?: Scalars["Boolean"]["input"];
  endMeters?: InputMaybe<Scalars["Int"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  pricePer100m: Scalars["Float"]["input"];
  sortOrder?: InputMaybe<Scalars["Int"]["input"]>;
  startMeters: Scalars["Int"]["input"];
};

export type ServiceFilter = {
  and?: InputMaybe<Array<ServiceFilter>>;
  categoryId?: InputMaybe<IdFilterComparison>;
  displayPriority?: InputMaybe<IntFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isDefaultDispatchService?: InputMaybe<BooleanFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ServiceFilter>>;
};

export type ServiceInput = {
  baseFare: Scalars["Float"]["input"];
  cancellationDriverShare: Scalars["Float"]["input"];
  cancellationTotalFee: Scalars["Float"]["input"];
  categoryId: Scalars["ID"]["input"];
  dateRangeMultipliers: Array<DateRangeMultiplierInput>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  displayPriority?: Scalars["Int"]["input"];
  distanceMultipliers: Array<DistanceMultiplierInput>;
  isDefaultDispatchService?: Scalars["Boolean"]["input"];
  maximumDestinationDistance: Scalars["Int"]["input"];
  mediaId: Scalars["ID"]["input"];
  minimumFee: Scalars["Float"]["input"];
  name: Scalars["String"]["input"];
  orderTypes?: Array<TaxiOrderType>;
  paymentMethod: ServicePaymentMethod;
  perHundredMeters: Scalars["Float"]["input"];
  perMinuteDrive: Scalars["Float"]["input"];
  perMinuteWait: Scalars["Float"]["input"];
  personCapacity?: InputMaybe<Scalars["Int"]["input"]>;
  prepayPercent: Scalars["Float"]["input"];
  priceRangeMaxPercent?: Scalars["Float"]["input"];
  priceRangeMinPercent?: Scalars["Float"]["input"];
  pricingMode?: PricingMode;
  providerShareFlat: Scalars["Float"]["input"];
  providerSharePercent: Scalars["Int"]["input"];
  rangePolicy?: RangePolicy;
  roundingFactor?: InputMaybe<Scalars["Float"]["input"]>;
  searchRadius: Scalars["Int"]["input"];
  timeMultipliers: Array<TimeMultiplierInput>;
  twoWayAvailable: Scalars["Boolean"]["input"];
  weekdayMultipliers: Array<WeekdayMultiplierInput>;
};

export type ServiceOption = {
  __typename?: "ServiceOption";
  additionalFee?: Maybe<Scalars["Float"]["output"]>;
  icon: ServiceOptionIcon;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  type: ServiceOptionType;
};

export type ServiceOptionAggregateFilter = {
  and?: InputMaybe<Array<ServiceOptionAggregateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ServiceOptionAggregateFilter>>;
};

export type ServiceOptionDeleteResponse = {
  __typename?: "ServiceOptionDeleteResponse";
  additionalFee?: Maybe<Scalars["Float"]["output"]>;
  icon?: Maybe<ServiceOptionIcon>;
  id?: Maybe<Scalars["ID"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<ServiceOptionType>;
};

export type ServiceOptionFilter = {
  and?: InputMaybe<Array<ServiceOptionFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ServiceOptionFilter>>;
};

export enum ServiceOptionIcon {
  Custom1 = "Custom1",
  Custom2 = "Custom2",
  Custom3 = "Custom3",
  Custom4 = "Custom4",
  Custom5 = "Custom5",
  Luggage = "Luggage",
  PackageDelivery = "PackageDelivery",
  Pet = "Pet",
  Shopping = "Shopping",
  TwoWay = "TwoWay",
}

export type ServiceOptionInput = {
  additionalFee?: InputMaybe<Scalars["Float"]["input"]>;
  icon: ServiceOptionIcon;
  name: Scalars["String"]["input"];
  type: ServiceOptionType;
};

export type ServiceOptionSort = {
  direction: SortDirection;
  field: ServiceOptionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ServiceOptionSortFields {
  Id = "id",
}

export enum ServiceOptionType {
  Free = "Free",
  Paid = "Paid",
  TwoWay = "TwoWay",
}

export enum ServicePaymentMethod {
  CashCredit = "CashCredit",
  OnlyCash = "OnlyCash",
  OnlyCredit = "OnlyCredit",
}

export type ServiceSort = {
  direction: SortDirection;
  field: ServiceSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ServiceSortFields {
  CategoryId = "categoryId",
  DisplayPriority = "displayPriority",
  Id = "id",
  IsDefaultDispatchService = "isDefaultDispatchService",
  Name = "name",
}

export type ServiceTariffProfile = {
  __typename?: "ServiceTariffProfile";
  baseFare?: Maybe<Scalars["Float"]["output"]>;
  commissionRate?: Maybe<Scalars["Float"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  dateRangeMultipliers?: Maybe<Array<TariffDateRangeRule>>;
  id: Scalars["ID"]["output"];
  maxCalendarMultiplier?: Maybe<Scalars["Float"]["output"]>;
  maximumDestinationDistance?: Maybe<Scalars["Int"]["output"]>;
  minimumFee?: Maybe<Scalars["Float"]["output"]>;
  perKm?: Maybe<Scalars["Float"]["output"]>;
  perMinute?: Maybe<Scalars["Float"]["output"]>;
  perMinuteDrive?: Maybe<Scalars["Float"]["output"]>;
  perMinuteWait?: Maybe<Scalars["Float"]["output"]>;
  roundingFactor?: Maybe<Scalars["Float"]["output"]>;
  searchRadius?: Maybe<Scalars["Int"]["output"]>;
  service: Service;
  serviceId: Scalars["ID"]["output"];
  tariffProfile: TariffProfile;
  tariffProfileId: Scalars["ID"]["output"];
  timeMultipliers?: Maybe<Array<TariffTimeOfDayRule>>;
  updatedAt: Scalars["DateTime"]["output"];
  weekdayMultipliers?: Maybe<Array<TariffWeekdayRule>>;
};

export type ServiceTariffProfileConnection = {
  __typename?: "ServiceTariffProfileConnection";
  /** Array of nodes. */
  nodes: Array<ServiceTariffProfile>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type ServiceTariffProfileDeleteResponse = {
  __typename?: "ServiceTariffProfileDeleteResponse";
  baseFare?: Maybe<Scalars["Float"]["output"]>;
  commissionRate?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  dateRangeMultipliers?: Maybe<Array<TariffDateRangeRule>>;
  id?: Maybe<Scalars["ID"]["output"]>;
  maxCalendarMultiplier?: Maybe<Scalars["Float"]["output"]>;
  maximumDestinationDistance?: Maybe<Scalars["Int"]["output"]>;
  minimumFee?: Maybe<Scalars["Float"]["output"]>;
  perKm?: Maybe<Scalars["Float"]["output"]>;
  perMinute?: Maybe<Scalars["Float"]["output"]>;
  perMinuteDrive?: Maybe<Scalars["Float"]["output"]>;
  perMinuteWait?: Maybe<Scalars["Float"]["output"]>;
  roundingFactor?: Maybe<Scalars["Float"]["output"]>;
  searchRadius?: Maybe<Scalars["Int"]["output"]>;
  serviceId?: Maybe<Scalars["ID"]["output"]>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
  timeMultipliers?: Maybe<Array<TariffTimeOfDayRule>>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  weekdayMultipliers?: Maybe<Array<TariffWeekdayRule>>;
};

export type ServiceTariffProfileFilter = {
  and?: InputMaybe<Array<ServiceTariffProfileFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ServiceTariffProfileFilter>>;
  serviceId?: InputMaybe<IdFilterComparison>;
  tariffProfileId?: InputMaybe<IdFilterComparison>;
};

export type ServiceTariffProfileInput = {
  baseFare?: InputMaybe<Scalars["Float"]["input"]>;
  commissionRate?: InputMaybe<Scalars["Float"]["input"]>;
  dateRangeMultipliers?: InputMaybe<Array<TariffDateRangeRuleInput>>;
  maxCalendarMultiplier?: InputMaybe<Scalars["Float"]["input"]>;
  maximumDestinationDistance?: InputMaybe<Scalars["Int"]["input"]>;
  minimumFee?: InputMaybe<Scalars["Float"]["input"]>;
  perKm?: InputMaybe<Scalars["Float"]["input"]>;
  perMinute?: InputMaybe<Scalars["Float"]["input"]>;
  perMinuteDrive?: InputMaybe<Scalars["Float"]["input"]>;
  perMinuteWait?: InputMaybe<Scalars["Float"]["input"]>;
  roundingFactor?: InputMaybe<Scalars["Float"]["input"]>;
  searchRadius?: InputMaybe<Scalars["Int"]["input"]>;
  serviceId: Scalars["ID"]["input"];
  tariffProfileId: Scalars["ID"]["input"];
  timeMultipliers?: InputMaybe<Array<TariffTimeOfDayRuleInput>>;
  weekdayMultipliers?: InputMaybe<Array<TariffWeekdayRuleInput>>;
};

export type ServiceTariffProfileSort = {
  direction: SortDirection;
  field: ServiceTariffProfileSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ServiceTariffProfileSortFields {
  Id = "id",
  ServiceId = "serviceId",
  TariffProfileId = "tariffProfileId",
}

export type ServiceWithCost = {
  __typename?: "ServiceWithCost";
  /** @deprecated Use costResult instead for range pricing support */
  cost: Scalars["Float"]["output"];
  costResult: CostResult;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  media: Media;
  name: Scalars["String"]["output"];
  options: Array<ServiceOption>;
  personCapacity?: Maybe<Scalars["Int"]["output"]>;
};

export type SessionInfo = {
  __typename?: "SessionInfo";
  appType: AppType;
  createdAt: Scalars["DateTime"]["output"];
  deviceName?: Maybe<Scalars["String"]["output"]>;
  devicePlatform: DevicePlatform;
  deviceType: DeviceType;
  ip?: Maybe<Scalars["String"]["output"]>;
  ipLocation?: Maybe<Scalars["String"]["output"]>;
  lastActivityAt?: Maybe<Scalars["DateTime"]["output"]>;
  token: Scalars["String"]["output"];
};

export type SetActiveServicesOnDriverInput = {
  driverId: Scalars["ID"]["input"];
  serviceIds: Array<Scalars["ID"]["input"]>;
};

export type SetFleetsOnZonePriceInput = {
  /** The id of the record. */
  id: Scalars["ID"]["input"];
  /** The ids of the relations. */
  relationIds: Array<Scalars["ID"]["input"]>;
};

export type SetOptionsOnServiceInput = {
  /** The id of the record. */
  id: Scalars["ID"]["input"];
  /** The ids of the relations. */
  relationIds: Array<Scalars["ID"]["input"]>;
};

export type SetRegionsOnServiceInput = {
  /** The id of the record. */
  id: Scalars["ID"]["input"];
  /** The ids of the relations. */
  relationIds: Array<Scalars["ID"]["input"]>;
};

export type SetRiderWhatsAppEnabledInput = {
  confirmRiderRuntimeReady: Scalars["Boolean"]["input"];
  enabled: Scalars["Boolean"]["input"];
  expectedVersion: Scalars["Int"]["input"];
};

export type SetServicesOnZonePriceInput = {
  /** The id of the record. */
  id: Scalars["ID"]["input"];
  /** The ids of the relations. */
  relationIds: Array<Scalars["ID"]["input"]>;
};

export type SetTelematicsProfileActiveInput = {
  active: Scalars["Boolean"]["input"];
  profileId: Scalars["ID"]["input"];
};

export type SetTelematicsProviderSecretInput = {
  providerSettingId: Scalars["ID"]["input"];
  token: Scalars["String"]["input"];
};

/** Which settlement path produced the final collected amount. */
export enum SettlementSource {
  Cash = "Cash",
  Fixed = "Fixed",
  Gateway = "Gateway",
  Meter = "Meter",
  Wallet = "Wallet",
}

/** Sort Directions */
export enum SortDirection {
  Asc = "ASC",
  Desc = "DESC",
}

/** Sort Nulls Options */
export enum SortNulls {
  NullsFirst = "NULLS_FIRST",
  NullsLast = "NULLS_LAST",
}

/** Sort order */
export enum SortOrder {
  Asc = "ASC",
  Desc = "DESC",
}

export type StringFieldComparison = {
  eq?: InputMaybe<Scalars["String"]["input"]>;
  gt?: InputMaybe<Scalars["String"]["input"]>;
  gte?: InputMaybe<Scalars["String"]["input"]>;
  iLike?: InputMaybe<Scalars["String"]["input"]>;
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<Scalars["String"]["input"]>;
  lt?: InputMaybe<Scalars["String"]["input"]>;
  lte?: InputMaybe<Scalars["String"]["input"]>;
  neq?: InputMaybe<Scalars["String"]["input"]>;
  notILike?: InputMaybe<Scalars["String"]["input"]>;
  notIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
  notLike?: InputMaybe<Scalars["String"]["input"]>;
};

export type Subscription = {
  __typename?: "Subscription";
  adminNotificationEventCreated: AdminNotificationEventV1;
  complaintCreated: TaxiSupportRequest;
  driverLocationClusterUpdate: Array<ClusteredLocation>;
  driverLocationUpdated: DriverLocationUpdate;
  driverManualRideCreated: DriverManualRideCreatedEvent;
  driverStatusUpdated: DriverStatusUpdate;
  notificationCreated: AdminNotificationUnion;
  operatorDashboardEvent: OperatorDashboardEvent;
  orderChanged: OrderChangeEvent;
  orderUpdated: OrderChangeEvent;
  sosCreated: DistressSignal;
  telematicsAlertReviewChanged: TelematicsChangeEventDto;
  telematicsIntegrityAlertChanged: TelematicsChangeEventDto;
  telematicsLatestStatusChanged: TelematicsChangeEventDto;
};

export type SubscriptionDriverLocationClusterUpdateArgs = {
  h3IndexIds: Array<Scalars["String"]["input"]>;
  h3Resolution: Scalars["Int"]["input"];
};

export type SubscriptionDriverLocationUpdatedArgs = {
  driverIds: Array<Scalars["ID"]["input"]>;
};

export type SubscriptionDriverStatusUpdatedArgs = {
  driverIds: Array<Scalars["ID"]["input"]>;
};

export type SubscriptionOrderUpdatedArgs = {
  orderId: Scalars["ID"]["input"];
};

export type TariffDateRangeRule = {
  __typename?: "TariffDateRangeRule";
  enabled: Scalars["Boolean"]["output"];
  endDateTime: Scalars["String"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  startDateTime: Scalars["String"]["output"];
  upliftPercentage: Scalars["Float"]["output"];
};

export type TariffDateRangeRuleInput = {
  enabled?: Scalars["Boolean"]["input"];
  endDateTime: Scalars["String"]["input"];
  label?: InputMaybe<Scalars["String"]["input"]>;
  startDateTime: Scalars["String"]["input"];
  upliftPercentage: Scalars["Float"]["input"];
};

export type TariffProfile = {
  __typename?: "TariffProfile";
  code: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  title: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type TariffProfileConnection = {
  __typename?: "TariffProfileConnection";
  /** Array of nodes. */
  nodes: Array<TariffProfile>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type TariffProfileDeleteResponse = {
  __typename?: "TariffProfileDeleteResponse";
  code?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  isDefault?: Maybe<Scalars["Boolean"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type TariffProfileFilter = {
  and?: InputMaybe<Array<TariffProfileFilter>>;
  code?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isActive?: InputMaybe<BooleanFieldComparison>;
  isDefault?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<TariffProfileFilter>>;
  title?: InputMaybe<StringFieldComparison>;
};

export type TariffProfileInput = {
  code: Scalars["String"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  isActive?: Scalars["Boolean"]["input"];
  isDefault?: Scalars["Boolean"]["input"];
  title: Scalars["String"]["input"];
};

export type TariffProfileSort = {
  direction: SortDirection;
  field: TariffProfileSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum TariffProfileSortFields {
  Code = "code",
  Id = "id",
  IsActive = "isActive",
  IsDefault = "isDefault",
  Title = "title",
}

export type TariffTimeOfDayRule = {
  __typename?: "TariffTimeOfDayRule";
  enabled: Scalars["Boolean"]["output"];
  endTime: Scalars["String"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  startTime: Scalars["String"]["output"];
  upliftPercentage: Scalars["Float"]["output"];
};

export type TariffTimeOfDayRuleInput = {
  enabled?: Scalars["Boolean"]["input"];
  endTime: Scalars["String"]["input"];
  label?: InputMaybe<Scalars["String"]["input"]>;
  startTime: Scalars["String"]["input"];
  upliftPercentage: Scalars["Float"]["input"];
};

export type TariffWeekdayRule = {
  __typename?: "TariffWeekdayRule";
  enabled: Scalars["Boolean"]["output"];
  upliftPercentage: Scalars["Float"]["output"];
  weekday: Weekday;
};

export type TariffWeekdayRuleInput = {
  enabled?: Scalars["Boolean"]["input"];
  upliftPercentage: Scalars["Float"]["input"];
  weekday: Weekday;
};

export type TaxiOrder = {
  __typename?: "TaxiOrder";
  activities: Array<RequestActivity>;
  chatMessages: Array<ChatMessage>;
  couponDiscount?: Maybe<Scalars["Float"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  createdDirectlyByDriverId?: Maybe<Scalars["ID"]["output"]>;
  currency: Scalars["String"]["output"];
  directions: Array<Point>;
  driver?: Maybe<TaxiOrderDriver>;
  driverVehicleAssignmentId?: Maybe<Scalars["ID"]["output"]>;
  driversSentTo: Scalars["Int"]["output"];
  dropoffEta?: Maybe<Scalars["DateTime"]["output"]>;
  estimatedFixedPrice?: Maybe<Scalars["Float"]["output"]>;
  fareMode?: Maybe<FareMode>;
  finalCollectedAmount?: Maybe<Scalars["Float"]["output"]>;
  fleet?: Maybe<ActiveTaxiOrderFleet>;
  id: Scalars["ID"]["output"];
  isAnonymousPassenger?: Maybe<Scalars["Boolean"]["output"]>;
  meterAmount?: Maybe<Scalars["Float"]["output"]>;
  meterCurrency?: Maybe<Scalars["String"]["output"]>;
  meterEnteredAt?: Maybe<Scalars["DateTime"]["output"]>;
  meterExtrasAmount?: Maybe<Scalars["Float"]["output"]>;
  meterNote?: Maybe<Scalars["String"]["output"]>;
  meterPhotoUrl?: Maybe<Scalars["String"]["output"]>;
  operator?: Maybe<Operator>;
  operatorId?: Maybe<Scalars["ID"]["output"]>;
  options: Array<RideOption>;
  orderSource?: Maybe<OrderSource>;
  paymentMethod: PaymentMethodBase;
  pickupEta?: Maybe<Scalars["DateTime"]["output"]>;
  reportingSource?: Maybe<OrderSource>;
  rider: ActiveTaxiOrderRider;
  routeSource?: Maybe<RouteSource>;
  scheduledAt?: Maybe<Scalars["DateTime"]["output"]>;
  service: TaxiOrderService;
  settlementSource?: Maybe<SettlementSource>;
  status: OrderStatus;
  streetPassengerName?: Maybe<Scalars["String"]["output"]>;
  streetPassengerNationality?: Maybe<Scalars["String"]["output"]>;
  streetPassengerPhone?: Maybe<Scalars["String"]["output"]>;
  totalCost: Scalars["Float"]["output"];
  type: TaxiOrderType;
  vehicleColor?: Maybe<Scalars["String"]["output"]>;
  vehicleId?: Maybe<Scalars["ID"]["output"]>;
  vehicleModel?: Maybe<Scalars["String"]["output"]>;
  vehiclePlate?: Maybe<Scalars["String"]["output"]>;
  vehicleProductionYear?: Maybe<Scalars["Int"]["output"]>;
  vehicleSnapshotSource?: Maybe<VehicleSnapshotSource>;
  waitMinutes?: Maybe<Scalars["Int"]["output"]>;
  waypoints: Array<WaypointBase>;
};

export type TaxiOrderDriver = {
  __typename?: "TaxiOrderDriver";
  fullName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  location?: Maybe<Point>;
  mobileNumber: Scalars["String"]["output"];
  rating?: Maybe<Scalars["Int"]["output"]>;
  vehicleColor?: Maybe<Scalars["String"]["output"]>;
  vehicleModel?: Maybe<Scalars["String"]["output"]>;
  vehiclePlate?: Maybe<Scalars["String"]["output"]>;
};

export type TaxiOrderFilterInput = {
  driverId?: InputMaybe<Scalars["ID"]["input"]>;
  fleetId?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  orderType?: InputMaybe<Array<TaxiOrderType>>;
  riderId?: InputMaybe<Scalars["ID"]["input"]>;
  serviceId?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  status?: InputMaybe<Array<TaxiOrderStatus>>;
};

export type TaxiOrderNote = {
  __typename?: "TaxiOrderNote";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  note: Scalars["String"]["output"];
  orderId: Scalars["ID"]["output"];
  staff: Operator;
};

export type TaxiOrderNoteConnection = {
  __typename?: "TaxiOrderNoteConnection";
  /** Array of nodes. */
  nodes: Array<TaxiOrderNote>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type TaxiOrderNoteFilter = {
  and?: InputMaybe<Array<TaxiOrderNoteFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<TaxiOrderNoteFilter>>;
  orderId: IdFilterComparison;
};

export type TaxiOrderNoteSort = {
  direction: SortDirection;
  field: TaxiOrderNoteSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum TaxiOrderNoteSortFields {
  Id = "id",
  OrderId = "orderId",
}

export type TaxiOrderService = {
  __typename?: "TaxiOrderService";
  id: Scalars["ID"]["output"];
  imageUrl: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type TaxiOrderSortInput = {
  id?: InputMaybe<SortOrder>;
};

export enum TaxiOrderStatus {
  Canceled = "Canceled",
  Completed = "Completed",
  Expired = "Expired",
  OnTrip = "OnTrip",
  Scheduled = "Scheduled",
  SearchingForDriver = "SearchingForDriver",
}

/** Different types of taxi orders, including ride, rideshare, parcel delivery, and food delivery. */
export enum TaxiOrderType {
  FoodDelivery = "FoodDelivery",
  ParcelDelivery = "ParcelDelivery",
  Ride = "Ride",
  Rideshare = "Rideshare",
}

export type TaxiOrderTypeFilterComparison = {
  eq?: InputMaybe<TaxiOrderType>;
  gt?: InputMaybe<TaxiOrderType>;
  gte?: InputMaybe<TaxiOrderType>;
  iLike?: InputMaybe<TaxiOrderType>;
  in?: InputMaybe<Array<TaxiOrderType>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<TaxiOrderType>;
  lt?: InputMaybe<TaxiOrderType>;
  lte?: InputMaybe<TaxiOrderType>;
  neq?: InputMaybe<TaxiOrderType>;
  notILike?: InputMaybe<TaxiOrderType>;
  notIn?: InputMaybe<Array<TaxiOrderType>>;
  notLike?: InputMaybe<TaxiOrderType>;
};

export type TaxiPayoutSession = {
  __typename?: "TaxiPayoutSession";
  createdAt: Scalars["DateTime"]["output"];
  currency: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  driverTransactions: TaxiPayoutSessionDriverTransactionsConnection;
  driverTransactionsAggregate: Array<TaxiPayoutSessionDriverTransactionsAggregateResponse>;
  id: Scalars["ID"]["output"];
  payoutMethodDetails: Array<TaxiPayoutSessionPayoutMethodDetail>;
  payoutMethods: Array<PayoutMethod>;
  processedAt?: Maybe<Scalars["DateTime"]["output"]>;
  status: PayoutSessionStatus;
  totalAmount: Scalars["Float"]["output"];
};

export type TaxiPayoutSessionDriverTransactionsArgs = {
  filter?: DriverTransactionFilter;
  paging?: OffsetPaging;
  sorting?: Array<DriverTransactionSort>;
};

export type TaxiPayoutSessionDriverTransactionsAggregateArgs = {
  filter?: InputMaybe<DriverTransactionAggregateFilter>;
};

export type TaxiPayoutSessionPayoutMethodDetailsArgs = {
  filter?: TaxiPayoutSessionPayoutMethodDetailFilter;
  sorting?: Array<TaxiPayoutSessionPayoutMethodDetailSort>;
};

export type TaxiPayoutSessionPayoutMethodsArgs = {
  filter?: PayoutMethodFilter;
  sorting?: Array<PayoutMethodSort>;
};

export type TaxiPayoutSessionConnection = {
  __typename?: "TaxiPayoutSessionConnection";
  /** Array of nodes. */
  nodes: Array<TaxiPayoutSession>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type TaxiPayoutSessionDriverTransactionsAggregateGroupBy = {
  __typename?: "TaxiPayoutSessionDriverTransactionsAggregateGroupBy";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  payoutAccountId?: Maybe<Scalars["ID"]["output"]>;
  payoutMethodId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type TaxiPayoutSessionDriverTransactionsAggregateResponse = {
  __typename?: "TaxiPayoutSessionDriverTransactionsAggregateResponse";
  avg?: Maybe<TaxiPayoutSessionDriverTransactionsAvgAggregate>;
  count?: Maybe<TaxiPayoutSessionDriverTransactionsCountAggregate>;
  groupBy?: Maybe<TaxiPayoutSessionDriverTransactionsAggregateGroupBy>;
  max?: Maybe<TaxiPayoutSessionDriverTransactionsMaxAggregate>;
  min?: Maybe<TaxiPayoutSessionDriverTransactionsMinAggregate>;
  sum?: Maybe<TaxiPayoutSessionDriverTransactionsSumAggregate>;
};

export type TaxiPayoutSessionDriverTransactionsAvgAggregate = {
  __typename?: "TaxiPayoutSessionDriverTransactionsAvgAggregate";
  amount?: Maybe<Scalars["Float"]["output"]>;
  driverId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Float"]["output"]>;
  payoutAccountId?: Maybe<Scalars["Float"]["output"]>;
  payoutMethodId?: Maybe<Scalars["Float"]["output"]>;
  payoutSessionId?: Maybe<Scalars["Float"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["Float"]["output"]>;
};

export type TaxiPayoutSessionDriverTransactionsConnection = {
  __typename?: "TaxiPayoutSessionDriverTransactionsConnection";
  /** Array of nodes. */
  nodes: Array<DriverTransaction>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type TaxiPayoutSessionDriverTransactionsCountAggregate = {
  __typename?: "TaxiPayoutSessionDriverTransactionsCountAggregate";
  action?: Maybe<Scalars["Int"]["output"]>;
  amount?: Maybe<Scalars["Int"]["output"]>;
  createdAt?: Maybe<Scalars["Int"]["output"]>;
  currency?: Maybe<Scalars["Int"]["output"]>;
  driverId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Int"]["output"]>;
  payoutAccountId?: Maybe<Scalars["Int"]["output"]>;
  payoutMethodId?: Maybe<Scalars["Int"]["output"]>;
  payoutSessionId?: Maybe<Scalars["Int"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
};

export type TaxiPayoutSessionDriverTransactionsMaxAggregate = {
  __typename?: "TaxiPayoutSessionDriverTransactionsMaxAggregate";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  payoutAccountId?: Maybe<Scalars["ID"]["output"]>;
  payoutMethodId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type TaxiPayoutSessionDriverTransactionsMinAggregate = {
  __typename?: "TaxiPayoutSessionDriverTransactionsMinAggregate";
  action?: Maybe<TransactionAction>;
  amount?: Maybe<Scalars["Float"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
  payoutAccountId?: Maybe<Scalars["ID"]["output"]>;
  payoutMethodId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionId?: Maybe<Scalars["ID"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<TransactionStatus>;
};

export type TaxiPayoutSessionDriverTransactionsSumAggregate = {
  __typename?: "TaxiPayoutSessionDriverTransactionsSumAggregate";
  amount?: Maybe<Scalars["Float"]["output"]>;
  driverId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
  paymentGatewayId?: Maybe<Scalars["Float"]["output"]>;
  payoutAccountId?: Maybe<Scalars["Float"]["output"]>;
  payoutMethodId?: Maybe<Scalars["Float"]["output"]>;
  payoutSessionId?: Maybe<Scalars["Float"]["output"]>;
  payoutSessionMethodId?: Maybe<Scalars["Float"]["output"]>;
};

export type TaxiPayoutSessionFilter = {
  and?: InputMaybe<Array<TaxiPayoutSessionFilter>>;
  currency?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<TaxiPayoutSessionFilter>>;
  status?: InputMaybe<PayoutSessionStatusFilterComparison>;
  totalAmount?: InputMaybe<NumberFieldComparison>;
};

export type TaxiPayoutSessionPayoutMethodDetail = {
  __typename?: "TaxiPayoutSessionPayoutMethodDetail";
  driverTransactions: TaxiPayoutSessionPayoutMethodDetailDriverTransactionsConnection;
  driverTransactionsAggregate: Array<TaxiPayoutSessionPayoutMethodDetailDriverTransactionsAggregateResponse>;
  id: Scalars["ID"]["output"];
  payoutMethod: PayoutMethod;
  status: PayoutSessionStatus;
};

export type TaxiPayoutSessionPayoutMethodDetailDriverTransactionsArgs = {
  filter?: DriverTransactionFilter;
  paging?: OffsetPaging;
  sorting?: Array<DriverTransactionSort>;
};

export type TaxiPayoutSessionPayoutMethodDetailDriverTransactionsAggregateArgs =
  {
    filter?: InputMaybe<DriverTransactionAggregateFilter>;
  };

export type TaxiPayoutSessionPayoutMethodDetailDriverTransactionsAggregateGroupBy =
  {
    __typename?: "TaxiPayoutSessionPayoutMethodDetailDriverTransactionsAggregateGroupBy";
    action?: Maybe<TransactionAction>;
    amount?: Maybe<Scalars["Float"]["output"]>;
    createdAt?: Maybe<Scalars["DateTime"]["output"]>;
    currency?: Maybe<Scalars["String"]["output"]>;
    driverId?: Maybe<Scalars["ID"]["output"]>;
    id?: Maybe<Scalars["ID"]["output"]>;
    paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
    payoutAccountId?: Maybe<Scalars["ID"]["output"]>;
    payoutMethodId?: Maybe<Scalars["ID"]["output"]>;
    payoutSessionId?: Maybe<Scalars["ID"]["output"]>;
    payoutSessionMethodId?: Maybe<Scalars["ID"]["output"]>;
    status?: Maybe<TransactionStatus>;
  };

export type TaxiPayoutSessionPayoutMethodDetailDriverTransactionsAggregateResponse =
  {
    __typename?: "TaxiPayoutSessionPayoutMethodDetailDriverTransactionsAggregateResponse";
    avg?: Maybe<TaxiPayoutSessionPayoutMethodDetailDriverTransactionsAvgAggregate>;
    count?: Maybe<TaxiPayoutSessionPayoutMethodDetailDriverTransactionsCountAggregate>;
    groupBy?: Maybe<TaxiPayoutSessionPayoutMethodDetailDriverTransactionsAggregateGroupBy>;
    max?: Maybe<TaxiPayoutSessionPayoutMethodDetailDriverTransactionsMaxAggregate>;
    min?: Maybe<TaxiPayoutSessionPayoutMethodDetailDriverTransactionsMinAggregate>;
    sum?: Maybe<TaxiPayoutSessionPayoutMethodDetailDriverTransactionsSumAggregate>;
  };

export type TaxiPayoutSessionPayoutMethodDetailDriverTransactionsAvgAggregate =
  {
    __typename?: "TaxiPayoutSessionPayoutMethodDetailDriverTransactionsAvgAggregate";
    amount?: Maybe<Scalars["Float"]["output"]>;
    driverId?: Maybe<Scalars["Float"]["output"]>;
    id?: Maybe<Scalars["Float"]["output"]>;
    paymentGatewayId?: Maybe<Scalars["Float"]["output"]>;
    payoutAccountId?: Maybe<Scalars["Float"]["output"]>;
    payoutMethodId?: Maybe<Scalars["Float"]["output"]>;
    payoutSessionId?: Maybe<Scalars["Float"]["output"]>;
    payoutSessionMethodId?: Maybe<Scalars["Float"]["output"]>;
  };

export type TaxiPayoutSessionPayoutMethodDetailDriverTransactionsConnection = {
  __typename?: "TaxiPayoutSessionPayoutMethodDetailDriverTransactionsConnection";
  /** Array of nodes. */
  nodes: Array<DriverTransaction>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type TaxiPayoutSessionPayoutMethodDetailDriverTransactionsCountAggregate =
  {
    __typename?: "TaxiPayoutSessionPayoutMethodDetailDriverTransactionsCountAggregate";
    action?: Maybe<Scalars["Int"]["output"]>;
    amount?: Maybe<Scalars["Int"]["output"]>;
    createdAt?: Maybe<Scalars["Int"]["output"]>;
    currency?: Maybe<Scalars["Int"]["output"]>;
    driverId?: Maybe<Scalars["Int"]["output"]>;
    id?: Maybe<Scalars["Int"]["output"]>;
    paymentGatewayId?: Maybe<Scalars["Int"]["output"]>;
    payoutAccountId?: Maybe<Scalars["Int"]["output"]>;
    payoutMethodId?: Maybe<Scalars["Int"]["output"]>;
    payoutSessionId?: Maybe<Scalars["Int"]["output"]>;
    payoutSessionMethodId?: Maybe<Scalars["Int"]["output"]>;
    status?: Maybe<Scalars["Int"]["output"]>;
  };

export type TaxiPayoutSessionPayoutMethodDetailDriverTransactionsMaxAggregate =
  {
    __typename?: "TaxiPayoutSessionPayoutMethodDetailDriverTransactionsMaxAggregate";
    action?: Maybe<TransactionAction>;
    amount?: Maybe<Scalars["Float"]["output"]>;
    createdAt?: Maybe<Scalars["DateTime"]["output"]>;
    currency?: Maybe<Scalars["String"]["output"]>;
    driverId?: Maybe<Scalars["ID"]["output"]>;
    id?: Maybe<Scalars["ID"]["output"]>;
    paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
    payoutAccountId?: Maybe<Scalars["ID"]["output"]>;
    payoutMethodId?: Maybe<Scalars["ID"]["output"]>;
    payoutSessionId?: Maybe<Scalars["ID"]["output"]>;
    payoutSessionMethodId?: Maybe<Scalars["ID"]["output"]>;
    status?: Maybe<TransactionStatus>;
  };

export type TaxiPayoutSessionPayoutMethodDetailDriverTransactionsMinAggregate =
  {
    __typename?: "TaxiPayoutSessionPayoutMethodDetailDriverTransactionsMinAggregate";
    action?: Maybe<TransactionAction>;
    amount?: Maybe<Scalars["Float"]["output"]>;
    createdAt?: Maybe<Scalars["DateTime"]["output"]>;
    currency?: Maybe<Scalars["String"]["output"]>;
    driverId?: Maybe<Scalars["ID"]["output"]>;
    id?: Maybe<Scalars["ID"]["output"]>;
    paymentGatewayId?: Maybe<Scalars["ID"]["output"]>;
    payoutAccountId?: Maybe<Scalars["ID"]["output"]>;
    payoutMethodId?: Maybe<Scalars["ID"]["output"]>;
    payoutSessionId?: Maybe<Scalars["ID"]["output"]>;
    payoutSessionMethodId?: Maybe<Scalars["ID"]["output"]>;
    status?: Maybe<TransactionStatus>;
  };

export type TaxiPayoutSessionPayoutMethodDetailDriverTransactionsSumAggregate =
  {
    __typename?: "TaxiPayoutSessionPayoutMethodDetailDriverTransactionsSumAggregate";
    amount?: Maybe<Scalars["Float"]["output"]>;
    driverId?: Maybe<Scalars["Float"]["output"]>;
    id?: Maybe<Scalars["Float"]["output"]>;
    paymentGatewayId?: Maybe<Scalars["Float"]["output"]>;
    payoutAccountId?: Maybe<Scalars["Float"]["output"]>;
    payoutMethodId?: Maybe<Scalars["Float"]["output"]>;
    payoutSessionId?: Maybe<Scalars["Float"]["output"]>;
    payoutSessionMethodId?: Maybe<Scalars["Float"]["output"]>;
  };

export type TaxiPayoutSessionPayoutMethodDetailFilter = {
  and?: InputMaybe<Array<TaxiPayoutSessionPayoutMethodDetailFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<TaxiPayoutSessionPayoutMethodDetailFilter>>;
};

export type TaxiPayoutSessionPayoutMethodDetailSort = {
  direction: SortDirection;
  field: TaxiPayoutSessionPayoutMethodDetailSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum TaxiPayoutSessionPayoutMethodDetailSortFields {
  Id = "id",
}

export type TaxiPayoutSessionSort = {
  direction: SortDirection;
  field: TaxiPayoutSessionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum TaxiPayoutSessionSortFields {
  Currency = "currency",
  Id = "id",
  Status = "status",
  TotalAmount = "totalAmount",
}

export enum TaxiPermission {
  DriverEdit = "DRIVER_EDIT",
  DriverView = "DRIVER_VIEW",
  FleetEdit = "FLEET_EDIT",
  FleetView = "FLEET_VIEW",
  OrderEdit = "ORDER_EDIT",
  OrderView = "ORDER_VIEW",
  PricingEdit = "PRICING_EDIT",
  PricingView = "PRICING_VIEW",
  RegionEdit = "REGION_EDIT",
  RegionView = "REGION_VIEW",
  VehicleEdit = "VEHICLE_EDIT",
  VehicleView = "VEHICLE_VIEW",
}

export type TaxiSupportRequest = {
  __typename?: "TaxiSupportRequest";
  activities: Array<TaxiSupportRequestActivity>;
  activitiesAggregate: Array<TaxiSupportRequestActivitiesAggregateResponse>;
  assignedToStaffs: Array<Operator>;
  assignedToStaffsAggregate: Array<TaxiSupportRequestAssignedToStaffsAggregateResponse>;
  content?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  inscriptionTimestamp: Scalars["DateTime"]["output"];
  request: Order;
  requestId: Scalars["ID"]["output"];
  requestedByDriver: Scalars["Boolean"]["output"];
  status: ComplaintStatus;
  subject: Scalars["String"]["output"];
};

export type TaxiSupportRequestActivitiesArgs = {
  filter?: TaxiSupportRequestActivityFilter;
  sorting?: Array<TaxiSupportRequestActivitySort>;
};

export type TaxiSupportRequestActivitiesAggregateArgs = {
  filter?: InputMaybe<TaxiSupportRequestActivityAggregateFilter>;
};

export type TaxiSupportRequestAssignedToStaffsArgs = {
  filter?: OperatorFilter;
  sorting?: Array<OperatorSort>;
};

export type TaxiSupportRequestAssignedToStaffsAggregateArgs = {
  filter?: InputMaybe<OperatorAggregateFilter>;
};

export type TaxiSupportRequestActivitiesAggregateGroupBy = {
  __typename?: "TaxiSupportRequestActivitiesAggregateGroupBy";
  complaintId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type TaxiSupportRequestActivitiesAggregateResponse = {
  __typename?: "TaxiSupportRequestActivitiesAggregateResponse";
  avg?: Maybe<TaxiSupportRequestActivitiesAvgAggregate>;
  count?: Maybe<TaxiSupportRequestActivitiesCountAggregate>;
  groupBy?: Maybe<TaxiSupportRequestActivitiesAggregateGroupBy>;
  max?: Maybe<TaxiSupportRequestActivitiesMaxAggregate>;
  min?: Maybe<TaxiSupportRequestActivitiesMinAggregate>;
  sum?: Maybe<TaxiSupportRequestActivitiesSumAggregate>;
};

export type TaxiSupportRequestActivitiesAvgAggregate = {
  __typename?: "TaxiSupportRequestActivitiesAvgAggregate";
  complaintId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type TaxiSupportRequestActivitiesCountAggregate = {
  __typename?: "TaxiSupportRequestActivitiesCountAggregate";
  complaintId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
};

export type TaxiSupportRequestActivitiesMaxAggregate = {
  __typename?: "TaxiSupportRequestActivitiesMaxAggregate";
  complaintId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type TaxiSupportRequestActivitiesMinAggregate = {
  __typename?: "TaxiSupportRequestActivitiesMinAggregate";
  complaintId?: Maybe<Scalars["ID"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type TaxiSupportRequestActivitiesSumAggregate = {
  __typename?: "TaxiSupportRequestActivitiesSumAggregate";
  complaintId?: Maybe<Scalars["Float"]["output"]>;
  id?: Maybe<Scalars["Float"]["output"]>;
};

export type TaxiSupportRequestActivity = {
  __typename?: "TaxiSupportRequestActivity";
  actor?: Maybe<Operator>;
  assignedToStaffs: Array<Operator>;
  comment?: Maybe<Scalars["String"]["output"]>;
  complaintId: Scalars["ID"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  statusFrom?: Maybe<ComplaintStatus>;
  statusTo?: Maybe<ComplaintStatus>;
  type: ComplaintActivityType;
  unassignedFromStaffs: Array<Operator>;
};

export type TaxiSupportRequestActivityAssignedToStaffsArgs = {
  filter?: OperatorFilter;
  sorting?: Array<OperatorSort>;
};

export type TaxiSupportRequestActivityUnassignedFromStaffsArgs = {
  filter?: OperatorFilter;
  sorting?: Array<OperatorSort>;
};

export type TaxiSupportRequestActivityAggregateFilter = {
  and?: InputMaybe<Array<TaxiSupportRequestActivityAggregateFilter>>;
  complaintId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<TaxiSupportRequestActivityAggregateFilter>>;
};

export type TaxiSupportRequestActivityFilter = {
  and?: InputMaybe<Array<TaxiSupportRequestActivityFilter>>;
  complaintId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<TaxiSupportRequestActivityFilter>>;
};

export type TaxiSupportRequestActivitySort = {
  direction: SortDirection;
  field: TaxiSupportRequestActivitySortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum TaxiSupportRequestActivitySortFields {
  ComplaintId = "complaintId",
  Id = "id",
}

export type TaxiSupportRequestAggregateFilter = {
  and?: InputMaybe<Array<TaxiSupportRequestAggregateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<TaxiSupportRequestAggregateFilter>>;
  request?: InputMaybe<TaxiSupportRequestAggregateFilterOrderAggregateFilter>;
  requestId?: InputMaybe<IdFilterComparison>;
  requestedByDriver?: InputMaybe<BooleanFieldComparison>;
  status?: InputMaybe<ComplaintStatusFilterComparison>;
};

export type TaxiSupportRequestAggregateFilterOrderAggregateFilter = {
  and?: InputMaybe<
    Array<TaxiSupportRequestAggregateFilterOrderAggregateFilter>
  >;
  costAfterCoupon?: InputMaybe<FloatFieldComparison>;
  costBest?: InputMaybe<FloatFieldComparison>;
  createdOn?: InputMaybe<DateFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  distanceBest?: InputMaybe<IntFieldComparison>;
  driverId?: InputMaybe<IdFilterComparison>;
  durationBest?: InputMaybe<IntFieldComparison>;
  fareMode?: InputMaybe<FareModeFilterComparison>;
  finishTimestamp?: InputMaybe<DateFieldComparison>;
  fleetId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  operatorId?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<TaxiSupportRequestAggregateFilterOrderAggregateFilter>>;
  orderSource?: InputMaybe<OrderSourceFilterComparison>;
  paymentMode?: InputMaybe<PaymentModeFilterComparison>;
  regionId?: InputMaybe<IdFilterComparison>;
  reportingSource?: InputMaybe<OrderSourceFilterComparison>;
  riderId?: InputMaybe<IdFilterComparison>;
  routeSource?: InputMaybe<RouteSourceFilterComparison>;
  serviceId?: InputMaybe<IdFilterComparison>;
  status?: InputMaybe<OrderStatusFilterComparison>;
  tariffProfileId?: InputMaybe<IdFilterComparison>;
  type?: InputMaybe<TaxiOrderTypeFilterComparison>;
};

export type TaxiSupportRequestAggregateGroupBy = {
  __typename?: "TaxiSupportRequestAggregateGroupBy";
  id?: Maybe<Scalars["ID"]["output"]>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  requestedByDriver?: Maybe<Scalars["Boolean"]["output"]>;
  status?: Maybe<ComplaintStatus>;
};

export type TaxiSupportRequestAggregateResponse = {
  __typename?: "TaxiSupportRequestAggregateResponse";
  avg?: Maybe<TaxiSupportRequestAvgAggregate>;
  count?: Maybe<TaxiSupportRequestCountAggregate>;
  groupBy?: Maybe<TaxiSupportRequestAggregateGroupBy>;
  max?: Maybe<TaxiSupportRequestMaxAggregate>;
  min?: Maybe<TaxiSupportRequestMinAggregate>;
  sum?: Maybe<TaxiSupportRequestSumAggregate>;
};

export type TaxiSupportRequestAssignedToStaffsAggregateGroupBy = {
  __typename?: "TaxiSupportRequestAssignedToStaffsAggregateGroupBy";
  email?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  isBlocked?: Maybe<Scalars["Boolean"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  mobileNumber?: Maybe<Scalars["String"]["output"]>;
  roleId?: Maybe<Scalars["ID"]["output"]>;
  userName?: Maybe<Scalars["String"]["output"]>;
};

export type TaxiSupportRequestAssignedToStaffsAggregateResponse = {
  __typename?: "TaxiSupportRequestAssignedToStaffsAggregateResponse";
  avg?: Maybe<TaxiSupportRequestAssignedToStaffsAvgAggregate>;
  count?: Maybe<TaxiSupportRequestAssignedToStaffsCountAggregate>;
  groupBy?: Maybe<TaxiSupportRequestAssignedToStaffsAggregateGroupBy>;
  max?: Maybe<TaxiSupportRequestAssignedToStaffsMaxAggregate>;
  min?: Maybe<TaxiSupportRequestAssignedToStaffsMinAggregate>;
  sum?: Maybe<TaxiSupportRequestAssignedToStaffsSumAggregate>;
};

export type TaxiSupportRequestAssignedToStaffsAvgAggregate = {
  __typename?: "TaxiSupportRequestAssignedToStaffsAvgAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
  roleId?: Maybe<Scalars["Float"]["output"]>;
};

export type TaxiSupportRequestAssignedToStaffsCountAggregate = {
  __typename?: "TaxiSupportRequestAssignedToStaffsCountAggregate";
  email?: Maybe<Scalars["Int"]["output"]>;
  firstName?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  isBlocked?: Maybe<Scalars["Int"]["output"]>;
  lastName?: Maybe<Scalars["Int"]["output"]>;
  mobileNumber?: Maybe<Scalars["Int"]["output"]>;
  roleId?: Maybe<Scalars["Int"]["output"]>;
  userName?: Maybe<Scalars["Int"]["output"]>;
};

export type TaxiSupportRequestAssignedToStaffsMaxAggregate = {
  __typename?: "TaxiSupportRequestAssignedToStaffsMaxAggregate";
  email?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  mobileNumber?: Maybe<Scalars["String"]["output"]>;
  roleId?: Maybe<Scalars["ID"]["output"]>;
  userName?: Maybe<Scalars["String"]["output"]>;
};

export type TaxiSupportRequestAssignedToStaffsMinAggregate = {
  __typename?: "TaxiSupportRequestAssignedToStaffsMinAggregate";
  email?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  mobileNumber?: Maybe<Scalars["String"]["output"]>;
  roleId?: Maybe<Scalars["ID"]["output"]>;
  userName?: Maybe<Scalars["String"]["output"]>;
};

export type TaxiSupportRequestAssignedToStaffsSumAggregate = {
  __typename?: "TaxiSupportRequestAssignedToStaffsSumAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
  roleId?: Maybe<Scalars["Float"]["output"]>;
};

export type TaxiSupportRequestAvgAggregate = {
  __typename?: "TaxiSupportRequestAvgAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
  requestId?: Maybe<Scalars["Float"]["output"]>;
};

export type TaxiSupportRequestConnection = {
  __typename?: "TaxiSupportRequestConnection";
  /** Array of nodes. */
  nodes: Array<TaxiSupportRequest>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type TaxiSupportRequestCountAggregate = {
  __typename?: "TaxiSupportRequestCountAggregate";
  id?: Maybe<Scalars["Int"]["output"]>;
  requestId?: Maybe<Scalars["Int"]["output"]>;
  requestedByDriver?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Scalars["Int"]["output"]>;
};

export type TaxiSupportRequestFilter = {
  and?: InputMaybe<Array<TaxiSupportRequestFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<TaxiSupportRequestFilter>>;
  request?: InputMaybe<TaxiSupportRequestFilterOrderFilter>;
  requestId?: InputMaybe<IdFilterComparison>;
  requestedByDriver?: InputMaybe<BooleanFieldComparison>;
  status?: InputMaybe<ComplaintStatusFilterComparison>;
};

export type TaxiSupportRequestFilterOrderFilter = {
  and?: InputMaybe<Array<TaxiSupportRequestFilterOrderFilter>>;
  costAfterCoupon?: InputMaybe<FloatFieldComparison>;
  costBest?: InputMaybe<FloatFieldComparison>;
  createdOn?: InputMaybe<DateFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  distanceBest?: InputMaybe<IntFieldComparison>;
  driverId?: InputMaybe<IdFilterComparison>;
  durationBest?: InputMaybe<IntFieldComparison>;
  fareMode?: InputMaybe<FareModeFilterComparison>;
  finishTimestamp?: InputMaybe<DateFieldComparison>;
  fleetId?: InputMaybe<IdFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  operatorId?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<TaxiSupportRequestFilterOrderFilter>>;
  orderSource?: InputMaybe<OrderSourceFilterComparison>;
  paymentMode?: InputMaybe<PaymentModeFilterComparison>;
  regionId?: InputMaybe<IdFilterComparison>;
  reportingSource?: InputMaybe<OrderSourceFilterComparison>;
  riderId?: InputMaybe<IdFilterComparison>;
  routeSource?: InputMaybe<RouteSourceFilterComparison>;
  serviceId?: InputMaybe<IdFilterComparison>;
  status?: InputMaybe<OrderStatusFilterComparison>;
  tariffProfileId?: InputMaybe<IdFilterComparison>;
  type?: InputMaybe<TaxiOrderTypeFilterComparison>;
};

export type TaxiSupportRequestMaxAggregate = {
  __typename?: "TaxiSupportRequestMaxAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<ComplaintStatus>;
};

export type TaxiSupportRequestMinAggregate = {
  __typename?: "TaxiSupportRequestMinAggregate";
  id?: Maybe<Scalars["ID"]["output"]>;
  requestId?: Maybe<Scalars["ID"]["output"]>;
  status?: Maybe<ComplaintStatus>;
};

export type TaxiSupportRequestNotification = {
  __typename?: "TaxiSupportRequestNotification";
  appType: AppType;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  readAt?: Maybe<Scalars["DateTime"]["output"]>;
  taxiSupportRequest: TaxiSupportRequest;
  type: AdminNotificationType;
};

export type TaxiSupportRequestSort = {
  direction: SortDirection;
  field: TaxiSupportRequestSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum TaxiSupportRequestSortFields {
  Id = "id",
  RequestId = "requestId",
  RequestedByDriver = "requestedByDriver",
  Status = "status",
}

export type TaxiSupportRequestSumAggregate = {
  __typename?: "TaxiSupportRequestSumAggregate";
  id?: Maybe<Scalars["Float"]["output"]>;
  requestId?: Maybe<Scalars["Float"]["output"]>;
};

export type TelematicsAlertDto = {
  __typename?: "TelematicsAlertDTO";
  attributionStatus: Scalars["String"]["output"];
  calibrationEvidence: Scalars["String"]["output"];
  conditionResolutionReason?: Maybe<Scalars["String"]["output"]>;
  conditionResolvedAt?: Maybe<Scalars["DateTime"]["output"]>;
  conditionStatus: Scalars["String"]["output"];
  currentReviewerOperatorId?: Maybe<Scalars["ID"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  driverLabel?: Maybe<Scalars["String"]["output"]>;
  dropoffEndpoint?: Maybe<TelematicsEndpointComparisonDto>;
  endpointEvaluationStatus: Scalars["String"]["output"];
  endpointEvidenceLimitations: Array<Scalars["String"]["output"]>;
  evidenceCompleteness: Scalars["String"]["output"];
  firstDetectedAt: Scalars["DateTime"]["output"];
  hardwareFreshness: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lastObservedAt: Scalars["DateTime"]["output"];
  movementConfirmed: Scalars["Boolean"]["output"];
  orderId?: Maybe<Scalars["ID"]["output"]>;
  passengerIntervalStatus?: Maybe<Scalars["String"]["output"]>;
  pickupEndpoint?: Maybe<TelematicsEndpointComparisonDto>;
  reviewHistory: Array<TelematicsAlertReviewDto>;
  route: Array<TelematicsPositionDto>;
  severity: Scalars["String"]["output"];
  signalFreshnessSeconds: Scalars["Int"]["output"];
  signalObservedAt?: Maybe<Scalars["DateTime"]["output"]>;
  taximeterIntervalStatus?: Maybe<Scalars["String"]["output"]>;
  timeline: Array<TelematicsTimelineItemDto>;
  type: Scalars["String"]["output"];
  vehicleId: Scalars["ID"]["output"];
  vehicleLabel?: Maybe<Scalars["String"]["output"]>;
  version: Scalars["Int"]["output"];
  workflowStatus: Scalars["String"]["output"];
};

export type TelematicsAlertReviewDto = {
  __typename?: "TelematicsAlertReviewDTO";
  action: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  internalNote?: Maybe<Scalars["String"]["output"]>;
  newStatus: Scalars["String"]["output"];
  operatorId: Scalars["ID"]["output"];
  previousStatus: Scalars["String"]["output"];
  reasonCode?: Maybe<Scalars["String"]["output"]>;
};

export type TelematicsAlertReviewInput = {
  alertId: Scalars["ID"]["input"];
  expectedVersion: Scalars["Int"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
  reasonCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type TelematicsCacheConsistencyDto = {
  __typename?: "TelematicsCacheConsistencyDTO";
  consistent: Scalars["Int"]["output"];
  mismatched: Scalars["Int"]["output"];
  missing: Scalars["Int"]["output"];
  mysqlRows: Scalars["Int"]["output"];
  redisPresent: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
};

export enum TelematicsCapability {
  Full = "Full",
  GpsOnly = "GpsOnly",
  InvalidOrUnsupported = "InvalidOrUnsupported",
  PassengerOnly = "PassengerOnly",
}

export type TelematicsChangeEventDto = {
  __typename?: "TelematicsChangeEventDTO";
  changedAt: Scalars["DateTime"]["output"];
  entityId: Scalars["ID"]["output"];
  reviewId?: Maybe<Scalars["String"]["output"]>;
};

export type TelematicsCurrentStatusPreview = {
  __typename?: "TelematicsCurrentStatusPreview";
  canonicalHash: Scalars["String"]["output"];
  capability: TelematicsCapability;
  deviceActivityAt?: Maybe<Scalars["DateTime"]["output"]>;
  doorState?: Maybe<Scalars["String"]["output"]>;
  gsmSignalLevel?: Maybe<Scalars["Float"]["output"]>;
  ignition: TelematicsNormalizedSignal;
  odometerMeters?: Maybe<Scalars["Float"]["output"]>;
  passengerPresence: TelematicsNormalizedSignal;
  position?: Maybe<TelematicsNormalizedPosition>;
  provider: TelematicsProvider;
  providerApplicationId: Scalars["Int"]["output"];
  providerDeviceId?: Maybe<Scalars["String"]["output"]>;
  providerDisplayName?: Maybe<Scalars["String"]["output"]>;
  providerObservedAt?: Maybe<Scalars["DateTime"]["output"]>;
  providerSettingId: Scalars["ID"]["output"];
  providerUserId: Scalars["String"]["output"];
  receivedAt: Scalars["DateTime"]["output"];
  satelliteCount?: Maybe<Scalars["Int"]["output"]>;
  taximeterActive: TelematicsNormalizedSignal;
  trackerBatteryLevel?: Maybe<Scalars["Float"]["output"]>;
  upstreamHttpStatus?: Maybe<Scalars["Int"]["output"]>;
  velocity: TelematicsNormalizedVelocity;
  voltage?: Maybe<Scalars["Float"]["output"]>;
  warnings: Array<TelematicsStatusWarning>;
};

export type TelematicsDriverReportDto = {
  __typename?: "TelematicsDriverReportDTO";
  alertCount: Scalars["Int"]["output"];
  autoResolved: Scalars["Int"]["output"];
  confirmed: Scalars["Int"]["output"];
  dismissed: Scalars["Int"]["output"];
  explained: Scalars["Int"]["output"];
  incompleteEvidenceCount: Scalars["Int"]["output"];
  matchedPassengerIntervals: Scalars["Int"]["output"];
  unattributed: Scalars["Int"]["output"];
};

export type TelematicsEndpointComparisonDto = {
  __typename?: "TelematicsEndpointComparisonDTO";
  evaluated: Scalars["Boolean"]["output"];
  expectedPosition?: Maybe<TelematicsPositionDto>;
  limitationCode?: Maybe<Scalars["String"]["output"]>;
  mismatch: Scalars["Boolean"]["output"];
  observedPosition?: Maybe<TelematicsPositionDto>;
  separationMeters?: Maybe<Scalars["Int"]["output"]>;
  toleranceMeters?: Maybe<Scalars["Int"]["output"]>;
};

export type TelematicsFeatureState = {
  __typename?: "TelematicsFeatureState";
  configurationEnabled: Scalars["Boolean"]["output"];
  historySyncEnabled: Scalars["Boolean"]["output"];
  integrityAlertsEnabled: Scalars["Boolean"]["output"];
  liveSyncEnabled: Scalars["Boolean"]["output"];
  operatorLiveViewEnabled: Scalars["Boolean"]["output"];
  retentionDays: Scalars["Int"]["output"];
  shadowCorrelationEnabled: Scalars["Boolean"]["output"];
  signalEngineEnabled: Scalars["Boolean"]["output"];
};

export type TelematicsFieldMapping = {
  __typename?: "TelematicsFieldMapping";
  caseSensitive: Scalars["Boolean"]["output"];
  currentStatusKey?: Maybe<Scalars["String"]["output"]>;
  expectedType: Scalars["String"]["output"];
  historicalKey?: Maybe<Scalars["String"]["output"]>;
  required: Scalars["Boolean"]["output"];
  semanticField: Scalars["String"]["output"];
  unit?: Maybe<Scalars["String"]["output"]>;
};

export type TelematicsFieldMappingInput = {
  caseSensitive: Scalars["Boolean"]["input"];
  currentStatusKey?: InputMaybe<Scalars["String"]["input"]>;
  expectedType: Scalars["String"]["input"];
  historicalKey?: InputMaybe<Scalars["String"]["input"]>;
  required: Scalars["Boolean"]["input"];
  semanticField: Scalars["String"]["input"];
  unit?: InputMaybe<Scalars["String"]["input"]>;
};

export enum TelematicsIntegrityAlertType {
  DropoffLocationMismatch = "DropoffLocationMismatch",
  PassengerPresentTripNotStarted = "PassengerPresentTripNotStarted",
  PassengerPresentWithoutSystemTrip = "PassengerPresentWithoutSystemTrip",
  PickupAndDropoffLocationMismatch = "PickupAndDropoffLocationMismatch",
  PickupLocationMismatch = "PickupLocationMismatch",
  SystemTripCompletedWithPassengerPresent = "SystemTripCompletedWithPassengerPresent",
  TaximeterActiveAfterPassengerExit = "TaximeterActiveAfterPassengerExit",
}

export enum TelematicsInventoryClassification {
  ServiceAccountOrInvalid = "ServiceAccountOrInvalid",
  Unsupported = "Unsupported",
  VehicleCandidate = "VehicleCandidate",
}

export enum TelematicsInventoryMappingStatus {
  Mapped = "Mapped",
  Unmapped = "Unmapped",
}

export type TelematicsLiveVehicleDto = {
  __typename?: "TelematicsLiveVehicleDTO";
  appGpsAgeSeconds?: Maybe<Scalars["Int"]["output"]>;
  appPosition?: Maybe<TelematicsPositionDto>;
  capability: Scalars["String"]["output"];
  currentOrderId?: Maybe<Scalars["ID"]["output"]>;
  driverId?: Maybe<Scalars["ID"]["output"]>;
  driverLabel?: Maybe<Scalars["String"]["output"]>;
  findingCount: Scalars["Int"]["output"];
  freshness: Scalars["String"]["output"];
  gpsDistanceMeters?: Maybe<Scalars["Int"]["output"]>;
  hardwareFreshnessSeconds: Scalars["Int"]["output"];
  hardwareGpsAgeSeconds?: Maybe<Scalars["Int"]["output"]>;
  hardwarePosition?: Maybe<TelematicsPositionDto>;
  ignition: Scalars["String"]["output"];
  ignitionObservedAt?: Maybe<Scalars["DateTime"]["output"]>;
  latestObservationAt?: Maybe<Scalars["DateTime"]["output"]>;
  passengerPresence: Scalars["String"]["output"];
  passengerPresenceObservedAt?: Maybe<Scalars["DateTime"]["output"]>;
  providerHealth: Scalars["String"]["output"];
  signalFreshnessSeconds: Scalars["Int"]["output"];
  speedMetersPerSecond?: Maybe<Scalars["Float"]["output"]>;
  taximeterActive: Scalars["String"]["output"];
  taximeterObservedAt?: Maybe<Scalars["DateTime"]["output"]>;
  vehicleId: Scalars["ID"]["output"];
  vehicleLabel?: Maybe<Scalars["String"]["output"]>;
};

export type TelematicsMappingConflicts = {
  __typename?: "TelematicsMappingConflicts";
  clean: Scalars["Boolean"]["output"];
  duplicateImeiIdentities: Scalars["Int"]["output"];
  duplicateProviderDevices: Scalars["Int"]["output"];
  duplicateProviderUsers: Scalars["Int"]["output"];
  duplicateVehicles: Scalars["Int"]["output"];
  invalidEffectiveDates: Scalars["Int"]["output"];
  missingVehicles: Scalars["Int"]["output"];
};

export enum TelematicsMappingSource {
  Manual = "Manual",
  Migrated = "Migrated",
}

export enum TelematicsMappingStatus {
  Active = "Active",
  Ended = "Ended",
}

export type TelematicsMappingVerificationDiagnostics = {
  __typename?: "TelematicsMappingVerificationDiagnostics";
  detailUpstreamHttpStatus?: Maybe<Scalars["Int"]["output"]>;
  statusUpstreamHttpStatus?: Maybe<Scalars["Int"]["output"]>;
};

export type TelematicsNormalizedPosition = {
  __typename?: "TelematicsNormalizedPosition";
  altitude?: Maybe<Scalars["Float"]["output"]>;
  latitude: Scalars["Float"]["output"];
  longitude: Scalars["Float"]["output"];
  observedAt?: Maybe<Scalars["DateTime"]["output"]>;
  valid: Scalars["Boolean"]["output"];
};

export type TelematicsNormalizedSignal = {
  __typename?: "TelematicsNormalizedSignal";
  freshness: TelematicsSignalFreshness;
  observedAt?: Maybe<Scalars["DateTime"]["output"]>;
  parseStatus: TelematicsSignalParseStatus;
  providerField: Scalars["String"]["output"];
  value: TelematicsSignalValue;
};

export type TelematicsNormalizedVelocity = {
  __typename?: "TelematicsNormalizedVelocity";
  headingDegrees?: Maybe<Scalars["Float"]["output"]>;
  observedAt?: Maybe<Scalars["DateTime"]["output"]>;
  speedMetersPerSecond?: Maybe<Scalars["Float"]["output"]>;
};

export type TelematicsOperationResult = {
  __typename?: "TelematicsOperationResult";
  applicationId: Scalars["Int"]["output"];
  errorCode?: Maybe<TelematicsProviderErrorCode>;
  latencyMs: Scalars["Int"]["output"];
  provider: TelematicsProvider;
  recommendedAction: Scalars["String"]["output"];
  status: TelematicsProviderHealthStatus;
  success: Scalars["Boolean"]["output"];
  testedAt: Scalars["DateTime"]["output"];
  upstreamHttpStatus?: Maybe<Scalars["Int"]["output"]>;
};

export type TelematicsPositionDto = {
  __typename?: "TelematicsPositionDTO";
  latitude: Scalars["Float"]["output"];
  longitude: Scalars["Float"]["output"];
  observedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type TelematicsProfile = {
  __typename?: "TelematicsProfile";
  active: Scalars["Boolean"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  fields: Array<TelematicsFieldMapping>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  previousProfileId?: Maybe<Scalars["ID"]["output"]>;
  providerSettingId: Scalars["ID"]["output"];
  published: Scalars["Boolean"]["output"];
  schemaVersion: Scalars["Int"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  version: Scalars["Int"]["output"];
};

export enum TelematicsProvider {
  Atd = "ATD",
}

export type TelematicsProviderDeviceDetail = {
  __typename?: "TelematicsProviderDeviceDetail";
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  deviceName?: Maybe<Scalars["String"]["output"]>;
  lastDeviceAt?: Maybe<Scalars["DateTime"]["output"]>;
  mappedVehicleId?: Maybe<Scalars["ID"]["output"]>;
  mappedVehicleName?: Maybe<Scalars["String"]["output"]>;
  mappingStatus: TelematicsInventoryMappingStatus;
  maskedImei?: Maybe<Scalars["String"]["output"]>;
  modelIdentifier?: Maybe<Scalars["String"]["output"]>;
  protocolIdentifier?: Maybe<Scalars["String"]["output"]>;
  providerDeviceId: Scalars["String"]["output"];
};

export enum TelematicsProviderErrorCode {
  CircuitOpen = "CircuitOpen",
  Disabled = "Disabled",
  Forbidden = "Forbidden",
  InvalidContentType = "InvalidContentType",
  InvalidResponse = "InvalidResponse",
  NetworkError = "NetworkError",
  NotConfigured = "NotConfigured",
  NotFound = "NotFound",
  RateLimited = "RateLimited",
  ResponseTooLarge = "ResponseTooLarge",
  SecretUnavailable = "SecretUnavailable",
  Timeout = "Timeout",
  Unauthorized = "Unauthorized",
  Unavailable = "Unavailable",
  UnknownError = "UnknownError",
  UrlRejected = "UrlRejected",
}

export enum TelematicsProviderHealthStatus {
  DegradedAuthorization = "DegradedAuthorization",
  DegradedInvalidResponse = "DegradedInvalidResponse",
  DegradedRateLimit = "DegradedRateLimit",
  Disabled = "Disabled",
  Healthy = "Healthy",
  NotConfigured = "NotConfigured",
  UnhealthyConfiguration = "UnhealthyConfiguration",
  UnhealthyProvider = "UnhealthyProvider",
}

export type TelematicsProviderInventoryDetail = {
  __typename?: "TelematicsProviderInventoryDetail";
  classification: TelematicsInventoryClassification;
  devices: Array<TelematicsProviderDeviceDetail>;
  displayName: Scalars["String"]["output"];
  mappedVehicleId?: Maybe<Scalars["ID"]["output"]>;
  mappedVehicleName?: Maybe<Scalars["String"]["output"]>;
  mappingStatus: TelematicsInventoryMappingStatus;
  providerUserId: Scalars["String"]["output"];
  upstreamHttpStatus?: Maybe<Scalars["Int"]["output"]>;
};

export type TelematicsProviderInventoryItem = {
  __typename?: "TelematicsProviderInventoryItem";
  classification: TelematicsInventoryClassification;
  displayName: Scalars["String"]["output"];
  latestActivityAt?: Maybe<Scalars["DateTime"]["output"]>;
  mappedVehicleId?: Maybe<Scalars["ID"]["output"]>;
  mappedVehicleName?: Maybe<Scalars["String"]["output"]>;
  mappingStatus: TelematicsInventoryMappingStatus;
  providerDeviceCount?: Maybe<Scalars["Int"]["output"]>;
  providerUserId: Scalars["String"]["output"];
};

export type TelematicsProviderInventoryPage = {
  __typename?: "TelematicsProviderInventoryPage";
  fromIndex: Scalars["Int"]["output"];
  hasMore: Scalars["Boolean"]["output"];
  items: Array<TelematicsProviderInventoryItem>;
  pageSize: Scalars["Int"]["output"];
  upstreamHttpStatus?: Maybe<Scalars["Int"]["output"]>;
};

export type TelematicsProviderSetting = {
  __typename?: "TelematicsProviderSetting";
  applicationId: Scalars["Int"]["output"];
  baseUrl: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  deactivatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  displayName: Scalars["String"]["output"];
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  lastError?: Maybe<Scalars["String"]["output"]>;
  lastSuccessAt?: Maybe<Scalars["DateTime"]["output"]>;
  provider: TelematicsProvider;
  providerTimeZone: Scalars["String"]["output"];
  retentionDays: Scalars["Int"]["output"];
  tokenConfigured: Scalars["Boolean"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type TelematicsProviderVariable = {
  __typename?: "TelematicsProviderVariable";
  description?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  providerType: Scalars["String"]["output"];
  unitName?: Maybe<Scalars["String"]["output"]>;
  usedByActiveProfile: Scalars["Boolean"]["output"];
};

export type TelematicsReconciliationInput = {
  alertId?: InputMaybe<Scalars["ID"]["input"]>;
  from?: InputMaybe<Scalars["String"]["input"]>;
  localDate: Scalars["String"]["input"];
  mappingId: Scalars["ID"]["input"];
  orderId?: InputMaybe<Scalars["ID"]["input"]>;
  until?: InputMaybe<Scalars["String"]["input"]>;
};

export type TelematicsRequestEvidenceDto = {
  __typename?: "TelematicsRequestEvidenceDTO";
  attributedDriverId?: Maybe<Scalars["ID"]["output"]>;
  attributionStatus: Scalars["String"]["output"];
  completeness: Scalars["String"]["output"];
  findings: Array<TelematicsAlertDto>;
  mappingId?: Maybe<Scalars["ID"]["output"]>;
  orderId: Scalars["ID"]["output"];
  reconciliationStatus: Scalars["String"]["output"];
  route: Array<TelematicsPositionDto>;
  timeline: Array<TelematicsTimelineItemDto>;
};

export type TelematicsRetentionResultDto = {
  __typename?: "TelematicsRetentionResultDTO";
  candidateCount: Scalars["Int"]["output"];
  cutoff: Scalars["DateTime"]["output"];
  deletedCount: Scalars["Int"]["output"];
  dryRun: Scalars["Boolean"]["output"];
};

export type TelematicsRuntimeConfiguration = {
  __typename?: "TelematicsRuntimeConfiguration";
  blockers: Array<Scalars["String"]["output"]>;
  effective: TelematicsRuntimePolicyValues;
  environmentMasterAllowed: Scalars["Boolean"]["output"];
  policyId: Scalars["ID"]["output"];
  providerSettingId?: Maybe<Scalars["ID"]["output"]>;
  readiness: TelematicsRuntimeReadiness;
  requested: TelematicsRuntimePolicyValues;
  source: IntegrationRuntimePolicySource;
  version: Scalars["Int"]["output"];
};

export type TelematicsRuntimePolicyValues = {
  __typename?: "TelematicsRuntimePolicyValues";
  adminLiveViewEnabled: Scalars["Boolean"]["output"];
  alertNotificationsEnabled: Scalars["Boolean"]["output"];
  approvedNotificationAlertTypes: Array<TelematicsIntegrityAlertType>;
  automaticHistoryReconciliationEnabled: Scalars["Boolean"]["output"];
  completedWithPassengerGraceSeconds: Scalars["Int"]["output"];
  configurationActionsEnabled: Scalars["Boolean"]["output"];
  finalDropoffEndpointToleranceMeters?: Maybe<Scalars["Int"]["output"]>;
  historyCurrentDayIntervalMinutes: Scalars["Int"]["output"];
  historyLatePassDelayHours: Scalars["Int"]["output"];
  historyPreviousDayFinalizeDelayMinutes: Scalars["Int"]["output"];
  historySyncEnabled: Scalars["Boolean"]["output"];
  integrityAlertsEnabled: Scalars["Boolean"]["output"];
  lateOrderMatchWindowSeconds: Scalars["Int"]["output"];
  liveSyncEnabled: Scalars["Boolean"]["output"];
  liveSyncIntervalMs: Scalars["Int"]["output"];
  movementThresholdMeters: Scalars["Int"]["output"];
  noTripConfirmationSamples: Scalars["Int"]["output"];
  noTripGraceSeconds: Scalars["Int"]["output"];
  operatorLiveViewEnabled: Scalars["Boolean"]["output"];
  pickupEndpointToleranceMeters?: Maybe<Scalars["Int"]["output"]>;
  retentionCleanupEnabled: Scalars["Boolean"]["output"];
  retentionDays: Scalars["Int"]["output"];
  shadowCorrelationEnabled: Scalars["Boolean"]["output"];
  signalEngineEnabled: Scalars["Boolean"]["output"];
  signalMaxAgeSeconds: Scalars["Int"]["output"];
  streetDraftGraceSeconds: Scalars["Int"]["output"];
  taximeterAfterExitDistanceMeters: Scalars["Int"]["output"];
  taximeterAfterExitGraceSeconds: Scalars["Int"]["output"];
  tripNotStartedGraceSeconds: Scalars["Int"]["output"];
};

export type TelematicsRuntimePolicyValuesInput = {
  adminLiveViewEnabled: Scalars["Boolean"]["input"];
  alertNotificationsEnabled: Scalars["Boolean"]["input"];
  approvedNotificationAlertTypes: Array<TelematicsIntegrityAlertType>;
  automaticHistoryReconciliationEnabled: Scalars["Boolean"]["input"];
  completedWithPassengerGraceSeconds: Scalars["Int"]["input"];
  configurationActionsEnabled: Scalars["Boolean"]["input"];
  finalDropoffEndpointToleranceMeters?: InputMaybe<Scalars["Int"]["input"]>;
  historyCurrentDayIntervalMinutes: Scalars["Int"]["input"];
  historyLatePassDelayHours: Scalars["Int"]["input"];
  historyPreviousDayFinalizeDelayMinutes: Scalars["Int"]["input"];
  historySyncEnabled: Scalars["Boolean"]["input"];
  integrityAlertsEnabled: Scalars["Boolean"]["input"];
  lateOrderMatchWindowSeconds: Scalars["Int"]["input"];
  liveSyncEnabled: Scalars["Boolean"]["input"];
  liveSyncIntervalMs: Scalars["Int"]["input"];
  movementThresholdMeters: Scalars["Int"]["input"];
  noTripConfirmationSamples: Scalars["Int"]["input"];
  noTripGraceSeconds: Scalars["Int"]["input"];
  operatorLiveViewEnabled: Scalars["Boolean"]["input"];
  pickupEndpointToleranceMeters?: InputMaybe<Scalars["Int"]["input"]>;
  retentionCleanupEnabled: Scalars["Boolean"]["input"];
  retentionDays: Scalars["Int"]["input"];
  shadowCorrelationEnabled: Scalars["Boolean"]["input"];
  signalEngineEnabled: Scalars["Boolean"]["input"];
  signalMaxAgeSeconds: Scalars["Int"]["input"];
  streetDraftGraceSeconds: Scalars["Int"]["input"];
  taximeterAfterExitDistanceMeters: Scalars["Int"]["input"];
  taximeterAfterExitGraceSeconds: Scalars["Int"]["input"];
  tripNotStartedGraceSeconds: Scalars["Int"]["input"];
};

export enum TelematicsRuntimePreset {
  AdminReview = "AdminReview",
  Disabled = "Disabled",
  NotificationPilot = "NotificationPilot",
  SelectedOperatorPilot = "SelectedOperatorPilot",
  ShadowAnalysis = "ShadowAnalysis",
  SyncOnly = "SyncOnly",
}

export type TelematicsRuntimeReadiness = {
  __typename?: "TelematicsRuntimeReadiness";
  activeMappingCount: Scalars["Int"]["output"];
  providerConfigured: Scalars["Boolean"]["output"];
  providerEnabled: Scalars["Boolean"]["output"];
  workerSafetyValid: Scalars["Boolean"]["output"];
};

export type TelematicsRuntimeStatusDto = {
  __typename?: "TelematicsRuntimeStatusDTO";
  component: Scalars["String"]["output"];
  lastUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  pendingCount: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
};

export type TelematicsShadowDiagnostics = {
  __typename?: "TelematicsShadowDiagnostics";
  analysisHealth: Scalars["String"]["output"];
  analysisReasonCode?: Maybe<Scalars["String"]["output"]>;
  cursorStatus: Scalars["String"]["output"];
  latestAcceptedAt?: Maybe<Scalars["DateTime"]["output"]>;
  latestCorrelationStatus?: Maybe<Scalars["String"]["output"]>;
  openPassengerInterval?: Maybe<TelematicsShadowIntervalSummary>;
  openTaximeterInterval?: Maybe<TelematicsShadowIntervalSummary>;
  passengerPresence: Scalars["String"]["output"];
  shadowFindingCount: Scalars["Int"]["output"];
  shadowFindings: Array<TelematicsShadowFindingSummary>;
  taximeterActive: Scalars["String"]["output"];
  vehicleId: Scalars["ID"]["output"];
};

export type TelematicsShadowFindingSummary = {
  __typename?: "TelematicsShadowFindingSummary";
  id: Scalars["ID"]["output"];
  severity: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
  workflowStatus: Scalars["String"]["output"];
};

export type TelematicsShadowIntervalSummary = {
  __typename?: "TelematicsShadowIntervalSummary";
  approximateDistanceMeters?: Maybe<Scalars["Float"]["output"]>;
  endedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  startedAt: Scalars["DateTime"]["output"];
  status: Scalars["String"]["output"];
};

export enum TelematicsSignalFreshness {
  Fresh = "Fresh",
  Stale = "Stale",
  Unavailable = "Unavailable",
}

export enum TelematicsSignalParseStatus {
  InvalidTimestamp = "InvalidTimestamp",
  InvalidValue = "InvalidValue",
  Missing = "Missing",
  Parsed = "Parsed",
}

export enum TelematicsSignalValue {
  False = "False",
  True = "True",
  Unavailable = "Unavailable",
}

export enum TelematicsStatusWarning {
  DeviceActivityStale = "DeviceActivityStale",
  DuplicateProviderField = "DuplicateProviderField",
  IgnitionSignalUnavailable = "IgnitionSignalUnavailable",
  NonVehicleAccount = "NonVehicleAccount",
  PassengerSignalUnavailable = "PassengerSignalUnavailable",
  PositionStale = "PositionStale",
  PositionUnavailable = "PositionUnavailable",
  SignalTimestampStale = "SignalTimestampStale",
  SignalTimestampUnavailable = "SignalTimestampUnavailable",
  TaximeterSignalUnavailable = "TaximeterSignalUnavailable",
}

export type TelematicsTimelineItemDto = {
  __typename?: "TelematicsTimelineItemDTO";
  confidence: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  position?: Maybe<TelematicsPositionDto>;
  relatedId?: Maybe<Scalars["String"]["output"]>;
  sourceCategory: Scalars["String"]["output"];
  timestamp: Scalars["DateTime"]["output"];
  type: Scalars["String"]["output"];
};

export type TelematicsVehicleHistoryDto = {
  __typename?: "TelematicsVehicleHistoryDTO";
  completeness: Scalars["String"]["output"];
  route: Array<TelematicsPositionDto>;
  timeline: Array<TelematicsTimelineItemDto>;
  vehicleId: Scalars["ID"]["output"];
};

export enum TimeFrequency {
  Daily = "Daily",
  Monthly = "Monthly",
  Quarterly = "Quarterly",
  Weekly = "Weekly",
  Yearly = "Yearly",
}

export type TimeMultiplier = {
  __typename?: "TimeMultiplier";
  endTime: Scalars["String"]["output"];
  multiply: Scalars["Float"]["output"];
  startTime: Scalars["String"]["output"];
};

export type TimeMultiplierInput = {
  endTime: Scalars["String"]["input"];
  multiply: Scalars["Float"]["input"];
  startTime: Scalars["String"]["input"];
};

export type TimeRange = {
  __typename?: "TimeRange";
  close: Scalars["String"]["output"];
  open: Scalars["String"]["output"];
};

export type TokenObject = {
  __typename?: "TokenObject";
  token: Scalars["String"]["output"];
};

export type TokenObject2 = {
  __typename?: "TokenObject2";
  accessToken: Scalars["String"]["output"];
  refreshToken: Scalars["String"]["output"];
};

export type TotalDailyPair = {
  __typename?: "TotalDailyPair";
  daily: Scalars["Float"]["output"];
  total: Scalars["Float"]["output"];
};

export enum TransactionAction {
  Deduct = "Deduct",
  Recharge = "Recharge",
}

export type TransactionActionFilterComparison = {
  eq?: InputMaybe<TransactionAction>;
  gt?: InputMaybe<TransactionAction>;
  gte?: InputMaybe<TransactionAction>;
  iLike?: InputMaybe<TransactionAction>;
  in?: InputMaybe<Array<TransactionAction>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<TransactionAction>;
  lt?: InputMaybe<TransactionAction>;
  lte?: InputMaybe<TransactionAction>;
  neq?: InputMaybe<TransactionAction>;
  notILike?: InputMaybe<TransactionAction>;
  notIn?: InputMaybe<Array<TransactionAction>>;
  notLike?: InputMaybe<TransactionAction>;
};

export enum TransactionStatus {
  Canceled = "Canceled",
  Done = "Done",
  Processing = "Processing",
  Rejected = "Rejected",
}

export type TransactionStatusFilterComparison = {
  eq?: InputMaybe<TransactionStatus>;
  gt?: InputMaybe<TransactionStatus>;
  gte?: InputMaybe<TransactionStatus>;
  iLike?: InputMaybe<TransactionStatus>;
  in?: InputMaybe<Array<TransactionStatus>>;
  is?: InputMaybe<Scalars["Boolean"]["input"]>;
  isNot?: InputMaybe<Scalars["Boolean"]["input"]>;
  like?: InputMaybe<TransactionStatus>;
  lt?: InputMaybe<TransactionStatus>;
  lte?: InputMaybe<TransactionStatus>;
  neq?: InputMaybe<TransactionStatus>;
  notILike?: InputMaybe<TransactionStatus>;
  notIn?: InputMaybe<Array<TransactionStatus>>;
  notLike?: InputMaybe<TransactionStatus>;
};

export type UpdateAdminBrowserPushPreferencesInput = {
  browserInstanceId: Scalars["String"]["input"];
  categoryPreferences?: InputMaybe<AdminBrowserPushCategoryPreferencesInput>;
  criticalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  desktopEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  soundEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdateAdminDesktopAlertRuntimePolicyInput = {
  expectedVersion: Scalars["Int"]["input"];
  reason: Scalars["String"]["input"];
  values: AdminDesktopAlertRuntimePolicyValuesInput;
};

export type UpdateAnnouncementInput = {
  appType?: InputMaybe<AppType>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  expireAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  mediaId?: InputMaybe<Scalars["ID"]["input"]>;
  startAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  title: Scalars["String"]["input"];
  url?: InputMaybe<Scalars["String"]["input"]>;
  userType?: InputMaybe<Array<AnnouncementUserType>>;
};

export type UpdateConfigInput = {
  adminPanelAPIKey?: InputMaybe<Scalars["String"]["input"]>;
  adminPanelMapId?: InputMaybe<Scalars["String"]["input"]>;
  backendMapsAPIKey?: InputMaybe<Scalars["String"]["input"]>;
  twilioAccountSid?: InputMaybe<Scalars["String"]["input"]>;
  twilioAuthToken?: InputMaybe<Scalars["String"]["input"]>;
  twilioFromNumber?: InputMaybe<Scalars["String"]["input"]>;
  twilioVerificationCodeSMSTemplate?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateConfigInputV2 = {
  adminPanelAPIKey?: InputMaybe<Scalars["String"]["input"]>;
  adminPanelMapId?: InputMaybe<Scalars["String"]["input"]>;
  backendMapsAPIKey?: InputMaybe<Scalars["String"]["input"]>;
  companyLogo?: InputMaybe<Scalars["String"]["input"]>;
  companyName?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firebaseProjectPrivateKey?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  mysqlDatabase?: InputMaybe<Scalars["String"]["input"]>;
  mysqlHost?: InputMaybe<Scalars["String"]["input"]>;
  mysqlPassword?: InputMaybe<Scalars["String"]["input"]>;
  mysqlPort?: InputMaybe<Scalars["Int"]["input"]>;
  mysqlUser?: InputMaybe<Scalars["String"]["input"]>;
  password?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  profilePicture?: InputMaybe<Scalars["String"]["input"]>;
  redisDb?: InputMaybe<Scalars["Int"]["input"]>;
  redisHost?: InputMaybe<Scalars["String"]["input"]>;
  redisPassword?: InputMaybe<Scalars["String"]["input"]>;
  redisPort?: InputMaybe<Scalars["Int"]["input"]>;
  taxi?: InputMaybe<AppConfigInfoInput>;
};

export type UpdateConfigResult = {
  __typename?: "UpdateConfigResult";
  message?: Maybe<Scalars["String"]["output"]>;
  status: UpdateConfigStatus;
};

export enum UpdateConfigStatus {
  Invalid = "INVALID",
  Ok = "OK",
}

export type UpdateDispatchPolicyInput = {
  activateNewBehavior: Scalars["Boolean"]["input"];
  automation: DispatchAutomationOptionsInput;
  configuration: DispatchConfigInput;
  expectedFingerprint: Scalars["String"]["input"];
  expectedVersion: Scalars["Int"]["input"];
  reason: Scalars["String"]["input"];
};

export type UpdateDriverInput = {
  accountNumber?: InputMaybe<Scalars["String"]["input"]>;
  address?: InputMaybe<Scalars["String"]["input"]>;
  bankName?: InputMaybe<Scalars["String"]["input"]>;
  bankRoutingNumber?: InputMaybe<Scalars["String"]["input"]>;
  bankSwift?: InputMaybe<Scalars["String"]["input"]>;
  canDeliver?: InputMaybe<Scalars["Boolean"]["input"]>;
  carColorId?: InputMaybe<Scalars["ID"]["input"]>;
  carId?: InputMaybe<Scalars["ID"]["input"]>;
  carPlate?: InputMaybe<Scalars["String"]["input"]>;
  carProductionYear?: InputMaybe<Scalars["Int"]["input"]>;
  certificateNumber?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  fleetId?: InputMaybe<Scalars["ID"]["input"]>;
  gender?: InputMaybe<Gender>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  maxDeliveryPackageSize?: InputMaybe<DeliveryPackageSize>;
  mediaId?: InputMaybe<Scalars["ID"]["input"]>;
  mobileNumber?: InputMaybe<Scalars["String"]["input"]>;
  password?: InputMaybe<Scalars["String"]["input"]>;
  softRejectionNote?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<DriverStatus>;
};

export type UpdateFeedback = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  driverId?: InputMaybe<Scalars["ID"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  requestId?: InputMaybe<Scalars["ID"]["input"]>;
  reviewTimestamp?: InputMaybe<Scalars["DateTime"]["input"]>;
  score?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdateFixedFareRoutingModeInput = {
  mode: FixedFareRoutingMode;
  reason?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateFleetInput = {
  accountNumber?: InputMaybe<Scalars["String"]["input"]>;
  address?: InputMaybe<Scalars["String"]["input"]>;
  commissionShareFlat?: InputMaybe<Scalars["Float"]["input"]>;
  commissionSharePercent?: InputMaybe<Scalars["Float"]["input"]>;
  exclusivityAreas?: InputMaybe<Array<Array<PointInput>>>;
  feeMultiplier?: InputMaybe<Scalars["Float"]["input"]>;
  isBlocked?: InputMaybe<Scalars["Boolean"]["input"]>;
  mobileNumber?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  password?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  profilePictureId?: InputMaybe<Scalars["ID"]["input"]>;
  userName?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateFleetStaffInput = {
  address?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  isBlocked?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  mobileNumber?: InputMaybe<Scalars["String"]["input"]>;
  password?: InputMaybe<Scalars["String"]["input"]>;
  permissionFinancial?: InputMaybe<FleetStaffPermissionFinancial>;
  permissionOrder?: InputMaybe<FleetStaffPermissionOrder>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  profileImageId?: InputMaybe<Scalars["ID"]["input"]>;
  userName?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateManyDriverDocumentRetentionPoliciesInput = {
  /** Filter used to find fields to update */
  filter: DriverDocumentRetentionPolicyUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: DriverDocumentRetentionPolicyInput;
};

export type UpdateManyDriverDocumentsInput = {
  /** Filter used to find fields to update */
  filter: DriverDocumentUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: DriverDocumentInput;
};

export type UpdateManyDriverShiftRulesInput = {
  /** Filter used to find fields to update */
  filter: DriverShiftRuleUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: DriverShiftRuleInput;
};

export type UpdateManyEmailProvidersInput = {
  /** Filter used to find fields to update */
  filter: EmailProviderUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: EmailProviderInput;
};

export type UpdateManyEmailTemplatesInput = {
  /** Filter used to find fields to update */
  filter: EmailTemplateUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: EmailTemplateInput;
};

export type UpdateManyResponse = {
  __typename?: "UpdateManyResponse";
  /** The number of records updated. */
  updatedCount: Scalars["Int"]["output"];
};

export type UpdateManyRiderAddressesInput = {
  /** Filter used to find fields to update */
  filter: RiderAddressUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateRiderAddress;
};

export type UpdateManySmsInput = {
  /** Filter used to find fields to update */
  filter: SmsUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateSms;
};

export type UpdateManySmsProvidersInput = {
  /** Filter used to find fields to update */
  filter: SmsProviderUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: SmsProviderInput;
};

export type UpdateOneAnnouncementInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: UpdateAnnouncementInput;
};

export type UpdateOneCarColorInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: CarColorInput;
};

export type UpdateOneCarModelInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: CarModelInput;
};

export type UpdateOneCouponInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: CouponInput;
};

export type UpdateOneDistressSignalInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: UpdateSosInput;
};

export type UpdateOneDriverDocumentInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: DriverDocumentInput;
};

export type UpdateOneDriverDocumentRetentionPolicyInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: DriverDocumentRetentionPolicyInput;
};

export type UpdateOneDriverInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: UpdateDriverInput;
};

export type UpdateOneDriverShiftRuleInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: DriverShiftRuleInput;
};

export type UpdateOneDriverToDriverDocumentInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: DriverToDriverDocumentInput;
};

export type UpdateOneEmailProviderInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: EmailProviderInput;
};

export type UpdateOneEmailTemplateInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: EmailTemplateInput;
};

export type UpdateOneFeedbackInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: UpdateFeedback;
};

export type UpdateOneFeedbackParameterInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: FeedbackParameterInput;
};

export type UpdateOneFleetInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: UpdateFleetInput;
};

export type UpdateOneFleetStaffInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: UpdateFleetStaffInput;
};

export type UpdateOneOperatorInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: UpdateOperatorInput;
};

export type UpdateOneOperatorRoleInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: OperatorRoleInput;
};

export type UpdateOneOrderCancelReasonInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: OrderCancelReasonInput;
};

export type UpdateOnePaymentGatewayInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: UpdatePaymentGatewayInput;
};

export type UpdateOnePayoutMethodInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: CreatePayoutMethodInput;
};

export type UpdateOneRegionCategoryInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: RegionCategoryInput;
};

export type UpdateOneRegionInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: UpdateRegionInput;
};

export type UpdateOneRewardInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: UpdateReward;
};

export type UpdateOneRiderAddressInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: UpdateRiderAddress;
};

export type UpdateOneRiderInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: RiderInput;
};

export type UpdateOneSmsInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: UpdateSms;
};

export type UpdateOneSmsProviderInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: SmsProviderInput;
};

export type UpdateOneSosReasonInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: UpdateSosReasonInput;
};

export type UpdateOneServiceCategoryInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: ServiceCategoryInput;
};

export type UpdateOneServiceInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: ServiceInput;
};

export type UpdateOneServiceOptionInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: ServiceOptionInput;
};

export type UpdateOneServiceTariffProfileInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: ServiceTariffProfileInput;
};

export type UpdateOneTariffProfileInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: TariffProfileInput;
};

export type UpdateOneTaxiPayoutSessionInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: UpdatePayoutSessionInput;
};

export type UpdateOneTaxiSupportRequestInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: UpdateTaxiSupportRequest;
};

export type UpdateOneZoneMultiplierInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: ZoneMultiplierInput;
};

export type UpdateOneZonePriceCategoryInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: ZonePriceCategoryInput;
};

export type UpdateOneZonePriceInput = {
  /** The id of the record to update */
  id: Scalars["ID"]["input"];
  /** The update to apply. */
  update: ZonePriceInput;
};

export type UpdateOperatorInput = {
  address?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  enabledNotifications?: InputMaybe<Array<Scalars["String"]["input"]>>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  isBlocked?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  mediaId?: InputMaybe<Scalars["ID"]["input"]>;
  mobileNumber?: InputMaybe<Scalars["String"]["input"]>;
  roleId?: InputMaybe<Scalars["ID"]["input"]>;
  userName?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdatePasswordInput = {
  newPassword: Scalars["String"]["input"];
  oldPassword: Scalars["String"]["input"];
};

export type UpdatePaymentGatewayInput = {
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  mediaId?: InputMaybe<Scalars["ID"]["input"]>;
  merchantId?: InputMaybe<Scalars["ID"]["input"]>;
  privateKey?: InputMaybe<Scalars["String"]["input"]>;
  publicKey?: InputMaybe<Scalars["String"]["input"]>;
  saltKey?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<PaymentGatewayType>;
};

export type UpdatePayoutSessionInput = {
  status: PayoutSessionStatus;
};

export type UpdateProfileInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  enabledNotifications?: InputMaybe<Array<EnabledNotification>>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  mediaId?: InputMaybe<Scalars["ID"]["input"]>;
  mobileNumber?: InputMaybe<Scalars["String"]["input"]>;
  userName?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateRegionInput = {
  categoryId?: InputMaybe<Scalars["ID"]["input"]>;
  currency?: InputMaybe<Scalars["String"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  location?: InputMaybe<Array<Array<PointInput>>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateReward = {
  appType?: InputMaybe<RewardAppType>;
  beneficiary?: InputMaybe<RewardBeneficiary>;
  conditionTripCountsLessThan?: InputMaybe<Scalars["Float"]["input"]>;
  conditionUserNumberFirstDigits?: InputMaybe<
    Array<Scalars["String"]["input"]>
  >;
  creditCurrency?: InputMaybe<Scalars["String"]["input"]>;
  creditGift?: InputMaybe<Scalars["Float"]["input"]>;
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  event?: InputMaybe<RewardEvent>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  tripFeePercentGift?: InputMaybe<Scalars["Float"]["input"]>;
};

export type UpdateRiderAddress = {
  details?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  location?: InputMaybe<PointInput>;
  riderId?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<RiderAddressType>;
};

export type UpdateSms = {
  countryIsoCode?: InputMaybe<Scalars["String"]["input"]>;
  from?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  message?: InputMaybe<Scalars["String"]["input"]>;
  providerId?: InputMaybe<Scalars["ID"]["input"]>;
  status?: InputMaybe<SmsStatus>;
  to?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<SmsType>;
};

export type UpdateSosInput = {
  status: SosStatus;
};

export type UpdateSosReasonInput = {
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateTaxiSupportRequest = {
  content?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  inscriptionTimestamp?: InputMaybe<Scalars["DateTime"]["input"]>;
  requestId?: InputMaybe<Scalars["ID"]["input"]>;
  requestedByDriver?: InputMaybe<Scalars["Boolean"]["input"]>;
  status?: InputMaybe<ComplaintStatus>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateTelematicsRuntimePolicyInput = {
  expectedVersion: Scalars["Int"]["input"];
  providerSettingId: Scalars["ID"]["input"];
  reason: Scalars["String"]["input"];
  values: TelematicsRuntimePolicyValuesInput;
};

export type UpdateVehicleInput = {
  colorId?: InputMaybe<Scalars["ID"]["input"]>;
  modelId?: InputMaybe<Scalars["ID"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  plate?: InputMaybe<Scalars["String"]["input"]>;
  productionYear?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<VehicleStatus>;
};

export type UpsertAdminBrowserPushRegistrationInput = {
  browser: AdminBrowserPushBrowser;
  browserInstanceId: Scalars["String"]["input"];
  browserVersion?: InputMaybe<Scalars["String"]["input"]>;
  categoryPreferences?: InputMaybe<AdminBrowserPushCategoryPreferencesInput>;
  criticalOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  desktopEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  locale?: InputMaybe<Scalars["String"]["input"]>;
  operatingSystemLabel?: InputMaybe<Scalars["String"]["input"]>;
  permissionState: AdminBrowserPushPermissionState;
  platform: AdminBrowserPushPlatform;
  provider: AdminBrowserPushProvider;
  providerToken: Scalars["String"]["input"];
  serviceWorkerVersion?: InputMaybe<Scalars["String"]["input"]>;
  soundEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpsertTelematicsProviderSettingInput = {
  applicationId: Scalars["Int"]["input"];
  baseUrl: Scalars["String"]["input"];
  displayName: Scalars["String"]["input"];
  enabled: Scalars["Boolean"]["input"];
  id?: InputMaybe<Scalars["ID"]["input"]>;
  provider: TelematicsProvider;
  providerTimeZone: Scalars["String"]["input"];
  retentionDays: Scalars["Int"]["input"];
};

export type UsedUnusedCountPairDto = {
  __typename?: "UsedUnusedCountPairDTO";
  unused: Scalars["Int"]["output"];
  used: Scalars["Int"]["output"];
};

/** The activity level of the user. */
export enum UserActivityLevel {
  Active = "Active",
  Inactive = "Inactive",
}

export type UserTypeCountPair = {
  __typename?: "UserTypeCountPair";
  count: Scalars["Float"]["output"];
  userType: AnnouncementUserType;
};

export type Vehicle = {
  __typename?: "Vehicle";
  assignedDriverId?: Maybe<Scalars["ID"]["output"]>;
  assignedDriverMobileNumber?: Maybe<Scalars["String"]["output"]>;
  assignedDriverName?: Maybe<Scalars["String"]["output"]>;
  colorId?: Maybe<Scalars["ID"]["output"]>;
  colorName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  modelId?: Maybe<Scalars["ID"]["output"]>;
  modelName?: Maybe<Scalars["String"]["output"]>;
  notes?: Maybe<Scalars["String"]["output"]>;
  plate: Scalars["String"]["output"];
  productionYear?: Maybe<Scalars["Int"]["output"]>;
  status: VehicleStatus;
};

/** Source used to snapshot vehicle details onto an order. */
export enum VehicleSnapshotSource {
  Assignment = "Assignment",
  DriverProfileFallback = "DriverProfileFallback",
  Unknown = "Unknown",
}

/** Current operational state of a fleet vehicle. */
export enum VehicleStatus {
  Available = "Available",
  Charging = "Charging",
  InUse = "InUse",
  Inactive = "Inactive",
  Maintenance = "Maintenance",
}

export type VehicleTelematicsMapping = {
  __typename?: "VehicleTelematicsMapping";
  createdAt: Scalars["DateTime"]["output"];
  effectiveFrom: Scalars["DateTime"]["output"];
  effectiveTo?: Maybe<Scalars["DateTime"]["output"]>;
  endReason?: Maybe<Scalars["String"]["output"]>;
  endedByName?: Maybe<Scalars["String"]["output"]>;
  endedByOperatorId?: Maybe<Scalars["ID"]["output"]>;
  id: Scalars["ID"]["output"];
  imeiLastFour?: Maybe<Scalars["String"]["output"]>;
  mappedByName?: Maybe<Scalars["String"]["output"]>;
  mappedByOperatorId?: Maybe<Scalars["ID"]["output"]>;
  mappingSource: TelematicsMappingSource;
  mappingStatus: TelematicsMappingStatus;
  notes?: Maybe<Scalars["String"]["output"]>;
  profileId: Scalars["ID"]["output"];
  profileName?: Maybe<Scalars["String"]["output"]>;
  profileVersion?: Maybe<Scalars["Int"]["output"]>;
  provider: TelematicsProvider;
  providerApplicationId?: Maybe<Scalars["Int"]["output"]>;
  providerDeviceMasked?: Maybe<Scalars["String"]["output"]>;
  providerDeviceName?: Maybe<Scalars["String"]["output"]>;
  providerDisplayName?: Maybe<Scalars["String"]["output"]>;
  providerSettingId: Scalars["ID"]["output"];
  providerUserId: Scalars["String"]["output"];
  providerUserMasked: Scalars["String"]["output"];
  vehicleId: Scalars["ID"]["output"];
  vehiclePlate?: Maybe<Scalars["String"]["output"]>;
  verificationDiagnostics?: Maybe<TelematicsMappingVerificationDiagnostics>;
};

export type VehicleTelematicsProviderSummary = {
  __typename?: "VehicleTelematicsProviderSummary";
  displayName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  provider: TelematicsProvider;
};

export type VehicleTelematicsSetup = {
  __typename?: "VehicleTelematicsSetup";
  mappings: Array<VehicleTelematicsMapping>;
  profiles: Array<TelematicsProfile>;
  providerSetting?: Maybe<VehicleTelematicsProviderSummary>;
  vehicle: VehicleTelematicsVehicleSummary;
};

export type VehicleTelematicsVehicleSummary = {
  __typename?: "VehicleTelematicsVehicleSummary";
  colorName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  modelName?: Maybe<Scalars["String"]["output"]>;
  plate: Scalars["String"]["output"];
  productionYear?: Maybe<Scalars["Int"]["output"]>;
  status: VehicleStatus;
};

export type WalletPaymentMethod = PaymentMethodBase & {
  __typename?: "WalletPaymentMethod";
  id?: Maybe<Scalars["ID"]["output"]>;
  mode: PaymentMode;
};

export type WaypointBase = {
  address: Scalars["String"]["output"];
  deliveryContact?: Maybe<DeliveryContact>;
  location: Point;
  role: WaypointRole;
  service: WaypointService;
};

export enum WaypointRole {
  Dropoff = "Dropoff",
  Pickup = "Pickup",
  Stop = "Stop",
}

export enum WaypointService {
  Delivery = "Delivery",
  Ride = "Ride",
}

export enum Weekday {
  Friday = "Friday",
  Monday = "Monday",
  Saturday = "Saturday",
  Sunday = "Sunday",
  Thursday = "Thursday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
}

export type WeekdayMultiplier = {
  __typename?: "WeekdayMultiplier";
  multiply: Scalars["Float"]["output"];
  weekday: Weekday;
};

export type WeekdayMultiplierInput = {
  multiply: Scalars["Float"]["input"];
  weekday: Weekday;
};

export type ZoneMultiplier = {
  __typename?: "ZoneMultiplier";
  area: Array<Array<Point>>;
  createdAt: Scalars["DateTime"]["output"];
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  multiplier: Scalars["Float"]["output"];
  name: Scalars["String"]["output"];
  notes?: Maybe<Scalars["String"]["output"]>;
  priority: Scalars["Int"]["output"];
  triggerType: ZoneMultiplierTriggerType;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ZoneMultiplierConnection = {
  __typename?: "ZoneMultiplierConnection";
  /** Array of nodes. */
  nodes: Array<ZoneMultiplier>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type ZoneMultiplierDeleteResponse = {
  __typename?: "ZoneMultiplierDeleteResponse";
  area?: Maybe<Array<Array<Point>>>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
  id?: Maybe<Scalars["ID"]["output"]>;
  multiplier?: Maybe<Scalars["Float"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  notes?: Maybe<Scalars["String"]["output"]>;
  priority?: Maybe<Scalars["Int"]["output"]>;
  triggerType?: Maybe<ZoneMultiplierTriggerType>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ZoneMultiplierFilter = {
  and?: InputMaybe<Array<ZoneMultiplierFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ZoneMultiplierFilter>>;
};

export type ZoneMultiplierInput = {
  area: Array<Array<PointInput>>;
  enabled?: Scalars["Boolean"]["input"];
  multiplier: Scalars["Float"]["input"];
  name: Scalars["String"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
  priority?: Scalars["Int"]["input"];
  triggerType?: ZoneMultiplierTriggerType;
};

export type ZoneMultiplierSort = {
  direction: SortDirection;
  field: ZoneMultiplierSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ZoneMultiplierSortFields {
  Id = "id",
}

export enum ZoneMultiplierTriggerType {
  Dropoff = "Dropoff",
  Pickup = "Pickup",
  PickupAndDropoff = "PickupAndDropoff",
  PickupOrDropoff = "PickupOrDropoff",
}

export type ZonePrice = {
  __typename?: "ZonePrice";
  cost: Scalars["Float"]["output"];
  fleets: Array<Fleet>;
  from: Array<Array<Point>>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  profileFares?: Maybe<Array<ZonePriceProfileFare>>;
  services: Array<Service>;
  timeMultipliers: Array<TimeMultiplier>;
  to: Array<Array<Point>>;
};

export type ZonePriceFleetsArgs = {
  filter?: FleetFilter;
  sorting?: Array<FleetSort>;
};

export type ZonePriceServicesArgs = {
  filter?: ServiceFilter;
  sorting?: Array<ServiceSort>;
};

export type ZonePriceCategory = {
  __typename?: "ZonePriceCategory";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  zonePrices: ZonePriceCategoryZonePricesConnection;
};

export type ZonePriceCategoryZonePricesArgs = {
  filter?: ZonePriceFilter;
  paging?: OffsetPaging;
  sorting?: Array<ZonePriceSort>;
};

export type ZonePriceCategoryDeleteResponse = {
  __typename?: "ZonePriceCategoryDeleteResponse";
  id?: Maybe<Scalars["ID"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type ZonePriceCategoryFilter = {
  and?: InputMaybe<Array<ZonePriceCategoryFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ZonePriceCategoryFilter>>;
};

export type ZonePriceCategoryInput = {
  name: Scalars["String"]["input"];
};

export type ZonePriceCategorySort = {
  direction: SortDirection;
  field: ZonePriceCategorySortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ZonePriceCategorySortFields {
  Id = "id",
}

export type ZonePriceCategoryZonePricesConnection = {
  __typename?: "ZonePriceCategoryZonePricesConnection";
  /** Array of nodes. */
  nodes: Array<ZonePrice>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type ZonePriceConnection = {
  __typename?: "ZonePriceConnection";
  /** Array of nodes. */
  nodes: Array<ZonePrice>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars["Int"]["output"];
};

export type ZonePriceDeleteResponse = {
  __typename?: "ZonePriceDeleteResponse";
  cost?: Maybe<Scalars["Float"]["output"]>;
  from?: Maybe<Array<Array<Point>>>;
  id?: Maybe<Scalars["ID"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  profileFares?: Maybe<Array<ZonePriceProfileFare>>;
  timeMultipliers?: Maybe<Array<TimeMultiplier>>;
  to?: Maybe<Array<Array<Point>>>;
};

export type ZonePriceFareBreakdown = {
  __typename?: "ZonePriceFareBreakdown";
  defaultZonePrice: Scalars["Float"]["output"];
  finalZonePrice: Scalars["Float"]["output"];
  profilePriceApplied: Scalars["Boolean"]["output"];
  selectedProfileZonePrice?: Maybe<Scalars["Float"]["output"]>;
  tariffProfileId?: Maybe<Scalars["ID"]["output"]>;
  tariffProfileName?: Maybe<Scalars["String"]["output"]>;
  zonePriceId: Scalars["ID"]["output"];
  zonePriceName?: Maybe<Scalars["String"]["output"]>;
};

export type ZonePriceFilter = {
  and?: InputMaybe<Array<ZonePriceFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ZonePriceFilter>>;
};

export type ZonePriceInput = {
  cost: Scalars["Float"]["input"];
  from: Array<Array<PointInput>>;
  name: Scalars["String"]["input"];
  profileFares?: InputMaybe<Array<ZonePriceProfileFareInput>>;
  timeMultipliers: Array<TimeMultiplierInput>;
  to: Array<Array<PointInput>>;
};

export type ZonePriceProfileFare = {
  __typename?: "ZonePriceProfileFare";
  createdAt: Scalars["DateTime"]["output"];
  enabled: Scalars["Boolean"]["output"];
  fixedPrice: Scalars["Float"]["output"];
  id: Scalars["ID"]["output"];
  tariffProfileCode?: Maybe<Scalars["String"]["output"]>;
  tariffProfileId: Scalars["ID"]["output"];
  tariffProfileName?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
  zonePriceId: Scalars["ID"]["output"];
};

export type ZonePriceProfileFareInput = {
  enabled?: Scalars["Boolean"]["input"];
  fixedPrice?: InputMaybe<Scalars["Float"]["input"]>;
  tariffProfileId: Scalars["ID"]["input"];
};

export type ZonePriceSort = {
  direction: SortDirection;
  field: ZonePriceSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ZonePriceSortFields {
  Id = "id",
}

export type AdminNotificationCenterQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminNotificationCenterQuery = {
  __typename?: "Query";
  notifications: Array<
    | {
        __typename: "DriverPendingVerificationNotification";
        id: string;
        type: AdminNotificationType;
        appType: AppType;
        createdAt: any;
        readAt?: any | null;
      }
    | {
        __typename: "SOSNotification";
        id: string;
        type: AdminNotificationType;
        appType: AppType;
        createdAt: any;
        readAt?: any | null;
        sos: { __typename?: "DistressSignal"; id: string; requestId: string };
      }
    | {
        __typename: "ScheduleEventNotification";
        id: string;
        type: AdminNotificationType;
        appType: AppType;
        createdAt: any;
        readAt?: any | null;
        title?: string | null;
        message?: string | null;
        taxiOrderId?: number | null;
        canonicalEventId?: string | null;
        canonicalRoute?: string | null;
        canonicalSeverity?: AdminNotificationSeverity | null;
        canonicalCategory?: AdminNotificationCategory | null;
      }
    | {
        __typename: "TaxiSupportRequestNotification";
        id: string;
        type: AdminNotificationType;
        appType: AppType;
        createdAt: any;
        readAt?: any | null;
        taxiSupportRequest: {
          __typename?: "TaxiSupportRequest";
          id: string;
          requestId: string;
        };
      }
  >;
};

export type NotificationCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type NotificationCreatedSubscription = {
  __typename?: "Subscription";
  notificationCreated:
    | {
        __typename: "DriverPendingVerificationNotification";
        id: string;
        type: AdminNotificationType;
        appType: AppType;
        createdAt: any;
        readAt?: any | null;
      }
    | {
        __typename: "SOSNotification";
        id: string;
        type: AdminNotificationType;
        appType: AppType;
        createdAt: any;
        readAt?: any | null;
        sos: { __typename?: "DistressSignal"; id: string; requestId: string };
      }
    | {
        __typename: "ScheduleEventNotification";
        id: string;
        type: AdminNotificationType;
        appType: AppType;
        createdAt: any;
        readAt?: any | null;
        title?: string | null;
        message?: string | null;
        taxiOrderId?: number | null;
        canonicalEventId?: string | null;
        canonicalRoute?: string | null;
        canonicalSeverity?: AdminNotificationSeverity | null;
        canonicalCategory?: AdminNotificationCategory | null;
      }
    | {
        __typename: "TaxiSupportRequestNotification";
        id: string;
        type: AdminNotificationType;
        appType: AppType;
        createdAt: any;
        readAt?: any | null;
        taxiSupportRequest: {
          __typename?: "TaxiSupportRequest";
          id: string;
          requestId: string;
        };
      };
};

export type DriverManualRideCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type DriverManualRideCreatedSubscription = {
  __typename?: "Subscription";
  driverManualRideCreated: {
    __typename?: "DriverManualRideCreatedEvent";
    orderId: string;
    driverId: string;
    driverName: string;
    carPlate?: string | null;
    message: string;
    createdAt: any;
  };
};

export type MarkAdminNotificationsReadMutationVariables = Exact<{
  notificationIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type MarkAdminNotificationsReadMutation = {
  __typename?: "Mutation";
  markAsRead: boolean;
};

export type NotificationsQueryVariables = Exact<{ [key: string]: never }>;

export type NotificationsQuery = {
  __typename?: "Query";
  taxiSupportRequestAggregate: Array<{
    __typename?: "TaxiSupportRequestAggregateResponse";
    count?: {
      __typename?: "TaxiSupportRequestCountAggregate";
      id?: number | null;
    } | null;
  }>;
  distressSignalAggregate: Array<{
    __typename?: "DistressSignalAggregateResponse";
    count?: {
      __typename?: "DistressSignalCountAggregate";
      id?: number | null;
    } | null;
  }>;
  driverAggregate: Array<{
    __typename?: "DriverAggregateResponse";
    count?: { __typename?: "DriverCountAggregate"; id?: number | null } | null;
  }>;
};

export type SosSubscriptionSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type SosSubscriptionSubscription = {
  __typename?: "Subscription";
  sosCreated: { __typename?: "DistressSignal"; id: string; status: SosStatus };
};

export type ComplaintSubscriptionSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type ComplaintSubscriptionSubscription = {
  __typename?: "Subscription";
  complaintCreated: {
    __typename?: "TaxiSupportRequest";
    id: string;
    status: ComplaintStatus;
  };
};

export type ViewComplaintQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewComplaintQuery = {
  __typename?: "Query";
  complaint: {
    __typename?: "TaxiSupportRequest";
    id: string;
    inscriptionTimestamp: any;
    status: ComplaintStatus;
    subject: string;
    content?: string | null;
    requestedByDriver: boolean;
    activities: Array<{
      __typename?: "TaxiSupportRequestActivity";
      type: ComplaintActivityType;
      comment?: string | null;
      createdAt: any;
      statusFrom?: ComplaintStatus | null;
      statusTo?: ComplaintStatus | null;
      actor?: {
        __typename?: "Operator";
        id: string;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
      assignedToStaffs: Array<{
        __typename?: "Operator";
        id: string;
        firstName?: string | null;
        lastName?: string | null;
      }>;
    }>;
    request: {
      __typename?: "Order";
      id: string;
      status: OrderStatus;
      createdOn: any;
      startTimestamp?: any | null;
      finishTimestamp?: any | null;
      expectedTimestamp?: any | null;
      costBest: number;
      costAfterCoupon: number;
      estimatedFixedPrice?: number | null;
      finalCollectedAmount?: number | null;
      meterAmount?: number | null;
      meterExtrasAmount?: number | null;
      addresses: Array<string>;
      currency: string;
      fareMode: FareMode;
      paymentMode?: PaymentMode | null;
      orderSource: OrderSource;
      settlementSource?: SettlementSource | null;
      serviceName?: string | null;
      rider?: {
        __typename?: "Rider";
        id: string;
        mobileNumber?: string | null;
        status: RiderStatus;
        firstName?: string | null;
        lastName?: string | null;
        registrationTimestamp: any;
      } | null;
      driver?: {
        __typename?: "Driver";
        id: string;
        mobileNumber: string;
        status: DriverStatus;
        firstName?: string | null;
        lastName?: string | null;
        registrationTimestamp: any;
      } | null;
    };
  };
};

export type UpdateComplaintStatusMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  status: ComplaintStatus;
}>;

export type UpdateComplaintStatusMutation = {
  __typename?: "Mutation";
  updateOneTaxiSupportRequest: {
    __typename?: "TaxiSupportRequest";
    id: string;
  };
};

export type ComplaintsListQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;

export type ComplaintsListQuery = {
  __typename?: "Query";
  taxiSupportRequests: {
    __typename?: "TaxiSupportRequestConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "TaxiSupportRequest";
      id: string;
      inscriptionTimestamp: any;
      subject: string;
      status: ComplaintStatus;
      content?: string | null;
      requestedByDriver: boolean;
      request: {
        __typename?: "Order";
        id: string;
        status: OrderStatus;
        addresses: Array<string>;
        rider?: {
          __typename?: "Rider";
          id: string;
          firstName?: string | null;
          lastName?: string | null;
          mobileNumber?: string | null;
        } | null;
        driver?: {
          __typename?: "Driver";
          id: string;
          firstName?: string | null;
          lastName?: string | null;
          mobileNumber: string;
        } | null;
      };
    }>;
  };
  complaintSummary: {
    __typename?: "TaxiSupportRequestConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "TaxiSupportRequest";
      id: string;
      inscriptionTimestamp: any;
      status: ComplaintStatus;
    }>;
  };
};

export type AdminNotificationEventCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type AdminNotificationEventCreatedSubscription = {
  __typename?: "Subscription";
  adminNotificationEventCreated: {
    __typename?: "AdminNotificationEventV1";
    schemaVersion: number;
    eventId: string;
    type: AdminNotificationType;
    category: AdminNotificationCategory;
    severity: AdminNotificationSeverity;
    safeTitle: string;
    safeBody: string;
    route: string;
    tag: string;
    dedupeKey: string;
    createdAt: string;
    expiresAt: string;
    acknowledgementPolicy: AdminNotificationAcknowledgementPolicy;
    soundPolicy: AdminNotificationSoundPolicy;
  };
};

export type OpenAdminNotificationEventMutationVariables = Exact<{
  eventId: Scalars["String"]["input"];
}>;

export type OpenAdminNotificationEventMutation = {
  __typename?: "Mutation";
  openAdminNotificationEvent: boolean;
};

export type AcknowledgeAdminNotificationEventMutationVariables = Exact<{
  eventId: Scalars["String"]["input"];
}>;

export type AcknowledgeAdminNotificationEventMutation = {
  __typename?: "Mutation";
  acknowledgeAdminNotificationEvent: boolean;
};

export type UpsertAdminBrowserPushRegistrationMutationVariables = Exact<{
  input: UpsertAdminBrowserPushRegistrationInput;
}>;

export type UpsertAdminBrowserPushRegistrationMutation = {
  __typename?: "Mutation";
  upsertAdminBrowserPushRegistration: {
    __typename?: "AdminBrowserPushRegistration";
    id: string;
    browserInstanceId: string;
    provider: AdminBrowserPushProvider;
    platform: AdminBrowserPushPlatform;
    browser: AdminBrowserPushBrowser;
    browserVersion?: string | null;
    operatingSystemLabel?: string | null;
    locale: string;
    permissionState: AdminBrowserPushPermissionState;
    desktopEnabled: boolean;
    soundEnabled: boolean;
    criticalOnly: boolean;
    serviceWorkerVersion?: string | null;
    lastSeenAt: any;
    tokenRefreshedAt: any;
    revokedAt?: any | null;
    categoryPreferences: {
      __typename?: "AdminBrowserPushCategoryPreferencesDTO";
      emergencyEnabled: boolean;
      complaintEnabled: boolean;
      scheduleEnabled: boolean;
      requestEnabled: boolean;
      driverOperationalEnabled: boolean;
      systemEnabled: boolean;
      telematicsEnabled: boolean;
    };
  };
};

export type UpdateAdminBrowserPushPreferencesMutationVariables = Exact<{
  input: UpdateAdminBrowserPushPreferencesInput;
}>;

export type UpdateAdminBrowserPushPreferencesMutation = {
  __typename?: "Mutation";
  updateAdminBrowserPushPreferences: {
    __typename?: "AdminBrowserPushRegistration";
    id: string;
    browserInstanceId: string;
    desktopEnabled: boolean;
    soundEnabled: boolean;
    criticalOnly: boolean;
    permissionState: AdminBrowserPushPermissionState;
    serviceWorkerVersion?: string | null;
    lastSeenAt: any;
    categoryPreferences: {
      __typename?: "AdminBrowserPushCategoryPreferencesDTO";
      emergencyEnabled: boolean;
      complaintEnabled: boolean;
      scheduleEnabled: boolean;
      requestEnabled: boolean;
      driverOperationalEnabled: boolean;
      systemEnabled: boolean;
      telematicsEnabled: boolean;
    };
  };
};

export type RevokeAdminBrowserPushRegistrationMutationVariables = Exact<{
  browserInstanceId: Scalars["String"]["input"];
}>;

export type RevokeAdminBrowserPushRegistrationMutation = {
  __typename?: "Mutation";
  revokeAdminBrowserPushRegistration: boolean;
};

export type MyAdminBrowserPushRegistrationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type MyAdminBrowserPushRegistrationsQuery = {
  __typename?: "Query";
  myAdminBrowserPushRegistrations: Array<{
    __typename?: "AdminBrowserPushRegistration";
    id: string;
    browserInstanceId: string;
    provider: AdminBrowserPushProvider;
    platform: AdminBrowserPushPlatform;
    browser: AdminBrowserPushBrowser;
    browserVersion?: string | null;
    operatingSystemLabel?: string | null;
    locale: string;
    permissionState: AdminBrowserPushPermissionState;
    desktopEnabled: boolean;
    soundEnabled: boolean;
    criticalOnly: boolean;
    serviceWorkerVersion?: string | null;
    lastSeenAt: any;
    tokenRefreshedAt: any;
    revokedAt?: any | null;
  }>;
};

export type CreateDriverMutationVariables = Exact<{
  input: UpdateDriverInput;
}>;

export type CreateDriverMutation = {
  __typename?: "Mutation";
  createOneDriver: { __typename?: "Driver"; id: string };
};

export type ViewDriverQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewDriverQuery = {
  __typename?: "Query";
  driver: {
    __typename?: "Driver";
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    mobileNumber: string;
    registrationTimestamp: any;
    lastSeenTimestamp?: any | null;
    status: DriverStatus;
    gender?: Gender | null;
    carId?: string | null;
    carColorId?: string | null;
    fleetId?: string | null;
    carProductionYear?: number | null;
    carPlate?: string | null;
    accountNumber?: string | null;
    bankName?: string | null;
    bankRoutingNumber?: string | null;
    bankSwift?: string | null;
    address?: string | null;
    email?: string | null;
    mediaId?: string | null;
    rating?: number | null;
    reviewCount: number;
    enabledServices: Array<{
      __typename?: "DriverServicesServiceDTO";
      serviceId: string;
    }>;
    documents: Array<{ __typename?: "Media"; address: string }>;
    media?: { __typename?: "Media"; address: string } | null;
  };
  services: Array<{ __typename?: "Service"; id: string; name: string }>;
  fleets: {
    __typename?: "FleetConnection";
    nodes: Array<{ __typename?: "Fleet"; id: string; name: string }>;
  };
  driverFeedbackParametersSummary: Array<{
    __typename?: "FeedbackParameterAggregate";
    title: string;
    isGood: boolean;
    count: string;
  }>;
  driverTripRevenueSummary: {
    __typename?: "DriverTripRevenueSummary";
    finishedTripCount: number;
    lastCompletedTripAt?: any | null;
    currencyTotals: Array<{
      __typename?: "DriverTripRevenueCurrencyTotal";
      currency: string;
      amount: number;
    }>;
  };
  vehicles: Array<{
    __typename?: "Vehicle";
    id: string;
    plate: string;
    modelName?: string | null;
    colorName?: string | null;
    productionYear?: number | null;
    status: VehicleStatus;
    assignedDriverId?: string | null;
    assignedDriverName?: string | null;
  }>;
  driverCurrentVehicleAssignment?: {
    __typename?: "DriverVehicleAssignment";
    id: string;
    driverId: string;
    vehicleId: string;
    startedAt: any;
    endedAt?: any | null;
    assignedByOperatorId?: string | null;
    assignedByOperatorName?: string | null;
    reason?: string | null;
    note?: string | null;
    vehiclePlate: string;
    vehicleModel?: string | null;
    vehicleColor?: string | null;
    vehicleProductionYear?: number | null;
    vehicleStatus?: VehicleStatus | null;
  } | null;
  driverVehicleAssignmentHistory: Array<{
    __typename?: "DriverVehicleAssignment";
    id: string;
    startedAt: any;
    endedAt?: any | null;
    assignedByOperatorName?: string | null;
    reason?: string | null;
    note?: string | null;
    vehiclePlate: string;
    vehicleModel?: string | null;
    vehicleColor?: string | null;
    vehicleProductionYear?: number | null;
    vehicleStatus?: VehicleStatus | null;
  }>;
  carModels: {
    __typename?: "CarModelConnection";
    nodes: Array<{ __typename?: "CarModel"; id: string; name: string }>;
  };
  carColors: {
    __typename?: "CarColorConnection";
    nodes: Array<{ __typename?: "CarColor"; id: string; name: string }>;
  };
};

export type UpdateDriverProfileMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  update: UpdateDriverInput;
  serviceIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type UpdateDriverProfileMutation = {
  __typename?: "Mutation";
  setActivatedServicesOnDriver: boolean;
  updateOneDriver: { __typename?: "Driver"; id: string };
};

export type UpdateDriverStatusMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  status: DriverStatus;
}>;

export type UpdateDriverStatusMutation = {
  __typename?: "Mutation";
  updateDriverStatus: {
    __typename?: "Driver";
    id: string;
    status: DriverStatus;
  };
};

export type AssignVehicleToDriverMutationVariables = Exact<{
  input: AssignVehicleToDriverInput;
}>;

export type AssignVehicleToDriverMutation = {
  __typename?: "Mutation";
  assignVehicleToDriver: {
    __typename?: "DriverVehicleAssignment";
    id: string;
    driverId: string;
    vehicleId: string;
    startedAt: any;
    vehiclePlate: string;
    vehicleModel?: string | null;
    vehicleColor?: string | null;
    vehicleProductionYear?: number | null;
    vehicleStatus?: VehicleStatus | null;
  };
};

export type DriverFinancialsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  dateFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  dateTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  paging?: InputMaybe<OffsetPaging>;
  filter?: InputMaybe<OrderFilter>;
  sorting?: InputMaybe<Array<OrderSort> | OrderSort>;
}>;

export type DriverFinancialsQuery = {
  __typename?: "Query";
  driver: {
    __typename?: "Driver";
    orders: {
      __typename?: "DriverOrdersConnection";
      totalCount: number;
      nodes: Array<{
        __typename?: "Order";
        id: string;
        createdOn: any;
        finishTimestamp?: any | null;
        status: OrderStatus;
        addresses: Array<string>;
        costBest: number;
        costAfterCoupon: number;
        estimatedFixedPrice?: number | null;
        finalCollectedAmount?: number | null;
        currency: string;
        fareMode: FareMode;
        paymentMode?: PaymentMode | null;
        settlementSource?: SettlementSource | null;
        orderSource: OrderSource;
        meterAmount?: number | null;
        meterCurrency?: string | null;
        meterExtrasAmount?: number | null;
        streetPassengerName?: string | null;
        rider?: {
          __typename?: "Rider";
          firstName?: string | null;
          lastName?: string | null;
          mobileNumber?: string | null;
        } | null;
      }>;
    };
  };
  regions: {
    __typename?: "RegionConnection";
    nodes: Array<{ __typename?: "Region"; currency: string }>;
  };
  driverTripRevenueSummary: {
    __typename?: "DriverTripRevenueSummary";
    finishedTripCount: number;
    lastCompletedTripAt?: any | null;
    currencyTotals: Array<{
      __typename?: "DriverTripRevenueCurrencyTotal";
      currency: string;
      amount: number;
    }>;
  };
};

export type DriverFeedbacksQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  paging?: InputMaybe<OffsetPaging>;
}>;

export type DriverFeedbacksQuery = {
  __typename?: "Query";
  driver: {
    __typename?: "Driver";
    rating?: number | null;
    reviewCount: number;
  };
  feedbacks: {
    __typename?: "FeedbackConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "Feedback";
      id: string;
      requestId: string;
      reviewTimestamp: any;
      score: number;
      description?: string | null;
      parameters: Array<{
        __typename?: "FeedbackParameter";
        isGood: boolean;
        title: string;
      }>;
      request: {
        __typename?: "Order";
        id: string;
        rider?: {
          __typename?: "Rider";
          firstName?: string | null;
          lastName?: string | null;
          mobileNumber?: string | null;
        } | null;
      };
    }>;
  };
};

export type DriverOrdersQueryVariables = Exact<{
  driverId: Scalars["ID"]["input"];
  filter?: InputMaybe<OrderFilter>;
  paging?: InputMaybe<OffsetPaging>;
  sorting?: InputMaybe<Array<OrderSort> | OrderSort>;
}>;

export type DriverOrdersQuery = {
  __typename?: "Query";
  driver: {
    __typename?: "Driver";
    orders: {
      __typename?: "DriverOrdersConnection";
      totalCount: number;
      nodes: Array<{
        __typename?: "Order";
        id: string;
        createdOn: any;
        startTimestamp?: any | null;
        status: OrderStatus;
        distanceBest: number;
        durationBest: number;
        costBest: number;
        costAfterCoupon: number;
        currency: string;
        fareMode: FareMode;
        paymentMode?: PaymentMode | null;
        orderSource: OrderSource;
        addresses: Array<string>;
        expectedTimestamp?: any | null;
        points: Array<{ __typename?: "Point"; lat: number; lng: number }>;
      }>;
    };
  };
};

export type ArchiveDriverMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  reason: Scalars["String"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ArchiveDriverMutation = {
  __typename?: "Mutation";
  archiveDriver: { __typename?: "Driver"; id: string };
};

export type DriversListQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
  filter?: InputMaybe<DriverFilter>;
  sorting?: InputMaybe<Array<DriverSort> | DriverSort>;
}>;

export type DriversListQuery = {
  __typename?: "Query";
  allDrivers: { __typename?: "DriverConnection"; totalCount: number };
  drivers: {
    __typename?: "DriverConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "Driver";
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      gender?: Gender | null;
      mobileNumber: string;
      status: DriverStatus;
      registrationTimestamp: any;
      lastSeenTimestamp?: any | null;
      carPlate?: string | null;
      carProductionYear?: number | null;
      rating?: number | null;
      reviewCount: number;
      media?: { __typename?: "Media"; address: string } | null;
      ordersAggregate: Array<{
        __typename?: "DriverOrdersAggregateResponse";
        count?: {
          __typename?: "DriverOrdersCountAggregate";
          id?: number | null;
        } | null;
      }>;
    }>;
  };
};

export type ArchivedDriversRegisterQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ArchivedDriversRegisterQuery = {
  __typename?: "Query";
  archivedDrivers: Array<{
    __typename?: "ArchivedDriver";
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    mobileNumber: string;
    archivedAt: any;
    lastArchiveReason?: string | null;
  }>;
};

export type RestoreArchivedDriverMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  reason: Scalars["String"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type RestoreArchivedDriverMutation = {
  __typename?: "Mutation";
  restoreArchivedDriver: {
    __typename?: "Driver";
    id: string;
    status: DriverStatus;
  };
};

export type DriverLocationUpdatedSubscriptionVariables = Exact<{
  driverIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type DriverLocationUpdatedSubscription = {
  __typename?: "Subscription";
  driverLocationUpdated: {
    __typename?: "DriverLocationUpdate";
    driverId: string;
    lastUpdatedAt: any;
    point: { __typename?: "Point"; lat: number; lng: number };
  };
};

export type ProviderWalletsListQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;

export type ProviderWalletsListQuery = {
  __typename?: "Query";
  providerTransactions: {
    __typename?: "ProviderTransactionConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "ProviderTransaction";
      createdAt: any;
      action: TransactionAction;
      deductType?: ProviderDeductTransactionType | null;
      rechargeType?: ProviderRechargeTransactionType | null;
      amount: number;
      currency: string;
      description?: string | null;
      requestId?: string | null;
      operatorId?: string | null;
    }>;
  };
  providerWallets: Array<{
    __typename?: "ProviderWallet";
    balance: number;
    currency: string;
  }>;
  regions: {
    __typename?: "RegionConnection";
    nodes: Array<{ __typename?: "Region"; currency: string }>;
  };
};

export type ExportQueryVariables = Exact<{
  input: ExportArgs;
}>;

export type ExportQuery = {
  __typename?: "Query";
  export: { __typename?: "ExportResult"; url: string };
};

export type DriverWalletsListQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;

export type DriverWalletsListQuery = {
  __typename?: "Query";
  driverWallets: {
    __typename?: "DriverWalletConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "DriverWallet";
      id: string;
      driverId: string;
      balance: number;
      currency: string;
      driver?: {
        __typename?: "Driver";
        firstName?: string | null;
        lastName?: string | null;
      } | null;
    }>;
  };
  regions: {
    __typename?: "RegionConnection";
    nodes: Array<{ __typename?: "Region"; currency: string }>;
  };
};

export type FleetWalletsListQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
  filter?: InputMaybe<FleetWalletFilter>;
}>;

export type FleetWalletsListQuery = {
  __typename?: "Query";
  fleetWallets: {
    __typename?: "FleetWalletConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "FleetWallet";
      id: string;
      balance: number;
      currency: string;
      fleetId: string;
      fleet: { __typename?: "Fleet"; name: string };
    }>;
  };
  regions: {
    __typename?: "RegionConnection";
    nodes: Array<{ __typename?: "Region"; currency: string }>;
  };
};

export type RiderWalletsListQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;

export type RiderWalletsListQuery = {
  __typename?: "Query";
  riderWallets: {
    __typename?: "RiderWalletConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "RiderWallet";
      balance: number;
      currency: string;
      riderId: string;
      rider?: {
        __typename?: "Rider";
        firstName?: string | null;
        lastName?: string | null;
      } | null;
    }>;
  };
  regions: {
    __typename?: "RegionConnection";
    nodes: Array<{ __typename?: "Region"; currency: string }>;
  };
};

export type DispatcherCalculateFareQueryVariables = Exact<{
  points: Array<PointInput> | PointInput;
  riderId: Scalars["ID"]["input"];
  tariffProfileId?: InputMaybe<Scalars["ID"]["input"]>;
  waitTime?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type DispatcherCalculateFareQuery = {
  __typename?: "Query";
  calculateFare: {
    __typename?: "CalculateFare";
    currency: string;
    distance: number;
    duration: number;
    services: Array<{
      __typename?: "ServiceCategoryWithCost";
      name: string;
      services: Array<{
        __typename?: "ServiceWithCost";
        id: string;
        name: string;
        cost: number;
        costResult:
          | {
              __typename?: "FixedCost";
              zonePriceBreakdown?: {
                __typename?: "ZonePriceFareBreakdown";
                zonePriceId: string;
                zonePriceName?: string | null;
                tariffProfileId?: string | null;
                tariffProfileName?: string | null;
                defaultZonePrice: number;
                selectedProfileZonePrice?: number | null;
                finalZonePrice: number;
                profilePriceApplied: boolean;
              } | null;
            }
          | { __typename?: "RangeCost" };
      }>;
    }>;
  };
  rider: {
    __typename?: "Rider";
    id: string;
    tariffProfileId?: string | null;
    tariffProfile?: {
      __typename?: "TariffProfile";
      id: string;
      title: string;
      code: string;
    } | null;
  };
  tariffProfiles: {
    __typename?: "TariffProfileConnection";
    nodes: Array<{
      __typename?: "TariffProfile";
      id: string;
      title: string;
      code: string;
    }>;
  };
};

export type DispatcherSetupQueryVariables = Exact<{ [key: string]: never }>;

export type DispatcherSetupQuery = {
  __typename?: "Query";
  tariffProfiles: {
    __typename?: "TariffProfileConnection";
    nodes: Array<{
      __typename?: "TariffProfile";
      id: string;
      title: string;
      code: string;
    }>;
  };
  defaultDispatchService?: {
    __typename?: "Service";
    id: string;
    name: string;
    isDefaultDispatchService: boolean;
  } | null;
  dispatchConfig: {
    __typename?: "DispatchConfig";
    nextAvailable?: {
      __typename?: "NextAvailableConfig";
      enabled: boolean;
      manualBusyDriverReservationEnabled?: boolean | null;
    } | null;
  };
};

export type DispatcherPreviewFareQueryVariables = Exact<{
  points: Array<PointInput> | PointInput;
  riderId?: InputMaybe<Scalars["ID"]["input"]>;
  tariffProfileId?: InputMaybe<Scalars["ID"]["input"]>;
  waitTime?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type DispatcherPreviewFareQuery = {
  __typename?: "Query";
  calculateFare: {
    __typename?: "CalculateFare";
    currency: string;
    distance: number;
    duration: number;
    services: Array<{
      __typename?: "ServiceCategoryWithCost";
      name: string;
      services: Array<{
        __typename?: "ServiceWithCost";
        id: string;
        name: string;
        cost: number;
        costResult:
          | {
              __typename?: "FixedCost";
              zonePriceBreakdown?: {
                __typename?: "ZonePriceFareBreakdown";
                zonePriceId: string;
                zonePriceName?: string | null;
                tariffProfileId?: string | null;
                tariffProfileName?: string | null;
                defaultZonePrice: number;
                selectedProfileZonePrice?: number | null;
                finalZonePrice: number;
                profilePriceApplied: boolean;
              } | null;
            }
          | { __typename?: "RangeCost" };
      }>;
    }>;
  };
};

export type SearchDispatcherCustomersQueryVariables = Exact<{
  keyword: Scalars["String"]["input"];
}>;

export type SearchDispatcherCustomersQuery = {
  __typename?: "Query";
  searchDispatcherCustomers: Array<{
    __typename?: "Rider";
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    mobileNumber?: string | null;
    nationality?: string | null;
    countryOfResidence?: string | null;
    tariffProfileId?: string | null;
    tariffProfile?: {
      __typename?: "TariffProfile";
      id: string;
      title: string;
      code: string;
    } | null;
  }>;
};

export type CreateDispatcherGuestCustomerMutationVariables = Exact<{
  input: CreateDispatcherGuestCustomerInput;
}>;

export type CreateDispatcherGuestCustomerMutation = {
  __typename?: "Mutation";
  createDispatcherGuestCustomer: {
    __typename?: "Rider";
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    mobileNumber?: string | null;
    nationality?: string | null;
    countryOfResidence?: string | null;
    tariffProfileId?: string | null;
    tariffProfile?: {
      __typename?: "TariffProfile";
      id: string;
      title: string;
      code: string;
    } | null;
  };
};

export type CreateDispatcherRegisteredCustomerMutationVariables = Exact<{
  input: CreateDispatcherRegisteredCustomerInput;
}>;

export type CreateDispatcherRegisteredCustomerMutation = {
  __typename?: "Mutation";
  createDispatcherRegisteredCustomer: {
    __typename?: "Rider";
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    mobileNumber?: string | null;
    nationality?: string | null;
    countryOfResidence?: string | null;
    tariffProfileId?: string | null;
    tariffProfile?: {
      __typename?: "TariffProfile";
      id: string;
      title: string;
      code: string;
    } | null;
  };
};

export type DispatcherAvailableDriversQueryVariables = Exact<{
  center: PointInput;
  count: Scalars["Int"]["input"];
  serviceId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type DispatcherAvailableDriversQuery = {
  __typename?: "Query";
  getDriversLocationWithData: Array<{
    __typename?: "OnlineDriverWithData";
    id: string;
    mobileNumber: string;
    firstName?: string | null;
    lastName?: string | null;
    lastUpdatedAt: any;
    rating?: number | null;
    reviewCount: number;
    status: DriverStatus;
    vehiclePlate?: string | null;
    serviceIds: Array<string>;
    availabilityStatus: DriverAvailabilityStatus;
    availabilityReason: string;
    canAssignNow: boolean;
    isOnline: boolean;
    serviceCompatible: boolean;
    activeOrderId?: string | null;
    estimatedFinishTime?: any | null;
    location: { __typename?: "Point"; lat: number; lng: number };
  }>;
};

export type CreateOrderMutationVariables = Exact<{
  riderId?: InputMaybe<Scalars["ID"]["input"]>;
  points: Array<PointInput> | PointInput;
  addresses: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  serviceId: Scalars["ID"]["input"];
  scheduledAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  driverId?: InputMaybe<Scalars["ID"]["input"]>;
  fareMode?: InputMaybe<FareMode>;
  paymentMode?: InputMaybe<PaymentMode>;
  tariffProfileId?: InputMaybe<Scalars["ID"]["input"]>;
  tariffProfileReason?: InputMaybe<Scalars["String"]["input"]>;
  dispatcherNote?: InputMaybe<Scalars["String"]["input"]>;
  reportingSource?: InputMaybe<OrderSource>;
  waitingTimeMinutes?: InputMaybe<Scalars["Int"]["input"]>;
  deferDispatchForManualReservation?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type CreateOrderMutation = {
  __typename?: "Mutation";
  createOrder: { __typename?: "Order"; id: string };
};

export type QueueDispatcherOrderForNextAvailableMutationVariables = Exact<{
  orderId: Scalars["ID"]["input"];
}>;

export type QueueDispatcherOrderForNextAvailableMutation = {
  __typename?: "Mutation";
  queueDispatcherOrderForNextAvailable: {
    __typename?: "Order";
    id: string;
    status: OrderStatus;
    nextAvailableDriverId?: string | null;
    nextAvailableHoldExpiresAt?: any | null;
    nextAvailableEstimatedPickupAt?: any | null;
    nextAvailableEtaSeconds?: number | null;
    nextAvailablePickupDistanceMeters?: number | null;
    nextAvailableAttemptCount: number;
    nextAvailableFailureReason?: string | null;
    nextAvailableMode?: NextAvailableMode | null;
    nextAvailableDriver?: {
      __typename?: "Driver";
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      mobileNumber: string;
      carPlate?: string | null;
    } | null;
  };
};

export type ReserveDriverAfterCurrentTripMutationVariables = Exact<{
  orderId: Scalars["ID"]["input"];
  driverId: Scalars["ID"]["input"];
}>;

export type ReserveDriverAfterCurrentTripMutation = {
  __typename?: "Mutation";
  reserveDriverAfterCurrentTrip: {
    __typename?: "Order";
    id: string;
    status: OrderStatus;
    nextAvailableDriverId?: string | null;
    nextAvailableHoldExpiresAt?: any | null;
    nextAvailableEstimatedPickupAt?: any | null;
    nextAvailableEtaSeconds?: number | null;
    nextAvailablePickupDistanceMeters?: number | null;
    nextAvailableAttemptCount: number;
    nextAvailableFailureReason?: string | null;
    nextAvailableMode?: NextAvailableMode | null;
    nextAvailableDriver?: {
      __typename?: "Driver";
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      mobileNumber: string;
      carPlate?: string | null;
    } | null;
  };
};

export type CreateAndReserveDriverAfterCurrentTripMutationVariables = Exact<{
  riderId?: InputMaybe<Scalars["ID"]["input"]>;
  driverId: Scalars["ID"]["input"];
  points: Array<PointInput> | PointInput;
  addresses: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  serviceId: Scalars["ID"]["input"];
  fareMode?: InputMaybe<FareMode>;
  paymentMode?: InputMaybe<PaymentMode>;
  tariffProfileId?: InputMaybe<Scalars["ID"]["input"]>;
  tariffProfileReason?: InputMaybe<Scalars["String"]["input"]>;
  dispatcherNote?: InputMaybe<Scalars["String"]["input"]>;
  reportingSource?: InputMaybe<OrderSource>;
  waitingTimeMinutes?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type CreateAndReserveDriverAfterCurrentTripMutation = {
  __typename?: "Mutation";
  createAndReserveDriverAfterCurrentTrip: {
    __typename?: "CreateAndReserveDriverAfterCurrentTripResultDTO";
    success: boolean;
    code: string;
    message: string;
    orderId?: string | null;
    driverId?: string | null;
    reservedDriverId?: string | null;
    holdExpiresAt?: any | null;
    estimatedFinishEta?: any | null;
    estimatedPickupEta?: any | null;
    canTryAnotherDriver: boolean;
    canTryAutomaticNextAvailable: boolean;
    canCreateNormalRequest: boolean;
    canOpenRequest: boolean;
    canCancelRequest: boolean;
    order?: {
      __typename?: "Order";
      id: string;
      status: OrderStatus;
      nextAvailableDriverId?: string | null;
      nextAvailableHoldExpiresAt?: any | null;
      nextAvailableEstimatedPickupAt?: any | null;
      nextAvailableEtaSeconds?: number | null;
      nextAvailablePickupDistanceMeters?: number | null;
      nextAvailableAttemptCount: number;
      nextAvailableFailureReason?: string | null;
      nextAvailableMode?: NextAvailableMode | null;
      nextAvailableDriver?: {
        __typename?: "Driver";
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        mobileNumber: string;
        carPlate?: string | null;
      } | null;
    } | null;
  };
};

export type OrderUpdatedSubscriptionVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type OrderUpdatedSubscription = {
  __typename?: "Subscription";
  orderUpdated: {
    __typename?: "OrderChangeEvent";
    orderId: string;
    status: OrderStatus;
    driver?: {
      __typename?: "OrderChangeDriver";
      firstName?: string | null;
      lastName?: string | null;
      mobileNumber?: string | null;
    } | null;
  };
};

export type CancelOrderMutationVariables = Exact<{
  orderId: Scalars["ID"]["input"];
}>;

export type CancelOrderMutation = {
  __typename?: "Mutation";
  cancelOrder: { __typename?: "Order"; id: string; status: OrderStatus };
};

export type DriverOverviewInfoFragment = {
  __typename?: "Driver";
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  mobileNumber: string;
  status: DriverStatus;
};

export type DriverLocationFragment = {
  __typename?: "OnlineDriver";
  driverId: string;
  lastUpdatedAt: any;
  location: { __typename?: "Point"; lat: number; lng: number };
};

export type OverviewQueryVariables = Exact<{ [key: string]: never }>;

export type OverviewQuery = {
  __typename?: "Query";
  taxiSupportRequestAggregate: Array<{
    __typename?: "TaxiSupportRequestAggregateResponse";
    count?: {
      __typename?: "TaxiSupportRequestCountAggregate";
      id?: number | null;
    } | null;
  }>;
  driverAggregate: Array<{
    __typename?: "DriverAggregateResponse";
    count?: { __typename?: "DriverCountAggregate"; id?: number | null } | null;
  }>;
  activeOrders: Array<{
    __typename?: "OrderAggregateResponse";
    count?: { __typename?: "OrderCountAggregate"; id?: number | null } | null;
  }>;
  bookedOrders: Array<{
    __typename?: "OrderAggregateResponse";
    count?: { __typename?: "OrderCountAggregate"; id?: number | null } | null;
  }>;
  getDriversLocation: Array<{
    __typename?: "OnlineDriver";
    driverId: string;
    lastUpdatedAt: any;
    location: { __typename?: "Point"; lat: number; lng: number };
  }>;
};

export type OverviewDriverPagingQueryVariables = Exact<{
  ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type OverviewDriverPagingQuery = {
  __typename?: "Query";
  drivers: {
    __typename?: "DriverConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "Driver";
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      mobileNumber: string;
      status: DriverStatus;
    }>;
  };
};

export type RequestsChartQueryVariables = Exact<{
  timeframe: ChartTimeframe;
}>;

export type RequestsChartQuery = {
  __typename?: "Query";
  requestChart: Array<{
    __typename?: "RequestResultItem";
    time: string;
    count: number;
    status: OrderStatus;
  }>;
};

export type IncomeChartQueryVariables = Exact<{
  timeframe: ChartTimeframe;
}>;

export type IncomeChartQuery = {
  __typename?: "Query";
  incomeChart: Array<{
    __typename?: "IncomeResultItem";
    time: string;
    sum: number;
    currency: string;
  }>;
};

export type DashboardRevenueByServiceQueryVariables = Exact<{
  [key: string]: never;
}>;

export type DashboardRevenueByServiceQuery = {
  __typename?: "Query";
  dashboardRevenueByService: Array<{
    __typename?: "DashboardRevenueByServiceItemDTO";
    label: string;
    currency: string;
    sum: number;
  }>;
};

export type DashboardServicePerformanceQueryVariables = Exact<{
  [key: string]: never;
}>;

export type DashboardServicePerformanceQuery = {
  __typename?: "Query";
  dashboardServicePerformance: {
    __typename?: "DashboardServicePerformanceDTO";
    peakHour?: string | null;
    peakRideCount: number;
    avgTripDurationSeconds?: number | null;
    avgWaitMinutes?: number | null;
  };
};

export type DriverRegistrationsQueryVariables = Exact<{
  timeframe: ChartTimeframe;
}>;

export type DriverRegistrationsQuery = {
  __typename?: "Query";
  driverRegistrations: Array<{
    __typename?: "RegistrationResultItem";
    time: string;
    count: number;
  }>;
};

export type RiderRegistrationsQueryVariables = Exact<{
  timeframe: ChartTimeframe;
}>;

export type RiderRegistrationsQuery = {
  __typename?: "Query";
  riderRegistrations: Array<{
    __typename?: "RegistrationResultItem";
    time: string;
    count: number;
  }>;
};

export type OverviewLeaderboardsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type OverviewLeaderboardsQuery = {
  __typename?: "Query";
  topSpendingCustomers: Array<{
    __typename?: "LeaderboardItem";
    id: string;
    name: string;
    avatarUrl?: string | null;
    currency?: string | null;
    totalAmount?: number | null;
    totalCount?: number | null;
  }>;
  topTripsCompletedDrivers: Array<{
    __typename?: "LeaderboardItem";
    id: string;
    name: string;
    avatarUrl?: string | null;
    currency?: string | null;
    totalAmount?: number | null;
    totalCount?: number | null;
  }>;
};

export type CarsListQueryVariables = Exact<{ [key: string]: never }>;

export type CarsListQuery = {
  __typename?: "Query";
  carModels: {
    __typename?: "CarModelConnection";
    nodes: Array<{ __typename?: "CarModel"; id: string; name: string }>;
  };
  carColors: {
    __typename?: "CarColorConnection";
    nodes: Array<{ __typename?: "CarColor"; id: string; name: string }>;
  };
  vehicles: Array<{
    __typename?: "Vehicle";
    id: string;
    plate: string;
    modelId?: string | null;
    modelName?: string | null;
    colorId?: string | null;
    colorName?: string | null;
    productionYear?: number | null;
    status: VehicleStatus;
    notes?: string | null;
    assignedDriverId?: string | null;
    assignedDriverName?: string | null;
    assignedDriverMobileNumber?: string | null;
  }>;
};

export type DeleteCarModelMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteCarModelMutation = {
  __typename?: "Mutation";
  deleteOneCarModel: {
    __typename?: "CarModelDeleteResponse";
    id?: string | null;
  };
};

export type DeleteCarColorMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteCarColorMutation = {
  __typename?: "Mutation";
  deleteOneCarColor: {
    __typename?: "CarColorDeleteResponse";
    id?: string | null;
  };
};

export type CreateCarModelMutationVariables = Exact<{
  input: CarModelInput;
}>;

export type CreateCarModelMutation = {
  __typename?: "Mutation";
  createOneCarModel: { __typename?: "CarModel"; id: string };
};

export type CreateCarColorMutationVariables = Exact<{
  input: CarColorInput;
}>;

export type CreateCarColorMutation = {
  __typename?: "Mutation";
  createOneCarColor: { __typename?: "CarColor"; id: string };
};

export type UpdateCarModelMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: CarModelInput;
}>;

export type UpdateCarModelMutation = {
  __typename?: "Mutation";
  updateOneCarModel: { __typename?: "CarModel"; id: string };
};

export type UpdateCarColorMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: CarColorInput;
}>;

export type UpdateCarColorMutation = {
  __typename?: "Mutation";
  updateOneCarColor: { __typename?: "CarColor"; id: string };
};

export type CreateVehicleMutationVariables = Exact<{
  input: CreateVehicleInput;
}>;

export type CreateVehicleMutation = {
  __typename?: "Mutation";
  createVehicle: { __typename?: "Vehicle"; id: string };
};

export type UpdateVehicleMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: UpdateVehicleInput;
}>;

export type UpdateVehicleMutation = {
  __typename?: "Mutation";
  updateVehicle: { __typename?: "Vehicle"; id: string };
};

export type VehicleTelematicsMappingFieldsFragment = {
  __typename: "VehicleTelematicsMapping";
  id: string;
  provider: TelematicsProvider;
  providerSettingId: string;
  providerApplicationId?: number | null;
  profileId: string;
  vehicleId: string;
  vehiclePlate?: string | null;
  profileName?: string | null;
  profileVersion?: number | null;
  providerUserId: string;
  providerUserMasked: string;
  providerDisplayName?: string | null;
  providerDeviceMasked?: string | null;
  providerDeviceName?: string | null;
  imeiLastFour?: string | null;
  effectiveFrom: any;
  effectiveTo?: any | null;
  mappingStatus: TelematicsMappingStatus;
  mappingSource: TelematicsMappingSource;
  endReason?: string | null;
  notes?: string | null;
  mappedByOperatorId?: string | null;
  mappedByName?: string | null;
  endedByOperatorId?: string | null;
  endedByName?: string | null;
  createdAt: any;
};

export type VehicleTelematicsSetupPageQueryVariables = Exact<{
  vehicleId: Scalars["ID"]["input"];
}>;

export type VehicleTelematicsSetupPageQuery = {
  __typename?: "Query";
  vehicleTelematicsSetup: {
    __typename?: "VehicleTelematicsSetup";
    vehicle: {
      __typename?: "VehicleTelematicsVehicleSummary";
      id: string;
      plate: string;
      modelName?: string | null;
      colorName?: string | null;
      productionYear?: number | null;
      status: VehicleStatus;
    };
    providerSetting?: {
      __typename?: "VehicleTelematicsProviderSummary";
      id: string;
      provider: TelematicsProvider;
      displayName: string;
    } | null;
    profiles: Array<{
      __typename?: "TelematicsProfile";
      id: string;
      providerSettingId: string;
      name: string;
      version: number;
      schemaVersion: number;
      active: boolean;
      published: boolean;
      fields: Array<{
        __typename?: "TelematicsFieldMapping";
        semanticField: string;
        currentStatusKey?: string | null;
        historicalKey?: string | null;
        expectedType: string;
        required: boolean;
        caseSensitive: boolean;
        unit?: string | null;
      }>;
    }>;
    mappings: Array<{
      __typename: "VehicleTelematicsMapping";
      id: string;
      provider: TelematicsProvider;
      providerSettingId: string;
      providerApplicationId?: number | null;
      profileId: string;
      vehicleId: string;
      vehiclePlate?: string | null;
      profileName?: string | null;
      profileVersion?: number | null;
      providerUserId: string;
      providerUserMasked: string;
      providerDisplayName?: string | null;
      providerDeviceMasked?: string | null;
      providerDeviceName?: string | null;
      imeiLastFour?: string | null;
      effectiveFrom: any;
      effectiveTo?: any | null;
      mappingStatus: TelematicsMappingStatus;
      mappingSource: TelematicsMappingSource;
      endReason?: string | null;
      notes?: string | null;
      mappedByOperatorId?: string | null;
      mappedByName?: string | null;
      endedByOperatorId?: string | null;
      endedByName?: string | null;
      createdAt: any;
    }>;
  };
};

export type VehicleTelematicsInventoryQueryVariables = Exact<{
  providerSettingId: Scalars["ID"]["input"];
  fromIndex: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type VehicleTelematicsInventoryQuery = {
  __typename?: "Query";
  telematicsProviderInventory: {
    __typename?: "TelematicsProviderInventoryPage";
    fromIndex: number;
    pageSize: number;
    hasMore: boolean;
    upstreamHttpStatus?: number | null;
    items: Array<{
      __typename?: "TelematicsProviderInventoryItem";
      providerUserId: string;
      displayName: string;
      providerDeviceCount?: number | null;
      latestActivityAt?: any | null;
      classification: TelematicsInventoryClassification;
      mappingStatus: TelematicsInventoryMappingStatus;
      mappedVehicleId?: string | null;
      mappedVehicleName?: string | null;
    }>;
  };
};

export type VehicleTelematicsInventoryDetailQueryVariables = Exact<{
  providerSettingId: Scalars["ID"]["input"];
  providerUserId: Scalars["String"]["input"];
}>;

export type VehicleTelematicsInventoryDetailQuery = {
  __typename?: "Query";
  telematicsProviderInventoryItem: {
    __typename?: "TelematicsProviderInventoryDetail";
    providerUserId: string;
    displayName: string;
    classification: TelematicsInventoryClassification;
    mappingStatus: TelematicsInventoryMappingStatus;
    mappedVehicleId?: string | null;
    mappedVehicleName?: string | null;
    upstreamHttpStatus?: number | null;
    devices: Array<{
      __typename?: "TelematicsProviderDeviceDetail";
      providerDeviceId: string;
      deviceName?: string | null;
      modelIdentifier?: string | null;
      protocolIdentifier?: string | null;
      maskedImei?: string | null;
      createdAt?: any | null;
      lastDeviceAt?: any | null;
      mappingStatus: TelematicsInventoryMappingStatus;
      mappedVehicleId?: string | null;
      mappedVehicleName?: string | null;
    }>;
  };
};

export type VehicleTelematicsStatusVerificationQueryVariables = Exact<{
  providerSettingId: Scalars["ID"]["input"];
  providerUserId: Scalars["String"]["input"];
}>;

export type VehicleTelematicsStatusVerificationQuery = {
  __typename?: "Query";
  telematicsProviderCurrentStatusPreview: {
    __typename?: "TelematicsCurrentStatusPreview";
    provider: TelematicsProvider;
    providerSettingId: string;
    providerApplicationId: number;
    providerUserId: string;
    providerDisplayName?: string | null;
    receivedAt: any;
    providerObservedAt?: any | null;
    deviceActivityAt?: any | null;
    capability: TelematicsCapability;
    warnings: Array<TelematicsStatusWarning>;
    upstreamHttpStatus?: number | null;
    position?: {
      __typename?: "TelematicsNormalizedPosition";
      latitude: number;
      longitude: number;
      valid: boolean;
      observedAt?: any | null;
    } | null;
    velocity: {
      __typename?: "TelematicsNormalizedVelocity";
      speedMetersPerSecond?: number | null;
      headingDegrees?: number | null;
      observedAt?: any | null;
    };
    passengerPresence: {
      __typename?: "TelematicsNormalizedSignal";
      value: TelematicsSignalValue;
      observedAt?: any | null;
      freshness: TelematicsSignalFreshness;
      providerField: string;
      parseStatus: TelematicsSignalParseStatus;
    };
    taximeterActive: {
      __typename?: "TelematicsNormalizedSignal";
      value: TelematicsSignalValue;
      observedAt?: any | null;
      freshness: TelematicsSignalFreshness;
      providerField: string;
      parseStatus: TelematicsSignalParseStatus;
    };
    ignition: {
      __typename?: "TelematicsNormalizedSignal";
      value: TelematicsSignalValue;
      observedAt?: any | null;
      freshness: TelematicsSignalFreshness;
      providerField: string;
      parseStatus: TelematicsSignalParseStatus;
    };
  };
};

export type CreateVehicleTelematicsConnectionMutationVariables = Exact<{
  input: CreateVehicleTelematicsMappingInput;
}>;

export type CreateVehicleTelematicsConnectionMutation = {
  __typename?: "Mutation";
  createVehicleTelematicsMapping: {
    __typename: "VehicleTelematicsMapping";
    id: string;
    provider: TelematicsProvider;
    providerSettingId: string;
    providerApplicationId?: number | null;
    profileId: string;
    vehicleId: string;
    vehiclePlate?: string | null;
    profileName?: string | null;
    profileVersion?: number | null;
    providerUserId: string;
    providerUserMasked: string;
    providerDisplayName?: string | null;
    providerDeviceMasked?: string | null;
    providerDeviceName?: string | null;
    imeiLastFour?: string | null;
    effectiveFrom: any;
    effectiveTo?: any | null;
    mappingStatus: TelematicsMappingStatus;
    mappingSource: TelematicsMappingSource;
    endReason?: string | null;
    notes?: string | null;
    mappedByOperatorId?: string | null;
    mappedByName?: string | null;
    endedByOperatorId?: string | null;
    endedByName?: string | null;
    createdAt: any;
    verificationDiagnostics?: {
      __typename?: "TelematicsMappingVerificationDiagnostics";
      detailUpstreamHttpStatus?: number | null;
      statusUpstreamHttpStatus?: number | null;
    } | null;
  };
};

export type ReplaceVehicleTelematicsConnectionMutationVariables = Exact<{
  input: ReplaceVehicleTelematicsMappingInput;
}>;

export type ReplaceVehicleTelematicsConnectionMutation = {
  __typename?: "Mutation";
  replaceVehicleTelematicsMapping: {
    __typename: "VehicleTelematicsMapping";
    id: string;
    provider: TelematicsProvider;
    providerSettingId: string;
    providerApplicationId?: number | null;
    profileId: string;
    vehicleId: string;
    vehiclePlate?: string | null;
    profileName?: string | null;
    profileVersion?: number | null;
    providerUserId: string;
    providerUserMasked: string;
    providerDisplayName?: string | null;
    providerDeviceMasked?: string | null;
    providerDeviceName?: string | null;
    imeiLastFour?: string | null;
    effectiveFrom: any;
    effectiveTo?: any | null;
    mappingStatus: TelematicsMappingStatus;
    mappingSource: TelematicsMappingSource;
    endReason?: string | null;
    notes?: string | null;
    mappedByOperatorId?: string | null;
    mappedByName?: string | null;
    endedByOperatorId?: string | null;
    endedByName?: string | null;
    createdAt: any;
    verificationDiagnostics?: {
      __typename?: "TelematicsMappingVerificationDiagnostics";
      detailUpstreamHttpStatus?: number | null;
      statusUpstreamHttpStatus?: number | null;
    } | null;
  };
};

export type EndVehicleTelematicsConnectionMutationVariables = Exact<{
  input: EndVehicleTelematicsMappingInput;
}>;

export type EndVehicleTelematicsConnectionMutation = {
  __typename?: "Mutation";
  endVehicleTelematicsMapping: {
    __typename: "VehicleTelematicsMapping";
    id: string;
    provider: TelematicsProvider;
    providerSettingId: string;
    providerApplicationId?: number | null;
    profileId: string;
    vehicleId: string;
    vehiclePlate?: string | null;
    profileName?: string | null;
    profileVersion?: number | null;
    providerUserId: string;
    providerUserMasked: string;
    providerDisplayName?: string | null;
    providerDeviceMasked?: string | null;
    providerDeviceName?: string | null;
    imeiLastFour?: string | null;
    effectiveFrom: any;
    effectiveTo?: any | null;
    mappingStatus: TelematicsMappingStatus;
    mappingSource: TelematicsMappingSource;
    endReason?: string | null;
    notes?: string | null;
    mappedByOperatorId?: string | null;
    mappedByName?: string | null;
    endedByOperatorId?: string | null;
    endedByName?: string | null;
    createdAt: any;
  };
};

export type CreateFleetMutationVariables = Exact<{
  input: CreateFleetInput;
}>;

export type CreateFleetMutation = {
  __typename?: "Mutation";
  createOneFleet: { __typename?: "Fleet"; id: string };
};

export type ViewFleetQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewFleetQuery = {
  __typename?: "Query";
  fleet: {
    __typename?: "Fleet";
    id: string;
    name: string;
    phoneNumber: string;
    address?: string | null;
    mobileNumber: string;
    accountNumber: string;
    userName?: string | null;
    password?: string | null;
    commissionSharePercent: number;
    commissionShareFlat: number;
    feeMultiplier?: number | null;
    exclusivityAreas?: Array<
      Array<{ __typename?: "Point"; lat: number; lng: number }>
    > | null;
  };
};

export type FleetFinancialsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  paging?: InputMaybe<OffsetPaging>;
  filter?: InputMaybe<FleetTransactionFilter>;
  sorting?: InputMaybe<Array<FleetTransactionSort> | FleetTransactionSort>;
}>;

export type FleetFinancialsQuery = {
  __typename?: "Query";
  fleet: {
    __typename?: "Fleet";
    transactions: {
      __typename?: "FleetTransactionsConnection";
      totalCount: number;
      nodes: Array<{
        __typename?: "FleetTransaction";
        transactionTimestamp: any;
        amount: number;
        currency: string;
        action: TransactionAction;
        deductType?: ProviderDeductTransactionType | null;
        rechargeType?: ProviderRechargeTransactionType | null;
        refrenceNumber?: string | null;
        operatorId?: string | null;
        requestId?: string | null;
        description?: string | null;
      }>;
    };
    wallet: Array<{
      __typename?: "FleetWallet";
      currency: string;
      balance: number;
    }>;
  };
  regions: {
    __typename?: "RegionConnection";
    nodes: Array<{ __typename?: "Region"; currency: string }>;
  };
};

export type FleetZonePricesQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  paging?: InputMaybe<OffsetPaging>;
  filter?: InputMaybe<ZonePriceFilter>;
  sorting?: InputMaybe<Array<ZonePriceSort> | ZonePriceSort>;
}>;

export type FleetZonePricesQuery = {
  __typename?: "Query";
  fleet: {
    __typename?: "Fleet";
    zonePrices: {
      __typename?: "FleetZonePricesConnection";
      totalCount: number;
      nodes: Array<{ __typename?: "ZonePrice"; id: string; name: string }>;
    };
  };
};

export type FleetDriversQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  paging?: InputMaybe<OffsetPaging>;
}>;

export type FleetDriversQuery = {
  __typename?: "Query";
  drivers: {
    __typename?: "DriverConnection";
    nodes: Array<{
      __typename?: "Driver";
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      mobileNumber: string;
    }>;
  };
};

export type UpdateFleetMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  update: UpdateFleetInput;
}>;

export type UpdateFleetMutation = {
  __typename?: "Mutation";
  updateOneFleet: { __typename?: "Fleet"; id: string };
};

export type CreateFleetTransactionMutationVariables = Exact<{
  input: FleetTransactionInput;
}>;

export type CreateFleetTransactionMutation = {
  __typename?: "Mutation";
  createFleetTransaction: { __typename?: "FleetWallet"; id: string };
};

export type FleetsListQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
  filter?: InputMaybe<FleetFilter>;
}>;

export type FleetsListQuery = {
  __typename?: "Query";
  fleets: {
    __typename?: "FleetConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "Fleet";
      id: string;
      name: string;
      phoneNumber: string;
      address?: string | null;
    }>;
  };
};

export type OrderCancelReasonListQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;

export type OrderCancelReasonListQuery = {
  __typename?: "Query";
  orderCancelReasons: {
    __typename?: "OrderCancelReasonConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "OrderCancelReason";
      id: string;
      title: string;
      isEnabled: boolean;
      userType: AnnouncementUserType;
    }>;
  };
};

export type OrderCancelReasonViewQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type OrderCancelReasonViewQuery = {
  __typename?: "Query";
  orderCancelReason: {
    __typename?: "OrderCancelReason";
    id: string;
    title: string;
    userType: AnnouncementUserType;
    isEnabled: boolean;
  };
};

export type UpdateOrderCancelReasonMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  update: OrderCancelReasonInput;
}>;

export type UpdateOrderCancelReasonMutation = {
  __typename?: "Mutation";
  updateOneOrderCancelReason: { __typename?: "OrderCancelReason"; id: string };
};

export type CreateOrderCancelReasonMutationVariables = Exact<{
  input: OrderCancelReasonInput;
}>;

export type CreateOrderCancelReasonMutation = {
  __typename?: "Mutation";
  createOneOrderCancelReason: { __typename?: "OrderCancelReason"; id: string };
};

export type ViewPaymentGatewayQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewPaymentGatewayQuery = {
  __typename?: "Query";
  paymentGateway: {
    __typename?: "PaymentGateway";
    id: string;
    title: string;
    type: PaymentGatewayType;
    enabled: boolean;
    privateKey: string;
    publicKey?: string | null;
    merchantId?: string | null;
    saltKey?: string | null;
    mediaId?: string | null;
    media?: { __typename?: "Media"; address: string } | null;
  };
};

export type CreatePaymentGatewayMutationVariables = Exact<{
  input: CreatePaymentGatewayInput;
}>;

export type CreatePaymentGatewayMutation = {
  __typename?: "Mutation";
  createOnePaymentGateway: { __typename?: "PaymentGateway"; id: string };
};

export type UpdatePaymentGatewayMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: UpdatePaymentGatewayInput;
}>;

export type UpdatePaymentGatewayMutation = {
  __typename?: "Mutation";
  updateOnePaymentGateway: { __typename?: "PaymentGateway"; id: string };
};

export type PaymentGatewaysQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;

export type PaymentGatewaysQuery = {
  __typename?: "Query";
  paymentGateways: {
    __typename?: "PaymentGatewayConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "PaymentGateway";
      id: string;
      enabled: boolean;
      title: string;
      type: PaymentGatewayType;
      media?: { __typename?: "Media"; address: string } | null;
    }>;
  };
};

export type RegionListQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;

export type RegionListQuery = {
  __typename?: "Query";
  regions: {
    __typename?: "RegionConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "Region";
      id: string;
      name: string;
      currency: string;
      enabled: boolean;
      location: Array<
        Array<{ __typename?: "Point"; lat: number; lng: number }>
      >;
    }>;
  };
};

export type RegionViewQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type RegionViewQuery = {
  __typename?: "Query";
  region: {
    __typename?: "Region";
    id: string;
    name: string;
    currency: string;
    enabled: boolean;
    location: Array<Array<{ __typename?: "Point"; lat: number; lng: number }>>;
  };
};

export type UpdateRegionMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  update: UpdateRegionInput;
}>;

export type UpdateRegionMutation = {
  __typename?: "Mutation";
  updateOneRegion: { __typename?: "Region"; id: string };
};

export type CreateRegionMutationVariables = Exact<{
  input: CreateRegionInput;
}>;

export type CreateRegionMutation = {
  __typename?: "Mutation";
  createOneRegion: { __typename?: "Region"; id: string };
};

export type ReviewParameterViewQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ReviewParameterViewQuery = {
  __typename?: "Query";
  feedbackParameter: {
    __typename?: "FeedbackParameter";
    id: string;
    title: string;
    isGood: boolean;
  };
};

export type UpdateReviewParameterMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  update: FeedbackParameterInput;
}>;

export type UpdateReviewParameterMutation = {
  __typename?: "Mutation";
  updateOneFeedbackParameter: { __typename?: "FeedbackParameter"; id: string };
};

export type CreateReviewParameterMutationVariables = Exact<{
  input: FeedbackParameterInput;
}>;

export type CreateReviewParameterMutation = {
  __typename?: "Mutation";
  createOneFeedbackParameter: { __typename?: "FeedbackParameter"; id: string };
};

export type ReviewParametersListQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ReviewParametersListQuery = {
  __typename?: "Query";
  feedbackParameters: Array<{
    __typename?: "FeedbackParameter";
    id: string;
    title: string;
    isGood: boolean;
  }>;
};

export type RolesQueryVariables = Exact<{ [key: string]: never }>;

export type RolesQuery = {
  __typename?: "Query";
  operatorRoles: Array<{
    __typename?: "OperatorRole";
    id: string;
    title: string;
    systemType: OperatorRoleSystemType;
  }>;
};

export type RoleQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type RoleQuery = {
  __typename?: "Query";
  operatorRole: {
    __typename?: "OperatorRole";
    id: string;
    title: string;
    systemType: OperatorRoleSystemType;
    permissions: Array<OperatorPermission>;
  };
};

export type CreateRoleMutationVariables = Exact<{
  input: OperatorRoleInput;
}>;

export type CreateRoleMutation = {
  __typename?: "Mutation";
  createOneOperatorRole: {
    __typename?: "OperatorRole";
    id: string;
    title: string;
    systemType: OperatorRoleSystemType;
    permissions: Array<OperatorPermission>;
  };
};

export type UpdateRoleMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: OperatorRoleInput;
}>;

export type UpdateRoleMutation = {
  __typename?: "Mutation";
  updateOneOperatorRole: { __typename?: "OperatorRole"; id: string };
};

export type ServiceOptionViewQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ServiceOptionViewQuery = {
  __typename?: "Query";
  serviceOption: {
    __typename?: "ServiceOption";
    id: string;
    name: string;
    type: ServiceOptionType;
    icon: ServiceOptionIcon;
    additionalFee?: number | null;
  };
};

export type UpdateServiceOptionMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  update: ServiceOptionInput;
}>;

export type UpdateServiceOptionMutation = {
  __typename?: "Mutation";
  updateOneServiceOption: { __typename?: "ServiceOption"; id: string };
};

export type CreateServiceOptionMutationVariables = Exact<{
  input: ServiceOptionInput;
}>;

export type CreateServiceOptionMutation = {
  __typename?: "Mutation";
  createOneServiceOption: { __typename?: "ServiceOption"; id: string };
};

export type ServiceOptionsListQueryVariables = Exact<{ [key: string]: never }>;

export type ServiceOptionsListQuery = {
  __typename?: "Query";
  serviceOptions: Array<{
    __typename?: "ServiceOption";
    id: string;
    name: string;
    icon: ServiceOptionIcon;
    type: ServiceOptionType;
    additionalFee?: number | null;
  }>;
};

export type ServiceTariffViewQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ServiceTariffViewQuery = {
  __typename?: "Query";
  serviceTariffProfile: {
    __typename?: "ServiceTariffProfile";
    id: string;
    serviceId: string;
    tariffProfileId: string;
    baseFare?: number | null;
    minimumFee?: number | null;
    perKm?: number | null;
    perMinute?: number | null;
    perMinuteDrive?: number | null;
    perMinuteWait?: number | null;
    roundingFactor?: number | null;
    maxCalendarMultiplier?: number | null;
    searchRadius?: number | null;
    maximumDestinationDistance?: number | null;
    commissionRate?: number | null;
    timeMultipliers?: Array<{
      __typename?: "TariffTimeOfDayRule";
      label?: string | null;
      startTime: string;
      endTime: string;
      upliftPercentage: number;
      enabled: boolean;
    }> | null;
    weekdayMultipliers?: Array<{
      __typename?: "TariffWeekdayRule";
      weekday: Weekday;
      upliftPercentage: number;
      enabled: boolean;
    }> | null;
    dateRangeMultipliers?: Array<{
      __typename?: "TariffDateRangeRule";
      label?: string | null;
      startDateTime: string;
      endDateTime: string;
      upliftPercentage: number;
      enabled: boolean;
    }> | null;
  };
  services: Array<{ __typename?: "Service"; id: string; name: string }>;
  tariffProfiles: {
    __typename?: "TariffProfileConnection";
    nodes: Array<{
      __typename?: "TariffProfile";
      id: string;
      title: string;
      code: string;
    }>;
  };
};

export type ServiceTariffNewQueryVariables = Exact<{ [key: string]: never }>;

export type ServiceTariffNewQuery = {
  __typename?: "Query";
  services: Array<{ __typename?: "Service"; id: string; name: string }>;
  tariffProfiles: {
    __typename?: "TariffProfileConnection";
    nodes: Array<{
      __typename?: "TariffProfile";
      id: string;
      title: string;
      code: string;
    }>;
  };
};

export type CreateServiceTariffMutationVariables = Exact<{
  input: ServiceTariffProfileInput;
}>;

export type CreateServiceTariffMutation = {
  __typename?: "Mutation";
  createOneServiceTariffProfile: {
    __typename?: "ServiceTariffProfile";
    id: string;
  };
};

export type UpdateServiceTariffMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  update: ServiceTariffProfileInput;
}>;

export type UpdateServiceTariffMutation = {
  __typename?: "Mutation";
  updateOneServiceTariffProfile: {
    __typename?: "ServiceTariffProfile";
    id: string;
  };
};

export type DeleteServiceTariffMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteServiceTariffMutation = {
  __typename?: "Mutation";
  deleteOneServiceTariffProfile: {
    __typename?: "ServiceTariffProfileDeleteResponse";
    id?: string | null;
  };
};

export type ServiceTariffsListQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;

export type ServiceTariffsListQuery = {
  __typename?: "Query";
  serviceTariffProfiles: {
    __typename?: "ServiceTariffProfileConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "ServiceTariffProfile";
      id: string;
      minimumFee?: number | null;
      perKm?: number | null;
      perMinute?: number | null;
      service: { __typename?: "Service"; id: string; name: string };
      tariffProfile: {
        __typename?: "TariffProfile";
        id: string;
        title: string;
        code: string;
      };
    }>;
  };
};

export type ViewServiceCategoryQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewServiceCategoryQuery = {
  __typename?: "Query";
  serviceCategory: { __typename?: "ServiceCategory"; id: string; name: string };
};

export type CreateServiceCategoryMutationVariables = Exact<{
  input: ServiceCategoryInput;
}>;

export type CreateServiceCategoryMutation = {
  __typename?: "Mutation";
  createOneServiceCategory: { __typename?: "ServiceCategory"; id: string };
};

export type UpdateServiceCategoryMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: ServiceCategoryInput;
}>;

export type UpdateServiceCategoryMutation = {
  __typename?: "Mutation";
  updateOneServiceCategory: { __typename?: "ServiceCategory"; id: string };
};

export type DeleteServiceCategoryMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteServiceCategoryMutation = {
  __typename?: "Mutation";
  deleteOneServiceCategory: {
    __typename?: "ServiceCategoryDeleteResponse";
    id?: string | null;
  };
};

export type ServicesListQueryVariables = Exact<{ [key: string]: never }>;

export type ServicesListQuery = {
  __typename?: "Query";
  serviceCategories: Array<{
    __typename?: "ServiceCategory";
    id: string;
    name: string;
    services: Array<{
      __typename?: "Service";
      id: string;
      name: string;
      description?: string | null;
      isDefaultDispatchService: boolean;
      media: { __typename?: "Media"; address: string };
    }>;
  }>;
};

export type ViewServiceQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewServiceQuery = {
  __typename?: "Query";
  service: {
    __typename?: "Service";
    id: string;
    name: string;
    isDefaultDispatchService: boolean;
    categoryId: string;
    baseFare: number;
    perHundredMeters: number;
    perMinuteDrive: number;
    perMinuteWait: number;
    minimumFee: number;
    searchRadius: number;
    maximumDestinationDistance: number;
    paymentMethod: ServicePaymentMethod;
    cancellationTotalFee: number;
    cancellationDriverShare: number;
    providerShareFlat: number;
    providerSharePercent: number;
    prepayPercent: number;
    mediaId: string;
    description?: string | null;
    personCapacity?: number | null;
    roundingFactor?: number | null;
    media: { __typename?: "Media"; address: string };
    timeMultipliers: Array<{
      __typename?: "TimeMultiplier";
      startTime: string;
      endTime: string;
      multiply: number;
    }>;
    distanceMultipliers: Array<{
      __typename?: "DistanceMultiplier";
      distanceFrom: number;
      distanceTo: number;
      multiply: number;
    }>;
    weekdayMultipliers: Array<{
      __typename?: "WeekdayMultiplier";
      weekday: Weekday;
      multiply: number;
    }>;
    dateRangeMultipliers: Array<{
      __typename?: "DateRangeMultiplier";
      startDate: number;
      endDate: number;
      multiply: number;
    }>;
    options: Array<{
      __typename?: "ServiceOption";
      id: string;
      name: string;
      type: ServiceOptionType;
      additionalFee?: number | null;
      icon: ServiceOptionIcon;
    }>;
    regions: Array<{
      __typename?: "Region";
      id: string;
      name: string;
      currency: string;
    }>;
  };
  regions: {
    __typename?: "RegionConnection";
    nodes: Array<{
      __typename?: "Region";
      id: string;
      name: string;
      currency: string;
    }>;
  };
  serviceCategories: Array<{
    __typename?: "ServiceCategory";
    id: string;
    name: string;
  }>;
  serviceOptions: Array<{
    __typename?: "ServiceOption";
    id: string;
    name: string;
    icon: ServiceOptionIcon;
    type: ServiceOptionType;
    additionalFee?: number | null;
  }>;
};

export type NewServiceQueryVariables = Exact<{ [key: string]: never }>;

export type NewServiceQuery = {
  __typename?: "Query";
  regions: {
    __typename?: "RegionConnection";
    nodes: Array<{
      __typename?: "Region";
      id: string;
      name: string;
      currency: string;
    }>;
  };
  serviceCategories: Array<{
    __typename?: "ServiceCategory";
    id: string;
    name: string;
  }>;
  serviceOptions: Array<{
    __typename?: "ServiceOption";
    id: string;
    name: string;
    icon: ServiceOptionIcon;
    type: ServiceOptionType;
    additionalFee?: number | null;
  }>;
};

export type CreateServiceMutationVariables = Exact<{
  input: ServiceInput;
}>;

export type CreateServiceMutation = {
  __typename?: "Mutation";
  createOneService: { __typename?: "Service"; id: string };
};

export type DeleteServiceMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteServiceMutation = {
  __typename?: "Mutation";
  deleteOneService: {
    __typename?: "ServiceDeleteResponse";
    id?: string | null;
  };
};

export type UpdateServiceMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: ServiceInput;
}>;

export type UpdateServiceMutation = {
  __typename?: "Mutation";
  updateOneService: { __typename?: "Service"; id: string };
};

export type SetRegionsOnServiceMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  relationIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type SetRegionsOnServiceMutation = {
  __typename?: "Mutation";
  setRegionsOnService: { __typename?: "Service"; id: string };
};

export type SetOptionsOnServiceMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  relationIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type SetOptionsOnServiceMutation = {
  __typename?: "Mutation";
  setOptionsOnService: { __typename?: "Service"; id: string };
};

export type DispatchSettingsConfigFragment = {
  __typename: "DispatchConfig";
  strategy: DispatchStrategy;
  requestTimeoutSeconds: number;
  maxSearchRadiusMeters: number;
  preDispatchBufferMinutes?: number | null;
  notifyAdminOnFailure?: boolean | null;
  scoring?: {
    __typename?: "DriverScoringConfig";
    distanceWeight: number;
    driverRatingWeight: number;
    idleTimeWeight: number;
    cancelRateWeight: number;
    threshold?: number | null;
    topN?: number | null;
  } | null;
  sequentialConfig?: {
    __typename?: "SequentialConfig";
    perDriverTimeoutSeconds: number;
    avoidPreviousCandidates: boolean;
    driverRetryLimit: number;
    maxDriversToTest?: number | null;
  } | null;
  broadcastConfig?: {
    __typename?: "BroadcastConfig";
    waveSize: number;
    waveIntervalSeconds: number;
    maxWaves: number;
    finalResponseWindowSeconds?: number | null;
    radiusIncrementMeters?: number | null;
  } | null;
  radiusExpansion?: {
    __typename?: "RadiusExpansionConfig";
    enabled: boolean;
    stepMeters: number;
    intervalSeconds: number;
    maxSteps: number;
  } | null;
  fallback?: {
    __typename?: "FallbackConfig";
    fallbackEnabled: boolean;
    fallbackStrategy: DispatchStrategy;
    fallbackScoring?: {
      __typename?: "DriverScoringConfig";
      distanceWeight: number;
      driverRatingWeight: number;
      idleTimeWeight: number;
      cancelRateWeight: number;
      threshold?: number | null;
      topN?: number | null;
    } | null;
  } | null;
  schedule?: {
    __typename?: "ScheduleConfig";
    minimumLeadMinutes: number;
    driverSafetyBufferMinutes: number;
    driverHardBlockMinutes: number;
    adminWarningMinutes: number;
    urgentWarningMinutes: number;
    emergencyFallbackMinutes: number;
    emergencyAutoDispatchEnabled: boolean;
  } | null;
  nextAvailable?: {
    __typename?: "NextAvailableConfig";
    enabled: boolean;
    manualBusyDriverReservationEnabled?: boolean | null;
    maxPickupDistanceKm: number;
    maxEtaMinutes: number;
    candidateLimit: number;
    holdMinutes: number;
    recomputeAttempts: number;
    softGraceSeconds?: number | null;
    operationalBufferSeconds?: number | null;
    renewalRetrySeconds?: number | null;
    manualHardMaxSeconds?: number | null;
    reconcileIntervalSeconds?: number | null;
    redisRecoveryBufferSeconds?: number | null;
    operationCenterPhoneNumber?: string | null;
  } | null;
};

export type DispatchSettingsPolicyFragment = {
  __typename: "DispatchPolicy";
  version: number;
  fingerprint: string;
  updatedAt?: string | null;
  updatedBy?: number | null;
  automation: {
    __typename?: "DispatchAutomationOptions";
    enabled: boolean;
    candidateSearchLimit: number;
    initialRadiusMeters: number;
  };
  configuration: {
    __typename: "DispatchConfig";
    strategy: DispatchStrategy;
    requestTimeoutSeconds: number;
    maxSearchRadiusMeters: number;
    preDispatchBufferMinutes?: number | null;
    notifyAdminOnFailure?: boolean | null;
    scoring?: {
      __typename?: "DriverScoringConfig";
      distanceWeight: number;
      driverRatingWeight: number;
      idleTimeWeight: number;
      cancelRateWeight: number;
      threshold?: number | null;
      topN?: number | null;
    } | null;
    sequentialConfig?: {
      __typename?: "SequentialConfig";
      perDriverTimeoutSeconds: number;
      avoidPreviousCandidates: boolean;
      driverRetryLimit: number;
      maxDriversToTest?: number | null;
    } | null;
    broadcastConfig?: {
      __typename?: "BroadcastConfig";
      waveSize: number;
      waveIntervalSeconds: number;
      maxWaves: number;
      finalResponseWindowSeconds?: number | null;
      radiusIncrementMeters?: number | null;
    } | null;
    radiusExpansion?: {
      __typename?: "RadiusExpansionConfig";
      enabled: boolean;
      stepMeters: number;
      intervalSeconds: number;
      maxSteps: number;
    } | null;
    fallback?: {
      __typename?: "FallbackConfig";
      fallbackEnabled: boolean;
      fallbackStrategy: DispatchStrategy;
      fallbackScoring?: {
        __typename?: "DriverScoringConfig";
        distanceWeight: number;
        driverRatingWeight: number;
        idleTimeWeight: number;
        cancelRateWeight: number;
        threshold?: number | null;
        topN?: number | null;
      } | null;
    } | null;
    schedule?: {
      __typename?: "ScheduleConfig";
      minimumLeadMinutes: number;
      driverSafetyBufferMinutes: number;
      driverHardBlockMinutes: number;
      adminWarningMinutes: number;
      urgentWarningMinutes: number;
      emergencyFallbackMinutes: number;
      emergencyAutoDispatchEnabled: boolean;
    } | null;
    nextAvailable?: {
      __typename?: "NextAvailableConfig";
      enabled: boolean;
      manualBusyDriverReservationEnabled?: boolean | null;
      maxPickupDistanceKm: number;
      maxEtaMinutes: number;
      candidateLimit: number;
      holdMinutes: number;
      recomputeAttempts: number;
      softGraceSeconds?: number | null;
      operationalBufferSeconds?: number | null;
      renewalRetrySeconds?: number | null;
      manualHardMaxSeconds?: number | null;
      reconcileIntervalSeconds?: number | null;
      redisRecoveryBufferSeconds?: number | null;
      operationCenterPhoneNumber?: string | null;
    } | null;
  };
  nextAvailableRuntime: Array<{
    __typename?: "DispatchNextAvailableRuntimeField";
    field: string;
    value: number;
    overridden: boolean;
    invalidOverride: boolean;
  }>;
};

export type DispatchAutomationSettingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type DispatchAutomationSettingsQuery = {
  __typename?: "Query";
  dispatchPolicy: {
    __typename: "DispatchPolicy";
    version: number;
    fingerprint: string;
    updatedAt?: string | null;
    updatedBy?: number | null;
    automation: {
      __typename?: "DispatchAutomationOptions";
      enabled: boolean;
      candidateSearchLimit: number;
      initialRadiusMeters: number;
    };
    configuration: {
      __typename: "DispatchConfig";
      strategy: DispatchStrategy;
      requestTimeoutSeconds: number;
      maxSearchRadiusMeters: number;
      preDispatchBufferMinutes?: number | null;
      notifyAdminOnFailure?: boolean | null;
      scoring?: {
        __typename?: "DriverScoringConfig";
        distanceWeight: number;
        driverRatingWeight: number;
        idleTimeWeight: number;
        cancelRateWeight: number;
        threshold?: number | null;
        topN?: number | null;
      } | null;
      sequentialConfig?: {
        __typename?: "SequentialConfig";
        perDriverTimeoutSeconds: number;
        avoidPreviousCandidates: boolean;
        driverRetryLimit: number;
        maxDriversToTest?: number | null;
      } | null;
      broadcastConfig?: {
        __typename?: "BroadcastConfig";
        waveSize: number;
        waveIntervalSeconds: number;
        maxWaves: number;
        finalResponseWindowSeconds?: number | null;
        radiusIncrementMeters?: number | null;
      } | null;
      radiusExpansion?: {
        __typename?: "RadiusExpansionConfig";
        enabled: boolean;
        stepMeters: number;
        intervalSeconds: number;
        maxSteps: number;
      } | null;
      fallback?: {
        __typename?: "FallbackConfig";
        fallbackEnabled: boolean;
        fallbackStrategy: DispatchStrategy;
        fallbackScoring?: {
          __typename?: "DriverScoringConfig";
          distanceWeight: number;
          driverRatingWeight: number;
          idleTimeWeight: number;
          cancelRateWeight: number;
          threshold?: number | null;
          topN?: number | null;
        } | null;
      } | null;
      schedule?: {
        __typename?: "ScheduleConfig";
        minimumLeadMinutes: number;
        driverSafetyBufferMinutes: number;
        driverHardBlockMinutes: number;
        adminWarningMinutes: number;
        urgentWarningMinutes: number;
        emergencyFallbackMinutes: number;
        emergencyAutoDispatchEnabled: boolean;
      } | null;
      nextAvailable?: {
        __typename?: "NextAvailableConfig";
        enabled: boolean;
        manualBusyDriverReservationEnabled?: boolean | null;
        maxPickupDistanceKm: number;
        maxEtaMinutes: number;
        candidateLimit: number;
        holdMinutes: number;
        recomputeAttempts: number;
        softGraceSeconds?: number | null;
        operationalBufferSeconds?: number | null;
        renewalRetrySeconds?: number | null;
        manualHardMaxSeconds?: number | null;
        reconcileIntervalSeconds?: number | null;
        redisRecoveryBufferSeconds?: number | null;
        operationCenterPhoneNumber?: string | null;
      } | null;
    };
    nextAvailableRuntime: Array<{
      __typename?: "DispatchNextAvailableRuntimeField";
      field: string;
      value: number;
      overridden: boolean;
      invalidOverride: boolean;
    }>;
  };
};

export type DispatchAutomationHistoryQueryVariables = Exact<{
  beforeVersion?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type DispatchAutomationHistoryQuery = {
  __typename?: "Query";
  dispatchPolicyHistory: Array<{
    __typename?: "DispatchPolicyRevision";
    version: number;
    actorOperatorId: number;
    reason: string;
    changedAt: any;
    previousValues: {
      __typename?: "DispatchPolicyValues";
      automation: {
        __typename?: "DispatchAutomationOptions";
        enabled: boolean;
        candidateSearchLimit: number;
        initialRadiusMeters: number;
      };
      configuration: {
        __typename: "DispatchConfig";
        strategy: DispatchStrategy;
        requestTimeoutSeconds: number;
        maxSearchRadiusMeters: number;
        preDispatchBufferMinutes?: number | null;
        notifyAdminOnFailure?: boolean | null;
        scoring?: {
          __typename?: "DriverScoringConfig";
          distanceWeight: number;
          driverRatingWeight: number;
          idleTimeWeight: number;
          cancelRateWeight: number;
          threshold?: number | null;
          topN?: number | null;
        } | null;
        sequentialConfig?: {
          __typename?: "SequentialConfig";
          perDriverTimeoutSeconds: number;
          avoidPreviousCandidates: boolean;
          driverRetryLimit: number;
          maxDriversToTest?: number | null;
        } | null;
        broadcastConfig?: {
          __typename?: "BroadcastConfig";
          waveSize: number;
          waveIntervalSeconds: number;
          maxWaves: number;
          finalResponseWindowSeconds?: number | null;
          radiusIncrementMeters?: number | null;
        } | null;
        radiusExpansion?: {
          __typename?: "RadiusExpansionConfig";
          enabled: boolean;
          stepMeters: number;
          intervalSeconds: number;
          maxSteps: number;
        } | null;
        fallback?: {
          __typename?: "FallbackConfig";
          fallbackEnabled: boolean;
          fallbackStrategy: DispatchStrategy;
          fallbackScoring?: {
            __typename?: "DriverScoringConfig";
            distanceWeight: number;
            driverRatingWeight: number;
            idleTimeWeight: number;
            cancelRateWeight: number;
            threshold?: number | null;
            topN?: number | null;
          } | null;
        } | null;
        schedule?: {
          __typename?: "ScheduleConfig";
          minimumLeadMinutes: number;
          driverSafetyBufferMinutes: number;
          driverHardBlockMinutes: number;
          adminWarningMinutes: number;
          urgentWarningMinutes: number;
          emergencyFallbackMinutes: number;
          emergencyAutoDispatchEnabled: boolean;
        } | null;
        nextAvailable?: {
          __typename?: "NextAvailableConfig";
          enabled: boolean;
          manualBusyDriverReservationEnabled?: boolean | null;
          maxPickupDistanceKm: number;
          maxEtaMinutes: number;
          candidateLimit: number;
          holdMinutes: number;
          recomputeAttempts: number;
          softGraceSeconds?: number | null;
          operationalBufferSeconds?: number | null;
          renewalRetrySeconds?: number | null;
          manualHardMaxSeconds?: number | null;
          reconcileIntervalSeconds?: number | null;
          redisRecoveryBufferSeconds?: number | null;
          operationCenterPhoneNumber?: string | null;
        } | null;
      };
    };
    newValues: {
      __typename?: "DispatchPolicyValues";
      automation: {
        __typename?: "DispatchAutomationOptions";
        enabled: boolean;
        candidateSearchLimit: number;
        initialRadiusMeters: number;
      };
      configuration: {
        __typename: "DispatchConfig";
        strategy: DispatchStrategy;
        requestTimeoutSeconds: number;
        maxSearchRadiusMeters: number;
        preDispatchBufferMinutes?: number | null;
        notifyAdminOnFailure?: boolean | null;
        scoring?: {
          __typename?: "DriverScoringConfig";
          distanceWeight: number;
          driverRatingWeight: number;
          idleTimeWeight: number;
          cancelRateWeight: number;
          threshold?: number | null;
          topN?: number | null;
        } | null;
        sequentialConfig?: {
          __typename?: "SequentialConfig";
          perDriverTimeoutSeconds: number;
          avoidPreviousCandidates: boolean;
          driverRetryLimit: number;
          maxDriversToTest?: number | null;
        } | null;
        broadcastConfig?: {
          __typename?: "BroadcastConfig";
          waveSize: number;
          waveIntervalSeconds: number;
          maxWaves: number;
          finalResponseWindowSeconds?: number | null;
          radiusIncrementMeters?: number | null;
        } | null;
        radiusExpansion?: {
          __typename?: "RadiusExpansionConfig";
          enabled: boolean;
          stepMeters: number;
          intervalSeconds: number;
          maxSteps: number;
        } | null;
        fallback?: {
          __typename?: "FallbackConfig";
          fallbackEnabled: boolean;
          fallbackStrategy: DispatchStrategy;
          fallbackScoring?: {
            __typename?: "DriverScoringConfig";
            distanceWeight: number;
            driverRatingWeight: number;
            idleTimeWeight: number;
            cancelRateWeight: number;
            threshold?: number | null;
            topN?: number | null;
          } | null;
        } | null;
        schedule?: {
          __typename?: "ScheduleConfig";
          minimumLeadMinutes: number;
          driverSafetyBufferMinutes: number;
          driverHardBlockMinutes: number;
          adminWarningMinutes: number;
          urgentWarningMinutes: number;
          emergencyFallbackMinutes: number;
          emergencyAutoDispatchEnabled: boolean;
        } | null;
        nextAvailable?: {
          __typename?: "NextAvailableConfig";
          enabled: boolean;
          manualBusyDriverReservationEnabled?: boolean | null;
          maxPickupDistanceKm: number;
          maxEtaMinutes: number;
          candidateLimit: number;
          holdMinutes: number;
          recomputeAttempts: number;
          softGraceSeconds?: number | null;
          operationalBufferSeconds?: number | null;
          renewalRetrySeconds?: number | null;
          manualHardMaxSeconds?: number | null;
          reconcileIntervalSeconds?: number | null;
          redisRecoveryBufferSeconds?: number | null;
          operationCenterPhoneNumber?: string | null;
        } | null;
      };
    };
  }>;
};

export type SaveDispatchAutomationMutationVariables = Exact<{
  input: UpdateDispatchPolicyInput;
}>;

export type SaveDispatchAutomationMutation = {
  __typename?: "Mutation";
  updateDispatchPolicy: {
    __typename: "DispatchPolicy";
    version: number;
    fingerprint: string;
    updatedAt?: string | null;
    updatedBy?: number | null;
    automation: {
      __typename?: "DispatchAutomationOptions";
      enabled: boolean;
      candidateSearchLimit: number;
      initialRadiusMeters: number;
    };
    configuration: {
      __typename: "DispatchConfig";
      strategy: DispatchStrategy;
      requestTimeoutSeconds: number;
      maxSearchRadiusMeters: number;
      preDispatchBufferMinutes?: number | null;
      notifyAdminOnFailure?: boolean | null;
      scoring?: {
        __typename?: "DriverScoringConfig";
        distanceWeight: number;
        driverRatingWeight: number;
        idleTimeWeight: number;
        cancelRateWeight: number;
        threshold?: number | null;
        topN?: number | null;
      } | null;
      sequentialConfig?: {
        __typename?: "SequentialConfig";
        perDriverTimeoutSeconds: number;
        avoidPreviousCandidates: boolean;
        driverRetryLimit: number;
        maxDriversToTest?: number | null;
      } | null;
      broadcastConfig?: {
        __typename?: "BroadcastConfig";
        waveSize: number;
        waveIntervalSeconds: number;
        maxWaves: number;
        finalResponseWindowSeconds?: number | null;
        radiusIncrementMeters?: number | null;
      } | null;
      radiusExpansion?: {
        __typename?: "RadiusExpansionConfig";
        enabled: boolean;
        stepMeters: number;
        intervalSeconds: number;
        maxSteps: number;
      } | null;
      fallback?: {
        __typename?: "FallbackConfig";
        fallbackEnabled: boolean;
        fallbackStrategy: DispatchStrategy;
        fallbackScoring?: {
          __typename?: "DriverScoringConfig";
          distanceWeight: number;
          driverRatingWeight: number;
          idleTimeWeight: number;
          cancelRateWeight: number;
          threshold?: number | null;
          topN?: number | null;
        } | null;
      } | null;
      schedule?: {
        __typename?: "ScheduleConfig";
        minimumLeadMinutes: number;
        driverSafetyBufferMinutes: number;
        driverHardBlockMinutes: number;
        adminWarningMinutes: number;
        urgentWarningMinutes: number;
        emergencyFallbackMinutes: number;
        emergencyAutoDispatchEnabled: boolean;
      } | null;
      nextAvailable?: {
        __typename?: "NextAvailableConfig";
        enabled: boolean;
        manualBusyDriverReservationEnabled?: boolean | null;
        maxPickupDistanceKm: number;
        maxEtaMinutes: number;
        candidateLimit: number;
        holdMinutes: number;
        recomputeAttempts: number;
        softGraceSeconds?: number | null;
        operationalBufferSeconds?: number | null;
        renewalRetrySeconds?: number | null;
        manualHardMaxSeconds?: number | null;
        reconcileIntervalSeconds?: number | null;
        redisRecoveryBufferSeconds?: number | null;
        operationCenterPhoneNumber?: string | null;
      } | null;
    };
    nextAvailableRuntime: Array<{
      __typename?: "DispatchNextAvailableRuntimeField";
      field: string;
      value: number;
      overridden: boolean;
      invalidOverride: boolean;
    }>;
  };
};

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;

export type UpdatePasswordMutation = {
  __typename?: "Mutation";
  updatePassword: { __typename?: "Operator"; id: string };
};

export type GetConfigurationQueryVariables = Exact<{ [key: string]: never }>;

export type GetConfigurationQuery = {
  __typename?: "Query";
  currentConfiguration: {
    __typename?: "CurrentConfiguration";
    backendMapsAPIKey?: string | null;
    adminPanelAPIKey?: string | null;
    adminPanelMapId?: string | null;
  };
  fixedFareRoutingSettings: {
    __typename?: "FixedFareRoutingSettings";
    success: boolean;
    mode: FixedFareRoutingMode;
    ignoreLiveTraffic: boolean;
    recommendedMode: FixedFareRoutingMode;
    version: number;
    updatedAt?: string | null;
    updatedByName?: string | null;
    configurationWarning?: string | null;
    message?: string | null;
  };
};

export type UpdateConfigMutationVariables = Exact<{
  input: UpdateConfigInput;
}>;

export type UpdateConfigMutation = {
  __typename?: "Mutation";
  saveConfiguration: {
    __typename?: "CurrentConfiguration";
    backendMapsAPIKey?: string | null;
    adminPanelAPIKey?: string | null;
    adminPanelMapId?: string | null;
  };
};

export type UpdateFixedFareRoutingModeMutationVariables = Exact<{
  input: UpdateFixedFareRoutingModeInput;
}>;

export type UpdateFixedFareRoutingModeMutation = {
  __typename?: "Mutation";
  updateFixedFareRoutingMode: {
    __typename?: "FixedFareRoutingSettings";
    success: boolean;
    mode: FixedFareRoutingMode;
    ignoreLiveTraffic: boolean;
    recommendedMode: FixedFareRoutingMode;
    version: number;
    updatedAt?: string | null;
    updatedByName?: string | null;
    configurationWarning?: string | null;
    message?: string | null;
  };
};

export type RiderWhatsAppSettingsFieldsFragment = {
  __typename?: "RiderWhatsAppSettings";
  version: number;
  enabled: boolean;
  tokenConfigured: boolean;
  encryptionReady: boolean;
  validatedAt?: string | null;
  validationCode?: string | null;
  activationBlockers: Array<string>;
  embeddedSignupAvailable: boolean;
  embeddedSignupBlockers: Array<string>;
  tokenExpiresAt?: string | null;
  configuration?: {
    __typename?: "RiderWhatsAppBusinessConfiguration";
    businessAccountId: string;
    phoneNumberId: string;
    apiVersion: string;
    template: string;
    language: string;
  } | null;
};

export type RiderWhatsAppConfigurationQueryVariables = Exact<{
  [key: string]: never;
}>;

export type RiderWhatsAppConfigurationQuery = {
  __typename?: "Query";
  riderWhatsAppSettings: {
    __typename?: "RiderWhatsAppSettings";
    version: number;
    enabled: boolean;
    tokenConfigured: boolean;
    encryptionReady: boolean;
    validatedAt?: string | null;
    validationCode?: string | null;
    activationBlockers: Array<string>;
    embeddedSignupAvailable: boolean;
    embeddedSignupBlockers: Array<string>;
    tokenExpiresAt?: string | null;
    configuration?: {
      __typename?: "RiderWhatsAppBusinessConfiguration";
      businessAccountId: string;
      phoneNumberId: string;
      apiVersion: string;
      template: string;
      language: string;
    } | null;
  };
};

export type SaveRiderWhatsAppConfigurationMutationVariables = Exact<{
  input: SaveRiderWhatsAppSettingsInput;
}>;

export type SaveRiderWhatsAppConfigurationMutation = {
  __typename?: "Mutation";
  saveRiderWhatsAppSettings: {
    __typename?: "RiderWhatsAppSettings";
    version: number;
    enabled: boolean;
    tokenConfigured: boolean;
    encryptionReady: boolean;
    validatedAt?: string | null;
    validationCode?: string | null;
    activationBlockers: Array<string>;
    embeddedSignupAvailable: boolean;
    embeddedSignupBlockers: Array<string>;
    tokenExpiresAt?: string | null;
    configuration?: {
      __typename?: "RiderWhatsAppBusinessConfiguration";
      businessAccountId: string;
      phoneNumberId: string;
      apiVersion: string;
      template: string;
      language: string;
    } | null;
  };
};

export type CheckRiderWhatsAppConfigurationMutationVariables = Exact<{
  expectedVersion: Scalars["Int"]["input"];
}>;

export type CheckRiderWhatsAppConfigurationMutation = {
  __typename?: "Mutation";
  validateRiderWhatsAppSettings: {
    __typename?: "RiderWhatsAppSettings";
    version: number;
    enabled: boolean;
    tokenConfigured: boolean;
    encryptionReady: boolean;
    validatedAt?: string | null;
    validationCode?: string | null;
    activationBlockers: Array<string>;
    embeddedSignupAvailable: boolean;
    embeddedSignupBlockers: Array<string>;
    tokenExpiresAt?: string | null;
    configuration?: {
      __typename?: "RiderWhatsAppBusinessConfiguration";
      businessAccountId: string;
      phoneNumberId: string;
      apiVersion: string;
      template: string;
      language: string;
    } | null;
  };
};

export type ActivateRiderWhatsAppConfigurationMutationVariables = Exact<{
  input: SetRiderWhatsAppEnabledInput;
}>;

export type ActivateRiderWhatsAppConfigurationMutation = {
  __typename?: "Mutation";
  setRiderWhatsAppEnabled: {
    __typename?: "RiderWhatsAppSettings";
    version: number;
    enabled: boolean;
    tokenConfigured: boolean;
    encryptionReady: boolean;
    validatedAt?: string | null;
    validationCode?: string | null;
    activationBlockers: Array<string>;
    embeddedSignupAvailable: boolean;
    embeddedSignupBlockers: Array<string>;
    tokenExpiresAt?: string | null;
    configuration?: {
      __typename?: "RiderWhatsAppBusinessConfiguration";
      businessAccountId: string;
      phoneNumberId: string;
      apiVersion: string;
      template: string;
      language: string;
    } | null;
  };
};

export type DisconnectRiderWhatsAppConfigurationMutationVariables = Exact<{
  expectedVersion: Scalars["Int"]["input"];
}>;

export type DisconnectRiderWhatsAppConfigurationMutation = {
  __typename?: "Mutation";
  disconnectRiderWhatsApp: {
    __typename?: "RiderWhatsAppSettings";
    version: number;
    enabled: boolean;
    tokenConfigured: boolean;
    encryptionReady: boolean;
    validatedAt?: string | null;
    validationCode?: string | null;
    activationBlockers: Array<string>;
    embeddedSignupAvailable: boolean;
    embeddedSignupBlockers: Array<string>;
    tokenExpiresAt?: string | null;
    configuration?: {
      __typename?: "RiderWhatsAppBusinessConfiguration";
      businessAccountId: string;
      phoneNumberId: string;
      apiVersion: string;
      template: string;
      language: string;
    } | null;
  };
};

export type BeginRiderWhatsAppConnectionMutationVariables = Exact<{
  expectedVersion: Scalars["Int"]["input"];
}>;

export type BeginRiderWhatsAppConnectionMutation = {
  __typename?: "Mutation";
  beginRiderWhatsAppSignup: {
    __typename?: "RiderWhatsAppSignupSession";
    nonce: string;
    expiresAt: string;
    appId: string;
    configId: string;
    apiVersion: string;
    origin: string;
  };
};

export type ExchangeRiderWhatsAppConnectionMutationVariables = Exact<{
  nonce: Scalars["String"]["input"];
  code: Scalars["String"]["input"];
}>;

export type ExchangeRiderWhatsAppConnectionMutation = {
  __typename?: "Mutation";
  exchangeRiderWhatsAppSignup: Array<string>;
};

export type RiderWhatsAppConnectionPhonesMutationVariables = Exact<{
  nonce: Scalars["String"]["input"];
  businessAccountId: Scalars["String"]["input"];
}>;

export type RiderWhatsAppConnectionPhonesMutation = {
  __typename?: "Mutation";
  riderWhatsAppSignupPhones: Array<{
    __typename?: "RiderWhatsAppSignupPhone";
    id: string;
    displayNumber: string;
    verifiedName: string;
  }>;
};

export type CompleteRiderWhatsAppConnectionMutationVariables = Exact<{
  nonce: Scalars["String"]["input"];
  phoneNumberId: Scalars["String"]["input"];
  template: Scalars["String"]["input"];
  language: Scalars["String"]["input"];
}>;

export type CompleteRiderWhatsAppConnectionMutation = {
  __typename?: "Mutation";
  completeRiderWhatsAppSignup: boolean;
};

export type CancelRiderWhatsAppConnectionMutationVariables = Exact<{
  nonce: Scalars["String"]["input"];
}>;

export type CancelRiderWhatsAppConnectionMutation = {
  __typename?: "Mutation";
  cancelRiderWhatsAppSignup: boolean;
};

export type SmsProvidersQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;

export type SmsProvidersQuery = {
  __typename?: "Query";
  smsProviders: {
    __typename?: "SMSProviderConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "SMSProvider";
      id: string;
      isDefault: boolean;
      name: string;
      type: SmsProviderType;
    }>;
  };
};

export type ViewSmsProviderQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewSmsProviderQuery = {
  __typename?: "Query";
  smsProvider: {
    __typename?: "SMSProvider";
    id: string;
    name: string;
    type: SmsProviderType;
    isDefault: boolean;
    authToken?: string | null;
    accountId: string;
    fromNumber?: string | null;
    verificationTemplate?: string | null;
    smsType?: string | null;
  };
};

export type CreateSmsProviderMutationVariables = Exact<{
  input: SmsProviderInput;
}>;

export type CreateSmsProviderMutation = {
  __typename?: "Mutation";
  createOneSMSProvider: { __typename?: "SMSProvider"; id: string };
};

export type UpdateSmsProviderMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: SmsProviderInput;
}>;

export type UpdateSmsProviderMutation = {
  __typename?: "Mutation";
  updateOneSMSProvider: { __typename?: "SMSProvider"; id: string };
};

export type MarkSmsProviderAsDefaultMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type MarkSmsProviderAsDefaultMutation = {
  __typename?: "Mutation";
  markSMSProviderAsDefault: { __typename?: "SMSProvider"; id: string };
};

export type TariffProfileViewQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type TariffProfileViewQuery = {
  __typename?: "Query";
  tariffProfile: {
    __typename?: "TariffProfile";
    id: string;
    code: string;
    title: string;
    description?: string | null;
    isDefault: boolean;
    isActive: boolean;
  };
};

export type TariffProfileNewQueryVariables = Exact<{ [key: string]: never }>;

export type TariffProfileNewQuery = {
  __typename?: "Query";
  tariffProfiles: {
    __typename?: "TariffProfileConnection";
    nodes: Array<{ __typename?: "TariffProfile"; id: string }>;
  };
};

export type CreateTariffProfileMutationVariables = Exact<{
  input: TariffProfileInput;
}>;

export type CreateTariffProfileMutation = {
  __typename?: "Mutation";
  createOneTariffProfile: { __typename?: "TariffProfile"; id: string };
};

export type UpdateTariffProfileMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  update: TariffProfileInput;
}>;

export type UpdateTariffProfileMutation = {
  __typename?: "Mutation";
  updateOneTariffProfile: { __typename?: "TariffProfile"; id: string };
};

export type DeleteTariffProfileMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteTariffProfileMutation = {
  __typename?: "Mutation";
  deleteOneTariffProfile: {
    __typename?: "TariffProfileDeleteResponse";
    id?: string | null;
  };
};

export type TariffProfilesListQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;

export type TariffProfilesListQuery = {
  __typename?: "Query";
  tariffProfiles: {
    __typename?: "TariffProfileConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "TariffProfile";
      id: string;
      code: string;
      title: string;
      isDefault: boolean;
      isActive: boolean;
    }>;
  };
};

export type TelematicsFeatureStateQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TelematicsFeatureStateQuery = {
  __typename?: "Query";
  telematicsFeatureState: {
    __typename?: "TelematicsFeatureState";
    configurationEnabled: boolean;
    liveSyncEnabled: boolean;
    historySyncEnabled: boolean;
    integrityAlertsEnabled: boolean;
    operatorLiveViewEnabled: boolean;
    retentionDays: number;
  };
};

export type TelematicsSettingsPageQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TelematicsSettingsPageQuery = {
  __typename?: "Query";
  telematicsProviderSettings: Array<{
    __typename?: "TelematicsProviderSetting";
    id: string;
    provider: TelematicsProvider;
    displayName: string;
    enabled: boolean;
    baseUrl: string;
    applicationId: number;
    tokenConfigured: boolean;
    providerTimeZone: string;
    retentionDays: number;
    createdAt: any;
    updatedAt: any;
    deactivatedAt?: any | null;
    lastSuccessAt?: any | null;
    lastError?: string | null;
  }>;
};

export type TelematicsRuntimeValuesFieldsFragment = {
  __typename: "TelematicsRuntimePolicyValues";
  configurationActionsEnabled: boolean;
  liveSyncEnabled: boolean;
  signalEngineEnabled: boolean;
  shadowCorrelationEnabled: boolean;
  historySyncEnabled: boolean;
  automaticHistoryReconciliationEnabled: boolean;
  adminLiveViewEnabled: boolean;
  operatorLiveViewEnabled: boolean;
  integrityAlertsEnabled: boolean;
  alertNotificationsEnabled: boolean;
  retentionCleanupEnabled: boolean;
  liveSyncIntervalMs: number;
  signalMaxAgeSeconds: number;
  noTripGraceSeconds: number;
  noTripConfirmationSamples: number;
  streetDraftGraceSeconds: number;
  tripNotStartedGraceSeconds: number;
  movementThresholdMeters: number;
  completedWithPassengerGraceSeconds: number;
  taximeterAfterExitGraceSeconds: number;
  taximeterAfterExitDistanceMeters: number;
  pickupEndpointToleranceMeters?: number | null;
  finalDropoffEndpointToleranceMeters?: number | null;
  lateOrderMatchWindowSeconds: number;
  historyCurrentDayIntervalMinutes: number;
  historyPreviousDayFinalizeDelayMinutes: number;
  historyLatePassDelayHours: number;
  retentionDays: number;
  approvedNotificationAlertTypes: Array<TelematicsIntegrityAlertType>;
};

export type IntegrationRuntimeConfigurationFieldsFragment = {
  __typename: "IntegrationRuntimeConfiguration";
  telematics: {
    __typename?: "TelematicsRuntimeConfiguration";
    providerSettingId?: string | null;
    source: IntegrationRuntimePolicySource;
    environmentMasterAllowed: boolean;
    policyId: string;
    version: number;
    blockers: Array<string>;
    readiness: {
      __typename?: "TelematicsRuntimeReadiness";
      providerConfigured: boolean;
      providerEnabled: boolean;
      activeMappingCount: number;
      workerSafetyValid: boolean;
    };
    requested: {
      __typename: "TelematicsRuntimePolicyValues";
      configurationActionsEnabled: boolean;
      liveSyncEnabled: boolean;
      signalEngineEnabled: boolean;
      shadowCorrelationEnabled: boolean;
      historySyncEnabled: boolean;
      automaticHistoryReconciliationEnabled: boolean;
      adminLiveViewEnabled: boolean;
      operatorLiveViewEnabled: boolean;
      integrityAlertsEnabled: boolean;
      alertNotificationsEnabled: boolean;
      retentionCleanupEnabled: boolean;
      liveSyncIntervalMs: number;
      signalMaxAgeSeconds: number;
      noTripGraceSeconds: number;
      noTripConfirmationSamples: number;
      streetDraftGraceSeconds: number;
      tripNotStartedGraceSeconds: number;
      movementThresholdMeters: number;
      completedWithPassengerGraceSeconds: number;
      taximeterAfterExitGraceSeconds: number;
      taximeterAfterExitDistanceMeters: number;
      pickupEndpointToleranceMeters?: number | null;
      finalDropoffEndpointToleranceMeters?: number | null;
      lateOrderMatchWindowSeconds: number;
      historyCurrentDayIntervalMinutes: number;
      historyPreviousDayFinalizeDelayMinutes: number;
      historyLatePassDelayHours: number;
      retentionDays: number;
      approvedNotificationAlertTypes: Array<TelematicsIntegrityAlertType>;
    };
    effective: {
      __typename: "TelematicsRuntimePolicyValues";
      configurationActionsEnabled: boolean;
      liveSyncEnabled: boolean;
      signalEngineEnabled: boolean;
      shadowCorrelationEnabled: boolean;
      historySyncEnabled: boolean;
      automaticHistoryReconciliationEnabled: boolean;
      adminLiveViewEnabled: boolean;
      operatorLiveViewEnabled: boolean;
      integrityAlertsEnabled: boolean;
      alertNotificationsEnabled: boolean;
      retentionCleanupEnabled: boolean;
      liveSyncIntervalMs: number;
      signalMaxAgeSeconds: number;
      noTripGraceSeconds: number;
      noTripConfirmationSamples: number;
      streetDraftGraceSeconds: number;
      tripNotStartedGraceSeconds: number;
      movementThresholdMeters: number;
      completedWithPassengerGraceSeconds: number;
      taximeterAfterExitGraceSeconds: number;
      taximeterAfterExitDistanceMeters: number;
      pickupEndpointToleranceMeters?: number | null;
      finalDropoffEndpointToleranceMeters?: number | null;
      lateOrderMatchWindowSeconds: number;
      historyCurrentDayIntervalMinutes: number;
      historyPreviousDayFinalizeDelayMinutes: number;
      historyLatePassDelayHours: number;
      retentionDays: number;
      approvedNotificationAlertTypes: Array<TelematicsIntegrityAlertType>;
    };
  };
  desktopAlerts: {
    __typename?: "AdminDesktopAlertRuntimeConfiguration";
    source: IntegrationRuntimePolicySource;
    environmentMasterAllowed: boolean;
    policyId: string;
    version: number;
    blockers: Array<string>;
    readiness: {
      __typename?: "AdminDesktopAlertRuntimeReadiness";
      firebaseAdminConfigured: boolean;
      firebaseWebConfigured: boolean;
      vapidConfigured: boolean;
      serviceWorkerReady: boolean;
      outboxWorkerConfigured: boolean;
      activeBrowserRegistrationCount: number;
    };
    requested: {
      __typename?: "AdminDesktopAlertRuntimePolicyValues";
      registrationAllowed: boolean;
      deliveryEnabled: boolean;
      testPushEnabled: boolean;
    };
    effective: {
      __typename?: "AdminDesktopAlertRuntimePolicyValues";
      registrationAllowed: boolean;
      deliveryEnabled: boolean;
      testPushEnabled: boolean;
    };
  };
};

export type IntegrationRuntimeSettingsQueryVariables = Exact<{
  providerSettingId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type IntegrationRuntimeSettingsQuery = {
  __typename?: "Query";
  integrationRuntimeConfiguration: {
    __typename: "IntegrationRuntimeConfiguration";
    telematics: {
      __typename?: "TelematicsRuntimeConfiguration";
      providerSettingId?: string | null;
      source: IntegrationRuntimePolicySource;
      environmentMasterAllowed: boolean;
      policyId: string;
      version: number;
      blockers: Array<string>;
      readiness: {
        __typename?: "TelematicsRuntimeReadiness";
        providerConfigured: boolean;
        providerEnabled: boolean;
        activeMappingCount: number;
        workerSafetyValid: boolean;
      };
      requested: {
        __typename: "TelematicsRuntimePolicyValues";
        configurationActionsEnabled: boolean;
        liveSyncEnabled: boolean;
        signalEngineEnabled: boolean;
        shadowCorrelationEnabled: boolean;
        historySyncEnabled: boolean;
        automaticHistoryReconciliationEnabled: boolean;
        adminLiveViewEnabled: boolean;
        operatorLiveViewEnabled: boolean;
        integrityAlertsEnabled: boolean;
        alertNotificationsEnabled: boolean;
        retentionCleanupEnabled: boolean;
        liveSyncIntervalMs: number;
        signalMaxAgeSeconds: number;
        noTripGraceSeconds: number;
        noTripConfirmationSamples: number;
        streetDraftGraceSeconds: number;
        tripNotStartedGraceSeconds: number;
        movementThresholdMeters: number;
        completedWithPassengerGraceSeconds: number;
        taximeterAfterExitGraceSeconds: number;
        taximeterAfterExitDistanceMeters: number;
        pickupEndpointToleranceMeters?: number | null;
        finalDropoffEndpointToleranceMeters?: number | null;
        lateOrderMatchWindowSeconds: number;
        historyCurrentDayIntervalMinutes: number;
        historyPreviousDayFinalizeDelayMinutes: number;
        historyLatePassDelayHours: number;
        retentionDays: number;
        approvedNotificationAlertTypes: Array<TelematicsIntegrityAlertType>;
      };
      effective: {
        __typename: "TelematicsRuntimePolicyValues";
        configurationActionsEnabled: boolean;
        liveSyncEnabled: boolean;
        signalEngineEnabled: boolean;
        shadowCorrelationEnabled: boolean;
        historySyncEnabled: boolean;
        automaticHistoryReconciliationEnabled: boolean;
        adminLiveViewEnabled: boolean;
        operatorLiveViewEnabled: boolean;
        integrityAlertsEnabled: boolean;
        alertNotificationsEnabled: boolean;
        retentionCleanupEnabled: boolean;
        liveSyncIntervalMs: number;
        signalMaxAgeSeconds: number;
        noTripGraceSeconds: number;
        noTripConfirmationSamples: number;
        streetDraftGraceSeconds: number;
        tripNotStartedGraceSeconds: number;
        movementThresholdMeters: number;
        completedWithPassengerGraceSeconds: number;
        taximeterAfterExitGraceSeconds: number;
        taximeterAfterExitDistanceMeters: number;
        pickupEndpointToleranceMeters?: number | null;
        finalDropoffEndpointToleranceMeters?: number | null;
        lateOrderMatchWindowSeconds: number;
        historyCurrentDayIntervalMinutes: number;
        historyPreviousDayFinalizeDelayMinutes: number;
        historyLatePassDelayHours: number;
        retentionDays: number;
        approvedNotificationAlertTypes: Array<TelematicsIntegrityAlertType>;
      };
    };
    desktopAlerts: {
      __typename?: "AdminDesktopAlertRuntimeConfiguration";
      source: IntegrationRuntimePolicySource;
      environmentMasterAllowed: boolean;
      policyId: string;
      version: number;
      blockers: Array<string>;
      readiness: {
        __typename?: "AdminDesktopAlertRuntimeReadiness";
        firebaseAdminConfigured: boolean;
        firebaseWebConfigured: boolean;
        vapidConfigured: boolean;
        serviceWorkerReady: boolean;
        outboxWorkerConfigured: boolean;
        activeBrowserRegistrationCount: number;
      };
      requested: {
        __typename?: "AdminDesktopAlertRuntimePolicyValues";
        registrationAllowed: boolean;
        deliveryEnabled: boolean;
        testPushEnabled: boolean;
      };
      effective: {
        __typename?: "AdminDesktopAlertRuntimePolicyValues";
        registrationAllowed: boolean;
        deliveryEnabled: boolean;
        testPushEnabled: boolean;
      };
    };
  };
};

export type IntegrationRuntimePolicyHistoryQueryVariables = Exact<{
  providerSettingId: Scalars["ID"]["input"];
  policyType: IntegrationRuntimePolicyType;
  page: Scalars["Int"]["input"];
}>;

export type IntegrationRuntimePolicyHistoryQuery = {
  __typename?: "Query";
  integrationRuntimePolicyRevisions: Array<{
    __typename?: "IntegrationRuntimePolicyRevision";
    id: string;
    policyType: IntegrationRuntimePolicyType;
    priorVersion: number;
    newVersion: number;
    changedFields: Array<string>;
    previousValuesJson: string;
    newValuesJson: string;
    actorOperatorId?: string | null;
    reason: string;
    changedAt: any;
  }>;
};

export type UpdateTelematicsRuntimePolicyMutationVariables = Exact<{
  input: UpdateTelematicsRuntimePolicyInput;
}>;

export type UpdateTelematicsRuntimePolicyMutation = {
  __typename?: "Mutation";
  updateTelematicsRuntimePolicy: {
    __typename?: "TelematicsRuntimeConfiguration";
    providerSettingId?: string | null;
    source: IntegrationRuntimePolicySource;
    environmentMasterAllowed: boolean;
    policyId: string;
    version: number;
    blockers: Array<string>;
    readiness: {
      __typename?: "TelematicsRuntimeReadiness";
      providerConfigured: boolean;
      providerEnabled: boolean;
      activeMappingCount: number;
      workerSafetyValid: boolean;
    };
    requested: {
      __typename: "TelematicsRuntimePolicyValues";
      configurationActionsEnabled: boolean;
      liveSyncEnabled: boolean;
      signalEngineEnabled: boolean;
      shadowCorrelationEnabled: boolean;
      historySyncEnabled: boolean;
      automaticHistoryReconciliationEnabled: boolean;
      adminLiveViewEnabled: boolean;
      operatorLiveViewEnabled: boolean;
      integrityAlertsEnabled: boolean;
      alertNotificationsEnabled: boolean;
      retentionCleanupEnabled: boolean;
      liveSyncIntervalMs: number;
      signalMaxAgeSeconds: number;
      noTripGraceSeconds: number;
      noTripConfirmationSamples: number;
      streetDraftGraceSeconds: number;
      tripNotStartedGraceSeconds: number;
      movementThresholdMeters: number;
      completedWithPassengerGraceSeconds: number;
      taximeterAfterExitGraceSeconds: number;
      taximeterAfterExitDistanceMeters: number;
      pickupEndpointToleranceMeters?: number | null;
      finalDropoffEndpointToleranceMeters?: number | null;
      lateOrderMatchWindowSeconds: number;
      historyCurrentDayIntervalMinutes: number;
      historyPreviousDayFinalizeDelayMinutes: number;
      historyLatePassDelayHours: number;
      retentionDays: number;
      approvedNotificationAlertTypes: Array<TelematicsIntegrityAlertType>;
    };
    effective: {
      __typename: "TelematicsRuntimePolicyValues";
      configurationActionsEnabled: boolean;
      liveSyncEnabled: boolean;
      signalEngineEnabled: boolean;
      shadowCorrelationEnabled: boolean;
      historySyncEnabled: boolean;
      automaticHistoryReconciliationEnabled: boolean;
      adminLiveViewEnabled: boolean;
      operatorLiveViewEnabled: boolean;
      integrityAlertsEnabled: boolean;
      alertNotificationsEnabled: boolean;
      retentionCleanupEnabled: boolean;
      liveSyncIntervalMs: number;
      signalMaxAgeSeconds: number;
      noTripGraceSeconds: number;
      noTripConfirmationSamples: number;
      streetDraftGraceSeconds: number;
      tripNotStartedGraceSeconds: number;
      movementThresholdMeters: number;
      completedWithPassengerGraceSeconds: number;
      taximeterAfterExitGraceSeconds: number;
      taximeterAfterExitDistanceMeters: number;
      pickupEndpointToleranceMeters?: number | null;
      finalDropoffEndpointToleranceMeters?: number | null;
      lateOrderMatchWindowSeconds: number;
      historyCurrentDayIntervalMinutes: number;
      historyPreviousDayFinalizeDelayMinutes: number;
      historyLatePassDelayHours: number;
      retentionDays: number;
      approvedNotificationAlertTypes: Array<TelematicsIntegrityAlertType>;
    };
  };
};

export type UpdateAdminDesktopAlertRuntimePolicyMutationVariables = Exact<{
  providerSettingId: Scalars["ID"]["input"];
  input: UpdateAdminDesktopAlertRuntimePolicyInput;
}>;

export type UpdateAdminDesktopAlertRuntimePolicyMutation = {
  __typename?: "Mutation";
  updateAdminDesktopAlertRuntimePolicy: {
    __typename: "IntegrationRuntimeConfiguration";
    telematics: {
      __typename?: "TelematicsRuntimeConfiguration";
      providerSettingId?: string | null;
      source: IntegrationRuntimePolicySource;
      environmentMasterAllowed: boolean;
      policyId: string;
      version: number;
      blockers: Array<string>;
      readiness: {
        __typename?: "TelematicsRuntimeReadiness";
        providerConfigured: boolean;
        providerEnabled: boolean;
        activeMappingCount: number;
        workerSafetyValid: boolean;
      };
      requested: {
        __typename: "TelematicsRuntimePolicyValues";
        configurationActionsEnabled: boolean;
        liveSyncEnabled: boolean;
        signalEngineEnabled: boolean;
        shadowCorrelationEnabled: boolean;
        historySyncEnabled: boolean;
        automaticHistoryReconciliationEnabled: boolean;
        adminLiveViewEnabled: boolean;
        operatorLiveViewEnabled: boolean;
        integrityAlertsEnabled: boolean;
        alertNotificationsEnabled: boolean;
        retentionCleanupEnabled: boolean;
        liveSyncIntervalMs: number;
        signalMaxAgeSeconds: number;
        noTripGraceSeconds: number;
        noTripConfirmationSamples: number;
        streetDraftGraceSeconds: number;
        tripNotStartedGraceSeconds: number;
        movementThresholdMeters: number;
        completedWithPassengerGraceSeconds: number;
        taximeterAfterExitGraceSeconds: number;
        taximeterAfterExitDistanceMeters: number;
        pickupEndpointToleranceMeters?: number | null;
        finalDropoffEndpointToleranceMeters?: number | null;
        lateOrderMatchWindowSeconds: number;
        historyCurrentDayIntervalMinutes: number;
        historyPreviousDayFinalizeDelayMinutes: number;
        historyLatePassDelayHours: number;
        retentionDays: number;
        approvedNotificationAlertTypes: Array<TelematicsIntegrityAlertType>;
      };
      effective: {
        __typename: "TelematicsRuntimePolicyValues";
        configurationActionsEnabled: boolean;
        liveSyncEnabled: boolean;
        signalEngineEnabled: boolean;
        shadowCorrelationEnabled: boolean;
        historySyncEnabled: boolean;
        automaticHistoryReconciliationEnabled: boolean;
        adminLiveViewEnabled: boolean;
        operatorLiveViewEnabled: boolean;
        integrityAlertsEnabled: boolean;
        alertNotificationsEnabled: boolean;
        retentionCleanupEnabled: boolean;
        liveSyncIntervalMs: number;
        signalMaxAgeSeconds: number;
        noTripGraceSeconds: number;
        noTripConfirmationSamples: number;
        streetDraftGraceSeconds: number;
        tripNotStartedGraceSeconds: number;
        movementThresholdMeters: number;
        completedWithPassengerGraceSeconds: number;
        taximeterAfterExitGraceSeconds: number;
        taximeterAfterExitDistanceMeters: number;
        pickupEndpointToleranceMeters?: number | null;
        finalDropoffEndpointToleranceMeters?: number | null;
        lateOrderMatchWindowSeconds: number;
        historyCurrentDayIntervalMinutes: number;
        historyPreviousDayFinalizeDelayMinutes: number;
        historyLatePassDelayHours: number;
        retentionDays: number;
        approvedNotificationAlertTypes: Array<TelematicsIntegrityAlertType>;
      };
    };
    desktopAlerts: {
      __typename?: "AdminDesktopAlertRuntimeConfiguration";
      source: IntegrationRuntimePolicySource;
      environmentMasterAllowed: boolean;
      policyId: string;
      version: number;
      blockers: Array<string>;
      readiness: {
        __typename?: "AdminDesktopAlertRuntimeReadiness";
        firebaseAdminConfigured: boolean;
        firebaseWebConfigured: boolean;
        vapidConfigured: boolean;
        serviceWorkerReady: boolean;
        outboxWorkerConfigured: boolean;
        activeBrowserRegistrationCount: number;
      };
      requested: {
        __typename?: "AdminDesktopAlertRuntimePolicyValues";
        registrationAllowed: boolean;
        deliveryEnabled: boolean;
        testPushEnabled: boolean;
      };
      effective: {
        __typename?: "AdminDesktopAlertRuntimePolicyValues";
        registrationAllowed: boolean;
        deliveryEnabled: boolean;
        testPushEnabled: boolean;
      };
    };
  };
};

export type ApplyTelematicsRuntimePresetMutationVariables = Exact<{
  input: ApplyTelematicsRuntimePresetInput;
}>;

export type ApplyTelematicsRuntimePresetMutation = {
  __typename?: "Mutation";
  applyTelematicsRuntimePreset: {
    __typename: "IntegrationRuntimeConfiguration";
    telematics: {
      __typename?: "TelematicsRuntimeConfiguration";
      providerSettingId?: string | null;
      source: IntegrationRuntimePolicySource;
      environmentMasterAllowed: boolean;
      policyId: string;
      version: number;
      blockers: Array<string>;
      readiness: {
        __typename?: "TelematicsRuntimeReadiness";
        providerConfigured: boolean;
        providerEnabled: boolean;
        activeMappingCount: number;
        workerSafetyValid: boolean;
      };
      requested: {
        __typename: "TelematicsRuntimePolicyValues";
        configurationActionsEnabled: boolean;
        liveSyncEnabled: boolean;
        signalEngineEnabled: boolean;
        shadowCorrelationEnabled: boolean;
        historySyncEnabled: boolean;
        automaticHistoryReconciliationEnabled: boolean;
        adminLiveViewEnabled: boolean;
        operatorLiveViewEnabled: boolean;
        integrityAlertsEnabled: boolean;
        alertNotificationsEnabled: boolean;
        retentionCleanupEnabled: boolean;
        liveSyncIntervalMs: number;
        signalMaxAgeSeconds: number;
        noTripGraceSeconds: number;
        noTripConfirmationSamples: number;
        streetDraftGraceSeconds: number;
        tripNotStartedGraceSeconds: number;
        movementThresholdMeters: number;
        completedWithPassengerGraceSeconds: number;
        taximeterAfterExitGraceSeconds: number;
        taximeterAfterExitDistanceMeters: number;
        pickupEndpointToleranceMeters?: number | null;
        finalDropoffEndpointToleranceMeters?: number | null;
        lateOrderMatchWindowSeconds: number;
        historyCurrentDayIntervalMinutes: number;
        historyPreviousDayFinalizeDelayMinutes: number;
        historyLatePassDelayHours: number;
        retentionDays: number;
        approvedNotificationAlertTypes: Array<TelematicsIntegrityAlertType>;
      };
      effective: {
        __typename: "TelematicsRuntimePolicyValues";
        configurationActionsEnabled: boolean;
        liveSyncEnabled: boolean;
        signalEngineEnabled: boolean;
        shadowCorrelationEnabled: boolean;
        historySyncEnabled: boolean;
        automaticHistoryReconciliationEnabled: boolean;
        adminLiveViewEnabled: boolean;
        operatorLiveViewEnabled: boolean;
        integrityAlertsEnabled: boolean;
        alertNotificationsEnabled: boolean;
        retentionCleanupEnabled: boolean;
        liveSyncIntervalMs: number;
        signalMaxAgeSeconds: number;
        noTripGraceSeconds: number;
        noTripConfirmationSamples: number;
        streetDraftGraceSeconds: number;
        tripNotStartedGraceSeconds: number;
        movementThresholdMeters: number;
        completedWithPassengerGraceSeconds: number;
        taximeterAfterExitGraceSeconds: number;
        taximeterAfterExitDistanceMeters: number;
        pickupEndpointToleranceMeters?: number | null;
        finalDropoffEndpointToleranceMeters?: number | null;
        lateOrderMatchWindowSeconds: number;
        historyCurrentDayIntervalMinutes: number;
        historyPreviousDayFinalizeDelayMinutes: number;
        historyLatePassDelayHours: number;
        retentionDays: number;
        approvedNotificationAlertTypes: Array<TelematicsIntegrityAlertType>;
      };
    };
    desktopAlerts: {
      __typename?: "AdminDesktopAlertRuntimeConfiguration";
      source: IntegrationRuntimePolicySource;
      environmentMasterAllowed: boolean;
      policyId: string;
      version: number;
      blockers: Array<string>;
      readiness: {
        __typename?: "AdminDesktopAlertRuntimeReadiness";
        firebaseAdminConfigured: boolean;
        firebaseWebConfigured: boolean;
        vapidConfigured: boolean;
        serviceWorkerReady: boolean;
        outboxWorkerConfigured: boolean;
        activeBrowserRegistrationCount: number;
      };
      requested: {
        __typename?: "AdminDesktopAlertRuntimePolicyValues";
        registrationAllowed: boolean;
        deliveryEnabled: boolean;
        testPushEnabled: boolean;
      };
      effective: {
        __typename?: "AdminDesktopAlertRuntimePolicyValues";
        registrationAllowed: boolean;
        deliveryEnabled: boolean;
        testPushEnabled: boolean;
      };
    };
  };
};

export type DisableAllIntegrationRuntimeMutationVariables = Exact<{
  input: DisableAllIntegrationRuntimeInput;
}>;

export type DisableAllIntegrationRuntimeMutation = {
  __typename?: "Mutation";
  disableAllIntegrationRuntime: {
    __typename: "IntegrationRuntimeConfiguration";
    telematics: {
      __typename?: "TelematicsRuntimeConfiguration";
      providerSettingId?: string | null;
      source: IntegrationRuntimePolicySource;
      environmentMasterAllowed: boolean;
      policyId: string;
      version: number;
      blockers: Array<string>;
      readiness: {
        __typename?: "TelematicsRuntimeReadiness";
        providerConfigured: boolean;
        providerEnabled: boolean;
        activeMappingCount: number;
        workerSafetyValid: boolean;
      };
      requested: {
        __typename: "TelematicsRuntimePolicyValues";
        configurationActionsEnabled: boolean;
        liveSyncEnabled: boolean;
        signalEngineEnabled: boolean;
        shadowCorrelationEnabled: boolean;
        historySyncEnabled: boolean;
        automaticHistoryReconciliationEnabled: boolean;
        adminLiveViewEnabled: boolean;
        operatorLiveViewEnabled: boolean;
        integrityAlertsEnabled: boolean;
        alertNotificationsEnabled: boolean;
        retentionCleanupEnabled: boolean;
        liveSyncIntervalMs: number;
        signalMaxAgeSeconds: number;
        noTripGraceSeconds: number;
        noTripConfirmationSamples: number;
        streetDraftGraceSeconds: number;
        tripNotStartedGraceSeconds: number;
        movementThresholdMeters: number;
        completedWithPassengerGraceSeconds: number;
        taximeterAfterExitGraceSeconds: number;
        taximeterAfterExitDistanceMeters: number;
        pickupEndpointToleranceMeters?: number | null;
        finalDropoffEndpointToleranceMeters?: number | null;
        lateOrderMatchWindowSeconds: number;
        historyCurrentDayIntervalMinutes: number;
        historyPreviousDayFinalizeDelayMinutes: number;
        historyLatePassDelayHours: number;
        retentionDays: number;
        approvedNotificationAlertTypes: Array<TelematicsIntegrityAlertType>;
      };
      effective: {
        __typename: "TelematicsRuntimePolicyValues";
        configurationActionsEnabled: boolean;
        liveSyncEnabled: boolean;
        signalEngineEnabled: boolean;
        shadowCorrelationEnabled: boolean;
        historySyncEnabled: boolean;
        automaticHistoryReconciliationEnabled: boolean;
        adminLiveViewEnabled: boolean;
        operatorLiveViewEnabled: boolean;
        integrityAlertsEnabled: boolean;
        alertNotificationsEnabled: boolean;
        retentionCleanupEnabled: boolean;
        liveSyncIntervalMs: number;
        signalMaxAgeSeconds: number;
        noTripGraceSeconds: number;
        noTripConfirmationSamples: number;
        streetDraftGraceSeconds: number;
        tripNotStartedGraceSeconds: number;
        movementThresholdMeters: number;
        completedWithPassengerGraceSeconds: number;
        taximeterAfterExitGraceSeconds: number;
        taximeterAfterExitDistanceMeters: number;
        pickupEndpointToleranceMeters?: number | null;
        finalDropoffEndpointToleranceMeters?: number | null;
        lateOrderMatchWindowSeconds: number;
        historyCurrentDayIntervalMinutes: number;
        historyPreviousDayFinalizeDelayMinutes: number;
        historyLatePassDelayHours: number;
        retentionDays: number;
        approvedNotificationAlertTypes: Array<TelematicsIntegrityAlertType>;
      };
    };
    desktopAlerts: {
      __typename?: "AdminDesktopAlertRuntimeConfiguration";
      source: IntegrationRuntimePolicySource;
      environmentMasterAllowed: boolean;
      policyId: string;
      version: number;
      blockers: Array<string>;
      readiness: {
        __typename?: "AdminDesktopAlertRuntimeReadiness";
        firebaseAdminConfigured: boolean;
        firebaseWebConfigured: boolean;
        vapidConfigured: boolean;
        serviceWorkerReady: boolean;
        outboxWorkerConfigured: boolean;
        activeBrowserRegistrationCount: number;
      };
      requested: {
        __typename?: "AdminDesktopAlertRuntimePolicyValues";
        registrationAllowed: boolean;
        deliveryEnabled: boolean;
        testPushEnabled: boolean;
      };
      effective: {
        __typename?: "AdminDesktopAlertRuntimePolicyValues";
        registrationAllowed: boolean;
        deliveryEnabled: boolean;
        testPushEnabled: boolean;
      };
    };
  };
};

export type TelematicsProfilesQueryVariables = Exact<{
  providerSettingId: Scalars["ID"]["input"];
  includeInactive: Scalars["Boolean"]["input"];
}>;

export type TelematicsProfilesQuery = {
  __typename?: "Query";
  telematicsProfiles: Array<{
    __typename?: "TelematicsProfile";
    id: string;
    providerSettingId: string;
    name: string;
    version: number;
    schemaVersion: number;
    active: boolean;
    published: boolean;
    previousProfileId?: string | null;
    createdAt: any;
    updatedAt: any;
    fields: Array<{
      __typename?: "TelematicsFieldMapping";
      semanticField: string;
      currentStatusKey?: string | null;
      historicalKey?: string | null;
      expectedType: string;
      required: boolean;
      caseSensitive: boolean;
      unit?: string | null;
    }>;
  }>;
};

export type UpsertTelematicsProviderSettingMutationVariables = Exact<{
  input: UpsertTelematicsProviderSettingInput;
}>;

export type UpsertTelematicsProviderSettingMutation = {
  __typename?: "Mutation";
  upsertTelematicsProviderSetting: {
    __typename?: "TelematicsProviderSetting";
    id: string;
    provider: TelematicsProvider;
    displayName: string;
    enabled: boolean;
    baseUrl: string;
    applicationId: number;
    tokenConfigured: boolean;
    providerTimeZone: string;
    retentionDays: number;
    createdAt: any;
    updatedAt: any;
    deactivatedAt?: any | null;
    lastSuccessAt?: any | null;
    lastError?: string | null;
  };
};

export type SetTelematicsProviderSecretMutationVariables = Exact<{
  input: SetTelematicsProviderSecretInput;
}>;

export type SetTelematicsProviderSecretMutation = {
  __typename?: "Mutation";
  setTelematicsProviderSecret: {
    __typename?: "TelematicsProviderSetting";
    id: string;
    tokenConfigured: boolean;
    updatedAt: any;
  };
};

export type CreateTelematicsProfileVersionMutationVariables = Exact<{
  input: CreateTelematicsProfileVersionInput;
}>;

export type CreateTelematicsProfileVersionMutation = {
  __typename?: "Mutation";
  createTelematicsProfileVersion: {
    __typename?: "TelematicsProfile";
    id: string;
    providerSettingId: string;
    name: string;
    version: number;
    active: boolean;
    published: boolean;
    previousProfileId?: string | null;
    createdAt: any;
    updatedAt: any;
    fields: Array<{
      __typename?: "TelematicsFieldMapping";
      semanticField: string;
      currentStatusKey?: string | null;
      historicalKey?: string | null;
      expectedType: string;
      required: boolean;
      caseSensitive: boolean;
      unit?: string | null;
    }>;
  };
};

export type SetTelematicsProfileActiveMutationVariables = Exact<{
  input: SetTelematicsProfileActiveInput;
}>;

export type SetTelematicsProfileActiveMutation = {
  __typename?: "Mutation";
  setTelematicsProfileActive: {
    __typename?: "TelematicsProfile";
    id: string;
    active: boolean;
    updatedAt: any;
  };
};

export type TestTelematicsProviderConnectionMutationVariables = Exact<{
  providerSettingId: Scalars["ID"]["input"];
}>;

export type TestTelematicsProviderConnectionMutation = {
  __typename?: "Mutation";
  testTelematicsProviderConnection: {
    __typename?: "TelematicsOperationResult";
    success: boolean;
    status: TelematicsProviderHealthStatus;
    testedAt: any;
    latencyMs: number;
    upstreamHttpStatus?: number | null;
    provider: TelematicsProvider;
    applicationId: number;
    errorCode?: TelematicsProviderErrorCode | null;
    recommendedAction: string;
  };
};

export type TelematicsProviderVariablesQueryVariables = Exact<{
  providerSettingId: Scalars["ID"]["input"];
}>;

export type TelematicsProviderVariablesQuery = {
  __typename?: "Query";
  telematicsProviderVariables: Array<{
    __typename?: "TelematicsProviderVariable";
    name: string;
    providerType: string;
    description?: string | null;
    unitName?: string | null;
    usedByActiveProfile: boolean;
  }>;
};

export type TelematicsProviderInventoryQueryVariables = Exact<{
  providerSettingId: Scalars["ID"]["input"];
  fromIndex: Scalars["Int"]["input"];
  pageSize: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type TelematicsProviderInventoryQuery = {
  __typename?: "Query";
  telematicsProviderInventory: {
    __typename?: "TelematicsProviderInventoryPage";
    fromIndex: number;
    pageSize: number;
    hasMore: boolean;
    upstreamHttpStatus?: number | null;
    items: Array<{
      __typename?: "TelematicsProviderInventoryItem";
      providerUserId: string;
      displayName: string;
      providerDeviceCount?: number | null;
      latestActivityAt?: any | null;
      classification: TelematicsInventoryClassification;
      mappingStatus: TelematicsInventoryMappingStatus;
      mappedVehicleId?: string | null;
      mappedVehicleName?: string | null;
    }>;
  };
};

export type TelematicsProviderInventoryItemQueryVariables = Exact<{
  providerSettingId: Scalars["ID"]["input"];
  providerUserId: Scalars["String"]["input"];
}>;

export type TelematicsProviderInventoryItemQuery = {
  __typename?: "Query";
  telematicsProviderInventoryItem: {
    __typename?: "TelematicsProviderInventoryDetail";
    providerUserId: string;
    displayName: string;
    classification: TelematicsInventoryClassification;
    mappingStatus: TelematicsInventoryMappingStatus;
    mappedVehicleId?: string | null;
    mappedVehicleName?: string | null;
    upstreamHttpStatus?: number | null;
    devices: Array<{
      __typename?: "TelematicsProviderDeviceDetail";
      providerDeviceId: string;
      deviceName?: string | null;
      modelIdentifier?: string | null;
      protocolIdentifier?: string | null;
      maskedImei?: string | null;
      createdAt?: any | null;
      lastDeviceAt?: any | null;
    }>;
  };
};

export type TelematicsProviderCurrentStatusPreviewQueryVariables = Exact<{
  providerSettingId: Scalars["ID"]["input"];
  providerUserId: Scalars["String"]["input"];
}>;

export type TelematicsProviderCurrentStatusPreviewQuery = {
  __typename?: "Query";
  telematicsProviderCurrentStatusPreview: {
    __typename?: "TelematicsCurrentStatusPreview";
    provider: TelematicsProvider;
    providerSettingId: string;
    providerApplicationId: number;
    providerUserId: string;
    providerDeviceId?: string | null;
    providerDisplayName?: string | null;
    receivedAt: any;
    providerObservedAt?: any | null;
    deviceActivityAt?: any | null;
    odometerMeters?: number | null;
    doorState?: string | null;
    gsmSignalLevel?: number | null;
    satelliteCount?: number | null;
    voltage?: number | null;
    trackerBatteryLevel?: number | null;
    capability: TelematicsCapability;
    warnings: Array<TelematicsStatusWarning>;
    canonicalHash: string;
    upstreamHttpStatus?: number | null;
    position?: {
      __typename?: "TelematicsNormalizedPosition";
      latitude: number;
      longitude: number;
      altitude?: number | null;
      valid: boolean;
      observedAt?: any | null;
    } | null;
    velocity: {
      __typename?: "TelematicsNormalizedVelocity";
      speedMetersPerSecond?: number | null;
      headingDegrees?: number | null;
      observedAt?: any | null;
    };
    passengerPresence: {
      __typename?: "TelematicsNormalizedSignal";
      value: TelematicsSignalValue;
      observedAt?: any | null;
      freshness: TelematicsSignalFreshness;
      providerField: string;
      parseStatus: TelematicsSignalParseStatus;
    };
    taximeterActive: {
      __typename?: "TelematicsNormalizedSignal";
      value: TelematicsSignalValue;
      observedAt?: any | null;
      freshness: TelematicsSignalFreshness;
      providerField: string;
      parseStatus: TelematicsSignalParseStatus;
    };
    ignition: {
      __typename?: "TelematicsNormalizedSignal";
      value: TelematicsSignalValue;
      observedAt?: any | null;
      freshness: TelematicsSignalFreshness;
      providerField: string;
      parseStatus: TelematicsSignalParseStatus;
    };
  };
};

export type CreateOperatorMutationVariables = Exact<{
  input: CreateOperatorInput;
}>;

export type CreateOperatorMutation = {
  __typename?: "Mutation";
  createOneOperator: { __typename?: "Operator"; id: string };
};

export type ViewOperatorQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewOperatorQuery = {
  __typename?: "Query";
  operator: {
    __typename?: "Operator";
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    mobileNumber?: string | null;
    userName: string;
    email?: string | null;
    roleId?: string | null;
  };
  operatorRoles: Array<{
    __typename?: "OperatorRole";
    id: string;
    title: string;
  }>;
};

export type NewOperatorQueryVariables = Exact<{ [key: string]: never }>;

export type NewOperatorQuery = {
  __typename?: "Query";
  operatorRoles: Array<{
    __typename?: "OperatorRole";
    id: string;
    title: string;
  }>;
};

export type UpdateOperatorMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  update: UpdateOperatorInput;
}>;

export type UpdateOperatorMutation = {
  __typename?: "Mutation";
  updateOneOperator: { __typename?: "Operator"; id: string };
};

export type AdminResetOperatorPasswordMutationVariables = Exact<{
  input: AdminResetOperatorPasswordInput;
}>;

export type AdminResetOperatorPasswordMutation = {
  __typename?: "Mutation";
  adminResetOperatorPassword: boolean;
};

export type UsersListQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;

export type UsersListQuery = {
  __typename?: "Query";
  operators: {
    __typename?: "OperatorConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "Operator";
      id: string;
      userName: string;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      mobileNumber?: string | null;
      role?: { __typename?: "OperatorRole"; title: string } | null;
    }>;
  };
};

export type ZoneMultiplierViewQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ZoneMultiplierViewQuery = {
  __typename?: "Query";
  zoneMultiplier: {
    __typename?: "ZoneMultiplier";
    id: string;
    name: string;
    multiplier: number;
    triggerType: ZoneMultiplierTriggerType;
    priority: number;
    enabled: boolean;
    notes?: string | null;
    area: Array<Array<{ __typename?: "Point"; lat: number; lng: number }>>;
  };
};

export type ZoneMultiplierNewQueryVariables = Exact<{ [key: string]: never }>;

export type ZoneMultiplierNewQuery = { __typename: "Query" };

export type UpdateZoneMultiplierMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  update: ZoneMultiplierInput;
}>;

export type UpdateZoneMultiplierMutation = {
  __typename?: "Mutation";
  updateOneZoneMultiplier: { __typename?: "ZoneMultiplier"; id: string };
};

export type CreateZoneMultiplierMutationVariables = Exact<{
  input: ZoneMultiplierInput;
}>;

export type CreateZoneMultiplierMutation = {
  __typename?: "Mutation";
  createOneZoneMultiplier: { __typename?: "ZoneMultiplier"; id: string };
};

export type DeleteZoneMultiplierMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteZoneMultiplierMutation = {
  __typename?: "Mutation";
  deleteOneZoneMultiplier: {
    __typename?: "ZoneMultiplierDeleteResponse";
    id?: string | null;
  };
};

export type ZoneMultipliersListQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;

export type ZoneMultipliersListQuery = {
  __typename?: "Query";
  zoneMultipliers: {
    __typename?: "ZoneMultiplierConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "ZoneMultiplier";
      id: string;
      name: string;
      multiplier: number;
      triggerType: ZoneMultiplierTriggerType;
      priority: number;
      enabled: boolean;
      area: Array<Array<{ __typename?: "Point"; lat: number; lng: number }>>;
    }>;
  };
};

export type ZonePriceViewQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ZonePriceViewQuery = {
  __typename?: "Query";
  zonePrice: {
    __typename?: "ZonePrice";
    id: string;
    name: string;
    cost: number;
    from: Array<Array<{ __typename?: "Point"; lat: number; lng: number }>>;
    to: Array<Array<{ __typename?: "Point"; lat: number; lng: number }>>;
    profileFares?: Array<{
      __typename?: "ZonePriceProfileFare";
      id: string;
      tariffProfileId: string;
      tariffProfileName?: string | null;
      tariffProfileCode?: string | null;
      fixedPrice: number;
      enabled: boolean;
    }> | null;
    services: Array<{ __typename?: "Service"; id: string }>;
    fleets: Array<{ __typename?: "Fleet"; id: string }>;
    timeMultipliers: Array<{
      __typename?: "TimeMultiplier";
      startTime: string;
      endTime: string;
      multiply: number;
    }>;
  };
  fleets: {
    __typename?: "FleetConnection";
    nodes: Array<{ __typename?: "Fleet"; id: string; name: string }>;
  };
  services: Array<{ __typename?: "Service"; id: string; name: string }>;
  tariffProfiles: {
    __typename?: "TariffProfileConnection";
    nodes: Array<{
      __typename?: "TariffProfile";
      id: string;
      title: string;
      code: string;
    }>;
  };
};

export type ZonePriceNewQueryVariables = Exact<{ [key: string]: never }>;

export type ZonePriceNewQuery = {
  __typename?: "Query";
  fleets: {
    __typename?: "FleetConnection";
    nodes: Array<{ __typename?: "Fleet"; id: string; name: string }>;
  };
  services: Array<{ __typename?: "Service"; id: string; name: string }>;
  tariffProfiles: {
    __typename?: "TariffProfileConnection";
    nodes: Array<{
      __typename?: "TariffProfile";
      id: string;
      title: string;
      code: string;
    }>;
  };
};

export type UpdateZonePriceMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  update: ZonePriceInput;
}>;

export type UpdateZonePriceMutation = {
  __typename?: "Mutation";
  updateOneZonePrice: { __typename?: "ZonePrice"; id: string };
};

export type CreateZonePriceMutationVariables = Exact<{
  input: ZonePriceInput;
}>;

export type CreateZonePriceMutation = {
  __typename?: "Mutation";
  createOneZonePrice: { __typename?: "ZonePrice"; id: string };
};

export type DeleteZonePriceMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteZonePriceMutation = {
  __typename?: "Mutation";
  deleteOneZonePrice: {
    __typename?: "ZonePriceDeleteResponse";
    id?: string | null;
  };
};

export type SetZonePriceRelationsMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  services: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
  fleets: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type SetZonePriceRelationsMutation = {
  __typename?: "Mutation";
  setServicesOnZonePrice: { __typename?: "ZonePrice"; id: string };
  setFleetsOnZonePrice: { __typename?: "ZonePrice"; id: string };
};

export type SaveZonePriceProfileFaresMutationVariables = Exact<{
  input: SaveZonePriceProfileFaresInput;
}>;

export type SaveZonePriceProfileFaresMutation = {
  __typename?: "Mutation";
  saveZonePriceProfileFares: Array<{
    __typename?: "ZonePriceProfileFare";
    id: string;
    tariffProfileId: string;
    tariffProfileName?: string | null;
    tariffProfileCode?: string | null;
    fixedPrice: number;
    enabled: boolean;
  }>;
};

export type ZonePricesListQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;

export type ZonePricesListQuery = {
  __typename?: "Query";
  zonePrices: {
    __typename?: "ZonePriceConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "ZonePrice";
      id: string;
      name: string;
      cost: number;
      profileFares?: Array<{
        __typename?: "ZonePriceProfileFare";
        id: string;
        tariffProfileId: string;
        tariffProfileName?: string | null;
        tariffProfileCode?: string | null;
        fixedPrice: number;
        enabled: boolean;
      }> | null;
      from: Array<Array<{ __typename?: "Point"; lat: number; lng: number }>>;
      to: Array<Array<{ __typename?: "Point"; lat: number; lng: number }>>;
    }>;
  };
};

export type ViewAnnouncementQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewAnnouncementQuery = {
  __typename?: "Query";
  announcement: {
    __typename?: "Announcement";
    id: string;
    title: string;
    userType: Array<AnnouncementUserType>;
    description: string;
    url?: string | null;
    startAt: any;
    expireAt: any;
    notificationSentAt?: any | null;
  };
};

export type CreateAnnouncementMutationVariables = Exact<{
  input: CreateAnnouncementInput;
}>;

export type CreateAnnouncementMutation = {
  __typename?: "Mutation";
  createAnnouncement: { __typename?: "Announcement"; id: string };
};

export type UpdateAnnouncementMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: UpdateAnnouncementInput;
}>;

export type UpdateAnnouncementMutation = {
  __typename?: "Mutation";
  updateOneAnnouncement: { __typename?: "Announcement"; id: string };
};

export type DeleteAnnouncementMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteAnnouncementMutation = {
  __typename?: "Mutation";
  deleteOneAnnouncement: {
    __typename?: "AnnouncementDeleteResponse";
    id?: string | null;
  };
};

export type AnnouncementsListQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;

export type AnnouncementsListQuery = {
  __typename?: "Query";
  announcements: {
    __typename?: "AnnouncementConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "Announcement";
      id: string;
      title: string;
      userType: Array<AnnouncementUserType>;
      description: string;
      startAt: any;
      expireAt: any;
      notificationSentAt?: any | null;
    }>;
  };
  announcementSummary: {
    __typename?: "AnnouncementConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "Announcement";
      id: string;
      userType: Array<AnnouncementUserType>;
      notificationSentAt?: any | null;
    }>;
  };
};

export type ViewCouponQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewCouponQuery = {
  __typename?: "Query";
  coupon: {
    __typename?: "Coupon";
    id: string;
    isEnabled: boolean;
    code: string;
    title: string;
    description: string;
    manyUsersCanUse: number;
    manyTimesUserCanUse: number;
    minimumCost: number;
    maximumCost: number;
    startAt: any;
    expireAt: any;
    discountPercent: number;
    discountFlat: number;
    creditGift: number;
    isFirstTravelOnly: boolean;
    allowedServices: Array<{
      __typename?: "Service";
      id: string;
      name: string;
    }>;
  };
};

export type CreateCouponMutationVariables = Exact<{
  input: CouponInput;
}>;

export type CreateCouponMutation = {
  __typename?: "Mutation";
  createOneCoupon: { __typename?: "Coupon"; id: string };
};

export type UpdateCouponMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: CouponInput;
}>;

export type UpdateCouponMutation = {
  __typename?: "Mutation";
  updateOneCoupon: { __typename?: "Coupon"; id: string };
};

export type DeleteCouponMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteCouponMutation = {
  __typename?: "Mutation";
  deleteOneCoupon: { __typename?: "CouponDeleteResponse"; id?: string | null };
};

export type CouponListQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;

export type CouponListQuery = {
  __typename?: "Query";
  coupons: {
    __typename?: "CouponConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "Coupon";
      id: string;
      code: string;
      title: string;
      isEnabled: boolean;
      description: string;
      manyUsersCanUse: number;
      manyTimesUserCanUse: number;
      minimumCost: number;
      maximumCost: number;
      discountPercent: number;
      discountFlat: number;
      creditGift: number;
      isFirstTravelOnly: boolean;
      startAt: any;
      expireAt: any;
    }>;
  };
  couponSummary: {
    __typename?: "CouponConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "Coupon";
      id: string;
      isEnabled: boolean;
      manyUsersCanUse: number;
      manyTimesUserCanUse: number;
      startAt: any;
      expireAt: any;
    }>;
  };
};

export type GiftBatchListQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;

export type GiftBatchListQuery = {
  __typename?: "Query";
  giftBatches: {
    __typename?: "GiftBatchConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "GiftBatch";
      id: string;
      name: string;
      currency: string;
      amount: number;
      availableFrom?: any | null;
      expireAt?: any | null;
      totalUsed: Array<{
        __typename?: "GiftBatchGiftCodesAggregateResponse";
        count?: {
          __typename?: "GiftBatchGiftCodesCountAggregate";
          id?: number | null;
        } | null;
      }>;
      totalUnused: Array<{
        __typename?: "GiftBatchGiftCodesAggregateResponse";
        count?: {
          __typename?: "GiftBatchGiftCodesCountAggregate";
          id?: number | null;
        } | null;
      }>;
    }>;
  };
  giftBatchSummary: {
    __typename?: "GiftBatchConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "GiftBatch";
      id: string;
      availableFrom?: any | null;
      expireAt?: any | null;
      totalUsed: Array<{
        __typename?: "GiftBatchGiftCodesAggregateResponse";
        count?: {
          __typename?: "GiftBatchGiftCodesCountAggregate";
          id?: number | null;
        } | null;
      }>;
      totalUnused: Array<{
        __typename?: "GiftBatchGiftCodesAggregateResponse";
        count?: {
          __typename?: "GiftBatchGiftCodesCountAggregate";
          id?: number | null;
        } | null;
      }>;
    }>;
  };
};

export type CreateGiftBachMutationVariables = Exact<{
  input: CreateGiftBatchInput;
}>;

export type CreateGiftBachMutation = {
  __typename?: "Mutation";
  createGiftCardBatch: { __typename?: "GiftBatch"; id: string; name: string };
};

export type ViewGiftBatchQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewGiftBatchQuery = {
  __typename?: "Query";
  giftBatch: {
    __typename?: "GiftBatch";
    id: string;
    name: string;
    amount: number;
    currency: string;
    availableFrom?: any | null;
    expireAt?: any | null;
    totalUsed: Array<{
      __typename?: "GiftBatchGiftCodesAggregateResponse";
      count?: {
        __typename?: "GiftBatchGiftCodesCountAggregate";
        id?: number | null;
      } | null;
    }>;
    totalUnused: Array<{
      __typename?: "GiftBatchGiftCodesAggregateResponse";
      count?: {
        __typename?: "GiftBatchGiftCodesCountAggregate";
        id?: number | null;
      } | null;
    }>;
  };
};

export type GiftCodeListQueryVariables = Exact<{
  giftBatchId: Scalars["ID"]["input"];
  paging: OffsetPaging;
}>;

export type GiftCodeListQuery = {
  __typename?: "Query";
  giftBatch: {
    __typename?: "GiftBatch";
    giftCodes: {
      __typename?: "GiftBatchGiftCodesConnection";
      totalCount: number;
      nodes: Array<{
        __typename?: "GiftCode";
        id: string;
        code: string;
        usedAt?: any | null;
        riderTransaction?: {
          __typename?: "RiderTransaction";
          riderId: string;
          rider: {
            __typename?: "Rider";
            firstName?: string | null;
            lastName?: string | null;
          };
        } | null;
        driverTransaction?: {
          __typename?: "DriverTransaction";
          driverId?: string | null;
          driver?: {
            __typename?: "Driver";
            firstName?: string | null;
            lastName?: string | null;
          } | null;
        } | null;
      }>;
    };
  };
};

export type ExportGiftBatchToCsvMutationVariables = Exact<{
  giftBatchId: Scalars["ID"]["input"];
}>;

export type ExportGiftBatchToCsvMutation = {
  __typename?: "Mutation";
  exportGiftCardBatch: string;
};

export type RewardListQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;

export type RewardListQuery = {
  __typename?: "Query";
  rewards: {
    __typename?: "RewardConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "Reward";
      id: string;
      title: string;
      startDate?: any | null;
      endDate?: any | null;
      beneficiary: RewardBeneficiary;
      event: RewardEvent;
    }>;
  };
};

export type ViewRewardQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewRewardQuery = {
  __typename?: "Query";
  reward: {
    __typename?: "Reward";
    id: string;
    title: string;
    startDate?: any | null;
    endDate?: any | null;
    appType: RewardAppType;
    beneficiary: RewardBeneficiary;
    event: RewardEvent;
    creditGift: number;
    tripFeePercentGift?: number | null;
    creditCurrency?: string | null;
    conditionTripCountsLessThan?: number | null;
    conditionUserNumberFirstDigits?: Array<string> | null;
  };
};

export type CreateRewardMutationVariables = Exact<{
  input: CreateReward;
}>;

export type CreateRewardMutation = {
  __typename?: "Mutation";
  createOneReward: { __typename?: "Reward"; id: string };
};

export type UpdateRewardMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: UpdateReward;
}>;

export type UpdateRewardMutation = {
  __typename?: "Mutation";
  updateOneReward: { __typename?: "Reward"; id: string };
};

export type CreatePayoutSessionFieldsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CreatePayoutSessionFieldsQuery = {
  __typename?: "Query";
  supportedCurrencies: Array<string>;
  payoutMethods: {
    __typename?: "PayoutMethodConnection";
    nodes: Array<{ __typename?: "PayoutMethod"; id: string; name: string }>;
  };
};

export type CreatePayoutSessionMutationVariables = Exact<{
  input: CreatePayoutSessionInput;
}>;

export type CreatePayoutSessionMutation = {
  __typename?: "Mutation";
  createTaxiPayoutSession: { __typename?: "TaxiPayoutSession"; id: string };
};

export type PayoutMethodsQueryVariables = Exact<{ [key: string]: never }>;

export type PayoutMethodsQuery = {
  __typename?: "Query";
  payoutMethods: {
    __typename?: "PayoutMethodConnection";
    nodes: Array<{
      __typename?: "PayoutMethod";
      id: string;
      name: string;
      description?: string | null;
      type: PayoutMethodType;
      media?: { __typename?: "Media"; id: string; address: string } | null;
    }>;
  };
};

export type ViewPayoutMethodQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewPayoutMethodQuery = {
  __typename?: "Query";
  payoutMethod: {
    __typename?: "PayoutMethod";
    id: string;
    name: string;
    currency: string;
    description?: string | null;
    type: PayoutMethodType;
    privateKey?: string | null;
    publicKey?: string | null;
    saltKey?: string | null;
    merchantId?: string | null;
    media?: { __typename?: "Media"; address: string } | null;
  };
};

export type CreatePayoutMethodMutationVariables = Exact<{
  input: CreatePayoutMethodInput;
}>;

export type CreatePayoutMethodMutation = {
  __typename?: "Mutation";
  createOnePayoutMethod: { __typename?: "PayoutMethod"; id: string };
};

export type UpdatePayoutMethodMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  update: CreatePayoutMethodInput;
}>;

export type UpdatePayoutMethodMutation = {
  __typename?: "Mutation";
  updateOnePayoutMethod: { __typename?: "PayoutMethod"; id: string };
};

export type PayoutsQueryVariables = Exact<{
  sessionsPaging: OffsetPaging;
  currency?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type PayoutsQuery = {
  __typename?: "Query";
  supportedCurrencies: Array<string>;
  taxiPayoutStatistics: {
    __typename?: "PayoutStatistics";
    pendingAmount: number;
    lastPayoutAmount: number;
    currency: string;
    usersDefaultPayoutMethodStats: Array<{
      __typename?: "PayoutMethodStats";
      totalCount: number;
      payoutMethod?: {
        __typename?: "PayoutMethod";
        id: string;
        name: string;
      } | null;
    }>;
  };
  taxiPayoutSessions: {
    __typename?: "TaxiPayoutSessionConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "TaxiPayoutSession";
      id: string;
      createdAt: any;
      processedAt?: any | null;
      status: PayoutSessionStatus;
      totalAmount: number;
      currency: string;
    }>;
  };
};

export type ViewPayoutSessionQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewPayoutSessionQuery = {
  __typename?: "Query";
  taxiPayoutSession: {
    __typename?: "TaxiPayoutSession";
    id: string;
    currency: string;
    createdAt: any;
    processedAt?: any | null;
    totalAmount: number;
    status: PayoutSessionStatus;
    payoutMethods: Array<{
      __typename?: "PayoutMethod";
      id: string;
      type: PayoutMethodType;
      name: string;
      description?: string | null;
      currency: string;
      balance?: number | null;
      media?: { __typename?: "Media"; address: string } | null;
    }>;
    driverTransactions: {
      __typename?: "TaxiPayoutSessionDriverTransactionsConnection";
      nodes: Array<{
        __typename?: "DriverTransaction";
        amount: number;
        currency: string;
        status: TransactionStatus;
        createdAt: any;
        driver?: {
          __typename?: "Driver";
          firstName?: string | null;
          lastName?: string | null;
          media?: { __typename?: "Media"; address: string } | null;
        } | null;
      }>;
    };
    amountToBePaidByPayoutMethod: Array<{
      __typename?: "TaxiPayoutSessionDriverTransactionsAggregateResponse";
      groupBy?: {
        __typename?: "TaxiPayoutSessionDriverTransactionsAggregateGroupBy";
        payoutMethodId?: string | null;
      } | null;
      sum?: {
        __typename?: "TaxiPayoutSessionDriverTransactionsSumAggregate";
        amount?: number | null;
      } | null;
    }>;
    unpaidAmount: Array<{
      __typename?: "TaxiPayoutSessionDriverTransactionsAggregateResponse";
      sum?: {
        __typename?: "TaxiPayoutSessionDriverTransactionsSumAggregate";
        amount?: number | null;
      } | null;
    }>;
    paidAmount: Array<{
      __typename?: "TaxiPayoutSessionDriverTransactionsAggregateResponse";
      sum?: {
        __typename?: "TaxiPayoutSessionDriverTransactionsSumAggregate";
        amount?: number | null;
      } | null;
    }>;
  };
};

export type PayoutSessionTransactionsQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  paging: OffsetPaging;
}>;

export type PayoutSessionTransactionsQuery = {
  __typename?: "Query";
  taxiPayoutSession: {
    __typename?: "TaxiPayoutSession";
    driverTransactions: {
      __typename?: "TaxiPayoutSessionDriverTransactionsConnection";
      nodes: Array<{
        __typename?: "DriverTransaction";
        id: string;
        amount: number;
        currency: string;
        status: TransactionStatus;
        createdAt: any;
        driver?: {
          __typename?: "Driver";
          firstName?: string | null;
          lastName?: string | null;
          media?: { __typename?: "Media"; address: string } | null;
          payoutAccounts: {
            __typename?: "DriverPayoutAccountsConnection";
            nodes: Array<{
              __typename?: "PayoutAccount";
              id: string;
              name: string;
              type: SavedPaymentMethodType;
              accountNumber?: string | null;
              routingNumber?: string | null;
              bankName?: string | null;
              branchName?: string | null;
              accountHolderName?: string | null;
              accountHolderCountry?: string | null;
              accountHolderCity?: string | null;
              accountHolderState?: string | null;
              accountHolderZip?: string | null;
              accountHolderAddress?: string | null;
              accountHolderDateOfBirth?: any | null;
              payoutMethod: {
                __typename?: "PayoutMethod";
                name: string;
                media?: { __typename?: "Media"; address: string } | null;
              };
            }>;
          };
        } | null;
      }>;
    };
  };
};

export type ExportToCsvMutationVariables = Exact<{
  input: ExportSessionToCsvInput;
}>;

export type ExportToCsvMutation = {
  __typename?: "Mutation";
  exportTaxiPayoutSessionToCsv: string;
};

export type RunAutoPayoutMutationVariables = Exact<{
  input: RunAutoPayoutInput;
}>;

export type RunAutoPayoutMutation = {
  __typename?: "Mutation";
  runTaxiAutoPayout: boolean;
};

export type SaveManualPayoutItemMutationVariables = Exact<{
  input: ManualPayoutInput;
}>;

export type SaveManualPayoutItemMutation = {
  __typename?: "Mutation";
  taxiManualPayout: { __typename?: "DriverTransaction"; amount: number };
};

export type UpdatePayoutSessionMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  update: UpdatePayoutSessionInput;
}>;

export type UpdatePayoutSessionMutation = {
  __typename?: "Mutation";
  updateOneTaxiPayoutSession: {
    __typename?: "TaxiPayoutSession";
    id: string;
    status: PayoutSessionStatus;
  };
};

export type DriverClosingRecordFieldsFragment = {
  __typename?: "DriverClosingRecordDTO";
  id: string;
  recordNumber: string;
  driverId: string;
  driverName: string;
  driverMobile?: string | null;
  periodStart: any;
  periodEnd: any;
  businessTimezone: string;
  tripCount: number;
  generatedRevenue: string;
  manualPosAmount: string;
  chargingAmount: string;
  parkingAmount: string;
  tollsAmount: string;
  otherDeductibleAmount: string;
  otherDeductibleNote?: string | null;
  totalCommission: string;
  totalDeductions: string;
  amountToHandOver: string;
  notes?: string | null;
  status: DriverClosingRecordStatus;
  createdByOperatorId?: string | null;
  createdByName: string;
  createdBySystemType?: OperatorRoleSystemType | null;
  createdByRole?: string | null;
  finalizedByOperatorId?: string | null;
  finalizedByName?: string | null;
  finalizedAt?: any | null;
  createdAt: any;
  updatedAt: any;
  commissions: Array<{
    __typename?: "DriverClosingCommissionDTO";
    id: string;
    partnerId: string;
    partnerName: string;
    partnerType: CommissionPartnerType;
    calculationMode: DriverClosingCommissionCalculationMode;
    orderId?: string | null;
    orderReference?: string | null;
    tripReportTimestamp?: any | null;
    tripRevenue?: string | null;
    commissionRatePercent?: string | null;
    currentPartnerRatePercent?: string | null;
    partnerRateChanged: boolean;
    amount: string;
    note?: string | null;
  }>;
  corrections: Array<{
    __typename?: "DriverClosingCorrectionDTO";
    id: string;
    reason: string;
    reopenedByOperatorId?: string | null;
    reopenedByName: string;
    previousFinalizedByName?: string | null;
    previousFinalizedAt?: any | null;
    createdAt: any;
  }>;
};

export type DriverClosingDriversQueryVariables = Exact<{
  search?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type DriverClosingDriversQuery = {
  __typename?: "Query";
  driverClosingDrivers: Array<{
    __typename?: "DriverClosingDriverDTO";
    id: string;
    displayName: string;
    mobileNumber: string;
  }>;
};

export type PreviewDriverClosingRevenueQueryVariables = Exact<{
  driverId: Scalars["ID"]["input"];
  periodStartLocal: Scalars["String"]["input"];
  periodEndLocal: Scalars["String"]["input"];
  paging?: InputMaybe<ClosingPaginationInput>;
}>;

export type PreviewDriverClosingRevenueQuery = {
  __typename?: "Query";
  previewDriverClosingRevenue: {
    __typename?: "DriverClosingPreviewDTO";
    driverId: string;
    driverName: string;
    periodStart: any;
    periodEnd: any;
    tripCount: number;
    generatedRevenue: string;
    currency: string;
    includedTrips: Array<{
      __typename?: "DriverClosingPreviewTripDTO";
      orderId: string;
      orderReference: string;
      reportTimestamp: any;
      revenueAmount: string;
      status: string;
      source?: string | null;
      paymentMethod?: string | null;
      pickupAddress?: string | null;
      destinationAddress?: string | null;
    }>;
    includedTripsPageInfo: {
      __typename?: "DriverClosingPreviewPageInfoDTO";
      first: number;
      after: number;
      hasNextPage: boolean;
    };
  };
};

export type DriverClosingRecordsQueryVariables = Exact<{
  paging?: InputMaybe<ClosingPaginationInput>;
  filter?: InputMaybe<DriverClosingRecordFilterInput>;
}>;

export type DriverClosingRecordsQuery = {
  __typename?: "Query";
  driverClosingRecords: {
    __typename?: "DriverClosingRecordConnectionDTO";
    totalCount: number;
    nodes: Array<{
      __typename?: "DriverClosingRecordDTO";
      id: string;
      recordNumber: string;
      driverId: string;
      driverName: string;
      driverMobile?: string | null;
      periodStart: any;
      periodEnd: any;
      businessTimezone: string;
      tripCount: number;
      generatedRevenue: string;
      manualPosAmount: string;
      chargingAmount: string;
      parkingAmount: string;
      tollsAmount: string;
      otherDeductibleAmount: string;
      otherDeductibleNote?: string | null;
      totalCommission: string;
      totalDeductions: string;
      amountToHandOver: string;
      notes?: string | null;
      status: DriverClosingRecordStatus;
      createdByOperatorId?: string | null;
      createdByName: string;
      createdBySystemType?: OperatorRoleSystemType | null;
      createdByRole?: string | null;
      finalizedByOperatorId?: string | null;
      finalizedByName?: string | null;
      finalizedAt?: any | null;
      createdAt: any;
      updatedAt: any;
      commissions: Array<{
        __typename?: "DriverClosingCommissionDTO";
        id: string;
        partnerId: string;
        partnerName: string;
        partnerType: CommissionPartnerType;
        calculationMode: DriverClosingCommissionCalculationMode;
        orderId?: string | null;
        orderReference?: string | null;
        tripReportTimestamp?: any | null;
        tripRevenue?: string | null;
        commissionRatePercent?: string | null;
        currentPartnerRatePercent?: string | null;
        partnerRateChanged: boolean;
        amount: string;
        note?: string | null;
      }>;
      corrections: Array<{
        __typename?: "DriverClosingCorrectionDTO";
        id: string;
        reason: string;
        reopenedByOperatorId?: string | null;
        reopenedByName: string;
        previousFinalizedByName?: string | null;
        previousFinalizedAt?: any | null;
        createdAt: any;
      }>;
    }>;
  };
};

export type DriverClosingRecordQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DriverClosingRecordQuery = {
  __typename?: "Query";
  driverClosingRecord: {
    __typename?: "DriverClosingRecordDTO";
    id: string;
    recordNumber: string;
    driverId: string;
    driverName: string;
    driverMobile?: string | null;
    periodStart: any;
    periodEnd: any;
    businessTimezone: string;
    tripCount: number;
    generatedRevenue: string;
    manualPosAmount: string;
    chargingAmount: string;
    parkingAmount: string;
    tollsAmount: string;
    otherDeductibleAmount: string;
    otherDeductibleNote?: string | null;
    totalCommission: string;
    totalDeductions: string;
    amountToHandOver: string;
    notes?: string | null;
    status: DriverClosingRecordStatus;
    createdByOperatorId?: string | null;
    createdByName: string;
    createdBySystemType?: OperatorRoleSystemType | null;
    createdByRole?: string | null;
    finalizedByOperatorId?: string | null;
    finalizedByName?: string | null;
    finalizedAt?: any | null;
    createdAt: any;
    updatedAt: any;
    commissions: Array<{
      __typename?: "DriverClosingCommissionDTO";
      id: string;
      partnerId: string;
      partnerName: string;
      partnerType: CommissionPartnerType;
      calculationMode: DriverClosingCommissionCalculationMode;
      orderId?: string | null;
      orderReference?: string | null;
      tripReportTimestamp?: any | null;
      tripRevenue?: string | null;
      commissionRatePercent?: string | null;
      currentPartnerRatePercent?: string | null;
      partnerRateChanged: boolean;
      amount: string;
      note?: string | null;
    }>;
    corrections: Array<{
      __typename?: "DriverClosingCorrectionDTO";
      id: string;
      reason: string;
      reopenedByOperatorId?: string | null;
      reopenedByName: string;
      previousFinalizedByName?: string | null;
      previousFinalizedAt?: any | null;
      createdAt: any;
    }>;
  };
};

export type EligibleDriverClosingCommissionTripsQueryVariables = Exact<{
  input: EligibleDriverClosingCommissionTripsInput;
}>;

export type EligibleDriverClosingCommissionTripsQuery = {
  __typename?: "Query";
  eligibleDriverClosingCommissionTrips: Array<{
    __typename?: "EligibleDriverClosingCommissionTripDTO";
    orderId: string;
    orderReference: string;
    reportTimestamp: any;
    revenueAmount: string;
    vehiclePlate?: string | null;
    serviceName?: string | null;
    currency: string;
    commissionRatePercent?: string | null;
    calculatedCommissionAmount?: string | null;
  }>;
};

export type CreateDriverClosingDraftMutationVariables = Exact<{
  input: DriverClosingDraftInput;
}>;

export type CreateDriverClosingDraftMutation = {
  __typename?: "Mutation";
  createDriverClosingDraft: {
    __typename?: "DriverClosingRecordDTO";
    id: string;
    recordNumber: string;
    driverId: string;
    driverName: string;
    driverMobile?: string | null;
    periodStart: any;
    periodEnd: any;
    businessTimezone: string;
    tripCount: number;
    generatedRevenue: string;
    manualPosAmount: string;
    chargingAmount: string;
    parkingAmount: string;
    tollsAmount: string;
    otherDeductibleAmount: string;
    otherDeductibleNote?: string | null;
    totalCommission: string;
    totalDeductions: string;
    amountToHandOver: string;
    notes?: string | null;
    status: DriverClosingRecordStatus;
    createdByOperatorId?: string | null;
    createdByName: string;
    createdBySystemType?: OperatorRoleSystemType | null;
    createdByRole?: string | null;
    finalizedByOperatorId?: string | null;
    finalizedByName?: string | null;
    finalizedAt?: any | null;
    createdAt: any;
    updatedAt: any;
    commissions: Array<{
      __typename?: "DriverClosingCommissionDTO";
      id: string;
      partnerId: string;
      partnerName: string;
      partnerType: CommissionPartnerType;
      calculationMode: DriverClosingCommissionCalculationMode;
      orderId?: string | null;
      orderReference?: string | null;
      tripReportTimestamp?: any | null;
      tripRevenue?: string | null;
      commissionRatePercent?: string | null;
      currentPartnerRatePercent?: string | null;
      partnerRateChanged: boolean;
      amount: string;
      note?: string | null;
    }>;
    corrections: Array<{
      __typename?: "DriverClosingCorrectionDTO";
      id: string;
      reason: string;
      reopenedByOperatorId?: string | null;
      reopenedByName: string;
      previousFinalizedByName?: string | null;
      previousFinalizedAt?: any | null;
      createdAt: any;
    }>;
  };
};

export type UpdateDriverClosingDraftMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: DriverClosingDraftInput;
}>;

export type UpdateDriverClosingDraftMutation = {
  __typename?: "Mutation";
  updateDriverClosingDraft: {
    __typename?: "DriverClosingRecordDTO";
    id: string;
    recordNumber: string;
    driverId: string;
    driverName: string;
    driverMobile?: string | null;
    periodStart: any;
    periodEnd: any;
    businessTimezone: string;
    tripCount: number;
    generatedRevenue: string;
    manualPosAmount: string;
    chargingAmount: string;
    parkingAmount: string;
    tollsAmount: string;
    otherDeductibleAmount: string;
    otherDeductibleNote?: string | null;
    totalCommission: string;
    totalDeductions: string;
    amountToHandOver: string;
    notes?: string | null;
    status: DriverClosingRecordStatus;
    createdByOperatorId?: string | null;
    createdByName: string;
    createdBySystemType?: OperatorRoleSystemType | null;
    createdByRole?: string | null;
    finalizedByOperatorId?: string | null;
    finalizedByName?: string | null;
    finalizedAt?: any | null;
    createdAt: any;
    updatedAt: any;
    commissions: Array<{
      __typename?: "DriverClosingCommissionDTO";
      id: string;
      partnerId: string;
      partnerName: string;
      partnerType: CommissionPartnerType;
      calculationMode: DriverClosingCommissionCalculationMode;
      orderId?: string | null;
      orderReference?: string | null;
      tripReportTimestamp?: any | null;
      tripRevenue?: string | null;
      commissionRatePercent?: string | null;
      currentPartnerRatePercent?: string | null;
      partnerRateChanged: boolean;
      amount: string;
      note?: string | null;
    }>;
    corrections: Array<{
      __typename?: "DriverClosingCorrectionDTO";
      id: string;
      reason: string;
      reopenedByOperatorId?: string | null;
      reopenedByName: string;
      previousFinalizedByName?: string | null;
      previousFinalizedAt?: any | null;
      createdAt: any;
    }>;
  };
};

export type DeleteDriverClosingDraftMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteDriverClosingDraftMutation = {
  __typename?: "Mutation";
  deleteDriverClosingDraft: boolean;
};

export type DeleteDriverClosingRecordMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteDriverClosingRecordMutation = {
  __typename?: "Mutation";
  deleteDriverClosingRecord: boolean;
};

export type FinalizeDriverClosingRecordMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type FinalizeDriverClosingRecordMutation = {
  __typename?: "Mutation";
  finalizeDriverClosingRecord: {
    __typename?: "DriverClosingRecordDTO";
    id: string;
    recordNumber: string;
    driverId: string;
    driverName: string;
    driverMobile?: string | null;
    periodStart: any;
    periodEnd: any;
    businessTimezone: string;
    tripCount: number;
    generatedRevenue: string;
    manualPosAmount: string;
    chargingAmount: string;
    parkingAmount: string;
    tollsAmount: string;
    otherDeductibleAmount: string;
    otherDeductibleNote?: string | null;
    totalCommission: string;
    totalDeductions: string;
    amountToHandOver: string;
    notes?: string | null;
    status: DriverClosingRecordStatus;
    createdByOperatorId?: string | null;
    createdByName: string;
    createdBySystemType?: OperatorRoleSystemType | null;
    createdByRole?: string | null;
    finalizedByOperatorId?: string | null;
    finalizedByName?: string | null;
    finalizedAt?: any | null;
    createdAt: any;
    updatedAt: any;
    commissions: Array<{
      __typename?: "DriverClosingCommissionDTO";
      id: string;
      partnerId: string;
      partnerName: string;
      partnerType: CommissionPartnerType;
      calculationMode: DriverClosingCommissionCalculationMode;
      orderId?: string | null;
      orderReference?: string | null;
      tripReportTimestamp?: any | null;
      tripRevenue?: string | null;
      commissionRatePercent?: string | null;
      currentPartnerRatePercent?: string | null;
      partnerRateChanged: boolean;
      amount: string;
      note?: string | null;
    }>;
    corrections: Array<{
      __typename?: "DriverClosingCorrectionDTO";
      id: string;
      reason: string;
      reopenedByOperatorId?: string | null;
      reopenedByName: string;
      previousFinalizedByName?: string | null;
      previousFinalizedAt?: any | null;
      createdAt: any;
    }>;
  };
};

export type ReopenDriverClosingRecordMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  reason: Scalars["String"]["input"];
}>;

export type ReopenDriverClosingRecordMutation = {
  __typename?: "Mutation";
  reopenDriverClosingRecord: {
    __typename?: "DriverClosingRecordDTO";
    id: string;
    recordNumber: string;
    driverId: string;
    driverName: string;
    driverMobile?: string | null;
    periodStart: any;
    periodEnd: any;
    businessTimezone: string;
    tripCount: number;
    generatedRevenue: string;
    manualPosAmount: string;
    chargingAmount: string;
    parkingAmount: string;
    tollsAmount: string;
    otherDeductibleAmount: string;
    otherDeductibleNote?: string | null;
    totalCommission: string;
    totalDeductions: string;
    amountToHandOver: string;
    notes?: string | null;
    status: DriverClosingRecordStatus;
    createdByOperatorId?: string | null;
    createdByName: string;
    createdBySystemType?: OperatorRoleSystemType | null;
    createdByRole?: string | null;
    finalizedByOperatorId?: string | null;
    finalizedByName?: string | null;
    finalizedAt?: any | null;
    createdAt: any;
    updatedAt: any;
    commissions: Array<{
      __typename?: "DriverClosingCommissionDTO";
      id: string;
      partnerId: string;
      partnerName: string;
      partnerType: CommissionPartnerType;
      calculationMode: DriverClosingCommissionCalculationMode;
      orderId?: string | null;
      orderReference?: string | null;
      tripReportTimestamp?: any | null;
      tripRevenue?: string | null;
      commissionRatePercent?: string | null;
      currentPartnerRatePercent?: string | null;
      partnerRateChanged: boolean;
      amount: string;
      note?: string | null;
    }>;
    corrections: Array<{
      __typename?: "DriverClosingCorrectionDTO";
      id: string;
      reason: string;
      reopenedByOperatorId?: string | null;
      reopenedByName: string;
      previousFinalizedByName?: string | null;
      previousFinalizedAt?: any | null;
      createdAt: any;
    }>;
  };
};

export type UseCurrentDriverClosingCommissionRateMutationVariables = Exact<{
  entryId: Scalars["ID"]["input"];
}>;

export type UseCurrentDriverClosingCommissionRateMutation = {
  __typename?: "Mutation";
  useCurrentDriverClosingCommissionRate: {
    __typename?: "DriverClosingRecordDTO";
    id: string;
    recordNumber: string;
    driverId: string;
    driverName: string;
    driverMobile?: string | null;
    periodStart: any;
    periodEnd: any;
    businessTimezone: string;
    tripCount: number;
    generatedRevenue: string;
    manualPosAmount: string;
    chargingAmount: string;
    parkingAmount: string;
    tollsAmount: string;
    otherDeductibleAmount: string;
    otherDeductibleNote?: string | null;
    totalCommission: string;
    totalDeductions: string;
    amountToHandOver: string;
    notes?: string | null;
    status: DriverClosingRecordStatus;
    createdByOperatorId?: string | null;
    createdByName: string;
    createdBySystemType?: OperatorRoleSystemType | null;
    createdByRole?: string | null;
    finalizedByOperatorId?: string | null;
    finalizedByName?: string | null;
    finalizedAt?: any | null;
    createdAt: any;
    updatedAt: any;
    commissions: Array<{
      __typename?: "DriverClosingCommissionDTO";
      id: string;
      partnerId: string;
      partnerName: string;
      partnerType: CommissionPartnerType;
      calculationMode: DriverClosingCommissionCalculationMode;
      orderId?: string | null;
      orderReference?: string | null;
      tripReportTimestamp?: any | null;
      tripRevenue?: string | null;
      commissionRatePercent?: string | null;
      currentPartnerRatePercent?: string | null;
      partnerRateChanged: boolean;
      amount: string;
      note?: string | null;
    }>;
    corrections: Array<{
      __typename?: "DriverClosingCorrectionDTO";
      id: string;
      reason: string;
      reopenedByOperatorId?: string | null;
      reopenedByName: string;
      previousFinalizedByName?: string | null;
      previousFinalizedAt?: any | null;
      createdAt: any;
    }>;
  };
};

export type CommissionPartnersQueryVariables = Exact<{
  paging?: InputMaybe<ClosingPaginationInput>;
  filter?: InputMaybe<CommissionPartnerFilterInput>;
}>;

export type CommissionPartnersQuery = {
  __typename?: "Query";
  commissionPartners: {
    __typename?: "CommissionPartnerConnectionDTO";
    totalCount: number;
    nodes: Array<{
      __typename?: "CommissionPartnerDTO";
      id: string;
      name: string;
      type: CommissionPartnerType;
      active: boolean;
      commissionRatePercent?: string | null;
      notes?: string | null;
      usedHistorically: boolean;
      createdAt: any;
      updatedAt: any;
    }>;
  };
};

export type CreateCommissionPartnerMutationVariables = Exact<{
  input: CommissionPartnerInput;
}>;

export type CreateCommissionPartnerMutation = {
  __typename?: "Mutation";
  createCommissionPartner: {
    __typename?: "CommissionPartnerDTO";
    id: string;
    name: string;
    type: CommissionPartnerType;
    active: boolean;
    commissionRatePercent?: string | null;
    notes?: string | null;
    usedHistorically: boolean;
    createdAt: any;
    updatedAt: any;
  };
};

export type UpdateCommissionPartnerMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: CommissionPartnerInput;
}>;

export type UpdateCommissionPartnerMutation = {
  __typename?: "Mutation";
  updateCommissionPartner: {
    __typename?: "CommissionPartnerDTO";
    id: string;
    name: string;
    type: CommissionPartnerType;
    active: boolean;
    commissionRatePercent?: string | null;
    notes?: string | null;
    usedHistorically: boolean;
    createdAt: any;
    updatedAt: any;
  };
};

export type SetCommissionPartnerActiveMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  active: Scalars["Boolean"]["input"];
}>;

export type SetCommissionPartnerActiveMutation = {
  __typename?: "Mutation";
  setCommissionPartnerActive: {
    __typename?: "CommissionPartnerDTO";
    id: string;
    active: boolean;
  };
};

export type DeleteCommissionPartnerMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteCommissionPartnerMutation = {
  __typename?: "Mutation";
  deleteCommissionPartner: boolean;
};

export type DriverCommissionReportQueryVariables = Exact<{
  paging?: InputMaybe<ClosingPaginationInput>;
  filter?: InputMaybe<CommissionReportFilterInput>;
}>;

export type DriverCommissionReportQuery = {
  __typename?: "Query";
  driverCommissionReport: {
    __typename?: "CommissionReportConnectionDTO";
    totalCount: number;
    nodes: Array<{
      __typename?: "CommissionReportRowDTO";
      id: string;
      partnerId: string;
      partnerName: string;
      partnerType: CommissionPartnerType;
      driverId: string;
      driverName: string;
      closingRecordId: string;
      recordNumber: string;
      periodStart: any;
      periodEnd: any;
      calculationMode: DriverClosingCommissionCalculationMode;
      orderId?: string | null;
      orderReference?: string | null;
      tripReportTimestamp?: any | null;
      tripRevenue?: string | null;
      commissionRatePercent?: string | null;
      amount: string;
      note?: string | null;
      createdByName: string;
      createdAt: any;
      finalizedAt?: any | null;
      status: DriverClosingRecordStatus;
    }>;
    summary: {
      __typename?: "CommissionReportSummaryDTO";
      totalCommission: string;
      entryCount: number;
      recordCount: number;
      partnerCount: number;
      commissionedTripCount: number;
    };
  };
};

export type ExportDriverClosingRecordQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ExportDriverClosingRecordQuery = {
  __typename?: "Query";
  exportDriverClosingRecord: { __typename?: "ExportResult"; url: string };
};

export type ExportDriverClosingRecordsQueryVariables = Exact<{
  filter?: InputMaybe<DriverClosingRecordFilterInput>;
}>;

export type ExportDriverClosingRecordsQuery = {
  __typename?: "Query";
  exportDriverClosingRecords: { __typename?: "ExportResult"; url: string };
};

export type ExportDriverCommissionReportQueryVariables = Exact<{
  filter?: InputMaybe<CommissionReportFilterInput>;
}>;

export type ExportDriverCommissionReportQuery = {
  __typename?: "Query";
  exportDriverCommissionReport: { __typename?: "ExportResult"; url: string };
};

export type DriverTripReportQueryVariables = Exact<{
  paging?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<DriverTripReportFilterInput>;
}>;

export type DriverTripReportQuery = {
  __typename?: "Query";
  driverTripReport: {
    __typename?: "DriverTripReportConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "DriverTripReportRow";
      orderId: string;
      driverId?: string | null;
      driverName: string;
      operatorId?: string | null;
      operatorName?: string | null;
      plateNumber: string;
      pickupAddress: string;
      destinationAddress: string;
      departureTime: any;
      arrivalTime?: any | null;
      fareMode: FareMode;
      finalPrice: number;
      currency: string;
      paymentMode?: PaymentMode | null;
      orderSource: OrderSource;
      reportingSource?: OrderSource | null;
      status: OrderStatus;
    }>;
  };
};

export type ExportDriverTripReportToExcelMutationVariables = Exact<{
  filter?: InputMaybe<DriverTripReportFilterInput>;
}>;

export type ExportDriverTripReportToExcelMutation = {
  __typename?: "Mutation";
  exportDriverTripReportToExcel: { __typename?: "ExportResult"; url: string };
};

export type AvailableDriversForOrderQueryVariables = Exact<{
  center: PointInput;
  count: Scalars["Int"]["input"];
}>;

export type AvailableDriversForOrderQuery = {
  __typename?: "Query";
  getDriversLocationWithData: Array<{
    __typename?: "OnlineDriverWithData";
    id: string;
    mobileNumber: string;
    firstName?: string | null;
    lastName?: string | null;
    lastUpdatedAt: any;
    rating?: number | null;
    reviewCount: number;
    status: DriverStatus;
    location: { __typename?: "Point"; lat: number; lng: number };
  }>;
};

export type DriverSearchQueryVariables = Exact<{
  filter: Scalars["String"]["input"];
}>;

export type DriverSearchQuery = {
  __typename?: "Query";
  drivers: {
    __typename?: "DriverConnection";
    nodes: Array<{
      __typename?: "Driver";
      id: string;
      mobileNumber: string;
      firstName?: string | null;
      lastName?: string | null;
      rating?: number | null;
      reviewCount: number;
      status: DriverStatus;
    }>;
  };
};

export type AssignDriverToOrderMutationVariables = Exact<{
  orderId: Scalars["ID"]["input"];
  driverId: Scalars["ID"]["input"];
}>;

export type AssignDriverToOrderMutation = {
  __typename?: "Mutation";
  assignDriverToOrder: { __typename?: "Order"; id: string };
};

export type ViewOrderQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewOrderQuery = {
  __typename?: "Query";
  order: {
    __typename?: "Order";
    id: string;
    riderBookingSetupStatus?: string | null;
    createdOn: any;
    expectedTimestamp?: any | null;
    isScheduled: boolean;
    scheduledAt?: any | null;
    scheduleStatus?: ScheduleStatus | null;
    scheduledAssignmentMode?: ScheduledAssignmentMode | null;
    scheduledDriverId?: string | null;
    scheduledDriverConfirmedAt?: any | null;
    scheduleRevision: number;
    scheduleNotes?: string | null;
    nextAvailableDriverId?: string | null;
    nextAvailableHoldExpiresAt?: any | null;
    nextAvailableEstimatedPickupAt?: any | null;
    nextAvailableEtaSeconds?: number | null;
    nextAvailablePickupDistanceMeters?: number | null;
    nextAvailableAttemptCount: number;
    nextAvailableFailureReason?: string | null;
    nextAvailableCandidateStillFeasible?: boolean | null;
    nextAvailableOperationCenterPhoneNumber?: string | null;
    costBest: number;
    costAfterCoupon: number;
    waitMinutes: number;
    waitCost: number;
    estimatedFixedPrice?: number | null;
    meterAmount?: number | null;
    meterExtrasAmount?: number | null;
    finalCollectedAmount?: number | null;
    meterCurrency?: string | null;
    meterNote?: string | null;
    meterPhotoUrl?: string | null;
    meterEnteredAt?: any | null;
    status: OrderStatus;
    currency: string;
    fareMode: FareMode;
    paymentMode?: PaymentMode | null;
    orderSource: OrderSource;
    reportingSource?: OrderSource | null;
    operatorId?: string | null;
    operatorDisplayName?: string | null;
    settlementSource?: SettlementSource | null;
    vehicleId?: string | null;
    driverVehicleAssignmentId?: string | null;
    vehiclePlate?: string | null;
    vehicleModel?: string | null;
    vehicleColor?: string | null;
    vehicleProductionYear?: number | null;
    vehicleSnapshotSource?: VehicleSnapshotSource | null;
    tariffProfileTitle?: string | null;
    tariffProfileCode?: string | null;
    couponCode?: string | null;
    distanceBest: number;
    durationBest: number;
    pickupEta?: any | null;
    dropOffEta?: any | null;
    startTimestamp?: any | null;
    finishTimestamp?: any | null;
    streetPassengerName?: string | null;
    streetPassengerPhone?: string | null;
    streetPassengerNationality?: string | null;
    isAnonymousPassenger: boolean;
    createdDirectlyByDriverId?: string | null;
    addresses: Array<string>;
    serviceName?: string | null;
    nextAvailableDriver?: {
      __typename?: "Driver";
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      mobileNumber: string;
      status: DriverStatus;
      carPlate?: string | null;
    } | null;
    nextAvailableReservation?: {
      __typename?: "NextAvailableReservation";
      id: string;
      orderId: string;
      driverId: string;
      driverName: string;
      currentTripId: string;
      mode: string;
      status: string;
      generation: number;
      leaseVersion: number;
      latestEstimatedPickupAt?: any | null;
      latestEtaSeconds?: number | null;
      latestPickupDistanceMeters?: number | null;
      initialSoftExpiresAt: any;
      softExpiresAt: any;
      hardExpiresAt: any;
      lastRenewedAt?: any | null;
      renewalCount: number;
      etaState: string;
      offerSentAt?: any | null;
      endedAt?: any | null;
      endReason?: string | null;
      lastFailureCode?: string | null;
      createdAt: any;
      warningCode?: string | null;
      warningMessage?: string | null;
    } | null;
    finalPriceAdjustments: Array<{
      __typename?: "OrderFinalPriceAdjustment";
      id: string;
      orderId: string;
      oldFinalCollectedAmount?: number | null;
      newFinalCollectedAmount: number;
      oldSettlementSource?: SettlementSource | null;
      newSettlementSource?: SettlementSource | null;
      adjustedByOperatorId?: string | null;
      reason: string;
      note?: string | null;
      createdAt: any;
      actor: {
        __typename?: "OrderFinalPriceAdjustmentActor";
        displayName: string;
        systemType?: OperatorRoleSystemType | null;
        roleName?: string | null;
      };
    }>;
    points: Array<{ __typename?: "Point"; lat: number; lng: number }>;
    driver?: {
      __typename?: "Driver";
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      mobileNumber: string;
      registrationTimestamp: any;
      status: DriverStatus;
      carPlate?: string | null;
      media?: { __typename?: "Media"; address: string } | null;
    } | null;
    scheduledDriver?: {
      __typename?: "Driver";
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      mobileNumber: string;
      registrationTimestamp: any;
      status: DriverStatus;
      carPlate?: string | null;
      media?: { __typename?: "Media"; address: string } | null;
    } | null;
    rider?: {
      __typename?: "Rider";
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      mobileNumber?: string | null;
      registrationTimestamp: any;
      status: RiderStatus;
      media?: { __typename?: "Media"; address: string } | null;
    } | null;
    complaints: Array<{
      __typename?: "TaxiSupportRequest";
      id: string;
      subject: string;
      inscriptionTimestamp: any;
      content?: string | null;
      requestedByDriver: boolean;
    }>;
    conversation: Array<{
      __typename?: "OrderMessage";
      sentAt: any;
      sentByDriver: boolean;
      status: MessageStatus;
      content: string;
    }>;
    activities: Array<{
      __typename?: "RequestActivity";
      createdAt: any;
      type: RequestActivityType;
      operatorId?: string | null;
      operatorDisplayName?: string | null;
    }>;
    riderTransactions: Array<{
      __typename?: "RiderTransaction";
      action: TransactionAction;
      rechargeType?: RiderRechargeTransactionType | null;
      deductType?: RiderDeductTransactionType | null;
      amount: number;
      status: TransactionStatus;
      currency: string;
      refrenceNumber?: string | null;
    }>;
    driverTransactions: Array<{
      __typename?: "DriverTransaction";
      action: TransactionAction;
      rechargeType?: DriverRechargeTransactionType | null;
      deductType?: DriverDeductTransactionType | null;
      amount: number;
      status: TransactionStatus;
      currency: string;
      refrenceNumber?: string | null;
    }>;
    providerTransactions: Array<{
      __typename?: "ProviderTransaction";
      action: TransactionAction;
      rechargeType?: ProviderRechargeTransactionType | null;
      deductType?: ProviderDeductTransactionType | null;
      amount: number;
      currency: string;
      refrenceNumber?: string | null;
    }>;
    fleetTransactions: Array<{
      __typename?: "FleetTransaction";
      action: TransactionAction;
      rechargeType?: ProviderRechargeTransactionType | null;
      deductType?: ProviderDeductTransactionType | null;
      amount: number;
      currency: string;
      refrenceNumber?: string | null;
    }>;
  };
};

export type ForceCancelTaxiOrderMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ForceCancelTaxiOrderMutation = {
  __typename?: "Mutation";
  forceCancelTaxiOrder: {
    __typename?: "Order";
    id: string;
    status: OrderStatus;
  };
};

export type AdjustOrderFinalPriceMutationVariables = Exact<{
  orderId: Scalars["ID"]["input"];
  newAmount: Scalars["Float"]["input"];
  reason: Scalars["String"]["input"];
  note?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AdjustOrderFinalPriceMutation = {
  __typename?: "Mutation";
  adjustOrderFinalPrice: {
    __typename?: "OrderFinalPriceAdjustment";
    id: string;
    orderId: string;
    oldFinalCollectedAmount?: number | null;
    newFinalCollectedAmount: number;
    reason: string;
    note?: string | null;
    createdAt: any;
    actor: {
      __typename?: "OrderFinalPriceAdjustmentActor";
      displayName: string;
      systemType?: OperatorRoleSystemType | null;
      roleName?: string | null;
    };
  };
};

export type CloseRiderBookingReviewMutationVariables = Exact<{
  orderId: Scalars["ID"]["input"];
  expectedStatus: Scalars["String"]["input"];
  reason: Scalars["String"]["input"];
}>;

export type CloseRiderBookingReviewMutation = {
  __typename?: "Mutation";
  closeRiderBookingReview: boolean;
};

export type OrdersListQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
  filter?: InputMaybe<OrderFilter>;
  sorting?: InputMaybe<Array<OrderSort> | OrderSort>;
  todayStart: Scalars["DateTime"]["input"];
}>;

export type OrdersListQuery = {
  __typename?: "Query";
  totalRequests: { __typename?: "OrderConnection"; totalCount: number };
  urgentRequests: { __typename?: "OrderConnection"; totalCount: number };
  unassignedRequests: { __typename?: "OrderConnection"; totalCount: number };
  activeTrips: { __typename?: "OrderConnection"; totalCount: number };
  waitingNextAvailable: { __typename?: "OrderConnection"; totalCount: number };
  completedToday: { __typename?: "OrderConnection"; totalCount: number };
  orders: {
    __typename?: "OrderConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "Order";
      id: string;
      status: OrderStatus;
      orderSource: OrderSource;
      reportingSource?: OrderSource | null;
      createdOn: any;
      startTimestamp?: any | null;
      expectedTimestamp?: any | null;
      scheduledAt?: any | null;
      scheduleStatus?: ScheduleStatus | null;
      isScheduled: boolean;
      fareMode: FareMode;
      paymentMode?: PaymentMode | null;
      addresses: Array<string>;
      streetPassengerName?: string | null;
      streetPassengerPhone?: string | null;
      isAnonymousPassenger: boolean;
      meterAmount?: number | null;
      finalCollectedAmount?: number | null;
      estimatedFixedPrice?: number | null;
      nextAvailableEstimatedPickupAt?: any | null;
      nextAvailableEtaSeconds?: number | null;
      nextAvailablePickupDistanceMeters?: number | null;
      nextAvailableFailureReason?: string | null;
      nextAvailableHoldExpiresAt?: any | null;
      vehiclePlate?: string | null;
      costAfterCoupon: number;
      currency: string;
      operatorId?: string | null;
      operatorDisplayName?: string | null;
      serviceName?: string | null;
      rider?: {
        __typename?: "Rider";
        firstName?: string | null;
        lastName?: string | null;
        mobileNumber?: string | null;
      } | null;
      driver?: {
        __typename?: "Driver";
        firstName?: string | null;
        lastName?: string | null;
        mobileNumber: string;
        carPlate?: string | null;
      } | null;
      scheduledDriver?: {
        __typename?: "Driver";
        firstName?: string | null;
        lastName?: string | null;
        mobileNumber: string;
        carPlate?: string | null;
      } | null;
      nextAvailableDriver?: {
        __typename?: "Driver";
        firstName?: string | null;
        lastName?: string | null;
        mobileNumber: string;
        carPlate?: string | null;
      } | null;
    }>;
  };
};

export type OrderChangedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type OrderChangedSubscription = {
  __typename?: "Subscription";
  orderChanged: {
    __typename?: "OrderChangeEvent";
    orderId: string;
    status: OrderStatus;
    isScheduled: boolean;
    scheduleStatus?: ScheduleStatus | null;
    scheduledAt?: any | null;
    driverId?: string | null;
    scheduledDriverId?: string | null;
    driver?: {
      __typename?: "OrderChangeDriver";
      firstName?: string | null;
      lastName?: string | null;
      mobileNumber?: string | null;
    } | null;
  };
};

export type SearchDriversForOrderFilterQueryVariables = Exact<{
  query: Scalars["String"]["input"];
  limit?: Scalars["Int"]["input"];
}>;

export type SearchDriversForOrderFilterQuery = {
  __typename?: "Query";
  searchDriversForOrderFilter: Array<{
    __typename?: "DriverOrderFilterOption";
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    mobileNumber: string;
    carPlate?: string | null;
  }>;
};

export type DriverForOrderFilterQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DriverForOrderFilterQuery = {
  __typename?: "Query";
  driverForOrderFilter?: {
    __typename?: "DriverOrderFilterOption";
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    mobileNumber: string;
    carPlate?: string | null;
  } | null;
};

export type CreateRiderMutationVariables = Exact<{
  input: RiderInput;
}>;

export type CreateRiderMutation = {
  __typename?: "Mutation";
  createOneRider: {
    __typename?: "Rider";
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    mobileNumber?: string | null;
    gender?: Gender | null;
  };
};

export type ViewRiderQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewRiderQuery = {
  __typename?: "Query";
  rider: {
    __typename?: "Rider";
    id: string;
    status: RiderStatus;
    firstName?: string | null;
    lastName?: string | null;
    mobileNumber?: string | null;
    isResident?: boolean | null;
    idNumber?: string | null;
    registrationTimestamp: any;
    email?: string | null;
    gender?: Gender | null;
    nationality?: string | null;
    countryOfResidence?: string | null;
    tariffProfileId?: string | null;
    tariffProfileTitle?: string | null;
    tariffProfileCode?: string | null;
    media?: { __typename?: "Media"; address: string } | null;
    wallet: Array<{
      __typename?: "RiderWallet";
      balance: number;
      currency: string;
    }>;
  };
};

export type RiderAddressesQueryVariables = Exact<{
  riderId: Scalars["ID"]["input"];
  paging?: InputMaybe<OffsetPaging>;
}>;

export type RiderAddressesQuery = {
  __typename?: "Query";
  riderAddresses: {
    __typename?: "RiderAddressConnection";
    nodes: Array<{
      __typename?: "RiderAddress";
      title: string;
      details?: string | null;
      location: { __typename?: "Point"; lat: number; lng: number };
    }>;
  };
};

export type RiderWalletQueryVariables = Exact<{
  riderId: Scalars["ID"]["input"];
  paging?: InputMaybe<OffsetPaging>;
  filter?: InputMaybe<RiderTransactionFilter>;
  sorting?: InputMaybe<Array<RiderTransactionSort> | RiderTransactionSort>;
}>;

export type RiderWalletQuery = {
  __typename?: "Query";
  rider: {
    __typename?: "Rider";
    wallet: Array<{
      __typename?: "RiderWallet";
      balance: number;
      currency: string;
    }>;
    transactions: {
      __typename?: "RiderTransactionsConnection";
      totalCount: number;
      nodes: Array<{
        __typename?: "RiderTransaction";
        action: TransactionAction;
        deductType?: RiderDeductTransactionType | null;
        status: TransactionStatus;
        createdAt: any;
        rechargeType?: RiderRechargeTransactionType | null;
        amount: number;
        currency: string;
        refrenceNumber?: string | null;
        description?: string | null;
        paymentGatewayId?: string | null;
        operatorId?: string | null;
        requestId?: string | null;
      }>;
    };
  };
};

export type RiderOrdersQueryVariables = Exact<{
  riderId: Scalars["ID"]["input"];
  filter?: InputMaybe<OrderFilter>;
  paging?: InputMaybe<OffsetPaging>;
  sorting?: InputMaybe<Array<OrderSort> | OrderSort>;
}>;

export type RiderOrdersQuery = {
  __typename?: "Query";
  rider: {
    __typename?: "Rider";
    orders: {
      __typename?: "RiderOrdersConnection";
      totalCount: number;
      nodes: Array<{
        __typename?: "Order";
        id: string;
        createdOn: any;
        startTimestamp?: any | null;
        status: OrderStatus;
        distanceBest: number;
        durationBest: number;
        costBest: number;
        costAfterCoupon: number;
        estimatedFixedPrice?: number | null;
        finalCollectedAmount?: number | null;
        meterAmount?: number | null;
        meterExtrasAmount?: number | null;
        fareMode: FareMode;
        currency: string;
        addresses: Array<string>;
        expectedTimestamp?: any | null;
        points: Array<{ __typename?: "Point"; lat: number; lng: number }>;
      }>;
    };
  };
};

export type UpdateRiderMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  update: RiderInput;
}>;

export type UpdateRiderMutation = {
  __typename?: "Mutation";
  updateOneRider: { __typename?: "Rider"; id: string };
};

export type CreateRiderTransactionMutationVariables = Exact<{
  input: RiderTransactionInput;
}>;

export type CreateRiderTransactionMutation = {
  __typename?: "Mutation";
  createRiderTransaction: { __typename?: "RiderWallet"; id: string };
};

export type DeleteRiderMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteRiderMutation = {
  __typename?: "Mutation";
  deleteOneRider: { __typename?: "Rider"; id: string };
};

export type RidersListQueryVariables = Exact<{
  filter?: InputMaybe<RiderFilter>;
  paging?: InputMaybe<OffsetPaging>;
  sorting?: InputMaybe<Array<RiderSort> | RiderSort>;
}>;

export type RidersListQuery = {
  __typename?: "Query";
  riders: {
    __typename?: "RiderConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "Rider";
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      status: RiderStatus;
      gender?: Gender | null;
      mobileNumber?: string | null;
      registrationTimestamp: any;
    }>;
  };
};

export type ScheduledRideBoardQueryVariables = Exact<{
  filter?: InputMaybe<ScheduledRideFilterInput>;
}>;

export type ScheduledRideBoardQuery = {
  __typename?: "Query";
  scheduledRideBoard: {
    __typename?: "ScheduledRideBoardConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "ScheduledRideBoardRow";
      orderId: string;
      status: OrderStatus;
      isScheduled: boolean;
      scheduledAt: any;
      scheduleStatus?: ScheduleStatus | null;
      scheduledAssignmentMode?: ScheduledAssignmentMode | null;
      scheduledDriverConfirmedAt?: any | null;
      scheduleRevision: number;
      fareMode: FareMode;
      costAfterCoupon?: number | null;
      currency?: string | null;
      paymentMode?: PaymentMode | null;
      orderSource: OrderSource;
      pickupAddress: string;
      destinationAddress: string;
      serviceId?: string | null;
      serviceName?: string | null;
      customerId?: string | null;
      customerName: string;
      customerPhone?: string | null;
      assignedDriverId?: string | null;
      assignedDriverName?: string | null;
      assignedDriverPhone?: string | null;
      assignedDriverPlate?: string | null;
      assignedDriverStatus?: DriverStatus | null;
      isAtRisk: boolean;
      minutesUntilPickup?: number | null;
      createdByOperatorId?: string | null;
      createdByOperatorName?: string | null;
      lastScheduleAction?: string | null;
      lastScheduleOperatorId?: string | null;
      lastScheduleOperatorName?: string | null;
      lastScheduleActivityAt?: any | null;
      pickupPoint: { __typename?: "Point"; lat: number; lng: number };
      destinationPoint?: {
        __typename?: "Point";
        lat: number;
        lng: number;
      } | null;
    }>;
  };
};

export type ScheduledRideAssignmentDriversQueryVariables = Exact<{
  orderId: Scalars["ID"]["input"];
}>;

export type ScheduledRideAssignmentDriversQuery = {
  __typename?: "Query";
  scheduledRideAssignmentDrivers: Array<{
    __typename?: "ScheduledRideAssignmentDriver";
    id: string;
    mobileNumber: string;
    firstName?: string | null;
    lastName?: string | null;
    rating?: number | null;
    status: DriverStatus;
    vehiclePlate?: string | null;
    serviceIds: Array<string>;
    distanceMeters?: number | null;
    isOnline: boolean;
    isFeasible: boolean;
    feasibilityReason?: string | null;
  }>;
};

export type AssignScheduledRideMutationVariables = Exact<{
  orderId: Scalars["ID"]["input"];
  driverId: Scalars["ID"]["input"];
  reason?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AssignScheduledRideMutation = {
  __typename?: "Mutation";
  assignScheduledRide: boolean;
};

export type RescheduleScheduledRideByAdminMutationVariables = Exact<{
  orderId: Scalars["ID"]["input"];
  scheduledAt: Scalars["DateTime"]["input"];
  reason?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type RescheduleScheduledRideByAdminMutation = {
  __typename?: "Mutation";
  rescheduleScheduledRideByAdmin: boolean;
};

export type CancelScheduledRideByAdminMutationVariables = Exact<{
  orderId: Scalars["ID"]["input"];
  reason?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CancelScheduledRideByAdminMutation = {
  __typename?: "Mutation";
  cancelScheduledRideByAdmin: boolean;
};

export type EmergencyDispatchScheduledRideMutationVariables = Exact<{
  orderId: Scalars["ID"]["input"];
  reason?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type EmergencyDispatchScheduledRideMutation = {
  __typename?: "Mutation";
  emergencyDispatchScheduledRide: boolean;
};

export type SosListQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;

export type SosListQuery = {
  __typename?: "Query";
  distressSignals: {
    __typename?: "DistressSignalConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "DistressSignal";
      id: string;
      createdAt: any;
      status: SosStatus;
      submittedByRider: boolean;
      location?: { __typename?: "Point"; lat: number; lng: number } | null;
      activities: Array<{
        __typename?: "SOSActivity";
        action: SosActivityAction;
        createdAt: any;
      }>;
      order: {
        __typename?: "Order";
        id: string;
        status: OrderStatus;
        addresses: Array<string>;
        rider?: {
          __typename?: "Rider";
          id: string;
          firstName?: string | null;
          lastName?: string | null;
          mobileNumber?: string | null;
        } | null;
        driver?: {
          __typename?: "Driver";
          id: string;
          firstName?: string | null;
          lastName?: string | null;
          mobileNumber: string;
        } | null;
      };
    }>;
  };
  distressSignalSummary: {
    __typename?: "DistressSignalConnection";
    totalCount: number;
    nodes: Array<{
      __typename?: "DistressSignal";
      id: string;
      createdAt: any;
      status: SosStatus;
    }>;
  };
};

export type ViewSosQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ViewSosQuery = {
  __typename?: "Query";
  distressSignal: {
    __typename?: "DistressSignal";
    id: string;
    createdAt: any;
    status: SosStatus;
    submittedByRider: boolean;
    location?: { __typename?: "Point"; lat: number; lng: number } | null;
    activities: Array<{
      __typename?: "SOSActivity";
      action: SosActivityAction;
      createdAt: any;
      note?: string | null;
      operatorDisplayName?: string | null;
    }>;
    order: {
      __typename?: "Order";
      id: string;
      status: OrderStatus;
      createdOn: any;
      startTimestamp?: any | null;
      finishTimestamp?: any | null;
      expectedTimestamp?: any | null;
      costBest: number;
      costAfterCoupon: number;
      estimatedFixedPrice?: number | null;
      finalCollectedAmount?: number | null;
      meterAmount?: number | null;
      meterExtrasAmount?: number | null;
      fareMode: FareMode;
      addresses: Array<string>;
      currency: string;
      rider?: {
        __typename?: "Rider";
        id: string;
        mobileNumber?: string | null;
        status: RiderStatus;
        firstName?: string | null;
        lastName?: string | null;
        registrationTimestamp: any;
      } | null;
      driver?: {
        __typename?: "Driver";
        id: string;
        mobileNumber: string;
        status: DriverStatus;
        firstName?: string | null;
        lastName?: string | null;
        registrationTimestamp: any;
      } | null;
    };
  };
};

export type CreateSosActivityMutationVariables = Exact<{
  activity: CreateSosAcitivtyInput;
}>;

export type CreateSosActivityMutation = {
  __typename?: "Mutation";
  createOneSOSActivity: { __typename?: "SOSActivity"; id: string };
};

export type TelematicsLiveFleetQueryVariables = Exact<{ [key: string]: never }>;

export type TelematicsLiveFleetQuery = {
  __typename?: "Query";
  telematicsLiveFleet: Array<{
    __typename?: "TelematicsLiveVehicleDTO";
    vehicleId: string;
    vehicleLabel?: string | null;
    driverId?: string | null;
    driverLabel?: string | null;
    currentOrderId?: string | null;
    freshness: string;
    latestObservationAt?: any | null;
    appGpsAgeSeconds?: number | null;
    hardwareGpsAgeSeconds?: number | null;
    gpsDistanceMeters?: number | null;
    passengerPresence: string;
    passengerPresenceObservedAt?: any | null;
    taximeterActive: string;
    taximeterObservedAt?: any | null;
    signalFreshnessSeconds: number;
    ignition: string;
    speedMetersPerSecond?: number | null;
    capability: string;
    providerHealth: string;
    findingCount: number;
    appPosition?: {
      __typename?: "TelematicsPositionDTO";
      latitude: number;
      longitude: number;
      observedAt?: any | null;
    } | null;
    hardwarePosition?: {
      __typename?: "TelematicsPositionDTO";
      latitude: number;
      longitude: number;
      observedAt?: any | null;
    } | null;
  }>;
};

export type TelematicsAlertsQueryVariables = Exact<{
  vehicleId?: InputMaybe<Scalars["ID"]["input"]>;
  driverId?: InputMaybe<Scalars["ID"]["input"]>;
  orderId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type TelematicsAlertsQuery = {
  __typename?: "Query";
  telematicsIntegrityAlerts: Array<{
    __typename?: "TelematicsAlertDTO";
    id: string;
    type: string;
    severity: string;
    workflowStatus: string;
    conditionStatus: string;
    conditionResolvedAt?: any | null;
    conditionResolutionReason?: string | null;
    version: number;
    vehicleId: string;
    driverId?: string | null;
    orderId?: string | null;
    passengerIntervalStatus?: string | null;
    taximeterIntervalStatus?: string | null;
    calibrationEvidence: string;
    firstDetectedAt: any;
    lastObservedAt: any;
    movementConfirmed: boolean;
    currentReviewerOperatorId?: string | null;
  }>;
};

export type TelematicsAlertQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type TelematicsAlertQuery = {
  __typename?: "Query";
  telematicsIntegrityAlert?: {
    __typename?: "TelematicsAlertDTO";
    id: string;
    type: string;
    severity: string;
    workflowStatus: string;
    conditionStatus: string;
    conditionResolvedAt?: any | null;
    conditionResolutionReason?: string | null;
    version: number;
    vehicleId: string;
    driverId?: string | null;
    orderId?: string | null;
    firstDetectedAt: any;
    lastObservedAt: any;
    movementConfirmed: boolean;
    currentReviewerOperatorId?: string | null;
    endpointEvaluationStatus: string;
    endpointEvidenceLimitations: Array<string>;
    pickupEndpoint?: {
      __typename?: "TelematicsEndpointComparisonDTO";
      evaluated: boolean;
      mismatch: boolean;
      separationMeters?: number | null;
      toleranceMeters?: number | null;
      limitationCode?: string | null;
      expectedPosition?: {
        __typename?: "TelematicsPositionDTO";
        latitude: number;
        longitude: number;
        observedAt?: any | null;
      } | null;
      observedPosition?: {
        __typename?: "TelematicsPositionDTO";
        latitude: number;
        longitude: number;
        observedAt?: any | null;
      } | null;
    } | null;
    dropoffEndpoint?: {
      __typename?: "TelematicsEndpointComparisonDTO";
      evaluated: boolean;
      mismatch: boolean;
      separationMeters?: number | null;
      toleranceMeters?: number | null;
      limitationCode?: string | null;
      expectedPosition?: {
        __typename?: "TelematicsPositionDTO";
        latitude: number;
        longitude: number;
        observedAt?: any | null;
      } | null;
      observedPosition?: {
        __typename?: "TelematicsPositionDTO";
        latitude: number;
        longitude: number;
        observedAt?: any | null;
      } | null;
    } | null;
    reviewHistory: Array<{
      __typename?: "TelematicsAlertReviewDTO";
      id: string;
      operatorId: string;
      action: string;
      previousStatus: string;
      newStatus: string;
      reasonCode?: string | null;
      internalNote?: string | null;
      createdAt: any;
    }>;
  } | null;
};

export type TelematicsDriverReportQueryVariables = Exact<{
  driverId?: InputMaybe<Scalars["ID"]["input"]>;
  vehicleId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type TelematicsDriverReportQuery = {
  __typename?: "Query";
  telematicsDriverIntegrityReport: {
    __typename?: "TelematicsDriverReportDTO";
    alertCount: number;
    confirmed: number;
    explained: number;
    dismissed: number;
    autoResolved: number;
    unattributed: number;
    matchedPassengerIntervals: number;
    incompleteEvidenceCount: number;
  };
};

export type AcknowledgeTelematicsAlertMutationVariables = Exact<{
  input: TelematicsAlertReviewInput;
}>;

export type AcknowledgeTelematicsAlertMutation = {
  __typename?: "Mutation";
  acknowledgeTelematicsAlert: {
    __typename?: "TelematicsAlertDTO";
    id: string;
    workflowStatus: string;
    conditionStatus: string;
    conditionResolvedAt?: any | null;
    conditionResolutionReason?: string | null;
    version: number;
  };
};

export type StartTelematicsAlertReviewMutationVariables = Exact<{
  input: TelematicsAlertReviewInput;
}>;

export type StartTelematicsAlertReviewMutation = {
  __typename?: "Mutation";
  startTelematicsAlertReview: {
    __typename?: "TelematicsAlertDTO";
    id: string;
    workflowStatus: string;
    conditionStatus: string;
    conditionResolvedAt?: any | null;
    conditionResolutionReason?: string | null;
    version: number;
  };
};

export type ConfirmTelematicsAlertMutationVariables = Exact<{
  input: TelematicsAlertReviewInput;
}>;

export type ConfirmTelematicsAlertMutation = {
  __typename?: "Mutation";
  confirmTelematicsAlert: {
    __typename?: "TelematicsAlertDTO";
    id: string;
    workflowStatus: string;
    conditionStatus: string;
    conditionResolvedAt?: any | null;
    conditionResolutionReason?: string | null;
    version: number;
  };
};

export type DismissTelematicsAlertMutationVariables = Exact<{
  input: TelematicsAlertReviewInput;
}>;

export type DismissTelematicsAlertMutation = {
  __typename?: "Mutation";
  dismissTelematicsAlert: {
    __typename?: "TelematicsAlertDTO";
    id: string;
    workflowStatus: string;
    conditionStatus: string;
    conditionResolvedAt?: any | null;
    conditionResolutionReason?: string | null;
    version: number;
  };
};

export type TelematicsLatestStatusChangedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type TelematicsLatestStatusChangedSubscription = {
  __typename?: "Subscription";
  telematicsLatestStatusChanged: {
    __typename?: "TelematicsChangeEventDTO";
    entityId: string;
    changedAt: any;
  };
};

export type TelematicsIntegrityAlertChangedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type TelematicsIntegrityAlertChangedSubscription = {
  __typename?: "Subscription";
  telematicsIntegrityAlertChanged: {
    __typename?: "TelematicsChangeEventDTO";
    entityId: string;
    changedAt: any;
  };
};

export type TelematicsAlertReviewChangedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type TelematicsAlertReviewChangedSubscription = {
  __typename?: "Subscription";
  telematicsAlertReviewChanged: {
    __typename?: "TelematicsChangeEventDTO";
    entityId: string;
    reviewId?: string | null;
    changedAt: any;
  };
};

export type SearchVehiclesForTelematicsFilterQueryVariables = Exact<{
  query: Scalars["String"]["input"];
  limit?: Scalars["Int"]["input"];
}>;

export type SearchVehiclesForTelematicsFilterQuery = {
  __typename?: "Query";
  searchVehiclesForTelematicsFilter: Array<{
    __typename?: "Vehicle";
    id: string;
    plate: string;
    modelName?: string | null;
    colorName?: string | null;
    status: VehicleStatus;
    assignedDriverId?: string | null;
    assignedDriverName?: string | null;
  }>;
};

export type CurrentConfigurationQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CurrentConfigurationQuery = {
  __typename?: "Query";
  currentConfiguration: {
    __typename?: "CurrentConfiguration";
    backendMapsAPIKey?: string | null;
    adminPanelAPIKey?: string | null;
    adminPanelMapId?: string | null;
    firebaseProjectPrivateKey?: string | null;
  };
};

export type UpdateMapsApiKeyMutationVariables = Exact<{
  backend: Scalars["String"]["input"];
  adminPanel: Scalars["String"]["input"];
}>;

export type UpdateMapsApiKeyMutation = {
  __typename?: "Mutation";
  updateMapsAPIKey: {
    __typename?: "UpdateConfigResult";
    status: UpdateConfigStatus;
    message?: string | null;
  };
};

export type UpdateFirebaseMutationVariables = Exact<{
  keyFileName: Scalars["String"]["input"];
}>;

export type UpdateFirebaseMutation = {
  __typename?: "Mutation";
  updateFirebase: {
    __typename?: "UpdateConfigResult";
    status: UpdateConfigStatus;
    message?: string | null;
  };
};

export type LoginQueryVariables = Exact<{
  username: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
}>;

export type LoginQuery = {
  __typename?: "Query";
  login: { __typename?: "TokenObject"; token: string };
};

export const DriverOverviewInfoFragmentDoc = gql`
  fragment DriverOverviewInfo on Driver {
    id
    firstName
    lastName
    mobileNumber
    status
  }
`;
export const DriverLocationFragmentDoc = gql`
  fragment DriverLocation on OnlineDriver {
    location {
      lat
      lng
    }
    driverId
    lastUpdatedAt
  }
`;
export const VehicleTelematicsMappingFieldsFragmentDoc = gql`
  fragment VehicleTelematicsMappingFields on VehicleTelematicsMapping {
    __typename
    id
    provider
    providerSettingId
    providerApplicationId
    profileId
    vehicleId
    vehiclePlate
    profileName
    profileVersion
    providerUserId
    providerUserMasked
    providerDisplayName
    providerDeviceMasked
    providerDeviceName
    imeiLastFour
    effectiveFrom
    effectiveTo
    mappingStatus
    mappingSource
    endReason
    notes
    mappedByOperatorId
    mappedByName
    endedByOperatorId
    endedByName
    createdAt
  }
`;
export const DispatchSettingsConfigFragmentDoc = gql`
  fragment DispatchSettingsConfig on DispatchConfig {
    __typename
    strategy
    requestTimeoutSeconds
    maxSearchRadiusMeters
    preDispatchBufferMinutes
    notifyAdminOnFailure
    scoring {
      distanceWeight
      driverRatingWeight
      idleTimeWeight
      cancelRateWeight
      threshold
      topN
    }
    sequentialConfig {
      perDriverTimeoutSeconds
      avoidPreviousCandidates
      driverRetryLimit
      maxDriversToTest
    }
    broadcastConfig {
      waveSize
      waveIntervalSeconds
      maxWaves
      finalResponseWindowSeconds
      radiusIncrementMeters
    }
    radiusExpansion {
      enabled
      stepMeters
      intervalSeconds
      maxSteps
    }
    fallback {
      fallbackEnabled
      fallbackStrategy
      fallbackScoring {
        distanceWeight
        driverRatingWeight
        idleTimeWeight
        cancelRateWeight
        threshold
        topN
      }
    }
    schedule {
      minimumLeadMinutes
      driverSafetyBufferMinutes
      driverHardBlockMinutes
      adminWarningMinutes
      urgentWarningMinutes
      emergencyFallbackMinutes
      emergencyAutoDispatchEnabled
    }
    nextAvailable {
      enabled
      manualBusyDriverReservationEnabled
      maxPickupDistanceKm
      maxEtaMinutes
      candidateLimit
      holdMinutes
      recomputeAttempts
      softGraceSeconds
      operationalBufferSeconds
      renewalRetrySeconds
      manualHardMaxSeconds
      reconcileIntervalSeconds
      redisRecoveryBufferSeconds
      operationCenterPhoneNumber
    }
  }
`;
export const DispatchSettingsPolicyFragmentDoc = gql`
  fragment DispatchSettingsPolicy on DispatchPolicy {
    __typename
    version
    fingerprint
    updatedAt
    updatedBy
    automation {
      enabled
      candidateSearchLimit
      initialRadiusMeters
    }
    configuration {
      ...DispatchSettingsConfig
    }
    nextAvailableRuntime {
      field
      value
      overridden
      invalidOverride
    }
  }
  ${DispatchSettingsConfigFragmentDoc}
`;
export const RiderWhatsAppSettingsFieldsFragmentDoc = gql`
  fragment RiderWhatsAppSettingsFields on RiderWhatsAppSettings {
    version
    enabled
    tokenConfigured
    encryptionReady
    validatedAt
    validationCode
    activationBlockers
    embeddedSignupAvailable
    embeddedSignupBlockers
    tokenExpiresAt
    configuration {
      businessAccountId
      phoneNumberId
      apiVersion
      template
      language
    }
  }
`;
export const TelematicsRuntimeValuesFieldsFragmentDoc = gql`
  fragment TelematicsRuntimeValuesFields on TelematicsRuntimePolicyValues {
    __typename
    configurationActionsEnabled
    liveSyncEnabled
    signalEngineEnabled
    shadowCorrelationEnabled
    historySyncEnabled
    automaticHistoryReconciliationEnabled
    adminLiveViewEnabled
    operatorLiveViewEnabled
    integrityAlertsEnabled
    alertNotificationsEnabled
    retentionCleanupEnabled
    liveSyncIntervalMs
    signalMaxAgeSeconds
    noTripGraceSeconds
    noTripConfirmationSamples
    streetDraftGraceSeconds
    tripNotStartedGraceSeconds
    movementThresholdMeters
    completedWithPassengerGraceSeconds
    taximeterAfterExitGraceSeconds
    taximeterAfterExitDistanceMeters
    pickupEndpointToleranceMeters
    finalDropoffEndpointToleranceMeters
    lateOrderMatchWindowSeconds
    historyCurrentDayIntervalMinutes
    historyPreviousDayFinalizeDelayMinutes
    historyLatePassDelayHours
    retentionDays
    approvedNotificationAlertTypes
  }
`;
export const IntegrationRuntimeConfigurationFieldsFragmentDoc = gql`
  fragment IntegrationRuntimeConfigurationFields on IntegrationRuntimeConfiguration {
    __typename
    telematics {
      providerSettingId
      source
      environmentMasterAllowed
      policyId
      version
      blockers
      readiness {
        providerConfigured
        providerEnabled
        activeMappingCount
        workerSafetyValid
      }
      requested {
        ...TelematicsRuntimeValuesFields
      }
      effective {
        ...TelematicsRuntimeValuesFields
      }
    }
    desktopAlerts {
      source
      environmentMasterAllowed
      policyId
      version
      blockers
      readiness {
        firebaseAdminConfigured
        firebaseWebConfigured
        vapidConfigured
        serviceWorkerReady
        outboxWorkerConfigured
        activeBrowserRegistrationCount
      }
      requested {
        registrationAllowed
        deliveryEnabled
        testPushEnabled
      }
      effective {
        registrationAllowed
        deliveryEnabled
        testPushEnabled
      }
    }
  }
  ${TelematicsRuntimeValuesFieldsFragmentDoc}
`;
export const DriverClosingRecordFieldsFragmentDoc = gql`
  fragment DriverClosingRecordFields on DriverClosingRecordDTO {
    id
    recordNumber
    driverId
    driverName
    driverMobile
    periodStart
    periodEnd
    businessTimezone
    tripCount
    generatedRevenue
    manualPosAmount
    chargingAmount
    parkingAmount
    tollsAmount
    otherDeductibleAmount
    otherDeductibleNote
    totalCommission
    totalDeductions
    amountToHandOver
    notes
    status
    createdByOperatorId
    createdByName
    createdBySystemType
    createdByRole
    finalizedByOperatorId
    finalizedByName
    finalizedAt
    createdAt
    updatedAt
    commissions {
      id
      partnerId
      partnerName
      partnerType
      calculationMode
      orderId
      orderReference
      tripReportTimestamp
      tripRevenue
      commissionRatePercent
      currentPartnerRatePercent
      partnerRateChanged
      amount
      note
    }
    corrections {
      id
      reason
      reopenedByOperatorId
      reopenedByName
      previousFinalizedByName
      previousFinalizedAt
      createdAt
    }
  }
`;
export const AdminNotificationCenterDocument = gql`
  query AdminNotificationCenter {
    notifications {
      __typename
      ... on TaxiSupportRequestNotification {
        id
        type
        appType
        createdAt
        readAt
        taxiSupportRequest {
          id
          requestId
        }
      }
      ... on SOSNotification {
        id
        type
        appType
        createdAt
        readAt
        sos {
          id
          requestId
        }
      }
      ... on DriverPendingVerificationNotification {
        id
        type
        appType
        createdAt
        readAt
      }
      ... on ScheduleEventNotification {
        id
        type
        appType
        createdAt
        readAt
        title
        message
        taxiOrderId
        canonicalEventId
        canonicalRoute
        canonicalSeverity
        canonicalCategory
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class AdminNotificationCenterGQL extends Apollo.Query<
  AdminNotificationCenterQuery,
  AdminNotificationCenterQueryVariables
> {
  document = AdminNotificationCenterDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const NotificationCreatedDocument = gql`
  subscription NotificationCreated {
    notificationCreated {
      __typename
      ... on TaxiSupportRequestNotification {
        id
        type
        appType
        createdAt
        readAt
        taxiSupportRequest {
          id
          requestId
        }
      }
      ... on SOSNotification {
        id
        type
        appType
        createdAt
        readAt
        sos {
          id
          requestId
        }
      }
      ... on DriverPendingVerificationNotification {
        id
        type
        appType
        createdAt
        readAt
      }
      ... on ScheduleEventNotification {
        id
        type
        appType
        createdAt
        readAt
        title
        message
        taxiOrderId
        canonicalEventId
        canonicalRoute
        canonicalSeverity
        canonicalCategory
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class NotificationCreatedGQL extends Apollo.Subscription<
  NotificationCreatedSubscription,
  NotificationCreatedSubscriptionVariables
> {
  document = NotificationCreatedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DriverManualRideCreatedDocument = gql`
  subscription DriverManualRideCreated {
    driverManualRideCreated {
      orderId
      driverId
      driverName
      carPlate
      message
      createdAt
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DriverManualRideCreatedGQL extends Apollo.Subscription<
  DriverManualRideCreatedSubscription,
  DriverManualRideCreatedSubscriptionVariables
> {
  document = DriverManualRideCreatedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MarkAdminNotificationsReadDocument = gql`
  mutation MarkAdminNotificationsRead($notificationIds: [ID!]!) {
    markAsRead(notificationIds: $notificationIds)
  }
`;

@Injectable({
  providedIn: "root",
})
export class MarkAdminNotificationsReadGQL extends Apollo.Mutation<
  MarkAdminNotificationsReadMutation,
  MarkAdminNotificationsReadMutationVariables
> {
  document = MarkAdminNotificationsReadDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const NotificationsDocument = gql`
  query Notifications {
    taxiSupportRequestAggregate(
      filter: { status: { in: [UnderInvestigation, Submitted] } }
    ) {
      count {
        id
      }
    }
    distressSignalAggregate(
      filter: { status: { in: [UnderReview, Submitted] } }
    ) {
      count {
        id
      }
    }
    driverAggregate(filter: { status: { in: [PendingApproval] } }) {
      count {
        id
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class NotificationsGQL extends Apollo.Query<
  NotificationsQuery,
  NotificationsQueryVariables
> {
  document = NotificationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SosSubscriptionDocument = gql`
  subscription SOSSubscription {
    sosCreated {
      id
      status
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class SosSubscriptionGQL extends Apollo.Subscription<
  SosSubscriptionSubscription,
  SosSubscriptionSubscriptionVariables
> {
  document = SosSubscriptionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ComplaintSubscriptionDocument = gql`
  subscription ComplaintSubscription {
    complaintCreated {
      id
      status
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ComplaintSubscriptionGQL extends Apollo.Subscription<
  ComplaintSubscriptionSubscription,
  ComplaintSubscriptionSubscriptionVariables
> {
  document = ComplaintSubscriptionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ViewComplaintDocument = gql`
  query ViewComplaint($id: ID!) {
    complaint: taxiSupportRequest(id: $id) {
      id
      inscriptionTimestamp
      status
      subject
      content
      requestedByDriver
      activities {
        type
        comment
        createdAt
        statusFrom
        statusTo
        actor {
          id
          firstName
          lastName
        }
        assignedToStaffs {
          id
          firstName
          lastName
        }
      }
      request {
        id
        status
        createdOn
        startTimestamp
        finishTimestamp
        expectedTimestamp
        costBest
        costAfterCoupon
        estimatedFixedPrice
        finalCollectedAmount
        meterAmount
        meterExtrasAmount
        addresses
        currency
        fareMode
        paymentMode
        orderSource
        settlementSource
        serviceName
        rider {
          id
          mobileNumber
          status
          firstName
          lastName
          registrationTimestamp
        }
        driver {
          id
          mobileNumber
          status
          firstName
          lastName
          registrationTimestamp
        }
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ViewComplaintGQL extends Apollo.Query<
  ViewComplaintQuery,
  ViewComplaintQueryVariables
> {
  document = ViewComplaintDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateComplaintStatusDocument = gql`
  mutation UpdateComplaintStatus($id: ID!, $status: ComplaintStatus!) {
    updateOneTaxiSupportRequest(
      input: { id: $id, update: { status: $status } }
    ) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateComplaintStatusGQL extends Apollo.Mutation<
  UpdateComplaintStatusMutation,
  UpdateComplaintStatusMutationVariables
> {
  document = UpdateComplaintStatusDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ComplaintsListDocument = gql`
  query ComplaintsList($paging: OffsetPaging) {
    taxiSupportRequests(paging: $paging) {
      nodes {
        id
        inscriptionTimestamp
        subject
        status
        content
        requestedByDriver
        request {
          id
          status
          addresses
          rider {
            id
            firstName
            lastName
            mobileNumber
          }
          driver {
            id
            firstName
            lastName
            mobileNumber
          }
        }
      }
      totalCount
    }
    complaintSummary: taxiSupportRequests(paging: { limit: 10000 }) {
      nodes {
        id
        inscriptionTimestamp
        status
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ComplaintsListGQL extends Apollo.Query<
  ComplaintsListQuery,
  ComplaintsListQueryVariables
> {
  document = ComplaintsListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AdminNotificationEventCreatedDocument = gql`
  subscription AdminNotificationEventCreated {
    adminNotificationEventCreated {
      schemaVersion
      eventId
      type
      category
      severity
      safeTitle
      safeBody
      route
      tag
      dedupeKey
      createdAt
      expiresAt
      acknowledgementPolicy
      soundPolicy
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class AdminNotificationEventCreatedGQL extends Apollo.Subscription<
  AdminNotificationEventCreatedSubscription,
  AdminNotificationEventCreatedSubscriptionVariables
> {
  document = AdminNotificationEventCreatedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OpenAdminNotificationEventDocument = gql`
  mutation OpenAdminNotificationEvent($eventId: String!) {
    openAdminNotificationEvent(eventId: $eventId)
  }
`;

@Injectable({
  providedIn: "root",
})
export class OpenAdminNotificationEventGQL extends Apollo.Mutation<
  OpenAdminNotificationEventMutation,
  OpenAdminNotificationEventMutationVariables
> {
  document = OpenAdminNotificationEventDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AcknowledgeAdminNotificationEventDocument = gql`
  mutation AcknowledgeAdminNotificationEvent($eventId: String!) {
    acknowledgeAdminNotificationEvent(eventId: $eventId)
  }
`;

@Injectable({
  providedIn: "root",
})
export class AcknowledgeAdminNotificationEventGQL extends Apollo.Mutation<
  AcknowledgeAdminNotificationEventMutation,
  AcknowledgeAdminNotificationEventMutationVariables
> {
  document = AcknowledgeAdminNotificationEventDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpsertAdminBrowserPushRegistrationDocument = gql`
  mutation UpsertAdminBrowserPushRegistration(
    $input: UpsertAdminBrowserPushRegistrationInput!
  ) {
    upsertAdminBrowserPushRegistration(input: $input) {
      id
      browserInstanceId
      provider
      platform
      browser
      browserVersion
      operatingSystemLabel
      locale
      permissionState
      desktopEnabled
      soundEnabled
      criticalOnly
      categoryPreferences {
        emergencyEnabled
        complaintEnabled
        scheduleEnabled
        requestEnabled
        driverOperationalEnabled
        systemEnabled
        telematicsEnabled
      }
      serviceWorkerVersion
      lastSeenAt
      tokenRefreshedAt
      revokedAt
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpsertAdminBrowserPushRegistrationGQL extends Apollo.Mutation<
  UpsertAdminBrowserPushRegistrationMutation,
  UpsertAdminBrowserPushRegistrationMutationVariables
> {
  document = UpsertAdminBrowserPushRegistrationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateAdminBrowserPushPreferencesDocument = gql`
  mutation UpdateAdminBrowserPushPreferences(
    $input: UpdateAdminBrowserPushPreferencesInput!
  ) {
    updateAdminBrowserPushPreferences(input: $input) {
      id
      browserInstanceId
      desktopEnabled
      soundEnabled
      criticalOnly
      categoryPreferences {
        emergencyEnabled
        complaintEnabled
        scheduleEnabled
        requestEnabled
        driverOperationalEnabled
        systemEnabled
        telematicsEnabled
      }
      permissionState
      serviceWorkerVersion
      lastSeenAt
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateAdminBrowserPushPreferencesGQL extends Apollo.Mutation<
  UpdateAdminBrowserPushPreferencesMutation,
  UpdateAdminBrowserPushPreferencesMutationVariables
> {
  document = UpdateAdminBrowserPushPreferencesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RevokeAdminBrowserPushRegistrationDocument = gql`
  mutation RevokeAdminBrowserPushRegistration($browserInstanceId: String!) {
    revokeAdminBrowserPushRegistration(browserInstanceId: $browserInstanceId)
  }
`;

@Injectable({
  providedIn: "root",
})
export class RevokeAdminBrowserPushRegistrationGQL extends Apollo.Mutation<
  RevokeAdminBrowserPushRegistrationMutation,
  RevokeAdminBrowserPushRegistrationMutationVariables
> {
  document = RevokeAdminBrowserPushRegistrationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MyAdminBrowserPushRegistrationsDocument = gql`
  query MyAdminBrowserPushRegistrations {
    myAdminBrowserPushRegistrations {
      id
      browserInstanceId
      provider
      platform
      browser
      browserVersion
      operatingSystemLabel
      locale
      permissionState
      desktopEnabled
      soundEnabled
      criticalOnly
      serviceWorkerVersion
      lastSeenAt
      tokenRefreshedAt
      revokedAt
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class MyAdminBrowserPushRegistrationsGQL extends Apollo.Query<
  MyAdminBrowserPushRegistrationsQuery,
  MyAdminBrowserPushRegistrationsQueryVariables
> {
  document = MyAdminBrowserPushRegistrationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateDriverDocument = gql`
  mutation CreateDriver($input: UpdateDriverInput!) {
    createOneDriver(input: { driver: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateDriverGQL extends Apollo.Mutation<
  CreateDriverMutation,
  CreateDriverMutationVariables
> {
  document = CreateDriverDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ViewDriverDocument = gql`
  query ViewDriver($id: ID!) {
    driver(id: $id) {
      id
      firstName
      lastName
      mobileNumber
      registrationTimestamp
      lastSeenTimestamp
      status
      gender
      carId
      carColorId
      fleetId
      carProductionYear
      carPlate
      accountNumber
      bankName
      bankRoutingNumber
      bankSwift
      address
      email
      enabledServices {
        serviceId
      }
      documents {
        address
      }
      mediaId
      media {
        address
      }
      rating
      reviewCount
    }
    services {
      id
      name
    }
    fleets {
      nodes {
        id
        name
      }
    }
    driverFeedbackParametersSummary(driverId: $id) {
      title
      isGood
      count
    }
    driverTripRevenueSummary(driverId: $id) {
      finishedTripCount
      lastCompletedTripAt
      currencyTotals {
        currency
        amount
      }
    }
    vehicles {
      id
      plate
      modelName
      colorName
      productionYear
      status
      assignedDriverId
      assignedDriverName
    }
    driverCurrentVehicleAssignment(driverId: $id) {
      id
      driverId
      vehicleId
      startedAt
      endedAt
      assignedByOperatorId
      assignedByOperatorName
      reason
      note
      vehiclePlate
      vehicleModel
      vehicleColor
      vehicleProductionYear
      vehicleStatus
    }
    driverVehicleAssignmentHistory(driverId: $id) {
      id
      startedAt
      endedAt
      assignedByOperatorName
      reason
      note
      vehiclePlate
      vehicleModel
      vehicleColor
      vehicleProductionYear
      vehicleStatus
    }
    carModels(paging: { limit: 100 }) {
      nodes {
        id
        name
      }
    }
    carColors {
      nodes {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ViewDriverGQL extends Apollo.Query<
  ViewDriverQuery,
  ViewDriverQueryVariables
> {
  document = ViewDriverDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDriverProfileDocument = gql`
  mutation UpdateDriverProfile(
    $id: ID!
    $update: UpdateDriverInput!
    $serviceIds: [ID!]!
  ) {
    updateOneDriver(input: { id: $id, update: $update }) {
      id
    }
    setActivatedServicesOnDriver(
      input: { driverId: $id, serviceIds: $serviceIds }
    )
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateDriverProfileGQL extends Apollo.Mutation<
  UpdateDriverProfileMutation,
  UpdateDriverProfileMutationVariables
> {
  document = UpdateDriverProfileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDriverStatusDocument = gql`
  mutation UpdateDriverStatus($id: ID!, $status: DriverStatus!) {
    updateDriverStatus(id: $id, status: $status) {
      id
      status
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateDriverStatusGQL extends Apollo.Mutation<
  UpdateDriverStatusMutation,
  UpdateDriverStatusMutationVariables
> {
  document = UpdateDriverStatusDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AssignVehicleToDriverDocument = gql`
  mutation AssignVehicleToDriver($input: AssignVehicleToDriverInput!) {
    assignVehicleToDriver(input: $input) {
      id
      driverId
      vehicleId
      startedAt
      vehiclePlate
      vehicleModel
      vehicleColor
      vehicleProductionYear
      vehicleStatus
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class AssignVehicleToDriverGQL extends Apollo.Mutation<
  AssignVehicleToDriverMutation,
  AssignVehicleToDriverMutationVariables
> {
  document = AssignVehicleToDriverDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DriverFinancialsDocument = gql`
  query DriverFinancials(
    $id: ID!
    $dateFrom: DateTime
    $dateTo: DateTime
    $paging: OffsetPaging
    $filter: OrderFilter
    $sorting: [OrderSort!]
  ) {
    driver(id: $id) {
      orders(filter: $filter, paging: $paging, sorting: $sorting) {
        nodes {
          id
          createdOn
          finishTimestamp
          status
          addresses
          costBest
          costAfterCoupon
          estimatedFixedPrice
          finalCollectedAmount
          currency
          fareMode
          paymentMode
          settlementSource
          orderSource
          meterAmount
          meterCurrency
          meterExtrasAmount
          streetPassengerName
          rider {
            firstName
            lastName
            mobileNumber
          }
        }
        totalCount
      }
    }
    regions {
      nodes {
        currency
      }
    }
    driverTripRevenueSummary(
      driverId: $id
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      finishedTripCount
      lastCompletedTripAt
      currencyTotals {
        currency
        amount
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DriverFinancialsGQL extends Apollo.Query<
  DriverFinancialsQuery,
  DriverFinancialsQueryVariables
> {
  document = DriverFinancialsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DriverFeedbacksDocument = gql`
  query DriverFeedbacks($id: ID!, $paging: OffsetPaging) {
    driver(id: $id) {
      rating
      reviewCount
    }
    feedbacks(filter: { driverId: { eq: $id } }, paging: $paging) {
      nodes {
        id
        requestId
        reviewTimestamp
        score
        description
        parameters {
          isGood
          title
        }
        request {
          id
          rider {
            firstName
            lastName
            mobileNumber
          }
        }
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DriverFeedbacksGQL extends Apollo.Query<
  DriverFeedbacksQuery,
  DriverFeedbacksQueryVariables
> {
  document = DriverFeedbacksDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DriverOrdersDocument = gql`
  query DriverOrders(
    $driverId: ID!
    $filter: OrderFilter
    $paging: OffsetPaging
    $sorting: [OrderSort!]
  ) {
    driver(id: $driverId) {
      orders(filter: $filter, paging: $paging, sorting: $sorting) {
        nodes {
          id
          createdOn
          startTimestamp
          status
          distanceBest
          durationBest
          costBest
          costAfterCoupon
          currency
          fareMode
          paymentMode
          orderSource
          addresses
          points {
            lat
            lng
          }
          expectedTimestamp
        }
        totalCount
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DriverOrdersGQL extends Apollo.Query<
  DriverOrdersQuery,
  DriverOrdersQueryVariables
> {
  document = DriverOrdersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchiveDriverDocument = gql`
  mutation ArchiveDriver($id: ID!, $reason: String!, $note: String) {
    archiveDriver(id: $id, reason: $reason, note: $note) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ArchiveDriverGQL extends Apollo.Mutation<
  ArchiveDriverMutation,
  ArchiveDriverMutationVariables
> {
  document = ArchiveDriverDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DriversListDocument = gql`
  query DriversList(
    $paging: OffsetPaging
    $filter: DriverFilter
    $sorting: [DriverSort!]
  ) {
    allDrivers: drivers {
      totalCount
    }
    drivers(paging: $paging, filter: $filter, sorting: $sorting) {
      nodes {
        id
        firstName
        lastName
        gender
        mobileNumber
        status
        registrationTimestamp
        lastSeenTimestamp
        carPlate
        carProductionYear
        rating
        reviewCount
        media {
          address
        }
        ordersAggregate {
          count {
            id
          }
        }
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DriversListGQL extends Apollo.Query<
  DriversListQuery,
  DriversListQueryVariables
> {
  document = DriversListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ArchivedDriversRegisterDocument = gql`
  query ArchivedDriversRegister {
    archivedDrivers {
      id
      firstName
      lastName
      mobileNumber
      archivedAt
      lastArchiveReason
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ArchivedDriversRegisterGQL extends Apollo.Query<
  ArchivedDriversRegisterQuery,
  ArchivedDriversRegisterQueryVariables
> {
  document = ArchivedDriversRegisterDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RestoreArchivedDriverDocument = gql`
  mutation RestoreArchivedDriver($id: ID!, $reason: String!, $note: String) {
    restoreArchivedDriver(id: $id, reason: $reason, note: $note) {
      id
      status
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class RestoreArchivedDriverGQL extends Apollo.Mutation<
  RestoreArchivedDriverMutation,
  RestoreArchivedDriverMutationVariables
> {
  document = RestoreArchivedDriverDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DriverLocationUpdatedDocument = gql`
  subscription DriverLocationUpdated($driverIds: [ID!]!) {
    driverLocationUpdated(driverIds: $driverIds) {
      driverId
      point {
        lat
        lng
      }
      lastUpdatedAt
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DriverLocationUpdatedGQL extends Apollo.Subscription<
  DriverLocationUpdatedSubscription,
  DriverLocationUpdatedSubscriptionVariables
> {
  document = DriverLocationUpdatedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ProviderWalletsListDocument = gql`
  query ProviderWalletsList($paging: OffsetPaging) {
    providerTransactions(paging: $paging) {
      nodes {
        createdAt
        action
        deductType
        rechargeType
        amount
        currency
        description
        requestId
        operatorId
      }
      totalCount
    }
    providerWallets {
      balance
      currency
    }
    regions {
      nodes {
        currency
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ProviderWalletsListGQL extends Apollo.Query<
  ProviderWalletsListQuery,
  ProviderWalletsListQueryVariables
> {
  document = ProviderWalletsListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportDocument = gql`
  query Export($input: ExportArgs!) {
    export(input: $input) {
      url
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ExportGQL extends Apollo.Query<ExportQuery, ExportQueryVariables> {
  document = ExportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DriverWalletsListDocument = gql`
  query DriverWalletsList($paging: OffsetPaging) {
    driverWallets(paging: $paging) {
      nodes {
        id
        driverId
        balance
        currency
        driver {
          firstName
          lastName
        }
      }
      totalCount
    }
    regions {
      nodes {
        currency
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DriverWalletsListGQL extends Apollo.Query<
  DriverWalletsListQuery,
  DriverWalletsListQueryVariables
> {
  document = DriverWalletsListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FleetWalletsListDocument = gql`
  query FleetWalletsList($paging: OffsetPaging, $filter: FleetWalletFilter) {
    fleetWallets(paging: $paging, filter: $filter) {
      nodes {
        id
        balance
        currency
        fleetId
        fleet {
          name
        }
      }
      totalCount
    }
    regions {
      nodes {
        currency
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class FleetWalletsListGQL extends Apollo.Query<
  FleetWalletsListQuery,
  FleetWalletsListQueryVariables
> {
  document = FleetWalletsListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RiderWalletsListDocument = gql`
  query RiderWalletsList($paging: OffsetPaging) {
    riderWallets(paging: $paging) {
      nodes {
        balance
        currency
        riderId
        rider {
          firstName
          lastName
        }
      }
      totalCount
    }
    regions {
      nodes {
        currency
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class RiderWalletsListGQL extends Apollo.Query<
  RiderWalletsListQuery,
  RiderWalletsListQueryVariables
> {
  document = RiderWalletsListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DispatcherCalculateFareDocument = gql`
  query DispatcherCalculateFare(
    $points: [PointInput!]!
    $riderId: ID!
    $tariffProfileId: ID
    $waitTime: Int
  ) {
    calculateFare(
      input: {
        points: $points
        riderId: $riderId
        tariffProfileId: $tariffProfileId
        waitTime: $waitTime
        orderType: Ride
      }
    ) {
      currency
      distance
      duration
      services {
        name
        services {
          id
          name
          cost
          costResult {
            ... on FixedCost {
              zonePriceBreakdown {
                zonePriceId
                zonePriceName
                tariffProfileId
                tariffProfileName
                defaultZonePrice
                selectedProfileZonePrice
                finalZonePrice
                profilePriceApplied
              }
            }
          }
        }
      }
    }
    rider(id: $riderId) {
      id
      tariffProfileId
      tariffProfile {
        id
        title
        code
      }
    }
    tariffProfiles(
      filter: { isActive: { is: true } }
      paging: { limit: 100 }
      sorting: [{ field: title, direction: ASC }]
    ) {
      nodes {
        id
        title
        code
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DispatcherCalculateFareGQL extends Apollo.Query<
  DispatcherCalculateFareQuery,
  DispatcherCalculateFareQueryVariables
> {
  document = DispatcherCalculateFareDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DispatcherSetupDocument = gql`
  query DispatcherSetup {
    tariffProfiles(
      filter: { isActive: { is: true } }
      paging: { limit: 100 }
      sorting: [{ field: title, direction: ASC }]
    ) {
      nodes {
        id
        title
        code
      }
    }
    defaultDispatchService {
      id
      name
      isDefaultDispatchService
    }
    dispatchConfig {
      nextAvailable {
        enabled
        manualBusyDriverReservationEnabled
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DispatcherSetupGQL extends Apollo.Query<
  DispatcherSetupQuery,
  DispatcherSetupQueryVariables
> {
  document = DispatcherSetupDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DispatcherPreviewFareDocument = gql`
  query DispatcherPreviewFare(
    $points: [PointInput!]!
    $riderId: ID
    $tariffProfileId: ID
    $waitTime: Int
  ) {
    calculateFare(
      input: {
        points: $points
        riderId: $riderId
        tariffProfileId: $tariffProfileId
        waitTime: $waitTime
        orderType: Ride
      }
    ) {
      currency
      distance
      duration
      services {
        name
        services {
          id
          name
          cost
          costResult {
            ... on FixedCost {
              zonePriceBreakdown {
                zonePriceId
                zonePriceName
                tariffProfileId
                tariffProfileName
                defaultZonePrice
                selectedProfileZonePrice
                finalZonePrice
                profilePriceApplied
              }
            }
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DispatcherPreviewFareGQL extends Apollo.Query<
  DispatcherPreviewFareQuery,
  DispatcherPreviewFareQueryVariables
> {
  document = DispatcherPreviewFareDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SearchDispatcherCustomersDocument = gql`
  query SearchDispatcherCustomers($keyword: String!) {
    searchDispatcherCustomers(keyword: $keyword) {
      id
      firstName
      lastName
      mobileNumber
      nationality
      countryOfResidence
      tariffProfileId
      tariffProfile {
        id
        title
        code
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class SearchDispatcherCustomersGQL extends Apollo.Query<
  SearchDispatcherCustomersQuery,
  SearchDispatcherCustomersQueryVariables
> {
  document = SearchDispatcherCustomersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateDispatcherGuestCustomerDocument = gql`
  mutation CreateDispatcherGuestCustomer(
    $input: CreateDispatcherGuestCustomerInput!
  ) {
    createDispatcherGuestCustomer(input: $input) {
      id
      firstName
      lastName
      mobileNumber
      nationality
      countryOfResidence
      tariffProfileId
      tariffProfile {
        id
        title
        code
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateDispatcherGuestCustomerGQL extends Apollo.Mutation<
  CreateDispatcherGuestCustomerMutation,
  CreateDispatcherGuestCustomerMutationVariables
> {
  document = CreateDispatcherGuestCustomerDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateDispatcherRegisteredCustomerDocument = gql`
  mutation CreateDispatcherRegisteredCustomer(
    $input: CreateDispatcherRegisteredCustomerInput!
  ) {
    createDispatcherRegisteredCustomer(input: $input) {
      id
      firstName
      lastName
      mobileNumber
      nationality
      countryOfResidence
      tariffProfileId
      tariffProfile {
        id
        title
        code
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateDispatcherRegisteredCustomerGQL extends Apollo.Mutation<
  CreateDispatcherRegisteredCustomerMutation,
  CreateDispatcherRegisteredCustomerMutationVariables
> {
  document = CreateDispatcherRegisteredCustomerDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DispatcherAvailableDriversDocument = gql`
  query DispatcherAvailableDrivers(
    $center: PointInput!
    $count: Int!
    $serviceId: ID
  ) {
    getDriversLocationWithData(
      center: $center
      count: $count
      serviceId: $serviceId
    ) {
      id
      location {
        lat
        lng
      }
      mobileNumber
      firstName
      lastName
      lastUpdatedAt
      rating
      reviewCount
      status
      vehiclePlate
      serviceIds
      availabilityStatus
      availabilityReason
      canAssignNow
      isOnline
      serviceCompatible
      activeOrderId
      estimatedFinishTime
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DispatcherAvailableDriversGQL extends Apollo.Query<
  DispatcherAvailableDriversQuery,
  DispatcherAvailableDriversQueryVariables
> {
  document = DispatcherAvailableDriversDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateOrderDocument = gql`
  mutation CreateOrder(
    $riderId: ID
    $points: [PointInput!]!
    $addresses: [String!]!
    $serviceId: ID!
    $scheduledAt: DateTime
    $driverId: ID
    $fareMode: FareMode
    $paymentMode: PaymentMode
    $tariffProfileId: ID
    $tariffProfileReason: String
    $dispatcherNote: String
    $reportingSource: OrderSource
    $waitingTimeMinutes: Int
    $deferDispatchForManualReservation: Boolean
  ) {
    createOrder(
      input: {
        points: $points
        serviceId: $serviceId
        addresses: $addresses
        scheduledAt: $scheduledAt
        riderId: $riderId
        driverId: $driverId
        fareMode: $fareMode
        paymentMode: $paymentMode
        tariffProfileId: $tariffProfileId
        tariffProfileReason: $tariffProfileReason
        dispatcherNote: $dispatcherNote
        reportingSource: $reportingSource
        waitingTimeMinutes: $waitingTimeMinutes
        deferDispatchForManualReservation: $deferDispatchForManualReservation
      }
    ) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateOrderGQL extends Apollo.Mutation<
  CreateOrderMutation,
  CreateOrderMutationVariables
> {
  document = CreateOrderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const QueueDispatcherOrderForNextAvailableDocument = gql`
  mutation QueueDispatcherOrderForNextAvailable($orderId: ID!) {
    queueDispatcherOrderForNextAvailable(orderId: $orderId) {
      id
      status
      nextAvailableDriverId
      nextAvailableHoldExpiresAt
      nextAvailableEstimatedPickupAt
      nextAvailableEtaSeconds
      nextAvailablePickupDistanceMeters
      nextAvailableAttemptCount
      nextAvailableFailureReason
      nextAvailableMode
      nextAvailableDriver {
        id
        firstName
        lastName
        mobileNumber
        carPlate
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class QueueDispatcherOrderForNextAvailableGQL extends Apollo.Mutation<
  QueueDispatcherOrderForNextAvailableMutation,
  QueueDispatcherOrderForNextAvailableMutationVariables
> {
  document = QueueDispatcherOrderForNextAvailableDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ReserveDriverAfterCurrentTripDocument = gql`
  mutation ReserveDriverAfterCurrentTrip($orderId: ID!, $driverId: ID!) {
    reserveDriverAfterCurrentTrip(orderId: $orderId, driverId: $driverId) {
      id
      status
      nextAvailableDriverId
      nextAvailableHoldExpiresAt
      nextAvailableEstimatedPickupAt
      nextAvailableEtaSeconds
      nextAvailablePickupDistanceMeters
      nextAvailableAttemptCount
      nextAvailableFailureReason
      nextAvailableMode
      nextAvailableDriver {
        id
        firstName
        lastName
        mobileNumber
        carPlate
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ReserveDriverAfterCurrentTripGQL extends Apollo.Mutation<
  ReserveDriverAfterCurrentTripMutation,
  ReserveDriverAfterCurrentTripMutationVariables
> {
  document = ReserveDriverAfterCurrentTripDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateAndReserveDriverAfterCurrentTripDocument = gql`
  mutation CreateAndReserveDriverAfterCurrentTrip(
    $riderId: ID
    $driverId: ID!
    $points: [PointInput!]!
    $addresses: [String!]!
    $serviceId: ID!
    $fareMode: FareMode
    $paymentMode: PaymentMode
    $tariffProfileId: ID
    $tariffProfileReason: String
    $dispatcherNote: String
    $reportingSource: OrderSource
    $waitingTimeMinutes: Int
  ) {
    createAndReserveDriverAfterCurrentTrip(
      input: {
        riderId: $riderId
        driverId: $driverId
        points: $points
        addresses: $addresses
        serviceId: $serviceId
        fareMode: $fareMode
        paymentMode: $paymentMode
        tariffProfileId: $tariffProfileId
        tariffProfileReason: $tariffProfileReason
        dispatcherNote: $dispatcherNote
        reportingSource: $reportingSource
        waitingTimeMinutes: $waitingTimeMinutes
      }
    ) {
      success
      code
      message
      orderId
      driverId
      reservedDriverId
      holdExpiresAt
      estimatedFinishEta
      estimatedPickupEta
      canTryAnotherDriver
      canTryAutomaticNextAvailable
      canCreateNormalRequest
      canOpenRequest
      canCancelRequest
      order {
        id
        status
        nextAvailableDriverId
        nextAvailableHoldExpiresAt
        nextAvailableEstimatedPickupAt
        nextAvailableEtaSeconds
        nextAvailablePickupDistanceMeters
        nextAvailableAttemptCount
        nextAvailableFailureReason
        nextAvailableMode
        nextAvailableDriver {
          id
          firstName
          lastName
          mobileNumber
          carPlate
        }
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateAndReserveDriverAfterCurrentTripGQL extends Apollo.Mutation<
  CreateAndReserveDriverAfterCurrentTripMutation,
  CreateAndReserveDriverAfterCurrentTripMutationVariables
> {
  document = CreateAndReserveDriverAfterCurrentTripDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OrderUpdatedDocument = gql`
  subscription OrderUpdated($id: ID!) {
    orderUpdated(orderId: $id) {
      orderId
      status
      driver {
        firstName
        lastName
        mobileNumber
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class OrderUpdatedGQL extends Apollo.Subscription<
  OrderUpdatedSubscription,
  OrderUpdatedSubscriptionVariables
> {
  document = OrderUpdatedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CancelOrderDocument = gql`
  mutation CancelOrder($orderId: ID!) {
    cancelOrder(orderId: $orderId) {
      id
      status
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CancelOrderGQL extends Apollo.Mutation<
  CancelOrderMutation,
  CancelOrderMutationVariables
> {
  document = CancelOrderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OverviewDocument = gql`
  query Overview {
    taxiSupportRequestAggregate(
      filter: { status: { in: [Submitted, UnderInvestigation] } }
    ) {
      count {
        id
      }
    }
    driverAggregate(filter: { status: { eq: PendingApproval } }) {
      count {
        id
      }
    }
    activeOrders: orderAggregate(
      filter: {
        status: { in: [DriverAccepted, Arrived, Started, WaitingForPostPay] }
      }
    ) {
      count {
        id
      }
    }
    bookedOrders: orderAggregate(filter: { status: { eq: Booked } }) {
      count {
        id
      }
    }
    getDriversLocation(center: { lat: 45, lng: 45 }, count: 150) {
      ...DriverLocation
    }
  }
  ${DriverLocationFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class OverviewGQL extends Apollo.Query<
  OverviewQuery,
  OverviewQueryVariables
> {
  document = OverviewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OverviewDriverPagingDocument = gql`
  query OverviewDriverPaging($ids: [ID!]!) {
    drivers(filter: { id: { in: $ids } }) {
      nodes {
        ...DriverOverviewInfo
      }
      totalCount
    }
  }
  ${DriverOverviewInfoFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class OverviewDriverPagingGQL extends Apollo.Query<
  OverviewDriverPagingQuery,
  OverviewDriverPagingQueryVariables
> {
  document = OverviewDriverPagingDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RequestsChartDocument = gql`
  query RequestsChart($timeframe: ChartTimeframe!) {
    requestChart(timeframe: $timeframe) {
      time
      count
      status
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class RequestsChartGQL extends Apollo.Query<
  RequestsChartQuery,
  RequestsChartQueryVariables
> {
  document = RequestsChartDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const IncomeChartDocument = gql`
  query IncomeChart($timeframe: ChartTimeframe!) {
    incomeChart(timeframe: $timeframe) {
      time
      sum
      currency
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class IncomeChartGQL extends Apollo.Query<
  IncomeChartQuery,
  IncomeChartQueryVariables
> {
  document = IncomeChartDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DashboardRevenueByServiceDocument = gql`
  query DashboardRevenueByService {
    dashboardRevenueByService {
      label
      currency
      sum
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DashboardRevenueByServiceGQL extends Apollo.Query<
  DashboardRevenueByServiceQuery,
  DashboardRevenueByServiceQueryVariables
> {
  document = DashboardRevenueByServiceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DashboardServicePerformanceDocument = gql`
  query DashboardServicePerformance {
    dashboardServicePerformance {
      peakHour
      peakRideCount
      avgTripDurationSeconds
      avgWaitMinutes
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DashboardServicePerformanceGQL extends Apollo.Query<
  DashboardServicePerformanceQuery,
  DashboardServicePerformanceQueryVariables
> {
  document = DashboardServicePerformanceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DriverRegistrationsDocument = gql`
  query DriverRegistrations($timeframe: ChartTimeframe!) {
    driverRegistrations(timeframe: $timeframe) {
      time
      count
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DriverRegistrationsGQL extends Apollo.Query<
  DriverRegistrationsQuery,
  DriverRegistrationsQueryVariables
> {
  document = DriverRegistrationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RiderRegistrationsDocument = gql`
  query RiderRegistrations($timeframe: ChartTimeframe!) {
    riderRegistrations(timeframe: $timeframe) {
      time
      count
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class RiderRegistrationsGQL extends Apollo.Query<
  RiderRegistrationsQuery,
  RiderRegistrationsQueryVariables
> {
  document = RiderRegistrationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OverviewLeaderboardsDocument = gql`
  query OverviewLeaderboards {
    topSpendingCustomers {
      id
      name
      avatarUrl
      currency
      totalAmount
      totalCount
    }
    topTripsCompletedDrivers {
      id
      name
      avatarUrl
      currency
      totalAmount
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class OverviewLeaderboardsGQL extends Apollo.Query<
  OverviewLeaderboardsQuery,
  OverviewLeaderboardsQueryVariables
> {
  document = OverviewLeaderboardsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CarsListDocument = gql`
  query CarsList {
    carModels(paging: { limit: 100 }) {
      nodes {
        id
        name
      }
    }
    carColors {
      nodes {
        id
        name
      }
    }
    vehicles {
      id
      plate
      modelId
      modelName
      colorId
      colorName
      productionYear
      status
      notes
      assignedDriverId
      assignedDriverName
      assignedDriverMobileNumber
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CarsListGQL extends Apollo.Query<
  CarsListQuery,
  CarsListQueryVariables
> {
  document = CarsListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteCarModelDocument = gql`
  mutation DeleteCarModel($id: ID!) {
    deleteOneCarModel(input: { id: $id }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DeleteCarModelGQL extends Apollo.Mutation<
  DeleteCarModelMutation,
  DeleteCarModelMutationVariables
> {
  document = DeleteCarModelDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteCarColorDocument = gql`
  mutation DeleteCarColor($id: ID!) {
    deleteOneCarColor(input: { id: $id }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DeleteCarColorGQL extends Apollo.Mutation<
  DeleteCarColorMutation,
  DeleteCarColorMutationVariables
> {
  document = DeleteCarColorDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateCarModelDocument = gql`
  mutation CreateCarModel($input: CarModelInput!) {
    createOneCarModel(input: { carModel: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateCarModelGQL extends Apollo.Mutation<
  CreateCarModelMutation,
  CreateCarModelMutationVariables
> {
  document = CreateCarModelDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateCarColorDocument = gql`
  mutation CreateCarColor($input: CarColorInput!) {
    createOneCarColor(input: { carColor: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateCarColorGQL extends Apollo.Mutation<
  CreateCarColorMutation,
  CreateCarColorMutationVariables
> {
  document = CreateCarColorDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateCarModelDocument = gql`
  mutation UpdateCarModel($id: ID!, $input: CarModelInput!) {
    updateOneCarModel(input: { id: $id, update: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateCarModelGQL extends Apollo.Mutation<
  UpdateCarModelMutation,
  UpdateCarModelMutationVariables
> {
  document = UpdateCarModelDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateCarColorDocument = gql`
  mutation UpdateCarColor($id: ID!, $input: CarColorInput!) {
    updateOneCarColor(input: { id: $id, update: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateCarColorGQL extends Apollo.Mutation<
  UpdateCarColorMutation,
  UpdateCarColorMutationVariables
> {
  document = UpdateCarColorDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateVehicleDocument = gql`
  mutation CreateVehicle($input: CreateVehicleInput!) {
    createVehicle(input: $input) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateVehicleGQL extends Apollo.Mutation<
  CreateVehicleMutation,
  CreateVehicleMutationVariables
> {
  document = CreateVehicleDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateVehicleDocument = gql`
  mutation UpdateVehicle($id: ID!, $input: UpdateVehicleInput!) {
    updateVehicle(id: $id, input: $input) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateVehicleGQL extends Apollo.Mutation<
  UpdateVehicleMutation,
  UpdateVehicleMutationVariables
> {
  document = UpdateVehicleDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VehicleTelematicsSetupPageDocument = gql`
  query VehicleTelematicsSetupPage($vehicleId: ID!) {
    vehicleTelematicsSetup(vehicleId: $vehicleId) {
      vehicle {
        id
        plate
        modelName
        colorName
        productionYear
        status
      }
      providerSetting {
        id
        provider
        displayName
      }
      profiles {
        id
        providerSettingId
        name
        version
        schemaVersion
        active
        published
        fields {
          semanticField
          currentStatusKey
          historicalKey
          expectedType
          required
          caseSensitive
          unit
        }
      }
      mappings {
        ...VehicleTelematicsMappingFields
      }
    }
  }
  ${VehicleTelematicsMappingFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class VehicleTelematicsSetupPageGQL extends Apollo.Query<
  VehicleTelematicsSetupPageQuery,
  VehicleTelematicsSetupPageQueryVariables
> {
  document = VehicleTelematicsSetupPageDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VehicleTelematicsInventoryDocument = gql`
  query VehicleTelematicsInventory(
    $providerSettingId: ID!
    $fromIndex: Int!
    $pageSize: Int!
    $search: String
  ) {
    telematicsProviderInventory(
      providerSettingId: $providerSettingId
      fromIndex: $fromIndex
      pageSize: $pageSize
      search: $search
    ) {
      fromIndex
      pageSize
      hasMore
      upstreamHttpStatus
      items {
        providerUserId
        displayName
        providerDeviceCount
        latestActivityAt
        classification
        mappingStatus
        mappedVehicleId
        mappedVehicleName
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class VehicleTelematicsInventoryGQL extends Apollo.Query<
  VehicleTelematicsInventoryQuery,
  VehicleTelematicsInventoryQueryVariables
> {
  document = VehicleTelematicsInventoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VehicleTelematicsInventoryDetailDocument = gql`
  query VehicleTelematicsInventoryDetail(
    $providerSettingId: ID!
    $providerUserId: String!
  ) {
    telematicsProviderInventoryItem(
      providerSettingId: $providerSettingId
      providerUserId: $providerUserId
    ) {
      providerUserId
      displayName
      classification
      mappingStatus
      mappedVehicleId
      mappedVehicleName
      upstreamHttpStatus
      devices {
        providerDeviceId
        deviceName
        modelIdentifier
        protocolIdentifier
        maskedImei
        createdAt
        lastDeviceAt
        mappingStatus
        mappedVehicleId
        mappedVehicleName
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class VehicleTelematicsInventoryDetailGQL extends Apollo.Query<
  VehicleTelematicsInventoryDetailQuery,
  VehicleTelematicsInventoryDetailQueryVariables
> {
  document = VehicleTelematicsInventoryDetailDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const VehicleTelematicsStatusVerificationDocument = gql`
  query VehicleTelematicsStatusVerification(
    $providerSettingId: ID!
    $providerUserId: String!
  ) {
    telematicsProviderCurrentStatusPreview(
      providerSettingId: $providerSettingId
      providerUserId: $providerUserId
    ) {
      provider
      providerSettingId
      providerApplicationId
      providerUserId
      providerDisplayName
      receivedAt
      providerObservedAt
      deviceActivityAt
      position {
        latitude
        longitude
        valid
        observedAt
      }
      velocity {
        speedMetersPerSecond
        headingDegrees
        observedAt
      }
      passengerPresence {
        value
        observedAt
        freshness
        providerField
        parseStatus
      }
      taximeterActive {
        value
        observedAt
        freshness
        providerField
        parseStatus
      }
      ignition {
        value
        observedAt
        freshness
        providerField
        parseStatus
      }
      capability
      warnings
      upstreamHttpStatus
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class VehicleTelematicsStatusVerificationGQL extends Apollo.Query<
  VehicleTelematicsStatusVerificationQuery,
  VehicleTelematicsStatusVerificationQueryVariables
> {
  document = VehicleTelematicsStatusVerificationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateVehicleTelematicsConnectionDocument = gql`
  mutation CreateVehicleTelematicsConnection(
    $input: CreateVehicleTelematicsMappingInput!
  ) {
    createVehicleTelematicsMapping(input: $input) {
      ...VehicleTelematicsMappingFields
      verificationDiagnostics {
        detailUpstreamHttpStatus
        statusUpstreamHttpStatus
      }
    }
  }
  ${VehicleTelematicsMappingFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class CreateVehicleTelematicsConnectionGQL extends Apollo.Mutation<
  CreateVehicleTelematicsConnectionMutation,
  CreateVehicleTelematicsConnectionMutationVariables
> {
  document = CreateVehicleTelematicsConnectionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ReplaceVehicleTelematicsConnectionDocument = gql`
  mutation ReplaceVehicleTelematicsConnection(
    $input: ReplaceVehicleTelematicsMappingInput!
  ) {
    replaceVehicleTelematicsMapping(input: $input) {
      ...VehicleTelematicsMappingFields
      verificationDiagnostics {
        detailUpstreamHttpStatus
        statusUpstreamHttpStatus
      }
    }
  }
  ${VehicleTelematicsMappingFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class ReplaceVehicleTelematicsConnectionGQL extends Apollo.Mutation<
  ReplaceVehicleTelematicsConnectionMutation,
  ReplaceVehicleTelematicsConnectionMutationVariables
> {
  document = ReplaceVehicleTelematicsConnectionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const EndVehicleTelematicsConnectionDocument = gql`
  mutation EndVehicleTelematicsConnection(
    $input: EndVehicleTelematicsMappingInput!
  ) {
    endVehicleTelematicsMapping(input: $input) {
      ...VehicleTelematicsMappingFields
    }
  }
  ${VehicleTelematicsMappingFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class EndVehicleTelematicsConnectionGQL extends Apollo.Mutation<
  EndVehicleTelematicsConnectionMutation,
  EndVehicleTelematicsConnectionMutationVariables
> {
  document = EndVehicleTelematicsConnectionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateFleetDocument = gql`
  mutation CreateFleet($input: CreateFleetInput!) {
    createOneFleet(input: { fleet: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateFleetGQL extends Apollo.Mutation<
  CreateFleetMutation,
  CreateFleetMutationVariables
> {
  document = CreateFleetDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ViewFleetDocument = gql`
  query ViewFleet($id: ID!) {
    fleet(id: $id) {
      id
      name
      phoneNumber
      address
      mobileNumber
      accountNumber
      userName
      password
      commissionSharePercent
      commissionShareFlat
      feeMultiplier
      exclusivityAreas {
        lat
        lng
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ViewFleetGQL extends Apollo.Query<
  ViewFleetQuery,
  ViewFleetQueryVariables
> {
  document = ViewFleetDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FleetFinancialsDocument = gql`
  query FleetFinancials(
    $id: ID!
    $paging: OffsetPaging
    $filter: FleetTransactionFilter
    $sorting: [FleetTransactionSort!]
  ) {
    fleet(id: $id) {
      transactions(paging: $paging, filter: $filter, sorting: $sorting) {
        nodes {
          transactionTimestamp
          amount
          currency
          action
          deductType
          rechargeType
          refrenceNumber
          operatorId
          requestId
          description
        }
        totalCount
      }
      wallet {
        currency
        balance
      }
    }
    regions {
      nodes {
        currency
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class FleetFinancialsGQL extends Apollo.Query<
  FleetFinancialsQuery,
  FleetFinancialsQueryVariables
> {
  document = FleetFinancialsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FleetZonePricesDocument = gql`
  query FleetZonePrices(
    $id: ID!
    $paging: OffsetPaging
    $filter: ZonePriceFilter
    $sorting: [ZonePriceSort!]
  ) {
    fleet(id: $id) {
      zonePrices(paging: $paging, filter: $filter, sorting: $sorting) {
        nodes {
          id
          name
        }
        totalCount
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class FleetZonePricesGQL extends Apollo.Query<
  FleetZonePricesQuery,
  FleetZonePricesQueryVariables
> {
  document = FleetZonePricesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FleetDriversDocument = gql`
  query FleetDrivers($id: ID!, $paging: OffsetPaging) {
    drivers(filter: { fleetId: { eq: $id } }, paging: $paging) {
      nodes {
        id
        firstName
        lastName
        mobileNumber
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class FleetDriversGQL extends Apollo.Query<
  FleetDriversQuery,
  FleetDriversQueryVariables
> {
  document = FleetDriversDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateFleetDocument = gql`
  mutation UpdateFleet($id: ID!, $update: UpdateFleetInput!) {
    updateOneFleet(input: { id: $id, update: $update }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateFleetGQL extends Apollo.Mutation<
  UpdateFleetMutation,
  UpdateFleetMutationVariables
> {
  document = UpdateFleetDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateFleetTransactionDocument = gql`
  mutation CreateFleetTransaction($input: FleetTransactionInput!) {
    createFleetTransaction(input: $input) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateFleetTransactionGQL extends Apollo.Mutation<
  CreateFleetTransactionMutation,
  CreateFleetTransactionMutationVariables
> {
  document = CreateFleetTransactionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FleetsListDocument = gql`
  query FleetsList($paging: OffsetPaging, $filter: FleetFilter) {
    fleets(paging: $paging, filter: $filter) {
      nodes {
        id
        name
        phoneNumber
        address
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class FleetsListGQL extends Apollo.Query<
  FleetsListQuery,
  FleetsListQueryVariables
> {
  document = FleetsListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OrderCancelReasonListDocument = gql`
  query OrderCancelReasonList($paging: OffsetPaging) {
    orderCancelReasons(paging: $paging) {
      nodes {
        id
        title
        isEnabled
        userType
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class OrderCancelReasonListGQL extends Apollo.Query<
  OrderCancelReasonListQuery,
  OrderCancelReasonListQueryVariables
> {
  document = OrderCancelReasonListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OrderCancelReasonViewDocument = gql`
  query OrderCancelReasonView($id: ID!) {
    orderCancelReason(id: $id) {
      id
      title
      userType
      isEnabled
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class OrderCancelReasonViewGQL extends Apollo.Query<
  OrderCancelReasonViewQuery,
  OrderCancelReasonViewQueryVariables
> {
  document = OrderCancelReasonViewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateOrderCancelReasonDocument = gql`
  mutation UpdateOrderCancelReason($id: ID!, $update: OrderCancelReasonInput!) {
    updateOneOrderCancelReason(input: { id: $id, update: $update }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateOrderCancelReasonGQL extends Apollo.Mutation<
  UpdateOrderCancelReasonMutation,
  UpdateOrderCancelReasonMutationVariables
> {
  document = UpdateOrderCancelReasonDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateOrderCancelReasonDocument = gql`
  mutation CreateOrderCancelReason($input: OrderCancelReasonInput!) {
    createOneOrderCancelReason(input: { orderCancelReason: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateOrderCancelReasonGQL extends Apollo.Mutation<
  CreateOrderCancelReasonMutation,
  CreateOrderCancelReasonMutationVariables
> {
  document = CreateOrderCancelReasonDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ViewPaymentGatewayDocument = gql`
  query ViewPaymentGateway($id: ID!) {
    paymentGateway(id: $id) {
      id
      title
      type
      enabled
      privateKey
      publicKey
      merchantId
      saltKey
      mediaId
      media {
        address
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ViewPaymentGatewayGQL extends Apollo.Query<
  ViewPaymentGatewayQuery,
  ViewPaymentGatewayQueryVariables
> {
  document = ViewPaymentGatewayDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreatePaymentGatewayDocument = gql`
  mutation CreatePaymentGateway($input: CreatePaymentGatewayInput!) {
    createOnePaymentGateway(input: { paymentGateway: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreatePaymentGatewayGQL extends Apollo.Mutation<
  CreatePaymentGatewayMutation,
  CreatePaymentGatewayMutationVariables
> {
  document = CreatePaymentGatewayDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdatePaymentGatewayDocument = gql`
  mutation UpdatePaymentGateway($id: ID!, $input: UpdatePaymentGatewayInput!) {
    updateOnePaymentGateway(input: { id: $id, update: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdatePaymentGatewayGQL extends Apollo.Mutation<
  UpdatePaymentGatewayMutation,
  UpdatePaymentGatewayMutationVariables
> {
  document = UpdatePaymentGatewayDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PaymentGatewaysDocument = gql`
  query PaymentGateways($paging: OffsetPaging) {
    paymentGateways(paging: $paging) {
      nodes {
        id
        enabled
        title
        type
        media {
          address
        }
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class PaymentGatewaysGQL extends Apollo.Query<
  PaymentGatewaysQuery,
  PaymentGatewaysQueryVariables
> {
  document = PaymentGatewaysDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RegionListDocument = gql`
  query RegionList($paging: OffsetPaging) {
    regions(paging: $paging) {
      nodes {
        id
        name
        currency
        enabled
        location {
          lat
          lng
        }
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class RegionListGQL extends Apollo.Query<
  RegionListQuery,
  RegionListQueryVariables
> {
  document = RegionListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RegionViewDocument = gql`
  query RegionView($id: ID!) {
    region(id: $id) {
      id
      name
      currency
      enabled
      location {
        lat
        lng
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class RegionViewGQL extends Apollo.Query<
  RegionViewQuery,
  RegionViewQueryVariables
> {
  document = RegionViewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateRegionDocument = gql`
  mutation UpdateRegion($id: ID!, $update: UpdateRegionInput!) {
    updateOneRegion(input: { id: $id, update: $update }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateRegionGQL extends Apollo.Mutation<
  UpdateRegionMutation,
  UpdateRegionMutationVariables
> {
  document = UpdateRegionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateRegionDocument = gql`
  mutation CreateRegion($input: CreateRegionInput!) {
    createOneRegion(input: { region: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateRegionGQL extends Apollo.Mutation<
  CreateRegionMutation,
  CreateRegionMutationVariables
> {
  document = CreateRegionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ReviewParameterViewDocument = gql`
  query ReviewParameterView($id: ID!) {
    feedbackParameter(id: $id) {
      id
      title
      isGood
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ReviewParameterViewGQL extends Apollo.Query<
  ReviewParameterViewQuery,
  ReviewParameterViewQueryVariables
> {
  document = ReviewParameterViewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateReviewParameterDocument = gql`
  mutation UpdateReviewParameter($id: ID!, $update: FeedbackParameterInput!) {
    updateOneFeedbackParameter(input: { id: $id, update: $update }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateReviewParameterGQL extends Apollo.Mutation<
  UpdateReviewParameterMutation,
  UpdateReviewParameterMutationVariables
> {
  document = UpdateReviewParameterDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateReviewParameterDocument = gql`
  mutation CreateReviewParameter($input: FeedbackParameterInput!) {
    createOneFeedbackParameter(input: { feedbackParameter: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateReviewParameterGQL extends Apollo.Mutation<
  CreateReviewParameterMutation,
  CreateReviewParameterMutationVariables
> {
  document = CreateReviewParameterDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ReviewParametersListDocument = gql`
  query ReviewParametersList {
    feedbackParameters {
      id
      title
      isGood
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ReviewParametersListGQL extends Apollo.Query<
  ReviewParametersListQuery,
  ReviewParametersListQueryVariables
> {
  document = ReviewParametersListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RolesDocument = gql`
  query Roles {
    operatorRoles {
      id
      title
      systemType
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class RolesGQL extends Apollo.Query<RolesQuery, RolesQueryVariables> {
  document = RolesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RoleDocument = gql`
  query Role($id: ID!) {
    operatorRole(id: $id) {
      id
      title
      systemType
      permissions
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class RoleGQL extends Apollo.Query<RoleQuery, RoleQueryVariables> {
  document = RoleDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateRoleDocument = gql`
  mutation CreateRole($input: OperatorRoleInput!) {
    createOneOperatorRole(input: { operatorRole: $input }) {
      id
      title
      systemType
      permissions
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateRoleGQL extends Apollo.Mutation<
  CreateRoleMutation,
  CreateRoleMutationVariables
> {
  document = CreateRoleDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateRoleDocument = gql`
  mutation UpdateRole($id: ID!, $input: OperatorRoleInput!) {
    updateOneOperatorRole(input: { id: $id, update: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateRoleGQL extends Apollo.Mutation<
  UpdateRoleMutation,
  UpdateRoleMutationVariables
> {
  document = UpdateRoleDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ServiceOptionViewDocument = gql`
  query ServiceOptionView($id: ID!) {
    serviceOption(id: $id) {
      id
      name
      type
      icon
      additionalFee
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ServiceOptionViewGQL extends Apollo.Query<
  ServiceOptionViewQuery,
  ServiceOptionViewQueryVariables
> {
  document = ServiceOptionViewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateServiceOptionDocument = gql`
  mutation UpdateServiceOption($id: ID!, $update: ServiceOptionInput!) {
    updateOneServiceOption(input: { id: $id, update: $update }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateServiceOptionGQL extends Apollo.Mutation<
  UpdateServiceOptionMutation,
  UpdateServiceOptionMutationVariables
> {
  document = UpdateServiceOptionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateServiceOptionDocument = gql`
  mutation CreateServiceOption($input: ServiceOptionInput!) {
    createOneServiceOption(input: { serviceOption: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateServiceOptionGQL extends Apollo.Mutation<
  CreateServiceOptionMutation,
  CreateServiceOptionMutationVariables
> {
  document = CreateServiceOptionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ServiceOptionsListDocument = gql`
  query ServiceOptionsList {
    serviceOptions {
      id
      name
      icon
      type
      additionalFee
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ServiceOptionsListGQL extends Apollo.Query<
  ServiceOptionsListQuery,
  ServiceOptionsListQueryVariables
> {
  document = ServiceOptionsListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ServiceTariffViewDocument = gql`
  query ServiceTariffView($id: ID!) {
    serviceTariffProfile(id: $id) {
      id
      serviceId
      tariffProfileId
      baseFare
      minimumFee
      perKm
      perMinute
      perMinuteDrive
      perMinuteWait
      roundingFactor
      timeMultipliers {
        label
        startTime
        endTime
        upliftPercentage
        enabled
      }
      weekdayMultipliers {
        weekday
        upliftPercentage
        enabled
      }
      dateRangeMultipliers {
        label
        startDateTime
        endDateTime
        upliftPercentage
        enabled
      }
      maxCalendarMultiplier
      searchRadius
      maximumDestinationDistance
      commissionRate
    }
    services {
      id
      name
    }
    tariffProfiles(
      filter: { isActive: { is: true } }
      paging: { limit: 100 }
      sorting: [{ field: title, direction: ASC }]
    ) {
      nodes {
        id
        title
        code
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ServiceTariffViewGQL extends Apollo.Query<
  ServiceTariffViewQuery,
  ServiceTariffViewQueryVariables
> {
  document = ServiceTariffViewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ServiceTariffNewDocument = gql`
  query ServiceTariffNew {
    services {
      id
      name
    }
    tariffProfiles(
      filter: { isActive: { is: true } }
      paging: { limit: 100 }
      sorting: [{ field: title, direction: ASC }]
    ) {
      nodes {
        id
        title
        code
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ServiceTariffNewGQL extends Apollo.Query<
  ServiceTariffNewQuery,
  ServiceTariffNewQueryVariables
> {
  document = ServiceTariffNewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateServiceTariffDocument = gql`
  mutation CreateServiceTariff($input: ServiceTariffProfileInput!) {
    createOneServiceTariffProfile(input: { serviceTariffProfile: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateServiceTariffGQL extends Apollo.Mutation<
  CreateServiceTariffMutation,
  CreateServiceTariffMutationVariables
> {
  document = CreateServiceTariffDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateServiceTariffDocument = gql`
  mutation UpdateServiceTariff($id: ID!, $update: ServiceTariffProfileInput!) {
    updateOneServiceTariffProfile(input: { id: $id, update: $update }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateServiceTariffGQL extends Apollo.Mutation<
  UpdateServiceTariffMutation,
  UpdateServiceTariffMutationVariables
> {
  document = UpdateServiceTariffDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteServiceTariffDocument = gql`
  mutation DeleteServiceTariff($id: ID!) {
    deleteOneServiceTariffProfile(input: { id: $id }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DeleteServiceTariffGQL extends Apollo.Mutation<
  DeleteServiceTariffMutation,
  DeleteServiceTariffMutationVariables
> {
  document = DeleteServiceTariffDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ServiceTariffsListDocument = gql`
  query ServiceTariffsList($paging: OffsetPaging) {
    serviceTariffProfiles(
      paging: $paging
      sorting: [{ field: id, direction: DESC }]
    ) {
      nodes {
        id
        minimumFee
        perKm
        perMinute
        service {
          id
          name
        }
        tariffProfile {
          id
          title
          code
        }
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ServiceTariffsListGQL extends Apollo.Query<
  ServiceTariffsListQuery,
  ServiceTariffsListQueryVariables
> {
  document = ServiceTariffsListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ViewServiceCategoryDocument = gql`
  query ViewServiceCategory($id: ID!) {
    serviceCategory(id: $id) {
      id
      name
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ViewServiceCategoryGQL extends Apollo.Query<
  ViewServiceCategoryQuery,
  ViewServiceCategoryQueryVariables
> {
  document = ViewServiceCategoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateServiceCategoryDocument = gql`
  mutation CreateServiceCategory($input: ServiceCategoryInput!) {
    createOneServiceCategory(input: { serviceCategory: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateServiceCategoryGQL extends Apollo.Mutation<
  CreateServiceCategoryMutation,
  CreateServiceCategoryMutationVariables
> {
  document = CreateServiceCategoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateServiceCategoryDocument = gql`
  mutation UpdateServiceCategory($id: ID!, $input: ServiceCategoryInput!) {
    updateOneServiceCategory(input: { id: $id, update: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateServiceCategoryGQL extends Apollo.Mutation<
  UpdateServiceCategoryMutation,
  UpdateServiceCategoryMutationVariables
> {
  document = UpdateServiceCategoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteServiceCategoryDocument = gql`
  mutation DeleteServiceCategory($id: ID!) {
    deleteOneServiceCategory(input: { id: $id }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DeleteServiceCategoryGQL extends Apollo.Mutation<
  DeleteServiceCategoryMutation,
  DeleteServiceCategoryMutationVariables
> {
  document = DeleteServiceCategoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ServicesListDocument = gql`
  query ServicesList {
    serviceCategories {
      id
      name
      services {
        id
        name
        description
        isDefaultDispatchService
        media {
          address
        }
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ServicesListGQL extends Apollo.Query<
  ServicesListQuery,
  ServicesListQueryVariables
> {
  document = ServicesListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ViewServiceDocument = gql`
  query ViewService($id: ID!) {
    service(id: $id) {
      id
      name
      isDefaultDispatchService
      categoryId
      baseFare
      perHundredMeters
      perMinuteDrive
      perMinuteWait
      minimumFee
      searchRadius
      maximumDestinationDistance
      paymentMethod
      cancellationTotalFee
      cancellationDriverShare
      providerShareFlat
      providerSharePercent
      prepayPercent
      searchRadius
      mediaId
      description
      personCapacity
      roundingFactor
      media {
        address
      }
      timeMultipliers {
        startTime
        endTime
        multiply
      }
      distanceMultipliers {
        distanceFrom
        distanceTo
        multiply
      }
      weekdayMultipliers {
        weekday
        multiply
      }
      dateRangeMultipliers {
        startDate
        endDate
        multiply
      }
      options {
        id
        name
        type
        additionalFee
        icon
      }
      regions {
        id
        name
        currency
      }
    }
    regions {
      nodes {
        id
        name
        currency
      }
    }
    serviceCategories {
      id
      name
    }
    serviceOptions {
      id
      name
      icon
      type
      additionalFee
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ViewServiceGQL extends Apollo.Query<
  ViewServiceQuery,
  ViewServiceQueryVariables
> {
  document = ViewServiceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const NewServiceDocument = gql`
  query NewService {
    regions {
      nodes {
        id
        name
        currency
      }
    }
    serviceCategories {
      id
      name
    }
    serviceOptions {
      id
      name
      icon
      type
      additionalFee
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class NewServiceGQL extends Apollo.Query<
  NewServiceQuery,
  NewServiceQueryVariables
> {
  document = NewServiceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateServiceDocument = gql`
  mutation CreateService($input: ServiceInput!) {
    createOneService(input: { service: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateServiceGQL extends Apollo.Mutation<
  CreateServiceMutation,
  CreateServiceMutationVariables
> {
  document = CreateServiceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteServiceDocument = gql`
  mutation DeleteService($id: ID!) {
    deleteOneService(input: { id: $id }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DeleteServiceGQL extends Apollo.Mutation<
  DeleteServiceMutation,
  DeleteServiceMutationVariables
> {
  document = DeleteServiceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateServiceDocument = gql`
  mutation UpdateService($id: ID!, $input: ServiceInput!) {
    updateOneService(input: { id: $id, update: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateServiceGQL extends Apollo.Mutation<
  UpdateServiceMutation,
  UpdateServiceMutationVariables
> {
  document = UpdateServiceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SetRegionsOnServiceDocument = gql`
  mutation SetRegionsOnService($id: ID!, $relationIds: [ID!]!) {
    setRegionsOnService(input: { id: $id, relationIds: $relationIds }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class SetRegionsOnServiceGQL extends Apollo.Mutation<
  SetRegionsOnServiceMutation,
  SetRegionsOnServiceMutationVariables
> {
  document = SetRegionsOnServiceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SetOptionsOnServiceDocument = gql`
  mutation SetOptionsOnService($id: ID!, $relationIds: [ID!]!) {
    setOptionsOnService(input: { id: $id, relationIds: $relationIds }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class SetOptionsOnServiceGQL extends Apollo.Mutation<
  SetOptionsOnServiceMutation,
  SetOptionsOnServiceMutationVariables
> {
  document = SetOptionsOnServiceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DispatchAutomationSettingsDocument = gql`
  query DispatchAutomationSettings {
    dispatchPolicy {
      ...DispatchSettingsPolicy
    }
  }
  ${DispatchSettingsPolicyFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class DispatchAutomationSettingsGQL extends Apollo.Query<
  DispatchAutomationSettingsQuery,
  DispatchAutomationSettingsQueryVariables
> {
  document = DispatchAutomationSettingsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DispatchAutomationHistoryDocument = gql`
  query DispatchAutomationHistory($beforeVersion: Int) {
    dispatchPolicyHistory(beforeVersion: $beforeVersion) {
      version
      actorOperatorId
      reason
      changedAt
      previousValues {
        automation {
          enabled
          candidateSearchLimit
          initialRadiusMeters
        }
        configuration {
          ...DispatchSettingsConfig
        }
      }
      newValues {
        automation {
          enabled
          candidateSearchLimit
          initialRadiusMeters
        }
        configuration {
          ...DispatchSettingsConfig
        }
      }
    }
  }
  ${DispatchSettingsConfigFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class DispatchAutomationHistoryGQL extends Apollo.Query<
  DispatchAutomationHistoryQuery,
  DispatchAutomationHistoryQueryVariables
> {
  document = DispatchAutomationHistoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SaveDispatchAutomationDocument = gql`
  mutation SaveDispatchAutomation($input: UpdateDispatchPolicyInput!) {
    updateDispatchPolicy(input: $input) {
      ...DispatchSettingsPolicy
    }
  }
  ${DispatchSettingsPolicyFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class SaveDispatchAutomationGQL extends Apollo.Mutation<
  SaveDispatchAutomationMutation,
  SaveDispatchAutomationMutationVariables
> {
  document = SaveDispatchAutomationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdatePasswordDocument = gql`
  mutation UpdatePassword($input: UpdatePasswordInput!) {
    updatePassword(input: $input) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdatePasswordGQL extends Apollo.Mutation<
  UpdatePasswordMutation,
  UpdatePasswordMutationVariables
> {
  document = UpdatePasswordDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetConfigurationDocument = gql`
  query GetConfiguration {
    currentConfiguration {
      backendMapsAPIKey
      adminPanelAPIKey
      adminPanelMapId
    }
    fixedFareRoutingSettings {
      success
      mode
      ignoreLiveTraffic
      recommendedMode
      version
      updatedAt
      updatedByName
      configurationWarning
      message
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetConfigurationGQL extends Apollo.Query<
  GetConfigurationQuery,
  GetConfigurationQueryVariables
> {
  document = GetConfigurationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateConfigDocument = gql`
  mutation UpdateConfig($input: UpdateConfigInput!) {
    saveConfiguration(input: $input) {
      backendMapsAPIKey
      adminPanelAPIKey
      adminPanelMapId
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateConfigGQL extends Apollo.Mutation<
  UpdateConfigMutation,
  UpdateConfigMutationVariables
> {
  document = UpdateConfigDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateFixedFareRoutingModeDocument = gql`
  mutation UpdateFixedFareRoutingMode(
    $input: UpdateFixedFareRoutingModeInput!
  ) {
    updateFixedFareRoutingMode(input: $input) {
      success
      mode
      ignoreLiveTraffic
      recommendedMode
      version
      updatedAt
      updatedByName
      configurationWarning
      message
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateFixedFareRoutingModeGQL extends Apollo.Mutation<
  UpdateFixedFareRoutingModeMutation,
  UpdateFixedFareRoutingModeMutationVariables
> {
  document = UpdateFixedFareRoutingModeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RiderWhatsAppConfigurationDocument = gql`
  query RiderWhatsAppConfiguration {
    riderWhatsAppSettings {
      ...RiderWhatsAppSettingsFields
    }
  }
  ${RiderWhatsAppSettingsFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class RiderWhatsAppConfigurationGQL extends Apollo.Query<
  RiderWhatsAppConfigurationQuery,
  RiderWhatsAppConfigurationQueryVariables
> {
  document = RiderWhatsAppConfigurationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SaveRiderWhatsAppConfigurationDocument = gql`
  mutation SaveRiderWhatsAppConfiguration(
    $input: SaveRiderWhatsAppSettingsInput!
  ) {
    saveRiderWhatsAppSettings(input: $input) {
      ...RiderWhatsAppSettingsFields
    }
  }
  ${RiderWhatsAppSettingsFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class SaveRiderWhatsAppConfigurationGQL extends Apollo.Mutation<
  SaveRiderWhatsAppConfigurationMutation,
  SaveRiderWhatsAppConfigurationMutationVariables
> {
  document = SaveRiderWhatsAppConfigurationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CheckRiderWhatsAppConfigurationDocument = gql`
  mutation CheckRiderWhatsAppConfiguration($expectedVersion: Int!) {
    validateRiderWhatsAppSettings(expectedVersion: $expectedVersion) {
      ...RiderWhatsAppSettingsFields
    }
  }
  ${RiderWhatsAppSettingsFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class CheckRiderWhatsAppConfigurationGQL extends Apollo.Mutation<
  CheckRiderWhatsAppConfigurationMutation,
  CheckRiderWhatsAppConfigurationMutationVariables
> {
  document = CheckRiderWhatsAppConfigurationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ActivateRiderWhatsAppConfigurationDocument = gql`
  mutation ActivateRiderWhatsAppConfiguration(
    $input: SetRiderWhatsAppEnabledInput!
  ) {
    setRiderWhatsAppEnabled(input: $input) {
      ...RiderWhatsAppSettingsFields
    }
  }
  ${RiderWhatsAppSettingsFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class ActivateRiderWhatsAppConfigurationGQL extends Apollo.Mutation<
  ActivateRiderWhatsAppConfigurationMutation,
  ActivateRiderWhatsAppConfigurationMutationVariables
> {
  document = ActivateRiderWhatsAppConfigurationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DisconnectRiderWhatsAppConfigurationDocument = gql`
  mutation DisconnectRiderWhatsAppConfiguration($expectedVersion: Int!) {
    disconnectRiderWhatsApp(expectedVersion: $expectedVersion) {
      ...RiderWhatsAppSettingsFields
    }
  }
  ${RiderWhatsAppSettingsFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class DisconnectRiderWhatsAppConfigurationGQL extends Apollo.Mutation<
  DisconnectRiderWhatsAppConfigurationMutation,
  DisconnectRiderWhatsAppConfigurationMutationVariables
> {
  document = DisconnectRiderWhatsAppConfigurationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const BeginRiderWhatsAppConnectionDocument = gql`
  mutation BeginRiderWhatsAppConnection($expectedVersion: Int!) {
    beginRiderWhatsAppSignup(expectedVersion: $expectedVersion) {
      nonce
      expiresAt
      appId
      configId
      apiVersion
      origin
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class BeginRiderWhatsAppConnectionGQL extends Apollo.Mutation<
  BeginRiderWhatsAppConnectionMutation,
  BeginRiderWhatsAppConnectionMutationVariables
> {
  document = BeginRiderWhatsAppConnectionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExchangeRiderWhatsAppConnectionDocument = gql`
  mutation ExchangeRiderWhatsAppConnection($nonce: String!, $code: String!) {
    exchangeRiderWhatsAppSignup(nonce: $nonce, code: $code)
  }
`;

@Injectable({
  providedIn: "root",
})
export class ExchangeRiderWhatsAppConnectionGQL extends Apollo.Mutation<
  ExchangeRiderWhatsAppConnectionMutation,
  ExchangeRiderWhatsAppConnectionMutationVariables
> {
  document = ExchangeRiderWhatsAppConnectionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RiderWhatsAppConnectionPhonesDocument = gql`
  mutation RiderWhatsAppConnectionPhones(
    $nonce: String!
    $businessAccountId: String!
  ) {
    riderWhatsAppSignupPhones(
      nonce: $nonce
      businessAccountId: $businessAccountId
    ) {
      id
      displayNumber
      verifiedName
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class RiderWhatsAppConnectionPhonesGQL extends Apollo.Mutation<
  RiderWhatsAppConnectionPhonesMutation,
  RiderWhatsAppConnectionPhonesMutationVariables
> {
  document = RiderWhatsAppConnectionPhonesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CompleteRiderWhatsAppConnectionDocument = gql`
  mutation CompleteRiderWhatsAppConnection(
    $nonce: String!
    $phoneNumberId: String!
    $template: String!
    $language: String!
  ) {
    completeRiderWhatsAppSignup(
      nonce: $nonce
      phoneNumberId: $phoneNumberId
      template: $template
      language: $language
    )
  }
`;

@Injectable({
  providedIn: "root",
})
export class CompleteRiderWhatsAppConnectionGQL extends Apollo.Mutation<
  CompleteRiderWhatsAppConnectionMutation,
  CompleteRiderWhatsAppConnectionMutationVariables
> {
  document = CompleteRiderWhatsAppConnectionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CancelRiderWhatsAppConnectionDocument = gql`
  mutation CancelRiderWhatsAppConnection($nonce: String!) {
    cancelRiderWhatsAppSignup(nonce: $nonce)
  }
`;

@Injectable({
  providedIn: "root",
})
export class CancelRiderWhatsAppConnectionGQL extends Apollo.Mutation<
  CancelRiderWhatsAppConnectionMutation,
  CancelRiderWhatsAppConnectionMutationVariables
> {
  document = CancelRiderWhatsAppConnectionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SmsProvidersDocument = gql`
  query SMSProviders($paging: OffsetPaging) {
    smsProviders(paging: $paging) {
      nodes {
        id
        isDefault
        name
        type
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class SmsProvidersGQL extends Apollo.Query<
  SmsProvidersQuery,
  SmsProvidersQueryVariables
> {
  document = SmsProvidersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ViewSmsProviderDocument = gql`
  query ViewSMSProvider($id: ID!) {
    smsProvider(id: $id) {
      id
      name
      type
      isDefault
      authToken
      accountId
      fromNumber
      verificationTemplate
      smsType
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ViewSmsProviderGQL extends Apollo.Query<
  ViewSmsProviderQuery,
  ViewSmsProviderQueryVariables
> {
  document = ViewSmsProviderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateSmsProviderDocument = gql`
  mutation CreateSMSProvider($input: SMSProviderInput!) {
    createOneSMSProvider(input: { sMSProvider: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateSmsProviderGQL extends Apollo.Mutation<
  CreateSmsProviderMutation,
  CreateSmsProviderMutationVariables
> {
  document = CreateSmsProviderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateSmsProviderDocument = gql`
  mutation UpdateSMSProvider($id: ID!, $input: SMSProviderInput!) {
    updateOneSMSProvider(input: { id: $id, update: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateSmsProviderGQL extends Apollo.Mutation<
  UpdateSmsProviderMutation,
  UpdateSmsProviderMutationVariables
> {
  document = UpdateSmsProviderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const MarkSmsProviderAsDefaultDocument = gql`
  mutation MarkSMSProviderAsDefault($id: ID!) {
    markSMSProviderAsDefault(id: $id) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class MarkSmsProviderAsDefaultGQL extends Apollo.Mutation<
  MarkSmsProviderAsDefaultMutation,
  MarkSmsProviderAsDefaultMutationVariables
> {
  document = MarkSmsProviderAsDefaultDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TariffProfileViewDocument = gql`
  query TariffProfileView($id: ID!) {
    tariffProfile(id: $id) {
      id
      code
      title
      description
      isDefault
      isActive
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class TariffProfileViewGQL extends Apollo.Query<
  TariffProfileViewQuery,
  TariffProfileViewQueryVariables
> {
  document = TariffProfileViewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TariffProfileNewDocument = gql`
  query TariffProfileNew {
    tariffProfiles(filter: { isDefault: { is: true } }, paging: { limit: 1 }) {
      nodes {
        id
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class TariffProfileNewGQL extends Apollo.Query<
  TariffProfileNewQuery,
  TariffProfileNewQueryVariables
> {
  document = TariffProfileNewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateTariffProfileDocument = gql`
  mutation CreateTariffProfile($input: TariffProfileInput!) {
    createOneTariffProfile(input: { tariffProfile: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateTariffProfileGQL extends Apollo.Mutation<
  CreateTariffProfileMutation,
  CreateTariffProfileMutationVariables
> {
  document = CreateTariffProfileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateTariffProfileDocument = gql`
  mutation UpdateTariffProfile($id: ID!, $update: TariffProfileInput!) {
    updateOneTariffProfile(input: { id: $id, update: $update }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateTariffProfileGQL extends Apollo.Mutation<
  UpdateTariffProfileMutation,
  UpdateTariffProfileMutationVariables
> {
  document = UpdateTariffProfileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteTariffProfileDocument = gql`
  mutation DeleteTariffProfile($id: ID!) {
    deleteOneTariffProfile(input: { id: $id }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DeleteTariffProfileGQL extends Apollo.Mutation<
  DeleteTariffProfileMutation,
  DeleteTariffProfileMutationVariables
> {
  document = DeleteTariffProfileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TariffProfilesListDocument = gql`
  query TariffProfilesList($paging: OffsetPaging) {
    tariffProfiles(
      paging: $paging
      sorting: [{ field: title, direction: ASC }]
    ) {
      nodes {
        id
        code
        title
        isDefault
        isActive
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class TariffProfilesListGQL extends Apollo.Query<
  TariffProfilesListQuery,
  TariffProfilesListQueryVariables
> {
  document = TariffProfilesListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TelematicsFeatureStateDocument = gql`
  query TelematicsFeatureState {
    telematicsFeatureState {
      configurationEnabled
      liveSyncEnabled
      historySyncEnabled
      integrityAlertsEnabled
      operatorLiveViewEnabled
      retentionDays
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class TelematicsFeatureStateGQL extends Apollo.Query<
  TelematicsFeatureStateQuery,
  TelematicsFeatureStateQueryVariables
> {
  document = TelematicsFeatureStateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TelematicsSettingsPageDocument = gql`
  query TelematicsSettingsPage {
    telematicsProviderSettings {
      id
      provider
      displayName
      enabled
      baseUrl
      applicationId
      tokenConfigured
      providerTimeZone
      retentionDays
      createdAt
      updatedAt
      deactivatedAt
      lastSuccessAt
      lastError
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class TelematicsSettingsPageGQL extends Apollo.Query<
  TelematicsSettingsPageQuery,
  TelematicsSettingsPageQueryVariables
> {
  document = TelematicsSettingsPageDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const IntegrationRuntimeSettingsDocument = gql`
  query IntegrationRuntimeSettings($providerSettingId: ID) {
    integrationRuntimeConfiguration(providerSettingId: $providerSettingId) {
      ...IntegrationRuntimeConfigurationFields
    }
  }
  ${IntegrationRuntimeConfigurationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class IntegrationRuntimeSettingsGQL extends Apollo.Query<
  IntegrationRuntimeSettingsQuery,
  IntegrationRuntimeSettingsQueryVariables
> {
  document = IntegrationRuntimeSettingsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const IntegrationRuntimePolicyHistoryDocument = gql`
  query IntegrationRuntimePolicyHistory(
    $providerSettingId: ID!
    $policyType: IntegrationRuntimePolicyType!
    $page: Int!
  ) {
    integrationRuntimePolicyRevisions(
      providerSettingId: $providerSettingId
      policyType: $policyType
      page: $page
    ) {
      id
      policyType
      priorVersion
      newVersion
      changedFields
      previousValuesJson
      newValuesJson
      actorOperatorId
      reason
      changedAt
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class IntegrationRuntimePolicyHistoryGQL extends Apollo.Query<
  IntegrationRuntimePolicyHistoryQuery,
  IntegrationRuntimePolicyHistoryQueryVariables
> {
  document = IntegrationRuntimePolicyHistoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateTelematicsRuntimePolicyDocument = gql`
  mutation UpdateTelematicsRuntimePolicy(
    $input: UpdateTelematicsRuntimePolicyInput!
  ) {
    updateTelematicsRuntimePolicy(input: $input) {
      providerSettingId
      source
      environmentMasterAllowed
      policyId
      version
      blockers
      readiness {
        providerConfigured
        providerEnabled
        activeMappingCount
        workerSafetyValid
      }
      requested {
        ...TelematicsRuntimeValuesFields
      }
      effective {
        ...TelematicsRuntimeValuesFields
      }
    }
  }
  ${TelematicsRuntimeValuesFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class UpdateTelematicsRuntimePolicyGQL extends Apollo.Mutation<
  UpdateTelematicsRuntimePolicyMutation,
  UpdateTelematicsRuntimePolicyMutationVariables
> {
  document = UpdateTelematicsRuntimePolicyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateAdminDesktopAlertRuntimePolicyDocument = gql`
  mutation UpdateAdminDesktopAlertRuntimePolicy(
    $providerSettingId: ID!
    $input: UpdateAdminDesktopAlertRuntimePolicyInput!
  ) {
    updateAdminDesktopAlertRuntimePolicy(
      providerSettingId: $providerSettingId
      input: $input
    ) {
      ...IntegrationRuntimeConfigurationFields
    }
  }
  ${IntegrationRuntimeConfigurationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class UpdateAdminDesktopAlertRuntimePolicyGQL extends Apollo.Mutation<
  UpdateAdminDesktopAlertRuntimePolicyMutation,
  UpdateAdminDesktopAlertRuntimePolicyMutationVariables
> {
  document = UpdateAdminDesktopAlertRuntimePolicyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ApplyTelematicsRuntimePresetDocument = gql`
  mutation ApplyTelematicsRuntimePreset(
    $input: ApplyTelematicsRuntimePresetInput!
  ) {
    applyTelematicsRuntimePreset(input: $input) {
      ...IntegrationRuntimeConfigurationFields
    }
  }
  ${IntegrationRuntimeConfigurationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class ApplyTelematicsRuntimePresetGQL extends Apollo.Mutation<
  ApplyTelematicsRuntimePresetMutation,
  ApplyTelematicsRuntimePresetMutationVariables
> {
  document = ApplyTelematicsRuntimePresetDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DisableAllIntegrationRuntimeDocument = gql`
  mutation DisableAllIntegrationRuntime(
    $input: DisableAllIntegrationRuntimeInput!
  ) {
    disableAllIntegrationRuntime(input: $input) {
      ...IntegrationRuntimeConfigurationFields
    }
  }
  ${IntegrationRuntimeConfigurationFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class DisableAllIntegrationRuntimeGQL extends Apollo.Mutation<
  DisableAllIntegrationRuntimeMutation,
  DisableAllIntegrationRuntimeMutationVariables
> {
  document = DisableAllIntegrationRuntimeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TelematicsProfilesDocument = gql`
  query TelematicsProfiles(
    $providerSettingId: ID!
    $includeInactive: Boolean!
  ) {
    telematicsProfiles(
      providerSettingId: $providerSettingId
      includeInactive: $includeInactive
    ) {
      id
      providerSettingId
      name
      version
      schemaVersion
      active
      published
      previousProfileId
      createdAt
      updatedAt
      fields {
        semanticField
        currentStatusKey
        historicalKey
        expectedType
        required
        caseSensitive
        unit
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class TelematicsProfilesGQL extends Apollo.Query<
  TelematicsProfilesQuery,
  TelematicsProfilesQueryVariables
> {
  document = TelematicsProfilesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpsertTelematicsProviderSettingDocument = gql`
  mutation UpsertTelematicsProviderSetting(
    $input: UpsertTelematicsProviderSettingInput!
  ) {
    upsertTelematicsProviderSetting(input: $input) {
      id
      provider
      displayName
      enabled
      baseUrl
      applicationId
      tokenConfigured
      providerTimeZone
      retentionDays
      createdAt
      updatedAt
      deactivatedAt
      lastSuccessAt
      lastError
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpsertTelematicsProviderSettingGQL extends Apollo.Mutation<
  UpsertTelematicsProviderSettingMutation,
  UpsertTelematicsProviderSettingMutationVariables
> {
  document = UpsertTelematicsProviderSettingDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SetTelematicsProviderSecretDocument = gql`
  mutation SetTelematicsProviderSecret(
    $input: SetTelematicsProviderSecretInput!
  ) {
    setTelematicsProviderSecret(input: $input) {
      id
      tokenConfigured
      updatedAt
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class SetTelematicsProviderSecretGQL extends Apollo.Mutation<
  SetTelematicsProviderSecretMutation,
  SetTelematicsProviderSecretMutationVariables
> {
  document = SetTelematicsProviderSecretDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateTelematicsProfileVersionDocument = gql`
  mutation CreateTelematicsProfileVersion(
    $input: CreateTelematicsProfileVersionInput!
  ) {
    createTelematicsProfileVersion(input: $input) {
      id
      providerSettingId
      name
      version
      active
      published
      previousProfileId
      createdAt
      updatedAt
      fields {
        semanticField
        currentStatusKey
        historicalKey
        expectedType
        required
        caseSensitive
        unit
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateTelematicsProfileVersionGQL extends Apollo.Mutation<
  CreateTelematicsProfileVersionMutation,
  CreateTelematicsProfileVersionMutationVariables
> {
  document = CreateTelematicsProfileVersionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SetTelematicsProfileActiveDocument = gql`
  mutation SetTelematicsProfileActive(
    $input: SetTelematicsProfileActiveInput!
  ) {
    setTelematicsProfileActive(input: $input) {
      id
      active
      updatedAt
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class SetTelematicsProfileActiveGQL extends Apollo.Mutation<
  SetTelematicsProfileActiveMutation,
  SetTelematicsProfileActiveMutationVariables
> {
  document = SetTelematicsProfileActiveDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TestTelematicsProviderConnectionDocument = gql`
  mutation TestTelematicsProviderConnection($providerSettingId: ID!) {
    testTelematicsProviderConnection(providerSettingId: $providerSettingId) {
      success
      status
      testedAt
      latencyMs
      upstreamHttpStatus
      provider
      applicationId
      errorCode
      recommendedAction
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class TestTelematicsProviderConnectionGQL extends Apollo.Mutation<
  TestTelematicsProviderConnectionMutation,
  TestTelematicsProviderConnectionMutationVariables
> {
  document = TestTelematicsProviderConnectionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TelematicsProviderVariablesDocument = gql`
  query TelematicsProviderVariables($providerSettingId: ID!) {
    telematicsProviderVariables(providerSettingId: $providerSettingId) {
      name
      providerType
      description
      unitName
      usedByActiveProfile
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class TelematicsProviderVariablesGQL extends Apollo.Query<
  TelematicsProviderVariablesQuery,
  TelematicsProviderVariablesQueryVariables
> {
  document = TelematicsProviderVariablesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TelematicsProviderInventoryDocument = gql`
  query TelematicsProviderInventory(
    $providerSettingId: ID!
    $fromIndex: Int!
    $pageSize: Int!
    $search: String
  ) {
    telematicsProviderInventory(
      providerSettingId: $providerSettingId
      fromIndex: $fromIndex
      pageSize: $pageSize
      search: $search
    ) {
      fromIndex
      pageSize
      hasMore
      upstreamHttpStatus
      items {
        providerUserId
        displayName
        providerDeviceCount
        latestActivityAt
        classification
        mappingStatus
        mappedVehicleId
        mappedVehicleName
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class TelematicsProviderInventoryGQL extends Apollo.Query<
  TelematicsProviderInventoryQuery,
  TelematicsProviderInventoryQueryVariables
> {
  document = TelematicsProviderInventoryDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TelematicsProviderInventoryItemDocument = gql`
  query TelematicsProviderInventoryItem(
    $providerSettingId: ID!
    $providerUserId: String!
  ) {
    telematicsProviderInventoryItem(
      providerSettingId: $providerSettingId
      providerUserId: $providerUserId
    ) {
      providerUserId
      displayName
      classification
      mappingStatus
      mappedVehicleId
      mappedVehicleName
      upstreamHttpStatus
      devices {
        providerDeviceId
        deviceName
        modelIdentifier
        protocolIdentifier
        maskedImei
        createdAt
        lastDeviceAt
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class TelematicsProviderInventoryItemGQL extends Apollo.Query<
  TelematicsProviderInventoryItemQuery,
  TelematicsProviderInventoryItemQueryVariables
> {
  document = TelematicsProviderInventoryItemDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TelematicsProviderCurrentStatusPreviewDocument = gql`
  query TelematicsProviderCurrentStatusPreview(
    $providerSettingId: ID!
    $providerUserId: String!
  ) {
    telematicsProviderCurrentStatusPreview(
      providerSettingId: $providerSettingId
      providerUserId: $providerUserId
    ) {
      provider
      providerSettingId
      providerApplicationId
      providerUserId
      providerDeviceId
      providerDisplayName
      receivedAt
      providerObservedAt
      deviceActivityAt
      position {
        latitude
        longitude
        altitude
        valid
        observedAt
      }
      velocity {
        speedMetersPerSecond
        headingDegrees
        observedAt
      }
      passengerPresence {
        value
        observedAt
        freshness
        providerField
        parseStatus
      }
      taximeterActive {
        value
        observedAt
        freshness
        providerField
        parseStatus
      }
      ignition {
        value
        observedAt
        freshness
        providerField
        parseStatus
      }
      odometerMeters
      doorState
      gsmSignalLevel
      satelliteCount
      voltage
      trackerBatteryLevel
      capability
      warnings
      canonicalHash
      upstreamHttpStatus
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class TelematicsProviderCurrentStatusPreviewGQL extends Apollo.Query<
  TelematicsProviderCurrentStatusPreviewQuery,
  TelematicsProviderCurrentStatusPreviewQueryVariables
> {
  document = TelematicsProviderCurrentStatusPreviewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateOperatorDocument = gql`
  mutation CreateOperator($input: CreateOperatorInput!) {
    createOneOperator(input: { operator: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateOperatorGQL extends Apollo.Mutation<
  CreateOperatorMutation,
  CreateOperatorMutationVariables
> {
  document = CreateOperatorDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ViewOperatorDocument = gql`
  query ViewOperator($id: ID!) {
    operator(id: $id) {
      id
      firstName
      lastName
      mobileNumber
      userName
      email
      roleId
    }
    operatorRoles {
      id
      title
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ViewOperatorGQL extends Apollo.Query<
  ViewOperatorQuery,
  ViewOperatorQueryVariables
> {
  document = ViewOperatorDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const NewOperatorDocument = gql`
  query NewOperator {
    operatorRoles {
      id
      title
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class NewOperatorGQL extends Apollo.Query<
  NewOperatorQuery,
  NewOperatorQueryVariables
> {
  document = NewOperatorDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateOperatorDocument = gql`
  mutation UpdateOperator($id: ID!, $update: UpdateOperatorInput!) {
    updateOneOperator(input: { id: $id, update: $update }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateOperatorGQL extends Apollo.Mutation<
  UpdateOperatorMutation,
  UpdateOperatorMutationVariables
> {
  document = UpdateOperatorDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AdminResetOperatorPasswordDocument = gql`
  mutation AdminResetOperatorPassword(
    $input: AdminResetOperatorPasswordInput!
  ) {
    adminResetOperatorPassword(input: $input)
  }
`;

@Injectable({
  providedIn: "root",
})
export class AdminResetOperatorPasswordGQL extends Apollo.Mutation<
  AdminResetOperatorPasswordMutation,
  AdminResetOperatorPasswordMutationVariables
> {
  document = AdminResetOperatorPasswordDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UsersListDocument = gql`
  query UsersList($paging: OffsetPaging) {
    operators(paging: $paging) {
      nodes {
        id
        userName
        firstName
        lastName
        email
        mobileNumber
        role {
          title
        }
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UsersListGQL extends Apollo.Query<
  UsersListQuery,
  UsersListQueryVariables
> {
  document = UsersListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ZoneMultiplierViewDocument = gql`
  query ZoneMultiplierView($id: ID!) {
    zoneMultiplier(id: $id) {
      id
      name
      area {
        lat
        lng
      }
      multiplier
      triggerType
      priority
      enabled
      notes
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ZoneMultiplierViewGQL extends Apollo.Query<
  ZoneMultiplierViewQuery,
  ZoneMultiplierViewQueryVariables
> {
  document = ZoneMultiplierViewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ZoneMultiplierNewDocument = gql`
  query ZoneMultiplierNew {
    __typename
  }
`;

@Injectable({
  providedIn: "root",
})
export class ZoneMultiplierNewGQL extends Apollo.Query<
  ZoneMultiplierNewQuery,
  ZoneMultiplierNewQueryVariables
> {
  document = ZoneMultiplierNewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateZoneMultiplierDocument = gql`
  mutation UpdateZoneMultiplier($id: ID!, $update: ZoneMultiplierInput!) {
    updateOneZoneMultiplier(input: { id: $id, update: $update }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateZoneMultiplierGQL extends Apollo.Mutation<
  UpdateZoneMultiplierMutation,
  UpdateZoneMultiplierMutationVariables
> {
  document = UpdateZoneMultiplierDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateZoneMultiplierDocument = gql`
  mutation CreateZoneMultiplier($input: ZoneMultiplierInput!) {
    createOneZoneMultiplier(input: { zoneMultiplier: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateZoneMultiplierGQL extends Apollo.Mutation<
  CreateZoneMultiplierMutation,
  CreateZoneMultiplierMutationVariables
> {
  document = CreateZoneMultiplierDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteZoneMultiplierDocument = gql`
  mutation DeleteZoneMultiplier($id: ID!) {
    deleteOneZoneMultiplier(input: { id: $id }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DeleteZoneMultiplierGQL extends Apollo.Mutation<
  DeleteZoneMultiplierMutation,
  DeleteZoneMultiplierMutationVariables
> {
  document = DeleteZoneMultiplierDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ZoneMultipliersListDocument = gql`
  query ZoneMultipliersList($paging: OffsetPaging) {
    zoneMultipliers(paging: $paging) {
      nodes {
        id
        name
        area {
          lat
          lng
        }
        multiplier
        triggerType
        priority
        enabled
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ZoneMultipliersListGQL extends Apollo.Query<
  ZoneMultipliersListQuery,
  ZoneMultipliersListQueryVariables
> {
  document = ZoneMultipliersListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ZonePriceViewDocument = gql`
  query ZonePriceView($id: ID!) {
    zonePrice(id: $id) {
      id
      name
      from {
        lat
        lng
      }
      to {
        lat
        lng
      }
      cost
      profileFares {
        id
        tariffProfileId
        tariffProfileName
        tariffProfileCode
        fixedPrice
        enabled
      }
      services {
        id
      }
      fleets {
        id
      }
      timeMultipliers {
        startTime
        endTime
        multiply
      }
    }
    fleets(paging: { limit: 50 }) {
      nodes {
        id
        name
      }
    }
    services {
      id
      name
    }
    tariffProfiles(
      filter: { isActive: { is: true } }
      paging: { limit: 100 }
      sorting: [{ field: title, direction: ASC }]
    ) {
      nodes {
        id
        title
        code
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ZonePriceViewGQL extends Apollo.Query<
  ZonePriceViewQuery,
  ZonePriceViewQueryVariables
> {
  document = ZonePriceViewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ZonePriceNewDocument = gql`
  query ZonePriceNew {
    fleets(paging: { limit: 50 }) {
      nodes {
        id
        name
      }
    }
    services {
      id
      name
    }
    tariffProfiles(
      filter: { isActive: { is: true } }
      paging: { limit: 100 }
      sorting: [{ field: title, direction: ASC }]
    ) {
      nodes {
        id
        title
        code
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ZonePriceNewGQL extends Apollo.Query<
  ZonePriceNewQuery,
  ZonePriceNewQueryVariables
> {
  document = ZonePriceNewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateZonePriceDocument = gql`
  mutation UpdateZonePrice($id: ID!, $update: ZonePriceInput!) {
    updateOneZonePrice(input: { id: $id, update: $update }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateZonePriceGQL extends Apollo.Mutation<
  UpdateZonePriceMutation,
  UpdateZonePriceMutationVariables
> {
  document = UpdateZonePriceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateZonePriceDocument = gql`
  mutation CreateZonePrice($input: ZonePriceInput!) {
    createOneZonePrice(input: { zonePrice: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateZonePriceGQL extends Apollo.Mutation<
  CreateZonePriceMutation,
  CreateZonePriceMutationVariables
> {
  document = CreateZonePriceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteZonePriceDocument = gql`
  mutation DeleteZonePrice($id: ID!) {
    deleteOneZonePrice(input: { id: $id }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DeleteZonePriceGQL extends Apollo.Mutation<
  DeleteZonePriceMutation,
  DeleteZonePriceMutationVariables
> {
  document = DeleteZonePriceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SetZonePriceRelationsDocument = gql`
  mutation SetZonePriceRelations($id: ID!, $services: [ID!]!, $fleets: [ID!]!) {
    setServicesOnZonePrice(input: { id: $id, relationIds: $services }) {
      id
    }
    setFleetsOnZonePrice(input: { id: $id, relationIds: $fleets }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class SetZonePriceRelationsGQL extends Apollo.Mutation<
  SetZonePriceRelationsMutation,
  SetZonePriceRelationsMutationVariables
> {
  document = SetZonePriceRelationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SaveZonePriceProfileFaresDocument = gql`
  mutation SaveZonePriceProfileFares($input: SaveZonePriceProfileFaresInput!) {
    saveZonePriceProfileFares(input: $input) {
      id
      tariffProfileId
      tariffProfileName
      tariffProfileCode
      fixedPrice
      enabled
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class SaveZonePriceProfileFaresGQL extends Apollo.Mutation<
  SaveZonePriceProfileFaresMutation,
  SaveZonePriceProfileFaresMutationVariables
> {
  document = SaveZonePriceProfileFaresDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ZonePricesListDocument = gql`
  query ZonePricesList($paging: OffsetPaging) {
    zonePrices(paging: $paging) {
      nodes {
        id
        name
        cost
        profileFares {
          id
          tariffProfileId
          tariffProfileName
          tariffProfileCode
          fixedPrice
          enabled
        }
        from {
          lat
          lng
        }
        to {
          lat
          lng
        }
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ZonePricesListGQL extends Apollo.Query<
  ZonePricesListQuery,
  ZonePricesListQueryVariables
> {
  document = ZonePricesListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ViewAnnouncementDocument = gql`
  query ViewAnnouncement($id: ID!) {
    announcement(id: $id) {
      id
      title
      userType
      description
      url
      startAt
      expireAt
      notificationSentAt
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ViewAnnouncementGQL extends Apollo.Query<
  ViewAnnouncementQuery,
  ViewAnnouncementQueryVariables
> {
  document = ViewAnnouncementDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateAnnouncementDocument = gql`
  mutation CreateAnnouncement($input: CreateAnnouncementInput!) {
    createAnnouncement(input: $input) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateAnnouncementGQL extends Apollo.Mutation<
  CreateAnnouncementMutation,
  CreateAnnouncementMutationVariables
> {
  document = CreateAnnouncementDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateAnnouncementDocument = gql`
  mutation UpdateAnnouncement($id: ID!, $input: UpdateAnnouncementInput!) {
    updateOneAnnouncement(input: { id: $id, update: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateAnnouncementGQL extends Apollo.Mutation<
  UpdateAnnouncementMutation,
  UpdateAnnouncementMutationVariables
> {
  document = UpdateAnnouncementDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteAnnouncementDocument = gql`
  mutation DeleteAnnouncement($id: ID!) {
    deleteOneAnnouncement(input: { id: $id }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DeleteAnnouncementGQL extends Apollo.Mutation<
  DeleteAnnouncementMutation,
  DeleteAnnouncementMutationVariables
> {
  document = DeleteAnnouncementDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AnnouncementsListDocument = gql`
  query AnnouncementsList($paging: OffsetPaging) {
    announcements(paging: $paging) {
      nodes {
        id
        title
        userType
        description
        startAt
        expireAt
        notificationSentAt
      }
      totalCount
    }
    announcementSummary: announcements(paging: { limit: 10000 }) {
      nodes {
        id
        userType
        notificationSentAt
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class AnnouncementsListGQL extends Apollo.Query<
  AnnouncementsListQuery,
  AnnouncementsListQueryVariables
> {
  document = AnnouncementsListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ViewCouponDocument = gql`
  query ViewCoupon($id: ID!) {
    coupon(id: $id) {
      id
      isEnabled
      code
      title
      description
      manyUsersCanUse
      manyTimesUserCanUse
      minimumCost
      maximumCost
      startAt
      expireAt
      discountPercent
      discountFlat
      creditGift
      isEnabled
      isFirstTravelOnly
      allowedServices {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ViewCouponGQL extends Apollo.Query<
  ViewCouponQuery,
  ViewCouponQueryVariables
> {
  document = ViewCouponDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateCouponDocument = gql`
  mutation CreateCoupon($input: CouponInput!) {
    createOneCoupon(input: { coupon: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateCouponGQL extends Apollo.Mutation<
  CreateCouponMutation,
  CreateCouponMutationVariables
> {
  document = CreateCouponDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateCouponDocument = gql`
  mutation UpdateCoupon($id: ID!, $input: CouponInput!) {
    updateOneCoupon(input: { id: $id, update: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateCouponGQL extends Apollo.Mutation<
  UpdateCouponMutation,
  UpdateCouponMutationVariables
> {
  document = UpdateCouponDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteCouponDocument = gql`
  mutation DeleteCoupon($id: ID!) {
    deleteOneCoupon(input: { id: $id }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DeleteCouponGQL extends Apollo.Mutation<
  DeleteCouponMutation,
  DeleteCouponMutationVariables
> {
  document = DeleteCouponDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CouponListDocument = gql`
  query CouponList($paging: OffsetPaging) {
    coupons(paging: $paging) {
      nodes {
        id
        code
        title
        isEnabled
        description
        manyUsersCanUse
        manyTimesUserCanUse
        minimumCost
        maximumCost
        discountPercent
        discountFlat
        creditGift
        isFirstTravelOnly
        startAt
        expireAt
      }
      totalCount
    }
    couponSummary: coupons(paging: { limit: 10000 }) {
      nodes {
        id
        isEnabled
        manyUsersCanUse
        manyTimesUserCanUse
        startAt
        expireAt
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CouponListGQL extends Apollo.Query<
  CouponListQuery,
  CouponListQueryVariables
> {
  document = CouponListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GiftBatchListDocument = gql`
  query GiftBatchList($paging: OffsetPaging) {
    giftBatches(paging: $paging) {
      nodes {
        id
        name
        currency
        amount
        availableFrom
        expireAt
        totalUsed: giftCodesAggregate(filter: { usedAt: { isNot: null } }) {
          count {
            id
          }
        }
        totalUnused: giftCodesAggregate(filter: { usedAt: { is: null } }) {
          count {
            id
          }
        }
      }
      totalCount
    }
    giftBatchSummary: giftBatches(paging: { limit: 10000 }) {
      nodes {
        id
        availableFrom
        expireAt
        totalUsed: giftCodesAggregate(filter: { usedAt: { isNot: null } }) {
          count {
            id
          }
        }
        totalUnused: giftCodesAggregate(filter: { usedAt: { is: null } }) {
          count {
            id
          }
        }
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GiftBatchListGQL extends Apollo.Query<
  GiftBatchListQuery,
  GiftBatchListQueryVariables
> {
  document = GiftBatchListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateGiftBachDocument = gql`
  mutation CreateGiftBach($input: CreateGiftBatchInput!) {
    createGiftCardBatch(input: $input) {
      id
      name
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateGiftBachGQL extends Apollo.Mutation<
  CreateGiftBachMutation,
  CreateGiftBachMutationVariables
> {
  document = CreateGiftBachDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ViewGiftBatchDocument = gql`
  query ViewGiftBatch($id: ID!) {
    giftBatch(id: $id) {
      id
      name
      amount
      currency
      availableFrom
      expireAt
      totalUsed: giftCodesAggregate(filter: { usedAt: { isNot: null } }) {
        count {
          id
        }
      }
      totalUnused: giftCodesAggregate(filter: { usedAt: { is: null } }) {
        count {
          id
        }
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ViewGiftBatchGQL extends Apollo.Query<
  ViewGiftBatchQuery,
  ViewGiftBatchQueryVariables
> {
  document = ViewGiftBatchDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GiftCodeListDocument = gql`
  query GiftCodeList($giftBatchId: ID!, $paging: OffsetPaging!) {
    giftBatch(id: $giftBatchId) {
      giftCodes(paging: $paging) {
        nodes {
          id
          code
          usedAt
          riderTransaction {
            riderId
            rider {
              firstName
              lastName
            }
          }
          driverTransaction {
            driverId
            driver {
              firstName
              lastName
            }
          }
        }
        totalCount
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GiftCodeListGQL extends Apollo.Query<
  GiftCodeListQuery,
  GiftCodeListQueryVariables
> {
  document = GiftCodeListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportGiftBatchToCsvDocument = gql`
  mutation ExportGiftBatchToCSV($giftBatchId: ID!) {
    exportGiftCardBatch(batchId: $giftBatchId)
  }
`;

@Injectable({
  providedIn: "root",
})
export class ExportGiftBatchToCsvGQL extends Apollo.Mutation<
  ExportGiftBatchToCsvMutation,
  ExportGiftBatchToCsvMutationVariables
> {
  document = ExportGiftBatchToCsvDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RewardListDocument = gql`
  query RewardList($paging: OffsetPaging) {
    rewards(paging: $paging) {
      nodes {
        id
        title
        startDate
        endDate
        beneficiary
        event
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class RewardListGQL extends Apollo.Query<
  RewardListQuery,
  RewardListQueryVariables
> {
  document = RewardListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ViewRewardDocument = gql`
  query ViewReward($id: ID!) {
    reward(id: $id) {
      id
      title
      startDate
      endDate
      appType
      beneficiary
      event
      creditGift
      tripFeePercentGift
      creditCurrency
      conditionTripCountsLessThan
      conditionUserNumberFirstDigits
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ViewRewardGQL extends Apollo.Query<
  ViewRewardQuery,
  ViewRewardQueryVariables
> {
  document = ViewRewardDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateRewardDocument = gql`
  mutation CreateReward($input: CreateReward!) {
    createOneReward(input: { reward: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateRewardGQL extends Apollo.Mutation<
  CreateRewardMutation,
  CreateRewardMutationVariables
> {
  document = CreateRewardDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateRewardDocument = gql`
  mutation UpdateReward($id: ID!, $input: UpdateReward!) {
    updateOneReward(input: { id: $id, update: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateRewardGQL extends Apollo.Mutation<
  UpdateRewardMutation,
  UpdateRewardMutationVariables
> {
  document = UpdateRewardDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreatePayoutSessionFieldsDocument = gql`
  query CreatePayoutSessionFields {
    supportedCurrencies
    payoutMethods {
      nodes {
        id
        name
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreatePayoutSessionFieldsGQL extends Apollo.Query<
  CreatePayoutSessionFieldsQuery,
  CreatePayoutSessionFieldsQueryVariables
> {
  document = CreatePayoutSessionFieldsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreatePayoutSessionDocument = gql`
  mutation CreatePayoutSession($input: CreatePayoutSessionInput!) {
    createTaxiPayoutSession(input: $input) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreatePayoutSessionGQL extends Apollo.Mutation<
  CreatePayoutSessionMutation,
  CreatePayoutSessionMutationVariables
> {
  document = CreatePayoutSessionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PayoutMethodsDocument = gql`
  query PayoutMethods {
    payoutMethods {
      nodes {
        id
        name
        description
        type
        media {
          id
          address
        }
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class PayoutMethodsGQL extends Apollo.Query<
  PayoutMethodsQuery,
  PayoutMethodsQueryVariables
> {
  document = PayoutMethodsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ViewPayoutMethodDocument = gql`
  query ViewPayoutMethod($id: ID!) {
    payoutMethod(id: $id) {
      id
      name
      currency
      description
      type
      privateKey
      publicKey
      saltKey
      merchantId
      media {
        address
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ViewPayoutMethodGQL extends Apollo.Query<
  ViewPayoutMethodQuery,
  ViewPayoutMethodQueryVariables
> {
  document = ViewPayoutMethodDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreatePayoutMethodDocument = gql`
  mutation CreatePayoutMethod($input: CreatePayoutMethodInput!) {
    createOnePayoutMethod(input: { payoutMethod: $input }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreatePayoutMethodGQL extends Apollo.Mutation<
  CreatePayoutMethodMutation,
  CreatePayoutMethodMutationVariables
> {
  document = CreatePayoutMethodDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdatePayoutMethodDocument = gql`
  mutation UpdatePayoutMethod($id: ID!, $update: CreatePayoutMethodInput!) {
    updateOnePayoutMethod(input: { id: $id, update: $update }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdatePayoutMethodGQL extends Apollo.Mutation<
  UpdatePayoutMethodMutation,
  UpdatePayoutMethodMutationVariables
> {
  document = UpdatePayoutMethodDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PayoutsDocument = gql`
  query Payouts($sessionsPaging: OffsetPaging!, $currency: String) {
    supportedCurrencies
    taxiPayoutStatistics(currency: $currency) {
      pendingAmount
      lastPayoutAmount
      currency
      usersDefaultPayoutMethodStats {
        payoutMethod {
          id
          name
        }
        totalCount
      }
    }
    taxiPayoutSessions(paging: $sessionsPaging) {
      nodes {
        id
        createdAt
        processedAt
        status
        totalAmount
        currency
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class PayoutsGQL extends Apollo.Query<
  PayoutsQuery,
  PayoutsQueryVariables
> {
  document = PayoutsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ViewPayoutSessionDocument = gql`
  query ViewPayoutSession($id: ID!) {
    taxiPayoutSession(id: $id) {
      id
      currency
      createdAt
      processedAt
      totalAmount
      status
      payoutMethods {
        id
        type
        name
        description
        currency
        balance
        media {
          address
        }
      }
      driverTransactions {
        nodes {
          amount
          currency
          status
          createdAt
          driver {
            firstName
            lastName
            media {
              address
            }
          }
        }
      }
      amountToBePaidByPayoutMethod: driverTransactionsAggregate(
        filter: { status: { eq: Processing }, payoutSessionId: { eq: $id } }
      ) {
        groupBy {
          payoutMethodId
        }
        sum {
          amount
        }
      }
      unpaidAmount: driverTransactionsAggregate(
        filter: { status: { eq: Processing } }
      ) {
        sum {
          amount
        }
      }
      paidAmount: driverTransactionsAggregate(
        filter: { status: { eq: Done } }
      ) {
        sum {
          amount
        }
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ViewPayoutSessionGQL extends Apollo.Query<
  ViewPayoutSessionQuery,
  ViewPayoutSessionQueryVariables
> {
  document = ViewPayoutSessionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PayoutSessionTransactionsDocument = gql`
  query PayoutSessionTransactions($id: ID!, $paging: OffsetPaging!) {
    taxiPayoutSession(id: $id) {
      driverTransactions(paging: $paging) {
        nodes {
          id
          amount
          currency
          status
          createdAt
          driver {
            firstName
            lastName
            media {
              address
            }
            payoutAccounts(filter: { isDefault: { is: true } }) {
              nodes {
                id
                name
                type
                accountNumber
                routingNumber
                bankName
                branchName
                accountHolderName
                accountHolderCountry
                accountHolderCity
                accountHolderState
                accountHolderZip
                accountHolderAddress
                accountHolderDateOfBirth
                payoutMethod {
                  name
                  media {
                    address
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class PayoutSessionTransactionsGQL extends Apollo.Query<
  PayoutSessionTransactionsQuery,
  PayoutSessionTransactionsQueryVariables
> {
  document = PayoutSessionTransactionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportToCsvDocument = gql`
  mutation ExportToCSV($input: ExportSessionToCsvInput!) {
    exportTaxiPayoutSessionToCsv(input: $input)
  }
`;

@Injectable({
  providedIn: "root",
})
export class ExportToCsvGQL extends Apollo.Mutation<
  ExportToCsvMutation,
  ExportToCsvMutationVariables
> {
  document = ExportToCsvDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RunAutoPayoutDocument = gql`
  mutation RunAutoPayout($input: RunAutoPayoutInput!) {
    runTaxiAutoPayout(input: $input)
  }
`;

@Injectable({
  providedIn: "root",
})
export class RunAutoPayoutGQL extends Apollo.Mutation<
  RunAutoPayoutMutation,
  RunAutoPayoutMutationVariables
> {
  document = RunAutoPayoutDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SaveManualPayoutItemDocument = gql`
  mutation SaveManualPayoutItem($input: ManualPayoutInput!) {
    taxiManualPayout(input: $input) {
      amount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class SaveManualPayoutItemGQL extends Apollo.Mutation<
  SaveManualPayoutItemMutation,
  SaveManualPayoutItemMutationVariables
> {
  document = SaveManualPayoutItemDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdatePayoutSessionDocument = gql`
  mutation UpdatePayoutSession($id: ID!, $update: UpdatePayoutSessionInput!) {
    updateOneTaxiPayoutSession(input: { id: $id, update: $update }) {
      id
      status
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdatePayoutSessionGQL extends Apollo.Mutation<
  UpdatePayoutSessionMutation,
  UpdatePayoutSessionMutationVariables
> {
  document = UpdatePayoutSessionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DriverClosingDriversDocument = gql`
  query DriverClosingDrivers($search: String) {
    driverClosingDrivers(search: $search) {
      id
      displayName
      mobileNumber
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DriverClosingDriversGQL extends Apollo.Query<
  DriverClosingDriversQuery,
  DriverClosingDriversQueryVariables
> {
  document = DriverClosingDriversDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PreviewDriverClosingRevenueDocument = gql`
  query PreviewDriverClosingRevenue(
    $driverId: ID!
    $periodStartLocal: String!
    $periodEndLocal: String!
    $paging: ClosingPaginationInput
  ) {
    previewDriverClosingRevenue(
      driverId: $driverId
      periodStartLocal: $periodStartLocal
      periodEndLocal: $periodEndLocal
      paging: $paging
    ) {
      driverId
      driverName
      periodStart
      periodEnd
      tripCount
      generatedRevenue
      currency
      includedTrips {
        orderId
        orderReference
        reportTimestamp
        revenueAmount
        status
        source
        paymentMethod
        pickupAddress
        destinationAddress
      }
      includedTripsPageInfo {
        first
        after
        hasNextPage
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class PreviewDriverClosingRevenueGQL extends Apollo.Query<
  PreviewDriverClosingRevenueQuery,
  PreviewDriverClosingRevenueQueryVariables
> {
  document = PreviewDriverClosingRevenueDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DriverClosingRecordsDocument = gql`
  query DriverClosingRecords(
    $paging: ClosingPaginationInput
    $filter: DriverClosingRecordFilterInput
  ) {
    driverClosingRecords(paging: $paging, filter: $filter) {
      nodes {
        ...DriverClosingRecordFields
      }
      totalCount
    }
  }
  ${DriverClosingRecordFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class DriverClosingRecordsGQL extends Apollo.Query<
  DriverClosingRecordsQuery,
  DriverClosingRecordsQueryVariables
> {
  document = DriverClosingRecordsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DriverClosingRecordDocument = gql`
  query DriverClosingRecord($id: ID!) {
    driverClosingRecord(id: $id) {
      ...DriverClosingRecordFields
    }
  }
  ${DriverClosingRecordFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class DriverClosingRecordGQL extends Apollo.Query<
  DriverClosingRecordQuery,
  DriverClosingRecordQueryVariables
> {
  document = DriverClosingRecordDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const EligibleDriverClosingCommissionTripsDocument = gql`
  query EligibleDriverClosingCommissionTrips(
    $input: EligibleDriverClosingCommissionTripsInput!
  ) {
    eligibleDriverClosingCommissionTrips(input: $input) {
      orderId
      orderReference
      reportTimestamp
      revenueAmount
      vehiclePlate
      serviceName
      currency
      commissionRatePercent
      calculatedCommissionAmount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class EligibleDriverClosingCommissionTripsGQL extends Apollo.Query<
  EligibleDriverClosingCommissionTripsQuery,
  EligibleDriverClosingCommissionTripsQueryVariables
> {
  document = EligibleDriverClosingCommissionTripsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateDriverClosingDraftDocument = gql`
  mutation CreateDriverClosingDraft($input: DriverClosingDraftInput!) {
    createDriverClosingDraft(input: $input) {
      ...DriverClosingRecordFields
    }
  }
  ${DriverClosingRecordFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class CreateDriverClosingDraftGQL extends Apollo.Mutation<
  CreateDriverClosingDraftMutation,
  CreateDriverClosingDraftMutationVariables
> {
  document = CreateDriverClosingDraftDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateDriverClosingDraftDocument = gql`
  mutation UpdateDriverClosingDraft(
    $id: ID!
    $input: DriverClosingDraftInput!
  ) {
    updateDriverClosingDraft(id: $id, input: $input) {
      ...DriverClosingRecordFields
    }
  }
  ${DriverClosingRecordFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class UpdateDriverClosingDraftGQL extends Apollo.Mutation<
  UpdateDriverClosingDraftMutation,
  UpdateDriverClosingDraftMutationVariables
> {
  document = UpdateDriverClosingDraftDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteDriverClosingDraftDocument = gql`
  mutation DeleteDriverClosingDraft($id: ID!) {
    deleteDriverClosingDraft(id: $id)
  }
`;

@Injectable({
  providedIn: "root",
})
export class DeleteDriverClosingDraftGQL extends Apollo.Mutation<
  DeleteDriverClosingDraftMutation,
  DeleteDriverClosingDraftMutationVariables
> {
  document = DeleteDriverClosingDraftDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteDriverClosingRecordDocument = gql`
  mutation DeleteDriverClosingRecord($id: ID!) {
    deleteDriverClosingRecord(id: $id)
  }
`;

@Injectable({
  providedIn: "root",
})
export class DeleteDriverClosingRecordGQL extends Apollo.Mutation<
  DeleteDriverClosingRecordMutation,
  DeleteDriverClosingRecordMutationVariables
> {
  document = DeleteDriverClosingRecordDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const FinalizeDriverClosingRecordDocument = gql`
  mutation FinalizeDriverClosingRecord($id: ID!) {
    finalizeDriverClosingRecord(id: $id) {
      ...DriverClosingRecordFields
    }
  }
  ${DriverClosingRecordFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class FinalizeDriverClosingRecordGQL extends Apollo.Mutation<
  FinalizeDriverClosingRecordMutation,
  FinalizeDriverClosingRecordMutationVariables
> {
  document = FinalizeDriverClosingRecordDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ReopenDriverClosingRecordDocument = gql`
  mutation ReopenDriverClosingRecord($id: ID!, $reason: String!) {
    reopenDriverClosingRecord(id: $id, reason: $reason) {
      ...DriverClosingRecordFields
    }
  }
  ${DriverClosingRecordFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class ReopenDriverClosingRecordGQL extends Apollo.Mutation<
  ReopenDriverClosingRecordMutation,
  ReopenDriverClosingRecordMutationVariables
> {
  document = ReopenDriverClosingRecordDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UseCurrentDriverClosingCommissionRateDocument = gql`
  mutation UseCurrentDriverClosingCommissionRate($entryId: ID!) {
    useCurrentDriverClosingCommissionRate(entryId: $entryId) {
      ...DriverClosingRecordFields
    }
  }
  ${DriverClosingRecordFieldsFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class UseCurrentDriverClosingCommissionRateGQL extends Apollo.Mutation<
  UseCurrentDriverClosingCommissionRateMutation,
  UseCurrentDriverClosingCommissionRateMutationVariables
> {
  document = UseCurrentDriverClosingCommissionRateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CommissionPartnersDocument = gql`
  query CommissionPartners(
    $paging: ClosingPaginationInput
    $filter: CommissionPartnerFilterInput
  ) {
    commissionPartners(paging: $paging, filter: $filter) {
      nodes {
        id
        name
        type
        active
        commissionRatePercent
        notes
        usedHistorically
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CommissionPartnersGQL extends Apollo.Query<
  CommissionPartnersQuery,
  CommissionPartnersQueryVariables
> {
  document = CommissionPartnersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateCommissionPartnerDocument = gql`
  mutation CreateCommissionPartner($input: CommissionPartnerInput!) {
    createCommissionPartner(input: $input) {
      id
      name
      type
      active
      commissionRatePercent
      notes
      usedHistorically
      createdAt
      updatedAt
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateCommissionPartnerGQL extends Apollo.Mutation<
  CreateCommissionPartnerMutation,
  CreateCommissionPartnerMutationVariables
> {
  document = CreateCommissionPartnerDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateCommissionPartnerDocument = gql`
  mutation UpdateCommissionPartner($id: ID!, $input: CommissionPartnerInput!) {
    updateCommissionPartner(id: $id, input: $input) {
      id
      name
      type
      active
      commissionRatePercent
      notes
      usedHistorically
      createdAt
      updatedAt
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateCommissionPartnerGQL extends Apollo.Mutation<
  UpdateCommissionPartnerMutation,
  UpdateCommissionPartnerMutationVariables
> {
  document = UpdateCommissionPartnerDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SetCommissionPartnerActiveDocument = gql`
  mutation SetCommissionPartnerActive($id: ID!, $active: Boolean!) {
    setCommissionPartnerActive(id: $id, active: $active) {
      id
      active
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class SetCommissionPartnerActiveGQL extends Apollo.Mutation<
  SetCommissionPartnerActiveMutation,
  SetCommissionPartnerActiveMutationVariables
> {
  document = SetCommissionPartnerActiveDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteCommissionPartnerDocument = gql`
  mutation DeleteCommissionPartner($id: ID!) {
    deleteCommissionPartner(id: $id)
  }
`;

@Injectable({
  providedIn: "root",
})
export class DeleteCommissionPartnerGQL extends Apollo.Mutation<
  DeleteCommissionPartnerMutation,
  DeleteCommissionPartnerMutationVariables
> {
  document = DeleteCommissionPartnerDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DriverCommissionReportDocument = gql`
  query DriverCommissionReport(
    $paging: ClosingPaginationInput
    $filter: CommissionReportFilterInput
  ) {
    driverCommissionReport(paging: $paging, filter: $filter) {
      nodes {
        id
        partnerId
        partnerName
        partnerType
        driverId
        driverName
        closingRecordId
        recordNumber
        periodStart
        periodEnd
        calculationMode
        orderId
        orderReference
        tripReportTimestamp
        tripRevenue
        commissionRatePercent
        amount
        note
        createdByName
        createdAt
        finalizedAt
        status
      }
      totalCount
      summary {
        totalCommission
        entryCount
        recordCount
        partnerCount
        commissionedTripCount
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DriverCommissionReportGQL extends Apollo.Query<
  DriverCommissionReportQuery,
  DriverCommissionReportQueryVariables
> {
  document = DriverCommissionReportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportDriverClosingRecordDocument = gql`
  query ExportDriverClosingRecord($id: ID!) {
    exportDriverClosingRecord(id: $id) {
      url
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ExportDriverClosingRecordGQL extends Apollo.Query<
  ExportDriverClosingRecordQuery,
  ExportDriverClosingRecordQueryVariables
> {
  document = ExportDriverClosingRecordDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportDriverClosingRecordsDocument = gql`
  query ExportDriverClosingRecords($filter: DriverClosingRecordFilterInput) {
    exportDriverClosingRecords(filter: $filter) {
      url
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ExportDriverClosingRecordsGQL extends Apollo.Query<
  ExportDriverClosingRecordsQuery,
  ExportDriverClosingRecordsQueryVariables
> {
  document = ExportDriverClosingRecordsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportDriverCommissionReportDocument = gql`
  query ExportDriverCommissionReport($filter: CommissionReportFilterInput) {
    exportDriverCommissionReport(filter: $filter) {
      url
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ExportDriverCommissionReportGQL extends Apollo.Query<
  ExportDriverCommissionReportQuery,
  ExportDriverCommissionReportQueryVariables
> {
  document = ExportDriverCommissionReportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DriverTripReportDocument = gql`
  query DriverTripReport(
    $paging: PaginationInput
    $filter: DriverTripReportFilterInput
  ) {
    driverTripReport(paging: $paging, filter: $filter) {
      nodes {
        orderId
        driverId
        driverName
        operatorId
        operatorName
        plateNumber
        pickupAddress
        destinationAddress
        departureTime
        arrivalTime
        fareMode
        finalPrice
        currency
        paymentMode
        orderSource
        reportingSource
        status
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DriverTripReportGQL extends Apollo.Query<
  DriverTripReportQuery,
  DriverTripReportQueryVariables
> {
  document = DriverTripReportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportDriverTripReportToExcelDocument = gql`
  mutation ExportDriverTripReportToExcel($filter: DriverTripReportFilterInput) {
    exportDriverTripReportToExcel(filter: $filter) {
      url
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ExportDriverTripReportToExcelGQL extends Apollo.Mutation<
  ExportDriverTripReportToExcelMutation,
  ExportDriverTripReportToExcelMutationVariables
> {
  document = ExportDriverTripReportToExcelDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AvailableDriversForOrderDocument = gql`
  query AvailableDriversForOrder($center: PointInput!, $count: Int!) {
    getDriversLocationWithData(center: $center, count: $count) {
      id
      location {
        lat
        lng
      }
      mobileNumber
      firstName
      lastName
      lastUpdatedAt
      rating
      reviewCount
      status
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class AvailableDriversForOrderGQL extends Apollo.Query<
  AvailableDriversForOrderQuery,
  AvailableDriversForOrderQueryVariables
> {
  document = AvailableDriversForOrderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DriverSearchDocument = gql`
  query DriverSearch($filter: String!) {
    drivers(
      filter: {
        or: [
          { mobileNumber: { like: $filter } }
          { lastName: { like: $filter } }
        ]
      }
    ) {
      nodes {
        id
        mobileNumber
        firstName
        lastName
        rating
        reviewCount
        status
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DriverSearchGQL extends Apollo.Query<
  DriverSearchQuery,
  DriverSearchQueryVariables
> {
  document = DriverSearchDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AssignDriverToOrderDocument = gql`
  mutation AssignDriverToOrder($orderId: ID!, $driverId: ID!) {
    assignDriverToOrder(orderId: $orderId, driverId: $driverId) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class AssignDriverToOrderGQL extends Apollo.Mutation<
  AssignDriverToOrderMutation,
  AssignDriverToOrderMutationVariables
> {
  document = AssignDriverToOrderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ViewOrderDocument = gql`
  query ViewOrder($id: ID!) {
    order(id: $id) {
      id
      riderBookingSetupStatus
      createdOn
      expectedTimestamp
      isScheduled
      scheduledAt
      scheduleStatus
      scheduledAssignmentMode
      scheduledDriverId
      scheduledDriverConfirmedAt
      scheduleRevision
      scheduleNotes
      nextAvailableDriverId
      nextAvailableHoldExpiresAt
      nextAvailableEstimatedPickupAt
      nextAvailableEtaSeconds
      nextAvailablePickupDistanceMeters
      nextAvailableAttemptCount
      nextAvailableFailureReason
      nextAvailableCandidateStillFeasible
      nextAvailableOperationCenterPhoneNumber
      nextAvailableDriver {
        id
        firstName
        lastName
        mobileNumber
        status
        carPlate
      }
      nextAvailableReservation {
        id
        orderId
        driverId
        driverName
        currentTripId
        mode
        status
        generation
        leaseVersion
        latestEstimatedPickupAt
        latestEtaSeconds
        latestPickupDistanceMeters
        initialSoftExpiresAt
        softExpiresAt
        hardExpiresAt
        lastRenewedAt
        renewalCount
        etaState
        offerSentAt
        endedAt
        endReason
        lastFailureCode
        createdAt
        warningCode
        warningMessage
      }
      costBest
      costAfterCoupon
      waitMinutes
      waitCost
      estimatedFixedPrice
      meterAmount
      meterExtrasAmount
      finalCollectedAmount
      meterCurrency
      meterNote
      meterPhotoUrl
      meterEnteredAt
      status
      currency
      fareMode
      paymentMode
      orderSource
      reportingSource
      operatorId
      operatorDisplayName
      settlementSource
      finalPriceAdjustments {
        id
        orderId
        oldFinalCollectedAmount
        newFinalCollectedAmount
        oldSettlementSource
        newSettlementSource
        adjustedByOperatorId
        actor {
          displayName
          systemType
          roleName
        }
        reason
        note
        createdAt
      }
      vehicleId
      driverVehicleAssignmentId
      vehiclePlate
      vehicleModel
      vehicleColor
      vehicleProductionYear
      vehicleSnapshotSource
      tariffProfileTitle
      tariffProfileCode
      couponCode
      distanceBest
      durationBest
      pickupEta
      dropOffEta
      startTimestamp
      finishTimestamp
      streetPassengerName
      streetPassengerPhone
      streetPassengerNationality
      isAnonymousPassenger
      createdDirectlyByDriverId
      addresses
      points {
        lat
        lng
      }
      serviceName
      driver {
        id
        firstName
        lastName
        mobileNumber
        registrationTimestamp
        status
        carPlate
        media {
          address
        }
      }
      scheduledDriver {
        id
        firstName
        lastName
        mobileNumber
        registrationTimestamp
        status
        carPlate
        media {
          address
        }
      }
      rider {
        id
        firstName
        lastName
        mobileNumber
        registrationTimestamp
        status
        media {
          address
        }
      }
      complaints {
        id
        subject
        inscriptionTimestamp
        content
        requestedByDriver
      }
      conversation {
        sentAt
        sentByDriver
        status
        content
      }
      activities {
        createdAt
        type
        operatorId
        operatorDisplayName
      }
      riderTransactions {
        action
        rechargeType
        deductType
        amount
        status
        currency
        refrenceNumber
      }
      driverTransactions {
        action
        rechargeType
        deductType
        amount
        status
        currency
        refrenceNumber
      }
      providerTransactions {
        action
        rechargeType
        deductType
        amount
        currency
        refrenceNumber
      }
      fleetTransactions {
        action
        rechargeType
        deductType
        amount
        currency
        refrenceNumber
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ViewOrderGQL extends Apollo.Query<
  ViewOrderQuery,
  ViewOrderQueryVariables
> {
  document = ViewOrderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ForceCancelTaxiOrderDocument = gql`
  mutation ForceCancelTaxiOrder($id: ID!) {
    forceCancelTaxiOrder(id: $id) {
      id
      status
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ForceCancelTaxiOrderGQL extends Apollo.Mutation<
  ForceCancelTaxiOrderMutation,
  ForceCancelTaxiOrderMutationVariables
> {
  document = ForceCancelTaxiOrderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AdjustOrderFinalPriceDocument = gql`
  mutation AdjustOrderFinalPrice(
    $orderId: ID!
    $newAmount: Float!
    $reason: String!
    $note: String
  ) {
    adjustOrderFinalPrice(
      orderId: $orderId
      newAmount: $newAmount
      reason: $reason
      note: $note
    ) {
      id
      orderId
      oldFinalCollectedAmount
      newFinalCollectedAmount
      actor {
        displayName
        systemType
        roleName
      }
      reason
      note
      createdAt
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class AdjustOrderFinalPriceGQL extends Apollo.Mutation<
  AdjustOrderFinalPriceMutation,
  AdjustOrderFinalPriceMutationVariables
> {
  document = AdjustOrderFinalPriceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CloseRiderBookingReviewDocument = gql`
  mutation CloseRiderBookingReview(
    $orderId: ID!
    $expectedStatus: String!
    $reason: String!
  ) {
    closeRiderBookingReview(
      orderId: $orderId
      expectedStatus: $expectedStatus
      reason: $reason
    )
  }
`;

@Injectable({
  providedIn: "root",
})
export class CloseRiderBookingReviewGQL extends Apollo.Mutation<
  CloseRiderBookingReviewMutation,
  CloseRiderBookingReviewMutationVariables
> {
  document = CloseRiderBookingReviewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OrdersListDocument = gql`
  query OrdersList(
    $paging: OffsetPaging
    $filter: OrderFilter
    $sorting: [OrderSort!]
    $todayStart: DateTime!
  ) {
    totalRequests: orders(paging: { limit: 1 }) {
      totalCount
    }
    urgentRequests: orders(
      paging: { limit: 1 }
      filter: { status: { in: [NoCloseFound, NotFound, NextAvailableExpired] } }
    ) {
      totalCount
    }
    unassignedRequests: orders(
      paging: { limit: 1 }
      filter: {
        status: {
          in: [
            Requested
            Booked
            WaitingForNextAvailableDriver
            NextAvailableOfferPending
          ]
        }
      }
    ) {
      totalCount
    }
    activeTrips: orders(
      paging: { limit: 1 }
      filter: {
        status: {
          in: [
            Found
            DriverAccepted
            Arrived
            Started
            WaitingForPostPay
            WaitingForDriverFee
          ]
        }
      }
    ) {
      totalCount
    }
    waitingNextAvailable: orders(
      paging: { limit: 1 }
      filter: {
        status: {
          in: [WaitingForNextAvailableDriver, NextAvailableOfferPending]
        }
      }
    ) {
      totalCount
    }
    completedToday: orders(
      paging: { limit: 1 }
      filter: {
        status: { in: [Finished, WaitingForReview] }
        finishTimestamp: { gte: $todayStart }
      }
    ) {
      totalCount
    }
    orders(paging: $paging, filter: $filter, sorting: $sorting) {
      nodes {
        id
        status
        orderSource
        reportingSource
        createdOn
        startTimestamp
        expectedTimestamp
        scheduledAt
        scheduleStatus
        isScheduled
        fareMode
        paymentMode
        addresses
        streetPassengerName
        streetPassengerPhone
        isAnonymousPassenger
        meterAmount
        finalCollectedAmount
        estimatedFixedPrice
        nextAvailableEstimatedPickupAt
        nextAvailableEtaSeconds
        nextAvailablePickupDistanceMeters
        nextAvailableFailureReason
        nextAvailableHoldExpiresAt
        vehiclePlate
        costAfterCoupon
        currency
        operatorId
        operatorDisplayName
        serviceName
        rider {
          firstName
          lastName
          mobileNumber
        }
        driver {
          firstName
          lastName
          mobileNumber
          carPlate
        }
        scheduledDriver {
          firstName
          lastName
          mobileNumber
          carPlate
        }
        nextAvailableDriver {
          firstName
          lastName
          mobileNumber
          carPlate
        }
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class OrdersListGQL extends Apollo.Query<
  OrdersListQuery,
  OrdersListQueryVariables
> {
  document = OrdersListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const OrderChangedDocument = gql`
  subscription OrderChanged {
    orderChanged {
      orderId
      status
      isScheduled
      scheduleStatus
      scheduledAt
      driverId
      scheduledDriverId
      driver {
        firstName
        lastName
        mobileNumber
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class OrderChangedGQL extends Apollo.Subscription<
  OrderChangedSubscription,
  OrderChangedSubscriptionVariables
> {
  document = OrderChangedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SearchDriversForOrderFilterDocument = gql`
  query SearchDriversForOrderFilter($query: String!, $limit: Int! = 10) {
    searchDriversForOrderFilter(query: $query, limit: $limit) {
      id
      firstName
      lastName
      mobileNumber
      carPlate
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class SearchDriversForOrderFilterGQL extends Apollo.Query<
  SearchDriversForOrderFilterQuery,
  SearchDriversForOrderFilterQueryVariables
> {
  document = SearchDriversForOrderFilterDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DriverForOrderFilterDocument = gql`
  query DriverForOrderFilter($id: ID!) {
    driverForOrderFilter(id: $id) {
      id
      firstName
      lastName
      mobileNumber
      carPlate
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DriverForOrderFilterGQL extends Apollo.Query<
  DriverForOrderFilterQuery,
  DriverForOrderFilterQueryVariables
> {
  document = DriverForOrderFilterDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateRiderDocument = gql`
  mutation CreateRider($input: RiderInput!) {
    createOneRider(input: { rider: $input }) {
      id
      firstName
      lastName
      mobileNumber
      gender
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateRiderGQL extends Apollo.Mutation<
  CreateRiderMutation,
  CreateRiderMutationVariables
> {
  document = CreateRiderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ViewRiderDocument = gql`
  query ViewRider($id: ID!) {
    rider(id: $id) {
      id
      status
      firstName
      lastName
      mobileNumber
      isResident
      idNumber
      media {
        address
      }
      mobileNumber
      registrationTimestamp
      email
      gender
      nationality
      countryOfResidence
      tariffProfileId
      tariffProfileTitle
      tariffProfileCode
      wallet(sorting: [{ field: balance, direction: DESC }]) {
        balance
        currency
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ViewRiderGQL extends Apollo.Query<
  ViewRiderQuery,
  ViewRiderQueryVariables
> {
  document = ViewRiderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RiderAddressesDocument = gql`
  query RiderAddresses($riderId: ID!, $paging: OffsetPaging) {
    riderAddresses(filter: { riderId: { eq: $riderId } }, paging: $paging) {
      nodes {
        title
        details
        location {
          lat
          lng
        }
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class RiderAddressesGQL extends Apollo.Query<
  RiderAddressesQuery,
  RiderAddressesQueryVariables
> {
  document = RiderAddressesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RiderWalletDocument = gql`
  query RiderWallet(
    $riderId: ID!
    $paging: OffsetPaging
    $filter: RiderTransactionFilter
    $sorting: [RiderTransactionSort!]
  ) {
    rider(id: $riderId) {
      wallet {
        balance
        currency
      }
      transactions(paging: $paging, sorting: $sorting, filter: $filter) {
        nodes {
          action
          deductType
          status
          createdAt
          rechargeType
          amount
          currency
          refrenceNumber
          description
          paymentGatewayId
          operatorId
          requestId
        }
        totalCount
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class RiderWalletGQL extends Apollo.Query<
  RiderWalletQuery,
  RiderWalletQueryVariables
> {
  document = RiderWalletDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RiderOrdersDocument = gql`
  query RiderOrders(
    $riderId: ID!
    $filter: OrderFilter
    $paging: OffsetPaging
    $sorting: [OrderSort!]
  ) {
    rider(id: $riderId) {
      orders(paging: $paging, filter: $filter, sorting: $sorting) {
        nodes {
          id
          createdOn
          startTimestamp
          status
          distanceBest
          durationBest
          costBest
          costAfterCoupon
          estimatedFixedPrice
          finalCollectedAmount
          meterAmount
          meterExtrasAmount
          fareMode
          currency
          addresses
          points {
            lat
            lng
          }
          expectedTimestamp
        }
        totalCount
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class RiderOrdersGQL extends Apollo.Query<
  RiderOrdersQuery,
  RiderOrdersQueryVariables
> {
  document = RiderOrdersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateRiderDocument = gql`
  mutation UpdateRider($id: ID!, $update: RiderInput!) {
    updateOneRider(input: { id: $id, update: $update }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateRiderGQL extends Apollo.Mutation<
  UpdateRiderMutation,
  UpdateRiderMutationVariables
> {
  document = UpdateRiderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateRiderTransactionDocument = gql`
  mutation CreateRiderTransaction($input: RiderTransactionInput!) {
    createRiderTransaction(input: $input) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateRiderTransactionGQL extends Apollo.Mutation<
  CreateRiderTransactionMutation,
  CreateRiderTransactionMutationVariables
> {
  document = CreateRiderTransactionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteRiderDocument = gql`
  mutation DeleteRider($id: ID!) {
    deleteOneRider(id: $id) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DeleteRiderGQL extends Apollo.Mutation<
  DeleteRiderMutation,
  DeleteRiderMutationVariables
> {
  document = DeleteRiderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RidersListDocument = gql`
  query RidersList(
    $filter: RiderFilter
    $paging: OffsetPaging
    $sorting: [RiderSort!]
  ) {
    riders(filter: $filter, paging: $paging, sorting: $sorting) {
      nodes {
        id
        firstName
        lastName
        status
        gender
        mobileNumber
        registrationTimestamp
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class RidersListGQL extends Apollo.Query<
  RidersListQuery,
  RidersListQueryVariables
> {
  document = RidersListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ScheduledRideBoardDocument = gql`
  query ScheduledRideBoard($filter: ScheduledRideFilterInput) {
    scheduledRideBoard(filter: $filter) {
      totalCount
      nodes {
        orderId
        status
        isScheduled
        scheduledAt
        scheduleStatus
        scheduledAssignmentMode
        scheduledDriverConfirmedAt
        scheduleRevision
        fareMode
        costAfterCoupon
        currency
        paymentMode
        orderSource
        pickupAddress
        destinationAddress
        pickupPoint {
          lat
          lng
        }
        destinationPoint {
          lat
          lng
        }
        serviceId
        serviceName
        customerId
        customerName
        customerPhone
        assignedDriverId
        assignedDriverName
        assignedDriverPhone
        assignedDriverPlate
        assignedDriverStatus
        isAtRisk
        minutesUntilPickup
        createdByOperatorId
        createdByOperatorName
        lastScheduleAction
        lastScheduleOperatorId
        lastScheduleOperatorName
        lastScheduleActivityAt
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ScheduledRideBoardGQL extends Apollo.Query<
  ScheduledRideBoardQuery,
  ScheduledRideBoardQueryVariables
> {
  document = ScheduledRideBoardDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ScheduledRideAssignmentDriversDocument = gql`
  query ScheduledRideAssignmentDrivers($orderId: ID!) {
    scheduledRideAssignmentDrivers(orderId: $orderId) {
      id
      mobileNumber
      firstName
      lastName
      rating
      status
      vehiclePlate
      serviceIds
      distanceMeters
      isOnline
      isFeasible
      feasibilityReason
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ScheduledRideAssignmentDriversGQL extends Apollo.Query<
  ScheduledRideAssignmentDriversQuery,
  ScheduledRideAssignmentDriversQueryVariables
> {
  document = ScheduledRideAssignmentDriversDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AssignScheduledRideDocument = gql`
  mutation AssignScheduledRide($orderId: ID!, $driverId: ID!, $reason: String) {
    assignScheduledRide(orderId: $orderId, driverId: $driverId, reason: $reason)
  }
`;

@Injectable({
  providedIn: "root",
})
export class AssignScheduledRideGQL extends Apollo.Mutation<
  AssignScheduledRideMutation,
  AssignScheduledRideMutationVariables
> {
  document = AssignScheduledRideDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RescheduleScheduledRideByAdminDocument = gql`
  mutation RescheduleScheduledRideByAdmin(
    $orderId: ID!
    $scheduledAt: DateTime!
    $reason: String
  ) {
    rescheduleScheduledRideByAdmin(
      orderId: $orderId
      scheduledAt: $scheduledAt
      reason: $reason
    )
  }
`;

@Injectable({
  providedIn: "root",
})
export class RescheduleScheduledRideByAdminGQL extends Apollo.Mutation<
  RescheduleScheduledRideByAdminMutation,
  RescheduleScheduledRideByAdminMutationVariables
> {
  document = RescheduleScheduledRideByAdminDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CancelScheduledRideByAdminDocument = gql`
  mutation CancelScheduledRideByAdmin($orderId: ID!, $reason: String) {
    cancelScheduledRideByAdmin(orderId: $orderId, reason: $reason)
  }
`;

@Injectable({
  providedIn: "root",
})
export class CancelScheduledRideByAdminGQL extends Apollo.Mutation<
  CancelScheduledRideByAdminMutation,
  CancelScheduledRideByAdminMutationVariables
> {
  document = CancelScheduledRideByAdminDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const EmergencyDispatchScheduledRideDocument = gql`
  mutation EmergencyDispatchScheduledRide($orderId: ID!, $reason: String) {
    emergencyDispatchScheduledRide(orderId: $orderId, reason: $reason)
  }
`;

@Injectable({
  providedIn: "root",
})
export class EmergencyDispatchScheduledRideGQL extends Apollo.Mutation<
  EmergencyDispatchScheduledRideMutation,
  EmergencyDispatchScheduledRideMutationVariables
> {
  document = EmergencyDispatchScheduledRideDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SosListDocument = gql`
  query SOSList($paging: OffsetPaging) {
    distressSignals(paging: $paging) {
      nodes {
        id
        createdAt
        status
        submittedByRider
        location {
          lat
          lng
        }
        activities {
          action
          createdAt
        }
        order {
          id
          status
          addresses
          rider {
            id
            firstName
            lastName
            mobileNumber
          }
          driver {
            id
            firstName
            lastName
            mobileNumber
          }
        }
      }
      totalCount
    }
    distressSignalSummary: distressSignals(paging: { limit: 10000 }) {
      nodes {
        id
        createdAt
        status
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class SosListGQL extends Apollo.Query<
  SosListQuery,
  SosListQueryVariables
> {
  document = SosListDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ViewSosDocument = gql`
  query ViewSOS($id: ID!) {
    distressSignal(id: $id) {
      id
      createdAt
      status
      submittedByRider
      location {
        lat
        lng
      }
      activities {
        action
        createdAt
        note
        operatorDisplayName
      }
      order {
        id
        status
        createdOn
        startTimestamp
        finishTimestamp
        expectedTimestamp
        costBest
        costAfterCoupon
        estimatedFixedPrice
        finalCollectedAmount
        meterAmount
        meterExtrasAmount
        fareMode
        addresses
        currency
        rider {
          id
          mobileNumber
          status
          firstName
          lastName
          registrationTimestamp
        }
        driver {
          id
          mobileNumber
          status
          firstName
          lastName
          registrationTimestamp
        }
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ViewSosGQL extends Apollo.Query<
  ViewSosQuery,
  ViewSosQueryVariables
> {
  document = ViewSosDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateSosActivityDocument = gql`
  mutation CreateSOSActivity($activity: CreateSOSAcitivtyInput!) {
    createOneSOSActivity(input: { sOSActivity: $activity }) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateSosActivityGQL extends Apollo.Mutation<
  CreateSosActivityMutation,
  CreateSosActivityMutationVariables
> {
  document = CreateSosActivityDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TelematicsLiveFleetDocument = gql`
  query TelematicsLiveFleet {
    telematicsLiveFleet {
      vehicleId
      vehicleLabel
      driverId
      driverLabel
      currentOrderId
      freshness
      latestObservationAt
      appGpsAgeSeconds
      hardwareGpsAgeSeconds
      gpsDistanceMeters
      passengerPresence
      passengerPresenceObservedAt
      taximeterActive
      taximeterObservedAt
      signalFreshnessSeconds
      ignition
      speedMetersPerSecond
      capability
      providerHealth
      findingCount
      appPosition {
        latitude
        longitude
        observedAt
      }
      hardwarePosition {
        latitude
        longitude
        observedAt
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class TelematicsLiveFleetGQL extends Apollo.Query<
  TelematicsLiveFleetQuery,
  TelematicsLiveFleetQueryVariables
> {
  document = TelematicsLiveFleetDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TelematicsAlertsDocument = gql`
  query TelematicsAlerts($vehicleId: ID, $driverId: ID, $orderId: ID) {
    telematicsIntegrityAlerts(
      vehicleId: $vehicleId
      driverId: $driverId
      orderId: $orderId
    ) {
      id
      type
      severity
      workflowStatus
      conditionStatus
      conditionResolvedAt
      conditionResolutionReason
      version
      vehicleId
      driverId
      orderId
      passengerIntervalStatus
      taximeterIntervalStatus
      calibrationEvidence
      firstDetectedAt
      lastObservedAt
      movementConfirmed
      currentReviewerOperatorId
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class TelematicsAlertsGQL extends Apollo.Query<
  TelematicsAlertsQuery,
  TelematicsAlertsQueryVariables
> {
  document = TelematicsAlertsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TelematicsAlertDocument = gql`
  query TelematicsAlert($id: ID!) {
    telematicsIntegrityAlert(id: $id) {
      id
      type
      severity
      workflowStatus
      conditionStatus
      conditionResolvedAt
      conditionResolutionReason
      version
      vehicleId
      driverId
      orderId
      firstDetectedAt
      lastObservedAt
      movementConfirmed
      currentReviewerOperatorId
      endpointEvaluationStatus
      endpointEvidenceLimitations
      pickupEndpoint {
        evaluated
        mismatch
        separationMeters
        toleranceMeters
        limitationCode
        expectedPosition {
          latitude
          longitude
          observedAt
        }
        observedPosition {
          latitude
          longitude
          observedAt
        }
      }
      dropoffEndpoint {
        evaluated
        mismatch
        separationMeters
        toleranceMeters
        limitationCode
        expectedPosition {
          latitude
          longitude
          observedAt
        }
        observedPosition {
          latitude
          longitude
          observedAt
        }
      }
      reviewHistory {
        id
        operatorId
        action
        previousStatus
        newStatus
        reasonCode
        internalNote
        createdAt
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class TelematicsAlertGQL extends Apollo.Query<
  TelematicsAlertQuery,
  TelematicsAlertQueryVariables
> {
  document = TelematicsAlertDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TelematicsDriverReportDocument = gql`
  query TelematicsDriverReport($driverId: ID, $vehicleId: ID) {
    telematicsDriverIntegrityReport(
      driverId: $driverId
      vehicleId: $vehicleId
    ) {
      alertCount
      confirmed
      explained
      dismissed
      autoResolved
      unattributed
      matchedPassengerIntervals
      incompleteEvidenceCount
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class TelematicsDriverReportGQL extends Apollo.Query<
  TelematicsDriverReportQuery,
  TelematicsDriverReportQueryVariables
> {
  document = TelematicsDriverReportDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const AcknowledgeTelematicsAlertDocument = gql`
  mutation AcknowledgeTelematicsAlert($input: TelematicsAlertReviewInput!) {
    acknowledgeTelematicsAlert(input: $input) {
      id
      workflowStatus
      conditionStatus
      conditionResolvedAt
      conditionResolutionReason
      version
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class AcknowledgeTelematicsAlertGQL extends Apollo.Mutation<
  AcknowledgeTelematicsAlertMutation,
  AcknowledgeTelematicsAlertMutationVariables
> {
  document = AcknowledgeTelematicsAlertDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const StartTelematicsAlertReviewDocument = gql`
  mutation StartTelematicsAlertReview($input: TelematicsAlertReviewInput!) {
    startTelematicsAlertReview(input: $input) {
      id
      workflowStatus
      conditionStatus
      conditionResolvedAt
      conditionResolutionReason
      version
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class StartTelematicsAlertReviewGQL extends Apollo.Mutation<
  StartTelematicsAlertReviewMutation,
  StartTelematicsAlertReviewMutationVariables
> {
  document = StartTelematicsAlertReviewDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ConfirmTelematicsAlertDocument = gql`
  mutation ConfirmTelematicsAlert($input: TelematicsAlertReviewInput!) {
    confirmTelematicsAlert(input: $input) {
      id
      workflowStatus
      conditionStatus
      conditionResolvedAt
      conditionResolutionReason
      version
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class ConfirmTelematicsAlertGQL extends Apollo.Mutation<
  ConfirmTelematicsAlertMutation,
  ConfirmTelematicsAlertMutationVariables
> {
  document = ConfirmTelematicsAlertDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DismissTelematicsAlertDocument = gql`
  mutation DismissTelematicsAlert($input: TelematicsAlertReviewInput!) {
    dismissTelematicsAlert(input: $input) {
      id
      workflowStatus
      conditionStatus
      conditionResolvedAt
      conditionResolutionReason
      version
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DismissTelematicsAlertGQL extends Apollo.Mutation<
  DismissTelematicsAlertMutation,
  DismissTelematicsAlertMutationVariables
> {
  document = DismissTelematicsAlertDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TelematicsLatestStatusChangedDocument = gql`
  subscription TelematicsLatestStatusChanged {
    telematicsLatestStatusChanged {
      entityId
      changedAt
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class TelematicsLatestStatusChangedGQL extends Apollo.Subscription<
  TelematicsLatestStatusChangedSubscription,
  TelematicsLatestStatusChangedSubscriptionVariables
> {
  document = TelematicsLatestStatusChangedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TelematicsIntegrityAlertChangedDocument = gql`
  subscription TelematicsIntegrityAlertChanged {
    telematicsIntegrityAlertChanged {
      entityId
      changedAt
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class TelematicsIntegrityAlertChangedGQL extends Apollo.Subscription<
  TelematicsIntegrityAlertChangedSubscription,
  TelematicsIntegrityAlertChangedSubscriptionVariables
> {
  document = TelematicsIntegrityAlertChangedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TelematicsAlertReviewChangedDocument = gql`
  subscription TelematicsAlertReviewChanged {
    telematicsAlertReviewChanged {
      entityId
      reviewId
      changedAt
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class TelematicsAlertReviewChangedGQL extends Apollo.Subscription<
  TelematicsAlertReviewChangedSubscription,
  TelematicsAlertReviewChangedSubscriptionVariables
> {
  document = TelematicsAlertReviewChangedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SearchVehiclesForTelematicsFilterDocument = gql`
  query SearchVehiclesForTelematicsFilter($query: String!, $limit: Int! = 10) {
    searchVehiclesForTelematicsFilter(query: $query, limit: $limit) {
      id
      plate
      modelName
      colorName
      status
      assignedDriverId
      assignedDriverName
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class SearchVehiclesForTelematicsFilterGQL extends Apollo.Query<
  SearchVehiclesForTelematicsFilterQuery,
  SearchVehiclesForTelematicsFilterQueryVariables
> {
  document = SearchVehiclesForTelematicsFilterDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CurrentConfigurationDocument = gql`
  query CurrentConfiguration {
    currentConfiguration {
      backendMapsAPIKey
      adminPanelAPIKey
      adminPanelMapId
      firebaseProjectPrivateKey
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CurrentConfigurationGQL extends Apollo.Query<
  CurrentConfigurationQuery,
  CurrentConfigurationQueryVariables
> {
  document = CurrentConfigurationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateMapsApiKeyDocument = gql`
  mutation UpdateMapsAPIKey($backend: String!, $adminPanel: String!) {
    updateMapsAPIKey(backend: $backend, adminPanel: $adminPanel) {
      status
      message
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateMapsApiKeyGQL extends Apollo.Mutation<
  UpdateMapsApiKeyMutation,
  UpdateMapsApiKeyMutationVariables
> {
  document = UpdateMapsApiKeyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateFirebaseDocument = gql`
  mutation UpdateFirebase($keyFileName: String!) {
    updateFirebase(keyFileName: $keyFileName) {
      status
      message
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateFirebaseGQL extends Apollo.Mutation<
  UpdateFirebaseMutation,
  UpdateFirebaseMutationVariables
> {
  document = UpdateFirebaseDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LoginDocument = gql`
  query Login($username: String!, $password: String!) {
    login(userName: $username, password: $password) {
      token
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class LoginGQL extends Apollo.Query<LoginQuery, LoginQueryVariables> {
  document = LoginDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
